'use strict';

angular.module('NavisphereOnline', ['NavisphereOnline.constants', 'angular-geohash', 'angulartics', 'angulartics.adobe.analytics', 'ngAria', 'ui.router', 'ngResource',
  'pascalprecht.translate', 'tmh.dynamicLocale', 'resourceLoader', 'ui.utils', 'ui.bootstrap', 'ui.select',
  'ngSanitize', 'angularFileUpload', 'ui.dashboard', 'toastr', 'angular-jwt',
  'LocalStorageModule', 'angular-intro', 'uiSwitch'])
  .value("oktaAuth", undefined)
  .factory("authClient", function() {
    var auth;
    return {
        init : function(options) {
            auth = new OktaAuth(options);
        },
        getClient : function() {
          return auth;
        }
    };
  })
  .run(['$rootScope', 'AdobeAnalyticsService', 'authService', 'authClient', 'authManager', 'tmhDynamicLocale',
        '$translate', 'tokenService', 'localStorageService', '$state', 'UserPermissionService', '$window', 'WindowLocationHref',
        'OKTA_CONFIG', '$transitions', 'WalkthroughService', 'LaunchDarklyService',
    function runBlock($rootScope, AdobeAnalyticsService, authService, authClient, authManager, tmhDynamicLocale,
                      $translate, tokenService, localStorageService, $state, UserPermissionService, $window, WindowLocationHref,
                      OKTA_CONFIG, $transitions, WalkthroughService, LaunchDarklyService) {
      authClient.init(OKTA_CONFIG.options);
      var oktaAuth = authClient.getClient();
      // Put the authService on $rootScope so its methods
      // can be accessed from the nav bar
      $rootScope.authService = authService;


      if(localStorageService.get('auth.data'))
      {
        authService.setupTokenManager(oktaAuth);
      }

      // Set the redirect in localStorage if provided
      if (!localStorageService.get('redirectUrl')) {
        localStorageService.set('redirectUrl', $window.location.href.split("&redirectUrl=")[1]);
      }

      // launch Darkly initialization - do not remove
      $rootScope.featureFlags = {};
      function setFlags(overrideClient) {
        // add flags to rootScope here. ex: $rootScope.featureFlags.*someNameForFeature* = overrideClient || $rootScope.ldclient.variation('*name-of-feature-key*');
        $rootScope.featureFlags.etaAtRiskFeatureFlag = overrideClient || $rootScope.ldclient.variation('customer-platform-legacy-dashboard-eta-risk');
        $rootScope.featureFlags.notifcationSettingsFeatureFlag =  overrideClient ? false : $rootScope.ldclient.variation('customer-platform-notification-settings-uplift');
        $rootScope.featureFlags.volumeQuoteFeatureFlag = overrideClient || $rootScope.ldclient.variation('customer_platform_volume_quote');
      }

      authService.authenticate(oktaAuth);

      // Use the authManager from angular-jwt to check for
      // the user's authentication state when the page is
      // refreshed and maintain authentication
      authManager.checkAuthOnRefresh();

      // Listen for 401 unauthorized requests and redirect
      // the user to the login page
      authManager.redirectWhenUnauthenticated();

      if(authService.isLoggedIn()) {
        authService.authorizeUser(oktaAuth);

        if (!localStorageService.get('User')) {
          authService.getUserData();
        }

        authService.readAcknowledgements();

        if($rootScope.ldclient === undefined) {
          // only initalize LD when not running tests
          if(typeof window.__karma__ === 'undefined') {
            var sevenLetter = localStorageService.get('User').email.split('@')[0].toUpperCase();
            LaunchDarklyService.initLD(sevenLetter).then(function (ldclient) {
              $rootScope.ldclient = ldclient
              setFlags();

              // listen for changes in the feature flag, and update the scope variable accordingly
              $rootScope.ldclient.on('change', function () {
                setFlags();
              })
            })
          }
        }

        if(!localStorageService.get('walkthroughs')) {
          var userId = localStorageService.get('User').userId;
          WalkthroughService.getAllWalkthroughs({ userId: userId }).$promise.then(function (data) {
            localStorageService.set('walkthroughs', data);
          });
        }
      } else {
        // running tests so override ld client
        if($rootScope.ldclient === undefined) {
          if(typeof window.__karma__ !== 'undefined') {
            setFlags(true);
          }
        }
      }

      $rootScope.$on('$locationChangeStart', function(event, next, current) {
        if(!localStorageService.get('redirectUrl') && next.indexOf('redirectUrl') !== -1) {
          localStorageService.set('redirectUrl', next.split("&redirectUrl=")[1]);
        }
      });

      $transitions.onStart({}, function(transition) {
        var statePermission = $state.get(transition.to().name).permission;
        $rootScope.pageTitle = transition.to().data ? transition.to().data.pageTitle : '';
        if (authService.isLoggedIn() && statePermission && !UserPermissionService.hasPermission(statePermission)) {
          WindowLocationHref.redirectToProductsPageNotFound();
        }

        if(!localStorageService.get('redirectUrl') && !authService.isLoggedIn() && transition.to().name !== 'login' && transition.to().name !== 'pageNotFound') {
          localStorageService.set('redirectUrl', $window.location.origin + '/#' + transition.to().url);
        }
      });

      $rootScope.$on('$locationChangeSuccess', function () {
        if($window.localStorage["NavisphereOnline.User"] !== undefined){
          var user = JSON.parse($window.localStorage["NavisphereOnline.User"]);
          AdobeAnalyticsService.tracking(user);
        }
      });
    }
  ])
  .provider('satellite', function () {
    return {
      $get: ['$window', function ($window) {
        return $window._satellite;
      }]
    };
  });


(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
  
    app.directive('reportSubscriptionSummary', [function () {
      return {
        scope: {
          report: '=',
          email: '=',
          frequency: '='
        },
        templateUrl: 'app/reporting/subscription/templates/subscriptionSummary.tpl.html'
      };
    }]);
  })();
(function () {
    'use strict';
  
    var app = angular.module('NavisphereOnline');

    subscriptionTokenService.$inject = ['$window'];
  
    function subscriptionTokenService($window) {
  
        function decodeToken(token) {

            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse($window.atob(base64));

          };
      
       return {
        decodeToken: decodeToken
      };
  
    }

    app.factory('SubscriptionTokenService', subscriptionTokenService);
  })();
(function (){
    'use strict'

    subscriptionToastService.$inject = ['$filter', '$templateCache', 'toastr', 'toastrConfig'];

    function subscriptionToastService($filter, $templateCache, toastr, toastrConfig) {

      function subscriptionSuccess(successText){

        $templateCache.put('../app/reporting/subscription/templates/custom-toast-success.tpl.html',
        '<div class="toast-inner-container toast-success-border" class="{{toastClass}}" ng-click="tapToast()">' +
          '<div class="row">' +
            '<div class="col-xs-1">' +
              '<div class="toast-success-left"></div>' +
            '</div>' +
            '<div class="col-xs-1">' +
              '<span class="glyphicon glyphicon-ok validator-icon-sm complete"></span>' +
            '</div>' +
            '<div class="col-xs-7 pad-left-0">' +
              '<div class="toast-message">' + $filter('translate')(successText) + '</div>' +
            '</div>' +
            '<div class="col-xs-1">' +
              '<span ng-click="close(true, $event)" class="glyphicon glyphicon-remove close-icon-sm"></span>' +
            '</div>' +
          '</div>' +
        '</div>'
      );

        angular.extend(toastrConfig, {
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
            tapToDismiss: false,
            templates: {
              toast: '../app/reporting/subscription/templates/custom-toast-success.tpl.html'
            }
          });

          return toastr.success();

      };

      function subscriptionError(errorText){

        $templateCache.put('../app/reporting/subscription/templates/custom-toast-error.tpl.html',
        '<div class="toast-inner-container toast-error-border" class="{{toastClass}}" ng-click="tapToast()">' +
          '<div class="row">' +
            '<div class="col-xs-1">' +
              '<div class="toast-error-left"></div>' +
            '</div>' +
            '<div class="col-xs-1">' +
              '<span class="glyphicon glyphicon-remove-sign error-icon-sm"></span>' +
            '</div>' +
            '<div class="col-xs-7 pad-left-0">' +
              '<div class="toast-message">' + $filter('translate')(errorText) + '</div>' +
            '</div>' +
            '<div class="col-xs-1">' +
              '<span ng-click="close(true, $event)" class="glyphicon glyphicon-remove close-icon-sm"></span>' +
            '</div>' +
          '</div>' +
        '</div>'
      );

        angular.extend(toastrConfig, {
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
            tapToDismiss: false,
            templates: {
              toast: '../app/reporting/subscription/templates/custom-toast-error.tpl.html'
            }
          });

          return toastr.error();

      }

      return{

          subscriptionSuccess: subscriptionSuccess,
          subscriptionError: subscriptionError
      }

    }

    angular.module('NavisphereOnline').factory('SubscriptionToastService', subscriptionToastService);

})();
(function () {
  'use strict';

  var app = angular.module('NavisphereOnline');
  subscriptionDisplayService.$inject = ['$filter', 'ListStringHelper'];

  function subscriptionDisplayService($filter, ListStringHelper) {

    var time = new Date();
    time.setHours(8);
    time.setMinutes(0);

    var strings = {
      and: $filter('translate')('AND').toLowerCase(),
      on: $filter('translate')('ON'),
      at: $filter('translate')('AT'),
      daily: $filter('translate')('DAILY'),
      weekly: $filter('translate')('WEEKLY'),
      monthly: $filter('translate')('MONTHLY'),
      pleaseSelectADay: $filter('translate')('PLEASE_SELECT_A_DAY').toLowerCase(),
      centralTime: $filter('translate')('CENTRAL_TIME')
    };

    function getDaysOfWeekOptions(){

      var daysOfWeekOptions = [
        { display: 'SUNDAY', value: 1, selected: false },
        { display: 'MONDAY', value: 2, selected: false },
        { display: 'TUESDAY', value: 3, selected: false },
        { display: 'WEDNESDAY', value: 4, selected: false },
        { display: 'THURSDAY', value: 5, selected: false },
        { display: 'FRIDAY', value: 6, selected: false },
        { display: 'SATURDAY', value: 7, selected: false }
      ];

      return daysOfWeekOptions;
    }

    function filteredDaysOfWeek(daysOfWeekOptions) {
      return _.filter(daysOfWeekOptions, function (day) {
        return day.selected;
      });
    }

    function generateVerificationFrequencyText(subscriptionFrequency, daysOfWeekOptions, preferences) {

      function strongify(text) {
        return '<strong>' + text + '</strong>';
      }

      var space = ' ';

      switch (subscriptionFrequency) {
        case 'WEEKLY':
          var days = ListStringHelper.buildListString(_.map(filteredDaysOfWeek(daysOfWeekOptions), function (elm) {
            return $filter('translate')(elm.display);
          }), strings.and);
          if (days === '') {
            days = strings.pleaseSelectADay;
          }
          var string = strongify(strings.weekly) + space + strings.on + space;
          string += strongify(days);
          string += '<br>' + strings.at + space;
          string += strongify(time.toLocaleTimeString(preferences.culture, {
              hour: '2-digit',
              hour12: preferences.timeFormat === '12',
              minute: '2-digit'
            }) + space + strings.centralTime);
          return string;
        default:
          return '';
      }
    }

    return {

      generateVerificationFrequencyText : generateVerificationFrequencyText,
      filteredDaysOfWeek : filteredDaysOfWeek,
      getDaysOfWeekOptions : getDaysOfWeekOptions,
      time : time

    };

  }
  app.factory('SubscriptionDisplayService', subscriptionDisplayService);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  UnsubscribeController.$inject = ['$scope','$state','$stateParams', 'ReportingService','SubscriptionDisplayService','subscriptionDetail', 'user', 'preferences', 'analyticsService', 'SubscriptionToastService'];

  function UnsubscribeController($scope, $state, $stateParams, ReportingService, SubscriptionDisplayService, subscriptionDetail, user, preferences, analyticsService, SubscriptionToastService) {

    $scope.subscriptionDetail = subscriptionDetail;
    $scope.reportName = subscriptionDetail.reportName;
    $scope.email = user.email;
    $scope.previousRoute = $stateParams.previousRoute ? $stateParams.previousRoute : 'app.reports.reportHub';
    $scope.reportName = $stateParams.reportName;
    $scope.reportConfigId = $stateParams.reportConfigId;
    $scope.subscriptionFrequency = 'WEEKLY';

    $scope.onInit = function(){

      if(!$scope.subscriptionDetail.items){

        $state.go('app.reports.noSubscriptionAccess');

      }
      else{

        var daysOfWeekOptions = SubscriptionDisplayService.getDaysOfWeekOptions();

        _.forEach(daysOfWeekOptions, function (day) {

          var reportDay = _.find($scope.subscriptionDetail.items.dayOfWeek.split(','), function (dowString) {
            return dowString == day.value;
          });

          if (reportDay) {
            day.selected = true;
          }
        });

        $scope.frequencySummary = SubscriptionDisplayService.generateVerificationFrequencyText($scope.subscriptionFrequency, daysOfWeekOptions, preferences);
    }

    };

    $scope.unsubscribe = function(){

     ReportingService.deleteSubscription({savedReportConfigId: $scope.reportConfigId})

     .$promise.then(function(){

          SubscriptionToastService.subscriptionSuccess('UNSUBSCRIBED');
          $scope.analyticsUnsubscribeLog();
          $state.go($scope.previousRoute);

      })
      .catch(function () {

        SubscriptionToastService.subscriptionError('ERROR_UNSUBSCRIBING');

      });
    };

    $scope.cancel = function(){

      $state.go($scope.previousRoute);

    };

    $scope.analyticsUnsubscribeLog = function(){

      analyticsService.trackWithVar('unsubscribeRoute', $scope.previousRoute);

    };

    $scope.onInit();

  }

  app.controller('UnsubscribeController', UnsubscribeController);
})();

(function () {
  'use strict';

  SubscriptionController.$inject = ['$scope', '$state', '$stateParams', 'ReportingService', 'user', 'preferences', 'SubscriptionDisplayService', 'SubscriptionTokenService', 'SubscriptionToastService'];

  function SubscriptionController($scope, $state, $stateParams, ReportingService, user, preferences, SubscriptionDisplayService, SubscriptionTokenService, SubscriptionToastService) {

    $scope.report = {
      reportName: $stateParams.reportName,
      reportConfigId: $stateParams.reportConfigId,
      subscriptionType: $stateParams.subscriptionType
    };

    $scope.getSubscription = function (reportConfigId) {

      ReportingService.subscriptionDetail({
          savedReportConfigId: reportConfigId
        })
        .$promise.then(function (subscription) {

          if(!subscription.items){

            $state.go('app.reports.noSubscriptionAccess');
    
          }
          else{

            $scope.report = subscription.items;
            $scope.displaySubscription();
            
          }

        })
    };

    $scope.displaySubscription = function () {

      switch ($scope.report.recurringTypeID) {
        case 2:
        default:
          $scope.subscriptionFrequency = 'WEEKLY';

          if ($scope.report.dayOfWeek.length === 0) {
            _.forEach($scope.daysOfWeekOptions, function (day) {
              day.selected = 2 <= day.value && day.value <= 6;
            });
          } else {
            _.forEach($scope.daysOfWeekOptions, function (day) {
              var reportDay = _.find($scope.report.dayOfWeek, function (dowStr) {
                return dowStr == day.value;
              });
              if (reportDay) {
                day.selected = true;
              }
            });
          }
          break;
      }

      $scope.formChanged();

    }

    $scope.formChanged = function () {

      $scope.frequencySummary = SubscriptionDisplayService.generateVerificationFrequencyText($scope.subscriptionFrequency, $scope.daysOfWeekOptions, preferences);

    };

    $scope.daysOfWeekRequired = function () {
      return !_.some($scope.daysOfWeekOptions, function (day) {
        return day.selected;
      });
    };

    $scope.apiParams = function () {

      switch ($scope.subscriptionFrequency) {
        case 'WEEKLY':
          return {
            savedReportConfigId: $scope.reportConfigId,
            recurringTypeID: 2,
            dayOfWeek: _.map(SubscriptionDisplayService.filteredDaysOfWeek($scope.daysOfWeekOptions), function (day) {
              return day.value;
            }).join(','),
            dayOfMonth: 0,
            hourOfDay: $scope.time.getHours(),
            minuteOfHour: $scope.time.getMinutes(),
            isMonthlyCustom: false,
            isWeekendOption: false,
            timeZoneName: "Central Standard Time"
          };
        default:
          return {};
      }
    };

    $scope.cancel = function () {

      $state.go($scope.previousRoute);

    };

    $scope.submit = function () {

      var createSubscription = $scope.apiParams();

      ReportingService.insertSubscription(createSubscription)

        .$promise.then(function () {

          SubscriptionToastService.subscriptionSuccess('SUBSCRIPTION_SAVED');

          $state.go($scope.previousRoute);

        })

        .catch(function () {

          SubscriptionToastService.subscriptionError('ERROR_SAVING');

        });

    };

    $scope.$onInit = function () {

      $scope.email = user.email;
      $scope.time = SubscriptionDisplayService.time;
      $scope.daysOfWeekOptions = SubscriptionDisplayService.getDaysOfWeekOptions();
      $scope.previousRoute = $stateParams.previousRoute ? $stateParams.previousRoute : 'app.reports.reportHub';


      if ($stateParams.token) {

        $scope.token = SubscriptionTokenService.decodeToken($stateParams.token);
        $scope.reportName = $scope.token.reportName;
        $scope.reportConfigId = $scope.token.reportConfigID;
        $scope.previousRoute = $scope.token.previousRoute;
        $scope.getSubscription($scope.reportConfigId)

      } else if ($stateParams.subscriptionType === 'change') {

        $scope.reportName = $stateParams.reportName
        $scope.reportConfigId = $stateParams.reportConfigId

        $scope.getSubscription($scope.reportConfigId)

      } else {

        $scope.reportName = $stateParams.reportName
        $scope.reportConfigId = $stateParams.reportConfigId
        $scope.report.dayOfWeek = [];
        $scope.displaySubscription();

      }

    };

    $scope.$onInit();
  }

  angular.module('NavisphereOnline').controller('SubscriptionController', SubscriptionController);

})();

(function () {
    'use strict';

    SubscriptionDownloadController.$inject = ['$scope', '$stateParams', '$state', 'SubscriptionTokenService', 'ReportingService'];
    function SubscriptionDownloadController($scope, $stateParams, $state, SubscriptionTokenService, ReportingService) {
  
      $scope.$onInit = function () {

        $scope.pageTitle = "DOWNLOAD_SUBSCRIPTION";
        $scope.token =  SubscriptionTokenService.decodeToken($stateParams.token);
        $scope.downloadFile();

      }
      
      $scope.downloadFile = function(){

        ReportingService.downloadFile({
          fileId: $scope.token.fileid,
          fileType: $scope.token.reportFolderName
        })
  
        .$promise.then(function (response) {

          if(response.data.size === 0){

            $state.go('app.reports.noSubscriptionAccess');

          }
          else{

            return saveAs(response.data, [$scope.token.fileName + '.xlsx']);

          }
  
        })

      }

      $scope.$onInit();
  
    }
  
    angular.module('NavisphereOnline').controller('SubscriptionDownloadController', SubscriptionDownloadController);
    
  })();
(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('savedReportDisplay', ['$filter', '$state', '$uibModalStack', 'WizardDataService', 'ModalService', 'ReportPersistanceService', '$uibModal', 'SubscriptionDisplayService', 'UserPermissionService',
    function ($filter, $state, $uibModalStack, WizardDataService, ModalService, ReportPersistanceService, $uibModal, SubscriptionDisplayService, UserPermissionService) {
      return {
        templateUrl: 'app/reporting/savedReportDisplay/templates/savedReportDisplay.tpl.html',
        restrict: 'E',
        scope: {
          reportInfo: '=',
          reportConfig: '=',
          configSchedules: '=',
          createReportPath: '=',
          runReportPath: '=',
          savedReportPath: '=',
          preferences: '='
        },
        link: function (scope) {

          scope.createReport = createReport;
          scope.editReportConfig = editReportConfig;
          scope.deleteReportConfig = deleteReportConfig;
          scope.runReport = runReport;
          scope.routeChange = routeChange;
          scope.loadingSpinner = loadingSpinner;
          scope.Subscribe = Subscribe;
          scope.unSubscribe = unSubscribe;
          scope.changeSubscription = changeSubscription;
          scope.onInit = onInit;
          scope.getLocationGroupNames = getLocationGroupNames;

          scope.onRouteChangeOff;
          var loadingModal;

          function onInit() {

            scope.hasSubscriptionPermission = UserPermissionService.hasPermission('Report Subscription');

            if(scope.reportInfo.name === "Location Report"){getLocationGroupNames()};

            _.forEach(scope.reportConfig.items, function(configItem){

              configItem.hasSubscription = false;

              _.forEach(scope.configSchedules.items, function(item){

                var daysOfWeekOptions = SubscriptionDisplayService.getDaysOfWeekOptions();

                if(item.savedReportConfigID === configItem.savedReportConfigId){configItem.hasSubscription = true}

                _.forEach(daysOfWeekOptions, function (day) {
                  var reportDay = _.find(item.dayOfWeek.split(','), function (dowString) {
                    return dowString == day.value;
                  });
                  if (reportDay) {
                    day.selected = true;
                  }
                });

               item.frequency = SubscriptionDisplayService.generateVerificationFrequencyText('WEEKLY', daysOfWeekOptions, scope.preferences);

              });

            });

          }

          function createReport() {

            loadingSpinner('LOADING');

            $state.go(scope.createReportPath);

          }

          function editReportConfig(configId) {

            loadingSpinner('LOADING');

            var reportConfig = _.find(scope.reportConfig.items, ['savedReportConfigId', configId]);

            $state.go(scope.createReportPath, {reportConfigPass: reportConfig});
          }

          function deleteReportConfig(configId, reportName) {

            scope.onRouteChangeOff = scope.$on('$stateChangeStart', scope.routeChange);

            var modalOptions = {
              closeButtonText: 'CANCEL',
              actionButtonText: 'OK',
              headerText: 'ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_REPORT',
              bodyText: $filter('translate')("THE") + ' ' + reportName + ' ' + $filter('translate')("REPORT_WILL_BE_PERMANENTLY_DELETED")
            };

            ModalService.showModal({}, modalOptions).then(function (result) {
              if (result === 'ok') {

                $uibModalStack.dismissAll(result);

                WizardDataService.deleteSavedReportConfig(configId).then(function () {

                  $state.reload();

                });

                scope.onRouteChangeOff();
              }
            },function(result) {
                if (result === 'cancel') {
                  scope.onRouteChangeOff();
                }
            });
          }

          function runReport(configId) {

            var savedReportConfig = _.find(scope.reportConfig.items, ['savedReportConfigId', configId]);

            ReportPersistanceService.addReportConfig(configId, savedReportConfig).then(function () {

              $state.go(scope.runReportPath);

            });
          }

          function routeChange(event) {

            event.preventDefault();

          }

          function loadingSpinner(notice) {

            loadingModal = $uibModal.open({
              templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
              size: 'sm',
              controller: 'loadingSpinnerController',
              backdrop: 'static',
              resolve: {
                title: function () {
                  return $filter('translate')(notice);
                }
              }
            });
          }

          function getLocationGroupNames(){

            _.forEach(scope.reportConfig.items, function (item) {

              var config = JSON.parse(item.reportConfiguration);

              item.pickGroup = config.pick.groupName;
              item.dropGroup = config.drop.groupName;

            });

          }

          function Subscribe(report){

            $state.go('app.reports.subscription',{reportConfigId : report.savedReportConfigId, reportName : report.reportNameByUser, previousRoute: scope.savedReportPath, subscriptionType: 'new'});
          
          }

          function unSubscribe(report){

            $state.go('app.reports.unsubscribe',{reportConfigId : report.savedReportConfigId, reportName: report.reportNameByUser, previousRoute: scope.savedReportPath});

          }

          function changeSubscription(report){

            $state.go('app.reports.subscription',{reportConfigId : report.savedReportConfigId, reportName: report.reportNameByUser, previousRoute: scope.savedReportPath, subscriptionType: "change"})

          }

          onInit();

        }
      }
    }]);
})();
(function () {
  'use strict';

  var app = angular.module('NavisphereOnline');
  wizardDataService.$inject = ['ReportingService'];
  function wizardDataService(ReportingService) {

    function getSavedReportConfig(reportInfo) {

      return ReportingService.selectSavedReportConfig({reportName: reportInfo.name}).$promise;

    }

    function createSavedReportConfig(reportInfo, finalize, reportConfig) {

      var createRequest = {
        reportName: reportInfo.name,
        reportCategory: reportInfo.category,
        reportNameByUser: finalize.reportName,
        reportDescriptionByUser: finalize.reportDescription,
        reportConfiguration: JSON.stringify(reportConfig),
        sortOrder: 0
      };

      return ReportingService.insertSavedReportConfig(createRequest).$promise;

    }

    function updateSavedReportConfig(reportConfigId, finalize, reportConfig) {

      var updateRequest = {
        reportNameByUser: finalize.reportName,
        reportDescriptionByUser: finalize.reportDescription,
        reportConfiguration: JSON.stringify(reportConfig),
        sortOrder: 0
      };

      return ReportingService.updateSavedReportConfig({savedReportConfigId: reportConfigId}, updateRequest).$promise

    }

    function deleteSavedReportConfig(reportConfigId) {

      return ReportingService.deleteSavedReportConfig({savedReportConfigId: reportConfigId}).$promise;

    }

    return {
      getSavedReportConfig: getSavedReportConfig,
      createSavedReportConfig: createSavedReportConfig,
      updateSavedReportConfig: updateSavedReportConfig,
      deleteSavedReportConfig: deleteSavedReportConfig

    };
  }

  app.factory('WizardDataService', wizardDataService);
})();

(function () {
  'use strict';

  var app = angular.module('NavisphereOnline');
  app.filter('displayLength', function () {
    return function (input, length) {

      return input.length > length ? input.substring(0, (length)) + '...' : input;

    };
  });
})();

(function () {
  'use strict';
  //Filter to Search only visible fields and keep selected
  var app = angular.module('NavisphereOnline');
  app.filter('accountSearch', function () {
    return function (input, search) {

      var filterSet = [];

      if (search === undefined) {
        return input;
      }

      var lowSearch = search.toLowerCase();

      _.forEach(input, function (item) {

        if (item.selected) {
          filterSet.push(item)

        }
        else if (item.displayName.toLowerCase().indexOf(lowSearch) !== -1
          || _.replace(item.addressLine1, null, "").toLowerCase().indexOf(lowSearch) !== -1
          || _.replace(item.addressLine2, null, "").toLowerCase().indexOf(lowSearch) !== -1
          || _.replace(item.addressLine3, null, "").toLowerCase().indexOf(lowSearch) !== -1
          || _.replace(item.addressLine4, null, "").toLowerCase().indexOf(lowSearch) !== -1
        ) {
          filterSet.unshift(item);

        }

      });
      return filterSet;
    };
  });
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('wizardShipmentType', ['$filter', function ($filter) {
    return {
      templateUrl: 'app/reporting/reportCreationWizard/templates/wizardShipmentType.tpl.html',
      restrict: 'E',
      scope: {
        customerModes: "=customerModes",
        reportConfig: "=reportConfig",
        modesDisplay: "=modesDisplay",
        statusDisplay: "=statusDisplay"

      },
      link: function (scope) {

        scope.setupShipmentTypes = setupShipmentTypes;
        scope.selectAllOrderStatus = selectAllOrderStatus;
        scope.orderStatusToggled = orderStatusToggled;
        scope.selectAllModeStatus = selectAllModeStatus;
        scope.modeStatusToggled = modeStatusToggled;
        scope.toggleAll = toggleAll;
        scope.translateConfig = translateConfig;
        scope.createValueSet = createValueSet;
        scope.createModeValueSet = createModeValueSet;

        scope.status = [
          {"value": "INCOMPLETE", "selected": false}
          , {"value": "ORDERED", "selected": false}
          , {"value": "BOOKED", "selected": false}
          , {"value": "INTRANSIT", "selected": false}
          , {"value": "DELIVERED", "selected": false}];

        scope.modesDisplay = '';
        scope.statusDisplay = '';

        function setupShipmentTypes() {

          if (scope.reportConfig.shipmentType.modes == 'ALL_ORDER_MODES') {
            scope.selectAllModeStatus();
          }
          else {

            _.forEach(scope.customerModes, function (modes) {

              if (_.includes(scope.reportConfig.shipmentType.modes, modes.orderModeValue)) {

                modes.selected = true;

              }
            });

            scope.modesDisplay = scope.translateConfig(scope.reportConfig.shipmentType.modes.split(','));
          }

          if (scope.reportConfig.shipmentType.status == 'ALL_ORDER_STATUS') {
            scope.selectAllOrderStatus();
          }
          else {
            scope.statusDisplay = scope.translateConfig(scope.reportConfig.shipmentType.status.split(','));

            _.forEach(scope.status, function (item) {
              if (_.includes(scope.reportConfig.shipmentType.status, item.value)) {
                item.selected = true;
              }
            });
          }

        }

        function selectAllOrderStatus() {

          scope.allOrderStatus = !scope.allOrderStatus;
          scope.reportConfig.shipmentType.status = scope.allOrderStatus ? 'ALL_ORDER_STATUS' : null;
          scope.statusDisplay = scope.allOrderStatus ? $filter('translate')('ALL_ORDER_STATUS') : null;

          _.forEach(scope.status, function (item) {
            item.selected = scope.allOrderStatus;
          });

        }

        function orderStatusToggled(status) {

          status.selected = !status.selected;
          scope.allOrderStatus = scope.toggleAll(scope.status);

          scope.reportConfig.shipmentType.status = scope.allOrderStatus ? 'ALL_ORDER_STATUS' : scope.createValueSet(scope.status);
          scope.statusDisplay = scope.allOrderStatus ? $filter('translate')('ALL_ORDER_STATUS') : scope.translateConfig(scope.reportConfig.shipmentType.status.split(','));

        }

        function selectAllModeStatus() {

          scope.allModeStatus = !scope.allModeStatus;
          scope.reportConfig.shipmentType.modes = scope.allModeStatus ? 'ALL_ORDER_MODES' : null;
          scope.modesDisplay = scope.allModeStatus ? $filter('translate')('ALL_ORDER_MODES') : null;

          _.forEach(scope.customerModes, function (item) {
            item.selected = scope.allModeStatus;
          });

        }

        function modeStatusToggled(status) {

          status.selected = !status.selected;
          scope.allModeStatus = scope.toggleAll(scope.customerModes);

          scope.reportConfig.shipmentType.modes = scope.allModeStatus ? "ALL_ORDER_MODES" : scope.createModeValueSet(scope.customerModes);
          scope.modesDisplay = scope.allModeStatus ? $filter('translate')("ALL_ORDER_MODES") : scope.translateConfig(scope.reportConfig.shipmentType.modes.split(','));

        }

        function toggleAll(selectionGroup) {

          return _.every(selectionGroup, ['selected', true]);

        }

        function translateConfig(config) {

          var display = [];

          _.forEach(config, function (item) {

            display.push($filter('translate')(item));

          });

          return display.join(', ');
        }

        function createValueSet(array) {

          var valueSet = [];
          _.forEach(array, function (item) {
            if (item.selected) {
              valueSet.push(item.value);
            }
          });

          return valueSet.join(',');
        }

        function createModeValueSet(array) {

          var valueSet = [];
          _.forEach(array, function (item) {
            if (item.selected) {
              valueSet.push(item.orderModeText);
            }
          });

          return valueSet.join(',');
        }

        scope.setupShipmentTypes();
      }
    }
  }]);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('wizardLocation', ['UserPermissionService', 'LocationService', 'AddressService', function (UserPermissionService, LocationService, AddressService) {
    return {
      templateUrl: 'app/reporting/reportCreationWizard/templates/wizardLocation.tpl.html',
      restrict: 'E',
      scope: {
        reportConfig: '=reportConfig',
        configLocation: '=configLocation',
        locationType: '=locationType',
        customerList : '=customerList',
        activeWidget : '=activeWidget'

      },
      link: function (scope) {

        scope.locationChange = locationChange;
        scope.addLocation = addLocation;
        scope.removeLocation = removeLocation;
        scope.removeAllLocations = removeAllLocations;
        scope.unSelected = unSelected;
        scope.boxValid = boxValid;

        scope.selectedLocations = scope.configLocation.details;

        scope.searchText = '';

        scope.$watch('reportConfig.accountSelection', function (newValue, oldValue) {

          if(newValue !== oldValue) {

            scope.locationResults = null;
            scope.selectedLocations = [];
            scope.configLocation.codes = null;
            if(scope.configLocation.type !== 'ANYWHERE'){scope.configLocation.groupName = null}

            if (scope.searchText.length > 1) {
              scope.searchLocation();
            }

          }
        });

        scope.$watch('searchText', function (searchText) {

          if (searchText.length < 2) {
            scope.locationResults = [];
            scope.noResults = false;
            return [];
          }
          else{
            scope.searchLocation();
          }

        });

        scope.searchLocation = function(){

          scope.locationResults = null;

          var useSupplierLocation;

          _.forEach(scope.customerList, function (customer) {
            if (customer.selected == true) {
              return useSupplierLocation = customer.useSupplierLocation
            }
          });

          return LocationService.searchPartyLocation({
            partyNumberOrCode: scope.reportConfig.accountSelection,
            term: scope.searchText,
            limit: 20,
            locationSearchType: scope.locationType,
            useSupplierLocation: useSupplierLocation
          }, function (data) {
            scope.locationResults = data.items;
            

          });

        };

        scope.getAddressLine1 = function(address) {
          return AddressService.GetAddressLine1(address);
        };
        scope.getAddressLine2 = function (address) {
          return AddressService.GetAddressLine2(address);
        };
        scope.getAddressLine3 = function (address) {
          return AddressService.GetAddressLine3(address);
        };
        scope.getAddressLine4 = function (address) {
          return AddressService.GetAddressLine4(address);
        };

        scope.createLocationSet = function(){

          var locations = [];

          _.forEach(scope.selectedLocations, function (location) {
            if (location.selected == true) {

              locations.push(location.locationPartyCode).toString();

            }
          });

          scope.configLocation.codes = locations.join(',');

          scope.configLocation.details = scope.selectedLocations;

        };

        function locationChange(){

          if(scope.configLocation.type === 'ANYWHERE'){

            scope.configLocation.groupName = 'ANYWHERE';
            scope.configLocation.codes =  'ANYWHERE';
            scope.configLocation.details = [];
            scope.selectedLocations = [];
            scope.locationResults = [];
            scope.searchText = '';

          }
          else{
            scope.configLocation.groupName = null;
          }

        }

        function addLocation(location) {

          location.selected = !location.selected;
          scope.selectedLocations.push(location).toString();
          if(!scope.configLocation.groupName && scope.selectedLocations.length === 1)
          {
            scope.configLocation.groupName = location.locationPartyName
          }
          else if(scope.configLocation.groupName && scope.selectedLocations.length > 1
            && scope.selectedLocations[0].locationPartyName === scope.configLocation.groupName)
          {
            scope.configLocation.groupName = '';
          }

          scope.createLocationSet();

        }

        function removeLocation(selected) {

          selected.selected = !selected.selected;
          _.pull(scope.selectedLocations,selected);

          if(scope.selectedLocations.length === 0)
          {
            scope.configLocation.groupName = ''
          }
          else if(!scope.configLocation.groupName && scope.selectedLocations.length === 1)
          {
            scope.configLocation.groupName = scope.selectedLocations[0].locationPartyName
          }

          scope.createLocationSet();

        }

        function removeAllLocations(){

           _.forEach(scope.selectedLocations, function (location) {

              location.selected = false;

           });

          scope.configLocation.details = [];
          scope.selectedLocations = [];
          scope.configLocation.groupName = '';
          scope.configLocation.codes = null;

        }

        function unSelected(location){

          return !location.selected;
        }

        function boxValid() {

          return _.every(scope.customerList, ['selected', false]);
        }

      }
    }
  }]);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('wizardFinalize', [function () {
    return {
      templateUrl: 'app/reporting/reportCreationWizard/templates/wizardFinalize.tpl.html',
      restrict: 'E',
      scope: {
        finalize: "=finalize"
      },
      link: function (scope) {

      }
    }
  }]);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('wizardDate', ['$locale', function ($locale) {
    return {
      templateUrl: 'app/reporting/reportCreationWizard/templates/wizardDate.tpl.html',
      restrict: 'E',
      scope: {
        reportConfig: '=reportConfig'
      },
      link: function (scope) {

        scope.openStart = openStart;
        scope.openStartBlur = openStartBlur;
        scope.openEnd = openEnd;
        scope.openEndBlur = openEndBlur;


        scope.format = $locale.DATETIME_FORMATS['shortDate'];

        var maxDate = new Date();
        maxDate = maxDate.setDate(maxDate.getDate() + 365);

        scope.startDatePickerOptions = {
          showWeeks: false,
          minDate: "01/01/2015",
          maxDate: maxDate

        };

        scope.endDatePickerOptions = {
          showWeeks: false,
          minDate: "01/01/2015",
          maxDate: maxDate

        };

        function openStart($event) {

          $event.preventDefault();
          $event.stopPropagation();
          scope.openedStart = true;
          scope.openedEnd = false;

        }

        function openStartBlur() {

          scope.openedStart = false;
          scope.endDatePickerOptions.minDate = scope.reportConfig.date.startDate;

        }

        function openEnd($event) {
          $event.preventDefault();
          $event.stopPropagation();
          scope.openedEnd = true;
          scope.openedStart = false;

        }

        function openEndBlur() {

          scope.openedEnd = false;
          scope.startDatePickerOptions.maxDate = scope.reportConfig.date.endDate;

        }

      }
    }
  }]);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('wizardAccount', ['$stateParams', '$q', '$uibModalStack', 'AddressService', 'CustomerService', 'ModalService'
    , function ($stateParams, $q, $uibModalStack, AddressService, CustomerService, ModalService) {
    return {
      templateUrl: 'app/reporting/reportCreationWizard/templates/wizardAccount.tpl.html',
      restrict: 'E',
      scope: {
        customerList: '=customerList',
        reportConfig: '=reportConfig',
        activeWidget: '=activeWidget',
        multiSelect: '=multiSelect'
      },
      link: function (scope) {

        scope.clickAccount = clickAccount;
        scope.setupAccounts = setupAccounts;
        scope.selectAllAccounts = selectAllAccounts;
        scope.removeAllAccounts = removeAllAccounts;
        scope.createAccountSet = createAccountSet;
        scope.accountChanged = accountChanged;

        scope.customers = scope.customerList;

        var modalOptions = {
          closeButtonText: 'NO_KEEP_ACCOUNT',
          actionButtonText: 'YES_I_AM_SURE',
          headerText: 'ARE_YOU_SURE_YOU_WANT_TO_CHANGE_YOUR_ACCOUNT',
          bodyText: 'ALL_INFORMATION_ENTERED_FOR_THIS_ACCOUNT_WILL_BE_R'
        };

        function setupAccounts() {

          _.forEach(scope.customers, function (customers) {
            customers['addressLine1'] = AddressService.GetAddressLine1(customers.address);
            customers['addressLine2'] = AddressService.GetAddressLine2(customers.address);
            customers['addressLine3'] = AddressService.GetAddressLine3(customers.address);
            customers['addressLine4'] = AddressService.GetAddressLine4(customers.address);
            customers['displayName'] = CustomerService.GetDisplayName(customers);
            customers['selected'] = false;
          });

          if ($stateParams.reportConfigPass) {

            _.forEach(scope.customers, function (item) {
              if (_.includes(scope.reportConfig.accountSelection, item.partyCode)) {
                item.selected = true;
              }
            });
          }

          if(scope.customers.length == 1){

            scope.customers[0].selected = true;
            createAccountSet(scope.customers);
          }

        }

        function accountChanged() {

          var deferred = $q.defer();

          if ((scope.reportConfig.drop.types !== 'ANYWHERE' && scope.reportConfig.drop.codes)
            || (scope.reportConfig.pick.types !== 'ANYWHERE' && scope.reportConfig.pick.codes)){
            ModalService.showModal({}, modalOptions).then(function(result) {
              if (result === 'ok') {
                deferred.resolve(true);
              }
              if (result === 'cancel') {
                deferred.resolve(false);
              }
            });
          } else {
            deferred.resolve(true);
          }
          return deferred.promise;
        }

        function clickAccount(customer) {

          if (!scope.multiSelect && scope.reportConfig.accountSelection !== customer.partycode) {

            accountChanged().then(function (changed) {

              if(changed) {

                removeAllAccounts();

                customer.selected = !customer.selected;

                scope.createAccountSet(scope.customers);

              }

            });

          }

          else{

            customer.selected = !customer.selected;
            scope.createAccountSet(scope.customers);

          }

        }

        function selectAllAccounts() {

          _.forEach(scope.customers, function (customers) {

            customers.selected = true;

          });

          scope.createAccountSet(scope.customers);
        }

        function removeAllAccounts() {

          _.forEach(scope.customers, function (customers) {

            customers.selected = false;

          });

          scope.createAccountSet(scope.customers);
        }

        function createAccountSet(customers) {

          var accountSel = [];
          var accountSelDisplay = [];

          _.forEach(customers, function (item) {
            if (item.selected == true) {
              accountSel.push(item.partyCode).toString();
              accountSelDisplay.push(item.displayName).toString();
            }
          });

          scope.reportConfig.accountSelection = accountSel.join(',');
          scope.reportConfig.accountSelectionDisplay = accountSelDisplay;

        }

        scope.setupAccounts();
      }
    };
  }]);
})();

(function () {
  'use strict';

  var app = angular.module('NavisphereOnline');
  reportHubConfigService.$inject = ['UserPermissionService','ReportingService'];
  function reportHubConfigService(UserPermissionService,ReportingService) {

    function getReportList(){
      var reportSet = ['In Transit Report', 'Orders Overview Report', 'Service Performance Report', 'Overdue Orders Report', 'Orders Summary Report', 'Location Report', 'Oceania Reports'];
      return reportSet;
    }

    var getReportConfig = function (){

      var reportConfig =  [{
        'rptid': 0,
        'title': 'IN_TRANSIT_ORDERS',
        'permission': 'In Transit Report',
        'cat': 'Order Activity',
        'route': 'app.reports.inTransitReport',
        'description': 'VIEW_ALL_ORDERS_THAT_HAVE_BEEN_PICKED_UP_AND_NOT_Y'
      },
        {
          'rptid': 1,
          'title': 'ORDER_OVERVIEW',
          'permission': 'Orders Overview Report',
          'cat': 'Order Activity',
          'route': 'app.reports.ordersOverviewReport',
          'description': 'CHOOSE_ACCOUNT_STATUS_AND_MODE_TO_CREATE_CUSTOM_OR'
        },
        {
          'rptid': 2,
          'title': 'SERVICE_PERFORMANCE',
          'permission': 'Service Performance Report',
          'cat': 'Performance',
          'route': 'app.reports.servicePerformanceReport',
          'description': 'VIEW_ON_TIME_PICK_UP_AND_DELIVERY_PERFORMANCE'
        },
        {
          'rptid': 3,
          'title': 'OVERDUE_ORDERS',
          'permission': 'Overdue Orders Report',
          'cat': 'Order Activity',
          'route': 'app.reports.overdueOrdersReport',
          'description': 'VIEW_ALL_ORDERS_THAT_ARE_LATE_FOR_PICK_UP_OR_DELIV'
        },
        {
          'rptid': 4,
          'title': 'ORDERS_SUMMARY',
          'permission': 'Orders Summary Report',
          'cat': 'Order Activity',
          'route': 'app.reports.savedOrdersSummary',
          'description': 'CHOOSE_ACCOUNT_STATUS_AND_MODE_TO_CREATE_CUSTOM_OR'
        },
        {
          'rptid': 5,
          'title': 'LOCATION_REPORTS',
          'permission': 'Location Report',
          'cat': 'Order Activity',
          'route': 'app.reports.savedLocation',
          'description': 'VIEW_ORDERS_PICKING_UP_FROM_OR_DELIVERING_TO_A_SPE'
        }];

      return reportConfig;
    };

    //Return the only report config for the permissions the user has access to.
    var getReportBuild = function(){

      var reportConfig = this.getReportConfig();

      for(var i = 0; i < reportConfig.length ; i++) {
        if(UserPermissionService.hasPermission(reportConfig[i].permission) === false) {
          delete reportConfig[i];
          }
        }
      return reportConfig;

    };

    var getSubscriptionSummary = function(){


      if(UserPermissionService.hasPermission('Report Subscription')) {

        return ReportingService.subscriptionSummary().$promise;

      }
      else{

        return Promise.reject('No Permssion');

      }

    };

    return {
      getReportList : getReportList,
      getReportConfig : getReportConfig,
      getReportBuild : getReportBuild,
      getSubscriptionSummary : getSubscriptionSummary
    };

  }
  app.factory('ReportHubConfigService', reportHubConfigService);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  ReportHubController.$inject = ['$scope', '$state', 'ReportHubConfigService', 'WizardDataService', 'SubscriptionDisplayService', 'preferences', 'UserPermissionService'];

  function ReportHubController($scope, $state, ReportHubConfigService, WizardDataService, SubscriptionDisplayService, preferences, UserPermissionService) {

    $scope.reportBuild = ReportHubConfigService.getReportBuild();

    if(UserPermissionService.hasPermission('Report Subscription')){
      ReportHubConfigService.getSubscriptionSummary().then(function(subscriptionSummary){

        $scope.subscriptionSummary = subscriptionSummary.subscriptionSummary;
        $scope.subscriptionFrequency = 'WEEKLY';

        _.forEach($scope.subscriptionSummary, function(item){

          var daysOfWeekOptions = SubscriptionDisplayService.getDaysOfWeekOptions();

          _.forEach(daysOfWeekOptions, function (day) {
            var reportDay = _.find(item.dayOfWeek.split(','), function (dowString) {
              return dowString == day.value;
            });
            if (reportDay) {
              day.selected = true;
            }
          });

          item.frequency = SubscriptionDisplayService.generateVerificationFrequencyText($scope.subscriptionFrequency, daysOfWeekOptions, preferences);

        });

      })
    }


    $scope.hasCategory = function(category)
    {
      return _.find($scope.reportBuild, ['cat' ,category]);
    };

    $scope.navSelected = function (state) {

      $state.go(state);

    };

    $scope.Subscribe = function(report, reportConfigId, type){

      if(reportConfigId === 0){

        var reportInfo = {
          'name': report.permission,
          'category':  report.cat,
          'title': ''
        };
        var reportConfig = {};

        var finalize = {'reportName': report.permission, 'reportDescription': 'testDescription'};

        WizardDataService.createSavedReportConfig(reportInfo, finalize, reportConfig).then(function (response) {

          $state.go('app.reports.subscription',{reportConfigId : response.configId, reportName : report.permission, subscriptionType: 'new'})

        });

      }

      else{$state.go('app.reports.subscription',{reportConfigId : reportConfigId, type: type})}
    };

    $scope.unSubscribe = function(report, reportConfigId){

      $state.go('app.reports.unsubscribe',{reportConfigId : reportConfigId, reportName: report.permission, previousRoute: 'app.reports.reportHub'});

    };

    $scope.changeSubscription = function(report, subscription){

      $state.go('app.reports.subscription',{reportConfigId : subscription.savedReportConfigID,
        reportName : report.permission,
        previousRoute: 'app.reports.reportHub',
        subscriptionType: 'change'

        })

    };
  }

  app.controller('ReportHubController', ReportHubController);

})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  OverdueOrdersController.$inject = ['$scope', '$state', '$window', '$filter', 'ReportingService', 'ServiceOffering'
    , 'StatusMappingService', 'ExcelReportExporterService', 'ReportDataDisplayService', 'WindowLocationHref'];
  function OverdueOrdersController($scope, $state, $window, $filter, ReportingService, ServiceOffering
    , StatusMappingService, ExcelReportExporterService, ReportDataDisplayService, WindowLocationHref) {

    $scope.currentPage = 1;
    $scope.totalRecords = 0;
    $scope.sortBy = 'account';
    $scope.sortDescending = "false";
    $scope.gridSort = "";
    $scope.limit = 50;
    $scope.offset = 0;
    $scope.exportReady = false;
    $scope.daysText = $filter('translate')("DAYS");
    $scope.onTimeText = $filter('translate')("ON_TIME");
    $scope.reportHeaders = {
      order: 'Orders',
      customer: 'Customer',
      primaryRefNumber: 'Primary Reference Number',
      orderCreateDate: 'Order Create Date',
      shippingMethod: 'Shipping Method',
      loadNumber: 'Load Number',
      trackingNumber: 'Tracking Number',
      orderActivityDate: 'Order Activity Date',
      originName: 'Order Pickup Location Name',
      originLocation: 'Order Pickup Location',
      earliestPickDate: 'Earliest Pickup Date',
      latestPickupDate: 'Latest Pickup Date',
      actualPickupDate: 'Actual Pickup Date',
      pickupDateDifference: 'Overdue for Pickup',
      destinationName: 'Order Delivery Location Name',
      destinationLocation: 'Order Delivery Location',
      earliestDeliveryDate: 'Earliest Delivery Date',
      latestDeliveryDate: 'Latest Delivery Date',
      deliveryDateDifference: 'Overdue for Delivery',
      status: 'Status'
    };
    $scope.reportRunning = false;
    $scope.reportTitle = $filter('translate')("OVERDUE_ORDERS");

    $scope.goToOrderDetails = function (orderNum) {
			var redirectUrl =  appConfig.ordersUIBaseUrl + '/#/detail/' + orderNum;
			WindowLocationHref.setWindowLocationHref(redirectUrl);
    };

    $scope.goToTrackingDetails = function (trackingNumber) {

      $window.open(appConfig.trackingDetailsLink + '/#/?trackingNumber=' + trackingNumber);

    };

    $scope.grabOverdueOrders = function () {

      $scope.reportRunning = true;
      $scope.overdueOrdersData = [];

      ReportingService.overdueOrders({
        from: (($scope.currentPage || 0) - 1) * $scope.limit,
        pageSize: $scope.limit,
        sortBy: $scope.sortBy,
        sortDescending: $scope.sortDescending
      })
        .$promise.then(function (response) {

          $scope.totalRecords = response.total;

          var data = [];

          _.forEach(response.items, function (value) {

            data.push({

              'order': value.orderNumber,
              'customer': ReportDataDisplayService.dataCheck(value.customer, -1, 'name'),
              'primaryRefNumber': ReportDataDisplayService.getPrimaryRefNumber(value),
              'orderCreateDate': ReportDataDisplayService.formatDate(value.createdDateTime),
              'shippingMethod': ServiceOffering.get(ReportDataDisplayService.dataCheck(value.services, 0, 'serviceOfferingNumber')),
              'trackingNumber': ReportDataDisplayService.getTrackingNumber(value),
              'orderActivityDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].loads, 0, 'activityDate')),
              'originName': ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'name'),
              'originLocation': ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'city') + ', ' + ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'state'),
              'latestPickupDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'plannedLatestTime')),
              'actualPickupDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'actualArrivalTime')),
              'pickupDateDiff': $scope.dateOverduePickDiff(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'plannedLatestTime'), ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'plannedLatestDate'), ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'actualArrivalTime'), ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'actualArrivalDate')),
              'overduePickup': $scope.dateDiff(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'plannedLatestTime'), ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'actualArrivalTime')),
              'destinationName': ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'name'),
              'destinationLocation': ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'city') + ', ' + ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'state'),
              'earliestDeliveryDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'plannedEarliestTime')),
              'latestDeliveryDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'plannedLatestTime')),
              'deliveryDateDiff': $scope.dateOverdueDeliveryDiff(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'plannedLatestTime'), moment.now()),
              'overdueDelivery': $scope.dateDiff(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'plannedLatestTime'), moment.now()),
              'status': $filter('translate')(StatusMappingService.getStatusResourceKey(ReportDataDisplayService.dataCheck(value.services, 0, 'statusRDN')))

            });
          });

          $scope.overdueOrdersData = data;
          $scope.reportRunning = false;

        }, function () {

        });
    };

    $scope.grabOverdueOrdersDataExport = function () {
      ReportingService.overdueOrders({
        from: 0,
        pageSize: 500,
        sortBy: $scope.sortBy,
        sortDescending: $scope.sortDescending
      }).$promise.then(function (response) {
        var data = [];

        _.forEach(response.items, function (value) {

          data.push({
            'order':'"=HYPERLINK(""' + appConfig.ordersUIBaseUrl + '/#/detail/' + value.orderNumber + '"",' + value.orderNumber + ')"',
            'customer': ReportDataDisplayService.dataCheck(value.customer, -1, 'name'),
            'primaryRefNumber': ReportDataDisplayService.removeComma(ReportDataDisplayService.getPrimaryRefNumber(value)),
            'orderCreateDate': ReportDataDisplayService.formatDate(value.createdDateTime),
            'shippingMethod': ServiceOffering.get(ReportDataDisplayService.dataCheck(value.services, 0, 'serviceOfferingNumber')).serviceOfferingName,
            'loadNumber': ReportDataDisplayService.dataCheck(value.services[0].loads, 0, 'loadNumber'),
            'trackingNumber': '"=HYPERLINK(""' + appConfig.trackingDetailsLink + '/#/?trackingNumber=' + ReportDataDisplayService.getTrackingNumber(value) + '"",""' + ReportDataDisplayService.getTrackingNumber(value) + '"")"',
            'orderActivityDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].loads, 0, 'activityDate')),
            'originName': ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'name')),
            'originLocation': ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'city') + ' ' + ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'state'))),
            'earliestPickupDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'plannedEarliestTime')),
            'latestPickupDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'plannedLatestTime')),
            'actualPickupDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'actualArrivalTime')),
            'pickupDateDiff': $scope.dateOverduePickDiffExport(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'plannedLatestTime'), ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'plannedLatestDate'), ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'actualArrivalTime'), ReportDataDisplayService.dataCheck(value.services[0].pickupFrom, -1, 'actualArrivalDate'), 'p'),
            'destinationName': ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'name')),
            'destinationLocation': ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'city') + ' ' + ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'state'))),
            'earliestDeliveryDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'plannedEarliestTime')),
            'latestDeliveryDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'plannedLatestTime')),
            'deliveryDateDiff': $scope.dateOverdueDeliveryDiffExport(ReportDataDisplayService.dataCheck(value.services[0].deliverTo, -1, 'plannedLatestTime'), moment.now()),
            'status': $filter('translate')(StatusMappingService.getStatusResourceKey(ReportDataDisplayService.dataCheck(value.services, 0, 'statusRDN')))
          });

          $scope.exportData = data;
          $scope.exportReady = true;
        });

        $scope.exportData.unshift($scope.reportHeaders);

      }, function () {

      });
    };

    $scope.limitChanged = function (limit) {

      $scope.limit = limit;
      $scope.currentPage = Math.floor($scope.offset / $scope.limit) + 1;
      $scope.offset = ($scope.currentPage - 1) * $scope.limit;
      $scope.grabOverdueOrders();

    };

    $scope.dateDiff = function (plannedDateTime, actualDateTime) {

      var plannedDateTimeMoment = moment(plannedDateTime);
      var actualDateTimeMoment = moment(actualDateTime);
      var dateDiff = actualDateTimeMoment.diff(plannedDateTimeMoment, 'hours');

      return dateDiff;
    };

    $scope.dateOverduePickDiff = function (plannedDateTime, plannedDate, actualDateTime, actualDate) {

      var overdueVerbiage = "";

      var plannedDateTimeMoment = moment(plannedDateTime);
      var actualDateTimeMoment = moment(actualDateTime);

      var overdue = actualDateTimeMoment.diff(plannedDateTimeMoment, 'hours');
      var days = (overdue / 24);
      var hours = ((days % 1) * 24).toFixed(0);
      if (plannedDateTime === plannedDate) { days-- }

      if (plannedDateTime === actualDate) { overdueVerbiage = "On Time"; }
      else if (overdue >= 24) {
        overdueVerbiage = Math.floor(days) + " " + $scope.daysText + " " + hours + " hrs";
      }
      else if (overdue > 0) {
        overdueVerbiage = hours + " hrs";
      }
      else {
        overdueVerbiage = $scope.onTimeText;
      }
      return overdueVerbiage;
    };

    $scope.dateOverduePickDiffExport = function (plannedDateTime, plannedDate, actualDateTime, actualDate) {

      var overdueVerbiage = "";

      var plannedDateTimeMoment = moment(plannedDateTime);
      var actualDateTimeMoment = moment(actualDateTime);

      var overdue = actualDateTimeMoment.diff(plannedDateTimeMoment, 'hours');
      var days = overdue / 24;
      var hours = ((days % 1) * 24).toFixed(0);
      //space that export for sorting
      var daysLength = days.toFixed(0).length;
      if (plannedDateTime === plannedDate) {
        days--
      }
      var daysSpaceAdd = daysLength === 2 ? " " : daysLength === 1 ? "  " : "";
      var hoursSpaceAdd = hours.length === 1 ? " " : "";

      if (plannedDateTime === actualDate) {
        overdueVerbiage = "   " + $scope.onTimeText;
      }
      else if (overdue >= 24) {
        overdueVerbiage = daysSpaceAdd + Math.floor(days) + " " + $scope.daysText + " " + hours + " hrs";
      }
      else if (overdue > 0) {
        overdueVerbiage = hoursSpaceAdd + "   " + hours + " hrs";
      }
      else {
        overdueVerbiage = "     " + $scope.onTimeText;
      }
      return overdueVerbiage;
    };

    $scope.dateOverdueDeliveryDiff = function (plannedDateTime, now) {

      var overdueVerbiage = "";

      var plannedDateTimeMoment = moment(plannedDateTime);
      var nowMoment = moment(now);
      var overdue = nowMoment.diff(plannedDateTimeMoment, 'hours');

      var days = overdue / 24;
      var hours = ((days % 1) * 24).toFixed(0);


      if (overdue >= 24) {
        overdueVerbiage = Math.floor(days) + " " + $scope.daysText + " " + hours + " hrs";
      }
      else if (overdue > 0) {
        overdueVerbiage = hours + " hrs";
      }
      else {
        overdueVerbiage = "";
      }
      return overdueVerbiage;
    };


    $scope.dateOverdueDeliveryDiffExport = function (plannedDateTime, now) {

      var overdueVerbiage = "";
      var plannedDateTimeMoment = moment(plannedDateTime);
      var nowMoment = moment(now);

      var overdue = nowMoment.diff(plannedDateTimeMoment, 'hours');
      var days = overdue / 24;
      var hours = ((days % 1) * 24).toFixed(0);

      var daysLength = days.toFixed(0).length;
      var daysSpaceAdd = daysLength === 2 ? " " : daysLength === 1 ? "  " : "";
      var hoursSpaceAdd = hours.length === 1 ? " " : "";

      if (overdue >= 24) {
        overdueVerbiage = daysSpaceAdd + Math.floor(days) + " " + $scope.daysText + " " + hours + " hrs";
      }
      else if (overdue > 0) {
        overdueVerbiage = daysSpaceAdd + hoursSpaceAdd + "         " + hours + " hrs";
      }
      else {
        overdueVerbiage = "";
      }
      return overdueVerbiage;
    };


    $scope.exportOverdueOrders = function () {

      ExcelReportExporterService.exportReportExcel($scope.exportData, $scope.reportTitle);

    };

    $scope.sortOverdueOrders = function () {
      if ($scope.sortBy === 'overdueDelivery' || $scope.sortBy === 'overduePickup') {
        $scope.gridSort = $scope.sortDescending == "true" ? "-" + $scope.sortBy : $scope.sortBy;
      }
      else {
        $scope.gridSort = "";
        $scope.grabOverdueOrders();
      }
    };

    $scope.grabOverdueOrders();
    $scope.grabOverdueOrdersDataExport();
  }
  app.controller('OverdueOrdersController', OverdueOrdersController);
})();

(function () {
  'use strict';

  var app = angular.module('NavisphereOnline');
  ordersSummaryExportService.$inject = ['$filter', '$uibModal', 'ReportingService', 'ReportDataDisplayService', 'ExcelReportExporterService'];
  function ordersSummaryExportService($filter, $uibModal, ReportingService, ReportDataDisplayService, ExcelReportExporterService) {

    var loadingModal;

    function exportXLSX(params) {

      reportSpinner('DOWNLOAD_REPORT');

      return ReportingService.ordersSummaryReportExport(params).$promise.then(function (response) {

        loadingModal.close();

        return saveAs(response.data, ['OrdersSummaryReport.xls']);

      });

    }

    function exportCSV(reportConfigId, sortBy, sortDescending, reportTitle, reportHeaders) {

      reportSpinner('DOWNLOAD_REPORT');

      return ReportingService.ordersSummaryReport({
        reportConfigId: reportConfigId,
        from: 0,
        pageSize: 1000,
        sortBy: sortBy,
        sortDescending: sortDescending
      }).$promise.then(function (response) {

        var data = [];
        var exportData = [];

        _.forEach(response.items, function (value) {

          data.push({
            'order':'"=HYPERLINK(""' + appConfig.ordersUIBaseUrl + '/#/detail/' + value.orderNumber + '"",' + value.orderNumber + ')"',
            'trackingNumber': '"=HYPERLINK(""' + appConfig.trackingDetailsLink + '/#/?trackingNumber=' + value.orderSummaryDetail.trackingReferenceNumber + '"",""' + value.orderSummaryDetail.trackingReferenceNumber + '"")"',
            'account': ReportDataDisplayService.removeComma(value.customer.name),
            'primaryRefNumber': ReportDataDisplayService.removeComma(value.orderSummaryDetail.primaryReferenceNumber),
            'originName': ReportDataDisplayService.removeComma(value.originLocation.name),
            'originCity': ReportDataDisplayService.removeComma(value.originLocation.city),
            'originState': ReportDataDisplayService.removeComma(value.originLocation.state),
            'earliestRequestesPickupDate': ReportDataDisplayService.formatDate(value.originLocation.earliestRequestedDate),
            'latestRequestedPickupDate': ReportDataDisplayService.formatDate(value.originLocation.latestRequestedDate),
            'earliestScheduledPickupDate': ReportDataDisplayService.formatDate(value.originLocation.earliestScheduledDate),
            'latestScheduledPickupDate': ReportDataDisplayService.formatDate(value.originLocation.earliestScheduledDate),
            'actualPickupArrivalDate': ReportDataDisplayService.formatDate(value.originLocation.actualArrivalDate),
            'actualPickupDepartureDate': ReportDataDisplayService.formatDate(value.originLocation.actualDepartureDate),
            'destinationName': ReportDataDisplayService.removeComma(value.destinationLocation.name),
            'destinationCity': ReportDataDisplayService.removeComma(value.destinationLocation.city),
            'destinationState': ReportDataDisplayService.removeComma(value.destinationLocation.state),
            'earliestRequestesDeliveryDate': ReportDataDisplayService.formatDate(value.destinationLocation.earliestRequestedDate),
            'latestRequestedDeliveryDate': ReportDataDisplayService.formatDate(value.destinationLocation.latestRequestedDate),
            'earliestScheduledDeliveryDate': ReportDataDisplayService.formatDate(value.destinationLocation.earliestScheduledDate),
            'latestScheduledDeliveryDate': ReportDataDisplayService.formatDate(value.destinationLocation.earliestScheduledDate),
            'actualDeliveryArrivalDate': ReportDataDisplayService.formatDate(value.destinationLocation.actualArrivalDate),
            'actualDeliveryDepartureDate': ReportDataDisplayService.formatDate(value.destinationLocation.actualDepartureDate),
            'orderStatus': $filter('translate')(ReportDataDisplayService.removeComma(value.orderSummaryDetail.orderStatus)),
            'orderMode': $filter('translate')(ReportDataDisplayService.removeComma(value.orderSummaryDetail.orderMode)),
            'carrierName': ReportDataDisplayService.removeComma(value.carrier.name),
            'proReferenceNumber': ReportDataDisplayService.removeComma(value.orderSummaryDetail.proReferenceNumber)
          });

          exportData = data;

        });

        exportData.unshift(reportHeaders);

        ExcelReportExporterService.exportReportExcel(exportData, reportTitle);

        loadingModal.close();

      });
    }

    function reportSpinner(notice){

      loadingModal = $uibModal.open({
        templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
        size: 'sm',
        controller: 'loadingSpinnerController',
        backdrop: 'static',
        resolve: {
          title: function () {
            return $filter('translate')(notice);
          }
        }
      });
    }

      return {
        exportXLSX: exportXLSX,
        exportCSV: exportCSV,
        reportSpinner: reportSpinner

      };
    }

    app.factory('OrdersSummaryExportService', ordersSummaryExportService);
  }

  )();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  SavedOrdersSummaryController.$inject = ['$scope', '$filter', 'savedReportConfigs','reportConfigsSchedules','preferences'];
  function SavedOrdersSummaryController($scope, $filter, savedReportConfigs, reportConfigsSchedules, preferences) {

    $scope.reportConfig = savedReportConfigs;

    $scope.configSchedules = reportConfigsSchedules;

    $scope.preferences = preferences;

    $scope.reportInfo = {name : 'Orders Summary Report', title: $filter('translate')('ORDERS_SUMMARY_REPORT'), message : $filter('translate')("YOU_HAVE_NOT_CREATED_ANY_ORDERS_SUMMARY_REPORTS_YE")};

    $scope.createReportPath = 'app.reports.createOrdersSummary';

    $scope.runReportPath = 'app.reports.ordersSummary';

    $scope.savedReportPath = 'app.reports.savedOrdersSummary';

  }

  app.controller('SavedOrdersSummaryController', SavedOrdersSummaryController);

})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  OrdersSummaryController.$inject = ['$scope', '$filter', '$stateParams', '$state', '$window', 'ReportingService'
    ,'ReportDataDisplayService', 'OrdersSummaryExportService', 'ReportPersistanceService', 'WindowLocationHref'];
  function OrdersSummaryController($scope, $filter, $stateParams, $state, $window, ReportingService
    ,ReportDataDisplayService, OrdersSummaryExportService, ReportPersistanceService, WindowLocationHref) {

    $scope.reportTitle = $filter('translate')("ORDERS_SUMMARY_REPORT");

    $scope.reportConfigId = ReportPersistanceService.getConfigVariable('orderSummaryConfigID');
		$scope.reportConfig = ReportPersistanceService.getConfigVariable('orderSummaryConfig');

		// If user is coming back from react order details or refreshes page 
		// they wont have a reportConfig so send them back to savedOrdersSummary
		if ($scope.reportConfig) {
			$scope.reportConfiguration = JSON.parse($scope.reportConfig.reportConfiguration);
		} else {
			$state.go('app.reports.savedOrdersSummary')
		}

    $scope.currentPage = 1;
    $scope.sortBy = 'account';
    $scope.sortDescending = 'true';
    $scope.limit = 50;
    $scope.offset = 0;
    $scope.accountViewSize = 3;
    $scope.reportReturn = [];
    $scope.reportRunning = true;

    $scope.reportHeaders = {
      order: $filter('translate')('ORDER_NUMBER'),
      trackingNumber: $filter('translate')('TRACKING_NUMBER'),
      account: $filter('translate')('ACCOUNT_NAME'),
      primaryRefNumber: $filter('translate')('PRIMARY_REFERENCE_NUMBER'),
      originName: $filter('translate')('ORIGIN_PICKUP_NAME'),
      originCity: $filter('translate')('ORIGIN_PICKUP_CITY'),
      originState: $filter('translate')('ORIGIN_PICKUP_STATE'),
      earliestRequestesPickupDate: $filter('translate')('EARLIEST_REQUESTED_PICKUP_DATE'),
      latestRequestedPickupDate: $filter('translate')('LATEST_REQUESTED_PICKUP_DATE'),
      earliestScheduledPickupDate: $filter('translate')('EARLIEST_SCHEDULED_PICKUP_DATE'),
      latestScheduledPickupDate: $filter('translate')('LATEST_SCHEDULED_PICKUP_DATE'),
      actualPickupArrivalDate: $filter('translate')('ACTUAL_PICKUP_ARRIVAL'),
      actualPickupDepartureDate: $filter('translate')('ACTUAL_PICKUP_DEPARTURE'),
      destinationName: $filter('translate')('DESTINATION_DELIVERY_NAME'),
      destinationCity: $filter('translate')('DESTINATION_DELIVERY_CITY'),
      destinationState: $filter('translate')('DESTINATION_DELIVERY_STATE'),
      earliestRequestesDeliveryDate: $filter('translate')('EARLIEST_REQUESTED_DELIVERY_DATE'),
      latestRequestedDeliveryDate: $filter('translate')('LATEST_REQUESTED_DELIVERY_DATE'),
      earliestScheduledDeliveryDate: $filter('translate')('EARLIEST_SCHEDULED_DELIVERY_DATE'),
      latestScheduledDeliveryDate: $filter('translate')('LATEST_SCHEDULED_DELIVERY_DATE'),
      actualDeliveryArrivalDate: $filter('translate')('ACTUAL_DELIVERY_ARRIVAL'),
      actualDeliveryDepartureDate: $filter('translate')('ACTUAL_DELIVERY_DEPARTURE'),
      orderStatus: $filter('translate')('ORDER_STATUS'),
      orderMode: $filter('translate')('ORDER_MODE'),
      carrierName: $filter('translate')('CARRIER_NAME'),
      proReferenceNumber: $filter('translate')('PRO_REFERENCE_NUMBER')
    };

    $scope.goToOrderDetails = function (orderNum) {
			var redirectUrl =  appConfig.ordersUIBaseUrl + '/#/detail/' + orderNum;
			WindowLocationHref.setWindowLocationHref(redirectUrl);
    };

    $scope.goToTrackingDetails = function (trackingNumber) {

      $window.open(appConfig.trackingDetailsLink + '/#/?trackingNumber=' + trackingNumber);

    };

    $scope.showAccounts = function () {
      $scope.accountList = !$scope.accountList;
      $scope.accountViewSize = $scope.accountList ? 500 : 3;
    };

    $scope.limitChanged = function (limit) {

      $scope.limit = limit;
      $scope.currentPage = Math.floor($scope.offset / $scope.limit) + 1;
      $scope.offset = ($scope.currentPage - 1) * $scope.limit;
      $scope.grabOrdersSummary();

    };

    $scope.grabOrdersSummary = function () {

      $scope.reportReturn = [];
      $scope.reportRunning = true;

        ReportingService.ordersSummaryReport({
          reportConfigId: $scope.reportConfigId,
          from: (($scope.currentPage || 0) - 1) * $scope.limit,
          pageSize: $scope.limit,
          sortBy: $scope.sortBy,
          sortDescending: $scope.sortDescending
        })
          .$promise.then(function (ordersSummaryReport) {
          $scope.reportReturn = ordersSummaryReport.items;
          $scope.totalRecords = ordersSummaryReport.total;
          $scope.reportRunning = false;
        })

    };

    $scope.exportXLSX = function(){

      var params = {
        reportConfigId: $scope.reportConfigId,
        from: 0,
        pageSize: 5000,
        sortBy: $scope.sortBy,
        sortDescending: $scope.sortDescending
      };

      OrdersSummaryExportService.exportXLSX(params);

    };

    $scope.exportCSV = function(){

      OrdersSummaryExportService.exportCSV($scope.reportConfigId, $scope.sortBy, $scope.sortDescending, $scope.reportTitle, $scope.reportHeaders);

    };

    $scope.grabOrdersSummary();
    $scope.statusDisplay = ReportDataDisplayService.translateConfig($scope.reportConfiguration.shipmentType.status.split(','));
    $scope.modesDisplay = ReportDataDisplayService.translateConfig($scope.reportConfiguration.shipmentType.modes.split(','));
    $scope.dateDisplay = ReportDataDisplayService.createDateRange($scope.reportConfiguration.date);

    $scope.grabOrdersSummary();

  }

  app.controller('OrdersSummaryController', OrdersSummaryController);

})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  CreateOrdersSummaryController.$inject = ['$scope', '$filter', '$state', '$uibModalStack', '$stateParams', '$window', '$timeout'
    , 'WizardDataService', 'ModalService', 'customerModes', 'orderCustomers', 'analyticsService'];
  function CreateOrdersSummaryController($scope, $filter, $state, $uibModalStack, $stateParams, $window, $timeout,
    WizardDataService, ModalService, customerModes, orderCustomers, analyticsService) {

    $uibModalStack.dismissAll();
    var onRouteChangeOff;
    $scope.widget = 'accountWidget';

    $scope.reportInfo = {
      'name': 'Orders Summary Report',
      'category': 'Order Activity',
      'title': $filter('translate')("CREATE_ORDERS_SUMMARY_REPORT")
    };
    $scope.reportConfig = {
      'accountSelection': '',
      'date': { 'type': '', 'range': '', 'startDate': '', 'endDate': '', 'startDatePass': 0, 'endDatePass': 0 },
      'shipmentType': { 'status': '', 'modes': '' },
      'accountSelectionDisplay': []
    };

    $scope.statusDisplay = '';
    $scope.modesDisplay = '';

    $scope.finalize = { 'reportName': '', 'reportDescription': '' };

    $scope.activeWidget = 'accountWidget';
    $scope.customerList = orderCustomers.customers;

    $scope.customerModes = customerModes;

    $scope.buttonWidgetHeight = $window.document.getElementById('buttonWidget').offsetHeight;
    $scope.scrollPullHeight = 20;

    $scope.showRefreshPrompt = function () {

      if (!$scope.createOrdersSummaryForm.$dirty && $scope.reportConfig.accountSelection.length === 0
        && !$scope.reportConfig.shipmentType.status && !$scope.reportConfig.shipmentType.modes) {
        return;
      }

      $scope.analyticsCancelLog();

      return true;

    };

    $window.onbeforeunload = $scope.showRefreshPrompt;

    $scope.clickWidget = function (widget) {

      $scope.widgetClick = 1;
      $scope.activeWidget = widget;
      $window.document.getElementById(widget).scrollIntoView();

    };

    var modalOptions = {
      closeButtonText: 'CANCEL',
      actionButtonText: 'OK',
      headerText: 'ARE_YOU_SURE_YOU_WANT_TO_EXIT_THE_REPORT_CREATION',
      bodyText: 'ALL_INFORMATION_FOR_THIS_REPORT_WILL_BE_LOST'
    };

    $scope.routeChange = function (event, toState) {

      if ((!$scope.createOrdersSummaryForm.$dirty && $scope.reportConfig.accountSelection.length === 0
        && !$scope.reportConfig.shipmentType.status && !$scope.reportConfig.shipmentType.modes) || toState.name === 'login') {
        return;
      }

      ModalService.showModal({}, modalOptions).then(function (result) {
        if (result === 'ok') {

          onRouteChangeOff();
          $uibModalStack.dismissAll(result);
          $scope.analyticsCancelLog();
          $state.go(toState);
        }
      });

      event.preventDefault();
    };

    $scope.initRouteChange = function () {

      onRouteChangeOff = $scope.$on('$stateChangeStart', $scope.routeChange);

    };

    $scope.cancelCreation = function () {

      $state.go('app.reports.savedOrdersSummary');

    };

    $scope.saveReport = function () {

      $scope.clearDates();

      if (!$scope.reportConfigId) {
        WizardDataService.createSavedReportConfig($scope.reportInfo, $scope.finalize, $scope.reportConfig).then(function () {

          onRouteChangeOff();
          $scope.analyticsSaveLog();
          $state.go('app.reports.savedOrdersSummary');

        });
      }
      else {

        WizardDataService.updateSavedReportConfig($scope.reportConfigId, $scope.finalize, $scope.reportConfig).then(function () {

          onRouteChangeOff();
          $scope.analyticsUpdateLog();
          $state.go('app.reports.savedOrdersSummary');

        });
      }
    };

    $scope.clearDates = function () {

      if ($scope.reportConfig.date.range !== 'CUSTOM') {

        $scope.reportConfig.date.startDate = '';
        $scope.reportConfig.date.endDate = '';

      }

    };

    $scope.createOrdersSummarySettup = function () {

      if ($stateParams.reportConfigPass) {

        var reportConfigSet = JSON.parse($stateParams.reportConfigPass.reportConfiguration);
        $scope.finalize.reportName = $stateParams.reportConfigPass.reportNameByUser;
        $scope.finalize.reportDescription = $stateParams.reportConfigPass.reportDescriptionByUser;
        $scope.reportConfigId = $stateParams.reportConfigPass.savedReportConfigId;
        $scope.reportConfig = reportConfigSet;
        $scope.reportConfig.date.startDate = $scope.reportConfig.date.startDate ? new Date($scope.reportConfig.date.startDate) : null;
        $scope.reportConfig.date.endDate = $scope.reportConfig.date.endDate ? new Date($scope.reportConfig.date.endDate) : null;

      }

    };

    $scope.dateRangeValid = function (date) {

      if (date.type !== '' && date.range !== '') {
        if (date.range !== 'CUSTOM') {
          return true;
        }
        else if (date.startDate && date.endDate) {
          return true;
        }
      }
      return false;
    };

    $scope.wizardScroll = function () {

      $scope.wizardAreaHeight = $window.document.getElementById('wizardScrollArea').offsetHeight;
      $scope.dateWidgetTop = $window.document.getElementById('dateWidget').offsetTop;
      $scope.shipWidgetTop = $window.document.getElementById('shipWidget').offsetTop;
      $scope.shipWidgetHeight = $window.document.getElementById('shipWidget').offsetHeight;
      $scope.finalizeWidgetHeight = $window.document.getElementById('finalizeWidget').offsetHeight;

      $scope.scrollTop = this.scrollTop;

      if ($scope.scrollTop < $scope.scrollPullHeight) {
        $scope.widget = 'accountWidget';
      }
      else if ($scope.scrollTop >= $scope.dateWidgetTop - $scope.scrollPullHeight && $scope.scrollTop < $scope.shipWidgetTop && $scope.widget === 'accountWidget') {
        $scope.widget = 'dateWidget';
      }
      else if ($scope.scrollTop <= $scope.dateWidgetTop + $scope.scrollPullHeight && $scope.widget !== 'accountWidget') {
        $scope.widget = 'dateWidget';
      }
      else if ($scope.scrollTop >= $scope.shipWidgetTop && $scope.scrollTop < $scope.shipWidgetTop + Math.floor($scope.shipWidgetHeight / 2) && $scope.widget !== 'finalizeWidget') {
        $scope.widget = 'shipWidget';
      }
      else if ($scope.scrollTop < $scope.shipWidgetTop + $scope.scrollPullHeight && $scope.widget === 'finalizeWidget') {
        $scope.widget = 'shipWidget';
      }
      else if (($scope.scrollTop + $scope.wizardAreaHeight) > ($scope.shipWidgetTop + $scope.shipWidgetHeight + $scope.finalizeWidgetHeight + $scope.buttonWidgetHeight - $scope.scrollPullHeight)) {
        $scope.widget = 'finalizeWidget';
      }

      if ($scope.widget !== $scope.activeWidget && $scope.widgetClick === 0) {

        $scope.activeWidget = $scope.widget;
        $timeout(0);

        $window.document.getElementById($scope.widget).scrollIntoView();

      }
      $scope.widgetClick = 0;

    };

    $scope.analyticsSaveLog = function () {

      var reportDepartureTime = new Date().getTime();

      analyticsService.trackWithVar('reportCreationSave', 'reportCreationDuration', Math.floor((reportDepartureTime - $scope.reportArrivalTime) / 1000));

    };

    $scope.analyticsUpdateLog = function () {

      var reportDepartureTime = new Date().getTime();

      analyticsService.trackWithVar('reportCreationUpdate', 'reportCreationDuration', Math.floor((reportDepartureTime - $scope.reportArrivalTime) / 1000));

    };

    $scope.analyticsCancelLog = function () {

      var reportDepartureTime = new Date().getTime();

      analyticsService.trackWithMultipleVars('reportCreationCancel',
        {
          'reportCreationDuration': Math.floor((reportDepartureTime - $scope.reportArrivalTime) / 1000),
          'reportAccount': $scope.reportConfig.accountSelection.length !== 0,
          'reportDate': $scope.dateRangeValid($scope.reportConfig.date),
          'reportShipmentType': ($scope.reportConfig.shipmentType.status.length !== 0 && $scope.reportConfig.shipmentType.modes.length !== 0),
          'reportFinalize': $scope.finalize.reportName.length !== 0
        });

    };

    angular.element('#wizardScrollArea').bind("scroll", $scope.wizardScroll);
    $scope.initRouteChange();
    $scope.createOrdersSummarySettup();

  }

  app.controller('CreateOrdersSummaryController', CreateOrdersSummaryController);
})();

(function () {
    'use strict';

    var app = angular.module('NavisphereOnline');
    locationReportExportService.$inject = ['$filter', '$uibModal', 'ReportingService', 'ReportDataDisplayService', 'ExcelReportExporterService'];
    function locationReportExportService($filter, $uibModal, ReportingService, ReportDataDisplayService, ExcelReportExporterService) {

      var loadingModal;

      function exportXLSX(params) {

        reportSpinner('DOWNLOAD_REPORT');

        return ReportingService.locationReportExport(params).$promise.then(function (response) {

          loadingModal.close();

          return saveAs(response.data, ['LocationReport.xls']);

        });

      }

      function exportCSV(reportConfigId, sortBy, sortDescending, reportTitle, reportHeaders) {

        reportSpinner('DOWNLOAD_REPORT');

        return ReportingService.locationReport({
          reportConfigId: reportConfigId,
          from: 0,
          pageSize: 1000,
          sortBy: sortBy,
          sortDescending: sortDescending
        }).$promise.then(function (response) {

          var data = [];
          var exportData = [];

          _.forEach(response.items, function (value) {

            data.push({
              'order':'"=HYPERLINK(""' + appConfig.ordersUIBaseUrl + '/#/detail/' + value.orderNumber + '"",' + value.orderNumber + ')"',
              'trackingNumber': '"=HYPERLINK(""' + appConfig.trackingDetailsLink + '/#/?trackingNumber=' + value.orderSummaryDetail.trackingReferenceNumber + '"",""' + value.orderSummaryDetail.trackingReferenceNumber + '"")"',
              'account': ReportDataDisplayService.removeComma(value.customer.name),
              'primaryRefNumber': ReportDataDisplayService.removeComma(value.orderSummaryDetail.primaryReferenceNumber),
              'originName': ReportDataDisplayService.removeComma(value.originLocation.name),
              'originCity': ReportDataDisplayService.removeComma(value.originLocation.city),
              'originState': ReportDataDisplayService.removeComma(value.originLocation.state),
              'earliestRequestesPickupDate': ReportDataDisplayService.formatDate(value.originLocation.earliestRequestedDate),
              'latestRequestedPickupDate': ReportDataDisplayService.formatDate(value.originLocation.latestRequestedDate),
              'earliestScheduledPickupDate': ReportDataDisplayService.formatDate(value.originLocation.earliestScheduledDate),
              'latestScheduledPickupDate': ReportDataDisplayService.formatDate(value.originLocation.earliestScheduledDate),
              'actualPickupArrivalDate': ReportDataDisplayService.formatDate(value.originLocation.actualArrivalDate),
              'actualPickupDepartureDate': ReportDataDisplayService.formatDate(value.originLocation.actualDepartureDate),
              'destinationName': ReportDataDisplayService.removeComma(value.destinationLocation.name),
              'destinationCity': ReportDataDisplayService.removeComma(value.destinationLocation.city),
              'destinationState': ReportDataDisplayService.removeComma(value.destinationLocation.state),
              'earliestRequestesDeliveryDate': ReportDataDisplayService.formatDate(value.destinationLocation.earliestRequestedDate),
              'latestRequestedDeliveryDate': ReportDataDisplayService.formatDate(value.destinationLocation.latestRequestedDate),
              'earliestScheduledDeliveryDate': ReportDataDisplayService.formatDate(value.destinationLocation.earliestScheduledDate),
              'latestScheduledDeliveryDate': ReportDataDisplayService.formatDate(value.destinationLocation.earliestScheduledDate),
              'actualDeliveryArrivalDate': ReportDataDisplayService.formatDate(value.destinationLocation.actualArrivalDate),
              'actualDeliveryDepartureDate': ReportDataDisplayService.formatDate(value.destinationLocation.actualDepartureDate),
              'orderStatus': $filter('translate')(ReportDataDisplayService.removeComma(value.orderSummaryDetail.orderStatus)),
              'orderMode': $filter('translate')(ReportDataDisplayService.removeComma(value.orderSummaryDetail.orderMode)),
              'carrierName': ReportDataDisplayService.removeComma(value.carrier.name),
              'proReferenceNumber': ReportDataDisplayService.removeComma(value.orderSummaryDetail.proReferenceNumber)
            });

            exportData = data;

          });

          exportData.unshift(reportHeaders);

          ExcelReportExporterService.exportReportExcel(exportData, reportTitle);

          loadingModal.close();

        });
      }

      function reportSpinner(notice){

        loadingModal = $uibModal.open({
          templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
          size: 'sm',
          controller: 'loadingSpinnerController',
          backdrop: 'static',
          resolve: {
            title: function () {
              return $filter('translate')(notice);
            }
          }
        });
      }

      return {
        exportXLSX: exportXLSX,
        exportCSV: exportCSV,
        reportSpinner: reportSpinner

      };
    }

    app.factory('LocationReportExportService', locationReportExportService);
  }

)();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  SavedLocationController.$inject = ['$scope', '$filter', 'savedReportConfigs','reportConfigsSchedules','preferences'];
  function SavedLocationController($scope, $filter, savedReportConfigs, reportConfigsSchedules, preferences) {

    $scope.reportConfig = savedReportConfigs;
    
    $scope.configSchedules = reportConfigsSchedules;

    $scope.preferences = preferences;

    $scope.reportInfo = {name : 'Location Report', title: $filter('translate')('LOCATION_REPORTS'), 
    message : $filter('translate')("YOU_HAVE_NOT_CREATED_ANY_LOCATION_REPORTS_YET")};

    $scope.createReportPath = 'app.reports.createLocation';

    $scope.runReportPath = 'app.reports.locationReport';

    $scope.savedReportPath = 'app.reports.savedLocation' 

  }

  app.controller('SavedLocationController', SavedLocationController);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  LocationReportController.$inject = ['$scope', '$filter', '$state', '$window', 'ReportingService',
    'ReportPersistanceService', 'ReportDataDisplayService', 'LocationReportExportService', 'WindowLocationHref'];

  function LocationReportController($scope, $filter, $state, $window, ReportingService
    , ReportPersistanceService, ReportDataDisplayService, LocationReportExportService, WindowLocationHref) {

    $scope.reportTitle = $filter('translate')("LOCATION_REPORT");

    $scope.currentPage = 1;
    $scope.sortBy = 'account';
    $scope.sortDescending = 'true';
    $scope.limit = 50;
    $scope.offset = 0;
    $scope.accountViewSize = 3;
    $scope.reportRunning = false;

    $scope.reportHeaders = {
      order: $filter('translate')('ORDER_NUMBER'),
      trackingNumber: $filter('translate')('TRACKING_NUMBER'),
      account: $filter('translate')('ACCOUNT_NAME'),
      primaryRefNumber: $filter('translate')('PRIMARY_REFERENCE_NUMBER'),
      originName: $filter('translate')('ORIGIN_PICKUP_NAME'),
      originCity: $filter('translate')('ORIGIN_PICKUP_CITY'),
      originState: $filter('translate')('ORIGIN_PICKUP_STATE'),
      earliestRequestesPickupDate: $filter('translate')('EARLIEST_REQUESTED_PICKUP_DATE'),
      latestRequestedPickupDate: $filter('translate')('LATEST_REQUESTED_PICKUP_DATE'),
      earliestScheduledPickupDate: $filter('translate')('EARLIEST_SCHEDULED_PICKUP_DATE'),
      latestScheduledPickupDate: $filter('translate')('LATEST_SCHEDULED_PICKUP_DATE'),
      actualPickupArrivalDate: $filter('translate')('ACTUAL_PICKUP_ARRIVAL'),
      actualPickupDepartureDate: $filter('translate')('ACTUAL_PICKUP_DEPARTURE'),
      destinationName: $filter('translate')('DESTINATION_DELIVERY_NAME'),
      destinationCity: $filter('translate')('DESTINATION_DELIVERY_CITY'),
      destinationState: $filter('translate')('DESTINATION_DELIVERY_STATE'),
      earliestRequestesDeliveryDate: $filter('translate')('EARLIEST_REQUESTED_DELIVERY_DATE'),
      latestRequestedDeliveryDate: $filter('translate')('LATEST_REQUESTED_DELIVERY_DATE'),
      earliestScheduledDeliveryDate: $filter('translate')('EARLIEST_SCHEDULED_DELIVERY_DATE'),
      latestScheduledDeliveryDate: $filter('translate')('LATEST_SCHEDULED_DELIVERY_DATE'),
      actualDeliveryArrivalDate: $filter('translate')('ACTUAL_DELIVERY_ARRIVAL'),
      actualDeliveryDepartureDate: $filter('translate')('ACTUAL_DELIVERY_DEPARTURE'),
      orderStatus: $filter('translate')('ORDER_STATUS'),
      orderMode: $filter('translate')('ORDER_MODE'),
      carrierName: $filter('translate')('CARRIER_NAME'),
      proReferenceNumber: $filter('translate')('PRO_REFERENCE_NUMBER')
    };

    $scope.reportDataSetup = function(){

      $scope.reportConfigId = ReportPersistanceService.getConfigVariable('locationConfigID');
      if(!$scope.reportConfigId){$state.go('app.reports.savedLocation')};
  
      $scope.reportConfig = ReportPersistanceService.getConfigVariable('locationConfig');
      $scope.reportConfiguration = JSON.parse($scope.reportConfig.reportConfiguration);

      $scope.statusDisplay = ReportDataDisplayService.translateConfig($scope.reportConfiguration.shipmentType.status.split(','));
      $scope.modesDisplay = ReportDataDisplayService.translateConfig($scope.reportConfiguration.shipmentType.modes.split(','));
      $scope.dateDisplay = ReportDataDisplayService.createDateRange($scope.reportConfiguration.date);

      $scope.grabLocationReport();

    }

    $scope.goToOrderDetails = function (orderNum) {
			var redirectUrl =  appConfig.ordersUIBaseUrl + '/#/detail/' + orderNum;
			WindowLocationHref.setWindowLocationHref(redirectUrl);			
    };

    $scope.goToTrackingDetails = function (trackingNumber) {

      $window.open(appConfig.trackingDetailsLink + '/#/?trackingNumber=' + trackingNumber);

    };

    $scope.showAccounts = function () {
      $scope.accountList = !$scope.accountList;
      $scope.accountViewSize = $scope.accountList ? 500 : 3;
    };

    $scope.limitChanged = function (limit) {

      $scope.limit = limit;
      $scope.currentPage = Math.floor($scope.offset / $scope.limit) + 1;
      $scope.offset = ($scope.currentPage - 1) * $scope.limit;
      $scope.grabLocationReport();

    };

    $scope.grabLocationReport = function () {

      $scope.reportRunning = true;
      $scope.reportReturn = [];

      ReportingService.locationReport({
        reportConfigId: $scope.reportConfigId,
        from: (($scope.currentPage || 0) - 1) * $scope.limit,
        pageSize: $scope.limit,
        sortBy: $scope.sortBy,
        sortDescending: $scope.sortDescending
      })
        .$promise.then(function (locationReport) {

        $scope.reportReturn = locationReport.items;
        $scope.reportRunning = false;

      })
    };

    $scope.exportXLSX = function () {

      var params = {
        reportConfigId: $scope.reportConfigId,
        from: 0,
        pageSize: 5000,
        sortBy: $scope.sortBy,
        sortDescending: $scope.sortDescending
      };

      LocationReportExportService.exportXLSX(params);

    };

    $scope.exportCSV = function () {

      LocationReportExportService.exportCSV($scope.reportConfigId, $scope.sortBy, $scope.sortDescending, $scope.reportTitle, $scope.reportHeaders);

    };

    $scope.reportDataSetup();

  }

  app.controller('LocationReportController', LocationReportController);

})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  CreateLocationController.$inject = ['$scope', '$filter', '$state', '$uibModalStack', '$stateParams', '$window', '$timeout',
    'WizardDataService', 'ModalService', 'customerModes', 'locationCustomers', 'analyticsService'];
  function CreateLocationController($scope, $filter, $state, $uibModalStack, $stateParams, $window, $timeout,
    WizardDataService, ModalService, customerModes, locationCustomers, analyticsService) {

    var onRouteChangeOff;
    $uibModalStack.dismissAll();
    $scope.widget = 'accountWidget';

    $scope.reportInfo = {
      'name': 'Location Report',
      'category': 'Order Activity',
      'title': $filter('translate')("CREATE_LOCATION_REPORT")
    };
    $scope.reportConfig = {
      'accountSelection': '',
      'date': { 'type': '', 'range': '', 'startDate': '', 'endDate': '', 'startDatePass': 0, 'endDatePass': 0 },
      'shipmentType': { 'status': '', 'modes': '' },
      'accountSelectionDisplay': [],
      'pick': { 'groupName': '', 'codes': '', 'details': [] },
      'drop': { 'groupName': '', 'codes': '', 'details': [] }
    };

    $scope.statusDisplay = '';
    $scope.modesDisplay = '';

    $scope.finalize = { 'reportName': '', 'reportDescription': '' };

    $scope.activeWidget = 'accountWidget';
    $scope.customerList = locationCustomers.customers;

    $scope.customerModes = customerModes;

    $scope.buttonWidgetHeight = $window.document.getElementById('buttonWidget').offsetHeight;
    $scope.scrollPullHeight = 20;

    $scope.showRefreshPrompt = function () {

      if (!$scope.createLocationReportForm.$dirty && $scope.reportConfig.accountSelection.length === 0
        && !$scope.reportConfig.shipmentType.status && !$scope.reportConfig.shipmentType.modes
        && !$scope.reportConfig.pick.groupName && !$scope.reportConfig.drop.groupName) {
        return;
      }

      $scope.analyticsCancelLog();

      return true;

    };

    $window.onbeforeunload = $scope.showRefreshPrompt;

    $scope.clickWidget = function (widget) {

      $scope.widgetClick = true;
      $scope.activeWidget = widget;
      $scope.widget = widget;
      $window.document.getElementById(widget).scrollIntoView();

    };

    var modalOptions = {
      closeButtonText: 'CANCEL',
      actionButtonText: 'OK',
      headerText: 'ARE_YOU_SURE_YOU_WANT_TO_EXIT_THE_REPORT_CREATION',
      bodyText: 'ALL_INFORMATION_FOR_THIS_REPORT_WILL_BE_LOST'
    };

    $scope.routeChange = function (event, toState) {

      if ((!$scope.createLocationReportForm.$dirty && $scope.reportConfig.accountSelection.length === 0
        && !$scope.reportConfig.shipmentType.status && !$scope.reportConfig.shipmentType.modes) || toState.name === 'login') {
        return;
      }

      ModalService.showModal({}, modalOptions).then(function (result) {
        if (result === 'ok') {

          onRouteChangeOff();
          $uibModalStack.dismissAll(result);
          $scope.analyticsCancelLog();
          $state.go(toState);
        }
      });

      event.preventDefault();
    };

    $scope.initRouteChange = function () {

      onRouteChangeOff = $scope.$on('$stateChangeStart', $scope.routeChange);

    };

    $scope.cancelCreation = function () {

      $state.go('app.reports.savedLocation');

    };

    $scope.saveReport = function () {

      $scope.clearDates();

      if (!$scope.reportConfigId) {
        WizardDataService.createSavedReportConfig($scope.reportInfo, $scope.finalize, $scope.reportConfig).then(function () {

          onRouteChangeOff();
          $scope.analyticsSaveLog();
          $state.go('app.reports.savedLocation');

        });
      }
      else {

        WizardDataService.updateSavedReportConfig($scope.reportConfigId, $scope.finalize, $scope.reportConfig).then(function () {

          onRouteChangeOff();
          $scope.analyticsUpdateLog();
          $state.go('app.reports.savedLocation');

        });
      }
    };

    $scope.clearDates = function () {

      if ($scope.reportConfig.date.range !== 'CUSTOM') {

        $scope.reportConfig.date.startDate = '';
        $scope.reportConfig.date.endDate = '';

      }

    };

    $scope.createLocationSettup = function () {

      if ($stateParams.reportConfigPass) {

        var reportConfigSet = JSON.parse($stateParams.reportConfigPass.reportConfiguration);
        $scope.finalize.reportName = $stateParams.reportConfigPass.reportNameByUser;
        $scope.finalize.reportDescription = $stateParams.reportConfigPass.reportDescriptionByUser;
        $scope.reportConfigId = $stateParams.reportConfigPass.savedReportConfigId;
        $scope.reportConfig = reportConfigSet;
        $scope.reportConfig.date.startDate = $scope.reportConfig.date.startDate ? new Date($scope.reportConfig.date.startDate) : null;
        $scope.reportConfig.date.endDate = $scope.reportConfig.date.endDate ? new Date($scope.reportConfig.date.endDate) : null;

      }

    };

    $scope.dateRangeValid = function (date) {

      if (date.type !== '' && date.range !== '') {
        if (date.range !== 'CUSTOM') {
          return true;
        }
        else if (date.startDate !== '' && date.endDate !== '') {
          return true;
        }
      }
      return false;
    };

    $scope.wizardScroll = function () {

      $scope.wizardAreaHeight = $window.document.getElementById('wizardScrollArea').offsetHeight;
      $scope.pickupWidgetTop = $window.document.getElementById('pickupWidget').offsetTop;
      $scope.deliveryWidgetTop = $window.document.getElementById('deliveryWidget').offsetTop;
      $scope.dateWidgetTop = $window.document.getElementById('dateWidget').offsetTop;
      $scope.shipWidgetTop = $window.document.getElementById('shipWidget').offsetTop;
      $scope.shipWidgetHeight = $window.document.getElementById('shipWidget').offsetHeight;
      $scope.finalizeWidgetHeight = $window.document.getElementById('finalizeWidget').offsetHeight;

      $scope.scrollTop = this.scrollTop;

      if ($scope.scrollTop < $scope.scrollPullHeight) {
        $scope.widget = 'accountWidget';
      }
      else if ($scope.scrollTop >= $scope.pickupWidgetTop - $scope.scrollPullHeight && $scope.scrollTop < $scope.deliveryWidgetTop && $scope.widget === 'accountWidget') {
        $scope.widget = 'pickupWidget';
      }
      else if ($scope.scrollTop <= $scope.pickupWidgetTop + $scope.scrollPullHeight && $scope.widget === 'deliveryWidget') {
        $scope.widget = 'pickupWidget';
      }
      else if ($scope.scrollTop >= $scope.deliveryWidgetTop - $scope.scrollPullHeight && $scope.scrollTop < $scope.dateWidgetTop && $scope.widget === 'pickupWidget') {
        $scope.widget = 'deliveryWidget';
      }
      else if ($scope.scrollTop <= $scope.deliveryWidgetTop + $scope.scrollPullHeight && $scope.widget === 'dateWidget') {
        $scope.widget = 'deliveryWidget';
      }
      else if ($scope.scrollTop >= $scope.dateWidgetTop - $scope.scrollPullHeight && $scope.scrollTop < $scope.shipWidgetTop && $scope.widget === 'deliveryWidget') {
        $scope.widget = 'dateWidget';
      }
      else if ($scope.scrollTop <= $scope.dateWidgetTop + $scope.scrollPullHeight && $scope.widget === 'shipWidget') {
        $scope.widget = 'dateWidget';
      }
      else if ($scope.scrollTop >= $scope.shipWidgetTop && $scope.scrollTop < $scope.shipWidgetTop + Math.floor($scope.shipWidgetHeight / 2) && $scope.widget === 'dateWidget') {
        $scope.widget = 'shipWidget';
      }
      else if ($scope.scrollTop < $scope.shipWidgetTop + $scope.scrollPullHeight && $scope.widget === 'finalizeWidget') {
        $scope.widget = 'shipWidget';
      }
      else if ($scope.scrollTop + $scope.wizardAreaHeight > $scope.shipWidgetTop + $scope.shipWidgetHeight + $scope.finalizeWidgetHeight + $scope.buttonWidgetHeight - $scope.scrollPullHeight) {
        $scope.widget = 'finalizeWidget';
      }

      if ($scope.widget !== $scope.activeWidget && !$scope.widgetClick) {

        $scope.activeWidget = $scope.widget;
        $timeout(0);

        $window.document.getElementById($scope.widget).scrollIntoView();

      }
      $scope.widgetClick = false;

    };

    $scope.analyticsSaveLog = function () {

      var reportDepartureTime = new Date().getTime();

      analyticsService.trackWithVar('reportCreationSave', 'reportCreationDuration', Math.floor((reportDepartureTime - $scope.reportArrivalTime) / 1000));

    };

    $scope.analyticsUpdateLog = function () {

      var reportDepartureTime = new Date().getTime();

      analyticsService.trackWithVar('reportCreationUpdate', 'reportCreationDuration', Math.floor((reportDepartureTime - $scope.reportArrivalTime) / 1000));

    };

    $scope.analyticsCancelLog = function () {

      var reportDepartureTime = new Date().getTime();

      analyticsService.trackWithMultipleVars('reportCreationCancel',
        {
          'reportCreationDuration': Math.floor((reportDepartureTime - $scope.reportArrivalTime) / 1000),
          'reportAccount': $scope.reportConfig.accountSelection.length !== 0,
          'reportPickup': $scope.reportConfig.pick.groupName !== null,
          'reportDelivery': $scope.reportConfig.drop.groupName !== null,
          'reportDate': $scope.dateRangeValid($scope.reportConfig.date),
          'reportShipmentType': ($scope.reportConfig.shipmentType.status && $scope.reportConfig.shipmentType.modes),
          'reportFinalize': $scope.finalize.reportName.length !== 0
        });

    };

    angular.element('#wizardScrollArea').bind("scroll", $scope.wizardScroll);
    $scope.initRouteChange();
    $scope.createLocationSettup();

  }

  app.controller('CreateLocationController', CreateLocationController);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  InTransitOrdersController.$inject = ['$scope', '$state', '$window', 'ReportingService', 'ServiceOffering',
    '$filter', 'StatusMappingService', 'ExcelReportExporterService', 'ReportDataDisplayService', 'WindowLocationHref'];
  function InTransitOrdersController($scope, $state, $window, ReportingService, ServiceOffering, $filter,
                                     StatusMappingService, ExcelReportExporterService, ReportDataDisplayService, WindowLocationHref) {

    $scope.inTransitData = [];
    $scope.currentPage = 1;
    $scope.totalRecords = 0;
    $scope.sortBy = 'deliveryDate';
    $scope.sortDescending = "true";
    $scope.limit = 50;
    $scope.offset = 0;
    $scope.exportReady = false;
    $scope.reportHeaders = {
      order: 'Orders',
      customer: 'Customer',
      primaryRefNumber:'Primary Reference Number',
      orderCreateDate:'Order Create Date',
      shippingMethod:'Shipping Method',
      loadNumber:'Load Number',
      trackingNumber:'Tracking Number',
      orderActivityDate:'Order Activity Date',
      originName:'Order Pickup Location Name',
      originLocation:'Order Pickup Location',
      earliestPickDate:'Earliest Pickup Date',
      latestPickupDate:'Latest Pickup Date',
      actualPickupDate:'Actual Pickup Date',
      destinationName:'Order Delivery Location Name',
      destinationLocation:'Order Delivery Location',
      earliestDeliveryDate:'Earliest Delivery Date',
      latestDeliveryDate:'Latest Delivery Date',
      status:'Status'
    };
    $scope.reportRunning = false;
    $scope.reportTitle = $filter('translate')("IN_TRANSIT_ORDERS");

    $scope.goToOrderDetails = function (orderNum) {
			var redirectUrl =  appConfig.ordersUIBaseUrl + '/#/detail/' + orderNum;
			WindowLocationHref.setWindowLocationHref(redirectUrl);
		};

    $scope.goToTrackingDetails = function (trackingNumber) {

      $window.open(appConfig.trackingDetailsLink + '/#/?trackingNumber=' + trackingNumber);

    };

    $scope.grabInTransit = function(){

      $scope.reportRunning = true;
      $scope.inTransitData = [];

      ReportingService.inTransitV2({
          from: (($scope.currentPage || 0) - 1) * $scope.limit,
          pageSize:$scope.limit,
          sortBy: $scope.sortBy,
          sortDescending: $scope.sortDescending
        })
        .$promise.then(function(response)
      {

        $scope.totalRecords = response.total;
        $scope.reportRunning = false;

        var data = [];

        _.forEach(response.items, function(value) {

          data.push({

            'order':value.orderNumber,
            'customer':ReportDataDisplayService.dataCheck(value.customer,-1,'name'),
            'primaryRefNumber':ReportDataDisplayService.getPrimaryRefNumber(value),
            'orderCreateDate':ReportDataDisplayService.formatDate(value.createdDateTime),
            'shippingMethod': ServiceOffering.get(ReportDataDisplayService.dataCheck(value.services,0,'serviceOfferingNumber')),
            'trackingNumber': ReportDataDisplayService.getTrackingNumber(value),
            'originName': ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'name'),
            'originLocation': ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'city') + ', ' + ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'state'),
            'actualPickupDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'actualArrivalTime')),
            'destinationName': ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'name'),
            'destinationLocation': ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'city') + ', ' + ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'state'),
            'orderActivityDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].loads,0,'activityDate')),
            'earliestPickDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'plannedEarliestTime')),
            'latestPickupDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'plannedLatestTime')),
            'earliestDeliveryDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'plannedEarliestTime')),
            'latestDeliveryDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'plannedLatestTime')),
            'status': $filter('translate')(StatusMappingService.getStatusResourceKey(ReportDataDisplayService.dataCheck(value.services,0,'statusRDN')))

          });
        });

        $scope.inTransitData = data;

      }, function() {

      });
    };

    $scope.grabInTransitDataExport = function(){

      ReportingService.inTransitV2({
        from:null,
        pageSize:null,
        sortBy: $scope.sortBy,
        sortDescending: $scope.sortDescending
      }).$promise.then(function(response)
      {
        var data = [];

        _.forEach(response.items, function(value) {

          data.push({
            'order':'"=HYPERLINK(""' + appConfig.ordersUIBaseUrl + '/#/detail/' + value.orderNumber + '"",' + value.orderNumber + ')"',
            'customer':ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.customer,-1,'name')),
            'primaryRefNumber':ReportDataDisplayService.removeComma(ReportDataDisplayService.getPrimaryRefNumber(value)),
            'orderCreateDate':ReportDataDisplayService.formatDate(value.createdDateTime),
            'shippingMethod': ServiceOffering.get(ReportDataDisplayService.dataCheck(value.services,0,'serviceOfferingNumber')).serviceOfferingName,
            'loadNumber': ReportDataDisplayService.dataCheck(value.services[0].loads,0,'loadNumber'),
            'trackingNumber': '"=HYPERLINK(""' + appConfig.trackingDetailsLink + '/#/?trackingNumber=' + ReportDataDisplayService.getTrackingNumber(value) + '"",""' + ReportDataDisplayService.getTrackingNumber(value) + '"")"',
            'orderActivityDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].loads,0,'activityDate')),
            'originName': ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'name')),
            'originLocation': ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'city') + ' ' + ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'state'))),
            'earliestPickDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'plannedEarliestTime')),
            'latestPickupDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'plannedLatestTime')),
            'actualPickupDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].pickupFrom,-1,'actualArrivalTime')),
            'destinationName': ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'name')),
            'destinationLocation': ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'city') + ' ' + ReportDataDisplayService.removeComma(ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'state'))),
            'earliestDeliveryDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'plannedEarliestTime')),
            'latestDeliveryDate': ReportDataDisplayService.formatDate(ReportDataDisplayService.dataCheck(value.services[0].deliverTo,-1,'plannedLatestTime')),
            'status': $filter('translate')(StatusMappingService.getStatusResourceKey(ReportDataDisplayService.dataCheck(value.services,0,'statusRDN')))
          });

          $scope.exportData = data;
          $scope.exportReady = true;
        });

        $scope.exportData.unshift($scope.reportHeaders);

      }, function() {

      });
    };

    $scope.limitChanged = function (limit) {

      $scope.limit = limit;
      $scope.currentPage = Math.floor($scope.offset / $scope.limit) + 1;
      $scope.offset = ($scope.currentPage - 1) * $scope.limit;
      $scope.grabInTransit();

    };

    $scope.exportInTransit = function() {

      ExcelReportExporterService.exportReportExcel($scope.exportData, $scope.reportTitle);

     };

    $scope.grabInTransit();
    $scope.grabInTransitDataExport();
  }
  app.controller('InTransitOrdersController', InTransitOrdersController);
})();

(function () {
    'use strict';

    subscriptionTokenService.$inject = ['$window'];
  
    function subscriptionTokenService($window) {
  
        function decodeToken(token) {

            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse($window.atob(base64));

          };
      
       return {
        decodeToken: decodeToken
      };
  
    }

    angular.module('NavisphereOnline').factory('SubscriptionTokenService', subscriptionTokenService);
    
  })();
(function () {
  'use strict';

  var app = angular.module('NavisphereOnline');

  reportPersistanceService.$inject = ['$q'];

  function reportPersistanceService($q) {

    var configVariables = {

      orderSummaryConfigID : null,
      orderSummaryConfig : null,
      locationConfigID : null,
      locationConfig : null

    };

    function addReportConfig(reportConfigID, savedReportConfig){

      var deferred = $q.defer();

      if(savedReportConfig.reportName === 'Orders Summary Report')
      {

        configVariables.orderSummaryConfigID = reportConfigID;
        configVariables.orderSummaryConfig = savedReportConfig;

      }
      else
      {

        configVariables.locationConfigID = reportConfigID;
        configVariables.locationConfig = savedReportConfig;

      }

      deferred.resolve();

      return deferred.promise;
    }

    function getConfigVariable(configVariable){

      return configVariables[configVariable];

    }

    function clearReportConfig(){

      configVariables = {};

    }

    return {
      addReportConfig: addReportConfig,
      clearReportConfig: clearReportConfig,
      getConfigVariable : getConfigVariable
    };

  }

  app.factory('ReportPersistanceService', reportPersistanceService);
})();

(function () {
  'use strict';

  var app = angular.module('NavisphereOnline');

  reportDataDisplayService.$inject = ['DateTimeService', 'RefDataMappingService', '$filter', '$locale'];

  function reportDataDisplayService(DateTimeService, RefDataMappingService, $filter, $locale) {

    function getPrimaryRefNumber(order) {

      if (!_.isNil(order.referenceNumbers)) {
        for (var i = 0; i < order.referenceNumbers.length; i++) {

          if (order.referenceNumbers[i].entity === "BillTo" &&
            order.referenceNumbers[i].entityId === 2 &&
            order.referenceNumbers[i].primary) {
            return order.referenceNumbers[i].value;
          }
        }
      }
      return null;
    }

    function getTrackingNumber(order) {

      if (!_.isNil(order.referenceNumbers)) {

        for (var i = 0; i < order.referenceNumbers.length; i++) {

          if (order.referenceNumbers[i].referenceDataNumber === RefDataMappingService.getCategoryId('TRACKING_NUMBER') &&
            order.referenceNumbers[i].entityId === 1) {
            return order.referenceNumbers[i].value;
          }
        }
      }
      return null;
    }

    function removeComma(value) {

      if (value) {
        var valuef = value.replace(/,/g, "");
        return valuef
      }
      return '';
    }

    function formatDate(date) {

      var datef = DateTimeService.getDisplayDateAndTime(date);

      if (datef == "Invalid Date") {
        datef = '';
      }
      //remove 12:00 AM from any dates.
      datef = datef.replace("12:00 AM", "");
      return datef;
    }

    function createDateRange(date) {

      var dateFormat = $locale.DATETIME_FORMATS['shortDate'] === 'dd/MM/yyyy' ? 'DD MMM' : 'MMM DD';

      var dateDisplay;

      if (date.range === 'LAST_MONTH') {
        dateDisplay = moment().subtract(1, 'month').startOf('month').format(dateFormat) + ' - ' + moment().subtract(1, 'month').endOf('month').format(dateFormat);
      }
      else if (date.range === 'THIS_MONTH') {
        dateDisplay = moment().startOf('month').format(dateFormat) + ' - ' + moment().endOf('month').format(dateFormat);
      }
      else if (date.range === 'LAST_WEEK') {
        dateDisplay = moment().subtract(1, 'week').startOf('week').format(dateFormat) + ' - ' + moment().subtract(1, 'week').endOf('week').format(dateFormat);
      }
      else if (date.range === 'THIS_WEEK') {
        dateDisplay = moment().startOf('week').format(dateFormat) + ' - ' + moment().endOf('week').format(dateFormat);
      }
      else {

        var startDate = new Date(date.startDate);
        var endDate = new Date(date.endDate);

        dateDisplay = moment(startDate).format(dateFormat) + ' - ' + moment(endDate).format(dateFormat)
      }

      return dateDisplay;

    }

    function dataCheck(data, level, checktype) {

      var datachecked;

      if (level >= 0 && !_.isNil(data) && data.length !== 0 && data[level][checktype] !== '') {
        datachecked = data[level][checktype];
      }
      else if (!_.isNil(data) && !_.isNil(data[checktype]) && data[checktype] !== '' && level === -1) {
        datachecked = data[checktype];
      }
      else {
        datachecked = null;
      }

      return datachecked;

    }

    function translateConfig(config) {

      var display = [];

      _.forEach(config, function (item) {

        display.push($filter('translate')(item));

      });

      return display.join(', ');

    }

    return {
      getPrimaryRefNumber: getPrimaryRefNumber,
      getTrackingNumber: getTrackingNumber,
      removeComma: removeComma,
      formatDate: formatDate,
      createDateRange: createDateRange,
      dataCheck: dataCheck,
      translateConfig: translateConfig
    };

  }

  app.factory('ReportDataDisplayService', reportDataDisplayService);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('downloadButton', function () {
    return {
      templateUrl: 'app/reporting/common/views/downloadButton.tpl.html',
      restrict: 'E',
      scope: {
        exportXlsx: '&exportXlsx',
        exportCsv: '&exportCsv'
      },
      link: function (scope) {

        scope.downloadType = 'xlsx';

        scope.downloadReport = function(type) {

          scope.downloadDropDown = scope.downloadDropDown ? !scope.downloadDropDown : scope.downloadDropDown;

          type === 'xlsx' ? scope.exportXlsx()('Directive Args') : scope.exportCsv()('Directive Args');

          scope.downloadType = type;

        };
      }
    };
  });
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    //use min and max attributes to make this directive limit to said min and/or max values
    app.directive('wholeNumber', ['CaretPositionService', '$document',
      function (CaretPositionService, $document) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, ngModelController) {

                ngModelController.$parsers.push(parser);

                function parser(value) {
                    if (!value) {
                        return null;
                    }
                    var cleanVal = '';
                    var hasFocus = (element[0] == $document[0].activeElement);
                    var min, allowsNegatives, caretPosition;

                    if (hasFocus) {
                        caretPosition = CaretPositionService.getCaretPosition(element[0]);
                    }

                    var nonCleanVals = 0;
                    if (attrs.min) {
                        min = parseInt(attrs.min);
                    }
                    allowsNegatives = !attrs.min || min < 0;

                    var v = value.toString();
                    for (var i = 0; i < v.length; i++) {
                        if ((['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(v[i]) >= 0) || (i == 0 && v[0] == '-' && allowsNegatives)) {
                            cleanVal += v[i];
                        } else {
                            nonCleanVals++;
                        }
                    }

                    var cleanInt = parseInt(cleanVal);
                    var setCaretToEnd = undefined;
                    if (attrs.max) {
                        var max = parseInt(attrs.max);
                        if (cleanInt > max) {
                            cleanVal = max;
                            setCaretToEnd = attrs.max.length;
                        }
                    }
                    if (attrs.min) {
                        if (cleanInt < min) {
                            cleanVal = min;
                            setCaretToEnd = attrs.min.length;
                        }
                    }
                    element.val(cleanVal);
                    ngModelController.$setViewValue(cleanVal);

                    if (hasFocus) {
                        CaretPositionService.setCaretPosition(element[0], setCaretToEnd ? setCaretToEnd : caretPosition - nonCleanVals);
                    }
                    return cleanVal;
                }

                ngModelController.$validators.wholeNumberValidator = function (modelValue, viewValue) {
                    if (ngModelController.$isEmpty(viewValue)) {
                        return true;
                    }
                    var validInt = parseInt(modelValue);
                    if (isNaN(validInt) || (attrs.max && validInt > parseInt(attrs.max)) || (attrs.min && validInt < parseInt(attrs.min))) {
                        return false;
                    }
                    return true;
                };
            }
        }
    }]);

})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    app.directive('navProgressBar', [function () {
        return {
            templateUrl: 'app/common/directives/progressBar/progressBar.tpl.html',
            restrict: 'E',
            link: function () {
            },
            scope: {
                steps: "=",
                onStepClick: "&"
            }
        };
    }]);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('stickySubHeader', ['$window', '$timeout', function ($window, $timeout) {

    function bindScrollEvent(element) {
      angular.element($window).bind("scroll", function () {
        stickProgressHeader(element);
      });
    }
    function stickProgressHeader(element) {
      var headerBottom = angular.element('[header-scroll]').height();
      element.children().first().css('top', headerBottom);
    }
    return {
      restrict: 'E',
      scope: {},
      link: function (scope, element) {
        bindScrollEvent(element);
        $timeout(function () {
          stickProgressHeader(element);
        }, 0);
      }
    }
  }]);
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    app.directive('showAddress', ['AddressService', function (AddressService) {
        return {
            templateUrl: 'app/common/directives/showAddress/showAddress.tpl.html',
            restrict: 'E',
            scope: {
                party: "="
            },
            link: function(scope) {
                scope.getAddressLine1 = AddressService.GetAddressLine1;
                scope.getAddressLine2 = AddressService.GetAddressLine2;
                scope.getAddressLine3 = AddressService.GetAddressLine3;
                scope.getAddressLine4 = AddressService.GetAddressLine4;
                scope.getAddressLine5 = AddressService.GetAddressLine5;
            }
        }
    }]);
})();

(function() {
  angular.module('NavisphereOnline').directive('datePicker', ['$locale', 'DateTimeService', function($locale, DateTimeService) {
      return {
        templateUrl: 'app/common/directives/datePicker/datePicker.tpl.html',
        transclude: true,
        scope: {
          startDate: "=start",
          endDate: "=end"
        },
        link: function($scope, init, attrs) {
          $scope.calendarOptions = {
            format: $locale.DATETIME_FORMATS['shortDate'],
            startDateOptions: {
              showWeeks: false,
              minDate: "01/01/17",
              maxDate: DateTimeService.getDateTwoYearsFromNow()
            },
            endDateOptions: {
              showWeeks: false,
              minDate: "01/01/17",
              maxDate: DateTimeService.getDateTwoYearsFromNow()
            }
          };
          $scope.isOpen = {
            startDate: false,
            endDate: false
          };

          $scope.openDate = function (dateType) {
            $scope.isOpen[dateType] = true;
          };

          $scope.startUpdated = function() {
            $scope.calendarOptions.endDateOptions.minDate = DateTimeService.getLatestDateMinDate($scope.startDate)
          }
        }
      };
    }]);
})();

(function() {
  "use strict";

  datePickerController.$inject = ["$locale", "$scope", "DateTimeService"];
  function datePickerController($locale, $scope, DateTimeService) {
    $scope.calendarOptions = {};
    $scope.calendarOptions.format = $locale.DATETIME_FORMATS['shortDate'];
    $scope.calendarOptions.dateOptions = {
      showWeeks: false,
      minDate: DateTimeService.getToday(),
      maxDate: DateTimeService.getDateTwoYearsFromNow()
    };

    $scope.openDate = function () {
      $scope.calendarOptions.isOpened = true;
    };
  }

  angular.module("NavisphereOnline").controller("datePickerController", datePickerController);
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    //use decimal-places="#" to set # decimal places allowed, defaults to 2
    app.directive('localeDecimalValidator', ['$locale', 'CaretPositionService', '$document',
      function ($locale, CaretPositionService,$document) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                decimalPlaces: '&',
                integerPlaces: '&'
            },
            link: function (scope, element, attrs, ngModelController) {
                var decimalPlaces = 2;
                var integerPlaces = 15;
                if (scope.decimalPlaces()) {
                    var decPlaces = parseInt(scope.decimalPlaces());
                    if (!isNaN(decPlaces)) {
                        decimalPlaces = decPlaces;
                    }
                }
                if (scope.integerPlaces()) {
                    var intPlaces = parseInt(scope.integerPlaces());
                    if (!isNaN(intPlaces)) {
                        integerPlaces = intPlaces;
                    }
                }
                ngModelController.$parsers.push(parser);
                ngModelController.$formatters.push(formatter);

                function parser(value) {
                    var cleanVal = '';
                    var hasFocus = (element[0] == $document[0].activeElement);

                    var caretPosition;
                    if (hasFocus) {
                        caretPosition = CaretPositionService.getCaretPosition(element[0]);
                    }

                    var nonCleanVals = 0;
                    var separatorUsed = false;
                    var decimalPlacesUsed = 0;
                    var integerPlacesUsed = 0;
                    var addCarrotPositions = 0;
                    for (var i = 0; i < value.length; i++) {

                        if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', $locale.NUMBER_FORMATS.DECIMAL_SEP].indexOf(value[i]) >= 0) {
                            if (separatorUsed && decimalPlacesUsed >= decimalPlaces) {
                                break;
                            }
                            if ($locale.NUMBER_FORMATS.DECIMAL_SEP === value[i]) {
                                if (separatorUsed && decimalPlacesUsed >= decimalPlaces) {
                                    break;
                                }
                                if (!separatorUsed) {
                                    separatorUsed = true;
                                    cleanVal += value[i];
                                }
                            } else{
                                if (separatorUsed) {
                                    decimalPlacesUsed++;
                                    cleanVal += value[i];
                                } else if (integerPlacesUsed >= integerPlaces) {
                                    cleanVal += $locale.NUMBER_FORMATS.DECIMAL_SEP;
                                    cleanVal += value[i];
                                    decimalPlacesUsed++;
                                    separatorUsed = true;
                                    if((caretPosition - 1) === integerPlaces){
                                      addCarrotPositions++;
                                    }
                                } else {
                                    integerPlacesUsed++;
                                    cleanVal += value[i];
                                }
                            }
                        } else {
                            nonCleanVals++;
                        }
                    }

                    ngModelController.$setViewValue(cleanVal);
                    element.val(cleanVal);

                    var invariantValue = cleanVal.split($locale.NUMBER_FORMATS.DECIMAL_SEP).join('.');
                    if (hasFocus) {
                        CaretPositionService.setCaretPosition(element[0], caretPosition - nonCleanVals + addCarrotPositions);
                    }
                    return invariantValue;
                }
                function formatter(value) {
                    if (value === 0)
                        return value;
                    if (value) {
                        var stringVal = value.toString();
                        var invariantDecimalSeparator = '.';
                        var localeVal = '';
                        var separatorUsed = false;
                        var decimalPlacesUsed = 0;
                        for (var i = 0; i < stringVal.length; i++) {
                            if (separatorUsed && decimalPlacesUsed >= decimalPlaces) {
                                break;
                            }
                            if (stringVal[i] === invariantDecimalSeparator) {
                                if (separatorUsed) {
                                    break;
                                }
                                localeVal += $locale.NUMBER_FORMATS.DECIMAL_SEP;
                                separatorUsed = true;
                            } else {
                                if (separatorUsed) {
                                    decimalPlacesUsed++;
                                }
                                localeVal += stringVal[i];
                            }
                        }

                        return localeVal;
                    }
                }

                ngModelController.$validators.localeDecimalValidator = function (modelValue, viewValue) {
                    if (ngModelController.$isEmpty(viewValue)) {
                        return true;
                    }
                    if (viewValue.split($locale.NUMBER_FORMATS.DECIMAL_SEP).length > 2) {
                        return false;
                    }
                    var validFloat = parseFloat(modelValue);
                    if (isNaN(validFloat)) {
                        return false;
                    }
                    if (attrs.min) {
                        if (validFloat < parseFloat(attrs.min)) {
                            ngModelController.$setValidity('min', false);
                        } else {
                            ngModelController.$setValidity('min', true);
                        }
                    }
                    if (attrs.max) {
                        return validFloat <= parseFloat(attrs.max);
                    }
                    return true;

                };
            }
        }
    }]);

})();

angular.module('NavisphereOnline').directive('formatDate', ['$filter', function ($filter) {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, element, attrs, ngModelController){
            element.bind('blur', function () {
                var val = ngModelController.$modelValue;
                if (val) {
                    ngModelController.$setViewValue($filter('date')(val, 'shortDate'), 'blur');
                    ngModelController.$render();
                }
            });
        }
    }
}]);

(function () {
    var compareTo = function () {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareTo"
            },
            link: function (scope, element, attributes, ngModel) {

                ngModel.$validators.compareTo = function (modelValue) {
                    return modelValue === scope.otherModelValue.$viewValue;
                };

                scope.$watch("otherModelValue.$viewValue", function () {
                    ngModel.$validate();
                });
            }
        };
    };

    angular.module('NavisphereOnline').directive("compareTo", compareTo);
}());
(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    app.directive('enforceMaxlength', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                var maxlength = Number(attrs.enforceMaxlength);
                function enforceMaxLength(text) {
                    if (text) {
                        if (text.length > maxlength) {
                            var transformedInput = text.substring(0, maxlength);
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                            return transformedInput;
                        }
                    }return text;
                }

                ngModelCtrl.$parsers.push(enforceMaxLength);
            }
        };
    });
}());
(function() {
  'use strict';

  angular
    .module('NavisphereOnline')
    .directive("analytics", ['analyticsService', function(analyticsService) {

      return {
        restrict: 'A',
        scope: {
          trackingTagType: '@',
          trackingTagName: '@',
          trackingTagValue: '@',
          trackingTagVariables: '='

        },
        link: function (scope, element) {
          element.on('click', function () {
            if (scope.trackingTagType === 'track') {
              analyticsService.track(scope.trackingTagName);
            }
            if (scope.trackingTagType === 'trackWithVar') {
               analyticsService.trackWithVar(scope.trackingTagName, scope.trackingTagValue, scope.trackingTagVariables);
            }
            if (scope.trackingTagType === 'trackWithMultipleVars') {
               analyticsService.trackWithMultipleVars(scope.trackingTagName, scope.trackingTagVariables);
            }
          });
        }
      }
    }]);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.constant('panelConfig', {
    closeOthers: true
  });

  app.directive('panel', function () {
    return {
      restrict: 'EA',
      controller: 'PanelController',
      transclude: true,
      replace: false,
      template: '<div class="panel-group" ng-transclude></div>'
    };
  });

  app.directive('panelGroup', function () {
    return {
      require: '^panel', // We need this directive to be inside an accordion
      restrict: 'EA',
      transclude: true, // It transcludes the contents of the directive into the template
      replace: true, // The element containing the directive will be replaced with the template
      templateUrl: 'app/common/directives/accordion/panelgroup-template.html',
      scope: {
        heading: '@', // Interpolate the heading attribute onto this scope
        title: '@',
        buttonText: '@',
        addButtonText: '@',
        isOpen: '=?',
        onOpenFunc: '&',
        isDisabled: '=?',
        step: '=step',
        isWide: '=?',
        hideHeading: '=?',
        hidePanel: '=?'
      },
      controller: function () {
        this.setHeading = function (element) {
          this.heading = element;
        };
      },
      link: function (scope, element, attrs, accordionCtrl) {
        accordionCtrl.addGroup(scope);

        scope.$watch('isOpen', function (value) {
          if (value) {
            accordionCtrl.closeOthers(scope);
            scope.step.visited = true;
            if (scope.onOpenFunc) {
              scope.onOpenFunc(scope.step);
            }
          }
        });

        scope.toggleOpen = function () {

          if (scope.step.canOpen) {
            scope.step.canOpen().then(function (canOpen) {
              if (canOpen) {
                if (!scope.isDisabled) {
                  scope.isOpen = !scope.isOpen;
                }
              }
            });
          } else {
            if (!scope.isDisabled) {
              scope.isOpen = !scope.isOpen;
            }
          }
        };
      }
    };
  });

  app.directive('panelHeading', function () {
    return {
      restrict: 'EA',
      transclude: true, // Grab the contents to be used as the heading
      template: '', // In effect remove this element!
      replace: true,
      require: '^panelGroup',
      link: function (scope, element, attr, accordionGroupCtrl, transclude) {
        // Pass the heading to the accordion-group controller
        // so that it can be transcluded into the right place in the template
        // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
        accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
      }
    };
  });

  app.directive('panelTransclude', function () {
    return {
      require: '^panelGroup',
      link: function (scope, element, attr, controller) {
        scope.$watch(function () {
          return controller[attr.panelTransclude];
        }, function (heading) {
          if (heading) {
            element.html('');
            element.append(heading);
          }
        });
      }
    };
  });
})();


(function () {
  'use strict';
  angular.module('NavisphereOnline').controller('PanelController', [
    '$scope', '$attrs', 'panelConfig', function ($scope, $attrs, panelConfig) {

      this.groups = [];

      /// Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
      this.closeOthers = function (openGroup) {
        var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : panelConfig.closeOthers;
        if (closeOthers) {
          angular.forEach(this.groups, function (group) {
            if (group !== openGroup) {
              group.isOpen = false;
            }
          });
        }
      };

      // This is called from the accordion-group directive to add itself to the accordion
      this.addGroup = function (groupScope) {
        var that = this;
        this.groups.push(groupScope);

        groupScope.$on('$destroy', function () {
          that.removeGroup(groupScope);
        });
      };

      // This is called from the accordion-group directive when to remove itself
      this.removeGroup = function (group) {
        var index = this.groups.indexOf(group);
        if (index !== -1) {
          this.groups.splice(index, 1);
        }
      };

    }
  ]);

})();

/**
 * Created by okoaset on 3/30/2016.
 */
(function () {

  trackOrder.$inject = ['OrderService', '$state', 'UserPermissionService', 'analyticsService', '$window', 'externalRoutesService', 'WindowLocationHref'];
  function trackOrder(OrderService, $state, UserPermissionService, analyticsService, $window, externalRoutesService, WindowLocationHref) {
    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'app/widgets/trackOrder/trackOrder.tpl.html',
      scope: {
        value: '='
      },
      controller: ['$scope', function ($scope) {

        $scope.track = function () {
          var search = {
            offset: 0,
            limit: 10,
            search: !$scope.value ? $scope.value : $scope.value.toString().toUpperCase()
          };

          analyticsService.trackWithVar('widgetSearch', 'widgetSearchValue', $scope.value);

          externalRoutesService.search({ search: search.search });
        };

        $scope.goToShipmentEntry = function () {
          $window.location.href = '/orders/#/create';
        };

        $scope.showCreateOrderButton = function () {
          return UserPermissionService.hasPermission('Create Order');
        };
      }]
    }
  }
  angular.module('NavisphereOnline').directive("trackOrder", trackOrder);

})();

/**
 * Created by okoaset on 3/30/2016.
 */
(function () {
  'use strict';
  function widgetService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/widgets', null,{
      'getWidgets': { method: 'GET', url: API_BASE_URL + 'api/widgets', isArray: true }
    });
  }
  widgetService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('WidgetService', widgetService);
})();


/**
 * Created by okoaset on 3/25/2016.
 */
(function () {

  'use strict';
  var app = angular.module('NavisphereOnline');

  function widgetDefinitions(RecentOrdersDataModel, NotificationsDataModel, GlanceDataModel, defaultSettingsDataModel, GlanceShipmentsDataModel, userPermissionService) {
    var widgets =  [
      {
        name: 'glance',
        iconName:  'glyphicon-eye-open',
        title : 'MY_ORDERS_AT_A_GLANCE',
        directive: 'glance',
        dataAttrName: 'glances',
        dataModelType: GlanceDataModel,
        dataModelOptions: {
          statuses:[{translationKey:"BOOKED", active: true},
            {translationKey:"INCOMPLETE"},
            {translationKey:"IN_TRANSIT", active: true},
            {translationKey:"DELIVERED", active: true},
            {translationKey:"ORDERED"}],
          shippingMethods:[{translationKey:"TRUCKLOAD"},
            {translationKey:"INTERMODAL"},
            {translationKey:"LTL"},
            {translationKey:"FLATBED"},
            {translationKey:"AIR"},
            {translationKey:"CONSOLIDATED"},
            {translationKey:"BULK"},
            {translationKey:"OCEAN"},
            {translationKey:"RAIL"},
            {translationKey:"SMALL_PARCEL"}],
          timeFrames:[{translationKey:"NEW", active: true},
            { translationKey: "REQUESTED_PICKUP_TODAY", active: true },
            { translationKey: "REQUESTED_PICKUP_THIS_WEEK", active: true },
            { translationKey: "REQUESTED_DELIVERY_TODAY" },
            { translationKey: "REQUESTED_DELIVERY_THIS_WEEK" }],
          atRisks:[{translationKey:"AT_RISK"}]
        },
        size: {
          width: '100%',
          height: '100%'
        },
        settingsModalOptions: {
          templateUrl: 'app/widgets/glance/glanceSettings.tpl.html',
          controller: 'GlanceSettingsController'
        }
      },
      {
        name: 'notifications',
        iconName:  'glyphicon-bell',
        title : 'MY_NOTIFICATIONS',
        directive: 'my-notifications',
        dataAttrName: 'notifications',
        dataModelType: NotificationsDataModel,
        dataModelOptions: {count: 0},
        size: {
          width: '50%',
          height: '300px'
        },
        settingsModalOptions: {
          controller: 'NotificationsSettingsController'
        }
      },
      {
        name: 'recentOrders',
        iconName:  'glyphicon-list',
        title : 'MY_RECENT_ACTIVITY',
        directive: 'recent-orders',
        dataAttrName: 'orders',
        dataModelType: RecentOrdersDataModel,
        size: {
          width: '50%',
          height: '300px'
        },
        settingsModalOptions: {
          templateUrl: 'app/widgets/default/defaultSettings.tpl.html',
          controller: 'DefaultSettingsController'
        }
      },
      {
        name: 'searchByReference',
        iconName: 'glyphicon-globe',
        title: 'SEARCH_BY_REFERENCE_HASHSIGN',
        directive: 'track-order',
        dataModelType: defaultSettingsDataModel,
        attrs: {
          value: 'referenceNumber'
        },
        size: {
          width: '100%',
          height: 'auto'
        },
        settingsModalOptions: {
          templateUrl: 'app/widgets/default/defaultSettings.tpl.html',
          controller: 'DefaultSettingsController'
        }
      }
    ];

    if (!userPermissionService.isSupplier()) {
      widgets.push({
        name: 'glanceShipments',
        iconName: 'glyphicon-eye-open',
        title: 'MY_SHIPMENTS_AT_A_GLANCE',
        directive: 'glance-shipments',
        dataAttrName: 'glances',
        dataModelType: GlanceShipmentsDataModel,
        dataModelOptions: {
          statuses: [{ translationKey: "BOOKED", active: true },
          { translationKey: "INCOMPLETE" },
          { translationKey: "IN_TRANSIT", active: true },
          { translationKey: "DELIVERED", active: true },
          { translationKey: "ORDERED" }],
          shippingMethods: [{ translationKey: "TRUCKLOAD" },
          { translationKey: "INTERMODAL" },
          { translationKey: "LTL" },
          { translationKey: "FLATBED" },
          { translationKey: "AIR" },
          { translationKey: "CONSOLIDATED" },
          { translationKey: "BULK" },
          { translationKey: "OCEAN" },
          { translationKey: "RAIL" },
          { translationKey: "SMALL_PARCEL" }],
          timeFrames: [{ translationKey: "NEW", active: true },
            { translationKey: "REQUESTED_PICKUP_TODAY", active: true },
            { translationKey: "REQUESTED_PICKUP_THIS_WEEK", active: true },
            { translationKey: "REQUESTED_DELIVERY_TODAY" },
            { translationKey: "REQUESTED_DELIVERY_THIS_WEEK" }],
          atRisks: [{ translationKey: "AT_RISK" }]
        },
        size: {
          width: '100%',
          height: '100%'
        },
        settingsModalOptions: {
          templateUrl: 'app/widgets/glance/glanceSettings.tpl.html',
          controller: 'GlanceSettingsController'
        }
      });
    }

    return widgets;

  }
  widgetDefinitions.$inject = ['RecentOrdersDataModel', 'NotificationsDataModel', 'GlanceDataModel', 'defaultSettingsDataModel', 'GlanceShipmentsDataModel', 'UserPermissionService'];
  app.factory('widgetDefinitions', widgetDefinitions);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  shipmentsGlanceDataService.$inject = ['ShipmentService', '$interval'];
  function shipmentsGlanceDataService(ShipmentService, $interval) {
    var subscribers = [];
    var glances = [];
    var intervalRunning;
    var intervalPromise;
    var shipmentFacet = {};
    var callback;
    this.setUpdateCallback = function (updateCallback) {
      callback = updateCallback;
    };
    this.subscribe = function (dataModel) {
      subscribers.push({ id: dataModel.widgetScope.$id, dataModel: dataModel });
      if (intervalRunning) {
        searchForShipmentFacets();
      } else {
        startInterval();
      }
    };
    this.unsubscribe = function (id) {
      _.remove(subscribers, function (sub) {
        return sub.id === id;
      });
      if (subscribers.length < 1) {
        $interval.cancel(intervalPromise);
        intervalRunning = false;
      }
    };
    function startInterval() {
      intervalPromise = $interval(function () {
        searchForShipmentFacets();
      }, 60000);
      intervalRunning = true;
      searchForShipmentFacets();
    }
    function searchForShipmentFacets() {
      if (subscribers.length < 1) {
        $interval.cancel(intervalPromise);
      } else {
        ShipmentService.getShipmentsAtAGlance().$promise.then(function (data) {
          shipmentFacet = data.shipmentFacet;
          notifySubscribers();
        });
      }
    }
    function notifySubscribers() {
      glances = [];
      _.each(subscribers, function (subscriber) {
        var subGlances = { statuses: [], shippingMethods: [], timeFrames: [], atRisks: [] };
        _.each(subscriber.dataModel.dataModelOptions, function (optionVal, optionKey) {
          _.each(shipmentFacet, function (glanceVal, glanceKey) {
            if (optionKey === glanceKey) {
              _.each(optionVal, function (oKeyVal, oKeyKey) {
                _.each(glanceVal, function (gKeyVal, gKeyKey) {
                  if (oKeyVal.translationKey === gKeyVal.translationKey && oKeyVal.active === true) {
                    subGlances[glanceKey].push(gKeyVal);
                  }
                });
              });
            }
          });
        });
        callback(subGlances, subscriber.dataModel);
      });
    }
  }
  app.service('ShipmentsGlanceDataService', shipmentsGlanceDataService);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  ordersGlanceDataService.$inject = ['OrderService', '$interval'];
  function ordersGlanceDataService(OrderService, $interval) {
    var subscribers = [];
    var glances = [];
    var intervalRunning;
    var intervalPromise;
    var orderFacet = {};
    var callback;
    this.setUpdateCallback = function (updateCallback) {
      callback = updateCallback;
    };
    this.subscribe = function (dataModel) {
      subscribers.push({ id: dataModel.widgetScope.$id, dataModel: dataModel });
      if (intervalRunning) {
        searchForOrderFacets();
      } else {
        startInterval();
      }
    };
    this.unsubscribe = function (id) {
      _.remove(subscribers, function (sub) {
        return sub.id === id;
      });
      if (subscribers.length < 1) {
        $interval.cancel(intervalPromise);
        intervalRunning = false;
      }
    };
    function startInterval() {
      intervalPromise = $interval(function () {
        searchForOrderFacets();
      }, 60000);
      intervalRunning = true;
      searchForOrderFacets();
    }
    function searchForOrderFacets() {
      if (subscribers.length < 1) {
        $interval.cancel(intervalPromise);
      } else {
        var search = {
          offset: 0,
          limit: 10
        };

        OrderService.getOrdersAtAGlance(search).$promise.then(function (data) {
          orderFacet = data.orderFacet;
          notifySubscribers();
        });
      }
    }
    function notifySubscribers() {
      glances = [];
      _.each(subscribers, function (subscriber) {
        var subGlances = { statuses: [], shippingMethods: [], timeFrames: [], atRisks: [] };
        _.each(subscriber.dataModel.dataModelOptions, function (optionVal, optionKey) {
          _.each(orderFacet, function (glanceVal, glanceKey) {
            if (optionKey === glanceKey) {
              _.each(optionVal, function (oKeyVal, oKeyKey) {
                _.each(glanceVal, function (gKeyVal, gKeyKey) {
                  if (oKeyVal.translationKey === gKeyVal.translationKey && oKeyVal.active === true) {
                    subGlances[glanceKey].push(gKeyVal);
                  }
                });
              });
            }
          });
        });
        callback(subGlances, subscriber.dataModel);
      });
    }
  }
  app.service('OrdersGlanceDataService', ordersGlanceDataService);
})();

(function () {
  'use strict';

  var app = angular.module('NavisphereOnline');

  function notificationDismissalService() {
    this.dismissing = false;

    this.setDismissingFlag = function() {
      this.dismissing = true;
    };

    this.unsetDismissingFlag = function() {
      this.dismissing = false;
    };
  }

  app.service('NotificationDismissalService', notificationDismissalService);
})();

/**
 * Created by okoaset on 3/30/2016.
 */
(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  databaseStorage.$inject = ['User','API_BASE_URL','$http'];
  function databaseStorage(User,API_BASE_URL,$http){
    this.setItem = function(key, value){
      User.saveWidgets(value).$promise.then(function () {
        return value;
      },function(){});
    };
    this.getItem = function(){
      return $http.get(API_BASE_URL + 'api/users/widgets').then(function(result) {
        // migrate the old user key's title and name to the new key while keeping the same customization
        return result.data.toString().replace('TRACK_MY_ORDER', 'SEARCH_BY_REFERENCE_HASHSIGN').replace('trackOrder', 'searchByReference');
      },function(){});
    };
  }
  app.service('databaseStorage', databaseStorage);
})();

/**
 * Created by okoaset on 3/30/2016.
 */
(function () {

  function detailUrlByEntityType(order) {
    switch (order.entityType) {
      case 0: // Order
        return appConfig.ordersUIBaseUrl + '/#/detail/' + order.orderNumber;
      case 1: // Shipment
        return appConfig.shipmentsUIBaseUrl + '/#/detail/' + order.orderNumber;
      default:
        return appConfig.ordersUIBaseUrl + '/#/detail/' + order.orderNumber;
    }
  }

  function recentOrders($state, WindowLocationHref) {
    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'app/widgets/recentOrders/recentOrders.tpl.html',
      scope: {
        orders: '='
      },
      controller: ['$scope', function ($scope) {
        $scope.orderDetails = function (order) {
          var url = detailUrlByEntityType(order);
          WindowLocationHref.setWindowLocationHref(url);
        };
        $scope.formatCityState = function (location) {
          if (angular.isUndefined(location) || location === null) {
            return null;
          }
          var text = [location.city, location.state].filter(function (val) { return val; }).join(', ');
          return text;
        };
      }]
    };
  }

  recentOrders.$inject = ['$state', 'WindowLocationHref'];
  angular.module('NavisphereOnline').directive("recentOrders", recentOrders);

})();

(function () {
  'use strict';

  function recentOrdersDataModel(OrderService, WidgetDataModel, $interval) {
    function RecentOrdersDataModel() {
    }

    RecentOrdersDataModel.prototype = Object.create(WidgetDataModel.prototype);
    RecentOrdersDataModel.prototype.init = function () {
      WidgetDataModel.prototype.init.call(this);
      this.intervalPromise = $interval(function () {
        this.load();
      }.bind(this), 60000);
      this.load();
    };

    RecentOrdersDataModel.prototype.destroy = function () {
      WidgetDataModel.prototype.destroy.call(this);
      $interval.cancel(this.intervalPromise);
    };

    RecentOrdersDataModel.prototype.load = function () {
      OrderService.getRecentOrdersAtAGlance().$promise.then(function (data) {
        this.updateScope(data);
      }.bind(this));
    };
    return RecentOrdersDataModel;
  };

  recentOrdersDataModel.$inject = ['OrderService', 'WidgetDataModel', '$interval'];
  angular.module('NavisphereOnline').factory('RecentOrdersDataModel', recentOrdersDataModel);
})();
(function () {
  'use strict';
  notificationsSettingsController.$inject = ['$state', '$window', '$rootScope'];
  function notificationsSettingsController($state, $window, $rootScope) {
    // This controller is now just here to trigger navigating to the notificationPreferences page.
      if ($rootScope.featureFlags.notifcationSettingsFeatureFlag){
        $window.location.href = appConfig.notificationSettingsLink;
      } else {
        $state.go('app.notificationPreferences');
      }
  }
  angular.module('NavisphereOnline').controller('NotificationsSettingsController', notificationsSettingsController);
})();

/**
 * Created by okoaset on 3/30/2016.
 */
(function () {

  function myNotifications($state, AlertService, WindowLocationHref) {
    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'app/widgets/notifications/notifications.tpl.html',
      scope: {
        notifications: '='
      },
      controller: ['$scope', 'NotificationDismissalService', function ($scope, NotificationDismissalService) {
        $scope.dismissNotification = function (notification) {
          $scope.notifications = AlertService.dismiss(notification);
        };
        $scope.$watch(function() {
          return NotificationDismissalService.dismissing;
        }, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            _.forEach($scope.notifications, function(notification) {
              $scope.notifications = AlertService.dismiss(notification);
            });
            NotificationDismissalService.unsetDismissingFlag();
          }
        });
        $scope.orderDetails = function (orderNum) {
					var redirectUrl =  appConfig.ordersUIBaseUrl + '/#/detail/' + orderNum;
					WindowLocationHref.setWindowLocationHref(redirectUrl);
        };
      }]
    };
  };

  myNotifications.$inject = ['$state', 'AlertService', 'WindowLocationHref'];
  angular.module('NavisphereOnline').directive("myNotifications", myNotifications);

})();

(function () {
  notificationsDataModel.$inject = ['AlertService','WidgetDataModel','$interval', 'SubscriptionService', '$q'];
  function notificationsDataModel (AlertService, WidgetDataModel,$interval, SubscriptionService, $q) {
      function NotificationsDataModel() {

      }

      NotificationsDataModel.prototype = Object.create(WidgetDataModel.prototype);

      //putting these services on the object itself to facilitate unit testing
      NotificationsDataModel.prototype.subscriptionService = SubscriptionService;
      NotificationsDataModel.prototype.alertService = AlertService;

      NotificationsDataModel.prototype.events = defaultEvents();
      NotificationsDataModel.prototype.submitting = true;
      NotificationsDataModel.prototype.init = function () {
           WidgetDataModel.prototype.init.call(this);
           this.intervalPromise = $interval(function () {
             getAlerts(this);
          }.bind(this), 60000);
          this.load();
      };
      NotificationsDataModel.prototype.destroy = function () {
          WidgetDataModel.prototype.destroy.call(this);
          $interval.cancel(this.intervalPromise);
      };
      NotificationsDataModel.prototype.load = function () {
          getAlerts(this);
      };

      NotificationsDataModel.prototype.saveSubscription = function(){
        var that = this;
        that.submitting = true;
        var eventNumbers = getActiveEventTypesForSave(that);
        return that.subscriptionService.save(eventNumbers).$promise.then(function(){
          //getAlerts(that);
        },
        function(){
          //failed to save
          return $q.reject('WE_ARE_UNABLE_TO_UPDATE_YOUR_NOTIFICATION_PREFEREN');
          //return
        });
      };
      NotificationsDataModel.prototype.getSubscribedEvents = function(){

        return this.subscriptionService.get().$promise.then(function(eventTypes){
            setActiveEventTypes(eventTypes, this);
            return this.events;
          }.bind(this),
          function(){
            //failed to get event types
            return $q.reject('WE_ARE_UNABLE_TO_RETRIEVE_YOUR_NOTIFICATION_PREFER');
          });
      };
      function getAlerts(that){
        that.alertService.getAlerts().$promise.then(function(data){
          that.dataModelOptions.count = data.length;
          that.updateScope(data);
        });
      }
      function setActiveEventTypes(eventTypes, that){
        that.events = defaultEvents();
        for(var i = 0; i < eventTypes.length; i++){
          for(var j = 0; j < that.events.length; j++){
            if (eventTypes[i].eventTypeNumber === that.events[j].eventNumber){
              that.events[j].active = true;
            }
          }
        }
      }
      function getActiveEventTypesForSave(that){
        var eventNums = [];
        for(var j = 0; j < that.events.length; j++){
          if (that.events[j].active === true){
            eventNums.push(that.events[j].eventNumber);
          }
        }
        return eventNums;
      }
      function defaultEvents(){
        return [
          {eventName: 'Carrier Bounced', eventNumber: 26, active: false},
          {eventName: 'Shipment Booked', eventNumber: 16, active: false},
          {eventName: 'Late Arrival', eventNumber: 47, active: false},
          {eventName: 'Potentially Late', eventNumber: 69, active: false},
          {eventName: 'Order Cancelled', eventNumber: 110, active: false},
          {eventName: 'Order Delivered', eventNumber: 111, active: false},
          {eventName: 'Carrier Arrived', eventNumber: 46, active: false},
          {eventName: 'Carrier Departed', eventNumber: 48, active: false},
          {eventName: 'Order Created', eventNumber: 101, active: false},
          {eventName: 'Commodity Changed', eventNumber: 102, active: false},
          {eventName: 'Location Changed', eventNumber: 109, active: false},
          {eventName: 'Ready By Date/Time Changed', eventNumber: 105, active: false},
          {eventName: 'Pick Up By Date/Time Changed', eventNumber: 106, active: false},
          {eventName: 'Delivery Date/Time Changed', eventNumber: 107, active: false},
          {eventName: 'Deliver By Date/Time Changed', eventNumber: 108, active: false}
        ];
      }

      return NotificationsDataModel;
  }
  angular.module('NavisphereOnline').factory('NotificationsDataModel', notificationsDataModel);
})();

 (function () {
  'use strict';
  shipmentsGlanceDataModel.$inject = ['WidgetDataModel', 'ShipmentsGlanceDataService'];
  function shipmentsGlanceDataModel(WidgetDataModel, ShipmentsGlanceDataService) {
    function GlanceDataModel() {
    }

    GlanceDataModel.prototype = Object.create(WidgetDataModel.prototype);
    GlanceDataModel.prototype.constructor = WidgetDataModel;

    angular.extend(GlanceDataModel.prototype, {
      init: function () {
        WidgetDataModel.prototype.init.call(this);
        ShipmentsGlanceDataService.setUpdateCallback(this.updateGlances);
        this.load();
      },
      saveSettings: function () {
        this.widgetScope.options.saveDashboard(true);
        //unsubscribe, resub with new settings
        ShipmentsGlanceDataService.unsubscribe(this.widgetScope.$id);
        ShipmentsGlanceDataService.subscribe(this);
      },
      destroy: function () {
        WidgetDataModel.prototype.destroy.call(this);
        ShipmentsGlanceDataService.unsubscribe(this.widgetScope.$id);
      },
      load: function () {
        ShipmentsGlanceDataService.subscribe(this);
      },
      updateGlances: function(glances, dataModel){
        dataModel.updateScope(glances);
      }
    });
    return GlanceDataModel;
  }

  angular.module('NavisphereOnline').factory('ShipmentsGlanceDataModel', shipmentsGlanceDataModel);
})();

(function () {
  glanceShipments.$inject = ['externalRoutesService'];
  var shipmentView = 'shipment';
  var predefinedTimeFrame = 'Pre-Defined';

  function glanceShipments(externalRoutesService) {
    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'app/widgets/glance/glanceShipments.tpl.html',
      scope: {
        glances: '='
      },
      controller: ['$scope', function ($scope) {
        $scope.goToShipmentsWithTimeFrame = function (timeFrame) {
          externalRoutesService.search({ view: shipmentView, timeFrame: timeFrame, currentTimeframe: predefinedTimeFrame });
        };

        $scope.goToShipmentsWithStatus = function (status) {
          externalRoutesService.search({ view: shipmentView, status: status });
        };

        $scope.goToShipmentsWithMethod = function (method) {
          externalRoutesService.search({ view: shipmentView, shippingMethod: method });
        };

        $scope.goToShipmentsWithAtRisk = function () {
          externalRoutesService.search({ view: shipmentView, atRisk: true });
        };
      }]
    };
  }

  angular.module('NavisphereOnline').directive("glanceShipments", glanceShipments);
})();

 (function () {
  'use strict';
  glanceShipmentsDataModel.$inject = ['WidgetDataModel', 'ShipmentsGlanceDataService'];
  function glanceShipmentsDataModel(WidgetDataModel, ShipmentsGlanceDataService) {
    function GlanceShipmentsDataModel() {
    }

    GlanceShipmentsDataModel.prototype = Object.create(WidgetDataModel.prototype);
    GlanceShipmentsDataModel.prototype.constructor = WidgetDataModel;

    angular.extend(GlanceShipmentsDataModel.prototype, {
      init: function () {
        WidgetDataModel.prototype.init.call(this);
        ShipmentsGlanceDataService.setUpdateCallback(this.updateGlances);
        this.load();
      },
      saveSettings: function () {
        this.widgetScope.options.saveDashboard(true);
        //unsubscribe, resub with new settings
        ShipmentsGlanceDataService.unsubscribe(this.widgetScope.$id);
        ShipmentsGlanceDataService.subscribe(this);
      },
      destroy: function () {
        WidgetDataModel.prototype.destroy.call(this);
        ShipmentsGlanceDataService.unsubscribe(this.widgetScope.$id);
      },
      load: function () {
        ShipmentsGlanceDataService.subscribe(this);
      },
      updateGlances: function(glances, dataModel){
        dataModel.updateScope(glances);
      }
    });
    return GlanceShipmentsDataModel;
  }

  angular.module('NavisphereOnline').factory('GlanceShipmentsDataModel', glanceShipmentsDataModel);
})();

(function () {
  'use strict';
  glanceSettingsController.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'widget', '$filter'];
  function glanceSettingsController($scope, $rootScope, $uibModalInstance, widget, $filter) {
    $scope.events = [];
    $scope.widget = widget;
    $scope.titleDisplay = $filter('translate')(widget.title);

    $scope.configuration = widget.dataModel.dataModelOptions;

    $scope.submitting = false;

    $scope.etaAtRiskFeatureFlag = $rootScope.featureFlags.etaAtRiskFeatureFlag;

    $scope.ok = function(){
      $scope.errorMessage = '';
      if($scope.titleForm.$dirty) {
        $scope.widget.title = $scope.titleDisplay;
        $scope.widget.dataModel.widgetScope.saveTitleEdit($scope.widget);
      }
      if($scope.glanceSettingsForm.$dirty){
        $scope.submitting = true;

        $scope.widget.dataModel.saveSettings();
        $uibModalInstance.close();
      } else {
        $uibModalInstance.close();
      }

    };
    $scope.cancel = function(){
      $uibModalInstance.dismiss('cancel');
    };
  }
  angular.module('NavisphereOnline').controller('GlanceSettingsController', glanceSettingsController);
})();

/**
 * Created by KRIEBRA on 6/29/2016.
 */
(function () {
  glance.$inject = ['externalRoutesService'];

  function glance(externalRoutesService) {
    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'app/widgets/glance/glance.tpl.html',
      scope: {
        glances: '='
      },
      controller: ['$scope', function ($scope) {
        $scope.goToOrdersWithTimeFrame = function (timeFrame) {
          externalRoutesService.search({ timeFrame: timeFrame, currentTimeframe: 'Pre-Defined' });
        };

        $scope.goToOrdersWithStatus = function (status) {
          externalRoutesService.search({ status: status });
        };

        $scope.goToOrdersWithMethod = function (method) {
          externalRoutesService.search({ shippingMethod: method });
        };

        $scope.goToOrdersWithAtRisk = function () {
          externalRoutesService.search({ atRisk: true });
        };
      }]
    };
  }

  angular.module('NavisphereOnline').directive("glance", glance);
})();

/**
 * Created by KRIEBRA on 6/28/2016.
 */
(function () {
  'use strict';
  glanceDataModel.$inject = ['WidgetDataModel', 'OrdersGlanceDataService'];
  function glanceDataModel(WidgetDataModel, OrdersGlanceDataService) {
    function GlanceDataModel() {
    }

    GlanceDataModel.prototype = Object.create(WidgetDataModel.prototype);
    GlanceDataModel.prototype.constructor = WidgetDataModel;

    angular.extend(GlanceDataModel.prototype, {
      init: function () {
        WidgetDataModel.prototype.init.call(this);
        OrdersGlanceDataService.setUpdateCallback(this.updateGlances);
        this.load();
      },
      saveSettings: function () {
        this.widgetScope.options.saveDashboard(true);
        //unsubscribe, resub with new settings
        OrdersGlanceDataService.unsubscribe(this.widgetScope.$id);
        OrdersGlanceDataService.subscribe(this);
      },
      destroy: function () {
        WidgetDataModel.prototype.destroy.call(this);
        OrdersGlanceDataService.unsubscribe(this.widgetScope.$id);
      },
      load: function () {
        OrdersGlanceDataService.subscribe(this);
      },
      updateGlances: function(glances, dataModel){
        dataModel.updateScope(glances);
      }
    });
    return GlanceDataModel;
  }

  angular.module('NavisphereOnline').factory('GlanceDataModel', glanceDataModel);
})();

(function () {
  defaultSettingsDataModel.$inject = ['WidgetDataModel'];
  function defaultSettingsDataModel (WidgetDataModel) {
    function defaultSettingsDataModel() {

    }

    defaultSettingsDataModel.prototype = Object.create(WidgetDataModel.prototype);

    return defaultSettingsDataModel;
  }
  angular.module('NavisphereOnline').factory('defaultSettingsDataModel', defaultSettingsDataModel);
})();

(function () {
  'use strict';
  defaultSettingsController.$inject = ['$scope', '$uibModalInstance', 'widget', '$filter'];
  function defaultSettingsController($scope, $uibModalInstance, widget, $filter) {
    $scope.events = [];
    $scope.widget = widget;
    $scope.titleDisplay = $filter('translate')(widget.title);

    $scope.ok = function(){
      if($scope.titleForm.$dirty) {
        $scope.widget.title = $scope.titleDisplay;
        $scope.widget.dataModel.widgetScope.saveTitleEdit($scope.widget);
      }
      $uibModalInstance.close();
    };
    $scope.cancel = function(){
      $uibModalInstance.dismiss('cancel');
    };
  }
  angular.module('NavisphereOnline').controller('DefaultSettingsController', defaultSettingsController);
})();


(function () {
  'use strict';
  function userPreferencesController($scope, $rootScope, $window, $state, $interval, $translate, tmhDynamicLocale, User, preferenceData, localStorageService) {

    var vm = this;
    vm.countryList = preferenceData.countryList;
    vm.dateExample = new Date(1898, 6, 29);
    vm.unitOfMeasure = preferenceData.userPreference.unitOfMeasure.toLowerCase();
    vm.timeFormat = preferenceData.userPreference.timeFormat;
    vm.country = setSelectedCulture(preferenceData.userPreference.culture);

    vm.setSelectedCulture = setSelectedCulture;
    vm.setClock = setClock;
    vm.countryChanged = countryChanged;
    vm.savePreferences = savePreferences;
    vm.goToNotificationPreferences = goToNotificationPreferences;

    vm.startIntro = function () {
      $state.go('app.dashboard', {
        runIntro: true
      });
    };

    function setSelectedCulture(cultureName) {
      var sc = undefined;
      for (var i = 0; i < preferenceData.countryList.length; i++) {
        if (preferenceData.countryList[i].culture === cultureName) {
          sc = preferenceData.countryList[i];
          break;
        }
      }
      return sc;
    }

    function setClock() {
      var currentDate = new Date();
      var hours = currentDate.getHours();
      var ampm = '';
      if (vm.timeFormat === '12') {
        ampm = (hours >= 12) ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
      } else {
        hours = (hours < 10) ? '0' + hours : hours;
      }
      var minutes = currentDate.getMinutes();
      minutes = (minutes < 10) ? '0' + minutes : minutes;
      // if timeFormat is not set to '12', ampm is never set. Is this intentional?
      vm.currentTime = hours + ":" + minutes + " " + ampm;
    }
    vm.setClock();
    $interval(vm.setClock, 1000);
    $scope.$watch('vm.timeFormat', function () {
      vm.setClock();
    });
    $scope.$watch('vm.unitOfMeasure', function (newValue) {
      vm.weightExample = (newValue === 'metric') ? 680425 : 150008;
      vm.unitText = (newValue === 'metric') ? 'kg' : 'lbs';
    });

    function countryChanged(item) {
      $translate.use(item.culture);
      tmhDynamicLocale.set(item.culture);
    }

    function savePreferences() {
      User.savePreferences({
        unitOfMeasure: vm.unitOfMeasure,
        timeFormat: vm.timeFormat,
        culture: vm.country.culture,
        preferencesConfirmed: true
      }).$promise.then(function (data) {
        data.eventNotificationPreferences = preferenceData.userPreference.eventNotificationPreferences;
        localStorageService.set("preferences", data);
        $state.go('app.dashboard');
      }, null);
    }

    function goToNotificationPreferences() {
      if ($rootScope.featureFlags.notifcationSettingsFeatureFlag){
        $window.location.href = appConfig.notificationSettingsLink;
      } else {
        $state.go('app.notificationPreferences');
      }
    }
  }

  userPreferencesController.$inject = ['$scope', '$rootScope', '$window', '$state', '$interval', '$translate', 'tmhDynamicLocale', 'User', 'preferenceData', 'localStorageService'];
  angular.module('NavisphereOnline').controller('userPreferencesController', userPreferencesController);

})();

(function () {
  'use strict';
  reverseLogisticsService.$inject = ['$filter', '$rootScope', '$uibModal', 'FilterService','ReverseLogisticsResource'];

  function reverseLogisticsService($filter, $rootScope, $uibModal, FilterService, ReverseLogisticsResource) {
    var originalResults = [];
    var filteredResults = [];
    var loadingModal;

    var setResults = function (results) {
      originalResults = results;
      filteredResults = results;
    };

    function openLoadingModal() {
      loadingModal = $uibModal.open({
        templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
        size: 'sm',
        controller: 'loadingSpinnerController',
        backdrop: 'static',
        resolve: {
          title: function () {
            return $filter('translate')('PROCESSING');
          }
        }
      });
    }

    this.clearResults = function () {
      originalResults = [];
      filteredResults = [];
    };

    this.filter = function (filterParams) {
      filteredResults = FilterService.filterThorough(originalResults, filterParams);
      filteredResults = _.uniq(filteredResults, function(ticket) {
        return ticket.ticketNumber;
      })

    };

    this.getDistinctTicketTypeOrStatusFilters = function (tickets, propertyName) {
      var uniqueKeys = {};
      var distinct = [];

      for (var index in tickets) {
        var result = tickets[index][propertyName];
          if (result && typeof(uniqueKeys[result]) === "undefined") {
            distinct.push({name: result, checked: false});
            uniqueKeys[result] = result;
        }
      }

      return distinct;
    };

    this.getDistinctCityStateFilters = function (tickets) {

      var uniqueKeys = {};
      var distinct = [];
      var locationTypes = ['originalDestination', 'originalOrigin', 'returnDestination', 'returnOrigin'];

      _.forEach(tickets, function(ticket) {
        _.forEach(locationTypes, function (locationType) {
          var location = ticket[locationType];
          if (location) {
            if (location.cityState && typeof(uniqueKeys[location.cityState]) === "undefined") {
              distinct.push({name: location.cityState, checked: false, state: location.state, city: location.city});
              uniqueKeys[location.cityState] = location.cityState;
            }
          }
        })
      });

      return _.sortBy(distinct, ['state', 'city']);
    };

    this.getDistinctLocationNameFilters = function(tickets) {
      var uniqueKeys = {};
      var distinct = [];
      var locationTypes = ['originalDestination', 'originalOrigin', 'returnDestination', 'returnOrigin'];

      _.forEach(tickets, function(ticket) {
        _.forEach(locationTypes, function (locationType) {
          var location = ticket[locationType];
          if (location) {
            if (location.name && typeof(uniqueKeys[location.name]) === "undefined") {
              distinct.push({name: location.name, checked: false, cityState: location.cityState});
              uniqueKeys[location.name] = location.name;
            }
          }
        })
      });

      return _.sortBy(distinct, [function(location) { return location.name.toLowerCase()}]);
    };

    this.getFilteredResults = function() {
      return filteredResults;
    };

    this.getOriginalResults = function() {
      return originalResults;
    };

    this.getTicketCount = function() {
      return filteredResults.length;
    };

    this.search = function(searchParams) {
      openLoadingModal();
      if(searchParams.referenceNumber) {
        searchParams.referenceNumber = searchParams.referenceNumber.toLowerCase();
      }
      ReverseLogisticsResource.search(searchParams).$promise.then(function(data){
        setResults(data.tickets);
        loadingModal.close();
        $rootScope.$broadcast('reverseLogisticsSearchComplete');
      });
    };

    this.setResults = setResults;
  }
  angular.module('NavisphereOnline').service('ReverseLogisticsService', reverseLogisticsService);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  reverseLogisticsSearchController.$inject = ['customersWithRL', 'ReverseLogisticsService', '$scope', 'user'];
  function reverseLogisticsSearchController(customersWithRL, ReverseLogisticsService, $scope, user) {
    $scope.user = user;
    $scope.searchType = 'REFNUM';
    $scope.sortType = 'NEWEST';
    $scope.customersWithRL = customersWithRL;
    $scope.searchParams = {
      cCodes: [],
      referenceNumber: null,
      refNumType: 'TICKETNUMBER',
      startDate: null,
      endDate: null,
      pageSize: 500,
      pageNumber: 1
    };

    $scope.selectedRefNumType = 'TICKET_NUMBER';
    $scope.startDate = null;
    $scope.endDate = null;
    $scope.refNumTypeMap = {
      "ALL": "ALL",
      "TICKET_NUMBER": "TICKETNUMBER",
      "RA_NUMBER_POUND": "RA Number",
      "BOL_POUND": "BOL",
      "CUSTOMER_PO_NUMBER": "CUST PO",
      "REFERENCE": "CRID",
      "PRO_TRIP_NUMBER_POUND": "RL Pro Number",
      "ORDER_POUND": "Cust Order Num"
    };

    $scope.checkKeyPress = checkKeyPress;
    $scope.search = search;
    $scope.setRefNumType = setRefNumType;
    $scope.setSearchType = setSearchType;
    $scope.setSortType = setSortType;

    getCcodes();

    function checkKeyPress(event) {
      if (event.keyCode === 13) {
        $scope.search();
      }
    }

    function search() {
      ReverseLogisticsService.search($scope.searchParams);
    }

    function setRefNumType(refNumType) {
      $scope.selectedRefNumType = refNumType;
      $scope.searchParams.refNumType = $scope.refNumTypeMap[refNumType];
    }

    function setSearchType(selection){
      if(selection === "REFNUM") {
        $scope.searchParams.startDate = null;
        $scope.searchParams.endDate = null;
      }
      else if (selection === "DATERANGE") {
        $scope.searchParams.referenceNumber = null;
        $scope.searchParams.refNumType = 'TICKETNUMBER';
      }
      $scope.searchType = selection;
    }

    function setSortType(selection) {
      $scope.sortType = selection;
    }

    function getCcodes(){
      _.forEach($scope.customersWithRL.customers, function(customer){
        $scope.searchParams.cCodes.push(customer.partyCode);
      });
    }
  }
  app.controller('reverseLogisticsSearchController', reverseLogisticsSearchController);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  reverseLogisticsResultsController.$inject = ['DocumentManagerService', 'ReverseLogisticsResource','ReverseLogisticsService', '$scope', '$state', '$stateParams'];
  function reverseLogisticsResultsController(DocumentManagerService, ReverseLogisticsResource, ReverseLogisticsService, $scope, $state, $stateParams) {
    $scope.cityStatesDisplayLimit = 10;
    $scope.currentPage = 1;
    $scope.filterParams = [];
    $scope.filters = {};
    $scope.hideFilters = true;
    $scope.limit = "10";
    $scope.locationNamesDisplayLimit = 10;
    $scope.offset = 0;
    $scope.sortDescending = true;
    $scope.totalTickets = 0;
    $scope.ticketStatusDisplayLimit = 10;
    $scope.ticketTypeDisplayLimit = 10;

    $scope.calculateTotalReturn = calculateTotalReturn;
    $scope.collapseFilter = collapseFilter;
    $scope.expandFilter = expandFilter;
    $scope.filter = filter;
    $scope.getFilteredResults = getFilteredResults;
    $scope.getFilters = getFilters;
    $scope.getLocationInfo = getLocationInfo;
    $scope.getLocationLabel = getLocationLabel;
    $scope.getTicketDetail = getTicketDetail;
    $scope.limitChanged = limitChanged;
    $scope.onCityStateClick = onCityStateClick;
    $scope.openDocumentViewer = openDocumentViewer;
    $scope.pageChanged = pageChanged;
    $scope.refreshResults = refreshResults;
    $scope.setCityStateFilterParams = setCityStateFilterParams;
    $scope.setLocationFilterParams = setLocationFilterParams;
    $scope.setSortDescending = setSortDescending;
    $scope.setTicketStatusFilterParams = setTicketStatusFilterParams;
    $scope.setTicketTypeFilterParams = setTicketTypeFilterParams;
    $scope.showCollapseButton = showCollapseButton;
    $scope.toggleCheck = toggleCheck;

    repopulateResults($stateParams);
    setReverseLogisticsListener();

    function calculateTotalReturn(ticket) {
      return ticket.processingFee + ticket.estimatedReturnCost;
    }

    function collapseFilter($event, filterType){
      $event.preventDefault();
      $event.stopPropagation();
      $scope[filterType + "DisplayLimit"] = 10;
    }

    function expandFilter($event, filterType){
      $event.preventDefault();
      $event.stopPropagation();
      $scope[filterType + "DisplayLimit"] += 10;
    }

    function filter() {
      ReverseLogisticsService.filter($scope.filterParams);
    }

    function getFilteredResults() {
      return ReverseLogisticsService.getFilteredResults();
    }

    function getFilters(searchResults) {
      $scope.filters.ticketTypes = ReverseLogisticsService.getDistinctTicketTypeOrStatusFilters(searchResults, "ticketType");
      $scope.filters.ticketStatuses = ReverseLogisticsService.getDistinctTicketTypeOrStatusFilters(searchResults, "status");
      $scope.filters.cityStates = ReverseLogisticsService.getDistinctCityStateFilters(searchResults);
      $scope.filters.locationNames = ReverseLogisticsService.getDistinctLocationNameFilters(searchResults);
    }

    /**
     *  OSD tickets - display Original Destination in first field and Return Destination in second field
     *  Customer Return tickets - display Return Origin in first field and Return Destination in second field
     */
    function getLocationInfo(ticket, propertyName) {

      if(ticket.ticketType === "OSD") {
        return ticket.originalDestination ? ticket.originalDestination[propertyName] : '';
      } else {
        return ticket.returnOrigin ? ticket.returnOrigin[propertyName] : '';
      }
    }

    function getLocationLabel(ticket) {
      if(ticket.ticketType === "OSD"){
        return "Original Destination"
      } else if(ticket.ticketType === "Customer Return" || ticket.ticketType === "CustReturn") {
        return "Return Origin"
      }
    }

    function getTicketDetail(ticket) {
      ReverseLogisticsResource.getTicket({
        ticketId: ticket.ticketNumber
      }).$promise.then(function (ticketDetail) {
        $stateParams.ticketDetail = ticketDetail;
        var results = ReverseLogisticsService.getOriginalResults();
        var status = ticket.status;
        var type = ticket.ticketType;
        $state.go('app.reverseLogisticsDetail', {
          ticketDetail: ticketDetail,
          ticketStatus: status,
          ticketType: type,
          rLSearchResults: results
        });
      });
    }

    function limitChanged() {
      $scope.currentPage = Math.floor($scope.offset / $scope.limit) + 1;
      $scope.pageChanged();
    }

    function onCityStateClick(cityState) {
      $scope.filterParams = [];
      $scope.toggleCheck(cityState);
      $scope.filters.locationNames = ReverseLogisticsService.getDistinctLocationNameFilters(ReverseLogisticsService.getOriginalResults());

      var checkedCityStates = [];
      _.forEach($scope.filters.cityStates, function(cityState) {
        if(cityState.checked) {
          checkedCityStates.push(cityState.name);
        }
      });

      if(checkedCityStates.length > 0) {
        $scope.filters.locationNames = _.filter($scope.filters.locationNames, function (location) {
          return _.includes(checkedCityStates, location.cityState);
        });
      }

      $scope.filters.locationNames = _.sortBy($scope.filters.locationNames, function(location) {
        return location.name.toLowerCase();
      });

      refreshFilterParams();
      $scope.filter();
      $scope.totalTickets = ReverseLogisticsService.getTicketCount();
    }

    function openDocumentViewer(ticketId) {
      var controller = 'reverseLogisticsDocumentViewerController';
      var resolveObject = {
        order: function () {
          return null;
        },
        documents: ['DocumentService', function (DocumentService) {
          return DocumentService.getReverseLogisticsDocuments({ticketId: ticketId}).$promise;
        }]
      };

      DocumentManagerService.openDocumentViewer(controller, ticketId, resolveObject);
    }

    function pageChanged() {
      $scope.offset = ($scope.currentPage - 1) * $scope.limit;
    }

    function refreshFilterParams() {
      $scope.setTicketTypeFilterParams();
      $scope.setTicketStatusFilterParams();
      $scope.setCityStateFilterParams();
      $scope.setLocationFilterParams();
    }

    function refreshResults(filter) {
      $scope.filterParams = [];

      $scope.toggleCheck(filter);
      refreshFilterParams();
      $scope.filter();

      $scope.totalTickets = ReverseLogisticsService.getTicketCount();
    }

    function repopulateResults($stateParams) {
      if ($stateParams.rLSearchResults) {
        ReverseLogisticsService.setResults($stateParams.rLSearchResults);
        setValuesOnInstantiation();
      }
    }

    function setCityStateFilterParams() {
      var cityStateFilters = [];

      _.forEach($scope.filters.cityStates, function(filter) {
        if (filter.checked) {
          cityStateFilters.push({
            originalDestination: {
              cityState: filter.name
            }
          });
          cityStateFilters.push({
            originalOrigin: {
              cityState: filter.name
            }
          });
          cityStateFilters.push({
            returnDestination: {
              cityState: filter.name
            }
          });
          cityStateFilters.push({
             returnOrigin: {
              cityState: filter.name
            }
          });
        }
      });

      if (cityStateFilters.length) {
        $scope.filterParams.push(cityStateFilters);
      }
    }

    function setLocationFilterParams() {
      var locationFilters = [];

      _.forEach($scope.filters.locationNames, function(filter) {
        if (filter.checked) {
          locationFilters.push({
            originalDestination: {
              name: filter.name
            }
          });
          locationFilters.push({
            originalOrigin: {
              name: filter.name
            }
          });
          locationFilters.push({
            returnDestination: {
              name: filter.name
            }
          });
          locationFilters.push({
            returnOrigin: {
              name: filter.name
            }
          });
        }
      });

      if (locationFilters.length) {
        $scope.filterParams.push(locationFilters);
      }
    }

    function setReverseLogisticsListener() {
      $scope.$on('reverseLogisticsSearchComplete', function () {
        setValuesOnInstantiation();
      });
    }

    function setSortDescending(sortDesc) {
      $scope.sortDescending = sortDesc;
    }

    function setTicketStatusFilterParams() {
      var ticketStatusFilters = [];

      _.forEach($scope.filters.ticketStatuses, function (filter) {
        if (filter.checked) {
          ticketStatusFilters.push({
            status: filter.name
          });
        }
      });

      if (ticketStatusFilters.length) {
        $scope.filterParams.push(ticketStatusFilters);
      }
    }

    function setTicketTypeFilterParams() {
      var ticketTypeFilters = [];

      _.forEach($scope.filters.ticketTypes, function (filter) {
        if (filter.checked) {
          ticketTypeFilters.push({
            ticketType: filter.name
          });
        }
      });

      if (ticketTypeFilters.length) {
        $scope.filterParams.push(ticketTypeFilters);
      }
    }

    function setValuesOnInstantiation() {
      $scope.hideFilters = false;
      $scope.showNoResultsMessage = !ReverseLogisticsService.getOriginalResults().length > 0;
      $scope.getFilters(ReverseLogisticsService.getOriginalResults());
      $scope.totalTickets = ReverseLogisticsService.getTicketCount();
    }

    function showCollapseButton(propertyName) {
      var displayLimit =  propertyName + 'DisplayLimit';
      if($scope.filters[propertyName]) {
        var filterList = $scope.filters[propertyName];
        return filterList.length <= $scope[displayLimit] && $scope[displayLimit] > 10
      } else {
        return false;
      }
    }

    function toggleCheck(filter) {
      filter.checked = !filter.checked;
    }
  }
  app.controller('reverseLogisticsResultsController', reverseLogisticsResultsController);
})();

(function () {
  'use strict';
  var app = angular.module("NavisphereOnline");

	reverseLogisticsDetailController.$inject = ['customerSettings', 'DocumentManagerService', 'localStorageService', 'notes',  'refNumTypes',
																						'ReverseLogisticsResource', '$scope', '$state', '$stateParams', 'ticketDetail', '$uibModal', 'WindowLocationHref'];
	function reverseLogisticsDetailController(customerSettings, DocumentManagerService, localStorageService, notes,  refNumTypes,
																						ReverseLogisticsResource, $scope, $state, $stateParams, ticketDetail, $uibModal, WindowLocationHref) {
    var stopRoleMap = {
      2094: "originalOriginLocation",
      2096: "originalDestLocation",
      5138: "returnOriginLocation",
      5139: "returnDestLocation"
    };

    $scope.ticket = ticketDetail;
    $scope.processingFee = customerSettings.ProcessingFee;
    $scope.returnCost = $scope.ticket.ItemInformation.EstimatedReturnCost;
    $scope.refNumTypes = refNumTypes;
    $scope.returnMiles = $scope.ticket.ItemInformation.ReturnMiles;
    $scope.bolShipped = $scope.ticket.ItemInformation.TotalBolPieces;
    $scope.bolSigned = $scope.ticket.ItemInformation.TotalPiecesSignedFor;
    $scope.sealNumber = $scope.ticket.ItemInformation.SealNumber;
    $scope.originalOriginLocation = null;
    $scope.originalDestLocation = null;
    $scope.returnOriginLocation = null;
    $scope.returnDestLocation = null;
    $scope.calls = [];
    $scope.notes = notes.reverse();
    $scope.months = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

    $scope.backToResults = backToResults;
    $scope.calculateTotals = calculateTotals;
    $scope.formatDate = formatDate;
    $scope.formatDateTime = formatDateTime;
    $scope.formatPhoneNumber = formatPhoneNumber;
    $scope.getCustomerPickup = getCustomerPickup;
    $scope.getDay = getDay;
    $scope.getEnteredByName = getEnteredByName;
    $scope.getMonth = getMonth;
    $scope.getProcessingFee = getProcessingFee;
    $scope.getProTripNum = getProTripNum;
    $scope.getRAEnteredDate = getRAEnteredDate;
    $scope.getRANumber = getRANumber;
    $scope.getRefNumType = getRefNumType;
    $scope.getReturnCarrier = getReturnCarrier;
    $scope.getSealIntact = getSealIntact;
    $scope.getSealSigned = getSealSigned;
    $scope.getStatus = getStatus;
    $scope.getTicketType = getTicketType;
    $scope.getTime = getTime;
    $scope.getTotalWeight = getTotalWeight;
    $scope.getTotalQty = getTotalQty;
    $scope.getYear = getYear;
    $scope.goToOrderDetail = goToOrderDetail;
    $scope.openDocumentViewer = openDocumentViewer;
    $scope.openNoteModal = openNoteModal;

    setLocationInfo();
    setCallerInfo();

    function backToResults() {
      var results = $stateParams.rLSearchResults;
      $state.go('app.reverseLogisticsSearch', {rLSearchResults: results});
    }

    function calculateTotals(propertyName) {
      var total = 0;
      _.forEach($scope.ticket.ItemInformation.Items, function(item){
        if(item.Active && item.Salvageable) {
          total += item[propertyName];
        }
      });

      return propertyName === "TotalValue" ? total.toFixed(2) : total;
    }

    /**
     * Takes in a 10 digit number and inserts dashes
     * @param phone
     */
    function formatPhoneNumber(phone) {
      return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    }

    function formatDate(date) {
      if(date) {
        return moment(date).format("MM/DD/YYYY");
      }
    }

    function formatDateTime(dateTime) {
      if(dateTime) {
        return moment(dateTime).format("MM/DD/YYYY hh:mm A");
      }
    }

    function getCustomerPickup() {
      return $scope.ticket.Carrier.CustomerPickUp ? "YES" : "NO";
    }

    function getDay(dateTime) {
      if(dateTime) {
        return moment(dateTime).date();
      }
    }

    /**
     * If the entered by name is a CHR employee (6, 7, or 8-letter)
     * display "CHR" instead of the name
     * @param name
     * @returns {*}
     */
    function getEnteredByName(name) {
      var regex = /^[a-zA-Z]+\s+[a-zA-Z]/;
      if (regex.test(name)) {
        return name;
      } else {
        return "CHR"
      }
    }

    function getMonth(dateTime) {
      if(dateTime) {
        var date = moment(dateTime);
        return $scope.months[date.month()];
      }
    }

    function getProcessingFee() {
      var fee = 0;
      _.forEach($scope.ticket.ItemInformation.Items, function(item){
        fee += item.ProcessingFee;
      });

      return fee;
    }

    function getProTripNum() {
      var proTrip = "";
      _.forEach($scope.ticket.ReferenceNumbers, function(refNum) {
        if(refNum.RefNumTypeRdn === 358) {
          proTrip = refNum.Value;
        }
      });

      return proTrip;
    }

    function getRAEnteredDate() {
      return moment($scope.ticket.RaEnteredByDateTime).format("MM/DD/YYYY");
    }

    function getRANumber() {
      var RANum = "";
      _.forEach($scope.ticket.ReferenceNumbers, function (refNum) {
        if (refNum.RefNumTypeRdn === 357) {
          RANum = refNum.Value;
        }
      });

      return RANum;
    }

    function getRefNumType(refNum) {
      var refNumType = _.find($scope.refNumTypes, function(type) {
        return type.Rdn === refNum.RefNumTypeRdn;
      });

      return refNumType.Description;
    }

    function getReturnCarrier() {
      if(!$scope.ticket.ItemInformation.ReturnCarrier) {
        return "";
      } else if($scope.ticket.ItemInformation.ReturnCarrier.Rdn === 5135) {
        return "CHR";
      } else if($scope.ticket.ItemInformation.ReturnCarrier.Rdn === 5136) {
        return "Original";
      } else {
        return "Other"
      }
    }

    function getSealIntact() {
      return $scope.ticket.ItemInformation.SealIntact ? "Intact" : "Not Intact";
    }

    function getSealSigned() {
      return $scope.ticket.ItemInformation.SealSigned ? "Signed" : "Not Signed";
    }

    function getStatus() {
      return $stateParams.ticketStatus;
    }

    function getTicketType() {
      return $stateParams.ticketType;
    }

    function getTime(dateTime) {
      if(dateTime) {
        return moment(dateTime).format("h:mm A");
      }
    }

    function getTotalWeight() {
      var total = 0;
      _.forEach($scope.ticket.ItemInformation.Items, function(item){
        if(item.Salvageable){
          total += (item.ActualWeight * item.Quantity);
        }
      });

      return total;
    }

    function getTotalQty() {
      var total = 0;
      _.forEach($scope.ticket.ItemInformation.Items, function(item){
        total += item.Quantity;
      });

      return total;
    }

    function getYear(dateTime) {
      if(dateTime) {
        return moment(dateTime).year();
      }
    }

    function goToOrderDetail() {
			var redirectUrl =  appConfig.ordersUIBaseUrl + '/#/detail/' + $scope.ticket.CustomerOrderNumber;
			WindowLocationHref.setWindowLocationHref(redirectUrl);
    }

    function openDocumentViewer(ticketId) {
      var controller = 'reverseLogisticsDocumentViewerController';
      var resolveObject = {
        order: function () {
          return null;
        },
        documents: ['DocumentService', function (DocumentService) {
          return DocumentService.getReverseLogisticsDocuments({ticketId: ticketId}).$promise;
        }]
      };

      DocumentManagerService.openDocumentViewer(controller, ticketId, resolveObject);
    }

    function openNoteModal() {
      $uibModal.open({
        templateUrl: 'app/reverseLogistics/views/addNoteModal.tpl.html',
        size: 'md',
        controller: 'addNoteController',
        scope: $scope
      }).result.then(function (data) {
        var ticketId = ticketDetail.TicketId;
        var onlineNote = {
          OnlineNote: {
            TicketId: ticketId,
            CreatedBy: localStorageService.get('User').firstName + " " + localStorageService.get('User').lastName,
            CreateDateTime: moment(),
            Note: data,
            ActionType: "IsNew",
            DisplayInOnline: true
          },
          TicketId: ticketId
        };
        ReverseLogisticsResource.createNote(onlineNote).$promise.then(function (result) {
          $scope.notes.unshift(onlineNote.OnlineNote)
        });
      });
    }

    /**
     * Call information is returned in two different arrays, CallLogs and CallParties.
     * Combine these into one dataset.
     */
    function setCallerInfo() {
      _.forEach($scope.ticket.CallLogs, function (log) {
        var callParty = _.find($scope.ticket.CallParties, function(party) {
          return log.CallPartyId === party.CallPartyId;
        });
        $scope.calls.push({
          name: callParty.Contact.Name,
          phone: callParty.Contact.Phone,
          email: callParty.Contact.Email,
          extension: callParty.Contact.PhoneExtension,
          dateTime: log.CallDateTime,
          comments: log.Comments
        });
      });
    }

    function setLocationInfo() {
      _.forEach($scope.ticket.Locations, function (location) {
        var locationType = stopRoleMap[location.StopRole.Rdn];
        $scope[locationType] = location;
      });
    }
  }

  app.controller('reverseLogisticsDetailController', reverseLogisticsDetailController);
})();

(function () {
  'use strict';
  var app = angular.module("NavisphereOnline");

  addNoteController.$inject = ['$uibModalInstance', '$scope'];
  function addNoteController($uibModalInstance, $scope) {

    $scope.onlineNote = "";

    $scope.close = function() {
      $uibModalInstance.dismiss("closed");
    };

    $scope.add = function() {
      $uibModalInstance.close($scope.onlineNote);
    };


  }
  app.controller('addNoteController', addNoteController);
})();

(function () {
    'use strict';

    function resendInvitationController($scope, $state, InvitationService, invitation) {
        $scope.processing = false;

        if (invitation) {
            $scope.invitation = invitation;
        } else {
            $state.go('login');
        }
        $scope.submit = function () {
            if ($scope.invitation) {
                var invitation = {
                    userId: $scope.invitation.userId,
                    requestedBy: $scope.invitation.requestedBy,
                    message: '',
                    email: $scope.invitation.email
                };
                InvitationService.save(invitation, function () {
                    $state.go('Resend Invitation Complete');
                });
            } else {
                $state.go('login');
            }
        };
    }
    resendInvitationController.$inject = ['$scope', '$state', 'InvitationService', 'invitation'];
    angular.module('NavisphereOnline').controller('resendInvitationController', resendInvitationController);
}());

(function() {
  'use strict';
  function resendInvitationCompleteController() {
  }
  angular.module('NavisphereOnline').controller('resendInvitationCompleteController', resendInvitationCompleteController);
}());



(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  servicePerformanceReportController.$inject = ['$scope', 'DateTimeService', 'ReportingService', 'UserPermissionService', 'moment'];
  function servicePerformanceReportController($scope, DateTimeService, ReportingService, UserPermissionService, moment) {
    $scope.dataComplete = false;

    var customerList = UserPermissionService.getCustomersForRole('Service Performance Report');
    var cCodeList = [];

    var beginDate = moment().startOf('month').format('YYYYMMDD');
    var endDate = moment().endOf('month').format('YYYYMMDD');
    var periodBeginDate = moment().subtract(14, 'month').startOf('month').format('YYYYMMDD');
    $scope.beginDateDisp = DateTimeService.getDisplayDate(moment().startOf('month'));
    $scope.endDateDisp = DateTimeService.getDisplayDate(moment().endOf('month'));

    for(var i = 0; i < customerList.length; i++){
      cCodeList.push(customerList[i].partyCode);
    }

    ReportingService.onTime({
      "beginDate": beginDate,
      "endDate": endDate
    }).$promise.then(function(response) {
      $scope.onTimePicks = response.onTimePickUpPercent;
      $scope.isEmpty = response.isEmpty;
      $scope.onTimeDrops = response.onTimeDeliveryPercent;
      $scope.pickCount = response.pickupCount;
      $scope.pickupFailCount = response.pickupFailCount;
      $scope.deliveryCount = response.deliveryCount;
      $scope.deliveryFailCount = response.deliveryFailCount;

      $scope.noZero = function(value){
        var newValue = 0;
        if(value === 0){
          newValue = .0001;
        }
        else {
          newValue = value;
        }
        return newValue;

      };

      ReportingService.servicePerformance( {
        "beginDate": beginDate,
        "endDate": endDate
      }).$promise.then(function(response) {
        $scope.freightMvmt = {
          avg_elt:response.avgEnteredLeadTime/60,
          avg_pdt:response.avgPickupDwellTime/60,
          avg_tt:response.avgTransitTime/60,
          avg_ddt:response.avgDropDwellTime/60,
          avg_tct:response.avgTotalCycleTime/60};
        ReportingService.onTimePeriod({
          "beginDate": periodBeginDate,
          "endDate": endDate
        }).$promise.then(function(response) {
          $scope.otPeriod = response;

          var sbcp = [];
          var sbcd = [];

          $.each($scope.otPeriod, function( index, value ) {
            sbcp.push({'country':'Pick','year':value.timePeriod,'percent':$scope.noZero(value.onTimePickUpPercent)/100});
            sbcd.push({'country':'Pick','year':value.timePeriod,'percent':$scope.noZero(value.onTimeDeliveryPercent)/100});
          });

          $scope.sbcp = sbcp;
          $scope.sbcd = sbcd;

          $scope.dataComplete = true;
        }, function() {});
      }, function() {});
    }, function() {});
  }

  app.controller('ServicePerformanceReportController', servicePerformanceReportController);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  ordersOverviewReportController.$inject = ['$scope', '$locale', 'ReportingService', 'UserPermissionService', 'moment', 'DateTimeService', 'customerModes', '$filter'];
  function ordersOverviewReportController($scope, $locale, ReportingService, UserPermissionService, moment, DateTimeService, customerModes, $filter) {

    $scope.format = $locale.DATETIME_FORMATS['shortDate'];

    $scope.partyCodeList = UserPermissionService.getCustomersForRole('Orders Overview Report');

    $scope.orderStatusList = [{
      Name: "Booked", Value: "BOOKED"
    }, {
      Name: "Incomplete", Value: "INCOMPLETE"
    }, {
      Name: "In Transit", Value: "INTRANSIT"
    }, {
      Name: "Delivered", Value: "DELIVERED"
    }, {
      Name: "Ordered", Value: "ORDERED"
    }];

    $scope.newArray = [];
    $scope.datetype = {};
    $scope.datetype.name = 'delivery';

    $scope.excelexport = 'exportexcel.png';
    $scope.exportfilename = $filter('translate')('ORDERS_OVERVIEW_REPORT');
    $scope.dataexport = {
      customerOrderNumber: $filter('translate')('ORDER_NUMBER'),
      trackingReferenceNumber: $filter('translate')('TRACKING_NUMBER'),
      partyCodeName: $filter('translate')('ACCOUNT_NAME'),
      primaryReferenceNumber: $filter('translate')('PRIMARY_REFERENCE_NUMBER'),
      orderOriginPickupName: $filter('translate')('ORIGIN_PICKUP_NAME'),
      orderOriginPickupCity: $filter('translate')('ORIGIN_PICKUP_CITY'),
      orderOriginPickupState: $filter('translate')('ORIGIN_PICKUP_STATE'),
      earliestRequestedPickupDate: $filter('translate')('EARLIEST_REQUESTED_PICKUP_DATE'),
      latestRequestedPickupDate: $filter('translate')('LATEST_REQUESTED_PICKUP_DATE'),
      earliestScheduledPickupDate: $filter('translate')('EARLIEST_SCHEDULED_PICKUP_DATE'),
      latestScheduledPickupDate: $filter('translate')('LATEST_SCHEDULED_PICKUP_DATE'),
      actualPickupArrival: $filter('translate')('ACTUAL_PICKUP_ARRIVAL'),
      actualPickupDeparture: $filter('translate')('ACTUAL_PICKUP_DEPARTURE'),
      orderDestinationDeliveryName: $filter('translate')('DESTINATION_DELIVERY_NAME'),
      orderDestinationDeliveryCity: $filter('translate')('DESTINATION_DELIVERY_CITY'),
      orderDestinationDeliveryState: $filter('translate')('DESTINATION_DELIVERY_STATE'),
      earliestRequestedDeliveryDate: $filter('translate')('EARLIEST_REQUESTED_DELIVERY_DATE'),
      latestRequestedDeliveryDate: $filter('translate')('LATEST_REQUESTED_DELIVERY_DATE'),
      earliestScheduledDeliveryDate: $filter('translate')('EARLIEST_SCHEDULED_DELIVERY_DATE'),
      latestScheduledDeliveryDate: $filter('translate')('LATEST_SCHEDULED_DELIVERY_DATE'),
      actualDeliveryArrival: $filter('translate')('ACTUAL_DELIVERY_ARRIVAL'),
      actualDeliveryDeparture: $filter('translate')('ACTUAL_DELIVERY_DEPARTURE'),
      orderStatus: $filter('translate')('ORDER_STATUS'),
      orderMode: $filter('translate')('ORDER_MODE'),
      carrierName: $filter('translate')('CARRIER_NAME'),
      proReferenceNumber: $filter('translate')('PRO_REFERENCE_NUMBER')
    };

    $scope.loader = {

      loading: false

    };

    $scope.dataexportfields = $scope.dataexport;

    $scope.CustomerModesList = customerModes;

    $scope.getCustomerModes = function () {

      $scope.customerList = $scope.getDisplayArray($scope.CustomerModesList, 'partyCode', 'Customer');


      $scope.shippingMethodList = $scope.getDisplayArray($scope.CustomerModesList, 'orderModeValue', 'Mode');
    };

    $scope.checkboxOrderStatusChanged = function () {
      $scope.OSCount = 0;

      angular.forEach($scope.orderStatusList, function (item) {
        if (item.SelectedOS === true) { $scope.OSCount = $scope.OSCount + 1; }
      });

      if ($scope.OSCount === 0) { $scope.showButtonOS = false; }
      else { $scope.showButtonOS = true; }
      $scope.selectAllOS = false;
    };

    $scope.checkAllOrderStatus = function () {

      if ($scope.selectAllOS) {
        $scope.selectAllOS = true;
        $scope.showButtonOS = true;
      } else {
        $scope.selectAllOS = false;
        $scope.showButtonOS = false;
      }

      angular.forEach($scope.orderStatusList, function (item) {
        item.SelectedOS = $scope.selectAllOS;

      });

    };

    $scope.checkboxShippingMethodsChanged = function () {
      $scope.SMCount = 0;

      angular.forEach($scope.shippingMethodList, function (item) {
        if (item.SelectedSM === true) { $scope.SMCount = $scope.SMCount + 1; }
      });

      if ($scope.SMCount === 0) { $scope.showButtonSM = false; }
      else { $scope.showButtonSM = true; }
      $scope.selectAllSM = false;
    };

    $scope.checkAllShippingMethods = function () {

      if ($scope.selectAllSM) {
        $scope.selectAllSM = true;
        $scope.showButtonSM = true;
      } else {
        $scope.selectAllSM = false;
        $scope.showButtonSM = false;
      }

      angular.forEach($scope.shippingMethodList, function (item) {
        item.SelectedSM = $scope.selectAllSM;
      });

    };

    $scope.getReport = function () {

      $('#modalGenerate').modal('show');

      $('#ordersOverviewLaunch').prop('disabled', true);

      $scope.noDataMessage = false;
      $scope.noStatusModeMessage = false;
      $scope.generatingMessage = true;

      $scope.orderStatusArray = [];
      $scope.shippingMethodArray = [];
      $scope.accountsArray = [];
      $scope.dataflatexport = [];

      $scope.createOrderStatusArray($scope.orderStatusList);
      $scope.createShippingMethodArray($scope.shippingMethodList);
      $scope.createAccountsArray($scope.customerList);

      $scope.getShippingMethodSelections($scope.selectAllSM);
      $scope.getOrderStatusSelections($scope.selectAllOS);
      $scope.getAccountsSelections();

      $scope.dateType = ($scope.datetype.name).substr(0, 1);

      $scope.beginDatePass = moment($scope.beginDate).format('YYYYMMDD');

      $scope.endDatePass = moment($scope.endDate).format('YYYYMMDD');

      if (_.has($scope.item, 'SelectedAccounts') && $scope.mode !== '' && $scope.status !== '' && $scope.accounts !== '') {

        ReportingService.historicOrders(
          {
            "partyCodesStr": $scope.accounts,
            "modeStr": $scope.mode,
            "statusStr": $scope.status,
            "beginDate": $scope.beginDatePass,
            "endDate": $scope.endDatePass,
            "dateType": $scope.dateType
          }
        )
          .$promise
          .then(function (response) {

            $scope.dataexportresults = response;
            $('#ordersOverviewLaunch').prop('disabled', false);

            $scope.generatingMessage = false;
            $scope.noDataMessage = false;
            $scope.noStatusModeMessage = false;
            $scope.errorMessage = false;

            $scope.returnDataLogic($scope.dataexportresults);

          })
          .catch(function () {
            $scope.errorMessage = true;
            $('#ordersOverviewLaunch').prop('disabled', false);
            $('#modalGenerate').modal('hide');
          })

      }
      else {

        $('#ordersOverviewLaunch').prop('disabled', false);
        $scope.generatingMessage = false;
        $scope.noDataMessage = false;
        $scope.noStatusModeMessage = true;
        $scope.errorMessage = false;
        $('#modalGenerate').modal('hide');
      }

    };

    $scope.returnDataLogic = function (dataexportresults) {

      $scope.dataLength = dataexportresults.length;
      $scope.displayMessages($scope.dataLength);

      if ($scope.dataLength !== 0) {

        $.each(dataexportresults, function (index, value) {

          $scope.dataflatexport.push({

            'customerOrderNumber': value.customerOrderNumber,
            'trackingReferenceNumber': value.trackingReferenceNumber,
            'partyCodeName': $scope.removeComma(value.partyCodeName),
            'primaryReferenceNumber': $scope.removeComma(value.primaryReferenceNumber),
            'orderOriginPickupName': $scope.removeComma(value.orderOriginPickupName),
            'orderOriginPickupCity': $scope.removeComma(value.orderOriginPickupCity),
            'orderOriginPickupState': $scope.removeComma(value.orderOriginPickupState),
            'earliestRequestedPickupDate': $scope.formatDate(value.earliestRequestedPickupDate),
            'latestRequestedPickupDate': $scope.formatDate(value.latestRequestedPickupDate),
            'earliestScheduledPickupDate': $scope.formatDate(value.earliestScheduledPickupDate),
            'latestScheduledPickupDate': $scope.formatDate(value.latestScheduledPickupDate),
            'actualPickupArrival': $scope.formatDate(value.actualPickupArrival),
            'actualPickupDeparture': $scope.formatDate(value.actualPickupDeparture),
            'orderDestinationDeliveryName': $scope.removeComma(value.orderDestinationDeliveryName),
            'orderDestinationDeliveryCity': $scope.removeComma(value.orderDestinationDeliveryCity),
            'orderDestinationDeliveryState': $scope.removeComma(value.orderDestinationDeliveryState),
            'earliestRequestedDeliveryDate': $scope.formatDate(value.earliestRequestedDeliveryDate),
            'latestRequestedDeliveryDate': $scope.formatDate(value.latestRequestedDeliveryDate),
            'earliestScheduledDeliveryDate': $scope.formatDate(value.earliestScheduledDeliveryDate),
            'latestScheduledDeliveryDate': $scope.formatDate(value.latestScheduledDeliveryDate),
            'actualDeliveryArrival': $scope.formatDate(value.actualDeliveryArrival),
            'actualDeliveryDeparture': $scope.formatDate(value.actualDeliveryDeparture),
            'orderStatus': $filter('translate')(value.orderStatus),
            'orderMode': $filter('translate')(value.orderMode),
            'carrierName': $scope.removeComma(value.carrierName),
            'proReferenceNumber': $scope.removeComma(value.proReferenceNumber)

          });
        });
        $('#modalGenerate').modal('hide');
        $scope.exportCompleteExcelFile();
      }
    };

    $scope.exportCompleteExcelFile = function () {

      angular.element("#historicalordersexport").triggerHandler('click');
      $scope.generatingMessage = false;

    };

    $scope.displayMessages = function (dataLength) {

      if (dataLength === 0) {
        $scope.generatingMessage = false;
        $scope.noDataMessage = true;
        $scope.errorMessage = false;
        $('#modalGenerate').modal('hide');
      }
      else {
        $scope.noDataMessage = false;
      }

    };

    $scope.getAccountsSelections = function (selectAllAccounts) {

      if (selectAllAccounts === true) {
        $scope.accounts = "ALL"
      } else {
        $scope.accounts = $scope.accountsArray.join()
      }

      return $scope.accounts;
    };

    $scope.getOrderStatusSelections = function (selectAllOS) {

      if (selectAllOS === true) {
        $scope.status = "ALL"
      } else {
        $scope.status = $scope.orderStatusArray.join()
      }

      return $scope.status;
    };

    $scope.getShippingMethodSelections = function (selectAllSM) {

      if (selectAllSM === true) {
        $scope.mode = "ALL"
      } else {
        $scope.mode = $scope.shippingMethodArray.join()
      }
      return $scope.mode;
    };

    $scope.createOrderStatusArray = function () {
      $scope.orderStatusArray = [];

      angular.forEach($scope.orderStatusList, function (item) {

        if (!!item.SelectedOS && $scope.orderStatusArray.indexOf(item) === -1) {
          $scope.orderStatusArray.push(item.Value);
        }
      });

      return $scope.orderStatusArray;

    };

    $scope.createShippingMethodArray = function () {

      $scope.shippingMethodArray = [];

      angular.forEach($scope.shippingMethodList, function (item) {
        if (!!item.SelectedSM && $scope.shippingMethodArray.indexOf(item) === -1) {
          $scope.shippingMethodArray.push(item.Value);
        }
      });

      return $scope.shippingMethodArray;

    };

    $scope.createAccountsArray = function () {
      $scope.accountsArray = [];

      if (!$scope.item) {
        return;
      }

      if ($scope.item.SelectedAccounts[0] === 'ALL') {

        angular.forEach($scope.customerList, function (item) {
          if ($scope.customerList.indexOf(item) !== 0) {
            $scope.accountsArray.push(item.Value);
          }
        });
      }
      else {

        for (var i = 0; i < $scope.item.SelectedAccounts.length; i++) {
          $scope.accountsArray.push($scope.item.SelectedAccounts[i]);
        }
      }

      return $scope.accountsArray;
    };

    //DisplayArray Creation
    $scope.getDisplayArray = function (originalArray, dupCheckOn, arrayType) {

      $scope.originalArray = $scope.removeDuplicates(originalArray, dupCheckOn);

      $scope.col = 0;
      $scope.counter = 1;
      $scope.newArray = [];

      if (arrayType === 'Customer') {
        $scope.newArray.push({ Text: $filter('translate')('ALL'), Value: 'ALL' });

        angular.forEach($scope.originalArray, function (item) {

          $scope.counter = $scope.counter + 1;
          if (item.partyCode !== undefined) {
            $scope.newArray.push({ Text: item.partyName, Value: item.partyCode });
          }
        });
      }
      else {
        angular.forEach($scope.originalArray, function (item) {

          $scope.col = $scope.columnCounter($scope.counter, $scope.col);

          $scope.counter = $scope.counter + 1;
          if (item.orderModeValue !== undefined) {
            $scope.newArray.push({ Text: item.orderModeText, Value: item.orderModeValue, col: $scope.col });
          }
        });
      }

      return $scope.newArray;

    };

    $scope.removeDuplicates = function (originalArray, prop) {
      $scope.cleanArray = [];
      $scope.lookupObject = {};

      for ($scope.i in originalArray) {
        $scope.lookupObject[originalArray[$scope.i][prop]] = originalArray[$scope.i];
      }

      for ($scope.i in $scope.lookupObject) {
        $scope.cleanArray.push($scope.lookupObject[$scope.i]);
      }
      return $scope.cleanArray;
    };

    $scope.columnCounter = function (counter, cols) {

      if (counter % 4 === 0) {
        cols = cols + 1;
      }

      return cols;
    };

    //Formatting
    $scope.formatDate = function (date) {
      var strdate = String(date);

      var year = strdate.substr(0, 4);
      var month = strdate.substr(4, 2);
      var day = strdate.substr(6, 2);

      var datef = month + '/' + day + '/' + year;

      if (strdate === "0") {
        datef = ""
      }

      return datef
    };

    $scope.removeComma = function (value) {
      var valuef;
      valuef = value.replace(/,/g, "");

      return valuef

    };

    //Date Picker Setup
    var maxDate = new Date();

    maxDate.setDate(maxDate.getDate() + 365);

    $scope.minDate = "01-01-2015";
    $scope.maxDate = maxDate;

    $scope.openBegin = function ($event) {

      $event.preventDefault();
      $event.stopPropagation();

      $scope.openedBegin = true;
    };

    $scope.openEnd = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.openedEnd = true;
    };

    $scope.beginDateOptions = {
      showWeeks: false
    };

    $scope.endDateOptions = {
      showWeeks: false
    };


    $scope.init = function () {

      $scope.getCustomerModes();

    };
  }

  app.controller('OrdersOverviewReportController', ordersOverviewReportController);
})();

(function () {
  'use strict';

  var app = angular.module('NavisphereOnline');
  function ExcelReportExporterService() {

    function exportReportExcel(exportData, reportTitle) {

      var jsonObject = JSON.stringify(exportData);

      var csv = convertToCSV(jsonObject);

      var exportedFileName = reportTitle ? reportTitle + '.csv' : 'export.csv';

      var blob = new Blob([csv], { type: 'text/csv;charset=utf-16;' });

      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFileName);
      }
      else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
        }
        return "success";
      }
    }

    function convertToCSV(jsonObject) {

      var array = typeof jsonObject !== 'object' ? JSON.parse(jsonObject) : jsonObject;
      var str = '';

      for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
          if (line !== '') line += ',';

          line += array[i][index];
        }

        str += line + '\r\n';
      }
      return str;
    }

    return {
      exportReportExcel: exportReportExcel,
      convertToCSV: convertToCSV
    };

  }
  app.factory('ExcelReportExporterService', ExcelReportExporterService);
})();

(function() {
  "use strict";

  angular.module("NavisphereOnline").directive("quoteHistoryCard",
            ["$state", "DateTimeService", "GAQAccessorialService", "GAQService", "QuoteHistoryService", "QuoteHistoryTransformService", "QuoteService",
    function($state, DateTimeService, GAQAccessorialService, GAQService, QuoteHistoryService, QuoteHistoryTransformService, QuoteService) {
    return {
      templateUrl: "app/quoteHistory/views/quoteHistoryCard.tpl.html",
      scope: {
        card: "=card",
        customers: "=customers",
        isMetric: "=isMetric",
        itemDdlRefData: "=itemDdlRefData",
        user: "=user",
        quoteId: "=quoteId"
      },
      link: function(scope) {
        scope.getDisplayDate = getDisplayDate;
        scope.reQuote = reQuote;
        scope.viewResults = viewResults;

        function getDisplayDate(date) {
          var stillUtc = moment.utc(date).toDate();
          var localdt = moment.utc(stillUtc).local().toISOString();
          return DateTimeService.getDisplayDate(localdt);
        }

        function prepForStateChange(quoteRequestId, isShippable, quoteId, callback) {
          QuoteService.getQuoteDetails({ quoteRequestId: quoteRequestId, quoteId: quoteId }).$promise.then(function(result) {
            return QuoteHistoryTransformService.transform(result, scope.customers, scope.itemDdlRefData);
          }).then(function(transformedQuote) {
            return QuoteHistoryService.buildParams(transformedQuote, quoteRequestId, scope.isMetric, isShippable);
          }).then(callback);
        }

        function viewResults(quoteRequestId, isShippable) {
          prepForStateChange(quoteRequestId, isShippable, scope.quoteId, viewResultsCallback);
        }

        function reQuote(quoteRequestId) {
          prepForStateChange(quoteRequestId, null, null, reQuoteCallback);
        }

        function viewResultsCallback(params) {
          $state.go("app.getAQuoteResults", params);
        }

        function reQuoteCallback(params) {
          var order = GAQService.setInitialOrderState();

          _.merge(order, params.rawQuoteParams);

          //We cannot requote TL quote requests after 2 pm eastern
          if (getRequestType(params.quoteResults) !==  "LTL" && isAfterTwoPMETLQuoteRequest(order.pickupDate)) {
            reRouteQuoteRequestScreen(order);
            return;
          }

          order.isTeam = isTeamRequest(params.quoteResults);

          GAQService.getQuote(order, scope.user, scope.isMetric, "quoteHistory", getRequestType(params.quoteResults));
        }

        function getRequestType(quotes) {
          var truckloadQuotes = 0;
          var flatbedQuotes = 0;
          var ltlQuotes = 0;
          var requestType = "";

          _.forEach(quotes, function(quote) {
            if(quote.transportModeType === 12) {
              flatbedQuotes++;
            } else if(quote.transportModeType === 2) {
              truckloadQuotes++;
            } else {
              ltlQuotes++;
            }
          });

          if (truckloadQuotes > 0 && flatbedQuotes === 0 && ltlQuotes === 0) {
            requestType = "Truckload";
          } else if (truckloadQuotes === 0 && flatbedQuotes > 0 && ltlQuotes === 0) {
            requestType = "Flatbed";
          } else {
            requestType = "LTL";
          }
          return requestType;
        }

        function isTeamRequest(quotes) {
          var isTeam = false;
          _.forEach(quotes, function(quote) {
            if (quote.specialServiceList) {
              _.forEach(quote.specialServiceList, function(service) {
                //EXD check for expedite/team rate
                if (service === "EXD") {
                  isTeam = true;
                }
              });
            }
          });
          return isTeam;
        }

        function isAfterTwoPMETLQuoteRequest(pickupDate) {
          var todayDate = DateTimeService.getToday();
          return !!(pickupDate.getDate() === todayDate.getDate() && DateTimeService.isLocalTimePastTwoPMEastern(pickupDate));
        }

        function reRouteQuoteRequestScreen(order) {
          $state.go("app.getAQuote", {
            noQuotesFound: true,
            rawQuoteParams: order
          });
        }
      }
    }
  }]);
})();

(function() {
  "use strict";

  QuoteHistoryTransformService.$inject = ["$q", "BolCommentService", "GAQAccessorialService", "LocationSelectionHelperService", "LocationService"];

  function QuoteHistoryTransformService($q, BolCommentService, GAQAccessorialService, LocationSelectionHelperService, LocationService) {
    this.transform = transform;

    function constructFilterParams(location) {
      var filterParams = {};

      if (location.address.city) {
        filterParams.name = location.address.city;
      }

      if (location.address.stateProvince) {
        filterParams.adminDistrictCode = location.address.stateProvince;
      }

      if (location.address.country) {
        filterParams.countryCode = location.address.country;
      }

      return filterParams;
    }

    function determineLocationRefinementMethod(location) {
      if (location.locationCode) {
        return {
          method: LocationService.getLocation,
          params: {
            locationPartyNumberOrCode: location.locationCode
          }
        }
      } else {
        return {
          isZip: true,
          method: LocationService.getCities,
          params: {
            zipCode: location.address.postalCode
          }
        }
      }
    }

    function getSpecificLocation(data, location) {
      if (data && data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          data[i].name = data[i].name.toUpperCase();
        }
      }
      var filterParams = constructFilterParams(location);
      var resultSet = _.filter(data, filterParams)[0];
      resultSet.specialRequirementCodes = location.specialRequirementCodes;
      return resultSet;
    }

    function handleRateDescription(quotes) {
      _.forEach(quotes, function(quote) {
        _.forEach(quote.rateList, function(rate) {
          if (rate.rateCodeValue) {
            rate.rateDescription = rate.rateCodeValue;
          }
        });
      });

      return quotes;
    }

    function hydrateCustomer(cust, customers) {
      //if unable to hydrate, some downstream processes rely on partyCode 
      cust.partyCode = cust.customerCode;

      _.forEach(customers, function(customer) {
        if (cust.customerCode && customer.partyCode && 
            cust.customerCode.toUpperCase() === customer.partyCode.toUpperCase()) {
          cust = customer;
          BolCommentService.get(cust);
        }
      });

      return cust;
    }

    function hydrateItems(quote, itemDdlRefData) {
      _.forEach(quote.itemList, function(item) {
        item.commodityName = item.productName;
        item.weight = item.actualWeight;
        prefillComplexFields(item, itemDdlRefData);
        hydrateItemSearch(item, quote);
      });
    }

    function hydrateItemSearch(item, quote) {
      return BolCommentService.getSearchItem(item, quote.customer).then(function () {
        return item;
      });
    }

    function prefillComplexFields(item, itemDdlRefData) {
      prefillPackaging(item, itemDdlRefData);
      prefillTemperature(item, itemDdlRefData);
      prefillFreightClass(item, itemDdlRefData);
    }

    function prefillPackaging(item, itemDdlRefData) {
      if (item.packagingCode) {
        item.packaging = _.filter(itemDdlRefData.Packaging, { refDataCode: item.packagingCode })[0];
      }
    }

    function prefillTemperature(item, itemDdlRefData) {
      if (item.temperatureSensitiveCode) {
        item.tempCategory = _.filter(itemDdlRefData.TemperatureSensitive, { refDataCode: item.temperatureSensitiveCode})[0];
      }
    }

    function prefillFreightClass(item, itemDdlRefData) {
      if (item.freightClass) {
        item.freightClass = _.filter(itemDdlRefData.FreightClass, { refDataCode: item.freightClass.toString()})[0];
      }
    }

    function hydrateLocation(quote) {
      var capCities = determineAddressCityName(quote);
      var destCity = capCities[0];
      var originCity = capCities[1];
      var destinationRefinement = determineLocationRefinementMethod(quote.destination);
      var originRefinement = determineLocationRefinementMethod(quote.origin);

      return $q.all([
        destinationRefinement.method(destinationRefinement.params).$promise,
        originRefinement.method(originRefinement.params).$promise
      ]).then(function(result) {
        if (destinationRefinement.isZip) {
          quote.destination = getSpecificLocation(result[0], quote.destination);
          quote.destination = LocationSelectionHelperService.restructureLocation(quote.destination);
        }

        if (originRefinement.isZip) {
          quote.origin = getSpecificLocation(result[1], quote.origin);
          quote.origin = LocationSelectionHelperService.restructureLocation(quote.origin);
        }

        if (quote.destination.address){
          quote.destination.address.city = destCity;
          quote.destination.name = destCity;
        }

        if (quote.origin.address){
          quote.origin.address.city = originCity;
          quote.origin.name = originCity;
        }
        return quote;
      });
    }

    function determineAddressCityName(quote) {
      var destCity;
      var originCity;
      var capCities = new Array();
      if (quote != null && quote != undefined) {
        if (quote.destination != null && quote.destination != undefined) {
          if (quote.destination.address && quote.destination.address.city) {
            destCity = quote.destination.address.city;
            quote.destination.address.city = quote.destination.address.city.toUpperCase();
          }
        }
        if (quote.origin != null && quote.origin != undefined) {
          if (quote.origin.address && quote.origin.address.city) {
            originCity = quote.origin.address.city;
            quote.origin.address.city = quote.origin.address.city.toUpperCase();
          }
        }
      }
      capCities = [ destCity, originCity ];
      return capCities;
    }

    function hydrateQuoteCharges(quoteDetails) {
      var resultQuotes = [];

      _.forEach(quoteDetails, function(quoteDetail) {
        quoteDetail.totalCharge = quoteDetail.total;
        quoteDetail.totalAccessorialCharge = quoteDetail.totalAccessorial;

        resultQuotes.push(quoteDetail);
      });

      return resultQuotes;
    }

    /**
     * Preps data for use in Get A Quote, Get a Quote Results, and Quote to Order.
     *
     * @param quoteHistoryQuote A single quote history result.
     */
    function transform(quoteHistoryQuote, customers, itemDdlRefData) {
      return hydrateLocation(quoteHistoryQuote).then(function(quote) {
        quote.quoteDetailList = hydrateQuoteCharges(quote.quoteDetailList);
        quote.customer = hydrateCustomer(quote.customer, customers);
        hydrateItems(quote, itemDdlRefData);
        quote.quoteDetailList = handleRateDescription(quote.quoteDetailList);
        quote.originAccessorials = GAQAccessorialService.getOriginAccessorialsWithSelections(quote.origin.specialRequirementCodes);
        quote.destinationAccessorials = GAQAccessorialService.getDestinationAccessorialsWithSelections(quote.destination.specialRequirementCodes);
        quote.overallAccessorials = GAQAccessorialService.getOverallAccessorialsWithSelections(quote.accessorialList);
        quote.isTruckload = (quoteHistoryQuote.transportModeList.length === 1);
        return quote;
      });
    }
  }

  angular.module("NavisphereOnline").service("QuoteHistoryTransformService", QuoteHistoryTransformService);
})();

(function() {
  "use strict";

  QuoteHistoryService.$inject = ["QuoteService"];

  function QuoteHistoryService(QuoteService) {
    this.buildParams = buildParams;
    this.constructQuoteHistoryRequest = constructQuoteHistoryRequest;

    function buildParams(quote, quoteRequestId, isMetric, isShippable) {
      return isTransactional(quote.customer.partyCode).then(function(isTransactional) {
        return {
          rawQuoteParams: {
            customer: quote.customer,
            deliver: quote.destination,
            destinationAccessorials: quote.destinationAccessorials,
            isTransactional: isTransactional,
            items: quote.itemList,
            originAccessorials: quote.originAccessorials,
            overallAccessorials: quote.overallAccessorials,
            pickup: quote.origin,
            isTruckload: quote.isTruckload
          },
          quoteRequestId: quoteRequestId,
          quoteResults: quote.quoteDetailList,
          getAQuoteParams: {
            customer: quote.customer,
            destination: quote.destination,
            origin: quote.origin,
            items: quote.itemList,
            shipDate: quote.shipDate,
            useMetric: isMetric,
            actualWeight: getTotalWeight(quote.itemList),

            // TODO This may cause issues with QTO if the naming conventions are different (they are);
            // TODO This may not actually be an issue. Leaving this note in until Quote History goes through QA.
            accessorials: quote.accessorialList
          },
          isShippable: isShippable
        }
      });
    }

    function constructQuoteHistoryRequest() {
      return {
        customerCodeList: [],
        destination: {
          address: {
            city: "",
            stateProvinceCode: "",
            postalCode: "",
            countryCode: "",
            countyRegion: ""
          }
        },
        origin: {
          address: {
            city: "",
            stateProvinceCode: "",
            postalCode: "",
            countryCode: "",
            countyRegion: ""
          }
        },
        userName: "",
        pageSize: 10,
        page: 1,
        quoteId: null,
        quotedStartDate: moment().subtract(90, "days").startOf("day"),
        quotedEndDate: "",
        quoteStatusList: [],
        shipStartDate: "",
        shipEndDate: "",
        sourceSystemList: [
          "Online",
          "ExternalRating"
        ]
      };
    }

    function getTotalWeight(items) {
      var total = 0;

      _.forEach(items, function(item) {
        total += item.weight;
      });

      return total;
    }

    function isTransactional(customerCode) {
      return QuoteService.getTransactionalPricingFlag({ customerCode: customerCode }).$promise.then(function(result) {
        return !result.isTransactional;
      });
    }
  }

  angular.module("NavisphereOnline").service("QuoteHistoryService", QuoteHistoryService);
})();

(function() {
  "use strict";

  QuoteHistoryController.$inject = ["$scope", "customers", "quoteHistory", "QuoteHistoryService", "QuoteService", "refDataDDLs", "user", "userPreferences"];

  function QuoteHistoryController($scope, customers, quoteHistory, QuoteHistoryService, QuoteService, refDataDDLs, user, userPreferences) {
    $scope.customerDisplayLimit = 5;
    $scope.customers = customers;
    $scope.currentPage = 1;
    $scope.dateFilters = [
      {
        isVisible: true,
        name: "TODAY"
      }, {
        isVisible: true,
        name: "NEXT_SEVEN_DAYS"
      }, {
        isVisible: true,
        name: "NEXT_THIRTY_DAYS"
      }, {
        isVisible: true,
        name: "CUSTOM_DATE_RANGE"
      }
    ];
    $scope.isMetric = userPreferences.unitOfMeasure === 'metric';
    $scope.itemDdlRefData = refDataDDLs;
    $scope.pageLimit = 10;
    $scope.quoteHistory = quoteHistory.quoteHistorySummaryList;
    $scope.search = {
      quoteId: null,
      canViewAnyone: false
    };
    $scope.shouldHideSeeMore = false;
    $scope.statusFilters = [
      {
        code: 1,
        status: "Active",
        checked: false,
        isShippable: true,
        tagColor: "tag-orange"
      }, {
        code: 2,
        status: "Expired",
        checked: false,
        isShippable: false,
        tagColor: "tag-blue"
      }, {
        code: 3,
        status: "Ordered",
        checked: false,
        isShippable: false,
        tagColor: "tag-grey"
      }
    ];
    $scope.totalQuotes = quoteHistory.total;
    $scope.user = user;
    $scope.expandFilter = expandFilter;
    $scope.refreshResults = refreshResults;
    $scope.toggleCustomer = toggleCustomer;
    $scope.toggleStatusFilter = toggleStatusFilter;

    translateStatus($scope.quoteHistory);


    function expandFilter(filterType) {
      $scope[filterType + "DisplayLimit"] += 5;
    }

    function handleCustomer(request) {
      $scope.shouldHideSeeMore = false;

      _.forEach($scope.customers, function(customer) {
        if (customer.checked) {
          $scope.shouldHideSeeMore = true;
          request.customerCodeList.push(customer.partyCode);
        }
      });
    }

    function handleQuoteIdSearch(request) {
      if ($scope.search.quoteId) {
        request.quoteId = Number($scope.search.quoteId);
      }
    }

    function handleCanViewAnyone(request) {
      if (!$scope.search.canViewAnyone) {
        request.userName = $scope.user.name;
      }
    }

    function handlePagination(request) {
        request.page = $scope.currentPage;
        request.pageSize = $scope.pageLimit;
    }

    function handleStatuses(request) {
      _.forEach($scope.statusFilters, function(statusFilter) {
        if (statusFilter.checked) {
          request.quoteStatusList.push(statusFilter.status);
        }
      })
    }

    function refreshResults() {
      var request = QuoteHistoryService.constructQuoteHistoryRequest();

      handleCustomer(request);
      handleQuoteIdSearch(request);
      handlePagination(request);
      handleStatuses(request);
      handleCanViewAnyone(request);

      QuoteService.getQuoteHistory(request).$promise.then(function(data) {
        $scope.quoteHistory = data.quoteHistorySummaryList;
        translateStatus($scope.quoteHistory);
        $scope.totalQuotes = data.total;
      });
    }

    function toggleCustomer(cust) {
      cust.checked = !cust.checked;

      _.forEach($scope.customers, function(customer) {
        if (_.isEqual(customer, cust)) {
          customer.isVisible = true;
        } else {
          customer.isVisible = !cust.checked;
        }
      });

      refreshResults();
    }

    function toggleStatusFilter(filter) {
      filter.checked = !filter.checked;

      refreshResults();
    }

    function translateStatus(quotes) {
      _.forEach(quotes, function(quote) {
        _.forEach($scope.statusFilters, function(status) {
          if (quote.quoteStatus === status.code) {
            quote.quoteStatus = status;
          }
        });
      });
    }
  }

  angular.module("NavisphereOnline").controller("QuoteHistoryController", QuoteHistoryController);
})();

(function () {
    'use strict';
    drawItemService.$inject = ['DateTimeService'];
    function drawItemService(DateTimeService) {
        var order = {};
        var aggs = {};
        this.init = function() {
            order = {
                customer: undefined,
                createdViaPurchaseOrder: true,
                pickup: null,
                delivery: null,
                destination: null,
                serviceOffering: {
                    description: "LTL Transportation",
                    displayKey: "LTL",
                    id: 1484,
                    modeDescription: "Truck",
                    modeId: 14,
                    serviceTypeDescription: "Dry",
                    serviceTypeId: 9
                },
                customerNumber: null,
                billToNumber: null,
                shipWithNumber: null,
                items: [],
                newRefNums: [],
                stepOneValid:false,
                stepTwoValid:false
            };
            aggs = {};
        };

        function calculateDates(){
          if (order.pickup) {
            var po = _.minBy(order.items, function (item) { return item.requestedPickupStartDate; });
            if (po && moment().isSameOrBefore(moment(po.requestedPickupStartDate), 'day')) {
              order.pickup.earliestDate = DateTimeService.getRawDateTime(po.requestedPickupStartDate);
              order.pickup.latestDate = DateTimeService.getRawDateTime(po.requestedPickupStartDate);
            }
          }

          if (order.delivery) {
            var po = _.maxBy(order.items, function (item) { return item.requestedDeliveryStartDate; });
            if (po && moment().isSameOrBefore(moment(po.requestedPickupStartDate), 'day')) {
              order.delivery.earliestDate = DateTimeService.getRawDateTime(po.requestedDeliveryStartDate);
              order.delivery.latestDate = DateTimeService.getRawDateTime(po.requestedDeliveryStartDate);
            }
          }
        }

        function calculateTotals() {
            aggs.quantity = _.sumBy(order.items, function (item) { return item.quantity; });
            aggs.weight = _.sumBy(order.items, function (item) { return item.weight; });
            aggs.itemCount = order.items.length;
        }
        this.add = function (item) {
            if (item.quantity > 0) {
                var itemUpdate = _.find(order.items, ['purchaseOrderItemId', item.purchaseOrderItemId]);
                if (itemUpdate) {
                    itemUpdate.quantity = item.quantity;
                } else {
                    order.items.push(item);
                }
                calculateTotals();
                calculateDates();
            }
        };
        this.remove = function (item) {
            _.remove(order.items, { purchaseOrderItemId: item.purchaseOrderItemId });
            calculateTotals();
            calculateDates();
        };
        this.getItems = function () {
            return order.items;
        };
        this.getOrder = function () {
            return order;
        };
        this.calculateTotals = calculateTotals;
        this.calculateDates = calculateDates;
        this.getTotals = function () {
            return aggs;
        };
        this.setCustomer = function (customer) {
            order.customer = customer;
        };
        this.clear = function () {
            aggs = null;
            order = null;
        };

    }
    angular.module('NavisphereOnline').service('DrawItemService', drawItemService);
})();

(function () {
  'use strict';
  drawSearchController.$inject = ['$scope', '$locale', '$filter', '$state', 'DateTimeService', '$uibModal', 'User', 'AddressService',
    'CustomerService', 'DrawItemService', 'LocationService', 'PurchaseOrderService','RefDataMappingService', 'API_BASE_URL'];
  function drawSearchController($scope, $locale, $filter, $state, DateTimeService, $uibModal, User, AddressService,
    CustomerService, DrawItemService, LocationService, PurchaseOrderService,RefDataMappingService, API_BASE_URL) {
    var PICK = 'pick';
    var DELIVERY = 'delivery';
    $scope.dropDownCustomer = {};
    User.getPoDrawCustomers().$promise.then(function (result) {
      for (var i = 0; i < result.customers.length; i++) {
        var cust = result.customers[i];
        cust.addressLine1 = AddressService.GetAddressLine1(cust.address);
        cust.addressLine2 = AddressService.GetAddressLine2(cust.address);
        cust.addressLine3 = AddressService.GetAddressLine3(cust.address);
        cust.addressLine4 = AddressService.GetAddressLine4(cust.address);
        cust.displayName = CustomerService.GetDisplayName(cust);
      }
      $scope.poCustomers = result.customers;
      if($scope.poCustomers.length === 1){
        $scope.dropDownCustomer.selected = $scope.poCustomers[0];
        $scope.onSelectedDropDownCustomerChange($scope.poCustomers[0]);
      }
    });

    RefDataMappingService.getRefDataCategoryDDLs().then(function(result){
      $scope.refDataDDLs = result;
    });
    $scope.dateOptions ={
      showWeeks: false
    };
    var defCountry = { code: 'US', name: $filter('translate')('UNITED_STATES') };
    $scope.countries = [defCountry, { code: 'CA', name: $filter('translate')('CANADA')}, { code: 'MX', name: $filter('translate')('MEXICO')}];
    $scope.countryStates = {};
    for (var i = 0; i < $scope.countries.length; i++) {
      LocationService.getStates({
        countryCode: $scope.countries[i].code
      }).$promise.then(function (result) {
        $scope.countryStates[result[0].countryCode] = result;
      });
    }

    $scope.searchParams = { destinationCountry: defCountry.code, searchByDate: DELIVERY };
    $scope.currentParams = {};
    $scope.searchResults = [];
    $scope.pagingInfo = {
      limit: '50',
      page: 1,
      sortBy: '0',
      sortDescending: '0',
      totalItems: 0
    };
    $scope.sortSelect = "0-0";
    $scope.onSelectedDropDownCustomerChange = function(selected){
      $scope.searchResults = [];
      $scope.customer = selected;
      DrawItemService.init();
      DrawItemService.setCustomer(selected);
      $scope.itemCount = undefined;
      $scope.searchParams.customerCode = selected.partyCode;
    };
    $scope.format = $locale.DATETIME_FORMATS['shortDate'];
    $scope.getDisplayDate = function(dateTime){
      return DateTimeService.getDisplayDateOrTime(dateTime, $scope.$parent.userPreference);
    };
    $scope.toggleSearchByDate = function(){
      if($scope.searchParams.searchByDate === PICK){
        $scope.searchParams.requestedDeliveryStartDate = undefined;
        $scope.searchParams.requestedDeliveryEndDate = undefined;
        $scope.searchParams.requestedPickupStartDate = $scope.startDateSelection;
        $scope.searchParams.requestedPickupEndDate = $scope.endDateSelection;
      } else if ($scope.searchParams.searchByDate === DELIVERY){
        $scope.searchParams.requestedDeliveryStartDate = $scope.startDateSelection;
        $scope.searchParams.requestedDeliveryEndDate = $scope.endDateSelection;
        $scope.searchParams.requestedPickupStartDate = undefined;
        $scope.searchParams.requestedPickupEndDate = undefined;
      }
    };
    $scope.clear = function(){
      if($scope.poCustomers.length > 1){
        $scope.customer = undefined;
        $scope.searchParams.customerCode = undefined;
        $scope.dropDownCustomer.selected = undefined;
        DrawItemService.setCustomer(undefined);
      }
      $scope.searchParams.requestedDeliveryStartDate = undefined;
      $scope.searchParams.requestedDeliveryEndDate = undefined;
      $scope.searchParams.requestedPickupStartDate = undefined;
      $scope.searchParams.requestedPickupEndDate = undefined;
      $scope.startDateSelection = undefined;
      $scope.endDateSelection = undefined;
      $scope.searchParams.purchaseOrderNumber = undefined;
      $scope.searchParams.destinationCountry = undefined;
      $scope.searchParams.customerItemId = undefined;
      $scope.searchParams.destinationCity = undefined;
      $scope.searchParams.destinationStateProvince = undefined;
    };
    $scope.$watch('startDateSelection', function(value){
      if($scope.searchParams.searchByDate === PICK){
        $scope.searchParams.requestedPickupStartDate = value;
      } else if ($scope.searchParams.searchByDate === DELIVERY){
        $scope.searchParams.requestedDeliveryStartDate = value;
      }
    });
    $scope.$watch('endDateSelection', function(value){
      if($scope.searchParams.searchByDate === PICK){
        $scope.searchParams.requestedPickupEndDate = value;
      } else if ($scope.searchParams.searchByDate === DELIVERY){
        $scope.searchParams.requestedDeliveryEndDate = value;
      }
    });
    $scope.startDate = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.startDateOpened = true;
      $scope.endDateOpened = false;
    };
    $scope.endDate = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.endDateOpened = true;
      $scope.startDateOpened = false;
    };
    $scope.countryDropChanged = function () {
      $scope.searchParams.destinationStateProvince = undefined;
    };
    $scope.search = function(searchParams, pagingInfo) {
      searchParams.page = pagingInfo.page;
      searchParams.limit = pagingInfo.limit;
      searchParams.orderBy = pagingInfo.sortBy;
      searchParams.orderByDirection = pagingInfo.sortDescending;
      setDateDefaults(searchParams);
      PurchaseOrderService.availableItems(searchParams).$promise.then(function(result){
        $scope.currentParams = searchParams;
        $scope.currentParams.isDefined = true;
        $scope.pagingInfo.totalItems = result.total;
        $scope.searchResults = result.purchaseOrderItems;
        $scope.hasNoResults = (result.purchaseOrderItems.length < 1);
      });
    };
    function setDateDefaults(searchParams){
      if($scope.searchParams.searchByDate === PICK){
        if(angular.isDefined(searchParams.requestedPickupStartDate) && !angular.isDefined(searchParams.requestedPickupEndDate)){
          //default requestedPickupEndDate to +90 days
          searchParams.requestedPickupEndDate = DateTimeService.getDateAddDays(90, searchParams.requestedPickupStartDate);
          $scope.endDateSelection = searchParams.requestedPickupEndDate;
        }
        if(angular.isDefined(searchParams.requestedPickupEndDate) && !angular.isDefined(searchParams.requestedPickupStartDate)){
          //default requestedPickupStartDate to -90 days
          searchParams.requestedPickupStartDate = DateTimeService.getDateAddDays(-90, searchParams.requestedPickupEndDate);
          $scope.startDateSelection = searchParams.requestedPickupStartDate;
        }
      } else if ($scope.searchParams.searchByDate === DELIVERY){
        if(angular.isDefined(searchParams.requestedDeliveryStartDate) && !angular.isDefined(searchParams.requestedDeliveryEndDate)){
          //default requestedDeliveryEndDate to +90 days
          searchParams.requestedDeliveryEndDate = DateTimeService.getDateAddDays(90, searchParams.requestedDeliveryStartDate);
          $scope.endDateSelection = searchParams.requestedDeliveryEndDate;
        }
        if(angular.isDefined(searchParams.requestedDeliveryEndDate) && !angular.isDefined(searchParams.requestedDeliveryStartDate)){
          //default requestedDeliveryStartDate to -90 days
          searchParams.requestedDeliveryStartDate = DateTimeService.getDateAddDays(-90, searchParams.requestedDeliveryEndDate);
          $scope.startDateSelection = searchParams.requestedDeliveryStartDate;
        }
      }
    }
    $scope.pageChanged = function(){
      if($scope.currentParams.isDefined) {
        $scope.search($scope.currentParams, $scope.pagingInfo);
      }
    };
    $scope.sortSelected = function(sortSelect){
      if(angular.isDefined(sortSelect)) {
        var sortPieces = sortSelect.split('-');
        $scope.pagingInfo.sortBy = sortPieces[0];
        $scope.pagingInfo.sortDescending = sortPieces[1];
        $scope.pageChanged();
      }
    };
    $scope.getCityStateProvince = function(destination){
      var cityState = '';
      if(angular.isDefined(destination) && angular.isDefined(destination.physicalAddress)){
        if(angular.isDefined(destination.physicalAddress.city)){
          cityState += destination.physicalAddress.city;
        }
        if(angular.isDefined(destination.physicalAddress.city) && angular.isDefined(destination.physicalAddress.stateProvince)){
          cityState += ', ';
        }
        if(angular.isDefined(destination.physicalAddress.stateProvince)){
          cityState += destination.physicalAddress.stateProvince;
        }
      }
      return cityState;
    };
    $scope.findRdnByValue = function(category, value){
      if(!angular.isDefined(category) || !angular.isDefined(value)){
        return;
      }
      return _.find($scope.refDataDDLs[category], function(x){
        if(!angular.isDefined(x.refDataCode)){
          return false;
        }
        return x.refDataCode.toUpperCase() === value.toUpperCase()
      });
    };
    $scope.addAll = function(){
      for(var i = 0; i < $scope.searchResults.length; i++){
        $scope.addItem($scope.searchResults[i]);
      }
    };
    $scope.addItem = function (item) {
      var packaging = $scope.findRdnByValue('Packaging', item.outerPackType);
      DrawItemService.add({
        purchaseOrderItemId: item.purchaseOrderItemId,
        commodity: {sku: item.sku, upc: item.upc, plu: item.plu },
        destination: item.destination,
        weight: item.outerPackWeight,
        weightUom: item.outerPackIsMetric ? RefDataMappingService.getItemId('KG_UOM') : RefDataMappingService.getItemId('LB_UOM'),
        quantity: item.availableQuantity,
        availableQuantity: item.availableQuantity,
        commodityName: item.productName,
        requestedDeliveryStartDate: item.requestedDeliveryStartDate,
        requestedPickupStartDate:item.requestedPickupStartDate,
        purchaseOrderNumber: item.purchaseOrderNumber,
        lineItemNumber: item.lineItemNumber,
        totalInsuranceValue: item.innerPackTotalValue,
        flatbed: {},
        packaging: packaging,
        hasDefaultPackaging: (packaging) ? true : false,
        freightClass: $scope.findRdnByValue('FreightClass', item.freightClass)
      });

      $scope.itemCount = DrawItemService.getTotals().itemCount;
    };

    $scope.createOrder = function () {
      var modalInstance = $uibModal.open({
        templateUrl: '/app/purchaseOrder/views/drawModal.tpl.html',
        size: 'lg',
        controller: 'DrawModalController',
        backdrop: 'static',
        resolve: {
          refDataDDLs: $scope.refDataDDLs,
          preferences: ['authService', function (authService) {
            return authService.getPreferences();
          }]
        }
      });
      modalInstance.result.then(function () {
        $state.go($state.$current, null, { reload: true });
      }, function (itemCount) {
          $scope.itemCount = itemCount;
      });
    };
    $scope.$on('$destroy', function () {
      DrawItemService.clear();
    });
  }

  angular.module('NavisphereOnline').controller('DrawSearchController', drawSearchController);
} ());

(function () {
  'use strict';
  drawModalController.$inject = ['$locale', '$scope', 'DateTimeService', '$state', '$uibModalInstance', '$uibModal', '$filter', 'DrawItemService', 'OrderConfirmationService', 'LocationService', 'AddressService', 'OrderService', 'OrderTransformService', 'refDataDDLs', 'preferences'];
  function drawModalController($locale, $scope, DateTimeService, $state, $uibModalInstance, $uibModal, $filter, DrawItemService, OrderConfirmationService, LocationService, AddressService, OrderService, OrderTransformService, refDataDDLs, preferences) {
    $scope.refData = refDataDDLs;
    $scope.getAddressLine1 = AddressService.GetAddressLine1;
    $scope.getAddressLine2 = AddressService.GetAddressLine2;
    $scope.getAddressLine3 = AddressService.GetAddressLine3;
    $scope.getAddressLine4 = AddressService.GetAddressLine4;
    $scope.displayDate = DateTimeService.getRawDateTime;
    $scope.confirmation = OrderConfirmationService.getConfirmation;
    $scope.order = DrawItemService.getOrder();
    $scope.step = 1;
    $scope.isMetric = preferences.unitOfMeasure === "metric";
    $scope.items = DrawItemService.getItems();
    $scope.remove = DrawItemService.remove;
    $scope.setStep = function (step) {
      $scope.step = step;
    };

    $scope.order.totalWeight = null;
    $scope.order.totalPallets = null;
    $scope.order.totalPalletSpaces = null;
    $scope.format = $locale.DATETIME_FORMATS['shortDate'];
    $scope.ismeridian = preferences.timeFormat === '12';
    $scope.hourStep = 1;
    $scope.minuteStep = 15;

    autoFillLocation();

    $scope.cancel = function () {
      $uibModalInstance.dismiss($scope.order.items.length);
    };
    $scope.refreshLocations = function (searchText, type) {
      if (searchText.length < 2) {
        $scope[type+'HasNoResults'] = false;
        return [];
      }
      $scope[type+'LocationResults'] = [];
      return LocationService.searchPartyLocation({
        partyNumberOrCode: $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, ''),
        term: searchText,
        limit: 20,
        locationSearchType: 2,
        useSupplierLocation: $scope.order.customer.useSupplierLocation
      }, function (data) {
        $scope[type+'LocationResults'] = data.items;
        $scope[type+'HasNoResults'] = data.items.length === 0;
      });
    };

    $scope.getWeightMeasurement = function() {
      return $scope.isMetric ? "KGS" : "LBS";
    };

    $scope.onPickupSelected = function (item) {
      $scope.order.pickup = item;
      $scope.order.pickupHasNoResults = false;
      LocationService.getLocation({
        locationPartyNumberOrCode: item.locationPartyCode,
        relatedLocationId: item.relatedLocationId,
        useSupplierLocation: $scope.order.customer.useSupplierLocation
      }, function (data) {
        if (data) {
          $scope.order.pickup.dryShippingHours = data.dryShippingHours;
          if (data.notes) {
            $scope.order.pickup.notes = data.notes.substring(0, 255);
          }
          $scope.order.pickup.address = data.physicalAddress;
          $scope.order.pickup.partyCode = data.partyCode;
          $scope.order.pickup.partyNumber = data.partyNumber;
          $scope.order.pickup.physicalAddress = data.physicalAddress;
          $scope.order.pickup.generalAddress = data.generalAddress;
          $scope.order.pickup.relatedLocationId = data.relatedLocationId;
          $scope.order.pickup.earliestTime = DateTimeService.getBeginningOfDay();
        }
        $scope.order.pickup.name = $scope.order.pickup.addressName;
        DrawItemService.calculateTotals();
        DrawItemService.calculateDates();
      });
    };

    $scope.onDeliverySelected = function (item) {
      $scope.order.delivery = item;
      LocationService.getLocation({
        locationPartyNumberOrCode: item.locationPartyCode,
        relatedLocationId: item.relatedLocationId,
        useSupplierLocation: $scope.order.customer.useSupplierLocation
      }, function (data) {
        if (data) {
          $scope.order.delivery.dryReceivingHours = data.dryReceivingHours;
          if (data.notes) {
            $scope.order.delivery.notes = data.notes.substring(0, 255);
          }
          $scope.order.delivery.address = data.physicalAddress;
          $scope.order.delivery.partyCode = data.partyCode;
          $scope.order.delivery.partyNumber = data.partyNumber;
          $scope.order.delivery.physicalAddress = data.physicalAddress;
          $scope.order.delivery.generalAddress = data.generalAddress;
          $scope.order.delivery.relatedLocationId = data.relatedLocationId;
          $scope.order.delivery.latestTime = DateTimeService.getBeginningOfDay();
        }
        $scope.order.delivery.name = $scope.order.delivery.addressName;
        DrawItemService.calculateTotals();
        DrawItemService.calculateDates();
      });
    };

    $scope.$watch('order.pickup.earliestDate', function (newValue) {
      if ($scope.order.pickup && newValue && $scope.order.pickup.dryShippingHours) {
        var shippingHours = $scope.order.pickup.dryShippingHours;
        var day = newValue.getDay();
        var dayName = DateTimeService.getWeekDayName(day);
        var dayClosedKey = dayName + 'Closed';
        var dayOpenTimeKey = dayName + 'OpenTime';
        if (shippingHours[dayClosedKey]) {
          return;
        }
        if (shippingHours[dayOpenTimeKey]) {
          var openTime = new Date(shippingHours[dayOpenTimeKey]);
          $scope.order.pickup.earliestTime = openTime;
        }
      }

      $scope.latestDateOptions.minDate = DateTimeService.getLatestDateMinDate(newValue);
    });

    $scope.updateTotal = function(propertyType) {
      var total = 0;
      var camelCasedPropertyType = propertyType[0].toUpperCase() + propertyType.slice(1);

      _.forEach($scope.order.items, function(item) {
        if (item[propertyType]) {
          total += Number(item[propertyType]);
        }
      });

      $scope.order["total" + camelCasedPropertyType] = total;
    };

    $scope.calculateTotals = function() {
      distributeTotal('weight');
      distributeTotal('pallets');
      distributeTotal('palletSpaces');
    };

    function distributeTotal(propertyType) {
      var camelCased = propertyType[0].toUpperCase() + propertyType.slice(1);

      if ($scope.order["total" + camelCased]) {
        var distributed = $scope.order["total" + camelCased] / $scope.order.items.length;

        _.forEach($scope.order.items, function(item) {
          item[propertyType] = distributed;
        })
      }
    }

    function autoFillLocation() {
      $scope.order.delivery = {};

      if (isLocationHomogenous()) {
        var location = $scope.order.items[0].destination;

        LocationService.getLocation({
          locationPartyNumberOrCode: location.partyCode,
          relatedLocationId: location.relatedLocationId,
          useSupplierLocation: $scope.order.customer.useSupplierLocation
        }, function (data) {
          if (data) {
            if (data.notes) {
              $scope.order.delivery.notes = data.notes.substring(0, 255);
            }

            $scope.order.delivery.addressName = data.name;
            $scope.order.delivery.dryReceivingHours = data.dryReceivingHours;
            $scope.order.delivery.address = data.physicalAddress;
            $scope.order.delivery.partyCode = data.partyCode;
            $scope.order.delivery.partyNumber = data.partyNumber;
            $scope.order.delivery.physicalAddress = data.physicalAddress;
            $scope.order.delivery.generalAddress = data.generalAddress;
            $scope.order.delivery.relatedLocationId = data.relatedLocationId;
          }

          $scope.order.delivery.latestTime = DateTimeService.getBeginningOfDay();
        });

        DrawItemService.calculateTotals();
      }
    }

    function isLocationHomogenous() {
      var result = true;

      if ($scope.order.items) {
        _.forEach($scope.order.items, function(item) {
          if ($scope.order.items[0].destination.partyCode !== item.destination.partyCode) {
            result = false;
          }
        });
      } else {
        result = false;
      }

      return result;
    }

    $scope.earliestDateOptions ={
      showWeeks: false,
      minDate: DateTimeService.getToday(),
      maxDate: DateTimeService.getDateTwoYearsFromNow()
    };

    $scope.latestDateOptions ={
      showWeeks: false,
      minDate: DateTimeService.getToday(),
      maxDate: DateTimeService.getDateTwoYearsFromNow()
    };

    $scope.earliestTimeChanged = function(value) {
      if (value === null) {
        $scope.order.pickup.earliestTime = DateTimeService.getBeginningOfDay();
      }
    };
    $scope.latestTimeChanged = function (value) {
      if (value === null) {
        $scope.order.pickup.latestTime = DateTimeService.getBeginningOfDay();
      }
    };

    $scope.$watch('drawForm.itemsForm.$valid', function (value) {
      $scope.order.stepOneValid = value;
    });
    $scope.$watch('drawForm.locationsForm.$valid', function (value) {
      if (angular.isDefined(value)) {
        $scope.order.stepTwoValid = value;
      }
    });
    $scope.close = function () {
      $uibModalInstance.close(true);
    };
    $scope.showValidationError = function() {
      $uibModal.open({
        templateUrl: 'app/validationModal/validationModal.tpl.html',
        size: 'lg',
        controller: 'validationModalController',
        resolve: {
          validations: function () { return $scope.validationMessages; },
          title: function () { return $filter('translate')('WE_WERE_NOT_ABLE_TO_PROCESS_YOUR_ORDER_PLEASE_RESO'); }
        }
      }).result.then(function () {
        $scope.validationMessages = [];
      }, function () {
        $scope.validationMessages = [];
      });
    };
        $scope.pickDeliverSequenceValid  = function() {
      var latestPickupDate = moment($scope.order.pickup.earliestDate);
      var earliestDeliveryDate = moment($scope.order.delivery.latestDate);
      var latestPickLessThanEarliestDelivery;
      if (latestPickupDate < earliestDeliveryDate) {
        latestPickLessThanEarliestDelivery = true;
      } else if (latestPickupDate.diff(earliestDeliveryDate) === 0) {
        var latestPickupTime = moment($scope.order.pickup.earliestTime);
        var earliestDeliveryTime = moment($scope.order.delivery.latestTime);
        if (latestPickupTime < earliestDeliveryTime) {
          latestPickLessThanEarliestDelivery = true;
        } else {
          latestPickLessThanEarliestDelivery = false;
        }
      } else {
        latestPickLessThanEarliestDelivery = false;
      }
      if (!latestPickLessThanEarliestDelivery) {
        $scope.validationMessages.push($filter('translate')('PICKUP_EARLIEST_DATE_TIME_MUST_BE_BEFORE_DELIVERY_'));
      }
      return latestPickLessThanEarliestDelivery;
    };

    $scope.validationMessages = [];
    $scope.submitOrder = function () {
      $scope.validationMessages = [];
            if ($scope.drawForm.$valid && $scope.pickDeliverSequenceValid()) {
        $scope.loadingModal = $uibModal.open({
          templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
          size: 'sm',
          controller: 'loadingSpinnerController',
          backdrop: 'static',
          resolve: {
            title: function () { return $filter('translate')('PLACING_ORDER'); }
          }
        });
        $scope.order.pickup.latestDate = $scope.order.pickup.earliestDate;
        $scope.order.pickup.latestTime = $scope.order.pickup.earliestTime;
        $scope.order.delivery.earliestDate = $scope.order.delivery.latestDate;
        $scope.order.delivery.earliestTime = $scope.order.delivery.latestTime;
        var customerOrderRequest = OrderTransformService.getCustomerOrderSaveRequest($scope.order);
        var orderService = new OrderService(customerOrderRequest);
        orderService.$save().then(function (result) {
          $scope.loadingModal.close(result);
          $scope.validationMessages = [];
          if (result.success) {
            $scope.hasError = false;
            OrderConfirmationService.setOrderConfirmation($scope.order, result, null, null);
          } else {
            angular.forEach(result.errors, function (error) {
              $scope.validationMessages.push($filter('translate')(error.errorMessage));
            });
            $scope.hasError = true;
            $scope.showValidationError();
          }
          $scope.setStep(3);
        }, function (result) {
          $scope.validationMessages.push($filter('translate')('WE_ARE_UNABLE_TO_PROCESS_YOUR_ORDER_AT_THIS_TIME_P'));
          $scope.showValidationError();
          $scope.hasError = true;
          $scope.setStep(3);
        });

      }else{
        $scope.showValidationError();
        $scope.setStep(2);
      }
    };

    $scope.setPackagingTypeAllItems = function(packagingType) {
      _.forEach($scope.order.items, function(item) {
        if(!item.hasDefaultPackaging) {
          item.packaging = packagingType;
        }
      });
    };
  }

  angular.module('NavisphereOnline').controller('DrawModalController', drawModalController);
} ());

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  app.directive('viewBolLink', ['bolContext', function (bolContext) {
    return {
      templateUrl: 'app/orderDetails/directives/viewBolLink.tpl.html',
      restrict: 'E',
      bindToController: {
        order: "="
      },
      controllerAs: 'ctrl',
      controller: ['$scope', 'StatusMappingService', 'UserPermissionService', 'DocumentHelper', '$timeout', 'API_BASE_URL',
        function ($scope, StatusMappingService, UserPermissionService, DocumentHelper, $timeout, API_BASE_URL) {
          var customer = $scope.order.customerInfo.customer;
          this.canViewBOL = (
            customer.bolContext === bolContext.Order &&
            UserPermissionService.hasCustomerRole(customer.partyCode, "View BOL") &&
            $scope.order.service.statusRDN > StatusMappingService.serviceStatus.incomplete
          );

          this.viewBOL = function () {
            $timeout(function () {
              DocumentHelper.showDocument(API_BASE_URL + 'api/documents/bol' + '?orderNumber=' + encodeURIComponent($scope.order.customerOrderNumber));
            });
          };
        }]
    };
  }]);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('ballProgressBar', [function () {
    return {
      templateUrl: 'app/orderDetails/directives/ballProgressBar.tpl.html',
      restrict: 'E',
      scope: {
        order: "="
      },
      controller: ['$scope', '$filter', 'RefDataMappingService', 'CarrierLogService', 'StatusMappingService', 'DateTimeService',
                    'CarrierRuleService', 'UserPermissionService', 'InteropService', '$state', '$window',
        function ($scope, $filter, RefDataMappingService, CarrierLogService, StatusMappingService, DateTimeService,
                  CarrierRuleService, UserPermissionService, InteropService, $state, $window) {

          $scope.loadNumber = getLoadNumber();
          $scope.carrier = getCarrier();
          $scope.carrierProNumber = getCarrierProNumber($scope.order);
          $scope.orderedDateLabel = getOrderedDateLabel();
          $scope.orderedDate = getOrderedDate();
          $scope.deliveredDateLabel = getDeliveredDateLabel();
          $scope.deliveredDate = getDeliveredDate();
          $scope.redirectToOnlineOne = redirectToOnlineOne;
          getProgressBarCarrierLogInformation();
          setLoadViewPermission();

          $scope.StatusMappingService = StatusMappingService;
          $scope.getDisplayDate = DateTimeService.getDisplayDate;
          $scope.getDisplayTime = DateTimeService.getDisplayTime;

          $scope.rerun = function () {
            $scope.loadNumber = getLoadNumber();
            $scope.carrier = getCarrier();
            $scope.carrierProNumber = getCarrierProNumber($scope.order);
            $scope.orderedDateLabel = getOrderedDateLabel();
            $scope.orderedDate = getOrderedDate();
            $scope.deliveredDateLabel = getDeliveredDateLabel();
            $scope.deliveredDate = getDeliveredDate();
            getProgressBarCarrierLogInformation();
          };

          function getLoadNumber() {
            if (!$scope.order || !$scope.order.service || !$scope.order.service.loads || $scope.order.isMultiLeg) {
              return null;
            }

            if (!$scope.order.service.loads[0]) {
              return null;
            }

            return $scope.order.service.loads[0].loadNumber;
          }

          function getCarrier() {
            if (!$scope.order || !$scope.order.service || !$scope.order.service.loads) {
              return null;
            }

            if (!CarrierRuleService.showCarrier($scope.order.service.serviceOffering.id,$scope.order.isMultiLeg) || !$scope.order.service.loads[0] || !$scope.order.service.loads[0].carriers || !$scope.order.service.loads[0].carriers[0]) {
              return null;
            }

            return $scope.order.service.loads[0].carriers[0].name;
          }

          function orderHasNoService(order) {
            return !order || !order.service;
          }

          function serviceHasNoLoad(order){
            if(orderHasNoService(order)){
              return true;
            }

            return !order.service.loads || !order.service.loads[0];
          }

          function loadHasNoCarriers(order){
            if(serviceHasNoLoad(order)){
              return true;
            }

            return !order.service.loads[0].carriers || !order.service.loads[0].carriers[0];
          }

          function carrierHasNoReferenceNumbers(order) {

            if(loadHasNoCarriers(order)){
              return true;
            }

            return !order.service.loads[0].carriers[0].referenceNumbers;
          }

          function getCarrierProNumber(order) {
            if(!order){
              return null;
            }
            if ( order.isMultiLeg || carrierHasNoReferenceNumbers(order)) {
              return null;
            }

            return getReferenceNumber($scope.order.service.loads[0].carriers[0].referenceNumbers, 'CARRIER_PRO_NUMBER');
          }

          function getReferenceNumber(referenceNumbers, refNumberType) {
            for (var i = 0; i < referenceNumbers.length; i++) {
              if (referenceNumbers[i].referenceNumberType.refDataNumber ===
                RefDataMappingService.getCategoryId(refNumberType)) {
                return $scope.order.service.loads[0].carriers[0].referenceNumbers[i].value;
              }
            }
          }

          function getOrderedDateLabel() {

            var orderedDateLabel = null;

            if (!$scope.order || !$scope.order.service || !$scope.order.service.pickupFrom) {
              return orderedDateLabel;
            }

            if ($scope.order.service.pickupFrom.actualArrivalDateTime) {
              orderedDateLabel = $filter('translate')('ACTUAL_PICK_UP');
            } else if ($scope.order.service.pickupFrom.scheduledOpenDateTime) {
              orderedDateLabel = $filter('translate')('SCHEDULED_PICKUP');
            } else if ($scope.order.service.pickupFrom.earliestDate) {
              orderedDateLabel = $filter('translate')('REQUESTED_PICK_UP');
            }

            return orderedDateLabel;
          }

          function getOrderedDate() {

            var returnString = null;

            if (!$scope.order || !$scope.order.service || !$scope.order.service.pickupFrom) {
              return returnString;
            }

            if ($scope.order.service.pickupFrom.actualArrivalDateTime) {
              returnString = DateTimeService.getDisplayDateOrTime($scope.order.service.pickupFrom.actualArrivalDateTime, $scope.$parent.userPreferences);
            } else if ($scope.order.service.pickupFrom.scheduledOpenDateTime) {
              returnString = DateTimeService.getDisplayDateOrTime($scope.order.service.pickupFrom.scheduledOpenDateTime, $scope.$parent.userPreferences);
            } else if ($scope.order.service.pickupFrom.earliestDate) {
              returnString = DateTimeService.getDisplayDateOrTime($scope.order.service.pickupFrom.earliestDate.utcDateTime, $scope.$parent.userPreferences, false);
            }

            return returnString;
          }

          function getDeliveredDateLabel() {

            var deliveredDateLabel = null;

            if (!$scope.order || !$scope.order.service || !$scope.order.service.deliverTo) {
              return deliveredDateLabel;
            }
            if ($scope.order.service.deliverTo.actualArrivalDateTime) {
              deliveredDateLabel = $filter('translate')('ACTUAL_DELIVERY');
            } else if ($scope.order.service.deliverTo.scheduledOpenDateTime) {
              deliveredDateLabel = $filter('translate')('SCHEDULED_DELIVERY');
            } else if ($scope.order.service.deliverTo.earliestDate) {
              deliveredDateLabel = $filter('translate')('REQUESTED_DELIVERY');
            }

            return deliveredDateLabel;
          }

          function getDeliveredDate() {

            var deliveredDate = null;

            if (!$scope.order || !$scope.order.service || !$scope.order.service.deliverTo) {
              return deliveredDate;
            }
            if ($scope.order.service.deliverTo.actualArrivalDateTime) {
              deliveredDate = DateTimeService.getDisplayDateOrTime($scope.order.service.deliverTo.actualArrivalDateTime, $scope.$parent.userPreferences);
            } else if ($scope.order.service.deliverTo.scheduledOpenDateTime) {
              deliveredDate = DateTimeService.getDisplayDateOrTime($scope.order.service.deliverTo.scheduledOpenDateTime, $scope.$parent.userPreferences);
            } else if ($scope.order.service.deliverTo.earliestDate) {
              deliveredDate = DateTimeService.getDisplayDateOrTime($scope.order.service.deliverTo.earliestDate.utcDateTime, $scope.$parent.userPreferences, false);
            }
            return deliveredDate;
          }

          function getProgressBarCarrierLogInformation() {
            if (!$scope.carrierLogs) {

              if (!$scope.order) {
                return;
              }

              CarrierLogService.get({
                orderNumber: $scope.order.customerOrderNumber
              }, function (carrierLogs) {

                if (!carrierLogs || !carrierLogs[0]) {
                  return;
                }

                $scope.carrierLogs = $filter('orderBy')(carrierLogs, '-eventDateTime', false);

                $scope.mostRecentCarrierLogEvent = _.find($scope.carrierLogs, function(log) {
                  return log.notes;
                });
                getCarrierLogLastLocation();
                getHasDLTrackingReasonCode(carrierLogs);

              }, function () {
              });

              return;
            }
            if (!$scope.carrierLogs || !$scope.carrierLogs[0]) {
              return;
            }

            $scope.mostRecentCarrierLogEvent = $scope.carrierLogs[0];
            getCarrierLogLastLocation();
            getHasDLTrackingReasonCode($scope.carrierLogs);
          }

          function getCarrierLogLastLocation() {
            if ($scope.mostRecentCarrierLogEvent.driverLocation.city && !$scope.mostRecentCarrierLogEvent.driverLocation.state) {
              $scope.carrierLogLastLocation = $scope.mostRecentCarrierLogEvent.driverLocation.city;
            } else if ($scope.mostRecentCarrierLogEvent.driverLocation.city && $scope.mostRecentCarrierLogEvent.driverLocation.state) {
              $scope.carrierLogLastLocation = $scope.mostRecentCarrierLogEvent.driverLocation.city + ', ' +
                $scope.mostRecentCarrierLogEvent.driverLocation.state;
            } else if (!$scope.mostRecentCarrierLogEvent.driverLocation.city && $scope.mostRecentCarrierLogEvent.driverLocation.state) {
              $scope.carrierLogLastLocation = $scope.mostRecentCarrierLogEvent.driverLocation.state;
            }
          }

          function getHasDLTrackingReasonCode(carrierLogs) {

            for (var i = 0; i < carrierLogs.length; i++) {
              if (carrierLogs[i].trackingReasonCode === 'DL') {
                $scope.hasDLTrackingReasonCode = true;
                i = carrierLogs.length;
              }
            }
          }

          function setLoadViewPermission() {
            $scope.hasLoadViewPermission = UserPermissionService.hasPermission('Load View Detail (Interop)');
          }

          function redirectToOnlineOne(loadNumber) {
            var baseUrl = appConfig.legacyOnlineBaseUrl;
            var redirectUrl = baseUrl + '/shipmentdetail/Shipmentdetail.aspx?val=' + loadNumber + '&type=1&mode=5&WCF=32';
            var currentUrl = $window.location.href;

            $state.go('outgoingBridge', {redirectUrl: redirectUrl,  currentUrl: currentUrl})
          }
        }]
    };
  }]);
})();

(function () {
    'use strict';
    warehouseDetailsController.$inject = ['$scope', '$filter','$uibModalInstance', 'warehouseDetails'];

    function warehouseDetailsController($scope, $filter, $uibModalInstance, locationInfo) {

        $scope.locationInfo = locationInfo;
        $scope.operationHours = [];
        $scope.ok = function () {
            $uibModalInstance.close();
        };
        $scope.formatPhoneNumber = function(phoneNumber) {
            return (phoneNumber) ? phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : null;
        };

        var locationToUse;
        if (locationInfo.useReceivingHours) {
            locationToUse = (locationInfo.displayDryHours) ? locationInfo.location.dryReceivingHours : locationInfo.location.tempControlledReceivingHours;
        } else {
            locationToUse = (locationInfo.displayDryHours) ? locationInfo.location.dryShippingHours : locationInfo.location.tempControlledShippingHours;
        }
        if (locationToUse) {

            var weekDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

            angular.forEach(weekDays, function(dayName) {

                var dayClosedKey = dayName + 'CloseTime';
                var dayOpenTimeKey = dayName + 'OpenTime';
                var dayOperationHour = { day: dayName };
                var dayClosed = locationToUse[dayName + 'Closed'];

                if (dayClosed !== true) {
                    if (locationToUse[dayOpenTimeKey]) {
                        dayOperationHour.openTime = $filter('time')(new Date(locationToUse[dayOpenTimeKey]));
                    }
                    if (locationToUse[dayClosedKey]) {
                        dayOperationHour.closeTime = $filter('time')(new Date(locationToUse[dayClosedKey]));
                    }

                    if (locationToUse[dayClosedKey] || locationToUse[dayOpenTimeKey]) {
                        $scope.operationHours.push(dayOperationHour);
                    }
                }

            });
        }
    }
    angular.module('NavisphereOnline').controller('warehouseDetailsController', warehouseDetailsController);
})();

(function () {
    'use strict';
    tryToGetLockAgainModalController.$inject = ['$scope', '$interval', '$uibModalInstance', 'LockService', 'orderNumber'];

    function tryToGetLockAgainModalController($scope, $interval, $uibModalInstance, LockService, orderNumber) {

        $scope.isTryAgainButtonDisabled = false;

        $scope.lockOrder = function () {

            LockService.lockOrder(orderNumber.toString(), function (result) {

                if (!result.user) {
                    $scope.isTryAgainButtonDisabled = true;
                    $interval(enableButton, 1000, 1);
                    return;
                }

                $uibModalInstance.close(result);
            });
        };

        $scope.ok = function () {
            $uibModalInstance.close(null);
        };

        function enableButton() {

            $scope.isTryAgainButtonDisabled = false;
        }
    }
    angular.module('NavisphereOnline').controller('tryToGetLockAgainModalController', tryToGetLockAgainModalController);
})();

(function () {
  'use strict';
  referenceNumberEditController.$inject = ['$scope', 'RefDataMappingService', '$filter'];
  function referenceNumberEditController($scope, RefDataMappingService, $filter) {
    $scope.RefDataMappingService = RefDataMappingService;

    $scope.primaryRefNumber = getPrimaryRefNumber($scope.$parent.order);
    $scope.secondaryRefNumber = getSecondaryRefNumber($scope.$parent.order);
    $scope.shipWithRefNumber = getShipWithRefNumber($scope.$parent.order);

    $scope.isConfNum = function (refNum) {
      return refNum.referenceNumberType.refDataNumber === RefDataMappingService.getItemId('CONFIRMATION_NUMBER');
    };

    $scope.isTrackingNumber = function (refNum) {
      return refNum.referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('TRACKING_NUMBER');
    };

    function getPrimaryRefNumber(order){

      if(isOrderBad(order)){
        return;
      }

      var billTo = order.billTos[0];
      for(var i = 0; i < billTo.referenceNumbers.length; i++){
        if(billTo.referenceNumbers[i].isPrimary){
          return billTo.referenceNumbers[i];
        }
      }

      return addPrimaryRefNumberToBillTo(billTo);
    }

    function addPrimaryRefNumberToBillTo(billTo){

      var primaryRefNum =
      {
        isPrimary:true,
        referenceNumberType: {
          refDataNumber: $scope.order.customerInfo.customer.primaryBillToReferenceNumTypeRDN,
          description: $filter('translate')('PRIMARY')
        },
        value:""
      };

      billTo.referenceNumbers.push(primaryRefNum);

      return primaryRefNum;
    }

    function getSecondaryRefNumber(order){

      if(isOrderBad(order)){
        return;
      }

      var customer = order.customerInfo;
      for(var i = 0; i < customer.referenceNumbers.length; i++){
        if(customer.referenceNumbers[i].isPrimary){
          return customer.referenceNumbers[i];
        }
      }

      return addSecondaryRefNumberToCustomer(order.customerInfo);
    }

    function addSecondaryRefNumberToCustomer(customer){

      var secondaryRefNum =
      {
        isPrimary:true,
        referenceNumberType: {
          refDataNumber: customer.customer.primaryCustomerReferenceNumTypeRDN,
          description: $filter('translate')('SECONDARY')
        },
        value:""
      };

      customer.referenceNumbers.push(secondaryRefNum);

      return secondaryRefNum;
    }

    function getShipWithRefNumber(order){

      if(isOrderBad(order)){
        return;
      }

      for(var i = 0; i < order.referenceNumbers.length; i++){
        if(!order.referenceNumbers[i].isPrimary &&
          order.referenceNumbers[i].referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('SHIPWITH_NUMBER')){
          return order.referenceNumbers[i];
        }
      }

      return addShipWithRefNumberToCustomer(order);
    }

    function addShipWithRefNumberToCustomer(order){

      var shipWithRefNum =
      {
        isPrimary:false,
        referenceNumberType: {
          refDataNumber: RefDataMappingService.getCategoryId('SHIPWITH_NUMBER'),
          description: $filter('translate')('SHIP_WITH_NUMBER')
        },
        value:""
      };

      order.referenceNumbers.push(shipWithRefNum);

      return shipWithRefNum;
    }

    function isOrderBad(order){
      return angular.isUndefined(order) || angular.isUndefined(order.billTos) || order.billTos.length < 1;
    }

    $scope.orderRefNumsFilter = function(element){

      if(!element.isPrimary &&
        element.referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('SHIPWITH_NUMBER')){
        element.referenceNumberType.description = $filter('translate')('SHIP_WITH_NUMBER')
      }

      return element.referenceNumberType.refDataNumber !== RefDataMappingService.getCategoryId('SHIPWITH_NUMBER');
    };

    $scope.filterBillToRefNums = function (element) {
      return !element.isPrimary;
    };

    $scope.filterCustomerRefNums = function (element) {
      return !element.isPrimary;
    };
  }
  angular.module('NavisphereOnline').controller('referenceNumberEditController', referenceNumberEditController);
})();

(function () {
    'use strict';
    referenceNumberDetailsController.$inject = ['$scope', 'RefDataMappingService', '$filter'];

    function referenceNumberDetailsController($scope, RefDataMappingService, $filter) {

        $scope.proNumber = null;
        $scope.carrierName = null;

        $scope.setProNumberAndCarrierName = function() {
            var proNumberRDN = RefDataMappingService.getCategoryId('CARRIER_PRO_NUMBER');

            if ($scope.$parent.order.service.loads && $scope.$parent.order.service.loads.length > 0) {
                var firstLoad = $scope.$parent.order.service.loads[0];
                if (firstLoad.carriers && firstLoad.carriers.length > 0) {
                    $scope.carrierName = firstLoad.carriers[0].name;
                    if (firstLoad.carriers[0].referenceNumbers) {

                        for (var k = 0; k < firstLoad.carriers[0].referenceNumbers.length; k++) {
                            if (firstLoad.carriers[0].referenceNumbers[k].referenceNumberType.refDataNumber === proNumberRDN) {
                                $scope.proNumber = firstLoad.carriers[0].referenceNumbers[k].value;
                                break;
                            }
                        }
                    }
                }
            }
        };
        $scope.setProNumberAndCarrierName();

      $scope.customerRefNumsFilter = function(element){

        if(element.isPrimary &&
          element.referenceNumberType.refDataNumber ===
          $scope.$parent.order.customerInfo.customer.primaryCustomerReferenceNumTypeRDN){
          element.referenceNumberType.description = $filter('translate')('SECONDARY')
        }

        return angular.isDefined(element.value) &&  element.value != '';
      };

      $scope.orderRefNumsFilter = function(element){

        if(!element.isPrimary &&
          element.referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('SHIPWITH_NUMBER')){
          element.referenceNumberType.description = $filter('translate')('SHIP_WITH_NUMBER')
        }

        return angular.isDefined(element.value) &&  element.value !== '';
      };

      $scope.hidePrimaryReferenceNumber = function(element){
        return  !(element.isPrimary && element.referenceNumberType.refDataNumber ===
          $scope.$parent.order.customerInfo.customer.primaryBillToReferenceNumTypeRDN);
      };
    }
    angular.module('NavisphereOnline').controller('referenceNumberDetailsController', referenceNumberDetailsController);
})();

(function () {

    'use strict';

    pickupEditController.$inject = ['$scope', '$filter', '$uibModal', 'DateTimeService', '$locale', 'LocationService',
      'AddressService', 'RefDataMappingService', 'UserPermissionService'];

    function pickupEditController($scope, $filter, $uibModal, DateTimeService, $locale, LocationService,
          AddressService, RefDataMappingService, UserPermissionService) {

        $scope.originLocationResults = [];
        $scope.getAddressLine1 = AddressService.GetAddressLine1;
        $scope.getAddressLine2 = AddressService.GetAddressLine2;
        $scope.getAddressLine3 = AddressService.GetAddressLine3;
        $scope.getAddressLine4 = AddressService.GetAddressLine4;

        $scope.earliestDateOptions ={
          showWeeks: false,
          minDate: DateTimeService.getToday(),
          maxDate: DateTimeService.getDateTwoYearsFromNow()
        };

        $scope.latestDateOptions ={
          showWeeks: false,
          minDate: DateTimeService.getToday(),
          maxDate: DateTimeService.getDateTwoYearsFromNow()
        };
        $scope.bolRefNum = getBolRefNum();
        $scope.puRefNum = getPuRefNum();

        function getBolRefNum(){
          if($scope.$parent.order.service.pickupFrom.referenceNumbers){
            for(var i = 0; i < $scope.$parent.order.service.pickupFrom.referenceNumbers.length; i++){
              if($scope.$parent.order.service.pickupFrom.referenceNumbers[i].referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('BOL_NUMBER')){
                return $scope.$parent.order.service.pickupFrom.referenceNumbers[i];
              }
            }
            var bolRefNum = { referenceNumberType: {
              description: $filter('translate')('BOL_POUND'),
              refDataNumber: RefDataMappingService.getCategoryId('BOL_NUMBER') }};
            $scope.$parent.order.service.pickupFrom.referenceNumbers.push(bolRefNum);
            return bolRefNum;
          }
        }
        function getPuRefNum(){
          if($scope.$parent.order.service.pickupFrom.referenceNumbers){
            for(var i = 0; i < $scope.$parent.order.service.pickupFrom.referenceNumbers.length; i++){
              if($scope.$parent.order.service.pickupFrom.referenceNumbers[i].referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('PICKUP_NUMBER')){
                return $scope.$parent.order.service.pickupFrom.referenceNumbers[i];
              }
            }
            var puRefNum = { referenceNumberType: {
              description: $filter('translate')('PICKUP_POUND'),
              refDataNumber: RefDataMappingService.getCategoryId('PICKUP_NUMBER') }};
            $scope.$parent.order.service.pickupFrom.referenceNumbers.push(puRefNum);
            return puRefNum;
          }
        }
        $scope.refNumbFilter = function(element){
          var test1 = element != $scope.bolRefNum;
          var test2 = element != $scope.puRefNum;
          return test1 && test2;
        };
        if ($scope.editAllowed('UPDATE_READY_BY_DATE_TIME')) {
            $scope.earliestDateOptions.minDate = DateTimeService.getToday();
            $scope.earliestDateOptions.maxDate = DateTimeService.getDateTwoYearsFromNow();
        }

        if ($scope.editAllowed('UPDATE_PICK_UP_BY_DATE_TIME')) {
            $scope.latestDateOptions.minDate = DateTimeService.getToday();
            $scope.latestDateOptions.maxDate = DateTimeService.getDateTwoYearsFromNow();
        }

        $scope.format = $locale.DATETIME_FORMATS['shortDate'];
        $scope.openEarliestDate = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.earliestDateOpened = true;
        };
        $scope.ismeridian = $scope.$parent.userPreferences.timeFormat === '12';

        $scope.hstep = 1;
        $scope.mstep = 15;
        $scope.hasAddLocation = UserPermissionService.hasCustomerRole($scope.order.customerInfo.customer.partyCode, 'Add New Location')
          && $scope.editAllowed('UPDATE_ORIGIN_LOCATION');
        $scope.openLatestDate = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.latestDateOpened = true;
        };
        $scope.earliestTimeChanged = function (value) {
            if (value === null) {
                $scope.$parent.order.service.pickupFrom.uiEarliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            }
        };
        $scope.latestTimeChanged = function (value) {
            if (value === null) {
                $scope.$parent.order.service.pickupFrom.uiLatestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            }
        };

        $scope.addNewLocation = function () {
            var modalInstance = $uibModal.open({
                templateUrl: '../app/addLocationModals/views/addLocation.tpl.html',
                size: 'lg',
                controller: 'addLocationController',
                backdrop: 'static',
                resolve: {
                  customer: function () {
                    return ($scope.order.customerInfo && $scope.order.customerInfo.customer)
                      ? $scope.order.customerInfo.customer.partyCode : '';
                  },
                  locationType: function() {
                    if($scope.$parent.pickupNeedsRefinement){
                      return "pickup";
                    }
                    return "";
                  },
                  supplier: function () {
                    return (angular.isDefined($scope.user) && angular.isDefined($scope.user.supplierPartyCode)
                    && angular.isDefined($scope.order.customerInfo) &&  angular.isDefined($scope.order.customerInfo.customer)
                    && $scope.order.customerInfo.customer.useSupplierLocation)
                      ?  $scope.user.supplierPartyCode
                      : undefined;
                  }
                }
            });
            modalInstance.result.then(function (newLocation) {
                $scope.$parent.order.pickupHasNoResults = false;
                $scope.$parent.order.service.pickupFrom.location = newLocation;
                $scope.$parent.order.service.pickupFrom.address = newLocation.physicalAddress;
                $scope.$parent.order.service.pickupFrom.uiEarliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
                $scope.$parent.order.service.pickupFrom.uiLatestTime = new Date((new Date()).setHours(0, 0, 0, 0));
                $scope.pickupForm.$setDirty();
            }, function () {
            });
        };
        $scope.$watch('$parent.order.service.pickupFrom.uiEarliestDate', function (newValue) {
            if ($scope.editAllowed('UPDATE_PICK_UP_BY_DATE_TIME') && newValue) {
                $scope.latestDateOptions.minDate = newValue > DateTimeService.getToday() ? newValue: $scope.latestDateOptions.minDate;
                if ($scope.$parent.order.service.pickupFrom.uiLatestDate) {
                    if ($scope.$parent.order.service.pickupFrom.uiLatestDate < newValue) {
                        $scope.$parent.order.service.pickupFrom.uiLatestDate = newValue;
                    }
                }
            }
            if ($scope.$parent.order.service.pickupFrom
                && $scope.$parent.order.service.pickupFrom.location
                && newValue
                && $scope.$parent.order.service.pickupFrom.location.dryShippingHours) {

                var shippingHours = $scope.$parent.order.service.pickupFrom.location.dryShippingHours;
                var day = newValue.getDay();
                var dayName = DateTimeService.getWeekDayName(day);
                var dayClosedKey = dayName + 'Closed';
                var dayOpenTimeKey = dayName + 'OpenTime';
                var dayCloseTimeKey = dayName + 'CloseTime';
                if (shippingHours[dayClosedKey]) {
                    return;
                }
                if (shippingHours[dayOpenTimeKey] && $scope.$parent.order.service.pickupFrom.uiEarliestTime.getTime() === (new Date((new Date()).setHours(0, 0, 0, 0))).getTime()) {
                    var openTime = new Date(shippingHours[dayOpenTimeKey]);
                    $scope.$parent.order.service.pickupFrom.uiEarliestTime = openTime;
                }
                if(shippingHours[dayCloseTimeKey]&& $scope.$parent.order.service.pickupFrom.uiLatestTime.getTime() === (new Date((new Date()).setHours(0, 0, 0, 0))).getTime()) {
                    var closeTime = new Date(shippingHours[dayCloseTimeKey]);
                    $scope.$parent.order.service.pickupFrom.uiLatestTime = closeTime;
                }
            }
        });

        $scope.refreshOriginLocations = function (searchText) {
            if (searchText.length < 2) {
                $scope.$parent.order.pickupHasNoResults = false;
                return [];
            }
            $scope.originLocationResults = [];
            return LocationService.searchPartyLocation({
                partyNumberOrCode: $scope.order.customerInfo.customer.partyCode.replace(/^\s+|\s+$/gm, ''),
                term: searchText,
                limit: 100,
                locationSearchType: 1,
                useSupplierLocation: $scope.order.customerInfo.customer.useSupplierLocation
            }, function (data) {
                $scope.originLocationResults = data.items;
                $scope.$parent.order.pickupHasNoResults = (data.items.length === 0) ? true : false;
            });
        };
        $scope.onPickupSelected = function (item) {

            $scope.$parent.order.pickupHasNoResults = false;
            $scope.$parent.order.service.pickupFrom.uiEarliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            $scope.$parent.order.service.pickupFrom.uiLatestTime = new Date((new Date()).setHours(0, 0, 0, 0));

            LocationService.getLocation({
                locationPartyNumberOrCode: item.locationPartyCode,
                relatedLocationId: item.relatedLocationId,
                useSupplierLocation: $scope.order.customerInfo.customer.useSupplierLocation
            }, function (data) {

                $scope.$parent.order.service.pickupFrom.address = data.physicalAddress;
                $scope.$parent.order.service.pickupFrom.location = data;
                $scope.$parent.order.service.pickupFrom.dropLocationNumber = item.dropLocationNumber;
                $scope.$parent.order.service.pickupFrom.pickLocationNumber = item.pickLocationNumber;
                if (data.notes) {
                    $scope.$parent.order.service.pickupFrom.specialInstructions = data.notes.substring(0, 255);
                } else {
                    $scope.$parent.order.service.pickupFrom.specialInstructions = '';
                }

                if ($scope.$parent.order.service.pickupFrom
                    && $scope.$parent.order.service.pickupFrom.location
                    && $scope.$parent.order.service.pickupFrom.location.dryShippingHours
                    && $scope.$parent.order.service.pickupFrom.uiEarliestDate) {

                    var shippingHours = $scope.$parent.order.service.pickupFrom.location.dryShippingHours;
                    var day = $scope.$parent.order.service.pickupFrom.uiEarliestDate.getDay();

                    var dayName = DateTimeService.getWeekDayName(day);
                    var dayClosedKey = dayName + 'Closed';
                    var dayOpenTimeKey = dayName + 'OpenTime';
                    var dayCloseTimeKey = dayName + 'CloseTime';

                    if (shippingHours[dayClosedKey]) {
                        return;
                    }
                    if (shippingHours[dayOpenTimeKey]) {
                        var openTime = new Date(shippingHours[dayOpenTimeKey]);
                        $scope.$parent.order.service.pickupFrom.uiEarliestTime = openTime;
                    }
                    if (shippingHours[dayCloseTimeKey]) {
                        var closeTime = new Date(shippingHours[dayCloseTimeKey]);
                        $scope.$parent.order.service.pickupFrom.uiLatestTime = closeTime;
                    }
                }
            });
            var cCode = ($scope.order.customerInfo && $scope.order.customerInfo.customer)
              ? $scope.order.customerInfo.customer.partyCode : '';
        };
    }

    angular.module('NavisphereOnline').controller('pickupEditController', pickupEditController);

})();

(function () {
    'use strict';
    pickupDetailsController.$inject = ['$scope', '$filter', 'AddressService', '$uibModal', 'DateTimeService',
    'RefDataMappingService'];

    function pickupDetailsController($scope, $filter, AddressService, $uibModal, DateTimeService,
                                     RefDataMappingService) {

        $scope.getAddressLine3 = AddressService.GetAddressLine3;
        $scope.getAddressLine4 = AddressService.GetAddressLine4;
        $scope.userPreferences = $scope.$parent.userPreferences;

        if ($scope.$parent.order.service.pickupFrom) {
            if ($scope.$parent.order.service.pickupFrom.earliestDate) {
                var earliestDate = $scope.$parent.order.service.pickupFrom.earliestDate.utcDateTime;
                $scope.$parent.order.service.pickupFrom.uiEarliestDate = DateTimeService.getRawDateTime(earliestDate);
            }
            if ($scope.$parent.order.service.pickupFrom.earliestTime) {
                var earliestTime = $scope.$parent.order.service.pickupFrom.earliestTime.utcDateTime;
                $scope.$parent.order.service.pickupFrom.uiEarliestTime = DateTimeService.getRawDateTime(earliestTime);
            } else {
                $scope.$parent.order.service.pickupFrom.uiEarliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            }
            if ($scope.$parent.order.service.pickupFrom.latestDate) {
                var latestDate = $scope.$parent.order.service.pickupFrom.latestDate.utcDateTime;
                $scope.$parent.order.service.pickupFrom.uiLatestDate = DateTimeService.getRawDateTime(latestDate);
            }
            if ($scope.$parent.order.service.pickupFrom.latestTime) {
                var latestTime = $scope.$parent.order.service.pickupFrom.latestTime.utcDateTime;
                $scope.$parent.order.service.pickupFrom.uiLatestTime = DateTimeService.getRawDateTime(latestTime);
            } else {
                $scope.$parent.order.service.pickupFrom.uiLatestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            }
        }

      $scope.refNumberFilter = function(element){

        if(element.referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('PICKUP_NUMBER')){
          element.referenceNumberType.description = $filter('translate')('PICKUP_POUND');
        }

        if(element.referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('BOL_NUMBER')){
          element.referenceNumberType.description = $filter('translate')('BOL_POUND');
        }

        return true;
      };

        $scope.pickupWarehouseDetails = function (locationDetail, displayDryHours) {
            var locationInfo = {
                location: locationDetail,
                displayDryHours: displayDryHours,
                useReceivingHours: false
            };
            $uibModal.open({
                templateUrl: '../app/orderDetails/views/warehouseDetails.tpl.html',
                size: 'md',
                controller: 'warehouseDetailsController',
                resolve: {
                    userPreference: function() {
                            return $scope.$parent.userPreferences;
                      }
                    ,
                    warehouseDetails: function () {
                        return locationInfo;
                    }
                }
            });
        };

      $scope.getDisplayDateTime = DateTimeService.getDisplayDateTime;

    }
    angular.module('NavisphereOnline').controller('pickupDetailsController', pickupDetailsController);
})();

/*global $ */
/*eslint angular/no-private-call:0*/
(function () {
  'use strict';
  orderDetailsController.$inject = ['DocumentManagerService', '$scope', '$state', '$uibModal', '$interval', '$q', '$filter',
    '$uibModalStack', 'RefDataMappingService', 'CustomerService', 'ServiceOffering', 'user', 'orderDetails',
    'userPreferences', '$window', 'UserPermissionService', 'refDataDDLs', 'OrderTransformService', 'OrderLockHelper',
    'ModalService', 'NotificationService', 'StatusMappingService', 'OrderLockPromptService', 'ConversionService',
    'OrderService', 'DateTimeService', 'OrderEditRulesService', 'CarrierLogService', 'localStorageService',
    'UnitsOfMeasurementService'];

  function orderDetailsController( DocumentManagerService, $scope, $state, $uibModal, $interval, $q, $filter, $uibModalStack,
                                  RefDataMappingService, CustomerService, ServiceOffering, user, orderDetails,
                                  userPreferences, $window, UserPermissionService, refDataDDLs, OrderTransformService,
                                  OrderLockHelper, ModalService, NotificationService, StatusMappingService,
                                  OrderLockPromptService, ConversionService, OrderService, DateTimeService,
                                  OrderEditRulesService, CarrierLogService, localStorageService, UnitsOfMeasurementService) {

    $scope.cancelInverval = function(){
      if ($scope.interval) {
        $interval.cancel($scope.interval);
      }
    };

    $scope.getTrackingNumber = function (order) {
      if (!order || !order.referenceNumbers || order.referenceNumbers.length === 0) {
        return null;
      }

      for (var i = 0; i < order.referenceNumbers.length; i++) {
        if (order.referenceNumbers[i].referenceNumberType.refDataNumber ==
          RefDataMappingService.getCategoryId('TRACKING_NUMBER')) {
          return order.referenceNumbers[i].value;
        }
      }

      return null;
    };

    $scope.sendTrackingModal = function(){
      $uibModal.open({
        templateUrl: 'app/common/views/sendTracking.tpl.html',
        size: 'lg',
        controller: 'sendTrackingController',
        resolve: {
          trackingNumber: function () {
            return $scope.order.trackingNumber;
          },
          user: ['UserServiceHelper', function (UserServiceHelper) {
            return UserServiceHelper.get();
          }]
        }
      });
    };

    $scope.getBillToRefNum = function(order) {
      if (!order || !order.billTos || !order.billTos[0] || !order.billTos[0].referenceNumbers
        || order.billTos[0].referenceNumbers.length === 0) {
        return null;
      }

      for (var i = 0; i < order.billTos[0].referenceNumbers.length; i++) {
        if (order.billTos[0].referenceNumbers[i].isPrimary) {
          return order.billTos[0].referenceNumbers[i].value;
        }
      }

      return null;
    };


    $scope.releaseOrderLock = function () {
      $scope.cancelInverval();
      OrderLockHelper.releaseOrderLock();
    };

    $scope.releaseOrderLockSync = function () {

      OrderLockHelper.releaseOrderLockSync();
      $scope.cancelInverval();
    };

    /*
      summarized field names
    */
    var WEIGHT = 'weight';
    var TOTAL_INSURANCE_VALUE = 'totalInsuranceValue';
    var PALLETS = 'totalPallets';
    var QTY = 'unitQuantity';
    var onRouteChangeOff;

    //
    $scope.DateTimeService = DateTimeService;
    $scope.order = OrderTransformService.getOrderForEdit(orderDetails, userPreferences);
    $scope.user = user;
    $scope.userPreferences = userPreferences;
    $scope.oneAtATime = true;
    $scope.orderIsDraw = orderDetails.sourceRDN === RefDataMappingService.getItemId('PO_DRAW_SOURCE');
    $scope.editRules = orderDetails.editRules;
    $scope.editAllowed = function (actionKey) {
      for (var i = 0; i < $scope.editRules.length; i++) {
        if ($scope.editRules[i].actionKey === actionKey) {
          return $scope.editRules[i].allowed;
        }
      }
      return false;
    };

    $scope.reorder = function () {
      var createOrderUrl = $window.location.origin + '/orders/#/create/' + $scope.order.customerOrderNumber
      window.location.href = createOrderUrl;
    };

    $scope.redirectToBetaPage = function () {
      var createRedirectBetaPageUrl = $window.location.origin + '/orders/#/detail/' + $scope.order.customerOrderNumber
      window.location.href = createRedirectBetaPageUrl;
    };

    $scope.initialize = function () {
      var isMetric = $scope.userPreferences.unitOfMeasure === 'metric';
      $scope.orionStatus = $filter('translate')(StatusMappingService.getStatusResourceKey($scope.order.service.statusRDN));
      $scope.itemDdlRefData = refDataDDLs;
      $scope.orderIsCanceled = $scope.order.conditionRDN === RefDataMappingService.getItemId('CANCELED_CONDITION');
      $scope.hasEditPermission = !$scope.orderIsCanceled && UserPermissionService.hasCustomerRole($scope.order.customerInfo.customer.partyCode, "Edit Order");
      $scope.hasReorderPermission = UserPermissionService.hasCustomerRole($scope.order.customerInfo.customer.partyCode, "Create Order");

      $scope.canEditShippingMethod = $scope.hasEditPermission && ($scope.editAllowed('UPDATE_BILL_TO_REFERENCE_NUMBERS')
        || $scope.editAllowed('UPDATE_CUSTOMER_REFERENCE_NUMBERS'));


      $scope.canEditPickupFrom = $scope.hasEditPermission && ($scope.editAllowed('UPDATE_ORIGIN_LOCATION')
        || $scope.editAllowed('UPDATE_READY_BY_DATE_TIME')
        || $scope.editAllowed('UPDATE_PICK_UP_BY_DATE_TIME')
        || $scope.editAllowed('UPDATE_ORIGIN_REFERENCE_NUMBERS')
        || $scope.editAllowed('UPDATE_ORIGIN_SPECIAL_INSTRUCTIONS'));

      $scope.canEditDeliverTo = $scope.hasEditPermission && ($scope.editAllowed('UPDATE_DESTINATION_LOCATION')
        || $scope.editAllowed('UPDATE_AVAILABLE_DELIVERY_DATE_TIME')
        || $scope.editAllowed('UPDATE_DELIVERY_BY_DATE_TIME')
        || $scope.editAllowed('UPDATE_DESTINATION_REFERENCE_NUMBERS')
        || $scope.editAllowed('UPDATE_DESTINATION_SPECIAL_INSTRUCTIONS'));

      $scope.canEditShippingItems = $scope.hasEditPermission && ($scope.editAllowed('DELETE_COMMODITY')
        || $scope.editAllowed('ADD_NEW_COMMODITY')
        || $scope.editAllowed('UPDATE_COMMODITY')
        || $scope.editAllowed('UPDATE_COMMODITY_REFERENCE_NUMBERS'));

      angular.forEach($scope.order.service.items, function (item) {
        if (!item.totalWeight) {
          item.totalWeight = {
            unitRDN: $scope.userPreferences.unitOfMeasure === 'metric'
              ? RefDataMappingService.getItemId('KG_UOM')
              : RefDataMappingService.getItemId('LB_UOM')
          };
        }

        if (item.commodity.isStackable) {
          item.isStackable = true;
        } else {
          item.isStackable = false;
        }

        if(item.unitLength && item.unitWidth && item.unitHeight) {
          if(!item.unitLength.unitRDN && !item.unitWidth.unitRDN && !item.unitHeight.unitRDN) {
            setUnitsOfMeasurement(item, isMetric);
          }
        }
        else {
          item.unitLength = { value: null };
          item.unitWidth = { value: null };
          item.unitHeight = { value: null };
          setUnitsOfMeasurement(item, isMetric);
        }
      });

      $scope.order.billToRefNum = $scope.getBillToRefNum($scope.order);
      $scope.order.trackingNumber = $scope.getTrackingNumber($scope.order);
    };

    $scope.initialize();
    $scope.getDisplayName = CustomerService.GetDisplayName;
    $scope.serviceOfferingName = '';
    $scope.serviceOfferingGenericType = '';
    $scope.serviceOfferingIconUrl = '';
    $scope.displayDryHours = true;
    $scope.refDataDDLs = refDataDDLs;
    $scope.isHazmat = hasHazmatItem();
    $scope.editRules = orderDetails.editRules;

    $scope.$on('$destroy', function () {
      $window.onbeforeunload = undefined;
    });

    setServiceOfferingDisplay();

    var modalOptions = {
      closeButtonText: 'CANCEL',
      actionButtonText: 'OK',
      headerText: 'ARE_YOU_SURE_YOU_WANT_TO_EXIT_THIS_ORDER',
      bodyText: 'ALL_INFORMATION_ENTERED_FOR_THIS_ORDER_WILL_BE_LOS'
    };

    $scope.sections = [{
      id: 1,
      title: 'ACCOUNT',
      headerUrl: 'app/orderDetails/views/customerSummary.tpl.html',
      templateUrl: null,
      active: false,
      visited: false,
      complete: function () {
        return $scope.order.validator.customerValid;
      },
      disabled: function () {
        return false;
      },
      buttonText: null,
      isEditSection: false,
      hideHeading: true,
      isWide: true
    },
      {
        id: 2,
        title: 'CHARGES',
        headerUrl: 'app/orderDetails/views/chargesDetails.tpl.html',
        templateUrl: null,
        active: false,
        visited: false,
        isWide: true,
        isEditSection: false,
        buttonText: null,
        hidePanel: angular.isDefined($scope.order.charges) && $scope.order.charges.length < 1
      },
      {
        id: 3,
        title: 'REFERENCE_S',
        headerUrl: 'app/orderDetails/views/referenceNumberDetails.tpl.html',
        templateUrl: 'app/orderDetails/views/referenceNumberEdit.tpl.html',
        active: false,
        visited: false,
        complete: function () {
          return $scope.order.validator.serviceOfferingValid;
        },
        disabled: function () {
          return !$scope.canEditShippingMethod;
        },
        buttonText: $filter('translate')('EDIT'),
        onOpen: lockOrder,
        canOpen: canOpen,
        isEditSection: true
      },
      {
        id: 4,
        title: 'PICKUP_FROM',
        headerUrl: 'app/orderDetails/views/pickupDetails.tpl.html',
        templateUrl: 'app/orderDetails/views/pickupEdit.tpl.html',
        active: false,
        visited: false,
        complete: function () {
          return $scope.order.validator.pickupValid;
        },
        disabled: function () {
          return !$scope.canEditPickupFrom;
        },
        buttonText: $filter('translate')('EDIT'),
        onOpen: lockOrder,
        canOpen: canOpen,
        isEditSection: true
      },
      {
        id: 5,
        title: 'DELIVER_TO',
        headerUrl: 'app/orderDetails/views/deliveryDetails.tpl.html',
        templateUrl: 'app/orderDetails/views/deliveryEdit.tpl.html',
        active: false,
        visited: false,
        complete: function () {
          return $scope.order.validator.deliveryValid;
        },
        disabled: function () {
          return !$scope.canEditDeliverTo;
        },
        buttonText: $filter('translate')('EDIT'),
        onOpen: lockOrder,
        canOpen: canOpen,
        isEditSection: true
      },
      {
        id: 6,
        title: 'SHIPPING_ITEMS',
        headerUrl: 'app/orderDetails/views/itemDetails.tpl.html',
        templateUrl: 'app/orderDetails/views/itemEdit.tpl.html',
        active: false,
        visited: false,
        isWide: true,
        complete: function () {
          return $scope.order.validator.itemsValid && $scope.order.service.items.length > 0;
        },
        disabled: function () {
          return !$scope.canEditShippingItems;
        },
        buttonText: $filter('translate')('EDIT'),
        onOpen: lockOrder,
        canOpen: canOpen,
        isEditSection: true
      }
    ];

    $scope.itemSummary = {
      lineItems: 0,
      weight: 0,
      insuranceValue: 0,
      pallets: 0,
      quantity: 0
    };

    $scope.order.validator = {
      customerValid: null,
      serviceOfferingValid: null,
      itemsValid: null,
      deliveryValid: null,
      pickupValid: null,
      customerAndServiceOfferingValid: function () {
        return this.customerValid && this.serviceOfferingValid;
      }
    };
    $scope.$watch('orderDetailsForm.shipMethodForm.$valid', function (value) {
      $scope.order.validator.serviceOfferingValid = value;
    });
    $scope.$watch('orderDetailsForm.pickupForm.$valid', function (value) {
      $scope.order.validator.pickupValid = value;
    });
    $scope.$watch('orderDetailsForm.deliveryForm.$valid', function (value) {
      $scope.order.validator.deliveryValid = value;
    });
    $scope.$watch('orderDetailsForm.itemsForm.$valid && order.service.items.length > 0', function (value) {
      $scope.order.validator.itemsValid = value;
    });

    function setUnitsOfMeasurement(item, isMetric) {
      UnitsOfMeasurementService.setUnitsOfMeasurement(item, isMetric)
    }

    $scope.getUserPreferenceWeightUoM = function () {
      var uomTranslation = '';
      if ($scope.userPreferences.unitOfMeasure === 'standard') {
        uomTranslation = RefDataMappingService.getUomTranslationByRefNum(RefDataMappingService.getItemId('LB_UOM'));
      }
      else if ($scope.userPreferences.unitOfMeasure === 'metric') {
        uomTranslation = RefDataMappingService.getUomTranslationByRefNum(RefDataMappingService.getItemId('KG_UOM'));
      }

      return uomTranslation;
    };

    function setServiceOfferingDisplay() {
      if (!$scope.order || !$scope.order.service || !$scope.order.service.serviceOffering)
        return;
      var offering = ServiceOffering.get($scope.order.service.serviceOffering.id);
      $scope.displayDryHours = offering.displayDryHours;
      $scope.serviceOfferingName = offering.serviceOfferingName;
      $scope.serviceOfferingGenericType = offering.genericType;
      $scope.serviceOfferingIconUrl = offering.serviceOfferingIconUrl;
    }

    $scope.getLocationDisplayName = function (location) {
      if (location) return location.locationPartyName;
      return '';
    };


    function hasHazmatItem() {
      for (var i = 0; i < $scope.order.service.items.length; i++) {
        if ($scope.order.service.items[i].commodity && $scope.order.service.items[i].commodity.isHazardous) {
          return true;
        }
      }
      return false;
    }

    $scope.openDocumentViewer = function () {
      var controller = 'orderDocumentViewerController';
      var resolveObject = {
            order: function () {
              return $scope.order;
            },
            documents: ['DocumentService', function (DocumentService) {
              return DocumentService.getAll({orderNumber: $scope.order.customerOrderNumber, cCode: $scope.order.customerInfo.customer.partyCode}).$promise;
            }]
          };

      DocumentManagerService.openDocumentViewer(controller, null, resolveObject);
    };

    $scope.submittingOrder = false;

    $scope.showValidationError = function (validationMessages) {
      $scope.showValidationErrorModal = $uibModal.open({
        templateUrl: 'app/validationModal/validationModal.tpl.html',
        size: 'lg',
        controller: 'validationModalController',
        resolve: {
          validations: function () {
            return validationMessages;
          },
          title: function () {
            return $filter('translate')('WE_WERE_NOT_ABLE_TO_PROCESS_YOUR_ORDER_PLEASE_RESO');
          }
        }
      });

      $scope.showValidationErrorModal.result.then(function () {
        $scope.submittingOrder = false;
      }, function () {
        $scope.submittingOrder = false;
      });
    };

    $scope.submitOrder = function () {

      var validationMessages = [];

      if (!$scope.submittingOrder) {
        $scope.submittingOrder = true;

        if (!$scope.order.validator.serviceOfferingValid)
          validationMessages.push($filter('translate')('REFERENCE_S'));

        if (!$scope.order.validator.pickupValid)
          validationMessages.push($filter('translate')('PICKUP_FROM'));

        if (!$scope.order.validator.deliveryValid)
          validationMessages.push($filter('translate')('DELIVER_TO'));

        if (!$scope.order.validator.itemsValid)
          validationMessages.push($filter('translate')('SHIPPING_ITEMS'));

        if (validationMessages.length > 0) {

          for (var key in $scope.sections)
            $scope.sections[key].visited = true;

          $scope.showValidationError(validationMessages);

        } else if (DateTimeService.startDateTimeLessThanOrEqualEndDateTime($scope.order.service.pickupFrom.uiLatestDate,
            $scope.order.service.pickupFrom.uiLatestTime, $scope.order.service.deliverTo.uiEarliestDate,
            $scope.order.service.deliverTo.uiEarliestTime)) {

          $scope.loadingModal = $uibModal.open({
            templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
            size: 'sm',
            controller: 'loadingSpinnerController',
            backdrop: 'static',
            resolve: {
              title: function () {
                return $filter('translate')('PLACING_ORDER');
              }
            }
          });

          OrderLockPromptService.lock.orderNumber = $scope.order.customerOrderNumber;
          var customerOrderRequest = {
            order: OrderTransformService.getCustomerOrderUpdateRequest($scope.order),
            lock: OrderLockPromptService.lock
          };
          var orderService = new OrderService(customerOrderRequest);
          orderService.$update().then(function (result) {
            $scope.loadingModal.close(result);
            if (result.success) {
              OrderLockPromptService.lock = null;

              $scope.cancelInverval();

              $scope.orderDetailsForm.$dirty = false;
              $state.go('app.orderEditConfirmation', {
                orderNumber: result.orderNumber
              });
            } else {
              angular.forEach(result.errors, function (error) {
                validationMessages.push($filter('translate')(error.errorMessage));
              });
              $scope.showValidationError(validationMessages);
            }
          }, function (result) {
            $scope.loadingModal.close(result);
            validationMessages.push($filter('translate')('WE_ARE_UNABLE_TO_PROCESS_YOUR_ORDER_AT_THIS_TIME_P'));
            $scope.showValidationError(validationMessages);
          });
        } else {
          validationMessages.push($filter('translate')('PICKUP_LATEST_DATE_TIME_RANGE_MUST_BE_BEFORE_DELIV'));
          $scope.showValidationError(validationMessages);
        }
      }
    };

    $scope.goBack = function () {
      $window.history.back();
    };

    $scope.cancelOrder = function () {

      var cancelModalOptions = {
        closeButtonText: 'NO',
        actionButtonText: 'YES',
        headerText: 'ARE_YOU_SURE_YOU_WANT_TO_CANCEL_EDITING_THIS_ORDER',
        bodyText: 'ALL_INFORMATION_ENTERED_FOR_THIS_ORDER_WILL_BE_LOS'
      };

      if ($scope.hasEditPermission && $scope.orderDetailsForm && $scope.orderDetailsForm.$dirty) {
        ModalService.showModal({}, cancelModalOptions).then(function (result) {
          if (result === 'ok') {
            if (OrderLockPromptService.lock) {
              $scope.releaseOrderLockSync();
            }

            $scope.reloadPage();
          }
        }, function () {
        });
      }
    };


    $scope.interval = null;

    $scope.updateOrderDetails = function() {
      OrderService.getOrder({orderNumber: $scope.order.customerOrderNumber})
        .$promise.then(function (orderDetails) {
        OrderEditRulesService.getOrderEditRules({serviceStatusRDN: orderDetails.services[0].statusRDN}).$promise
          .then(function (editRules) {
            orderDetails.editRules = editRules;
            $scope.order = OrderTransformService.getOrderForEdit(orderDetails, userPreferences);
            $scope.order.validator = {
              customerValid: null,
              serviceOfferingValid: null,
              itemsValid: null,
              deliveryValid: null,
              pickupValid: null,
              customerAndServiceOfferingValid: function () {
                return this.customerValid && this.serviceOfferingValid;
              }
            };
            $scope.initialize();
          });
      });
    };

    function lockOrder() {

      OrderLockHelper.lockOrder($scope.order.customerOrderNumber.toString()).$promise.then(function (result) {

        if (result) {

          OrderLockPromptService.lock = result;

          $scope.cancelInverval();
          $scope.interval = $interval(lockTimer, 60000, 60);

          $scope.updateOrderDetails();
        }
      });
    }

    function lockTimer(count) {
      if (count >= 59) {
        $scope.releaseOrderLock();
        $uibModal.open({
          templateUrl: '../app/orderDetails/views/lockExpiredModal.tpl.html',
          size: 'md',
          controller: 'lockExpiredModalController'
        }).result.then(function () {
          $scope.reloadPage();
          $window.onbeforeunload = undefined;
        }, function () {
          $scope.reloadPage();
          $window.onbeforeunload = undefined;
        });

      }
      else if (count === 55) {
        NotificationService.warn($filter('translate')('YOU_HAVE_5_MINUTES_TO_COMPLETE_CHANGES_BEFORE_THEY'));
      }
    }

    $scope.reloadPage = function() {
      $scope.orderDetailsForm.$setPristine();
      $state.reload();
    };

    function canOpen() {

      var d = $q.defer();

      if (OrderLockPromptService.lock)
        d.resolve(true);
      else {

        OrderLockHelper.lockOrder($scope.order.customerOrderNumber.toString()).$promise.then(function (data) {

          if (!data.user) {
            $uibModal.open({
              templateUrl: '../app/orderDetails/views/tryToGetLockAgainModal.tpl.html',
              size: 'md',
              controller: 'tryToGetLockAgainModalController',
              resolve: {
                orderNumber: function () {
                  return $scope.order.customerOrderNumber;
                }
              }
            }).result.then(function (result) {

              if (result) {

                OrderLockPromptService.lock = result;

                $scope.cancelInverval();
                $scope.interval = $interval(lockTimer, 60000, 60);

                $scope.updateOrderDetails();
              }

              d.resolve(result != null);
            });
          } else {

            OrderLockPromptService.lock = data;

            $scope.cancelInverval();
            $scope.interval = $interval(lockTimer, 60000, 60);
            d.resolve(true);
          }

        }, function () {
          d.resolve(false);
        });
      }

      return d.promise;
    }

    $scope.windowOnBeforeUnload = function (event) {
      if (!$scope.hasEditPermission || !$scope.orderDetailsForm || !$scope.orderDetailsForm.$dirty) {
        if (OrderLockPromptService.lock) {
          $scope.releaseOrderLockSync();
        }
        return;
      }

      var message = $filter('translate')('ARE_YOU_SURE_YOU_WANT_TO_EXIT_THIS_ORDER') + ' ' + $filter('translate')('ALL_INFORMATION_ENTERED_FOR_THIS_ORDER_WILL_BE_LOS');
      if (typeof event == 'undefined') {
        event = $window.event;
      }
      if (event) {
        event.returnValue = message;
      }
      return message;
    };

    $window.onbeforeunload = $scope.windowOnBeforeUnload;

    $scope.windowOnnUnload = function () {
      if (OrderLockPromptService.lock) {
        $scope.releaseOrderLockSync();
      }
    };

    $window.onunload = $scope.windowOnnUnload;

    $scope.carrierLogs = undefined;
    $scope.carrierLogExpanded = false;
    $scope.carrierLogsLoading = false;
    $scope.expandCarrierLogs = function() {
      if(angular.isUndefined($scope.carrierLogs)){
        $scope.carrierLogsLoading = true;
        $scope.carrierLogs = CarrierLogService.get({
          orderNumber: $scope.order.customerOrderNumber
        }, function(){
          $scope.carrierLogsLoading = false;
        }, function(){
          $scope.carrierLogsLoading = false;
        });

      }
      $scope.carrierLogExpanded = !$scope.carrierLogExpanded;
    };
    $scope.getLocationDisplay = function (log){
      var loc = '';
      if(log.driverLocation){
        if(log.driverLocation.city) {
          loc = log.driverLocation.city;
        }
        if(log.driverLocation.city && log.driverLocation.state){
          loc += ', ' + log.driverLocation.state;
        }
        else if(log.driverLocation.state){
          loc = log.driverLocation.state;
        }
      }
      return loc;
    };

    $scope.summaryFieldUpdates = [];

    $scope.summaryUpdate = function (fieldName) {
      $scope.summaryFieldUpdates.push(fieldName);
    };

    $scope.inSummaryUpdate = false;
    $scope.$watchCollection('summaryFieldUpdates', function (newVal) {
      if (!$scope.inSummaryUpdate) {
        $scope.inSummaryUpdate = true;
        $scope.itemSummary.lineItems = $scope.order.service.items.length;
        angular.forEach(newVal, function (fieldChangedName, i) {
          var valueSum = 0;
          angular.forEach($scope.order.service.items, function (item) {
            if (fieldChangedName == WEIGHT) {

              // Set default weight unit RDN if it does not exist
              if (!item.totalWeight) {
                item.totalWeight = {
                  value: undefined,
                  unitRDN: getDefaultWeightRDN(item)
                }
              }

              if (item.totalWeight) {
                if (RefDataMappingService.getItemByRefNum(item.totalWeight.unitRDN) === 'LB_UOM' && $scope.userPreferences.unitOfMeasure === 'metric') {
                  valueSum += isFinite(Number(item.totalWeight.value))
                    ? ConversionService.convertLBtoKG(Number(item.totalWeight.value), 2) : 0;
                }
                else if (RefDataMappingService.getItemByRefNum(item.totalWeight.unitRDN) === 'KG_UOM' && $scope.userPreferences.unitOfMeasure === 'standard') {
                  valueSum += isFinite(Number(item.totalWeight.value))
                    ? ConversionService.convertKGtoLB(Number(item.totalWeight.value), 2) : 0;
                } else {
                  valueSum += isFinite(Number(item.totalWeight.value)) ? Number(item.totalWeight.value) : 0;
                }
              }
            } else {
              valueSum += isFinite(Number(item[fieldChangedName])) ? Number(item[fieldChangedName]) : 0;
            }
          });
          switch (fieldChangedName) {
            case WEIGHT:
              $scope.itemSummary.weight = valueSum;
              break;
            case TOTAL_INSURANCE_VALUE:
              $scope.itemSummary.insuranceValue = valueSum;
              break;
            case PALLETS:
              $scope.itemSummary.pallets = valueSum;
              break;
            case QTY:
              $scope.itemSummary.quantity = valueSum;
              break;
            default:
              break;
          }
          newVal.splice(i, 1);
        });
        $scope.inSummaryUpdate = false;
      }
    });

    $scope.updateSummary = function () {
      $scope.summaryFieldUpdates.push(WEIGHT, TOTAL_INSURANCE_VALUE, PALLETS, QTY);
    };

    $scope.updateSummary();
    $scope.routeChange = function (event, toState, toParams, fromState) {
      if (!localStorageService.get('credentials')) {
        return;
      }
      if (!$scope.hasEditPermission || !$scope.orderDetailsForm || !$scope.orderDetailsForm.$dirty) {

        if (OrderLockPromptService.lock && toState.name !== 'app.orderEditConfirmation') {

          event.preventDefault();
          $scope.releaseOrderLock().then(function () {
            onRouteChangeOff();
            $state.go(toState);
          }, function () {
            onRouteChangeOff();
            $state.go(toState);
          });
        } else {
          OrderLockPromptService.lock = null;
          $scope.cancelInverval();
        }
        return;
      }
      ModalService.showModal({}, modalOptions).then(function (result) {
        if (result === 'ok') {
          if (OrderLockPromptService.lock) {
            $scope.releaseOrderLockSync();
          }
          onRouteChangeOff();
          $uibModalStack.dismissAll(result);
          $state.go(toState);
        }
      });
      event.preventDefault();
    };

    function getDefaultWeightRDN(item) {
      var weightUnitRDN = RefDataMappingService.getWeightUnitRDNFromItem(item);

      if (weightUnitRDN == null) {
        var isMetric = isMetric = $scope.userPreferences.unitOfMeasure === 'metric';
        weightUnitRDN = isMetric
          ? RefDataMappingService.getItemId('KG_UOM')
          : RefDataMappingService.getItemId('LB_UOM');
      }

      return weightUnitRDN;
    }

    $scope.initRouteChange = function () {
      onRouteChangeOff = $scope.$on('$stateChangeStart', $scope.routeChange);
    };
    $scope.initRouteChange();
  }
  angular.module('NavisphereOnline').controller('orderDetailsController', orderDetailsController);
})();

/*global $ */
/*eslint angular/no-private-call:0*/
(function () {
  'use strict';
  newOrderDetailsController.$inject = ['$window', '$stateParams'];

  function newOrderDetailsController($window, $stateParams) {
      var reactOrderDetailsUrl = $window.location.origin + '/orders/#/detail/' + $stateParams.orderNumber
      window.location.href = reactOrderDetailsUrl;
	}
   
  angular.module('NavisphereOnline').controller('newOrderDetailsController', newOrderDetailsController);
})();

(function () {
    'use strict';
    lockExpiredModalController.$inject = ['$scope', '$uibModalInstance'];

    function lockExpiredModalController($scope, $uibModalInstance) {

        $scope.ok = function () {
            $uibModalInstance.close(null);
        };
    }
    angular.module('NavisphereOnline').controller('lockExpiredModalController', lockExpiredModalController);
})();

(function () {
    'use strict';
    itemEditController.$inject = ['$scope', '$timeout', '$filter', '$uibModal', 'ItemService', 'ItemServiceHelper', 'UserPermissionService',
        'ModalService', 'RefDataMappingService', "FormService", 'ServiceOffering', '$document', '$window', 'UnitsOfMeasurementService'];
    function itemEditController($scope, $timeout, $filter, $uibModal, ItemService, ItemServiceHelper, UserPermissionService,
        ModalService, RefDataMappingService, FormService, ServiceOffering, $document,$window, UnitsOfMeasurementService) {
        //summarized field names
        var WEIGHT = 'weight';
        $scope.hasAddNewCommodityPerTrans = UserPermissionService.hasCustomerRole($scope.order.customerInfo.customer.partyCode, 'Add New Commodity Per Transaction');
        $scope.hasCreateNewCommodityInPartyCatalog = UserPermissionService.hasCustomerRole($scope.order.customerInfo.customer.partyCode, 'Create New Commodity in Party Catalog');
        $scope.isFlatbed = ServiceOffering.get($scope.order.service.serviceOffering.id).genericType === 'FLATBED';
        $scope.searchItemResults = [];
        $scope.itemFilter = '';
        $scope.newItemRefTypes = [
            { description: $filter('translate')('PO_POUND'), refDataNumber: RefDataMappingService.getItemId('PURCHASE_ORDER_NUMBER') }
        ];
        var isMetric = $scope.userPreferences.unitOfMeasure === 'metric';

        $scope.setItemAsVisited = function (item) {
          item.visited = true;
        };
        $scope.isStackableClick = function(item) {
            $scope.orderDetailsForm.$setDirty();
            item.isStackable = !item.isStackable;
            item.commodity.isStackable = item.isStackable;
        };
        giveItemsDefaultPoRefNums();
        function giveItemsDefaultPoRefNums(){
          for(var i = 0; i < $scope.order.service.items.length; i++){
            var itemHasPoRef = false;
            for(var j = 0; j < $scope.order.service.items[i].referenceNumbers.length; j++){
              if($scope.order.service.items[i].referenceNumbers[j].referenceNumberType.refDataNumber === RefDataMappingService.getItemId('PURCHASE_ORDER_NUMBER')){
                $scope.order.service.items[i].referenceNumbers[j].sortOrder = 0;
                itemHasPoRef = true;
              } else {
                $scope.order.service.items[i].referenceNumbers[j].sortOrder = 1;
              }
            }
            if(!itemHasPoRef){
              var poRefNum = {
                referenceNumberType: {
                  description: $filter('translate')('PO_POUND'),
                  refDataNumber: RefDataMappingService.getItemId('PURCHASE_ORDER_NUMBER') },
                sortOrder: 0
              };

              $scope.order.service.items[i].referenceNumbers.push(poRefNum);
            }
          }
        }
        function setDDLValByRdn(category, tempCatRdn) {
            var tc = undefined;
            for (var i = 0 ; i < $scope.itemDdlRefData[category].length; i++) {
                if ($scope.itemDdlRefData[category][i].refDataNumber === tempCatRdn) {
                    tc = $scope.itemDdlRefData[category][i];
                    break;
                }
            }
            return tc;
        }

        function hydrateItem(item) {
            return ItemService.get({ itemId: item.itemId }, function (itemDetails) {
                if ($scope.isFlatbed) {
                    itemDetails.temperatureCategoryRDN = RefDataMappingService.getItemId('DRY_TEMP_CATEGORY');
                } else {
                    itemDetails.temperatureCategoryRDN = (!itemDetails.temperatureCategoryRDN)
                        ? RefDataMappingService.getItemId('DRY_TEMP_CATEGORY')
                        : itemDetails.temperatureCategoryRDN;
                }
                item.itemDetails = setDDLValByRdn('Packaging', itemDetails.packagingTypeRDN);
                itemDetails.commodity.sku = item.sku;
                return itemDetails;
            }).$promise;
        }
        $scope.onItemSelected = function (cmdty) {
            $scope.itemFilter = '';
            hydrateItem(cmdty).then(function (item) {
                item.isNew = true;
                setPreviousItemsTouched();
                setUnitsOfMeasurment(item);
                addDefaultItemPoRefNum(item);
                addDefaultStackable(item);
                $scope.order.service.items.push(item);
                setFocusToAddedItem();
                registerItem();
                ieSelectFix();
            });
        };
        $scope.addShipmentItem = function () {

            setPreviousItemsTouched();
            var item = {
                commodity: {}, referenceNumbers: [], equipmentLength: {},
                equipmentWidth: {}, equipmentHeight: {}, totalWeight: {},
                isNew: true,description: ''
            };
            item.temperatureCategoryRDN = RefDataMappingService.getItemId('DRY_TEMP_CATEGORY');
            setUnitsOfMeasurment(item);
            addDefaultItemPoRefNum(item);
            addDefaultStackable(item);
            $scope.order.service.items.push(item);
            setFocusToAddedItem();
            registerItem();
            angular.element('#itemSearchInput').val('');
            ieSelectFix();
        };
        function addSuggestedShipmentItem(suggestedItem) {
            $scope.itemFilter = '';
            suggestedItem.flatbed = {};
            hydrateItem(suggestedItem).then(function (itemDetail) {
                itemDetail.isNew = true;
                setPreviousItemsTouched();
                setUnitsOfMeasurment(itemDetail);
                addDefaultItemPoRefNum(itemDetail);
                addDefaultStackable(itemDetail);
                $scope.order.service.items.push(itemDetail);
                setFocusToAddedItem();
                registerItem();
                ieSelectFix();
            });
        }

        function addNewlyAddedItem(item) {
            item.commodityName = item.description;
            item.commodity = {};
            item.commodity.commodityName = item.description;
            item.commodity.isHot = item.isHot;
            item.quantity = item.qty;
            item.isNew = true;
            if (item.flatbed) {
                if (item.flatbed.tarp) {
                    item.tarpTypeRDN = item.flatbed.tarp.refDataNumber;
                }
                if (item.flatbed.loading) {
                    item.loadingTypeRDN = item.flatbed.loading.refDataNumber;
                }
                if (item.flatbed.equipment) {
                    item.itemEquipmentRDN = item.flatbed.equipment.refDataNumber;
                }
                item.maxTrailerAge = item.flatbed.trailerage;
                item.requiredStrapsCount = item.flatbed.straps;
                item.requiredChainsCount = item.flatbed.chains;
                item.coilRacks = item.flatbed.coilRacks;
                item.lockBars = item.flatbed.locksbars;
                item.equipmentHeight = {
                    value: item.flatbed.height,
                    unitRDN: inUomRefNum
                };
                item.equipmentWidth = {
                    value: item.flatbed.width,
                    unitRDN: inUomRefNum
                };
                item.equipmentLength = {
                    value: item.flatbed.length,
                    unitRDN: ftUomRefNum
                };
            }
            if (item.freightClass) {
                item.freightClassRDN = item.freightClass.refDataNumber;
            }
            if (item.tempCategory) {
                item.temperatureCategoryRDN = item.tempCategory.refDataNumber;
            }
            if (item.packaging) {
                item.packagingTypeRDN = item.packaging.refDataNumber;
            }
            item.totalWeight = {
                value: item.weight,
                unitRDN: item.weightUom
            };
            if (item.poNum) {
                if (!item.referenceNumbers) {
                    item.referenceNumbers = [];
                }
                item.referenceNumbers.push({
                    value: item.poNum,
                    referenceNumberType: {
                        description: $filter('translate')('PO_POUND'),
                        refDataNumber: RefDataMappingService.getItemId('PURCHASE_ORDER_NUMBER')
                    }
                });
            } else {
              addDefaultItemPoRefNum(item);
            }
            item.totalPallets = item.pallets;
            item.totalPalletSpaces = item.palletSpaces;
            item.unitQuantity = item.qty;
            item.totalTrailerFeet = item.trailerFeet;
            $scope.itemFilter = '';
            setPreviousItemsTouched();
            item.freightClass = item.freightClass;
            setUnitsOfMeasurment(item);
            $scope.order.service.items.push(item);
            addDefaultStackable(item);
            setFocusToAddedItem();
            registerItem();
            ieSelectFix();
            $scope.orderDetailsForm.$setDirty();
        }
        function addDefaultStackable(item) {
            item.commodity.isStackable = null;
            item.isStackable = null;
        }
        function addDefaultItemPoRefNum(item) {
          if (!item.referenceNumbers) {
            item.referenceNumbers = [];
          }
          item.referenceNumbers.push({
            referenceNumberType: {
              description: $filter('translate')('PO_POUND'),
              refDataNumber: RefDataMappingService.getItemId('PURCHASE_ORDER_NUMBER')
            }
          });
        }
        $scope.findRdnByValue = function(category, value){
          if(!angular.isDefined(category) || !angular.isDefined(value)){
            return;
          }
          return _.find($scope.refDataDDLs[category], function(x){
            if(!angular.isDefined(x.refDataCode)){
              return false;
            }
            return x.refDataCode.toUpperCase() === value.toUpperCase()
          });
        };
        $scope.addDrawItem = function(){
          var modalInstance = $uibModal.open({
            templateUrl: '../app/addItemModals/views/addDraw.tpl.html',
            size: 'lg',
            controller: 'AddDrawController',
            backdrop: 'static',
            resolve: {
              user: function () {
                return $scope.user;
              },
              preferences: function () {
                return $scope.userPreferences;
              },
              customer: function () {
                return $scope.order.customerInfo.customer;
              },
              refDataDDLs: function() { return $scope.refDataDDLs; }
            }
          });
          modalInstance.result.then(function (item) {
            var packaging = $scope.findRdnByValue('Packaging', item.outerPackType);
            var freightClass = $scope.findRdnByValue('FreightClass', item.freightClass);
            var convertedItem = {
              purchaseOrderItemId: item.purchaseOrderItemId,
              commodity: { sku: item.sku, upc: item.upc, plu: item.plu },
              description: item.productName,
              totalWeight: {value: item.outerPackWeight,unitRdn: item.outerPackIsMetric ? RefDataMappingService.getItemId('KG_UOM') : RefDataMappingService.getItemId('LB_UOM')},
              unitQuantity: item.availableQuantity,
              purchaseOrderNumber: item.purchaseOrderNumber,
              lineItemNumber: item.lineItemNumber,
              lineItemId: item.lineItemId,
              totalInsuranceValue: item.innerPackTotalValue,
              flatbed: {},
              packagingTypeRDN: (packaging) ? packaging.refDataNumber : undefined,
              freightClassRDN: (freightClass) ? freightClass.refDataNumber : undefined
            };
            $scope.order.service.items.push(convertedItem);
            setFocusToAddedItem();
            registerItem();
            ieSelectFix();
            $scope.orderDetailsForm.$setDirty();
          }, function () {
          });
        };
        $scope.addCatalogShipmentItem = function () {
            if ($scope.isAddCatalogShipmentItem) return;

            $scope.isAddCatalogShipmentItem = true;

            var modalInstance = $uibModal.open({
                templateUrl: '../app/addItemModals/views/addItem.tpl.html',
                size: 'lg',
                controller: 'addItemController',
                backdrop: 'static',
                resolve: {
                    itemDdlRefData: [
                        'RefDataMappingService', function (RefDataMappingService) {
                            return RefDataMappingService.getRefDataCategoryDDLs();
                        }
                    ],
                    showFlatbedAttributes: function () {
                        return $scope.order.service.serviceOffering.id == 1482;
                    },
                    customer: function () {
                        return $scope.order.customerInfo.customer;
                    },
                    user: function () {
                        return $scope.user;
                    },
                    preferences: function () {
                        return $scope.userPreferences;
                    }
                }
            });

            modalInstance.result.then(function (suggestedItem) {

                $scope.isAddCatalogShipmentItem = false;

                if (!suggestedItem)
                    return;

                if (suggestedItem.qty)
                    addNewlyAddedItem(suggestedItem);
                else
                    addSuggestedShipmentItem(suggestedItem);
            }, function () {

              $scope.isAddCatalogShipmentItem = false;
            });
        };

        $scope.getWeightUomTranslationByRefNum = function (weightUnitRDN, item) {
          if (typeof weightUnitRDN === 'undefined' || weightUnitRDN === null) {
            var weightUnitRDNFromItem = null;

            if (typeof item !== 'undefined' && item !== null) {
              weightUnitRDNFromItem = RefDataMappingService.getWeightUnitRDNFromItem(item);
            }

            if (weightUnitRDNFromItem !== null) {
              weightUnitRDN = weightUnitRDNFromItem;
            } else if (isMetric) {
              weightUnitRDN = RefDataMappingService.getItemId('KG_UOM');
            } else {
              weightUnitRDN = RefDataMappingService.getItemId('LB_UOM');
            }
          }

          var translation = RefDataMappingService.getUomTranslationByRefNum(weightUnitRDN);
          return translation;
        }

        $scope.getUomTranslationByRefNum = RefDataMappingService.getUomTranslationByRefNum;
        $scope.getItemId = RefDataMappingService.getItemId;

        function setPreviousItemsTouched() {
            angular.forEach($scope.order.service.items, $scope.setItemAsVisited);
        }
        function setFocusToAddedItem() {
            $timeout(function () {
                angular.element('.description-input').last().focus();
            }, 300);
        }
        function ieSelectFix() {
            // ie9 and older script
            if ($document.all && !$window.atob) {
                $timeout(function () {
                    angular.element("select").width(angular.element("select").width());
                }, 300, false);
            }
        }

        $scope.removeItem = function (item) {
            var removed = false;
            var modalOptions = {
                closeButtonText: 'CANCEL',
                actionButtonText: 'REMOVE',
                headerText: 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_ITEM',
                bodyText: 'ALL_INFORMATION_ENTERED_FOR_THIS_ITEM_WILL_BE_REMO'
            };

            ModalService.showModal({}, modalOptions).then(function (result) {
                if (result === 'ok') {
                    angular.forEach($scope.order.service.items, function (itm, i) {
                        if (!removed) {
                            if (itm.$$hashKey === item.$$hashKey) {
                                $scope.order.service.items.splice(i, 1);
                                deregisterItem();
                                removed = true;
                                $scope.orderDetailsForm.$setDirty();
                            }
                        }
                    });
                }
            });
        };
        $scope.maxItemSearchResults = false;
        $scope.itemsNoResults = false;
        $scope.maxSearchResultLimit = 250;

        $scope.refreshSearchItems = function(search) {
          return ItemServiceHelper.searchHelper(search, $scope.order.customerInfo.customer, $scope);
        };

        $scope.showMaxItemSearchResults = function () {
            return $scope.maxItemSearchResults && angular.element('#itemSearchInput').val().length >= 2;
        };
        $scope.showNoResultsFound = function () {
            return $scope.itemsNoResults && !$scope.searchingItems && angular.element('#itemSearchInput').val().length >= 2;
        };

        $scope.setDropdownSize = FormService.setDropdownSize;

        var ftUomRefNum = RefDataMappingService.getItemId('FEET_UOM');
        var inUomRefNum = RefDataMappingService.getItemId('INCHES_UOM');

        var lbUomRefNum = RefDataMappingService.getItemId('LB_UOM');
        var kgUomRefNum = RefDataMappingService.getItemId('KG_UOM');

        function setUnitsOfMeasurment(item) {
            UnitsOfMeasurementService.setUnitsOfMeasurement(item, isMetric);
        }
        $scope.changeWeightUom = function (item, uom) {
            item.totalWeight.unitRDN = RefDataMappingService.getItemId(uom);
            $scope.summaryFieldUpdates.push(WEIGHT);
            $scope.orderDetailsForm.$setDirty();
        };

        $scope.refNumFilter = function(element){
          if(angular.isDefined(element.referenceNumberType) &&
            element.referenceNumberType.refDataNumber === RefDataMappingService.getItemId('PURCHASE_ORDER_NUMBER')){
            element.referenceNumberType.description = $filter('translate')('PO_POUND');
          }
          return true;
        };

        function registerItem() {
            $scope.itemSummary.lineItems += 1;
            $scope.$parent.updateSummary();
        }
        function deregisterItem() {
            $scope.itemSummary.lineItems -= 1;
            $scope.$parent.updateSummary();
        }
    }
    angular.module('NavisphereOnline').controller('itemEditController', itemEditController);
}());

(function () {
    'use strict';
    itemDetailsController.$inject = ['$scope', '$filter', 'RefDataMappingService'];

    function itemDetailsController($scope, $filter, RefDataMappingService) {
        $scope.toggleItemDetails = function (item) {
            item.expanded = !item.expanded;
        };

        $scope.getPackagingByRefNum = function (refNum) {
            return RefDataMappingService.getDdlValueByCategoryAndRefNum('Packaging', refNum);
        };
        $scope.getDimensionsUOMByRefNum = function (refNum) {
            return RefDataMappingService.getUomTranslationByRefNum(refNum);
        }
        $scope.getTarpTypeByRefNum = function (refNum) {
            return RefDataMappingService.getDdlValueByCategoryAndRefNum('FBedTarpType', refNum);
        };
        $scope.getLoadingTypeByRefNum = function (refNum) {
            return RefDataMappingService.getDdlValueByCategoryAndRefNum('FBedLoadingType', refNum);
        };
        $scope.getEquipTypeByRefNum = function (refNum) {
            return RefDataMappingService.getDdlValueByCategoryAndRefNum('ItemEquipment', refNum);
        };
        $scope.getClassByRefNum = function (refNum) {
            return RefDataMappingService.getDdlValueByCategoryAndRefNum('FreightClass', refNum);
        };
        $scope.getTempCatByRefNum = function (refNum) {
            return RefDataMappingService.getDdlValueByCategoryAndRefNum('TemperatureSensitive', refNum);
        };
        $scope.getTempCategoryDisplay = function (item) {
            if (!item.temperatureCategoryRDN) {
                return '';
            }
            if (item.temperatureCategoryRDN === RefDataMappingService.getItemId('CUSTOM_TEMP_CATEGORY')) {
                return $filter('translate')('CUSTOM');
            }
            var tempCategoryDisplay = $scope.getTempCatByRefNum(item.temperatureCategoryRDN);
            if (item.commodity.requiredTemperatureLow !== null && item.commodity.requiredTemperatureHigh !== null
                && item.commodity.requiredTemperatureLow !== item.commodity.requiredTemperatureHigh && item.temperatureUomRDN) {
                tempCategoryDisplay += ' ' + item.commodity.requiredTemperatureLow + ' - '
                    + item.commodity.requiredTemperatureHigh + ' '
                    + $filter('translate')(RefDataMappingService.getUomTranslationByRefNum(item.temperatureUomRDN));
            }
            return tempCategoryDisplay;
        };
        $scope.displayFlatSpec = function (item) {
            return (item.tarpTypeRDN) || (item.loadingTypeRDN) || (item.itemEquipmentRDN)
                || (item.maxTrailerAge) || (item.requiredStrapsCount) || (item.requiredChainsCount)
                || (item.coilRacks) || (item.locksBars) || (item.owod) || (item.equipmentHeight && item.equipmentHeight.value)
                || (item.equipmentLength && item.equipmentLength.value) || (item.equipmentWidth && item.equipmentWidth.value);
        };
        $scope.getStackableDisplay = function(item) {
            if (item.commodity.isStackable) {
                return $filter('translate')('YES');
            } else {
                return $filter('translate')('NO');
            }
        }

        $scope.getUomTranslation = RefDataMappingService.getUomTranslationByRefNum;
        $scope.itemIsTempControlled = function (item) {
            if(!item.temperatureCategoryRDN){
                return false;
            }
            for (var i = 0; i < $scope.refDataDDLs['TemperatureSensitive'].length; i++) {
                if ($scope.refDataDDLs['TemperatureSensitive'][i].refDataNumber === item.temperatureCategoryRDN) {
                    return item.temperatureCategoryRDN !== RefDataMappingService.getItemId('DRY_TEMP_CATEGORY');
                }
            }
            return false;
        };

      $scope.refNumFilter = function(element){

        if(element.referenceNumberType.refDataNumber === RefDataMappingService.getItemId('PURCHASE_ORDER_NUMBER')){
          element.referenceNumberType.description = $filter('translate')('PO_POUND');
        }

        return true;
      };
    }
    angular.module('NavisphereOnline').controller('itemDetailsController', itemDetailsController);
})();

/*global moment */
(function () {
    'use strict';

    deliveryEditController.$inject = ['$scope', '$filter', '$uibModal', 'DateTimeService', '$locale', 'LocationService',
      'AddressService', 'RefDataMappingService', 'UserPermissionService'];

    function deliveryEditController($scope, $filter, $uibModal, DateTimeService, $locale, LocationService,
                                    AddressService, RefDataMappingService, UserPermissionService) {

        $scope.deliveryLocationResults = [];
        $scope.getAddressLine1 = AddressService.GetAddressLine1;
        $scope.getAddressLine2 = AddressService.GetAddressLine2;
        $scope.getAddressLine3 = AddressService.GetAddressLine3;
        $scope.getAddressLine4 = AddressService.GetAddressLine4;

        $scope.earliestDateOptions ={
          showWeeks: false
        };

        $scope.latestDateOptions ={
          showWeeks: false
        };
        $scope.deliveryRefNum = getDeliveryRefNum();

        function getDeliveryRefNum(){
          if($scope.$parent.order.service.deliverTo.referenceNumbers){
            for(var i = 0; i < $scope.$parent.order.service.deliverTo.referenceNumbers.length; i++){
              if($scope.$parent.order.service.deliverTo.referenceNumbers[i].referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('DELIVERY_NUMBER')){
                return $scope.$parent.order.service.deliverTo.referenceNumbers[i];
              }
            }
            var deliveryRefNum = { referenceNumberType: {
              description: $filter('translate')('DELIVERY_POUND'),
              refDataNumber: RefDataMappingService.getCategoryId('DELIVERY_NUMBER') }};
            $scope.$parent.order.service.deliverTo.referenceNumbers.push(deliveryRefNum);
            return deliveryRefNum;
          }
        }
        $scope.refNumbFilter = function(element){
          return element != $scope.deliveryRefNum;
        };

        if ($scope.editAllowed('UPDATE_AVAILABLE_DELIVERY_DATE_TIME')) {
            $scope.earliestDateOptions.minDate = DateTimeService.getToday();
            $scope.earliestDateOptions.maxDate = DateTimeService.getDateTwoYearsFromNow();
        }

        if ($scope.editAllowed('UPDATE_DELIVERY_BY_DATE_TIME')) {
            $scope.latestDateOptions.minDate = DateTimeService.getToday();
            $scope.latestDateOptions.maxDate = DateTimeService.getDateTwoYearsFromNow();
        }

        $scope.format = $locale.DATETIME_FORMATS['shortDate'];
        $scope.ismeridian = $scope.$parent.userPreferences.timeFormat === '12';

        $scope.earliestDateDisabled = function (date, mode) {
            var now = Date.now();
            return mode === 'day' && (($scope.$parent.order.service.deliverTo && $scope.$parent.order.service.deliverTo.uiLatestDate
                && $scope.$parent.order.service.deliverTo.uiLatestDate <= date) || date < now
                || moment(date).diff(moment(now), 'years') >= 2);
        };

        $scope.latestDateDisabled = function (date, mode) {
            var now = Date.now();
            return mode === 'day' && (($scope.$parent.order.service.deliverTo && $scope.$parent.order.service.deliverTo.uiEarliestDate
                && $scope.$parent.order.service.deliverTo.uiEarliestDate >= date) || date < now
                || moment(date).diff(moment(now), 'years') >= 2);
        };

        $scope.earliestTimeChanged = function (value) {
            if (value === null) {
                $scope.$parent.order.service.deliverTo.uiEarliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            }
        };

        $scope.latestTimeChanged = function (value) {
            if (value === null) {
                $scope.$parent.order.service.deliverTo.uiLatestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            }
        };

        $scope.hstep = 1;
        $scope.mstep = 15;
        $scope.hasAddLocation = UserPermissionService.hasCustomerRole($scope.order.customerInfo.customer.partyCode, 'Add New Location');
        $scope.openEarliestDate = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.earliestDateOpened = true;
        };


        $scope.openLatestDate = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.latestDateOpened = true;
        };
        $scope.addNewLocation = function () {
            var modalInstance = $uibModal.open({
                templateUrl: '../app/addLocationModals/views/addLocation.tpl.html',
                size: 'lg',
                controller: 'addLocationController',
                backdrop: 'static',
                resolve: {
                  customer: function () {
                    return ($scope.order.customerInfo && $scope.order.customerInfo.customer)
                      ? $scope.order.customerInfo.customer.partyCode : '';
                  },
                  locationType: function() {
                    if($scope.$parent.deliveryNeedsRefinement){
                      return "delivery";
                    }
                    return "";
                  },
                  supplier: function () {
                    return (angular.isDefined($scope.user) && angular.isDefined($scope.user.supplierPartyCode)
                    && angular.isDefined($scope.order.customerInfo) &&  angular.isDefined($scope.order.customerInfo.customer)
                    && $scope.order.customerInfo.customer.useSupplierLocation)
                      ?  $scope.user.supplierPartyCode
                      : undefined;
                  }
                }
            });
            modalInstance.result.then(function (newLocation) {
                $scope.$parent.order.deliveryHasNoResults = false;
                $scope.$parent.order.service.deliverTo.location = newLocation;
                $scope.$parent.order.service.deliverTo.address = newLocation.physicalAddress;
                $scope.$parent.order.service.deliverTo.uiEarliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
                $scope.$parent.order.service.deliverTo.uiLatestTime = new Date((new Date()).setHours(0, 0, 0, 0));
                $scope.deliveryForm.$setDirty();
            }, function () {
            });
        };
        $scope.$watch('$parent.order.service.deliverTo.uiEarliestDate', function (newValue) {
            if ($scope.editAllowed('UPDATE_DELIVERY_BY_DATE_TIME') && newValue) {
                 $scope.latestDateOptions.minDate = newValue > DateTimeService.getToday() ? newValue: $scope.latestDateOptions.minDate;
                if ($scope.$parent.order.service.deliverTo.uiLatestDate) {
                    if ($scope.$parent.order.service.deliverTo.uiLatestDate < newValue) {
                        $scope.$parent.order.service.deliverTo.uiLatestDate = newValue;
                    }
                }
            }
            if ($scope.order.service.deliverTo && $scope.order.service.deliverTo.location && newValue
                && $scope.$parent.order.service.deliverTo.location.dryReceivingHours) {
                var shippingHours = $scope.$parent.order.service.deliverTo.location.dryReceivingHours;
                var day = newValue.getDay();
                var dayName = DateTimeService.getWeekDayName(day);
                var dayClosedKey = dayName + 'Closed';
                var dayOpenTimeKey = dayName + 'OpenTime';
                var dayCloseTimeKey = dayName + 'CloseTime';
                if (shippingHours[dayClosedKey]) {
                    return;
                }
                if (shippingHours[dayOpenTimeKey]&& $scope.$parent.order.service.deliverTo.uiEarliestTime && $scope.$parent.order.service.deliverTo.uiEarliestTime.getTime() === (new Date((new Date()).setHours(0, 0, 0, 0))).getTime()) {
                    var openTime = new Date(shippingHours[dayOpenTimeKey]);
                    $scope.$parent.order.service.deliverTo.uiEarliestTime = openTime;
                }
                if (shippingHours[dayCloseTimeKey]&& $scope.$parent.order.service.deliverTo.uiLatestTime && $scope.$parent.order.service.deliverTo.uiLatestTime.getTime() === (new Date((new Date()).setHours(0, 0, 0, 0))).getTime()) {
                    var closeTime = new Date(shippingHours[dayCloseTimeKey]);
                    $scope.$parent.order.service.deliverTo.uiLatestTime = closeTime;
                }
            }
        });

        $scope.refreshDeliveryLocations = function (searchText) {
            if (searchText.length < 2) {
                $scope.$parent.order.deliveryHasNoResults = false;
                return [];
            }
            $scope.deliveryLocationResults = [];
            return LocationService.searchPartyLocation({
                partyNumberOrCode: $scope.order.customerInfo.customer.partyCode.replace(/^\s+|\s+$/gm, ''),
                term: searchText,
                locationSearchType: 2,
                limit: 100,
                useSupplierLocation: $scope.order.customerInfo.customer.useSupplierLocation
            }, function (data) {
                $scope.deliveryLocationResults = data.items;
                $scope.$parent.order.deliveryHasNoResults = (data.items.length === 0) ? true : false;
            });
        };

        $scope.onDeliverySelected = function (item) {

            $scope.$parent.order.deliveryHasNoResults = false;
            $scope.$parent.order.service.deliverTo.uiEarliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            $scope.$parent.order.service.deliverTo.uiLatestTime = new Date((new Date()).setHours(0, 0, 0, 0));

            LocationService.getLocation({
                locationPartyNumberOrCode: item.locationPartyCode,
                relatedLocationId: item.relatedLocationId,
                useSupplierLocation: $scope.order.customerInfo.customer.useSupplierLocation
            }, function (data) {
                $scope.$parent.order.service.deliverTo.address = data.physicalAddress;
                $scope.$parent.order.service.deliverTo.location = data;
                $scope.$parent.order.service.deliverTo.dropLocationNumber = item.dropLocationNumber;
                $scope.$parent.order.service.deliverTo.pickLocationNumber = item.pickLocationNumber;
                if (data.notes) {
                    $scope.$parent.order.service.deliverTo.specialInstructions = data.notes.substring(0, 255);
                } else {
                    $scope.$parent.order.service.deliverTo.specialInstructions = '';
                }

                if ($scope.$parent.order.service.deliverTo
                    && $scope.$parent.order.service.deliverTo.location
                    && $scope.$parent.order.service.deliverTo.location.dryReceivingHours
                    && $scope.$parent.order.service.deliverTo.uiEarliestDate) {

                    var dryReceivingHours = $scope.$parent.order.service.deliverTo.location.dryReceivingHours;
                    var day = $scope.$parent.order.service.deliverTo.uiEarliestDate.getDay();
                    var dayName = DateTimeService.getWeekDayName(day);
                    var dayClosedKey = dayName + 'Closed';
                    var dayOpenTimeKey = dayName + 'OpenTime';
                    var dayCloseTimeKey = dayName + 'CloseTime';
                    if (dryReceivingHours[dayClosedKey]) {
                        return;
                    }
                    if (dryReceivingHours[dayOpenTimeKey]) {
                        var openTime = new Date(dryReceivingHours[dayOpenTimeKey]);
                        $scope.$parent.order.service.deliverTo.uiEarliestTime = openTime;
                    }
                    if (dryReceivingHours[dayCloseTimeKey]) {
                        var closeTime = new Date(dryReceivingHours[dayCloseTimeKey]);
                        $scope.$parent.order.service.deliverTo.uiLatestTime = closeTime;
                    }
                }
            });
          var cCode = ($scope.order.customerInfo && $scope.order.customerInfo.customer)
            ? $scope.order.customerInfo.customer.partyCode : '';
        };
    }
    angular.module('NavisphereOnline').controller('deliveryEditController', deliveryEditController);
})();

(function () {

    'use strict';

    deliveryDetailsController.$inject = ['$scope', '$filter', '$uibModal', 'AddressService', 'DateTimeService',
      'RefDataMappingService'];

    function deliveryDetailsController($scope, $filter, $uibModal, AddressService, DateTimeService,
                                       RefDataMappingService) {

        $scope.getAddressLine3 = AddressService.GetAddressLine3;
        $scope.getAddressLine4 = AddressService.GetAddressLine4
        $scope.userPreferences = $scope.$parent.userPreferences;

        if ($scope.$parent.order.service.deliverTo) {
            if ($scope.$parent.order.service.deliverTo.earliestDate) {
                var earliestDate = $scope.$parent.order.service.deliverTo.earliestDate.utcDateTime;
                $scope.$parent.order.service.deliverTo.uiEarliestDate = DateTimeService.getRawDateTime(earliestDate);
            }
            if ($scope.$parent.order.service.deliverTo.earliestTime) {
                var earliestTime = $scope.$parent.order.service.deliverTo.earliestTime.utcDateTime;
                $scope.$parent.order.service.deliverTo.uiEarliestTime = DateTimeService.getRawDateTime(earliestTime);
            } else {
                $scope.$parent.order.service.deliverTo.uiEarliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            }
            if ($scope.$parent.order.service.deliverTo.latestDate) {
                var latestDate = $scope.$parent.order.service.deliverTo.latestDate.utcDateTime;
                $scope.$parent.order.service.deliverTo.uiLatestDate = DateTimeService.getRawDateTime(latestDate);
            }
            if ($scope.$parent.order.service.deliverTo.latestTime) {
                var latestTime = $scope.$parent.order.service.deliverTo.latestTime.utcDateTime;
                $scope.$parent.order.service.deliverTo.uiLatestTime = DateTimeService.getRawDateTime(latestTime);
            } else {
                $scope.$parent.order.service.deliverTo.uiLatestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            }
        }

      $scope.refNumberFilter = function(element){

        if(element.referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('DELIVERY_NUMBER')){
          element.referenceNumberType.description = $filter('translate')('DELIVERY_POUND');
        }

        return true;
      };

        $scope.deliveryWarehouseDetails = function (locationDetail, displayDryHours) {
            var locationInfo = {
                location: locationDetail,
                displayDryHours: displayDryHours,
                useReceivingHours: true
            };

            $uibModal.open({
                templateUrl: '../app/orderDetails/views/warehouseDetails.tpl.html',
                size: 'md',
                controller: 'warehouseDetailsController',
                resolve: {
                    userPreference:  function () {
                        return $scope.$parent.userPreferences;
                    },
                    warehouseDetails: function () { return locationInfo; }
                }
            });
        };

        $scope.getDisplayDateTime = DateTimeService.getDisplayDateTime;
    }
    angular.module('NavisphereOnline').controller('deliveryDetailsController', deliveryDetailsController);
})();

(function () {
  'use strict';
  chargesDetailsController.$inject = ['$scope', 'RefDataMappingService', '$filter'];

  function chargesDetailsController($scope, RefDataMapping, $filter) {
    //can't just use total > 0 to determine if charges exist for a financial type
    //since 0 is apparently a valid charge... have mercy on our souls...
    $scope.freightTotal = 0;
    $scope.freightChargesExist = false;
    $scope.baselineTotal = 0;
    $scope.baselineChargesExist = false;
    $scope.customerTotal = 0;
    $scope.customerChargesExist = false;
    $scope.chargesDisplay = [];
    function createChargesDisplayList(){
      var lineHaulPlaced = false;
      if(angular.isDefined($scope.order.charges)) {
        for (var i = 0; i < $scope.order.charges.length; i++) {
          var chargePlaced = false;
          for (var j = 0; j < $scope.chargesDisplay.length; j++) {
            if ($scope.order.charges[i].rateDescription === $scope.chargesDisplay[j].rateDescription) {
              if (fillChargesDisplayFinancialTypeVacancy($scope.chargesDisplay[j], $scope.order.charges[i])) {
                chargePlaced = true;
                break;
              }
            }
          }
          if (!chargePlaced) {
            var newChargesDisplay = createChargesDisplay($scope.order.charges[i]);
            if (angular.isDefined(newChargesDisplay)) {
              if (!lineHaulPlaced && newChargesDisplay.rateCodeRDN === RefDataMapping.getItemId('LINE_HAUL')) {
                $scope.chargesDisplay.unshift(newChargesDisplay);
              } else {
                $scope.chargesDisplay.push(newChargesDisplay);
              }
            }
          }
          setHeaderLabel($scope.order.charges[i]);
        }
      }
    }
    createChargesDisplayList();
    function setHeaderLabel(charge){
      switch(charge.financialTypeRDN) {
        case RefDataMapping.getItemId('FREIGHT_CHARGES'):
          if(angular.isUndefined($scope.freightHeader)){
            $scope.freightHeader = $filter('translate')('FREIGHT_CHARGES') + ' (' + RefDataMapping.getItemByRefNum(charge.currencyCodeRDN) + ')';
          }
          break;
        case RefDataMapping.getItemId('CUSTOMER_CHARGES'):
          if(angular.isUndefined($scope.customerHeader)){
            $scope.customerHeader = $filter('translate')('END_CUSTOMER_CHARGES') + ' (' + RefDataMapping.getItemByRefNum(charge.currencyCodeRDN) + ')';
          }
          break;
        case RefDataMapping.getItemId('BASELINE_CHARGES'):
          if(angular.isUndefined($scope.baselineHeader)){
            $scope.baselineHeader = $filter('translate')('BASELINE_CHARGES') + ' (' + RefDataMapping.getItemByRefNum(charge.currencyCodeRDN) + ')';
          }
          break;
        default:
              break;
      }
    }
    function createChargesDisplay(charge){
      switch(charge.financialTypeRDN) {
        case RefDataMapping.getItemId('FREIGHT_CHARGES'):
          $scope.freightTotal += charge.amount;
          $scope.freightChargesExist = true;
          return { rateDescription: charge.rateDescription, freightCharge: charge.amount, rateCodeRDN: charge.rateCodeRDN};
        case RefDataMapping.getItemId('CUSTOMER_CHARGES'):
          $scope.customerTotal += charge.amount;
          $scope.customerChargesExist = true;
          return { rateDescription: charge.rateDescription, customerCharge: charge.amount, rateCodeRDN: charge.rateCodeRDN};
        case RefDataMapping.getItemId('BASELINE_CHARGES'):
          $scope.baselineTotal += charge.amount;
          $scope.baselineChargesExist = true;
          return { rateDescription: charge.rateDescription, baselineCharge: charge.amount, rateCodeRDN: charge.rateCodeRDN};
        default:
          break;
      }
    }
    function fillChargesDisplayFinancialTypeVacancy(chargesDisplay, charge){
      switch(charge.financialTypeRDN) {
        case RefDataMapping.getItemId('FREIGHT_CHARGES'):
          if(angular.isUndefined(chargesDisplay.freightCharge)) {
            chargesDisplay.freightCharge = charge.amount;
            $scope.freightTotal += charge.amount;
            $scope.freightChargesExist = true;
            return true;
          }
          return false;
        case RefDataMapping.getItemId('CUSTOMER_CHARGES'):
          if(angular.isUndefined(chargesDisplay.customerCharge)) {
            chargesDisplay.customerCharge = charge.amount;
            $scope.customerTotal += charge.amount;
            $scope.customerChargesExist = true;
            return true;
          }
          return false;
        case RefDataMapping.getItemId('BASELINE_CHARGES'):
          if(angular.isUndefined(chargesDisplay.baselineCharge)) {
            chargesDisplay.baselineCharge = charge.amount;
            $scope.baselineTotal += charge.amount;
            $scope.baselineChargesExist = true;
            return true;
          }
          return false;
        default:
          return false;
      }
    }
  }
  angular.module('NavisphereOnline').controller('chargesDetailsController', chargesDetailsController);
})();

(function () {
    'use strict';
    orderEditConfirmationController.$inject = ['$scope', '$state', 'orderNumber', '$window'];

    function orderEditConfirmationController($scope, $state, orderNumber, $window) {

        $scope.isGettingOrderNumber = false;
        $scope.orderNumber = orderNumber;

        $scope.createNewOrder = function () {
            $window.location.href = '/orders/#/create';
        };

        $scope.returnToDash = function () {
            $state.go('app.dashboard');
        };
    }

    angular.module('NavisphereOnline').controller('orderEditConfirmationController', orderEditConfirmationController);
})();

(function () {
  'use strict';
  orderConfirmationController.$inject = ['$scope', '$state', '$uibModal', '$filter', '$window', 'bolContext', 'API_BASE_URL',
    'UserPermissionService', 'OrderService', 'OrderConfirmationService', 'DocumentHelper', 'ModeTranslatorService', 'WindowLocationHref'];
  function orderConfirmationController($scope, $state, $uibModal, $filter, $window, bolContext, API_BASE_URL,
      UserPermissionService, OrderService, OrderConfirmationService, DocumentHelper, ModeTranslatorService, WindowLocationHref) {
    var validationMessages = [];
    $scope.isGettingOrderNumber = false;
    var confirmation = OrderConfirmationService.getConfirmation();
    var order = OrderConfirmationService.getOrder();
    var summary = OrderConfirmationService.getSummary();
    var preferences = OrderConfirmationService.getPreferences();
    if (!confirmation || !order || !summary) {
      $state.go('app.dashboard');
    } else {
      bindOrderConfirmationDetails();
    }
    function bindOrderConfirmationDetails(){
      var hasViewBOLRole = UserPermissionService.hasCustomerRole(order.customer.partyCode.replace(/^\s+|\s+$/gm, ''), "View BOL");
      var hasOrderBOLContext = order.customer.bolContext === bolContext.Order;
      $scope.confirmationNumber = confirmation.confirmationNumber;
      $scope.trackingNumber = confirmation.trackingNumber;
      $scope.showBOLLink = hasViewBOLRole && hasOrderBOLContext;
      
      $scope.accountName = order.customer.name;

      //This is for the case that we are coming from Quote To Order.
      if(!order.serviceOffering.displayKey){
        order.serviceOffering.displayKey = ModeTranslatorService.orderTransportModeIdMap[order.serviceOffering.id];
      }

      $scope.showLTLMessage = (order.serviceOffering.displayKey === "LTL");
      $scope.shippingMethod = $filter('translate')(order.serviceOffering.displayKey);
      $scope.shippingMethodIcon = setShippingMethodIcon();
      $scope.pickName = order.pickup.addressName ? order.pickup.addressName : order.pickup.locationPartyName;
      $scope.pickEarliestDisplay = getDateTimeDisplay(order.pickup.earliestDate, order.pickup.earliestTime, true);
      $scope.pickLatestDisplay = getDateTimeDisplay(order.pickup.latestDate, order.pickup.latestTime, false);
      $scope.deliveryName = order.delivery.addressName ? order.delivery.addressName : order.delivery.locationPartyName;
      $scope.deliveryEarliestDisplay = getDateTimeDisplay(order.delivery.earliestDate, order.delivery.earliestTime, true);
      $scope.deliveryLatestDisplay = getDateTimeDisplay(order.delivery.latestDate, order.delivery.latestTime, false);
      $scope.totalItems = $filter('translate')('TOTAL_ITEMS') + ': ' + summary.lineItems;
      $scope.quantity = $filter('translate')('QUANTITY') + ': ' + summary.quantity;
      $scope.weight = $filter('translate')('WEIGHT') + ': ' + summary.weight + ' ';
      $scope.weight += preferences.unitOfMeasure === 'metric' ? $filter('translate')('KG_UOM') : $filter('translate')('LB_UOM');
      $scope.value = $filter('translate')('VALUE') + ': ' + summary.insuranceValue;
      $scope.pallets = $filter('translate')('PALLETS') + ': ' + summary.pallets;
    }
    function getDateTimeDisplay(date, time, isEarliest){
      if(date) {
        var display = $filter('date')(date, 'shortDate');
        if(time){
          display += ' ';
          display += (isEarliest) ? $filter('translate')('AFTER') : $filter('translate')('BEFORE');
          display += ' ';
          display += $filter('time')({ userPreferences: preferences, date: time });
          return display;
        }
      }
      return null;
    }
    function setShippingMethodIcon(){
      switch(order.serviceOffering.displayKey){
        case 'TRUCKLOAD':
          return '#icon-truckload';
        case 'FLATBED':
              return '#icon-flatbed';
        case 'LTL':
              return '#icon-ltl';
        case 'BULK':
              return '#icon-bulk';
        case 'INTERMODAL':
              return '#icon-intermodal';
        case 'CONSOLIDATED':
              return '#icon-consolidated';
        case 'AIR':
              return '#icon-airplane';
        default:
              return '#icon-truckload';
      }
    }

    $scope.viewBol = function () {
      DocumentHelper.showDocument(API_BASE_URL + 'api/documents/bol' + '?confirmationNumber=' + encodeURIComponent($scope.confirmationNumber.replace(/[^0-9]+/g, '')));
    };

    $scope.viewOrderDetails = function () {

      if ($scope.isGettingOrderNumber) {
        return;
      }

      $scope.isGettingOrderNumber = true;

      $scope.loadingModal = $uibModal.open({
        templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
        size: 'sm',
        controller: 'loadingSpinnerController',
        backdrop: 'static',
        resolve: {
          title: function () {
            return $filter('translate')('GETTING_ORDER_DETAILS');
          }
        }
      });

      OrderService.getOrderNumber({
        confirmationNumber: $scope.confirmationNumber ? $scope.confirmationNumber : null
      }, function (result) {

        $scope.loadingModal.close(result);
        $scope.isGettingOrderNumber = false;


        if (result.success
          && result.orderNumber
          && result.orderNumber !== 0) {
						var redirectUrl =  appConfig.ordersUIBaseUrl + '/#/detail/' + result.orderNumber;
						WindowLocationHref.setWindowLocationHref(redirectUrl);
        } else {
          angular.forEach(result.errors, function (error) {
            validationMessages.push($filter('translate')(error.errorMessage));
          });
          showValidationError();
        }

      }, function (result) {

        $scope.loadingModal.close(result);
        $scope.isGettingOrderNumber = false;

        validationMessages.push($filter('translate')('Could not find your order'));
        showValidationError();
      });
    };
    $scope.sendTrackingModal = function(){
      $uibModal.open({
        templateUrl: 'app/common/views/sendTracking.tpl.html',
        size: 'lg',
        controller: 'sendTrackingController',
        resolve: {
          trackingNumber: function () {
            return $scope.trackingNumber;
          },
          user: ['UserServiceHelper', function (UserServiceHelper) {
            return UserServiceHelper.get();
          }]
        }
      });
    };
    $scope.createNewOrder = function () {
      $window.location.href = '/orders/#/create';
    };
    $scope.returnToDash = function () {
      $state.go('app.dashboard');
    };

    function showValidationError() {
      $uibModal.open({
        templateUrl: 'app/validationModal/validationModal.tpl.html',
        size: 'lg',
        controller: 'validationModalController',
        resolve: {
          validations: function () {
            return validationMessages;
          },
          title: function () {
            return $filter('translate')('Error with finding your order details');
          }
        }

      }).result.then(function () {
        validationMessages = [];
        $scope.isGettingOrderNumber = false;
      }, function () {
        validationMessages = [];
        $scope.isGettingOrderNumber = false;
      });
    }
  }

  angular.module('NavisphereOnline').controller('orderConfirmationController', orderConfirmationController);
})();

(function() {
  "use strict";

  ValidationErrorService.$inject = ["$filter", "$uibModal"]

  function ValidationErrorService($filter, $uibModal) {
    this.showValidationError = function($scope) {
      $uibModal.open({
        templateUrl: 'app/validationModal/validationModal.tpl.html',
        size: 'lg',
        controller: 'validationModalController',
        resolve: {
          validations: function () { return $scope.validationMessages; },
          title: function () { return $filter('translate')('WE_WERE_NOT_ABLE_TO_PROCESS_YOUR_ORDER_PLEASE_RESO'); }
        }
      }).result.then(function () {
        $scope.validationMessages = [];
        $scope.submittingOrder = false;
      }, function () {
        $scope.validationMessages = [];
        $scope.submittingOrder = false;
      });
    }
  }

  angular.module("NavisphereOnline").service("ValidationErrorService", ValidationErrorService);
})();

(function() {
  "use strict";

  UnitsOfMeasurementService.$inject = ["$filter", "RefDataMappingService"];

  function UnitsOfMeasurementService($filter, RefDataMappingService) {
    var ftUomRefNum = RefDataMappingService.getItemId('FEET_UOM');
    var ftUom = $filter('translate')('FEET_UOM');
    var inUomRefNum = RefDataMappingService.getItemId('INCHES_UOM');
    var inUom = $filter('translate')('INCHES_UOM');
    var mUomRefNum = RefDataMappingService.getItemId('METERS_UOM');
    var mUom = $filter('translate')('METERS_UOM');
    var cmUomRefNum = RefDataMappingService.getItemId('CENTIMETERS_UOM');
    var cmUom = $filter('translate')('CENTIMETERS_UOM');
    var lbUomRefNum = RefDataMappingService.getItemId('LB_UOM');
    var lbUom = $filter('translate')('LB_UOM');
    var kgUomRefNum = RefDataMappingService.getItemId('KG_UOM');
    var kgUom = $filter('translate')('KG_UOM');

    /**
     * @param input {array|object} An item or an array of items
     */
    this.setUnitsOfMeasurement = function(input, isMetric) {
      if (_.isArray(input)) {
        _.forEach(input, function(item) {
          set(item, isMetric);
        })
      } else {
        set(input, isMetric);
      }
    };

    function set(item, isMetric) {
      if (!item.flatbed) {
        item.flatbed = {}
      }

      if (!item.flatbed.lengthUom) {
        if (!isMetric) {
          item.flatbed.lengthUom = ftUomRefNum;
          item.flatbed.lengthUomLabel = ftUom;
          item.flatbed.lengthInUom = inUomRefNum;
          item.flatbed.lengthInUomLabel = inUom;
          item.flatbed.widthUom = inUomRefNum;
          item.flatbed.widthUomLabel = inUom;
          item.flatbed.heightUom = inUomRefNum;
          item.flatbed.heightUomLabel = inUom;
        } else {
          item.flatbed.lengthUom = mUomRefNum;
          item.flatbed.lengthUomLabel = mUom;
          item.flatbed.lengthInUom = cmUomRefNum;
          item.flatbed.lengthInUomLabel = cmUom;
          item.flatbed.widthUom = cmUomRefNum;
          item.flatbed.widthUomLabel = cmUom;
          item.flatbed.heightUom = cmUomRefNum;
          item.flatbed.heightUomLabel = cmUom;
        }
      }
      if(item.unitLength) {
        if(item.unitLength.value === null && isMetric) {
          item.unitLength.unitRDN = cmUomRefNum;
          item.unitWidth.unitRDN = cmUomRefNum;
          item.unitHeight.unitRDN = cmUomRefNum;
        }
        else if(item.unitLength.value === null && !isMetric) {
          item.unitLength.unitRDN = inUomRefNum;
          item.unitWidth.unitRDN = inUomRefNum;
          item.unitHeight.unitRDN = inUomRefNum;
        }
        if (RefDataMappingService.getItemByRefNum(item.unitLength.unitRDN) === 'CENTIMETERS_UOM') {
          setAndNullifyUnused(item, true);
        }
        else if (RefDataMappingService.getItemByRefNum(item.unitLength.unitRDN) === 'INCHES_UOM') {
          setAndNullifyUnused(item, false);
        }
      }
      else {
        item.unitLength = {};
        item.unitWidth = {};
        item.unitHeight = {};
        if(isMetric) {
          item.unitLength.unitRDN = cmUomRefNum;
          item.unitWidth.unitRDN = cmUomRefNum;
          item.unitHeight.unitRDN = cmUomRefNum;
          setAndNullifyUnused(item, true);
        }
        else {
          item.unitLength.unitRDN = inUomRefNum;
          item.unitWidth.unitRDN = inUomRefNum;
          item.unitHeight.unitRDN = inUomRefNum;
          setAndNullifyUnused(item, false);
        }
        item.unitHeight.value=item.height;
        item.unitLength.value=item.length;
        item.unitWidth.value=item.width;
      }
      if (!item.weightUom || !item.weightUomLabel) {
        if (isMetric) {
          item.weightUom = kgUomRefNum;
          item.weightUomLabel = kgUom;
        } else {
          item.weightUom = lbUomRefNum;
          item.weightUomLabel = lbUom;
        }
      }
    }

    /**
     * Attempting to avoid the case where metric and standard units of measure
     * are both set, resulting in both UoM being displayed.
     *
     * @param item
     * @param nullifyMetric
     */
    function nullifyUnusedUom(item, nullifyMetric) {
      if(nullifyMetric) {
        item.lengthCmUom = null;
        item.lengthCmUomLabel = null;
        item.widthCmUom = null;
        item.widthCmUomLabel = null;
        item.heightCmUom = null;
        item.heightCmUomLabel = null;
      }
      else if(!nullifyMetric) {
        item.lengthInUom = null;
        item.lengthInUomLabel = null;
        item.widthInUom = null;
        item.widthInUomLabel = null;
        item.heightInUom = null;
        item.heightInUomLabel = null;
      }
    }

    /**
     * Created for readability's sake, avoiding excessive repetition in set()
     * @param item
     * @param setMetric True to set metric UOM, false to set standard UOM.
     */
    function setAndNullifyUnused(item, setMetric) {
      if(!setMetric) {
        item.lengthInUom = inUomRefNum;
        item.lengthInUomLabel = inUom;
        item.widthInUom = inUomRefNum;
        item.widthInUomLabel = inUom;
        item.heightInUom = inUomRefNum;
        item.heightInUomLabel = inUom;
        nullifyUnusedUom(item, true);
      }
      else if(setMetric) {
        item.lengthCmUom = cmUomRefNum;
        item.lengthCmUomLabel = cmUom;
        item.widthCmUom = cmUomRefNum;
        item.widthCmUomLabel = cmUom;
        item.heightCmUom = cmUomRefNum;
        item.heightCmUomLabel = cmUom;
        nullifyUnusedUom(item, false);
      }
    }
  }

  angular.module("NavisphereOnline").service("UnitsOfMeasurementService", UnitsOfMeasurementService);
})();

(function () {

    'use strict';

    orderTransformService.$inject = ['RefDataMappingService', 'ServiceOffering', 'UserPermissionService'];

    function orderTransformService(RefDataMappingService, ServiceOffering, UserPermissionService) {

        var mapReferenceNumbers = function(customerOrder, order){
          for (var t = 0; t < order.newRefNums.length; t++) {
            var refNum = order.newRefNums[t];
            if (refNum.value !== '') {
              if (refNum.referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('SHIPWITH_NUMBER')) {
                customerOrder.referenceNumbers.push(refNum);
              } else if (refNum.referenceNumberType.refDataNumber === order.customerInfo.customer.primaryCustomerReferenceNumTypeRDN) {
                customerOrder.customerInfo.referenceNumbers.push(refNum);
              } else if (refNum.referenceNumberType.refDataNumber === order.customerInfo.customer.primaryBillToReferenceNumTypeRDN) {
                if (customerOrder.billTos && customerOrder.billTos.length > 0) {
                  customerOrder.billTos[0].referenceNumbers.push(refNum);
                }
              }
            }
          }
        };

        this.getCustomerOrderSaveRequest = function (order) {
            var request = {};
            request.order = this.getCustomerOrder(order);
            return request;
        };

        this.getCustomerOrderUpdateRequest = function (order) {

            removeEmptyRefNums(order);

            var customerOrder = {
                customerOrderNumber: order.customerOrderNumber,
                customerOrderId: order.customerOrderId,
                confirmationNumber: order.confirmationNumber,
                conditionRDN: order.conditionRDN,
                referenceNumbers: order.referenceNumbers,
                customerInfo: order.customerInfo,
                billTos: order.billTos,
                status: order.status,
                services: [],
                createdViaPurchaseOrder: order.createdViaPurchaseOrder
            };
            var service = angular.copy(order.service);
            service.pickupFrom.earliestDate = { utcDateTime: order.service.pickupFrom.uiEarliestDate, offSet: order.service.pickupFrom.uiEarliestDate.getTimezoneOffset() }
            service.pickupFrom.latestDate = { utcDateTime: order.service.pickupFrom.uiLatestDate, offSet: order.service.pickupFrom.uiLatestDate.getTimezoneOffset() }
            service.deliverTo.earliestDate = { utcDateTime: order.service.deliverTo.uiEarliestDate, offSet: order.service.deliverTo.uiEarliestDate.getTimezoneOffset() }
            service.deliverTo.latestDate = { utcDateTime: order.service.deliverTo.uiLatestDate, offSet: order.service.deliverTo.uiLatestDate.getTimezoneOffset() }

            if (order.service.pickupFrom.uiEarliestTime) {
                service.pickupFrom.earliestTime = { utcDateTime: order.service.pickupFrom.uiEarliestTime, offSet: order.service.pickupFrom.uiEarliestTime.getTimezoneOffset() };
            }

            if (order.service.pickupFrom.uiLatestTime) {
                service.pickupFrom.latestTime = { utcDateTime: order.service.pickupFrom.uiLatestTime, offSet: order.service.pickupFrom.uiLatestTime.getTimezoneOffset() };
            }

            if (order.service.deliverTo.uiEarliestTime) {
                service.deliverTo.earliestTime = { utcDateTime: order.service.deliverTo.uiEarliestTime, offSet: order.service.deliverTo.uiEarliestTime.getTimezoneOffset() };
            }

            if (order.service.deliverTo.uiLatestTime) {
                service.deliverTo.latestTime = { utcDateTime: order.service.deliverTo.uiLatestTime, offSet: order.service.deliverTo.uiLatestTime.getTimezoneOffset() };
            }

            if (order.newRefNums) {
              mapReferenceNumbers(customerOrder, order)
            }
            customerOrder.services.push(service);
            return customerOrder;
        };

        this.getOrderForEdit = function (order, userPreferences) {

            var orderForEdit = {
                service: order.services[0],
                customerOrderNumber: order.customerOrderNumber,
                customerOrderId: order.customerOrderId,
                confirmationNumber: order.confirmationNumber,
                conditionRDN: order.conditionRDN,
                referenceNumbers: order.referenceNumbers,
                customerInfo: order.customerInfo,
                billTos: order.billTos,
                status: order.status,
                isMultiLeg: order.isMultiLeg,
                charges: order.charges || [],
                createdViaPurchaseOrder: order.createdViaPurchaseOrder
            };

            if (ServiceOffering.get(orderForEdit.service.serviceOffering.id).genericType === 'FLATBED') {
                for (var i = 0; i < orderForEdit.service.items.length; i++) {
                    if (!orderForEdit.service.items[i].equipmentLength) {
                        orderForEdit.service.items[i].equipmentLength = {
                            unitRDN: (userPreferences.unitOfMeasure === 'standard')
                                ? RefDataMappingService.getItemId('FEET_UOM')
                                : RefDataMappingService.getItemId('CENTIMETERS_UOM')
                        }
                    }
                    if (!orderForEdit.service.items[i].equipmentHeight) {
                        orderForEdit.service.items[i].equipmentHeight = {
                            unitRDN: (userPreferences.unitOfMeasure === 'standard')
                                ? RefDataMappingService.getItemId('INCHES_UOM')
                                : RefDataMappingService.getItemId('CENTIMETERS_UOM')
                        }
                    }
                    if (!orderForEdit.service.items[i].equipmentWidth) {
                        orderForEdit.service.items[i].equipmentWidth = {
                            unitRDN: (userPreferences.unitOfMeasure === 'standard')
                                ? RefDataMappingService.getItemId('INCHES_UOM')
                                : RefDataMappingService.getItemId('CENTIMETERS_UOM')
                        }
                    }
                }
            }
            return orderForEdit;
        };

        function removeEmptyRefNums(order) {

            removeItemsEmptyRefNums(order.customerInfo);
            removeItemsEmptyRefNums(order);
            removeBillToEmptyRefNums(order.billTos);
            removeServiceEmptyRefNums(order.service);
        }

        function removeServiceEmptyRefNums(service) {

            if (angular.isUndefined(service)) {
                return;
            }

            if (angular.isDefined(service.items)) {

                for (var i = 0; i < service.items.length; i++) {

                    var item = service.items[i];

                    removeItemsEmptyRefNums(item);
                }
            }

            if (angular.isDefined(service.pickupFrom)) {
                removeItemsEmptyRefNums(service.pickupFrom);
            }

            if (angular.isDefined(service.deliverTo)) {
                removeItemsEmptyRefNums(service.deliverTo);
            }
        }

        function removeBillToEmptyRefNums(billTos) {

            if (angular.isUndefined(billTos)) {
                return;
            }

            for (var i = 0; i < billTos.length; i++) {

                var billTo = billTos[i];

                removeItemsEmptyRefNums(billTo);
            }
        }

        function removeItemsEmptyRefNums(item) {

            if (angular.isUndefined(item) || angular.isUndefined(item.referenceNumbers)) {
                return;
            }

            for (var i = item.referenceNumbers.length - 1; i >= 0; i--) {
                if (angular.isUndefined(item.referenceNumbers[i].value) || item.referenceNumbers[i].value === '') {
                    item.referenceNumbers.splice(i, 1);
                }
            }
        }

        function getRefNumber(refNumbers, refDataNumber) {
            for (var i = 0; i < refNumbers.length; i++) {
                if (refNumbers[i].referenceNumberType.refDataNumber === refDataNumber) {
                    return refNumbers[i].value;
                }
            }
            return null;
        }

        this.getCustomerOrder = function (order) {
            var items = getCustomerOrderItems(order.items, order.createdViaPurchaseOrder);
            var pickupNotes = order.pickup.notes;
            if (order.pickup.volumeQuoteId) {
                if (pickupNotes) {
                    pickupNotes = order.pickup.volumeQuoteId + ' \n' + pickupNotes;
                }
                else {
                    pickupNotes = order.pickup.volumeQuoteId + ' \n';
                }
            }
            var customerOrder = {
                services: [{
                    serviceOffering: order.serviceOffering,
                    pickupFrom: {
                        address: order.pickup.address,
                        location: order.pickup,
                        pickLocationNumber: order.pickup.pickLocationNumber,
                        dropLocationNumber: order.pickup.dropLocationNumber,
                        referenceNumbers: [],
                        specialInstructions: pickupNotes,
                        earliestDate: {
                            utcDateTime: order.pickup.earliestDate,
                            offSet: order.pickup.earliestDate.getTimezoneOffset()
                        },
                      latestDate: {
                            utcDateTime: order.pickup.latestDate,
                            offSet: order.pickup.latestDate.getTimezoneOffset()
                        },
                      loadingTypeRDN: order.pickup.loadingType && order.pickup.loadingType.refDataNumber ? order.pickup.loadingType.refDataNumber : null
                    },
                    deliverTo: {
                        address: order.delivery.address,
                        location: order.delivery,
                        pickLocationNumber: order.pickup.pickLocationNumber,
                        dropLocationNumber: order.pickup.dropLocationNumber,
                        referenceNumbers: [],
                        specialInstructions: order.delivery.notes,
                        earliestDate: {
                            utcDateTime: order.delivery.earliestDate,
                            offSet: order.delivery.earliestDate.getTimezoneOffset()
                        },
                        latestDate: {
                            utcDateTime: order.delivery.latestDate,
                            offSet: order.delivery.latestDate.getTimezoneOffset()
                        },
                        loadingTypeRDN: order.delivery.loadingType && order.delivery.loadingType.refDataNumber ? order.delivery.loadingType.refDataNumber : null
                    },
                    items: items,
                    carrierCode: order.preferredCarrier ? order.preferredCarrier.carrierCode : null,
                    carrierPartyNumber: order.preferredCarrier ? order.preferredCarrier.partyNumber : null,
                    referenceNumbers: [],
                    isTeam: order.isTeam
                }],
                charges: [],
                referenceNumbers: [],
                customerInfo: {
                    customer: order.customer,
                    referenceNumbers: []
                },
                billTos: [{
                    customer: order.customer,
                    referenceNumbers: [],
                    ediFreightTermsRDN: order.createdViaPurchaseOrder ? RefDataMappingService.getCategoryId('FREIGHT_TERM_COLLECT') : null
                }],
                billToReferenceNumber: order.billToReferenceNumber,
                customerReferenceNumber: order.customerReferenceNumber,
                createdViaPurchaseOrder: order.createdViaPurchaseOrder,
                quoteRequestId: order.quoteRequestId
            };
            _.forEach(order.charges, function(charge) {
              var mappedCharge = {};

              if (order.currencyCode) {
                mappedCharge.currencyCode = order.currencyCode;
              } else {
                mappedCharge.currencyCode = "USD";
              }

              mappedCharge.rateQuantity = charge.quantity ? charge.quantity : 1;;
              mappedCharge.amount = charge.totalRate;

              var convertedRateTypeRDN = convertRateTypeCodeToRDN(charge.rateTypeCode);
              mappedCharge.rateTypeRDN = convertedRateTypeRDN != 0 ? convertedRateTypeRDN : charge.rateEntryType;
              mappedCharge.rate = charge.unitRate;
              mappedCharge.rateCodeCode = charge.rateCode;
              mappedCharge.rateDescription = charge.rateDescription;
              mappedCharge.quoteTypeId = charge.quoteTypeId;
              mappedCharge.quoteId = charge.salesQuoteId && charge.rateSourceRDN === rateSourceMap.SQ ? charge.salesQuoteId : charge.quoteId;
              mappedCharge.rateSourceRDN = rateSourceMap[charge.rateSource] != undefined ? rateSourceMap[charge.rateSource] : charge.rateSourceRDN;
              mappedCharge.sourceSystemRDN = charge.sourceSystemRDN;
              mappedCharge.quoteSeqNum = charge.quoteSeqNum;

              customerOrder.charges.push(mappedCharge);
            });

            var service = customerOrder.services[0];
            if (order.pickup.earliestTime) {
                service.pickupFrom.earliestTime = { utcDateTime: order.pickup.earliestTime, offSet: order.pickup.earliestTime.getTimezoneOffset() };
            }

            if (order.pickup.latestTime) {
                service.pickupFrom.latestTime = { utcDateTime: order.pickup.latestTime, offSet: order.pickup.latestTime.getTimezoneOffset() };
            }

            if (order.delivery.earliestTime) {
                service.deliverTo.earliestTime = { utcDateTime: order.delivery.earliestTime, offSet: order.delivery.earliestTime.getTimezoneOffset() };
            }

            if (order.delivery.latestTime) {
                service.deliverTo.latestTime = { utcDateTime: order.delivery.latestTime, offSet: order.delivery.latestTime.getTimezoneOffset() };
            }

            //pickup reference numbers
            if (order.pickup.pickupNumber) {
                service.pickupFrom.referenceNumbers.push({ value: order.pickup.pickupNumber, referenceNumberType: { RefDataNumber: RefDataMappingService.getCategoryId('PICKUP_NUMBER') } });
            }

            if (order.pickup.bol) {
                service.pickupFrom.referenceNumbers.push({ value: order.pickup.bol, referenceNumberType: { RefDataNumber: RefDataMappingService.getCategoryId('BOL_NUMBER') } });
            }
            //delivery reference numbers
            if (order.delivery.deliveryNumber) {
                service.deliverTo.referenceNumbers.push({ value: order.delivery.deliveryNumber, referenceNumberType: { RefDataNumber: RefDataMappingService.getCategoryId('DELIVERY_NUMBER') } });
            }

            //carrier pre pro number
            if (order.carrierPreProNumber){
              service.referenceNumbers.push({
                  value: order.carrierPreProNumber,
                  referenceNumberType: {
                    RefDataNumber: RefDataMappingService.getCategoryId('CARRIER_PRO_NUMBER')
                  }
                });
            }

            if (order.newRefNums) {
              mapReferenceNumbers(customerOrder, order)
            }

            if (order.referenceNumbers) {
              _.forEach(order.referenceNumbers, function(refNum) {
                if(refNum.referenceNumberType.refDataNumber === RefDataMappingService.getCategoryId('QUOTE_ID')){
                  customerOrder.referenceNumbers.push(refNum);
                }
              })
            }

            if (order.carrierCode) {
              service.carrierCode = order.carrierCode;
            }

            return customerOrder;
        };

        function getCustomerOrderItems(items, createdViaPurchaseOrder) {
            var customerOrderItems = [];
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var itemInfo = {
                    commodity: item.commodity,
                    unitQuantity: item.quantity,
                    totalPallets: item.pallets,
                    description: item.commodityName,
                    notes: item.notes,
                    totalInsuranceValue: item.totalInsuranceValue,
                    totalPalletSpaces: item.palletSpaces,
                    coilRacks: (item.flatbed) ? item.flatbed.coilRacks : null,
                    maxTrailerAge: (item.flatbed) ? item.flatbed.trailerage : null,
                    requiredChainsCount: (item.flatbed) ? item.flatbed.chains : null,
                    requiredStrapsCount: (item.flatbed) ? item.flatbed.straps : null,
                    lockBars: (item.flatbed) ? item.flatbed.locksbars : null,
                    owod: (item.flatbed) ? item.flatbed.owod : null,
                    nmfc: item.nmfc,
                    totalWeight: { unitRDN: item.weightUom, value: item.weight },
                    purchaseOrderItemId: item.purchaseOrderItemId,
                    purchaseOrderNumber: item.purchaseOrderNumber,
                    lineItemId: item.lineItemId,
                    innerPackQuantity : (createdViaPurchaseOrder) ? item.quantity : null,
                    referenceNumbers: [],
                    unitLength: item.unitLength,
                    unitWidth: item.unitWidth,
                    unitHeight: item.unitHeight
                };



                if(!itemInfo.commodity) {
                  itemInfo.commodity = {};
                }
               // Bug 198310: PRB52750 - Online 2.0 Draw PO not pulling in the SKU
               if(item.commodity) {
                  itemInfo.commodity.sku = item.commodity.sku;
                 }
                  itemInfo.commodity.commodityName = item.commodityName;
                  itemInfo.commodity.IsStackable = item.isStackable;

                if (item.lengthInUom && item.widthInUom && item.heightInUom) {
                  itemInfo.lengthInUom = item.lengthInUom;
                  itemInfo.widthInUom = item.widthInUom;
                  itemInfo.heightInUom = item.heightInUom;

                  itemInfo.lengthInUomLabel = item.lengthInUomLabel;
                  itemInfo.widthInUomLabel = item.widthInUomLabel;
                  itemInfo.heightInUomLabel = item.heightInUomLabel;
                }

                if (item.lengthCmUom && item.widthCmUom && item.heightCmUom) {
                  itemInfo.lengthCmUom = item.lengthCmUom;
                  itemInfo.widthCmUom = item.widthCmUom;
                  itemInfo.heightCmUom = item.heightCmUom;

                  itemInfo.lengthCmUomLabel = item.lengthCmUomLabel;
                  itemInfo.widthCmUomLabel = item.widthCmUomLabel;
                  itemInfo.heightCmUomLabel = item.heightCmUomLabel;
                }

                if (item.freightClass) {
                    itemInfo.freightClassRDN = item.freightClass.refDataNumber;
                }
                if (item.trailerFeet) {
                    itemInfo.totalTrailerFeet = item.trailerFeet;
                }
                if (item.packaging) {
                    itemInfo.packagingTypeRDN = item.packaging.refDataNumber;
                }
                if (item.tempCategory) {
                    itemInfo.TemperatureCategoryRDN = item.tempCategory.refDataNumber;
                }
                if (item.flatbed && item.flatbed.loading) {
                    itemInfo.loadingTypeRDN = item.flatbed.loading.refDataNumber;
                }
                if (item.flatbed && item.flatbed.equipment) {
                    itemInfo.itemEquipmentRDN = item.flatbed.equipment.refDataNumber;
                }
                if (item.flatbed && item.flatbed.tarp) {
                    itemInfo.tarpTypeRDN = item.flatbed.tarp.refDataNumber;
                }
                if (item.flatbed && item.flatbed.length) {
                    itemInfo.equipmentLength = { unitRDN: item.flatbed.lengthUom, value: item.flatbed.length };
                }
                if (item.flatbed && item.flatbed.lengthIn) {
                    itemInfo.equipmentLengthIn = { unitRDN: item.flatbed.lengthInUom, value: item.flatbed.lengthIn };
                }
                if (item.flatbed && item.flatbed.width) {
                    itemInfo.equipmentWidth = { unitRDN: item.flatbed.widthUom, value: item.flatbed.width };
                }
                if (item.flatbed && item.flatbed.height) {
                    itemInfo.equipmentHeight = { unitRDN: item.flatbed.heightUom, value: item.flatbed.height };
                }
                if (item.purchaseOrderItemId) {
                    itemInfo.referenceNumbers.push({ value: Math.abs(item.purchaseOrderItemId) * -1, referenceNumberType: { RefDataNumber: RefDataMappingService.getItemId('FULFILMENT_ORDER_ITEM_IDENTIFIER') } });
                }
                if (item.purchaseOrderNumber) {
                    itemInfo.referenceNumbers.push({ value: item.purchaseOrderNumber, referenceNumberType: { RefDataNumber: RefDataMappingService.getCategoryId('CUSTOMER_PO_NUMBER') } });
                }
                if (item.poNum) {
                  itemInfo.referenceNumbers.push({ value: item.poNum, referenceNumberType: { RefDataNumber: RefDataMappingService.getItemId('PURCHASE_ORDER_NUMBER') } });
                }
                if (item.lineItemNumber) {
                    itemInfo.referenceNumbers.push({ value: item.lineItemNumber, referenceNumberType: { RefDataNumber: RefDataMappingService.getItemId('VENDOR_PO_LINE_NUMBER') } });
                }
                customerOrderItems.push(itemInfo);
            }
            return customerOrderItems;
        }

      function convertRateTypeCodeToRDN(code) {
        var rateTypeRDN = 0;
        _.forEach(rateTypes, function (type) {
          if (type.code == code) {
            rateTypeRDN = type.rdn;
          }
        });
        return rateTypeRDN;
      }
    }
    angular.module('NavisphereOnline').service('OrderTransformService', orderTransformService);
})();

var rateSourceMap = {
  "CM": 788,
  "CHR-FQ": 5373,
  "CHR-FQ Custom": 5389,
  "Transactional": 6282,
  "Contractual": 6283,
  "SGA": 5859,
  "SQ": 5374,
  "ManualQuote": 5806
};

var rateTypes = [
  {
    code: "M",
    rdn: 765,
    description: "Per Mile"
  },
  {
    code: "F",
    rdn: 775,
    description: "Flat Rate"
  },
  {
    code: "A",
    rdn: 776,
    description: "Fixed Charge"
  },
  {
    code: "J",
    rdn: 778,
    description: "Percent Of Net"
  }
];

(function () {
  "use strict";

  OrderCreateService.$inject = ["$filter", "$state", "$uibModal", "OrderConfirmationService", "OrderService", "OrderTransformService"];

  function OrderCreateService($filter, $state, $uibModal, OrderConfirmationService, OrderService, OrderTransformService) {
    this.createOrder = function($scope) {
      if (!$scope.submittingOrder) {
        $scope.submittingOrder = true;
        if (pickDeliverSequenceValid($scope)) {
          $scope.loadingModal = $uibModal.open({
            templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
            size: 'sm',
            controller: 'loadingSpinnerController',
            backdrop: 'static',
            resolve: {
              title: function () {
                return $filter('translate')('PLACING_ORDER');
              }
            }
          });
          $scope.loadingModal.result.then(function () {
          }, function () {
          });

          var customerOrderRequest = OrderTransformService.getCustomerOrderSaveRequest($scope.order);
          var orderService = new OrderService(customerOrderRequest);
          orderService.$save().then(function (result) {
            $scope.loadingModal.close(result);
            if (result.success) {
              $scope.orderForm.$dirty = false;
              OrderConfirmationService.setOrderConfirmation($scope.order, result, $scope.itemSummary, $scope.userPreferences);
              $state.go('app.orderConfirmation');
            } else {
              angular.forEach(result.errors, function (error) {
                $scope.validationMessages.push($filter('translate')(error.errorMessage));
              });
              $scope.showValidationError();
            }
          }, function (result) {
            $scope.loadingModal.close(result);
            $scope.validationMessages.push($filter('translate')('WE_ARE_UNABLE_TO_PROCESS_YOUR_ORDER_AT_THIS_TIME_P'));
            $scope.showValidationError();
          });

        } else {
          $scope.showValidationError();
        }
      }
    };

    function pickDeliverSequenceValid($scope) {
      //Same day Truckload Orders are allowed to pick any date available for delivery
      if (isSameDayTruckloadOrder($scope)) {
        return true;
      }
      var latestPickupDate = moment($scope.order.pickup.latestDate);
      var earliestDeliveryDate = moment($scope.order.delivery.earliestDate);
      var latestPickLessThanEarliestDelivery;
      if (latestPickupDate < earliestDeliveryDate) {
        latestPickLessThanEarliestDelivery = true;
      } else if (latestPickupDate.diff(earliestDeliveryDate) === 0) {
        var latestPickupTime = moment($scope.order.pickup.latestTime);
        var earliestDeliveryTime = moment($scope.order.delivery.earliestTime);
        if (latestPickupTime < earliestDeliveryTime) {
          latestPickLessThanEarliestDelivery = true;
        } else {
          latestPickLessThanEarliestDelivery = false;
        }
      } else {
        latestPickLessThanEarliestDelivery = false;
      }
      if (!latestPickLessThanEarliestDelivery) {
        $scope.validationMessages.push($filter('translate')('PICKUP_LATEST_DATE_TIME_RANGE_MUST_BE_BEFORE_DELIV'));
      }
      return latestPickLessThanEarliestDelivery;
    }
  }

  function isSameDayTruckloadOrder($scope) {
    var flatbedId = 1482;
    var truckloadId = 1481;
    var isTruckloadOrder = $scope.order.serviceOffering.id === flatbedId || $scope.order.serviceOffering.id === truckloadId;
    var isSameDayQuote = $scope.quote.transit && $scope.quote.transit.minimumTransitDays === 0 && $scope.quote.transit.maximumTransitDays === 1;
    return isTruckloadOrder && isSameDayQuote;
  }

  angular.module('NavisphereOnline').service('OrderCreateService', OrderCreateService);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  orderConfirmationService.$inject = [];
  function orderConfirmationService() {
    var _order, _confirmation, _summary, _preferences;
    this.setOrderConfirmation = function(order, confirmation, summary, preferences){
      _order = order;
      _confirmation = confirmation;
      _summary = summary;
      _preferences = preferences;
    };
    this.getOrder = function(){
      return _order;
    };
    this.getConfirmation = function(){
      return _confirmation;
    };
    this.getSummary = function(){
      return _summary;
    };
    this.getPreferences = function(){
      return _preferences;
    };
  }
  app.service('OrderConfirmationService', orderConfirmationService);
})();

(function() {
  "use strict";

  CreateOrderRefNumberService.$inject = ["$filter", "RefDataMappingService"];

  function CreateOrderRefNumberService($filter, RefDataMappingService) {
    this.getNewRefNumList = function() {
      return [
        {
          value: "",
          referenceNumberType: {
            description: $filter("translate")("SHIP_WITH_POUND"),
            refDataNumber: RefDataMappingService.getCategoryId("SHIPWITH_NUMBER")
          }
        }
      ];
    };
  }

  angular.module("NavisphereOnline").service("CreateOrderRefNumberService", CreateOrderRefNumberService);
})();

(function() {
  "use strict";

  BolCommentService.$inject = ["CustomerPartyService", "ItemService"];

  function BolCommentService(CustomerPartyService, ItemService) {
    this.get = function(cust) {
      CustomerPartyService.getBOLComment({
        partyNumberOrCode: cust.partyNumber
      }, function(response) {
        cust.bolComment = response.bolComment;
      });
    }
    this.getSearchItem = function (item, customer) {
      var productName = angular.isUndefined(item.productName) ? "null": item.productName;
      return ItemService.searchitems({ customerCode: customer.partyCode, term: productName }).$promise.then(function (itemDetails) {
        if (itemDetails.commodity) {
          item.commodity = {
            commodityCode: itemDetails.commodity.commodityCode,
            hazardousDOTName: itemDetails.commodity.hazardousDOTName,
            hazmatClassCode: itemDetails.commodity.hazmatClassCode,
            hazmatPackagingGroup: itemDetails.commodity.hazmatPackagingGroup,
            hazmatTechnicalName: itemDetails.commodity.hazmatTechnicalName,
            hazmatUNNumber: itemDetails.commodity.hazmatUNNumber,
            hazmatEmergencyPhone: itemDetails.commodity.hazmatEmergencyPhone,
            isHazardous: itemDetails.commodity.isHazardous
          };
        }
        return item;
      });
    }
  }

  angular.module("NavisphereOnline").service("BolCommentService", BolCommentService);
})();

(function () {
    angular.module('NavisphereOnline').filter('refNumberFilter', function () {
        return function (refNums, orderRefNums, itself) {
            var out = [];

            refNums.forEach(function (refNum) {
                var itemMatches = false;

                orderRefNums.forEach(function(orderRefNum) {
                    if (orderRefNum.referenceNumberType && refNum.refDataNumber === orderRefNum.referenceNumberType.refDataNumber)
                        itemMatches = true;
                });

                if (!itemMatches) {
                    out.push(refNum);
                }

                if (itself && refNum.refDataNumber === itself.refDataNumber) {
                    out.push(refNum);
                }
            });

            return out;
        }
    });
}());
(function() {
    angular.module('NavisphereOnline').filter('propsFilter', function() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                items.forEach(function(item) {
                    var itemMatches = false;
                    var keys = Object.keys(props);
                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();

                        if (item[prop] && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        }
    });
}());

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    app.directive('recentCustomers', [function () {
        return {
            templateUrl: '/app/order/directives/recentCustomers.tpl.html',
            restrict: 'E',
            link: function (scope) {
                scope.getDisplayName = scope.$parent.getDisplayName;
            },
            scope: {
                recentCustomers: "=",
                selectedRecentCustomer: "=",
                selectedRecentCustomerChange: "&"
            },
            controller: ['$scope', function ($scope) {
                $scope.changeSelectedRecentCustomer = function (cust) {
                    $scope.selectedRecentCustomerChange()(cust);
                };
            }]
        }
    }]);
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    app.directive('orderLocation', [function () {
        return {
            templateUrl: 'app/order/directives/order-location.tpl.html',
            restrict: 'E',
            scope: {
                location: "="
            },
            controller: ['$scope', 'AddressService', function ($scope, AddressService) {

                $scope.getLocationDisplayName = function (location) {
                    if (location) return location.addressName ? location.addressName : location.locationPartyName;
                    return '';
                };
                $scope.getAddressLine1 = function (address) {
                    return AddressService.GetAddressLine1(address);
                };
                $scope.getAddressLine2 = function (address) {
                    return AddressService.GetAddressLine2(address);
                };
                $scope.getAddressLine3 = function (address) {
                    return AddressService.GetAddressLine3(address);
                };
                $scope.getAddressLine4 = function (address) {
                    return AddressService.GetAddressLine4(address);
                };
            }]
        }
    }]);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('latestDateValidator', ['$parse', 'DateTimeService', function ($parse, DateTimeService) {
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {

        var validateDateRange = function (inputValue) {

          var earliestDate = moment(attrs.latestDateValidator).toDate();
          var latestDate = inputValue;

          var isValidDateRange = DateTimeService.isValidDateRange(earliestDate, latestDate);

          if (!isValidDateRange)
            $parse(attrs.ngModel).assign(scope, earliestDate);

          return inputValue;
        };

        ctrl.$parsers.unshift(validateDateRange);

        attrs.$observe('latestDateValidator', function () {

          if (attrs.latestDateValidator !== '') {
            var earliestDate = moment(attrs.latestDateValidator).toDate();

            if (!ctrl.$modelValue && DateTimeService.isValidDate(earliestDate))
              $parse(attrs.ngModel).assign(scope, earliestDate);
          }

          validateDateRange(ctrl.$modelValue);
        });
      }

    };

  }]);
}());

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('earliestDateValidator', ['$parse', 'DateTimeService', function ($parse, DateTimeService) {
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        var validateDateRange = function (inputValue) {
          return inputValue;
        };

        ctrl.$parsers.unshift(validateDateRange);

        attrs.$observe('earliestDateValidator', function () {

          if (attrs.earliestDateValidator !== '') {
            var latestDate = moment(attrs.earliestDateValidator).toDate();

            if (!ctrl.$modelValue && DateTimeService.isValidDate(latestDate)) {
              $parse(attrs.ngModel).assign(scope, latestDate);
            }
          }

          validateDateRange(ctrl.$modelValue);
        });
      }

    };

  }]);
}());

(function () {
    'use strict';
    pickupController.$inject = ['$scope', '$uibModal', 'analyticsService', 'LocationService', '$locale', 'DateTimeService', 'LocationSelectionHelper', 'UserPermissionService', 'LocationDateHelper'];

    function pickupController($scope, $uibModal, analyticsService,  LocationService, $locale, DateTimeService, LocationSelectionHelper, UserPermissionService, LocationDateHelper) {

        $scope.format = $locale.DATETIME_FORMATS['shortDate'];
        $scope.originLocationResults = [];
        $scope.recentOrigins = [];
        if(angular.isDefined($scope.$parent.order.customer)) {
          $scope.hasAddLocation = UserPermissionService.hasCustomerRole($scope.$parent.order.customer.partyCode, 'Add New Location');
        }

        $scope.openEarliestDate = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.earliestDateOpened = true;
        };

        $scope.ismeridian = $scope.$parent.userPreferences.timeFormat === '12';

        $scope.earliestDateOptions ={
          showWeeks: false,
          minDate: DateTimeService.getToday(),
          maxDate: DateTimeService.getDateTwoYearsFromNow()
        };

        $scope.latestDateOptions ={
          showWeeks: false,
          minDate: DateTimeService.getToday(),
          maxDate: DateTimeService.getDateTwoYearsFromNow()
        };

        $scope.hstep = 1;
        $scope.mstep = 15;
        $scope.openLatestDate = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.latestDateOpened = true;
        };

        $scope.refreshOriginLocations = function (searchText) {
            if (searchText.length < 2) {
                $scope.$parent.order.pickupHasNoResults = false;
                return [];
            }

            if(angular.isUndefined($scope.hasAddLocation)){
              $scope.hasAddLocation = UserPermissionService.hasCustomerRole($scope.order.customer.partyCode, 'Add New Location');
            }

            $scope.originLocationResults = [];
            return LocationService.searchPartyLocation({
                partyNumberOrCode: $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, ''),
                term: searchText,
                limit: 20,
                locationSearchType: 1,
                useSupplierLocation: $scope.order.customer.useSupplierLocation
            }, function (data) {
                $scope.originLocationResults = data.items;
                $scope.$parent.order.pickupHasNoResults = data.items.length === 0;
            });

        };
        $scope.addNewLocation = function () {
          analyticsService.track("addNewLocation");
            var modalInstance = $uibModal.open({
                templateUrl: '../app/addLocationModals/views/addLocation.tpl.html',
                size: 'lg',
                controller: 'addLocationController',
                backdrop: 'static',
                scope: $scope.$parent,
                resolve: {
                  customer: function () {
                    return ($scope.order.customer) ? $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, '') : '';
                  },
                  locationType: function() {
                    if($scope.$parent.pickupNeedsRefinement){
                      return "pickup";
                    }
                    return "";
                  },
                  supplier: function () {
                    return (angular.isDefined($scope.user) && angular.isDefined($scope.user.supplierPartyCode)
                    && angular.isDefined($scope.order.customer) && $scope.order.customer.useSupplierLocation)
                      ?  $scope.user.supplierPartyCode
                      : undefined;
                  }
                }
            });
            modalInstance.result.then(function (newLocation) {
              if ($scope.$parent.isQuoteToOrder) {
                var locationDateTime = $scope.$parent.getLocationDateTime('pickup') ;
                hydrateLocation(newLocation);
                $scope.$parent.pickupTemp = $scope.$parent.order.pickup;
                $scope.$parent.hydrateLocationDateTime('pickup', locationDateTime);
              } else {
                hydrateLocation(newLocation);
              }
            }, function () {
            });
        };

        function hydrateLocation(newLocation) {
          $scope.$parent.order.pickupHasNoResults = false;
          if ($scope.$parent.order.pickup.volumeQuoteId){
            newLocation.volumeQuoteId = $scope.$parent.order.pickup.volumeQuoteId;
          }
          $scope.$parent.order.pickup = newLocation;
          $scope.$parent.order.pickup.addressName = $scope.$parent.order.pickup.name;
          $scope.$parent.order.pickup.address = $scope.$parent.order.pickup.physicalAddress;
          $scope.$parent.order.pickup.earliestTime = DateTimeService.getBeginningOfDay();
          $scope.$parent.order.pickup.latestTime = DateTimeService.getBeginningOfDay();
        }

        $scope.$watch('$parent.order.pickup.earliestDate', function (newValue) {
            var times = LocationDateHelper.getEarliestAndLatestTimeFromScopeOrder({
                newValue: newValue,
                orderType: 'pickup',
                scopeOrder: $scope.order,
                scopeParentOrder: $scope.$parent.order
            });
            var orderPickup = $scope.$parent.order.pickup;
            if(times.earliestTime) {
                orderPickup.earliestTime = times.earliestTime;
            }

            $scope.latestDateOptions.minDate = DateTimeService.getLatestDateMinDate(newValue);
        });

        $scope.$watch('$parent.order.pickup.latestDate', function (newValue) {
            var times = LocationDateHelper.getEarliestAndLatestTimeFromScopeOrder({
                newValue: newValue,
                orderType: 'pickup',
                scopeOrder: $scope.order,
                scopeParentOrder: $scope.$parent.order
            });

            if(times.latestTime) {
                $scope.$parent.order.pickup.latestTime = times.latestTime;
            }
        });

        $scope.onPickupSelected = function (item, isRecent) {
          LocationSelectionHelper.onLocationSelected(item, $scope.$parent.order, 'pickup', isRecent, 2 /* `Unspecified` datetime serialization */);
          if(isRecent){
            analyticsService.trackWithVar('selectedRecentLocation', 'selectedRecentLocationValue', "selected recent location for pickup");
          }
        };

        $scope.$on('customerChanged', function (event, customer) {
            $scope.originLocationResults = [];
            $scope.$parent.order.pickup = null;
            $scope.hasAddLocation = UserPermissionService.hasCustomerRole(customer.partyCode, 'Add New Location');
            LocationService.getRecentOrigins({
                customerCode: customer.partyCode.replace(/^\s+|\s+$/gm, '')
            }).$promise.then(function (result) {
                $scope.recentOrigins = result;
            });
        });

        $scope.earliestTimeChanged = function(value) {
           if (value === null) {
               $scope.$parent.order.pickup.earliestTime = DateTimeService.getBeginningOfDay();
           }
        };
        $scope.latestTimeChanged = function (value) {
            if (value === null) {
                $scope.$parent.order.pickup.latestTime = DateTimeService.getBeginningOfDay();
            }
        };

        function setRecentOrigins() {
            if ($scope.order && $scope.order.customer) {
                LocationService.getRecentOrigins({
                    customerCode: $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, '')
                }).$promise.then(function (result) {
                    $scope.recentOrigins = result;
                });
            }
        }

        setRecentOrigins();
    }

    angular.module('NavisphereOnline').controller('PickupController', pickupController);
})();




(function () {
  'use strict';
  orderItemsController.$inject = ['$rootScope', '$scope', "$stateParams", '$timeout', '$filter', '$uibModal', 'analyticsService', 'ItemService', 'ItemServiceHelper', "UnitsOfMeasurementService",
    'UserPermissionService', 'ReferenceData', 'ModalService', 'RefDataMappingService', "FormService",
    'ConversionService', '$document', '$window'];
  function orderItemsController($rootScope, $scope, $stateParams, $timeout, $filter, $uibModal, analyticsService, ItemService, ItemServiceHelper, UnitsOfMeasurementService, UserPermissionService,
    ReferenceData, ModalService, RefDataMappingService, FormService, ConversionService,
    $document, $window) {

    //TODO Abstract to service
    var ftUomRefNum = RefDataMappingService.getItemId('FEET_UOM');
    var ftUom = $filter('translate')('FEET_UOM');
    var inUomRefNum = RefDataMappingService.getItemId('INCHES_UOM');
    var inUom = $filter('translate')('INCHES_UOM');
    var lbUomRefNum = RefDataMappingService.getItemId('LB_UOM');
    var lbUom = $filter('translate')('LB_UOM');
    var kgUomRefNum = RefDataMappingService.getItemId('KG_UOM');
    var kgUom = $filter('translate')('KG_UOM');
    var cmUomRefNum = RefDataMappingService.getItemId('CENTIMETERS_UOM');
    var cmUom = $filter('translate')('CENTIMETERS_UOM');

    //summarized field names
    var WEIGHT = 'weight';
    var TOTAL_INSURANCE_VALUE = 'totalInsuranceValue';
    var PALLETS = 'pallets';
    var QTY = 'quantity';
    var FLATBED_ONLY_RDN = 1890;

    var clientIdCounter = 0;
    var isMetric = $scope.userPreferences.unitOfMeasure === 'metric';
    $scope.hasAddNewCommodityPerTrans;

    $scope.isStackableClick = function (item) {
      item.isStackable = !item.isStackable;
    };

    $scope.searchItemResults = [];
    $scope.itemFilter = '';
    function hydrateItem(item) {
      return ItemService.get({ itemId: item.itemId }, function (itemDetails) {
        item.nmfc = itemDetails.nmfc;
        item.unitLength = itemDetails.unitLength;
        item.unitWidth = itemDetails.unitWidth;
        item.unitHeight = itemDetails.unitHeight;
        if (item.unitLength && item.unitWidth && item.unitHeight) {
          if (item.unitLength.value === 0) {
          item.unitLength.value = null;
          if (item.unitLength.unitRDN === 0 || !item.unitLength.unitRDN) {
          item.unitLength.unitRDN = null;
           }
           }
          if (item.unitWidth.value === 0) {
          item.unitWidth.value = null;
          if (item.unitWidth.unitRDN === 0 || !item.unitWidth.unitRDN) {
          item.unitWidth.unitRDN = null;
           }
           }
          if (item.unitHeight.value === 0) {
          item.unitHeight.value = null;
          if(item.unitHeight.unitRDN === 0 || !item.unitHeight.unitRDN) {
          item.unitHeight.unitRDN = null;
           }
           }
           }
          else {
          item.unitWidth = null;
          item.unitHeight = null;
          item.unitLength = null;
           }
        item.unitVolume = itemDetails.unitVolume;
        item.unitDensity = itemDetails.unitDensity;
        item.unitsPerPallet = itemDetails.unitsPerPallet;
        item.packaging = setDDLValByRdn('Packaging', itemDetails.packagingTypeRDN);
        setUnitsOfMeasurement(item, isMetric);
        addDefaultStackable(item);

        if (itemDetails.commodity) {
          item.isHot = itemDetails.commodity.isHot;
          item.requiredTemperatureHigh = itemDetails.commodity.requiredTemperatureHigh;
          item.requiredTemperatureLow = itemDetails.commodity.requiredTemperatureLow;
          item.isHazardous = itemDetails.commodity.isHazardous;
          item.commodity = {
            isHazardous: itemDetails.commodity.isHazardous,
            hazardousDOTName: itemDetails.commodity.hazardousDOTName,
            hazmatClassCode: itemDetails.commodity.hazmatClassCode,
            hazmatPackagingGroup: itemDetails.commodity.hazmatPackagingGroup,
            hazmatTechnicalName: itemDetails.commodity.hazmatTechnicalName,
            hazmatUNNumber: itemDetails.commodity.hazmatUNNumber,
            hazmatEmergencyPhone: itemDetails.commodity.hazmatEmergencyPhone,
            commodityCode: itemDetails.commodity.commodityCode
          };
        }
        if ($scope.order.isFlatbed) {
          item.tempCategory = $scope.dryTempCategory;
          item.flatbed.tarp = setDDLValByRdn('FBedTarpType', itemDetails.tarpTypeRDN);
          item.flatbed.loading = setDDLValByRdn('FBedLoadingType', itemDetails.loadingTypeRDN);
          item.flatbed.equipment = setDDLValByRdn('ItemEquipment', itemDetails.itemEquipmentRDN);
          item.flatbed.trailerage = itemDetails.maxTrailerAge;
          item.flatbed.straps = itemDetails.requiredStrapsCount;
          item.flatbed.chains = itemDetails.requiredChainsCount;
          if (itemDetails.equipmentLength) {
            item.flatbed.length = itemDetails.equipmentLength.value;
          }
          if (itemDetails.equipmentWidth) {
            item.flatbed.width = itemDetails.equipmentWidth.value;
          }
          if (itemDetails.equipmentHeight) {
            item.flatbed.height = itemDetails.equipmentHeight.value;
          }
          item.flatbed.coilRacks = itemDetails.coilRacks;
          item.flatbed.locksbars = itemDetails.lockBars;
        }
        else {
          item.tempCategory = (!itemDetails.temperatureCategoryRDN)
            ? $scope.dryTempCategory
            : setDDLValByRdn('TemperatureSensitive', itemDetails.temperatureCategoryRDN);
        }

        return item;
      }).$promise;
    }
    $scope.onItemSelected = function (item, shouldAddNewCard, index) {
      $scope.asyncItemSelected = undefined;
      $scope.itemFilter = '';
      item.flatbed = {};
      item.readOnlyProperties = {};
      item.readOnlyProperties.commodityName = true;
      item.readOnlyProperties.isHazardous = true;
      hydrateItem(item).then(function () {
        if ($scope.order.isTransactional) {
          if (item.tempCategory.refDataCode !== "Dry") {
            handleTransactional(index);

            return;
          }
        }
        setPreviousItemsTouched();
        item.clientId = clientIdCounter++;
        item.freightClass = item.freightClass == 0 ? undefined : setFreightClassByCode(item.freightClass);
        setUnitsOfMeasurement(item, isMetric);
        if (shouldAddNewCard) {
          $scope.order.items.push(item);
        } else {
          var firstFreightClass = angular.copy($scope.order.items[index].freightClass);
          if ($scope.$parent.isQuoteToOrder) {
            // we do not need to override value if it entered in Quote screen
            if ($scope.order.items[index].commodity !== JSON.undefined) {
              angular.merge($scope.order.items[index].commodity, item.commodity);
            }
            $scope.order.items[index].readOnlyProperties.unitLength = $scope.order.items[index].readOnlyProperties.length;
            $scope.order.items[index].readOnlyProperties.unitWidth = $scope.order.items[index].readOnlyProperties.width;
            $scope.order.items[index].readOnlyProperties.unitHeight = $scope.order.items[index].readOnlyProperties.height;
            for (var key in $scope.order.items[index]) {
              if ($scope.order.items[index].readOnlyProperties[key])
                item[key] = $scope.order.items[index][key];
            }
          }
          _.merge($scope.order.items[index], item);
          if (angular.isDefined(firstFreightClass)) {
            var freightClassList = $scope.itemDdlRefData['FreightClass'];
            var isFreightClassExist = _.find(freightClassList, function (fc) {
              return fc.refDataCode == firstFreightClass.refDataCode;
            });
            if (angular.isUndefined(isFreightClassExist)) {
              $scope.itemDdlRefData['FreightClass'].push(firstFreightClass);
            }
          }
          prefillComplexFields();
        }
        addDefaultStackable(item);
        $scope.order.isItemAltered = true;
        setFocusToAddedItem();
        registerItem();
        ieSelectFix();
      });
    };
    $scope.addShipmentItem = function () {
      setPreviousItemsTouched();
      var item = { clientId: clientIdCounter++, flatbed: {}, commodity: {}, commodityName: '' };
      setUnitsOfMeasurement(item, isMetric);
      addDefaultStackable(item);
      item.tempCategory = $scope.dryTempCategory;
      $scope.order.items.push(item);
      setFocusToAddedItem();
      registerItem();
      angular.element('#itemSearchInput').val('');
      ieSelectFix();
    };

    function addSuggestedShipmentItem(suggestedItem) {
      $scope.itemFilter = '';
      suggestedItem.flatbed = {};
      hydrateItem(suggestedItem).then(function () {
        setPreviousItemsTouched();
        suggestedItem.clientId = clientIdCounter++;
        suggestedItem.freightClass = suggestedItem.freightClass == 0 ? undefined : setFreightClassByCode(suggestedItem.freightClass);
        setUnitsOfMeasurement(suggestedItem, isMetric);
        addDefaultStackable(suggestedItem);
        $scope.order.items.push(suggestedItem);
        setFocusToAddedItem();
        registerItem();
        ieSelectFix();
      });
    }

    function addNewlyAddedItem(item) {
      item.commodityName = item.description;
      item.commodity = {};
      item.commodity.commodityName = item.description;
      item.commodity.isHot = item.isHot;
      item.quantity = item.qty;
      item.unitLength = {};
      if (item.perUnitLength != 0) {
        item.unitLength.value = item.perUnitLength;
        item.unitLength.unitRDN = item.perUnitLengthUom;
      }
      item.unitWidth = {};
      if (item.perUnitWidth != 0) {
        item.unitWidth.value = item.perUnitWidth;
        item.unitWidth.unitRDN = item.perUnitLengthUom;
      }
      item.unitHeight = {};
      if (item.perUnitHeight != 0) {
        item.unitHeight.value = item.perUnitHeight;
        item.unitHeight.unitRDN = item.perUnitLengthUom;
      }

      $scope.itemFilter = '';
      setPreviousItemsTouched();
      item.clientId = clientIdCounter++;
      setUnitsOfMeasurement(item, isMetric);
      addDefaultStackable(item);
      $scope.order.items.push(item);
      setFocusToAddedItem();
      registerItem();
      ieSelectFix();
    }

    $scope.addCatalogShipmentItem = function () {
      analyticsService.track('addNewItem');
      if ($scope.isAddCatalogShipmentItem) return;

      $scope.isAddCatalogShipmentItem = true;

      var modalInstance = $uibModal.open({
        templateUrl: '../app/addItemModals/views/addItem.tpl.html',
        size: 'lg',
        controller: 'addItemController',
        backdrop: 'static',
        resolve: {
          itemDdlRefData: function () {
            return $scope.itemDdlRefData;
          },
          showFlatbedAttributes: function () {
            return $scope.order.isFlatbed;
          },
          customer: function () {
            return $scope.order.customer;
          },
          user: function () {
            return $scope.user;
          },
          preferences: function () {
            return $scope.userPreferences;
          }
        }
      });

      modalInstance.result.then(function (suggestedItem) {

        $scope.isAddCatalogShipmentItem = false;

        if (!suggestedItem)
          return;

        suggestedItem.readOnlyProperties = {};
        suggestedItem.readOnlyProperties.commodityName = true;

        if (suggestedItem.qty)
          addNewlyAddedItem(suggestedItem);
        else
          addSuggestedShipmentItem(suggestedItem);
      }, function () {

      });
    };

    $scope.dryTempCategory = getDryTempCategory();
    function getDryTempCategory() {
      for (var i = 0; i < $scope.itemDdlRefData['TemperatureSensitive'].length; i++) {
        if ($scope.itemDdlRefData['TemperatureSensitive'][i].refDataCode === 'Dry') {
          return $scope.itemDdlRefData['TemperatureSensitive'][i];
        }
      }
    }

    function setFreightClassByCode(freightClassCode) {
      var fc = undefined;
      for (var i = 0; i < $scope.itemDdlRefData['FreightClass'].length; i++) {
        if ($scope.itemDdlRefData['FreightClass'][i].refDataCode === freightClassCode) {
          fc = $scope.itemDdlRefData['FreightClass'][i];
          break;
        }
      }
      return fc;
    }
    function setDDLValByRdn(category, tempCatRdn) {
      var tc = undefined;
      for (var i = 0; i < $scope.itemDdlRefData[category].length; i++) {
        if ($scope.itemDdlRefData[category][i].refDataNumber === tempCatRdn) {
          tc = $scope.itemDdlRefData[category][i];
          break;
        }
      }
      return tc;
    }
    function setPreviousItemsTouched() {
      angular.forEach($scope.order.items, function (item) {
        item.visited = true;
      });
    }
    function setFocusToAddedItem() {
      $timeout(function () {
        var elements = angular.element('.orderItem').last().find('input');
        _.forEach(elements, function (elementObj) {
          var element = angular.element(elementObj);
          if (!element.is('[readonly]')) {
            element.focus();
            return false;
          }
        });
      }, 300);
    }
    function ieSelectFix() {
      // ie9 and older script
      if ($document[0].all && !$window.atob) {
        $timeout(function () {
          angular.element("select").width(angular.element("select").width());
        }, 300, false);
      }
    }

    $scope.removeItem = function (item) {
      var removed = false;
      var modalOptions = {
        closeButtonText: 'CANCEL',
        actionButtonText: 'REMOVE',
        headerText: 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_ITEM',
        bodyText: 'ALL_INFORMATION_ENTERED_FOR_THIS_ITEM_WILL_BE_REMO'
      };

      ModalService.showModal({}, modalOptions).then(function (result) {
        if (result === 'ok') {
          angular.forEach($scope.order.items, function (itm, i) {
            if (!removed) {
              if (itm.clientId === item.clientId) {
                $scope.order.items.splice(i, 1);
                deregisterItem();
                removed = true;
              }
            }
          });
        }
      });
    };

    $scope.maxItemSearchResults = false;
    $scope.itemsNoResults = false;
    $scope.maxSearchResultLimit = 250;

    $scope.refreshSearchItems = function (search) {
      return ItemServiceHelper.searchHelper(search, $scope.order.customer, $scope, true);
    };

    $scope.showMaxItemSearchResults = function () {
      return $scope.maxItemSearchResults && (angular.isDefined(angular.element('#itemSearchInput')) ? angular.element('#itemSearchInput').val().length >= 2 : false);
    };
    $scope.showNoResultsFound = function () {
      return $scope.itemsNoResults && !$scope.searchingItems && angular.element('#itemSearchInput').val().length >= 2;
    };

    $scope.setDropdownSize = FormService.setDropdownSize;

    $scope.summaryFieldUpdates = [];

    $scope.summaryUpdate = function (fieldName) {
      $scope.summaryFieldUpdates.push(fieldName);
    };

    function setUnitsOfMeasurement(item, isMetric) {
      UnitsOfMeasurementService.setUnitsOfMeasurement(item, isMetric)
    }

    $scope.setLengthUomFt = function (item) {
      item.flatbed.lengthUom = ftUomRefNum;
      item.flatbed.lengthUomLabel = ftUom;
    };
    $scope.setLengthUomIn = function (item) {
      item.flatbed.lengthInUom = inUomRefNum;
      item.flatbed.lengthInUomLabel = inUom;
    };
    $scope.setWidthUomIn = function (item) {
      item.flatbed.widthUom = inUomRefNum;
      item.flatbed.widthUomLabel = inUom;
    };
    $scope.setHeightUomIn = function (item) {
      item.flatbed.heightUom = inUomRefNum;
      item.flatbed.heightUomLabel = inUom;
    };
    $scope.setWeightUomLb = function (item) {
      item.weightUom = lbUomRefNum;
      item.weightUomLabel = lbUom;
      $scope.summaryFieldUpdates.push(WEIGHT);
    };
    $scope.setWeightUomKg = function (item) {
      item.weightUom = kgUomRefNum;
      item.weightUomLabel = kgUom;
      $scope.summaryFieldUpdates.push(WEIGHT);
    };

    if ($scope.$parent.isQuoteToOrder) {
      _.forEach($scope.order.items, function (item) {
        registerItem();

        if (isMetric) {
          $scope.setWeightUomKg(item);
        } else {
          $scope.setWeightUomLb(item);
        }
      });
    }

    var inSummaryUpdate = false;
    $scope.$watchCollection('summaryFieldUpdates', function (newVal) {
      if (!inSummaryUpdate) {
        angular.forEach(newVal, function (fieldChangedName, i) {
          var valueSum = 0;
          angular.forEach($scope.order.items, function (item) {
            if (fieldChangedName == WEIGHT) {
              if (item.weight) {
                if (RefDataMappingService.getItemByRefNum(item.weightUom) === 'LB_UOM' &&
                  $scope.userPreferences.unitOfMeasure === 'metric') {
                  valueSum += isFinite(Number(item.weight))
                    ? ConversionService.convertLBtoKG(Number(item.weight), 2) : 0;
                }
                else if (RefDataMappingService.getItemByRefNum(item.weightUom) === 'KG_UOM' &&
                  $scope.userPreferences.unitOfMeasure === 'standard') {
                  valueSum += isFinite(Number(item.weight))
                    ? ConversionService.convertKGtoLB(Number(item.weight), 2) : 0;
                } else {
                  valueSum += isFinite(Number(item.weight)) ? Number(item.weight) : 0;
                }
              }
            } else {
              valueSum += isFinite(Number(item[fieldChangedName])) ? Number(item[fieldChangedName]) : 0;
            }
          });
          switch (fieldChangedName) {
            case WEIGHT:
              $scope.itemSummary.weight = valueSum; break;
            case TOTAL_INSURANCE_VALUE:
              $scope.itemSummary.insuranceValue = valueSum; break;
            case PALLETS:
              $scope.itemSummary.pallets = valueSum; break;
            case QTY:
              $scope.itemSummary.quantity = valueSum; break;
            default:
              break;
          }
          newVal.splice(i, 1);
        });
        inSummaryUpdate = false;
      }
    });
    $scope.$on('customerChanged', function () {
      $scope.searchItemResults = [];
      $scope.order.items = [];
      $scope.resetItemSummary();
      $scope.hasAddNewCommodityPerTrans = UserPermissionService.hasCustomerRole(
        $scope.order.customer.partyCode, 'Add New Commodity Per Transaction');
      $scope.hasCreateNewCommodityInPartyCatalog = UserPermissionService.hasCustomerRole(
        $scope.order.customer.partyCode, 'Create New Commodity in Party Catalog');
    });
    $scope.$on('modeSetToFlatbed', function () {
      for (var i = 0; i < $scope.order.items.length; i++) {
        $scope.order.items[i].tempCategory = $scope.dryTempCategory;
      }
    });

    function registerItem() {
      $scope.itemSummary.lineItems += 1;
      updateSummary();
    }
    function deregisterItem() {
      $scope.itemSummary.lineItems -= 1;
      updateSummary();
    }
    function updateSummary() {
      $scope.summaryFieldUpdates.push(WEIGHT, TOTAL_INSURANCE_VALUE, PALLETS, QTY);
    }
    function setHasAddNewCommodityPerTrans() {
      if ($scope.order && $scope.order.customer) {
        $scope.hasAddNewCommodityPerTrans = UserPermissionService.hasCustomerRole(
          $scope.order.customer.partyCode, 'Add New Commodity Per Transaction');
      }
    }
    function setHasCreateNewCommodityInPartyCatalog() {
      if ($scope.order && $scope.order.customer) {
        $scope.hasCreateNewCommodityInPartyCatalog = UserPermissionService.hasCustomerRole(
          $scope.order.customer.partyCode, 'Create New Commodity in Party Catalog');
      }
    }
    function addDefaultStackable(item) {
      item.commodity.isStackable = null;
      item.isStackable = null;
      $rootScope.$emit('getDensityBasedSuggestion', item);
    }

    function prefillComplexFields() {
      prefillPackaging();
      prefillTemperature();
      prefillFreightClass();
    }

    function prefillPackaging() {
      _.forEach($scope.order.items, function (item) {
        if (item.packaging) {
          item.packaging = _.filter($scope.itemDdlRefData.Packaging, { refDataNumber: item.packaging.refDataNumber })[0];
        }
      });
    }

    function prefillTemperature() {
      _.forEach($scope.order.items, function (item) {
        if (item.tempCategory) {
          item.tempCategory = _.filter($scope.itemDdlRefData.TemperatureSensitive, { refDataNumber: item.tempCategory.refDataNumber })[0];
        }
      });
    }

    function prefillFreightClass() {
      _.forEach($scope.order.items, function (item) {
        if (item.freightClass) {
          item.freightClass = _.filter($scope.itemDdlRefData.FreightClass, { refDataNumber: item.freightClass.refDataNumber })[0];
        }
      });
    }

    function handleTransactional(index) {
      var modalOptions = {
        closeButtonText: null,
        actionButtonText: "OK",
        headerText: 'ONLY_DRY_GOODS_ARE_SUPPORTED_AT_THIS_TIME',
        bodyText: 'PLEASE_SELECT_OR_ENTER_A_DIFFERENT_ITEM'
      };

      ModalService.showModal({}, modalOptions).then(function () {
        $scope.order.items[index].commodityName = null;
      });
    }

    function isNonLTLFlatbedTransactional() {
      var hasTransactionRate = false;
      var isFlatbedRequestType = false;
      if ($scope.quote && $scope.quote.rateList) {
        _.forEach($scope.quote.rateList, function(rate) {
          if(rate.rateSource === "Transactional" || rate.rateSource === "ManualQuote") {
            hasTransactionRate = true;
          }
        });
      }
      if ($scope.quote && $scope.quote.transportModeType) {
        isFlatbedRequestType = $scope.quote.transportModeType === 12;
      }

      return (isFlatbedRequestType && hasTransactionRate);
    }

    function setTransactionalFlatbedItemValues() {
      if (!isNonLTLFlatbedTransactional()) {
        return;
      }
      var flatbedOnlyEquipment = {};
      _.forEach($scope.itemDdlRefData.ItemEquipment, function (equipment) {
        if (equipment.refDataNumber === FLATBED_ONLY_RDN) {
          flatbedOnlyEquipment = equipment;
        }
      })
      if (flatbedOnlyEquipment !== {}) {
        _.forEach($scope.order.items, function (item) {
          item.flatbed.equipment = flatbedOnlyEquipment;
        });
      }
    }

    $scope.getFlatbedLength = function() {
      if(isNonLTLFlatbedTransactional()) {
        return 48;
      } else {
        return 100
      }
    }

    $scope.getFlatbedWidthAndHeight = function() {
      if(isNonLTLFlatbedTransactional()) {
        return 102;
      } else {
        return 240
      }
    }

    setHasAddNewCommodityPerTrans();
    setHasCreateNewCommodityInPartyCatalog();
    prefillComplexFields();
    setTransactionalFlatbedItemValues();
  }
  angular.module('NavisphereOnline').controller('orderItemsController', orderItemsController);
}());

(function () {
    'use strict';
    modeController.$inject = ['$scope', '$q', '$rootScope', '$filter', 'CreateOrderRefNumberService', 'ModalService', 'ServiceOfferingMapping',
      'ServiceOffering', 'RefDataMappingService'];

    function modeController($scope, $q, $rootScope, $filter, CreateOrderRefNumberService, ModalService, ServiceOfferingMapping, ServiceOffering,
                            RefDataMappingService) {

        var tl = ServiceOfferingMapping.getServiceOfferingId('TL_SERVICE_OFFERING');
        var ltl = ServiceOfferingMapping.getServiceOfferingId('LTL_SERVICE_OFFERING');
        var flatbed = ServiceOfferingMapping.getServiceOfferingId('FLATBED_SERVICE_OFFERING');
        var bulk = ServiceOfferingMapping.getServiceOfferingId('BULK_TRANSPORTATION');
        var intermodal = ServiceOfferingMapping.getServiceOfferingId('INTERMODAL_FULL_CONTAINER_TRANSPORTATION');

        $scope.order.newRefNums = CreateOrderRefNumberService.getNewRefNumList();

        $scope.form = {};

        angular.forEach($scope.serviceOfferings, function (offering) {
            switch (offering.id) {
                case tl:
                    $scope.serviceOfferingTL = offering;
                    $scope.serviceOfferingTL.displayKey = 'TRUCKLOAD';
                    break;
                case flatbed:
                    $scope.serviceOfferingFB = offering;
                    $scope.serviceOfferingFB.displayKey = 'FLATBED';
                    break;
                case ltl:
                    $scope.serviceOfferingLTL = offering;
                    $scope.serviceOfferingLTL.displayKey = 'LTL';
                    break;
                case bulk:
                    $scope.serviceOfferingBULK = offering;
                    $scope.serviceOfferingBULK.displayKey = 'BULK';
                    break;
                case intermodal:
                    $scope.serviceOfferingInterModal = offering;
                    $scope.serviceOfferingInterModal.displayKey = 'INTERMODAL';
                    break;
                default:
                    break;
            }
        });

        $scope.$on('customerChanged', function() {
            $scope.form.serviceOffering = null;
            $scope.order.newRefNums = CreateOrderRefNumberService.getNewRefNumList();
        });

        var modalOptions = {
            closeButtonText: 'NO',
            actionButtonText: 'YES',
            headerText: 'ARE_YOU_SURE_YOU_WANT_TO_CHANGE_YOUR_MODE',
            bodyText: 'CHANGING_MODE_WILL_CAUSE_COMMODITY_INFORMATION_TO_'
        };

        $scope.$watch('form.serviceOffering', function (newValue, oldValue) {

            if (!newValue)
                return;

            if (!oldValue || userDoesntHaveAnyCommodities()) {
                setModelServiceOffering(newValue);
                return;
            }

            if (oldValueEqualsNewValue(oldValue, newValue))
                return;

            if (modeChangedFromFlatbed(oldValue))
                confirmModeChange(oldValue, newValue);
            else if (modeChangedToFlatbed(newValue)) {
                $rootScope.$broadcast('modeSetToFlatbed');
                setModelServiceOffering(newValue);
            }
            else
                setModelServiceOffering(newValue);
        });

        function confirmModeChange(oldValue, newValue) {
            modeChangedConfirmation().then(
                function (changed) {
                    if (changed)
                        setModelServiceOffering(newValue);
                    else
                        setViewServiceOffering(oldValue);
                });
        }

        function setModelServiceOffering(serviceOffering) {
            $scope.order.serviceOffering = serviceOffering;
            $scope.order.isFlatbed = ServiceOffering.get($scope.order.serviceOffering.id).genericType === 'FLATBED';
        }

        function setViewServiceOffering(serviceOffering) {
            $scope.form.serviceOffering = serviceOffering;
        }

        function oldValueEqualsNewValue(oldValue, newValue) {

            return $scope.order.serviceOffering === newValue || oldValue === newValue;
        }

        function userDoesntHaveAnyCommodities() {
            return $scope.order.items && $scope.order.items.length === 0;
        }
        function modeChangedToFlatbed(newValue) {
            return newValue.id === flatbed;
        }
        function modeChangedFromFlatbed(oldValue) {
            return oldValue.id === flatbed;
        }

        function modeChangedConfirmation() {
            var deferred = $q.defer();

            if ($scope.order.serviceOffering) {
                ModalService.showModal({}, modalOptions).then(function (result) {
                    if (result === 'ok') {
                        deferred.resolve(true);
                    }
                }, function (result) {
                    if (result === 'cancel') {
                        deferred.resolve(false);
                    }
                });
            } else {
                deferred.resolve(true);
            }
            return deferred.promise;
        }
    }

    angular.module('NavisphereOnline').controller('ModeController', modeController);
}());

/*global moment */
(function () {
    'use strict';
    deliveryController.$inject = ['$scope', '$uibModal', 'analyticsService', 'LocationService', '$locale', 'DateTimeService', 'LocationSelectionHelper', 'UserPermissionService', 'LocationDateHelper'];

    function deliveryController($scope, $uibModal, analyticsService, LocationService, $locale, DateTimeService, LocationSelectionHelper, UserPermissionService, LocationDateHelper) {

        $scope.format = $locale.DATETIME_FORMATS['shortDate'];
        $scope.deliveryLocationResults = [];
        $scope.recentDestinations = [];
        if(angular.isDefined($scope.$parent.order.customer)) {
          $scope.hasAddLocation = UserPermissionService.hasCustomerRole($scope.$parent.order.customer.partyCode, 'Add New Location');
        }

        $scope.refreshDeliveryLocations = function (searchText) {
            if (searchText.length < 2) {
                $scope.$parent.order.deliveryHasNoResults = false;
                return [];
            }

            if(!$scope.hasAddLocation){
              $scope.hasAddLocation = UserPermissionService.hasCustomerRole($scope.order.customer.partyCode, 'Add New Location');
            }

            $scope.$parent.deliveryLocationResults = [];
              return LocationService.searchPartyLocation({
                  partyNumberOrCode: $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, ''),
                  term: searchText,
                  limit: 20,
                  locationSearchType: 2,
                  useSupplierLocation: $scope.order.customer.useSupplierLocation
              }, function (data) {
                  $scope.deliveryLocationResults = data.items;
                  $scope.$parent.order.deliveryHasNoResults = (data.items.length === 0) ? true : false;

              });

        };
        $scope.addNewLocation = function () {
            var modalInstance = $uibModal.open({
                templateUrl: '../app/addLocationModals/views/addLocation.tpl.html',
                size: 'lg',
                controller: 'addLocationController',
                backdrop: 'static',
                scope: $scope.$parent,
                resolve: {
                  customer: function () {
                    return ($scope.order.customer) ? $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, '') : '';
                  },
                  locationType: function() {
                    if($scope.$parent.deliveryNeedsRefinement){
                      return "delivery";
                    }
                    return "";
                  },
                  supplier: function () {
                    return (angular.isDefined($scope.user) && angular.isDefined($scope.user.supplierPartyCode)
                    && angular.isDefined($scope.order.customer) && $scope.order.customer.useSupplierLocation)
                      ?  $scope.user.supplierPartyCode
                      : undefined;
                  }
                }
            });
            modalInstance.result.then(function (newLocation) {
              if ($scope.$parent.isQuoteToOrder) {
                var locationDateTime = $scope.$parent.getLocationDateTime('delivery') ;
                hydrateLocation(newLocation);
                $scope.$parent.deliveryTemp = $scope.$parent.order.delivery;
                $scope.$parent.hydrateLocationDateTime('delivery', locationDateTime)
              } else {
                hydrateLocation(newLocation)
              }
            }, function () {
            });
        };

        function hydrateLocation(newLocation) {
            $scope.$parent.order.deliveryHasNoResults = false;
            $scope.$parent.order.delivery = newLocation;
            $scope.$parent.order.delivery.addressName = $scope.$parent.order.delivery.name;
            $scope.$parent.order.delivery.address = $scope.$parent.order.delivery.physicalAddress;
            $scope.$parent.order.delivery.earliestTime = DateTimeService.getBeginningOfDay();
            $scope.$parent.order.delivery.latestTime = DateTimeService.getBeginningOfDay();
        }

        $scope.$watch('$parent.order.delivery.earliestDate', function (newValue) {
            var times = LocationDateHelper.getEarliestAndLatestTimeFromScopeOrder({
                newValue: newValue,
                orderType: 'delivery',
                scopeOrder: $scope.order,
                scopeParentOrder: $scope.$parent.order
            });
            var orderDelivery = $scope.$parent.order.delivery
            if(times.earliestTime) {
                orderDelivery.earliestTime = times.earliestTime;
            }

            $scope.latestDateOptions.minDate = DateTimeService.getLatestDateMinDate(newValue);
        });

        $scope.$watch('$parent.order.delivery.latestDate', function (newValue) {
            var times = LocationDateHelper.getEarliestAndLatestTimeFromScopeOrder({
                newValue: newValue,
                orderType: 'delivery',
                scopeOrder: $scope.order,
                scopeParentOrder: $scope.$parent.order
            });

            if(times.latestTime) {
                $scope.$parent.order.delivery.latestTime = times.latestTime;
            }
        });

        $scope.openLatestDate = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.latestDateOpened = true;
        };

        $scope.ismeridian = $scope.$parent.userPreferences.timeFormat === '12';

        $scope.earliestDateOptions ={
          showWeeks: false,
          minDate: $scope.$parent.isQuoteToOrder ? $scope.$parent.setQuoteToOrderMinDate() : DateTimeService.getToday(),
          maxDate: DateTimeService.getDateTwoYearsFromNow()
        };

        $scope.latestDateOptions ={
          showWeeks: false,
          minDate: $scope.$parent.isQuoteToOrder ? $scope.$parent.setQuoteToOrderMinDate() : DateTimeService.getToday(),
          maxDate: DateTimeService.getDateTwoYearsFromNow()
        };

        $scope.hstep = 1;
        $scope.mstep = 15;

        $scope.openEarliestDate = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.earliestDateOpened = true;
        };

        $scope.onDeliverySelected = function (item, isRecent) {
          if(isRecent){
            analyticsService.trackWithVar('selectedRecentLocation', 'selectedRecentLocationValue', "selected recent location for deliver");
          }
          LocationSelectionHelper.onLocationSelected(item, $scope.$parent.order, 'delivery', isRecent, 2 /* `Unspecified` datetime serialization */);
        };

        $scope.$on('customerChanged', function (event, customer) {
            $scope.deliveryLocationResults = [];
            $scope.$parent.order.delivery = null;
            $scope.hasAddLocation = UserPermissionService.hasCustomerRole(customer.partyCode, 'Add New Location');
            LocationService.getRecentDestinations({
                customerCode: customer.partyCode.replace(/^\s+|\s+$/gm, '')
            }).$promise.then(function (result) {
                $scope.recentDestinations = result;
            });
        });

        $scope.earliestTimeChanged = function(value) {
           if (value === null) {
               $scope.$parent.order.delivery.earliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
           }
        };
        $scope.latestTimeChanged = function (value) {
            if (value === null) {
                $scope.$parent.order.delivery.latestTime = new Date((new Date()).setHours(0, 0, 0, 0));
            }
        };

        function setRecentDestinations() {
            if ($scope.order && $scope.order.customer) {
                LocationService.getRecentDestinations({
                    customerCode: $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, '')
                }).$promise.then(function (result) {
                    $scope.recentDestinations = result;
                });
            }
        }

        $scope.$parent.isFlatbed = function() {
          return $scope.$parent.requstType === 'Flatbed';
        }

        setRecentDestinations();
    }
    angular.module('NavisphereOnline').controller('DeliveryController', deliveryController);
})();

(function () {
    'use strict';
    customerController.$inject = ['$q', '$rootScope', '$scope', 'AddressService', 'analyticsService', 'BolCommentService', 'ModalService',
      'CustomerPartyService'];
    function customerController($q, $rootScope, $scope, AddressService, analyticsService, BolCommentService, ModalService) {

        $scope.dropDownCustomer = {
            selected: undefined
        };
        $scope.selectedRecentCustomer = undefined;
        var modalOptions = {
            closeButtonText: 'NO_KEEP_ACCOUNT',
            actionButtonText: 'YES_I_AM_SURE',
            headerText: 'ARE_YOU_SURE_YOU_WANT_TO_CHANGE_YOUR_ACCOUNT',
            bodyText: 'ALL_INFORMATION_ENTERED_FOR_THIS_ACCOUNT_WILL_BE_R'
        };
        var askingToKeepCustomer = false;

        function customerChanged() {
            var deferred = $q.defer();

            if ($scope.order.customer && ($scope.order.serviceOffering !== null || dirtyRefNums()) &&
              !askingToKeepCustomer) {
                askingToKeepCustomer = true;
                ModalService.showModal({}, modalOptions).then(function(result) {
                    if (result === 'ok') {
                        deferred.resolve(true);
                        askingToKeepCustomer = false;
                    }
                    if (result === 'cancel') {
                        deferred.resolve(false);
                        askingToKeepCustomer = false;
                    }
                }, function(result) {
                    if (result === 'cancel') {
                        deferred.resolve(false);
                        askingToKeepCustomer = false;
                    }
                });
            } else {
                deferred.resolve(true);
            }
            return deferred.promise;
        }

        $scope.onSelectedDropDownCustomerChange = function (cust) {
            if (cust !== $scope.order.customer) {
                customerChanged().then(function (changed) {
                    if (changed) {
                        angular.element('input[name=customerRecentList]').attr('checked', false);
                        $scope.order.customer = cust;
                        BolCommentService.get($scope.order.customer);

                        $rootScope.$broadcast('customerChanged', cust);
                    } else {
                        $scope.dropDownCustomer.selected = $scope.order.customer;
                    }
                });
            }
        };

        function selectNewCustomer(cust) {
            $scope.dropDownCustomer.selected = cust;
            $scope.order.customer = cust;
            BolCommentService.get($scope.order.customer);
            $rootScope.$broadcast('customerChanged', cust);
        }

        $scope.onSelectedRecentListCustomerChange = function (cust) {

            if (askingToKeepCustomer) return;

            if ($scope.order.customer && ($scope.order.serviceOffering !== null || dirtyRefNums())) {
                askingToKeepCustomer = true;
                ModalService.showModal({}, modalOptions).then(function (result) {
                    if (result === 'ok') {
                        selectNewCustomer(cust);
                        askingToKeepCustomer = false;
                    }
                    if (result === 'cancel') {
                        $scope.selectedRecentCustomer = $scope.order.customer;
                        askingToKeepCustomer = false;
                    }
                }, function (result) {
                    if (result === 'cancel') {
                        $scope.selectedRecentCustomer = $scope.order.customer;
                        askingToKeepCustomer = false;
                    }
                });
            } else {
              selectNewCustomer(cust);
            }
            analyticsService.track('selectedRecentAccount');
        };
        function dirtyRefNums(){
          for(var i = 0; i < $scope.order.newRefNums.length; i++){
            if ($scope.order.newRefNums[i].value){
              return true;
            }
          }
          return false;
        }
        function getCustomers() {
            $scope.customers = $scope.$parent.createOrderCustomers.customers;

            angular.forEach($scope.customers, function (cust) {
                cust['addressLine1'] = AddressService.GetAddressLine1(cust.address);
                cust['addressLine2'] = AddressService.GetAddressLine2(cust.address);
                cust['addressLine3'] = AddressService.GetAddressLine3(cust.address);
                cust['addressLine4'] = AddressService.GetAddressLine4(cust.address);
                cust['displayName'] = $scope.$parent.getDisplayName(cust);
            });
        }

        function getRecentCustomers() {
            $scope.recentCustomers = $scope.$parent.createOrderCustomers.recentCustomers;

            angular.forEach($scope.recentCustomers, function (cust) {
                cust['displayName'] = $scope.$parent.getDisplayName(cust);
            });
        }

        function isSingleCCode() {

            return $scope.createOrderCustomers.customers.length === 1;
        }

        function assignSingleCCode() {
            if (isSingleCCode()) {
                selectNewCustomer($scope.createOrderCustomers.customers[0]);
            }
        }

        assignSingleCCode();
        getCustomers();
        getRecentCustomers();
    }

    angular.module('NavisphereOnline').controller('CustomerController', customerController);
}());

(function () {
  'use strict';
  carriersController.$inject = ['$scope'];
  function carriersController($scope) {

    $scope.preferredCarriers = [];

    $scope.$on('getPreferredCarriersCalled', function(event, data){
      $scope.preferredCarriers = data.preferredCarriers;
    });

    $scope.onSelectedDropDownCarrierChange = function(){
      $scope.order.carrierPreProNumber = null;
    };
  }
  angular.module('NavisphereOnline').controller('CarriersController', carriersController);
}());

(function() {
  'use strict';

  notificationPreferencesController.$inject = ['$scope', '$rootScope', '$window', 'SubscriptionService', 'SubscriptionsEventsService', '$state', 'analyticsService', '$uibModalStack', 'ModalService', 'localStorageService', '$q', 'activeSubscriptions'];
  function notificationPreferencesController($scope, $rootScope, $window, SubscriptionService, SubscriptionsEventsService, $state, analyticsService, $uibModalStack, ModalService, localStorageService, $q, activeSubscriptions) {

    // temp redirect until we are sure local storge cache is purged - TENTADA 9/21/2020
    if ($rootScope.featureFlags.notifcationSettingsFeatureFlag) {
      $window.location.href = appConfig.notificationSettingsLink;
    }

    // Grabbed this code from the notification data model
    $scope.events = [
      { name: 'ORDER_CREATED', number: 101, inApp: false, email: false, category: 'Tracking', description: 'A new order was created. Track its progress as it makes its way to your destination.' },
      { name: 'SHIPMENT_BOOKED', number: 16, inApp: false, email: false, category: 'Tracking', description: 'A new shipment has been booked with C.H. Robinson. Your BOL is available and attached.' },
      { name: 'CARRIER_ARRIVED', number: 46, inApp: false, email: false, category: 'Tracking', description: 'The carrier has arrived at the pick up location.' },
      { name: 'CARRIER_DEPARTED', number: 48, inApp: false, email: false, category: 'Tracking', description: 'The carrier has left the pick up location with your order.Your order is on its way!' },
      { name: 'ORDER_DELIVERED', number: 111, inApp: false, email: false, category: 'Tracking', description: 'Hooray! Your order has been delivered.' },
      { name: 'ORDER_CANCELLED', number: 110, inApp: false, email: false, category: 'Tracking', description: 'Your order was cancelled.' },
      { name: 'CARRIER_BOUNCED', number: 26, inApp: false, email: false, category: 'Exception Management', description: 'The carrier is no longer able to complete the order. Don’t worry - we have got you covered.' },
      { name: 'POTENTIALLY_LATE', number: 69, inApp: false, email: false, category: 'Exception Management', description: 'Your order will be arriving late. Track its progress as it makes its way to your destination.' },
      { name: 'LATE_ARRIVAL', number: 47, inApp: false, email: false, category: 'Exception Management', description: 'Your order will be arriving late. Track its progress as it makes its way to your destination.' },
      { name: 'COMMODITY_CHANGED', number: 102, inApp: false, email: false, category: 'Order Changed' },
      { name: 'LOCATION_CHANGED', number: 109, inApp: false, email: false, category: 'Order Changed' },
      { name: 'READY_BY_DATE_OR_TIME_CHANGED', number: 105, inApp: false, email: false, category: 'Order Changed' },
      { name: 'PICK_UP_BY_DATE_OR_TIME_CHANGED', number: 106, inApp: false, email: false, category: 'Order Changed' },
      { name: 'DELIVERY_DATE_OR_TIME_CHANGED', number: 107, inApp: false, email: false, category: 'Order Changed' },
      { name: 'DELIVER_BY_DATE_OR_TIME_CHANGED', number: 108, inApp: false, email: false, category: 'Order Changed' }
    ];

    $scope.initialEvents = [];

    var preferences = localStorageService.get('preferences');
    setActiveEventTypes(activeSubscriptions, preferences.eventNotificationPreferences);

    if (_.isEmpty(preferences.eventNotificationPreferences)) {
      preferences.eventNotificationPreferences = getEventNotificationsForSave();
      localStorageService.set('preferences', preferences);
    }

    function setActiveEventTypes(eventTypeNumbers, eventNotificationPreferences) {
      if(!_.isEmpty(eventNotificationPreferences)) {
        _.forEach($scope.events, function(event, i) {
          _.forEach(eventNotificationPreferences, function(notificationPreference) {
            if (notificationPreference.eventTypeNumber === event.number && (notificationPreference.inApp || notificationPreference.email)) {
              $scope.initialEvents.push(event.number);
              $scope.events[i].inApp = notificationPreference.inApp;
              $scope.events[i].email = notificationPreference.email;
            }
          });
        });
      }
      else {
        _.forEach($scope.events, function(event, i) {
          _.forEach(eventTypeNumbers, function(eventTypeNumber) {
            if (eventTypeNumber.eventTypeNumber === event.number) {
              $scope.initialEvents.push(event.number);
              $scope.events[i].inApp = true;
            }
          });
        });
      }
    }

    function getEventNotificationsForSave() {
      var eventNotificationPreferences = [];
      _.forEach($scope.events, function(event) {
        eventNotificationPreferences.push(
          {
            eventTypeNumber: event.number,
            inApp: event.inApp,
            email: event.email
          }
        );
      });
      return eventNotificationPreferences;
    }

    $scope.save = function(e) {
      var preferences = localStorageService.get('preferences');
      preferences.eventNotificationPreferences = _.map(preferences.eventNotificationPreferences, function(event) {
        if (event.eventTypeNumber === e.number) {
          event.email = e.email;
          event.inApp = e.inApp;
        }
        return event;
      });

      localStorageService.set('preferences', preferences);

      SubscriptionService.saveNotificationPreferences(preferences.eventNotificationPreferences);
      SubscriptionsEventsService.save({ eventTypeNumber: e.number, inApp: e.inApp, shouldEmail: e.email });
    };

    $scope.goToUserPreferences = function() {
      analyticsService.track('userSettings');
      $state.go('app.userPreferences');
    };

    $scope.goToMergeAccounts = function() {
      analyticsService.track('mergeAccounts');
      $window.location.href = appConfig.mergeAccountsUrl;
    };
  }

  angular.module('NavisphereOnline').controller('notificationPreferencesController', notificationPreferencesController);

})();

/*global $ */
(function () {
  'use strict';
  myOrdersController.$inject = ['$scope', '$state', 'OrderService', '$filter', 'orderResults',
    'userPreference', 'ServiceOffering', 'status', 'CarrierRuleService', 'RefDataMappingService', 'StatusMappingService', '$stateParams', '$window'];

  function myOrdersController($scope, $state, OrderService, $filter, orderResults, userPreference, ServiceOffering,
    status, CarrierRuleService, RefDataMappingService, StatusMappingService, $stateParams, $window) {

    $scope.orderResults = orderResults;
    $scope.facet = orderResults.orderFacet;
    $scope.currentPage = 1;
    $scope.offset = 0;
    $scope.statuses = [];
    $scope.methods = [];
    $scope.ranges = [];
    $scope.sortBy = 'earliestPickUpDateDescending';

    //Making Status/Shipping Method/TimeFrame Headers appear/disappear
    $scope.showTimeFrame = true;
    $scope.showShipping = true;
    $scope.showStatus = true;

    $scope.showTimeFrameHead = function () {
      $scope.showTimeFrame = false;
      if ($scope.facet) {
        angular.forEach($scope.facet.timeFrames, function (timeFrame) {
          $scope.showTimeFrame = timeFrame.count > 0 || $scope.showTimeFrame;
        });
      }
    };
    $scope.showShippingHead = function () {
      $scope.showShipping = false;
      if ($scope.facet) {
        angular.forEach($scope.facet.shippingMethods, function (shippingMethod) {
          $scope.showShipping = shippingMethod.count > 0 || $scope.showShipping;
        });
      }
    };
    $scope.showStatusHead = function () {
      $scope.showStatus = false;
      if ($scope.facet) {
        angular.forEach($scope.facet.statuses, function (status) {
          $scope.showStatus = status.count > 0 || $scope.showStatus;
        });
      }
    };

    if ($stateParams.sortBy)
      $scope.sortBy = $stateParams.sortBy;

    if ($stateParams.offset && $stateParams.limit) {
      $scope.currentPage = Math.ceil($stateParams.offset / $stateParams.limit) + 1;
    }

    $scope.limit = $stateParams.limit || '10';
    if ($stateParams.statuses) {
      $scope.statuses = $stateParams.statuses.split(",");
    }
    if ($stateParams.methods) {
      $scope.methods = $stateParams.methods.split(",");
    }
    if ($stateParams.ranges) {
      $scope.ranges = $stateParams.ranges.split(",");
    }
    if ($stateParams.search) {
      $scope.search = $stateParams.search;
    }

    $scope.isRefNumberSearched = angular.isDefined($scope.search) && $scope.search !== '';

    $scope.removeStatus = function (key) {
      var index = $scope.statuses.indexOf(key);
      $scope.statuses.splice(index, 1);
      filtersChanged();
      $scope.pageChanged();
    };
    $scope.removeShippingMethod = function (key) {
      var index = $scope.methods.indexOf(key);
      $scope.methods.splice(index, 1);
      filtersChanged();
      $scope.pageChanged();
    };
    $scope.removeRange = function (key) {
      var index = $scope.ranges.indexOf(key);
      $scope.ranges.splice(index, 1);
      filtersChanged();
      $scope.pageChanged();
    };
    $scope.isStatusActive = function (item) {
      return $.inArray(item, $scope.statuses) !== -1;
    };
    $scope.isShippingMethodActive = function (item) {
      return $.inArray(item, $scope.methods) !== -1;
    };
    $scope.isTimeFrameActive = function (item) {
      return $.inArray(item, $scope.ranges) !== -1;
    };
    $scope.shippingItemClicked = function (item) {

      if ($.inArray(item, $scope.methods) === -1) {
        $scope.methods.push(item);
      } else {
        var index = $scope.methods.indexOf(item);
        $scope.methods.splice(index, 1);
      }
      filtersChanged();
      $scope.pageChanged();
    };
    $scope.timeframeItemClicked = function (item) {

      if ($.inArray(item, $scope.ranges) === -1) {
        $scope.ranges.push(item);
      } else {
        var index = $scope.ranges.indexOf(item);
        $scope.ranges.splice(index, 1);
      }
      filtersChanged();
      $scope.pageChanged();
    };
    $scope.statusItemClicked = function (item) {

      if ($.inArray(item, $scope.statuses) === -1) {
        $scope.statuses.push(item);
      } else {
        var index = $scope.statuses.indexOf(item);
        $scope.statuses.splice(index, 1);
      }
      filtersChanged();
      $scope.pageChanged();
    };
    function filtersChanged() {

      $scope.showTimeFrameHead();
      $scope.showShippingHead();
      $scope.showStatusHead();

      var filters = $scope.statuses.concat($scope.methods, $scope.ranges);
    }

    $scope.limitChanged = function () {
      $scope.currentPage = Math.floor($scope.offset / $scope.limit) + 1;
      $scope.pageChanged();
    };

    $scope.sortyByChanged = function () {

      $scope.pageChanged();
    };

    $scope.pageChanged = function () {
      $scope.offset = ($scope.currentPage - 1) * $scope.limit;
      var status = $scope.statuses.join(",");
      var range = $scope.ranges.join(",");
      var method = $scope.methods.join(",");
      $scope.updatePage();
      $scope.isRefNumberSearched = angular.isDefined($scope.search) && $scope.search !== '';
      $state.go('.', {
        offset: $scope.offset,
        limit: $scope.limit,
        statuses: status,
        ranges: range,
        methods: method,
        search: $scope.search,
        sortBy: $scope.sortBy
      }, { notify: false });
    };

    $scope.removeRefNumberSearch = function () {
      $scope.search = '';
      $scope.pageChanged();
    };

    $scope.onSearchKeyPress = function (event) {
      if (event.keyCode === 13) {
        $scope.pageChanged();
        event.preventDefault();
        return false;
      }
    };
    $scope.updatePage = function () {
      $scope.offset = ($scope.currentPage - 1) * $scope.limit;
      var status = $scope.statuses.join(",");
      var range = $scope.ranges.join(",");
      var method = $scope.methods.join(",");
      OrderService.search({
        offset: $scope.offset,
        limit: $scope.limit,
        statuses: status,
        ranges: range,
        methods: method,
        search: $scope.search,
        sortBy: $scope.sortBy
      }, function (data) {
        $scope.orderResults = data;
        $scope.facet = data.orderFacet;
        //Show/Hide headers of filters
        $scope.showTimeFrameHead();
        $scope.showShippingHead();
        $scope.showStatusHead();
      });
    };

    $scope.displayStatus = function (order) {
      var resourceKey = StatusMappingService.getStatusResourceKey(order.statusRDN);
      return $filter('translate')(resourceKey);
    };

    $scope.displayCarrier = function (order) {
      var service = order.services[0];
      if (CarrierRuleService.showCarrier(service.serviceOfferingNumber, order.isMultiLeg) && order.loads && order.loads.length > 0) {
        var firstLoad = order.loads[0];
        if (firstLoad.carriers && firstLoad.carriers.length > 0) {
          return firstLoad.carriers[0].name;
        }
      }
      return null;
    };

    $scope.displayProNumber = function (order) {

      var proNumberRDN = RefDataMappingService.getCategoryId('CARRIER_PRO_NUMBER');

      if (order.services && order.services[0] && order.loads && order.loads[0] && order.isMultiLeg === false) {
        for (var k = 0; k < order.loads[0].referenceNumbers.length; k++) {
          if (order.loads[0].referenceNumbers[k].referenceDataNumber === proNumberRDN && order.loads[0].referenceNumbers[k].entityId === 7) {
            return 'Pro #: ' + order.loads[0].referenceNumbers[k].value;
          }
        }
      }

      return null;
    };

    $scope.getServiceOfferingImageUrl = function (serviceOfferingNumber) {
      return ServiceOffering.get(serviceOfferingNumber);
    };

    $scope.getDisplayPlannedDateTime = function (locationInfo) {

      if (!locationInfo) {
        return null;
      }
      var serverDateTime = null;
      var dateParts = null;
      var timeParts = null;

      if (locationInfo.plannedEarliestDate) {
        var plannedEarliestDateInfo = locationInfo.plannedEarliestDate.split("T");
        dateParts = plannedEarliestDateInfo[0].split("-");

        if (locationInfo.plannedEarliestTime) {
          var plannedEarliestTimeInfo = locationInfo.plannedEarliestTime.split("T");
          timeParts = plannedEarliestTimeInfo[1].substring(0, 8).split(":");
        }
      }

      if ((timeParts && timeParts.length > 0) && (dateParts && dateParts.length > 0)) {
        serverDateTime = new Date(dateParts[0], parseInt(dateParts[1]) - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
      } else if (dateParts && dateParts.length > 0) {
        serverDateTime = new Date(dateParts[0], parseInt(dateParts[1]) - 1, dateParts[2]);
      }
      if (serverDateTime) {
        var time = serverDateTime.getHours();
        return (time > 0)
          ? $filter('date')(serverDateTime, 'shortDate') + ' at ' + $filter('time')({
              userPreferences: userPreference,
              date: serverDateTime
            })
          : $filter('date')(serverDateTime, 'shortDate');
      }
      return null;
    };

    $scope.getDisplayActualDateTime = function (locationInfo) {

      if (!locationInfo) {
        return null;
      }
      var serverDateTime = null;
      var dateParts = null;
      var timeParts = null;

      if (locationInfo.actualArrivalDate) {
        var actualArrivalDateInfo = locationInfo.actualArrivalDate.split("T");
        dateParts = actualArrivalDateInfo[0].split("-");

        if (locationInfo.actualArrivalTime) {
          var actualArrivalTimeInfo = locationInfo.actualArrivalTime.split("T");
          timeParts = actualArrivalTimeInfo[1].substring(0, 8).split(":");
        }
      }

      if ((timeParts && timeParts.length > 0) && (dateParts && dateParts.length > 0)) {
        serverDateTime = new Date(dateParts[0], parseInt(dateParts[1]) - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
      } else if (dateParts && dateParts.length > 0) {
        serverDateTime = new Date(dateParts[0], parseInt(dateParts[1]) - 1, dateParts[2]);
      }
      if (serverDateTime) {
        var time = serverDateTime.getHours();
        return (time > 0) ? $filter('date')(serverDateTime, 'shortDate') + ' at ' + $filter('time')({
          userPreferences: userPreference,
          date: serverDateTime
        }) : $filter('date')(serverDateTime, 'shortDate');

      }
      return null;
    };
    $scope.formatCityState = function (location) {
      if (angular.isUndefined(location) || location === null) {
        return null;
      }
      var text = [location.city, location.state].filter(function (val) {
        return val;
      }).join(', ');
      return text;
    };
    $scope.orderDetails = function (orderNum, event) {
      if (event.altKey && event.ctrlKey || event.altKey && event.shiftKey) {
        redirectToNewMicrosite(orderNum)
      } else {
        $state.go('app.orderDetails', { orderNumber: orderNum });
      }
    };

    function redirectToNewMicrosite(orderNum) {
      var orderDetailUrl = $window.location.origin + '/orders/#/detail/' + orderNum;
      $window.location.replace(orderDetailUrl);
    };

    //Need to call this on page load in order to make sure our filters are shown/hidden appropriately.
    filtersChanged();
  }

  angular.module('NavisphereOnline').controller('myOrdersController', myOrdersController);
})();

(function () {
  'use strict';
  function loginController($scope, $rootScope, authService) {

    var loggedIn = authService.isLoggedIn();

    $scope.render = loggedIn;

    if (loggedIn) {
      authService.getUserDataAndRedirect();
    } else {
      authService.login();
    }

  }

  loginController.$inject = ['$scope', '$rootScope', 'authService'];
  angular.module('NavisphereOnline').controller('LoginController', loginController);
})();

(function() {
    'use strict';
    var app = angular.module('NavisphereOnline');
    app.directive('headerScroll', ['$window', '$document', function ($window, $document) {
        return {
            link: function (scope, element) {
                angular.element($window).bind("scroll", function() {
                    var deltaY = this.pageYOffset || $document[0].documentElement.scrollTop;
                    element.toggleClass('header-shrink', deltaY > 50);
                });
            }
        };
    }]);
})();

(function() {
  'use strict';
  var app = angular.module('NavisphereOnline');
  app.directive('headerNav', ['$state', '$window', 'analyticsService', function ($state, $window, analyticsService) {
    return {
      templateUrl: 'app/header/views/header_nav_template.html',
      scope: {
        selectedState: '=',
        navOptions: '='
      },
      link: function(scope){
        scope.navSelected = function (subNav) {
          analyticsService.trackWithVar('navItemSelected','navItemSelectedValue', subNav.state);
          if(subNav.redirectToMicrosite) {
            $window.location.href = subNav.redirectUrl;
          } else if(subNav.redirectUrl) {
            $state.go(subNav.state, {redirectUrl: subNav.redirectUrl})
          } else {
            $state.go(subNav.state);
          }
        };
        scope.topNavContainsActiveSubNav = function(topNav){
          if(angular.isDefined(topNav) && angular.isDefined(topNav.navOptions)) {
            for (var i = 0; i < topNav.navOptions.length; i++) {
              if (scope.selectedState === topNav.navOptions[i].state){
                return true;
              }
            }
          }
          return false;
        };
      }
    };
  }]);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  InternalHeaderController.$inject = ['$scope', '$rootScope', '$state', 'analyticsService', 'authService', 'UserPermissionService', 'ModalService',
    'OrderEntryPromptService', 'OrderLockPromptService', 'OrderLockHelper', 'OrderService', 'APPLICATIONS',
    'WalkthroughHelper', 'searchBaseUrl', 'reportsUIBaseUrl', 'WalkthroughService', 'InternalHeaderService', 'localStorageService', '$timeout', 'ReportHubConfigService', 'user', '$location',
    'externalRoutesService', 'WindowLocationHref', '$transitions', '$window', 'AcknowledgementHelper', 'MERGE_ACCOUNTS'];
  function InternalHeaderController($scope, $rootScope, $state, analyticsService, authService, UserPermissionService, ModalService,
    OrderEntryPromptService, OrderLockPromptService, OrderLockHelper, OrderService, APPLICATIONS,
    WalkthroughHelper, searchBaseUrl, reportsUIBaseUrl, WalkthroughService, InternalHeaderService, localStorageService, $timeout, ReportHubConfigService, user, $location,
    externalRoutesService, WindowLocationHref, $transitions, $window, AcknowledgementHelper, MERGE_ACCOUNTS) {
    var ieBannerKey = 'showIEBannerWarning';

    $scope.walkthroughTimeOffset = 2.5;
    $scope.introExitTimeStamp = 0;
    $scope.introStartTimeStamp = 0;
    $scope.introStepsViewed = 0;
    $scope.introRunning = false;
    $scope.userApplications = localStorageService.get("users.applications");
    $scope.closedBannerIds = localStorageService.get('closedBannerIds') ? localStorageService.get('closedBannerIds') : [];
    $scope.userAppLinks = [];
    getUserAppLinks();
    $scope.bannerList = [];
    getBanners();
    $scope.user = user;
    $scope.IntroOptions = {
      steps: [],
      showStepNumbers: false,
      exitOnOverlayClick: false,
      exitOnEsc: true,
      nextLabel: '<strong>Next</strong>',
      prevLabel: '<span><strong>Previous</strong></span>',
      skipLabel: 'Close',
      scrollToElement: true,
      doneLabel: 'Finish',
      disableInteraction: true
    };
    $scope.notifcationSettingsFeatureFlag = $rootScope.featureFlags.notifcationSettingsFeatureFlag;
    $scope.hideMaintenanceBanner = function (bannerMessageId, selectedIndex) {
      $scope.closedBannerIds.push(bannerMessageId);
      localStorageService.set('closedBannerIds', $scope.closedBannerIds);
      $scope.bannerList.splice(selectedIndex, 1);
    };

    if(!sessionStorage.getItem(ieBannerKey)) {
      sessionStorage.setItem(ieBannerKey, 'true');
    }

    function getBanners() {
      var application = $scope.userApplications && _.find($scope.userApplications, function(application) {
        return application.applicationId === APPLICATIONS.Online2;
      });

      InternalHeaderService.getBannerMessageByAppId({ applicationId: application["applicationId"] }).$promise.then(function (data) {
        _.forEach(data.banners, function (banner) {
          if ($scope.closedBannerIds && !($scope.closedBannerIds.indexOf(banner.id) != -1)) {
            var now = new Date();
            var bannerStartDisplayTime = new Date(Date.parse(banner.fromDate + ' ' + banner.fromTime));
            var bannerEndDisplayTime = new Date(Date.parse(banner.toDate + ' ' + banner.toTime));
            if (now >= bannerStartDisplayTime && now <= bannerEndDisplayTime) {
              $scope.bannerList.push(banner);
            }
          }
        });
      });
    }

    function getUserAppLinks() {
      $scope.userApplications && _.forEach($scope.userApplications, function (application) {
        if (application.isEnabled && application.name && application.url) {
          var url = application.applicationId == APPLICATIONS.Online1 ? application.url + '/login.aspx' : application.url;
          var appLink = {
            url: url.replace(/\/$/, ''),
            name: application.name,
            isCurrentApp: application.applicationId === APPLICATIONS.Online2
          };
          $scope.userAppLinks.push(appLink);
        }
      });
    }

    $scope.getInitials = function () {
      return user.firstName[0] + user.lastName[0];
    }

    $scope.stepViewed = function () {
      $scope.introStepsViewed++;
    };

    $scope.introExited = function () {
      if ($scope.introRunning) {
        $scope.introExitTimeStamp = Date.now();
        WalkthroughHelper.recacheWalkthroughs();
        $scope.introRunning = false;

        var walkthrough = WalkthroughHelper.getCachedWalkthrough();
        WalkthroughService.insertUserWalkthrough({
          walkthroughID: walkthrough.WalkthroughID
        });
      }
    };

    $scope.setIntroRunningFlag = function () {
      $scope.introRunning = true;
    };

    $scope.navOptions = [
      {
        textKey: "DASHBOARD",
        state: 'app.dashboard'
      }
    ];

    if (UserPermissionService.hasPermission('Get a Quote')) {
      var quotingNavOptions = [];

      quotingNavOptions.push({
        textKey: "GET_A_QUOTE",
        state: 'app.getAQuote'
      });
      quotingNavOptions.push({
        textKey: "QUOTE_HISTORY",
        state: 'app.quoteHistory'
      });
      $scope.navOptions.push({
        textKey: "QUOTING",
        isSubMenu: true,
        navOptions: quotingNavOptions
      });
    }

    var orderNavOptions = [];
    if (UserPermissionService.hasPermission('Create Order')) {
      orderNavOptions.push({
        textKey: "CREATE_ORDER",
        state: 'create',
        redirectUrl: '/orders/#/create',
        redirectToMicrosite: true
      });
    }

    if (UserPermissionService.hasPermission('Draw PO')) {
      orderNavOptions.push({
        textKey: "DRAW_PO",
        state: 'app.drawPO'
      });
    }

    if (UserPermissionService.hasPermission('Create Order') ||
      UserPermissionService.hasPermission('Account Templates')) {
      orderNavOptions.push({
        textKey: "MANAGE_TEMPLATES",
        state: 'templates',
        redirectUrl: '/templates/#/',
        redirectToMicrosite: true
      });
    }

    if (UserPermissionService.hasPermission('Load Create (Interop)')) {
      orderNavOptions.push({
        textKey: "CREATE_LOAD",
        state: 'outgoingBridge',
        redirectUrl: appConfig.legacyOnlineBaseUrl + '/DSE/SelectShipmentEntry.aspx'
      });
    }

    if (UserPermissionService.hasPermission('Purchase Order Draw')) {
      orderNavOptions.push({
        textKey: "PURCHASE_ORDER_DRAW",
        state: 'purchaseorder',
        redirectUrl: '/purchaseorder/#/',
        redirectToMicrosite: true
      });
    }

    orderNavOptions.push({
      textKey: "STANDARD_OPERATING_PROCEDURES",
      state: 'sop',
      redirectUrl: '/documents/#/sop',
      redirectToMicrosite: true
    });

    if (orderNavOptions.length > 0) {
      $scope.navOptions.push({
        textKey: 'ORDERS',
        isSubMenu: true,
        navOptions: orderNavOptions
      });
    }

    var trackingNavOptions = [];
    trackingNavOptions.push({
      textKey: "SEARCH",
      state: 'search',
      redirectUrl: searchBaseUrl,
      redirectToMicrosite: true
    });

    trackingNavOptions.push({
      textKey: "MAPS",
      state: 'app.shipmentMap'
    });

    $scope.navOptions.push({
      textKey: "TRCK",
      isSubMenu: true,
      navOptions: trackingNavOptions
    });

    var hasApPermission = UserPermissionService.hasPermission('Accounts Payable');
    var hasSecurePayPermission = UserPermissionService.hasPermission('Secure Pay')

    if (hasApPermission || hasSecurePayPermission) {
      var apNavOptions = [];
      if (hasApPermission) {
        apNavOptions.push({
          textKey: "ACCOUNT_SUMMARY",
          state: 'app.accountSummary'
        });
        apNavOptions.push({
          textKey: "SEARCH_INVOICES",
          state: 'app.searchInvoices'
        });
      }

      if (hasSecurePayPermission) {
        apNavOptions.push({
          textKey: "SECURE_PAY",
          state: 'payments',
          redirectUrl: '/payments/?cid=95ab3/#',
          redirectToMicrosite: true
        });
      }

      $scope.navOptions.push({
        textKey: 'ACCOUNTS_PAYABLE',
        isSubMenu: true,
        navOptions: apNavOptions
      });
    }

    if (UserPermissionService.hasPermission('Reverse Logistics')) {
      $scope.navOptions.push({
        textKey: "REVERSE_LOGISTICS",
        state: 'app.reverseLogisticsSearch'
      });
    }

    var rptSet = ReportHubConfigService.getReportList();

    if (UserPermissionService.inPermissionSet(rptSet)) {

      $scope.navOptions.push({
        textKey: 'REPORTS',
        isSubMenu: false,
        redirectUrl: reportsUIBaseUrl,
        redirectToMicrosite: true
      })
    }

    $scope.expanded = true;
    $scope.selectedState = '';

    var modalOptions = {
      closeButtonText: 'CANCEL',
      actionButtonText: 'OK',
      headerText: 'ARE_YOU_SURE_YOU_WANT_TO_EXIT_THIS_ORDER',
      bodyText: 'ALL_INFORMATION_ENTERED_FOR_THIS_ORDER_WILL_BE_LOS'
    };

    $scope.showWalkthrough = function () {
      var preferences = authService.getPreferences();
      var walkthrough = WalkthroughHelper.getCachedWalkthrough();
      if (walkthrough && !walkthrough.Dismissed && !preferences.dismissAllWalkthroughs) {
        WalkthroughService.getWalkthrough({
          walkthroughID: walkthrough.WalkthroughID
        }).$promise.then(function (response) {
          var parsedSteps = JSON.parse(response.Steps);
          $scope.IntroOptions.steps = parsedSteps.steps;
          $scope.introStartTimeStamp = Date.now();
          $scope.introTimeOut = $timeout(function () {
            $scope.callWalkthrough();
          }, 2500);
        });
      }
    };

    $scope.logOut = function () {
      analyticsService.track('loggedOut');
      var entryInProgress = OrderEntryPromptService.getEntryInProgress();
      if (entryInProgress) {
        ModalService.showModal({}, modalOptions).then(function (result) {
          if (result === 'ok') {
            authService.logout();
          }
        });
      } else if (OrderLockPromptService.lock) {
        ModalService.showModal({}, modalOptions).then(function (result) {
          if (result === 'ok') {
            OrderLockHelper.releaseOrderLock();
            authService.logout();
          }
        });
      } else {
        authService.logout();
      }

    };

    $scope.onTrackKeyPress = function (event) {
      if (event.keyCode === 13) {
        $scope.headerTrack();
        event.preventDefault();
        return false;
      }
    };

    $scope.headerTrack = function () {
      var searchParam = {
        search: $scope.headerSearch
      };

      analyticsService.trackWithVar('headerSearch', 'headerSearchValue', $scope.headerSearch);
      $scope.headerSearch = '';

      externalRoutesService.search(searchParam);
    };

    $scope.goToUserPreferences = function () {
      analyticsService.track('userSettings');
      $state.go('app.userPreferences');
    };

    $scope.goToNotificationPreferences = function () {
      analyticsService.track('notificationSettings');
      if ($scope.notifcationSettingsFeatureFlag) {
        $window.location.href = appConfig.notificationSettingsLink;
      } else {
        $state.go('app.notificationPreferences');
      }
    };

    $scope.goToMergeAccounts = function () {
      analyticsService.track('mergeAccounts');
        $window.location.href = appConfig.mergeAccountsUrl;
    };

    $scope.isBrowserIE = function() {
      return(!!window.MSInputMethodContext && 'documentMode' in document && sessionStorage.getItem(ieBannerKey) == 'true');
    }

    $scope.hideIEBannerWarning = function() {
      sessionStorage.setItem(ieBannerKey,'false');
    }

    var setSelectedState = function (state) {
      $scope.selectedState = state;
    };
    setSelectedState($state.current.name);

    $scope.$on('$locationChangeStart', function () {
      $timeout.cancel($scope.introTimeOut);
    });

    $transitions.onSuccess({}, function(transition) {
      setSelectedState(transition.to().name);
    });

    $transitions.onSuccess('app.dashboard', function() {
      $scope.showWalkthrough();
    })

    $scope.$on('$viewContentLoaded', function () {
      $scope.showWalkthrough();
    });
  }
  app.controller('InternalHeaderController', InternalHeaderController);
})();

(function() {
  function ModeTranslatorService() {
    var transportModeMap = {
      "TL": "TRUCKLOAD",
      "DAIR": "DOMESTIC_AIR",
      "IAIR": "INTERNATIONAL_AIR",
      "IMDL": "INTERMODAL",
      "Consol": "CONSOLIDATED"
    };

    var orderTransportModeIdMap = {
      1481: "TRUCKLOAD",
      1480: "BULK",
      1336: "INTERMODAL",
      1293: "AIR",
      1084: "AIR",
      1482: "FLATBED",
      1483: "TRUCKLOAD",
      1484: "LTL",
      1486: "LTL",
      1477: "CONSOLIDATED"
    };

    this.transportModeMap = transportModeMap;
    this.orderTransportModeIdMap = orderTransportModeIdMap;

    this.getAbbreviatedTransportMode = function(displayName) {
      var returnVal = displayName;

      _.forEach(transportModeMap, function(value, key){
        if(displayName === value){
          returnVal = key;
        }
      });

      return returnVal;
    };
  };

  angular.module("NavisphereOnline").service("ModeTranslatorService", ModeTranslatorService);
})();

(function() {
  "use strict";

  function LocationSelectionHelperService() {
    this.restructureLocation = function(item) {
      return {
        address: {
          city: item.name,
          country: item.countryCode,
          stateProvince: item.adminDistrictCode,
          postalCode: item.postalCode,
          adminDistrict: item.adminDistrict,
          countryName: item.countryName,
          id: item.id,
          latitude: item.lat,
          longitude: item.lon,
          alternateNames: item.alternateNames,
          subDistricts: item.subDistricts
        },
        adminDistrictCode: item.adminDistrictCode,
        countryCode: item.countryCode,
        name: item.name,
        postalCode: item.postalCode,
        specialRequirementCodes: item.specialRequirementCodes
      }
    };
  }

  angular.module("NavisphereOnline").service("LocationSelectionHelperService", LocationSelectionHelperService);
})();

(function () {
	"use strict";

	GAQService.$inject = ["$filter", "$rootScope", "$state", "analyticsService", "$uibModal", "CustomerPartyService", "GAQAccessorialService", "QuoteService", "BolCommentService"];

	function GAQService($filter, $rootScope, $state, analyticsService, $uibModal, CustomerPartyService, GAQAccessorialService, QuoteService, BolCommentService) {
		var noRatesFoundMap = {
			getAQuote: GAQNoRatesCallback,
			quoteHistory: quoteHistoryNoRatesCallback
		};
		var loadingModal;

		this.getQuote = getQuote;
		this.setInitialOrderState = setInitialOrderState;

    /**
     * Quote to Order is at its core a create order process. Getting quotes should be understood as simply a layer on
     * top of the create order process. Given this, it is imperative that in constructing the Get A Quote params, nothing
     * in $scope.order should actually be changed, as those changes will likely have downstream consequences when the user
     * goes to submit an order. Put another way, $scope.order constructed to suit the needs of the Create Order service, and
     * constructGetAQuoteParams is simply a way of making a copy of $scope.order conform to the Get A Quote service.
     *
     * @param {Object} order
     * @param {Boolean} isMetric
     * @param {string} requestType
     * @returns {Object} Get A Quote params
     */
		function constructGetAQuoteParams(order, isMetric, requestType) {
			var selectedAccessorials = getSelectedAccessorials(order);
			trackAccessorialSelections(selectedAccessorials);
			var dateValue = order.pickupDate;
            var orderPickupDate = moment.parseZone(dateValue).format("L LT");

			var quoteParams = {
				customer: order.customer,
				shipDate: orderPickupDate,
				origin: getOriginLocation(order),
				destination: getDestinationLocation(order),
				useMetric: isMetric,
				actualWeight: getTotalWeight(order.items),
				freightClass: 0,
				items: constructItems(order),
				accessorials: constructAccessorialCodes(selectedAccessorials),
        requestType: requestType,
        isTransactional: order.isTransactional,
        specialServiceList: setSpecialServiceList(order.isTeam)
			};
			return quoteParams;
		}

		function constructItems(order) {
			var items = order.items
			var getAQuoteItems = _.cloneDeep(items);

			_.forEach(getAQuoteItems, function (item) {
				item.pieces = item.quantity;
				if (item.packaging && item.packaging.refDataCode) {
					item.packagingType = item.packaging.refDataCode;
				}
				if (item.commodity == null || item.commodity === undefined) {
					hydrateItemSearch(item, order);
				}

				deleteTemporyItemFreightClassProperties(item);
				handleFreightClass(item);
				handleTempCategory(item);
				handleDeepFrozen(item);
			});

			return getAQuoteItems;
		}

		function deleteTemporyItemFreightClassProperties(item) {
			if (item) {
				for (var temporaryProperty in item) {
					if (/_temporary.*/.test(temporaryProperty)) {
						delete item[temporaryProperty];
					}
				}
			}
		}

		function hydrateItemSearch(item, order) {
			return BolCommentService.getSearchItem(item, order.customer).then(function () {
				return item;
			});
		}

		function getAllAccessorials(order) {
			var accessorials = [];

			Array.prototype.push.apply(accessorials, order.originAccessorials);
			Array.prototype.push.apply(accessorials, order.destinationAccessorials);
			Array.prototype.push.apply(accessorials, order.overallAccessorials);

			return accessorials;
		}

		function getSelectedAccessorials(order) {
			var allAccessorials = getAllAccessorials(order);
			var checkedAccessorials = allAccessorials.filter(function (a) { return a.checked; });
			return checkedAccessorials;
		}

		function trackAccessorialSelections(accessorials) {
			_.forEach(accessorials, function (accessorial) {
				analyticsService.trackWithVar('getAQuote_Accessorial', 'getAQuote_accessorialValue', accessorial.name);
			});
		}

		function constructAccessorialCodes(accessorials) {
			var codes = accessorials.map(function (a) {
				var code = { RefDataCode: a.code };
				return code;
			});
			return codes;
		}

		function constructLocation(location, accessorials) {
			if (accessorials) {
				var selectedAccessorials = accessorials.filter(function (a) { return a.checked; });
				location.specialRequirementCodes = constructSpecialRequirementCodes(selectedAccessorials);
			}
			return location;
		}

		function getOriginLocation(order) {
			if (order.originAccessorials) {
				var originAccessorials = order.originAccessorials.filter(function (a) { return a.checked; });
				order.pickup.specialRequirementCodes = constructSpecialRequirementCodes(originAccessorials);
			}
			return order.pickup;
		}

		function getDestinationLocation(order) {
			if (order.destinationAccessorials) {
				var destinationAccessorials = order.destinationAccessorials.filter(function (a) { return a.checked; });
				order.deliver.specialRequirementCodes = constructSpecialRequirementCodes(destinationAccessorials);
			}
			return order.deliver;
		}

		function constructSpecialRequirementCodes(accessorials) {
			var codes = accessorials.map(function (a) { return a.specialRequirementCode; });
			return codes;
		}

		function getQuote(order, user, isMetric, noRatesCallbackType, requestType) {
			var getAQuoteParams;

			openLoadingModal();

			CustomerPartyService.getOnlineContact({
				partyCode: order.customer.partyCode,
				userName: user.name
			}, function (response) {
				if (response.partyID) {
					order.customer.contactInfo = {};
					order.customer.contactInfo.emailAddress = response.emailAddress;
					order.customer.contactInfo.phoneNumber = response.phoneNumber;
					order.customer.contactInfo.name = response.name;
				}

				getAQuoteParams = constructGetAQuoteParams(order, isMetric, requestType);

				QuoteService.save(getAQuoteParams).$promise.then(function (result) {
					if (_.isEmpty(result.quoteSummaryList)) {
						noRatesFoundMap[noRatesCallbackType](order);
						return;
					}

					loadingModal.close(result);

					$state.go("app.getAQuoteResults", {
						getAQuoteParams: getAQuoteParams,
						quoteRequestId: result.quoteRequestId,
						quoteResults: result.quoteSummaryList,
						rawQuoteParams: order
					});
				}, function () {
					noRatesFoundMap[noRatesCallbackType](order);
				});
			});
		}

		function GAQNoRatesCallback() {
			loadingModal.close();
			$rootScope.$broadcast("noQuotesFound");
		}

		function getTotalWeight(items) {
			var total = 0;

			_.forEach(items, function (commodity) {
				total += commodity.weight;
			});

			return total;
		}

		function handleFreightClass(item) {
			if (item.freightClass && item.freightClass.label) {
				item.freightClass = item.freightClass.label;
			}
		}

		function handleTempCategory(item) {
			if (item.tempCategory && item.tempCategory.refDataCode) {
				item.tempCategory = item.tempCategory.refDataCode;
			}
		}

		function handleDeepFrozen(item) {
			if (item.tempCategory === "DeepFrozen") {
				item.tempCategory = "Deep Frozen";
			}
		}

		function openLoadingModal() {
			loadingModal = $uibModal.open({
				templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
				size: 'sm',
				controller: 'loadingSpinnerController',
				backdrop: 'static',
				resolve: {
					title: function () {
						return $filter('translate')('PROCESSING');
					}
				}
			});
		}

		function quoteHistoryNoRatesCallback(order) {
			loadingModal.close();
			$state.go("app.getAQuote", {
				noQuotesFound: true,
				rawQuoteParams: order
			});
		}

		function setInitialOrderState() {
			return {
				items: [],
				customer: null,
				deliver: null,
				destinationAccessorials: GAQAccessorialService.getDestinationAccessorials(),
				originAccessorials: GAQAccessorialService.getOriginAccessorials(),
				overallAccessorials: GAQAccessorialService.getOverallAccessorials(),
				pickup: null,
				pickupDate: new Date(),
        isTeam: false
			};
		}
	}

	function setSpecialServiceList(isTeamRequest) {
	  if (isTeamRequest) {
	    return ['EXD']
    }
  }

	angular.module("NavisphereOnline").service("GAQService", GAQService);
})();

(function () {
  "use strict";

  GAQAccessorialService.$inject = [];

  function GAQAccessorialService() {
    this.getDestinationAccessorials = getDestinationAccessorials;
    this.getOriginAccessorials = getOriginAccessorials;
    this.getOverallAccessorials = getOverallAccessorials;
    this.getDestinationAccessorialsWithSelections = getDestinationAccessorialsWithSelections;
    this.getOriginAccessorialsWithSelections = getOriginAccessorialsWithSelections;
    this.getOverallAccessorialsWithSelections = getOverallAccessorialsWithSelections;

    function getDestinationAccessorials() {
      return [
        {
          name: "LIFT_GATE",
          checked: false,
          code: "LFT",
          specialRequirementCode: "LFT",
          number: 5381
        }, {
          name: "INSIDE_DELIVERY",
          checked: false,
          code: "IDL",
          specialRequirementCode: "IDL",
          number: 646
        }, {
          name: "RESIDENTIAL_DELIVERY_FEE",
          checked: false,
          code: "RES",
          specialRequirementCode: "RES",
          number: 700
        }, {
          name: "LIMITED_ACCESS",
          checked: false,
          code: "DLA",
          specialRequirementCode: "DLA",
          number: 3453
        }, {
          name: "TRADE_SHOW_OR_CONVENTION",
          checked: false,
          code: "EBD",
          specialRequirementCode: "EBD",
          number: 620
        }, {
          name: "CONSTRUCTION_SITE",
          checked: false,
          code: "CSD",
          specialRequirementCode: "CSD",
          number: 3487
        }, {
          name: "PICK_UP_AT_CARRIER_TERMINAL",
          checked: false,
          code: "PKU",
          specialRequirementCode: "PUT",
          number: 5379
        }
      ]
    }

    function getOverallAccessorials() {
      return [
        {
          name: "BLIND_SHIPMENT",
          checked: false,
          code: "BLD",
          number: 5153
        }, {
          name: "SORT_AND_SEGREGATE",
          checked: false,
          code: "SEG",
          number: 707
        }, {
          name: "COLLECT_ON_DELIVERY",
          checked: false,
          code: "COL",
          number: 585
        }
      ]
    }

    function getOriginAccessorials() {
      return [
        {
          name: "LIFT_GATE",
          checked: false,
          code: "LFT",
          specialRequirementCode: "LFT",
          number: 652
        }, {
          name: "INSIDE_PICKUP",
          checked: false,
          code: "IPU",
          specialRequirementCode: "IPU",
          number: 659
        }, {
          name: "RESIDENTIAL_PICKUP_FEE",
          checked: false,
          code: "REP",
          specialRequirementCode: "REP",
          number: 699
        }, {
          name: "LIMITED_ACCESS",
          checked: false,
          code: "PLA",
          specialRequirementCode: "PLA",
          number: 3454
        }, {
          name: "TRADE_SHOW_OR_CONVENTION",
          checked: false,
          code: "EBP",
          specialRequirementCode: "EBD",
          number: 5380
        }, {
          name: "CONSTRUCTION_SITE",
          checked: false,
          code: "CSP",
          specialRequirementCode: "CSP",
          number: 3500
        }, {
          name: "DROP_OFF_AT_CARRIER_TERMINAL",
          checked: false,
          code: "DRP",
          specialRequirementCode: "DAT",
          number: 5379
        }
      ]
    }

    function getDestinationAccessorialsWithSelections(specialRequirementCodes) {
      var accessorials = getDestinationAccessorials();
      var withSelections = getLocationAccessorialsWithSelections(specialRequirementCodes, accessorials);
      return withSelections;
    }

    function getOriginAccessorialsWithSelections(specialRequirementCodes) {
      var accessorials = getOriginAccessorials();
      var withSelections = getLocationAccessorialsWithSelections(specialRequirementCodes, accessorials);
      return withSelections;
    }

    function getOverallAccessorialsWithSelections(selectedAccessorials) {
      var overallAccessorials = getOverallAccessorials();
      var withSelections = overallAccessorials.map(function(a) { return createSelectedOverallAccessorial(selectedAccessorials, a) });
      return withSelections;
    }

    function getLocationAccessorialsWithSelections(specialRequirementCodes, accessorials) {
      var withSelections = accessorials.map(function(a) { return createSelectedLocationAccessorial(specialRequirementCodes, a) });
      return withSelections;
    }

    function createSelectedLocationAccessorial(specialRequirementCodes, accessorial) {
      accessorial.checked = containsSpecialRequirementCode(specialRequirementCodes, accessorial.specialRequirementCode);
      return accessorial;
    }

    function createSelectedOverallAccessorial(selectedAccessorials, accessorial) {
      if (!selectedAccessorials) {
        return accessorial;
      }
      accessorial.checked = selectedAccessorials.some(function(a) { return a.rateCode === accessorial.code });
      return accessorial;
    }

    function containsSpecialRequirementCode(specialRequirementCodes, specialRequirementCode) {
      if (!specialRequirementCodes) {
        return false;
      }
      var containsSpecialRequirement = specialRequirementCodes.some(function(s) { return s === specialRequirementCode });
      return containsSpecialRequirement;
    }
  }

  angular.module("NavisphereOnline").service("GAQAccessorialService", GAQAccessorialService);
})();

(function () {
  "use strict";
  var app = angular.module("NavisphereOnline");

  selectAddressController.$inject = ["$uibModalInstance", "$scope", "AddressService", "analyticsService", "customerCode", "LocationService", "locationType", "user", "UserPermissionService"];

  function selectAddressController($uibModalInstance, $scope, AddressService, analyticsService, customerCode, LocationService, locationType, user, UserPermissionService) {
    $scope.locationType = locationType;
    $scope.user = user;
    $scope.getAddressLine1 = AddressService.GetAddressLine1;
    $scope.getAddressLine2 = AddressService.GetAddressLine2;
    $scope.getAddressLine3 = AddressService.GetAddressLine3;
    $scope.getAddressLine4 = AddressService.GetAddressLine4;

    $scope.close = function() {
      $uibModalInstance.dismiss("closed");
    };

    $scope.add = function() {
      $uibModalInstance.close($scope.location);
    };

    $scope.getLocationDisplayName = function (location) {
      if (location) return location.addressName ? location.addressName : location.locationPartyName;
      return '';
    };

    function setRecentLocations() {
      if (customerCode) {
        if ($scope.locationType == "pickup") {
          LocationService.getRecentOrigins({
            customerCode: customerCode
          }).$promise.then(function (result) {
            $scope.recentLocations = result;
          });
        } else {
          LocationService.getRecentDestinations({
            customerCode: customerCode
          }).$promise.then(function (result) {
            $scope.recentLocations = result;
          });
        }
      }
    }

    $scope.refreshLocations = function (searchText) {
      $scope.locationResults = [];

      if (searchText.length < 2) {
        $scope.locationSearchHasNoResults = false;
        return $scope.locationResults;
      }

      if(angular.isUndefined($scope.hasAddLocation)){
        $scope.hasAddLocation = UserPermissionService.hasCustomerRole($scope.order.customer.partyCode, 'Add New Location');
      }

      return LocationService.searchPartyLocation({
        partyNumberOrCode: $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, ''),
        term: searchText,
        limit: 20,
        locationSearchType: 1,
        useSupplierLocation: $scope.order.customer.useSupplierLocation
      }, function (data) {
        $scope.locationResults = data.items;
        $scope.locationSearchHasNoResults = data.items.length === 0;
      });
    };

    $scope.onLocationSelected = function (item) {
      analyticsService.trackWithVar('selectedRecentLocation', 'selectedRecentLocationValue', "selected recent location" + ( ($scope.locationType)? " for " + $scope.locationType: ""));
      $scope.location = item;
      $scope.location.earliestTime = new Date((new Date()).setHours(0, 0, 0, 0));
      $scope.location.latestTime = new Date((new Date()).setHours(0, 0, 0, 0));
      $scope.locationSearchHasNoResults = false;
      LocationService.getLocation({
        locationPartyNumberOrCode: item.locationPartyCode,
        relatedLocationId: item.relatedLocationId,
        useSupplierLocation: $scope.$parent.order.customer.useSupplierLocation,
        // Unspecified DateTimeZoneHandling :convert to a local time if a time zone is specified
        dateTimeZoneHandling: 2
      }, function (data) {
        if (data) {
					$scope.location.dryReceivingHours = data.dryReceivingHours;
					$scope.location.dryShippingHours = data.dryShippingHours;

          if (data.notes) {
            $scope.location.notes = data.notes.substring(0, 255);
          }

          $scope.location.name = data.name;
          $scope.location.adminDistrictCode = data.physicalAddress.stateProvince;
          $scope.location.countryCode = data.physicalAddress.country;
          $scope.location.postalCode = data.physicalAddress.postalCode;
          $scope.location.partyCode = data.partyCode;
          $scope.location.partyNumber = data.partyNumber;
          $scope.location.physicalAddress = data.physicalAddress;
          $scope.location.generalAddress = data.generalAddress;
          $scope.location.relatedLocationId = data.relatedLocationId;
          $scope.location.loadingTypeRDN = data.loadingTypeRDN;
        }
      });
    };

    $scope.shouldHighlightLocation = function(recent) {
      if ($scope.order[locationType] && $scope.order[locationType].locationPartyCode) {
        return _.isEqual(recent, $scope.location) || recent.locationPartyCode === $scope.order[locationType].locationPartyCode;
      }

      return _.isEqual(recent, $scope.location);
    };

    setRecentLocations();
  }

    app.controller("selectAddressController", selectAddressController);
})();

(function () {
  "use strict";

  quoteToOrderController.$inject = ["$locale", "$scope", "$state", "$stateParams", "$uibModalStack", "AddressService", "CreateOrderRefNumberService", "ItemServiceHelper", "LocationSelectionHelper", "LocationService", "ModalService", "ModeTranslatorService", "OrderCreateService", "refDataDDLs", "ReferenceData", "UnitsOfMeasurementService", "UserPermissionService", "userPreferences", "ValidationErrorService", "LocationDateHelper","user", "DateTimeService"];

  function quoteToOrderController($locale, $scope, $state, $stateParams, $uibModalStack, AddressService, CreateOrderRefNumberService, ItemServiceHelper, LocationSelectionHelper, LocationService, ModalService, ModeTranslatorService, OrderCreateService, refDataDDLs, ReferenceData, UnitsOfMeasurementService, UserPermissionService, userPreferences, ValidationErrorService, LocationDateHelper,user, DateTimeService) {
    var modalOptions = {
      closeButtonText: "CANCEL",
      actionButtonText: "OK",
      headerText: "ARE_YOU_SURE_YOU_WANT_TO_EXIT_THIS_ORDER",
      bodyText: "INFORMATION_ENTERED_FOR_THIS_ORDER_MAY_BE_LOST"
    };
    var onRouteChangeOff;
    var rateSourceMap = {
      "CM": 788,
      "CHR-FQ": 5373,
      "CHR-FQ Custom": 5389,
      "Transactional": 6282,
      "Contractual": 6283,
      "SGA": 5859,
      "SQ": 5374
    };
    var stateChangeMap = {
      "app.getAQuote": {
        rawQuoteParams: $stateParams.rawQuoteParams
      },
      "app.getAQuoteResults": {
        getAQuoteParams: $stateParams.getAQuoteParams,
        quoteResults: $stateParams.quoteResults,
        rawQuoteParams: $stateParams.rawQuoteParams
      }
    };

    $scope.activeStep = 1;
    $scope.customer = $stateParams.rawQuoteParams.customer;
    $scope.customerDisplayName = $stateParams.rawQuoteParams.customer.displayName;
    $scope.deliveryFirstCheck = true;
    $scope.destination = $stateParams.destination;
    $scope.disabled = {
      isPickupDatePickerDisabled: true
    };
    $scope.format = $locale.DATETIME_FORMATS["shortDate"];
    $scope.hasAddNewCommodityPerTrans = UserPermissionService.hasCustomerRole($scope.customer.partyCode, "Add New Commodity Per Transaction");
    $scope.hasCreateNewCommodityInPartyCatalog = UserPermissionService.hasCustomerRole($scope.customer.partyCode, "Create New Commodity in Party Catalog");
    $scope.isMetric = userPreferences.unitOfMeasure === "metric";
    $scope.isQuoteToOrder = true;
    $scope.itemDdlRefData = refDataDDLs;
    $scope.itemSummary = {
      lineItems: 0,
      weight: 0,
      insuranceValue: 0,
      pallets: 0,
      quantity: 0
    };
    $scope.needsRefinement = {};
    $scope.origin = $stateParams.origin;
    $scope.quote = $stateParams.quote;
    $scope.pickupFirstCheck = true;
    _.forEach($stateParams.rawQuoteParams.items, function(ritem) {
      _.forEach($stateParams.getAQuoteParams.items, function(gitem) {
        if ((ritem.isHazardous && ritem.itemID === gitem.itemID) && (ritem.commodity == null || ritem.commodity === undefined)) {
          ritem.commodity = gitem.commodity;
        }
      });
    });
    $scope.order = {
      carrierCode: $stateParams.quote.carrier.carrierCode,
      currencyCode: $stateParams.quote.currencyCode,
      customer: $stateParams.getAQuoteParams.customer,
      delivery: $stateParams.getAQuoteParams.destination,
      items: $stateParams.rawQuoteParams.items,
      newRefNums: CreateOrderRefNumberService.getNewRefNumList(),
      pickup: $stateParams.getAQuoteParams.origin,
      charges: hydrateCharges($stateParams.quote.rateList),
      referenceNumbers: [],
      quoteRequestId: $stateParams.quoteRequestId,
      readOnlyProperties: {}
    };

    setLoadingTypeOnPreselectedLocations();

    $scope.requstType = $stateParams.getAQuoteParams.requestType;
    $scope.isTruckload = isTruckloadQuote($scope.quote);

    $scope.orderItemsConfig = {
      shouldShowFilterByDescription: false,
      shouldShowCatalogSearch: false,
      isAllowedToRemoveItems: false
    };
    $scope.shouldShowInfoBox = false;
    $scope.stepNames = ["Reference Numbers", "Pickup Details", "Delivery Details", "Shipment Items"];
    $scope.totalCharge = $stateParams.totalCharge;
    $scope.totalWeight = $stateParams.totalWeight;
    $scope.user = user;
    $scope.userPreferences = userPreferences;
    $scope.validationMessages = [];

    addQuoteIdToRefNums();
    setVolumeQuoteId();
    doesInitialLocationNeedRefinement("pickup");
    doesInitialLocationNeedRefinement("delivery");
    getLocationOptions("pickup");
    getLocationOptions("delivery");
    initRouteChange();
    isFlatbedOrder();
    isInitialDeliveryDatePickerDisabled();
    isInitialLocationValid("pickup");
    isInitialLocationValid("delivery");
    prefillDeliveryDateTime();
    prefillPickupDateTime();
    removePlaceHolderWeightForTLCustomer();
    setReadOnlyItemProperties();
    setServiceOffering();
    setUnitsOfMeasurement($scope.order.items, $scope.isMetric);
    setOrderTeamFlag();

    $scope.displaySelection = displaySelection;
    $scope.editQuote = editQuote;
    $scope.getLocationDateTime = getLocationDateTime;
    $scope.getLocationDisplay = getLocationDisplay;
    $scope.getLocationDisplayName = getLocationDisplayName;
    $scope.getShippingMethod = getShippingMethod;
    $scope.getTemplate = getTemplate;
    $scope.getWeightMeasurement = getWeightMeasurement;
    $scope.hydrateLocationDateTime = hydrateLocationDateTime;
    $scope.refreshSearchItems = refreshSearchItems;
    $scope.returnToQuotes = returnToQuotes;
    $scope.setLocation = setLocation;
    $scope.showValidationError = showValidationError;
    $scope.submitOrder = submitOrder;
    $scope.isTeamQuote = isTeamQuote;

    var destroyDryShippingHoursWatcher = $scope.$watch('order.pickup.dryShippingHours', function(newValue){
      if(!newValue){
        return;
      }

      var earliestTime = LocationDateHelper.getOpenTimeFromHours(newValue, $scope.order.pickup.earliestDate);
      var latestTime = LocationDateHelper.getCloseTimeFromHours(newValue, $scope.order.pickup.latestDate);
      var locationDateTime = {
        earliestTime: earliestTime,
        latestTime: latestTime
      }
      $scope.hydrateLocationDateTime('pickup', locationDateTime)
    });
    $scope.$on('$destroy', destroyDryShippingHoursWatcher);

    var destroyDryReceivingHoursWatcher = $scope.$watch('order.delivery.dryReceivingHours', function(newValue){
      if(!newValue){
        return;
      }

      var earliestTime = LocationDateHelper.getOpenTimeFromHours(newValue, $scope.order.delivery.earliestDate);
      var latestTime = LocationDateHelper.getCloseTimeFromHours(newValue, $scope.order.delivery.latestDate);
      var locationDateTime = {
        earliestTime: earliestTime,
        latestTime: latestTime
      }
      $scope.hydrateLocationDateTime('delivery', locationDateTime);
    })
    $scope.$on('$destroy', destroyDryReceivingHoursWatcher);

    function addQuoteIdToRefNums() {

      $scope.order.referenceNumbers.push({
        referenceNumberType: {
          description: "Quote Id",
          refDataNumber: 5204
        },
        value: $stateParams.quote.quoteId
      })
    }

    function setVolumeQuoteId() {
      if ($stateParams.quote.referenceNumberList) {
        for (var i = 0; i < $stateParams.quote.referenceNumberList.length; ++i) {
          if ($stateParams.quote.referenceNumberList[i].referenceNumberTypeCode === "CVQID") {
            $scope.order.pickup.volumeQuoteId =
              'VOLUME QUOTE ID ' + $stateParams.quote.referenceNumberList[i].value;
            break;
          }
        }
      }
    }

    function displaySelection(locationType) {
      if ($scope.order[locationType].partyCode || $scope.order[locationType].locationPartyCode) {
        return $scope.getLocationDisplay(locationType);
      }

      return "";
    }

    function doesInitialLocationNeedRefinement(locationType) {
      if (!$scope.order[locationType].partyCode && !$scope.order[locationType].locationCode) {
        $scope[locationType + "NeedsRefinement"] = true;
        $scope.needsRefinement[locationType] = $scope.order[locationType];
      }
    }

    /**
     * Return to the Get A Quote V2 search screen. Passes in the rawQuoteParams so the form can be prefilled.
     *
     * @param event
     */
    function editQuote() {
      $state.go("app.getAQuote", stateChangeMap["app.getAQuote"]);
    }

    function fillTime(locationType, timeType, time) {
      if (time) {
        $scope.order[locationType][timeType] = new Date(time);
      } else {
        var time = new Date();
        time.setHours(0, 0, 0, 0);
        $scope.order[locationType][timeType] = time;
      }
    }

    function formatLocationData(locationData) {
      _.forEach(locationData, function (location) {
        location["addressLine1"] = AddressService.GetAddressLine1(location.address);
        location["addressLine2"] = AddressService.GetAddressLine2(location.address);
        location["addressLine3"] = AddressService.GetAddressLine3(location.address);
        location["addressLine4"] = AddressService.GetAddressLine4(location.address);
      });
    }

    function getLocationDateTime(locationType) {
      return {
        earliestDate: $scope.order[locationType].earliestDate,
        latestDate: $scope.order[locationType].latestDate,
        earliestTime: $scope.order[locationType].earliestTime,
        latestTime: $scope.order[locationType].latestTime
      }
    }

    function getLocationDisplay(locationType) {
      var location = $scope.order[locationType].address;

      if (location.addressLine1) {
        return location.addressLine1 + ",\n " + location.city + " " + location.stateProvince + " " + location.postalCode;
      }

      return location.postalCode + ", " + location.city + " " + location.stateProvince;
    }

    function getLocationDisplayName(location) {
      if (location) return location.addressName ? location.addressName : location.locationPartyName;
      return '';
    }

    function getLocationOptions(locationType) {
      if (!$scope.order[locationType].partyCode) {
        LocationService.searchPartyLocation({
          partyNumberOrCode: $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, ""),
          term: $scope.order[locationType].postalCode ? $scope.order[locationType].postalCode : $scope.order[locationType].address.postalCode,
          locationSearchType: 1,
          useSupplierLocation: $scope.order.customer.useSupplierLocation
        }, function (data) {
          formatLocationData(data.items);
          $scope[locationType + "Options"] = data.items;
          if (!$scope[locationType + "NeedsRefinement"]) {
            setDetailsForPreselectedLocation(data.items, locationType);
          }
        });
      }
    }

    function setDetailsForPreselectedLocation(locationOptions, locationType) {
      var selectedLocation = _.find(locationOptions, function (location) {
        return location.locationPartyCode === $scope.order[locationType].locationCode;
      });

      var locationDateTimes = {
        earliestDate: $scope.order[locationType].earliestDate,
        earliestTime: $scope.order[locationType].earliestTime,
        latestDate: $scope.order[locationType].latestDate,
        latestTime: $scope.order[locationType].latestTime
      };

      LocationSelectionHelper.onLocationSelected(selectedLocation, $scope.order, locationType, false);

      $scope.order[locationType].earliestDate = locationDateTimes.earliestDate;
      $scope.order[locationType].earliestTime = locationDateTimes.earliestTime;
      $scope.order[locationType].latestDate = locationDateTimes.latestDate;
      $scope.order[locationType].latestTime = locationDateTimes.latestTime;
    }

    function getShippingMethod(key) {
      return ModeTranslatorService.transportModeMap[key] ? ModeTranslatorService.transportModeMap[key] : key;
    }

    function getTemplate(step) {
      return "app/getAQuote/views/quoteToOrderStep" + step + ".tpl.html";
    } $scope.toggleInfoBox = toggleInfoBox;

    function getWeightMeasurement() {
      return $scope.isMetric ? "kgs" : "lbs";
    }

    function hydrateCharges(charges) {
      _.forEach(charges, function (charge) {
        charge.quoteId = $stateParams.quote.quoteId;
        charge.rateSourceRDN = rateSourceMap[charge.rateSource];
        charge.sourceSystemRDN = 5435;

        if (hasSalesQuote($stateParams.quote)) {
          applySalesQuoteInfo(charge, $stateParams.quote);
        } else {
          charge.quoteTypeId = 2;
          charge.quoteSeqNum = -1;
        }
      });

      return charges;
    }

    function hydrateLocationDateTime(locationType, locationDateTime) {
      _.forEach(locationDateTime, function (value, key) {
        $scope.order[locationType][key] = value;
      })
    }

    function initRouteChange() {
      onRouteChangeOff = $scope.$on("$stateChangeStart", routeChange);
    }

    function isFlatbedOrder() {
      if ($scope.quote.transportModeType === 12) {
        $scope.order.isFlatbed = true;
      }
    }

    function isInitialDeliveryDatePickerDisabled() {
      $scope.disabled.isDeliveryDatePickerDisabled = (!!$stateParams.quote.transit && !isTruckloadQuote($stateParams.quote));
    }

    function isInitialLocationValid(locationType) {
      if ($scope.order[locationType].partyCode) {
        $scope[locationType + "Temp"] = "valid";
      } else {
        $scope[locationType + "Temp"] = null;
      }
    }

    function isTransactionalRate(rate) {
      return rate.rateSource === 'Transactional';
    }

    function isTransactionalQuote(quote) {
      return !!quote.rateList && _.some(quote.rateList, isTransactionalRate);
    }

    function getOrderShipDate() {
      return isTruckloadQuote($stateParams.quote) &&
        isTransactionalQuote($stateParams.quote) &&
        $stateParams.quote.transit &&
        $stateParams.quote.transit.minimumPickupDate
        ? $stateParams.quote.transit.minimumPickupDate
        : $stateParams.getAQuoteParams.shipDate;
    }

    function prefillPickupDateTime() {
      // Parsing Date to "MM/DD/YYYY HH:MM" format, to fix moving ahead one day
      // Bug 258056: INC9707130 - Quote to Order Date moves ahead one day
      var orderShipDate = getOrderShipDate();
      var isoUtcDate = moment.utc(orderShipDate).local().toISOString();
      var dateNoOffset = moment.parseZone(isoUtcDate).format("L LT");
      $scope.order.pickup.earliestDate = new Date(dateNoOffset);
      $scope.order.pickup.latestDate = new Date(dateNoOffset);
      fillTime("pickup", "earliestTime", $stateParams.getAQuoteParams.origin.earliestTime);
      fillTime("pickup", "latestTime", $stateParams.getAQuoteParams.origin.earliestTime);
    }

    function prefillDeliveryDateTime() {
      if ($stateParams.quote.transit && $stateParams.quote.transit.minimumDeliveryDate) {
        if (typeof ($stateParams.quote.transit.minimumDeliveryDate) === 'object') {
          $stateParams.quote.transit.minimumDeliveryDate = $stateParams.quote.transit.minimumDeliveryDate.toISOString()
        }
        // We strip Z (offset) from utc date bc rating gives all quotes at midnight.
        // This keeps date from moving to previous day after converting to date object
        var dateNoOffset = $stateParams.quote.transit.minimumDeliveryDate ? $stateParams.quote.transit.minimumDeliveryDate.replace(/Z$/gi, '') : undefined;
        var deliveryDate = new Date(dateNoOffset);
        if ($stateParams.quote.transit.minimumTransitDays === 0 && isTruckloadQuote($stateParams.quote)) {
          var latestDeliveryDate = DateTimeService.getDateAddDays(1, deliveryDate)
          $scope.order.delivery.earliestDate = deliveryDate;
          $scope.order.delivery.latestDate = latestDeliveryDate;
        } else {
          $scope.order.delivery.earliestDate = deliveryDate;
          $scope.order.delivery.latestDate = deliveryDate;
        }
      }

      fillTime("delivery", "earliestTime", $stateParams.getAQuoteParams.destination.earliestTime);
      fillTime("delivery", "latestTime", $stateParams.getAQuoteParams.destination.earliestTime);
    }

    $scope.setQuoteToOrderMinDate = function () {
      if ($stateParams.quote.transit && isTruckloadQuote($stateParams.quote)) {
        var dateNoOffset = $stateParams.quote.transit.minimumDeliveryDate.replace(/Z$/gi, '');
        return new Date(dateNoOffset);
      } else {
        return DateTimeService.getToday()
      }
    }

    /**
     * This function removes weights from all items in
     * order object for Transactional Truck Load
     * Customers.
     *
     * Weight is required for TL TPE data request but required
     * on get a quote TL form. It should be populated
     * on order creation by user.
     */
    function removePlaceHolderWeightForTLCustomer() {
      if (($scope.quote.transportModeType && $scope.quote.transportModeType === 2) || $scope.quote.transportModeType === 12) {
        _.forEach($scope.order.items, function (item) {
          item.actualWeight = null;
          item.weight = null;
        });
      }
    }

    function refreshSearchItems(search) {
      return ItemServiceHelper.searchHelper(search, $scope.order.customer, $scope, true);
    }

    function returnToQuotes() {
      $state.go("app.getAQuoteResults", stateChangeMap["app.getAQuoteResults"]);
    }

    function routeChange(event, toState) {
      if (!$scope.orderForm || !$scope.orderForm.$dirty || toState.name === "login") {
        return;
      }

      ModalService.showModal({}, modalOptions).then(function (result) {
        if (result === "ok") {
          onRouteChangeOff();
          $uibModalStack.dismissAll(result);

          $state.go(toState.name, stateChangeMap[toState.name]);
        }
      });
      event.preventDefault();
    }

    /**
     * getLocationDateTime will grab date and time values before they are overwritten. hydrateLocationDateTime will add them to the new location.
     * Using getLocationDateTime and hydrateLocationDateTime allow us to reuse deliveryDatePicker and pickupDatePicker as well as their
     * supporting controllers.
     *
     * Having separate location pairs (pickup/pickupTemp and delivery/deliveryTemp, respectively) decouples form validation
     * from what is actually sent to the API.
     *
     * @param location A new location object. In this case, a specific address that has a w-code.
     * @param locationType "pickup" or "delivery"
     */
    function setLoadingType(locationType) {
      if ($scope.order[locationType].loadingTypeRDN && $scope.order[locationType].loadingTypeRDN !== null) {
        $scope.order[locationType].loadingType = getLoadingTypeData($scope.order[locationType].loadingTypeRDN);
      }
    }

    function setLoadingTypeOnPreselectedLocations() {
      setLoadingType('pickup');
      setLoadingType('delivery');
    }

    function setLocation(location, locationType) {
      var locationDateTime = $scope.getLocationDateTime(locationType);
      $scope[locationType + "Temp"] = location;
      LocationSelectionHelper.onLocationSelected(location, $scope.order, locationType, false, 2).$promise.then(function () {
        setLoadingType(locationType);
      });
      $scope.hydrateLocationDateTime(locationType, locationDateTime)
    }

    function getLoadingTypeData(rdn) {
      var loadingTypes = refDataDDLs['FBedLoadingType'];
      var typeData = {};

      _.forEach(loadingTypes, function (loadingType) {
        if (loadingType.refDataNumber === rdn) {
          typeData = loadingType;
        }
      });
      return typeData;
    }

    function setReadOnlyItemProperties() {
      _.forEach($scope.order.items, function (item) {
        item.readOnlyProperties = {};
        _.forIn(item, function (value, key) {
          if (key == "isStackable") {
            item.readOnlyProperties[key] = true;
          }
          else if (value && key != "lengthCmUomLabel") {
            item.readOnlyProperties[key] = true;
          }
        });
        if (isNonLTLFlatbedTransactional()) {
          item.readOnlyProperties['equipment'] = true;
        }
      });
    }

    function setServiceOffering() {
      // Set a default in case ReferenceData doesn't come back with a match.
      $scope.order.serviceOffering = {
        id: $stateParams.quote.serviceOfferingId
      };

      ReferenceData.getServiceOfferings().$promise.then(function (serviceOfferings) {
        _.forEach(serviceOfferings, function (serviceOffering) {
          if ($stateParams.quote.serviceOfferingId === serviceOffering.id) {
            $scope.order.serviceOffering = serviceOffering;
          }

        });
      });
    }

    function setUnitsOfMeasurement(items, isMetric) {
      UnitsOfMeasurementService.setUnitsOfMeasurement(items, isMetric)
    }

    function showValidationError() {
      ValidationErrorService.showValidationError($scope);
    }

    function submitOrder() {
      OrderCreateService.createOrder($scope);
    }

    function toggleInfoBox() {
      $scope.shouldShowInfoBox = !$scope.shouldShowInfoBox;
    }

    $scope.carrierNameDisplay = function (carrierName) {
      if(!$scope.isTruckload) {
        return carrierName;
      }
      return 'CH Robinson Truckload Services';
    };

    function isTruckloadQuote(quote) {
      return ((quote.transportModeType && quote.transportModeType === 2) || $scope.quote.transportModeType === 12)
    }

    function isTeamQuote() {
      var isTeam = false;
      if ($stateParams.getAQuoteParams.specialServiceList) {
        _.forEach($stateParams.getAQuoteParams.specialServiceList, function(service) {
          //EXD check for expedite/team rate
          if (service === "EXD") {
            isTeam = true;
          }
        });
      }

      if ($scope.quote.specialServiceList) {
        _.forEach($scope.quote.specialServiceList, function(service) {
          //EXD check for expedite/team rate
          if (service === "EXD") {
            isTeam = true;
          }
        });
      }
      return isTeam;
    }

    $scope.shouldDisplayMode = function () {
      return $scope.quote.transportModeType !== 2;
    }

    function applySalesQuoteInfo(charge, quote) {
      _.forEach(quote.referenceNumberList, function(refNum) {
        if (refNum.referenceNumberTypeCode === "SQID") {
          charge.salesQuoteId = refNum.value;
        }
        if (refNum.referenceNumberTypeCode === "QSeqNum") {
          charge.quoteSeqNum = refNum.value;
        }
      });
      charge.quoteTypeId = 1;
    }

    function hasSalesQuote (quote) {
      var hasSQ = false;
      if (!quote.referenceNumberList || quote.referenceNumberList.length === 0) {
        return hasSQ;
      }
      _.forEach(quote.referenceNumberList, function (refNum) {
        if(refNum.referenceNumberTypeCode === "SQID") {
          hasSQ = true;
        }
      });
      return hasSQ;
    }

    function isNonLTLFlatbedTransactional() {
      var hasTransactionRate = false;
      _.forEach($scope.quote.rateList, function(rate) {
        if(rate.rateSource === "Transactional" || rate.rateSource === "ManualQuote") {
          hasTransactionRate = true;
        }
      });
      return ($scope.quote.transportModeType === 12 && hasTransactionRate);
    }

    function setOrderTeamFlag() {
      $scope.order.isTeam = isTeamQuote();
    }
  }

  angular.module("NavisphereOnline").controller("quoteToOrderController", quoteToOrderController)
})();

(function () {
  "use strict";

  var app = angular.module('NavisphereOnline');

  getAQuoteResultsController.$inject = ["$scope", "$rootScope", "$state", "$stateParams", "DateTimeService", "analyticsService", "FilterService", "ModeTranslatorService", "QuoteService", "ServiceOffering", "UserPermissionService", "userPreferences", "DocumentHelper", "API_BASE_URL", "$uibModal", "$window"];

  function getAQuoteResultsController($scope, $rootScope, $state, $stateParams, DateTimeService, analyticsService, FilterService, ModeTranslatorService, QuoteService, ServiceOffering, UserPermissionService, userPreferences, DocumentHelper, API_BASE_URL, $uibModal, $window) {
    $scope.accessorialDisplayLimit = 10;
    $scope.carrierDisplayLimit = 10;
    $scope.currentPage = 1;
    $scope.filterParams = [];
    $scope.limit = "10";
    $scope.offset = 0;
    $scope.getAQuoteParams = $stateParams.getAQuoteParams;
    $scope.isShippable = $stateParams.isShippable;
    $scope.quoteRequestId = $stateParams.quoteRequestId;
    $scope.quoteResults = $stateParams.quoteResults;
    $scope.rawQuoteParams = $stateParams.rawQuoteParams;
    $scope.isTruckloadOnlyResult = isTruckloadResults($stateParams.quoteResults);
    setDefaultCarrierInfo($scope.quoteResults);
    $scope.filteredResults = FilterService.filterThorough($scope.quoteResults, $scope.filterParams);
    setCurrencyCode();
    $scope.selectedCarriers = [];
    $scope.showAdditionalCharges = false;
    $scope.sort = "lowestPrice";
    $scope.isTLHazmat = isTLHazmatResult();
    $scope.hasTeamResult = hasTeamResult();
    $scope.dateRecommenderQuotes = getDateRecommenderQuotes($scope.quoteResults);
    /**
     *  Since we want to build an array in the url, we have to have a list of params that have the same name with different values.
     *  This function converts our array to such a string.  The return line takes care of the extra & at the end of the string.
     */
    function arrayToParamString(array, name) {
      var result = "";
      _.forEach(array, function (value) {
        result += name + "=" + value + "&";
      });
      return result.slice(0, -1);
    }

    $scope.showVolumeQuoteInfoModal = function () {
      $uibModal.open({
        templateUrl: 'app/common/views/showVolumeQuoteInfo.tpl.html',
        size: 'md',
        controller: 'showInfoController'
      });
    };

    $scope.showCargoLiabilitySection = function (quote) {
      if ($rootScope.featureFlags.volumeQuoteFeatureFlag) {
        return ((quote.transportModeDescription === 'LTL') && (quote.cargoLiability));
      }
      return !!quote.cargoLiability;
    };

    $scope.isTruckload = function (quote) {
      return quote.transportModeDescription === 'TL';
    };

    $scope.isFlatbed = function (quote) {
      return quote.transportModeDescription === 'Flatbed';
    };

    $scope.hasVolumeQuoteFeatureFlag = function () {
      return $rootScope.featureFlags.volumeQuoteFeatureFlag;
    };

    $scope.getMaxLiability = function (quote) {
      var maxLiability = 0;
      if (quote.cargoLiability) {
        var totalCost = quote.cargoLiability.perPound * $scope.getTotalWeight(quote.cargoLiability);
        if (quote.cargoLiability.max > 0) {
          var minCargoLiability = Math.min(quote.cargoLiability.max, totalCost);
          if (minCargoLiability === 0) {
            maxLiability = quote.cargoLiability.max;
          }
          else{
            maxLiability = minCargoLiability;
          }
        }
        else{
          maxLiability = totalCost;
        }
      }
      return maxLiability;
    };

    $scope.getLTLQuoteLabel = function (quote) {
      var label = '';
      if ($rootScope.featureFlags.volumeQuoteFeatureFlag && quote.transportModeDescription === 'LTL') {
        if ((quote.rateSourceCode && quote.rateSourceCode === 'VQ') ||
          (quote.rateList && $scope.isVolumeQuoteRateSource(quote.rateList))) {
          label = 'VOLUME_QUOTE';
        }
        else {
          label = 'LTL_STANDARD_RATE';
        }
      }
      return label;
    };

    $scope.isVolumeQuoteRateSource = function (rateList) {
      for (var i = 0; i < rateList.length; ++i) {
        if (rateList[i].rateSource === 'VQ' || rateList[i].rateTypeCode === 'U') {
          return true;
        }
      }
      return false;
    }

    $scope.getSelectedQuoteIds = function () {
      var quotes = [];
      _.forEach($scope.quoteResults, function (quote) {
        if (quote.checked) {
          quotes.push(quote.quoteId);
        }
      });
      return quotes;
    };

    $scope.valueToArray = function (input) {
      var array = [];
      array.push(input);
      return array;
    };

    $scope.shareEmail = function (quoteIds) {
      analyticsService.track('shareEmail');
      $uibModal.open({
        templateUrl: 'app/common/views/sendDocument.tpl.html',
        size: 'lg',
        controller: 'emailQuoteController',
        resolve: {
          quoteIds: function () {
            return quoteIds
          },
          quoteRequestId: function () {
            return $scope.quoteRequestId
          },
          user: ['UserServiceHelper', function (UserServiceHelper) {
            return UserServiceHelper.get();
          }]
        }
      });
    };

    $scope.sharePrint = function (quoteIds) {
      analyticsService.track('sharePrint');
      var quoteIdString = arrayToParamString(quoteIds, "quoteId");
      DocumentHelper.showDocument(API_BASE_URL + "api/quotes/print?quoteRequestId=" + $scope.quoteRequestId + "&" + quoteIdString);
    };

    $scope.hasQuoteToOrderPermission = UserPermissionService.hasPermission("Create Order");

    $scope.getServiceOfferingImageUrl = function (serviceOfferingNumber) {
      return ServiceOffering.get(serviceOfferingNumber);
    };

    $scope.expandFilter = function ($event, filterType) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope[filterType + "DisplayLimit"] += 10;
    };

    $scope.getAbbreviatedTransportMode = function (displayName) {
      return ModeTranslatorService.getAbbreviatedTransportMode(displayName);
    };

    /**
     * Returns the shipping method or the inputted code if the shipping method is not known.
     *
     * @param key
     * @returns {string}
     */
    $scope.getShippingMethod = function (key) {
      return ModeTranslatorService.transportModeMap[key] ? ModeTranslatorService.transportModeMap[key] : key;
    };

    /**
     * Returns an array of unique modes.
     * This array is used to define the list of mode filters to go on the side of the page.
     *
     * @param quotes
     * @returns {Array}
     */
    $scope.getDistinctModes = function (quotes) {
      var uniqueKeys = {};
      var distinct = [];

      for (var index in quotes) {
        var shippingMethod = $scope.getShippingMethod(quotes[index].transportModeDescription);

        if (typeof (uniqueKeys[shippingMethod]) === "undefined") {
          distinct.push({ name: shippingMethod, checked: false });
          uniqueKeys[shippingMethod] = shippingMethod;
        }
      }

      return distinct;
    };

    /**
     * Returns an array of unique carriers.
     * This array is used to define the list of carrier filters to go on the side of the page.
     *
     * @param quotes
     * @returns {Array}
     */
    $scope.getDistinctCarriers = function (quotes) {
      var uniqueKeys = {};
      var distinct = [];

      for (var index in quotes) {
        if (typeof (uniqueKeys[quotes[index].carrier.carrierName]) === "undefined") {
          distinct.push({ name: quotes[index].carrier.carrierName, checked: false });
          uniqueKeys[quotes[index].carrier.carrierName] = quotes[index].carrier.carrierName;
        }
      }

      return distinct;
    };

    /**
     * Returns an array of unique and optional accessorials.
     * This array is used to define the list of accessorial filters to go on the side of the page.
     *
     * @param quotes
     * @returns {Array}
     */
    $scope.getDistinctAccessorials = function (quotes) {
      var uniqueKeys = {};
      var distinct = [];

      _.forEach(quotes, function (quote) {
        for (var index in quote.rateList) {
          if (quote.rateList[index].isOptional) {
            if (typeof (uniqueKeys[quote.rateList[index].rateDescription]) === "undefined") {
              distinct.push({ name: quote.rateList[index].rateDescription, checked: false, rateCode: quote.rateList[index].rateCode });
              uniqueKeys[quote.rateList[index].rateDescription] = quote.rateList[index].rateDescription;
            }
          }
        }
      });

      return distinct;
    };

    $scope.filters = {};
    $scope.filters.modes = $scope.getDistinctModes($scope.quoteResults);
    $scope.filters.carriers = $scope.getDistinctCarriers($scope.quoteResults);
    $scope.filters.accessorials = $scope.getDistinctAccessorials($scope.quoteResults);
    $scope.userPreferences = userPreferences;
    $scope.isMetric = $scope.userPreferences.unitOfMeasure === "metric";

    /**
     * Return to the Get A Quote V2 search screen. Passes in the rawQuoteParams so the form can be prefilled.
     *
     * @param event
     */
    $scope.editQuoteParams = function (event) {
      event.preventDefault();
      $state.go("app.getAQuote", {
        rawQuoteParams: $scope.rawQuoteParams,
        shipDate: $scope.getAQuoteParams.shipDate
      });
      analyticsService.track('quoteResults_edit');
    };

    $scope.getAddress = function (locationType) {
      var location = $scope.getAQuoteParams[locationType].address;

      if (location.addressLine1) {
        return location.addressLine1 + ",\n " + location.city + " " + location.stateProvince + " " + location.postalCode;
      }

      return location.postalCode + ", " + location.city + " " + location.stateProvince;
    };

    $scope.getDimensionMeasurement = function () {
      return $scope.isMetric ? "cm" : "in";
    };

    $scope.getEstimatedDeliveryDate = function (quote) {
      if (quote.transit && quote.transit.minimumDeliveryDate && quote.transit.maximumDeliveryDate) {
        return DateTimeService.getDisplayDate(quote.transit.minimumDeliveryDate) + " - "
          + DateTimeService.getDisplayDate(quote.transit.maximumDeliveryDate);
      } else if (quote.transit && quote.transit.minimumDeliveryDate) {
        return DateTimeService.getDisplayDate(quote.transit.minimumDeliveryDate);
      } else {
        return "N/A";
      }
    };

    $scope.getTransitTimeRange = function (quote) {
      if (quote.transit && !isNaN(quote.transit.minimumTransitDays) && !isNaN(quote.transit.maximumTransitDays)) {
        return quote.transit.minimumTransitDays + ' - ' + quote.transit.maximumTransitDays;
      } else if (quote.transit && !isNaN(quote.transit.minimumTransitDays)) {
        return quote.transit.minimumTransitDays;
      } else {
        return "N/A";
      }
    };

    $scope.getFormattedPickupDate = function () {
      return DateTimeService.getDisplayDate($scope.getAQuoteParams.shipDate);
    };

    $scope.changeQuoteSort = function (value) {
      $scope.sort = value;
      analyticsService.trackWithVar('quoteResults_Filter', 'quoteResults_FilterValue', "Switched to " + $scope.sort);
    };

    $scope.sortQuotesList = function (quote) {
      if ($scope.sort === "lowestPrice") {
        return quote.totalCharge;
      } else if ($scope.sort === "quickestDelivery") {
        // INC9219124 - Change Quoting Results Sort Logic #1231
        // Sorting based on delivery date and lowest price
        if (quote.transit && quote.transit.minimumDeliveryDate) {
          return DateTimeService.getDisplayDate(quote.transit.minimumDeliveryDate);
        } else {
          // This will move quotes that do not have estimated transit times to the bottom of the list of quotes.
          return Number.MAX_VALUE;
        }
      }
    };
    $scope.getTotalWeight = function (cargoLiability) {
      var totalWeight;
      totalWeight = 0;
      _.forEach($scope.getAQuoteParams.items, function (item) {
        if (item.weight) {
          if (item.weightUnitCode && item.weightUnitCode.toLowerCase() === 'kilograms' && cargoLiability) {
            totalWeight += Number((item.weight) * 2.2046);
          }
          else {
            totalWeight += Number(item.weight);
          }
        }
      });

      return totalWeight;
    };

    $scope.getweightUnitCode = function () {
      var weightUnitCode;
      if ($scope.getAQuoteParams.items[0].weightUnitCode && $scope.getAQuoteParams.items[0].weightUnitCode.toLowerCase() === 'kilograms') {
        weightUnitCode = "kgs";
      }
      else {
        weightUnitCode = "lbs";
      }
      return weightUnitCode;
    };

    $scope.getWeightMeasurement = function () {
      return $scope.isMetric ? "kgs" : "lbs";
    };

    $scope.limitChanged = function () {
      $scope.currentPage = Math.floor($scope.offset / $scope.limit) + 1;
      $scope.pageChanged();
    };

    $scope.pageChanged = function () {
      $scope.offset = ($scope.currentPage - 1) * $scope.limit;
    };

    $scope.toggleCheck = function (shareQuote) {
      shareQuote.checked = !shareQuote.checked;
    };

    $scope.refreshResults = function (filter) {
      $scope.filteredResults = [];
      $scope.selectedCarriers = [];
      $scope.filterParams = [];

      $scope.toggleCheck(filter);
      refreshFilterParams();
      $scope.filteredResults = FilterService.filterThorough($scope.quoteResults, $scope.filterParams);
      analyticsService.trackWithVar('quoteResults_Filter', 'quoteResults_FilterValue', filter.name + " filter " + ((filter.checked) ? "checked" : "unchecked"));

    };

    function refreshFilterParams() {
      $scope.getModeFilters();
      $scope.getCarrierFilters();
      $scope.getAccessorialFilters();
    }

    $scope.getModeFilters = function () {
      var modeFilters = [];

      _.forEach($scope.filters.modes, function (filter) {
        if (filter.checked) {
          modeFilters.push({
            transportModeDescription: $scope.getAbbreviatedTransportMode(filter.name)
          });
        }
      });

      if (modeFilters.length) {
        $scope.filterParams.push(modeFilters);
      }
    };

    $scope.getAccessorialFilters = function () {
      var accessorialFilters = {
        rateList: []
      };

      // Used to determine whether the charge breakdown should altered.
      $scope.rateListFiltersChecked = [];

      _.forEach($scope.filters.accessorials, function (filter) {
        if (filter.checked) {
          $scope.rateListFiltersChecked.push(filter.name);
          accessorialFilters.rateList.push({
            rateDescription: filter.name
          });
        }
      });

      if (accessorialFilters.rateList.length) {
        $scope.filterParams.push([accessorialFilters]);
      }
    };

    $scope.getCarrierFilters = function () {
      var carrierFilters = [];

      _.forEach($scope.filters.carriers, function (filter) {
        if (filter.checked) {
          carrierFilters.push({
            carrier: {
              carrierName: filter.name
            }
          })
        }
      });

      if (carrierFilters.length) {
        $scope.filterParams.push(carrierFilters);
      }
    };

    $scope.toggleCharges = function (quote) {
      quote.chargesOpen = !quote.chargesOpen;
      analyticsService.track('quoteResults_openedCharges');
    };

    $scope.accessorialSelected = function (accessorial) {
      $scope.refreshResults(accessorial);
      QuoteService.setAccessorialChecked({
        RateCode: accessorial.rateCode,
        QuoteRequestId: $scope.quoteRequestId,
        Checked: accessorial.checked
      });
    };

    $scope.getAccessorialChargeTotal = function (quote) {
      $scope.showAdditionalCharges = false;
      var additionalCharges = 0;

      _.forEach(quote.rateList, function (accessorial) {
        _.forEach($scope.rateListFiltersChecked, function (charge) {
          if (accessorial.rateDescription === charge && accessorial.isOptional) {
            additionalCharges += accessorial.totalRate;
          }
        });
      });

      if (additionalCharges) {
        $scope.showAdditionalCharges = true;
      }

      return quote.totalCharge + additionalCharges;
    };

    $scope.shouldShowChargeInBreakdown = function (rate) {
      var result = false;

      if (!rate.isOptional) {
        result = true;
      } else if (_.isEmpty($scope.rateListFiltersChecked)) {
        result = false;
      } else {
        result = _.includes($scope.rateListFiltersChecked, rate.rateDescription);
      }

      return result;
    };

    $scope.initiateQuoteToOrder = function (quote) {
      if (useNewQuoteToOrder()) {
        $window.location.href = appConfig.ordersUIBaseUrl + "/#/quoteToOrder/" + quote.quoteId;
        return;
      }

      quote.currencyCode = $scope.currencyCode;

      // Only relevant for contractual customers.
      // Transactional customers will not have any optional accessorials to filter.
      quote = filterOptionalAccessorials(quote);

      $state.go("app.quoteToOrder", {
        quote: quote,
        getAQuoteParams: $scope.getAQuoteParams,
        rawQuoteParams: $scope.rawQuoteParams,
        quoteResults: $scope.quoteResults,
        destination: $scope.getAddress("destination"),
        origin: $scope.getAddress("origin"),
        totalCharge: $scope.getAccessorialChargeTotal(quote),
        totalWeight: $scope.getTotalWeight(),
        quoteRequestId: $scope.quoteRequestId
      });
    };

    $scope.carrierNameDisplay = function (carrierName, quote) {
      if (!carrierName) {
        if ($scope.isTruckload(quote) || $scope.isFlatbed(quote)) {
          return "CH Robinson Truckload Services";
        } else {
          return "C.H. Robinson";
        }
      }

      return carrierName;
    };

    $scope.tlQuoteType = function (quote) {
      if (hasContractualRate(quote.rateList)) {
        return "Your Rate on File"
      } else {
        return "Market Rate"
      }
    }

    function useNewQuoteToOrder() {
      if ($scope.rawQuoteParams && $scope.rawQuoteParams.customer && $scope.rawQuoteParams.customer.useNewQuoteToOrder) {
        return $scope.rawQuoteParams.customer.useNewQuoteToOrder;
      }
      return false
    }

    function hasContractualRate (rateList) {
      var contractRate = false;
      _.forEach(rateList, function(rate) {
        if (rate.rateSource === "SQ" || rate.rateSource === "CM") {
          contractRate = true;
        }
      })
      return contractRate;
    }

    function isTruckloadResults(quoteResults) {
      var hasTruckload = false;
      var hasLTL = false;
      _.forEach(quoteResults, function (quote) {
        if ((quote.transportModeType && quote.transportModeType === 2) || quote.transportModeType === 12) {
          hasTruckload = true;
        } else {
          hasLTL = true;
        }
      });
      return (hasTruckload && !hasLTL);
    }

    function isTLHazmatResult() {
      return !!(($scope.rawQuoteParams.items && $scope.rawQuoteParams.items.length === 1 && $scope.rawQuoteParams.items[0].isHazardous === true) && $scope.isTruckloadOnlyResult);

    }

    function hasTeamResult() {
      var isTeam = false;
      if ($scope.getAQuoteParams.specialServiceList) {
        _.forEach($scope.getAQuoteParams.specialServiceList, function(service) {
          //EXD check for expedite/team rate
          if (service === "EXD") {
            isTeam = true;
          }
        });
      }

      _.forEach($scope.filteredResults, function(result) {
        if (result.specialServiceList) {
          _.forEach(result.specialServiceList, function(service) {
            //EXD check for expedite/team rate
            if (service === "EXD") {
              isTeam = true;
            }
          });
        }
      });
      return isTeam;
    }

    $scope.setTLHazmatShipButton = function() {
      if(($scope.rawQuoteParams.items && $scope.rawQuoteParams.items.length === 1 && $scope.rawQuoteParams.items[0].isHazardous === true) && $scope.isTruckloadOnlyResult) {
        return "disabled";
      }
      return "";
    }

    function filterOptionalAccessorials(quote) {
      var filteredAccessorials = [];

      _.forEach(quote.rateList, function (accessorial) {
        if (!accessorial.isOptional || _.includes($scope.rateListFiltersChecked, accessorial.rateDescription)) {
          filteredAccessorials.push(accessorial);
        }
      });

      quote.rateList = filteredAccessorials;

      return quote;
    }

    /**
     * It is not always the case that the currencyCode we're choosing will be the same as the rest of the currencyCodes in all the other quotes.
     * That said, it is rare they will differ, and at the time of writing this code we had no better way of finding out.
     */
    function setCurrencyCode() {
      if ($scope.quoteResults.length) {
        if ($scope.quoteResults[0].rateList[0] && $scope.quoteResults[0].rateList[0].currencyCode) {
          $scope.currencyCode = $scope.quoteResults[0].rateList[0].currencyCode;
        } else {
          $scope.currencyCode = "USD";
        }
      }
    }

    /**
     * Defaults carrier name to "C.H. Robinson" if there is no carrier.
     *
     * @param quoteResults
     */
    function setDefaultCarrierInfo(quoteResults) {
      _.forEach(quoteResults, function (quote) {
        if (!quote.carrier) {
          quote.carrier = {};
        }

        if (!quote.carrier.carrierCode) {
          quote.carrier.carrierCode = null;
        }
      });
    }

    $scope.showDateRecommenderQuoteLabel = function (quote) {
      return !!$scope.dateRecommenderQuotes &&
        ($scope.dateRecommenderQuotes.requestedDateQuote === quote ||
          $scope.dateRecommenderQuotes.asapPickupQuote === quote ||
          $scope.dateRecommenderQuotes.bestAlternativeQuote === quote);
    };

    $scope.getDateRecommenderQuoteLabel = function (quote) {
      var quoteLabel = '';

      if (!$scope.dateRecommenderQuotes || !quote.transit || !quote.transit.minimumPickupDate) {
        return quoteLabel;
      }

      var displayShortDate = DateTimeService.getDisplayShortDate(quote.transit.minimumPickupDate);

      if (quote === $scope.dateRecommenderQuotes.requestedDateQuote) {
        quoteLabel = "Requested Pickup - " + displayShortDate;
      } else if (quote === $scope.dateRecommenderQuotes.asapPickupQuote) {
        quoteLabel = "ASAP Pickup - " + displayShortDate;
      } else if (quote === $scope.dateRecommenderQuotes.bestAlternativeQuote) {
        quoteLabel = "Best Alternative Pickup - " + displayShortDate;
      }

      return quoteLabel;
    }

    function getDateRecommenderRequestedDateQuote(quotes) {
      return _.find(quotes, function (quote) {
        return !!quote.transit &&
          !!quote.transit.minimumPickupDate &&
          DateTimeService.areDatesEqual($scope.getAQuoteParams.shipDate, quote.transit.minimumPickupDate);
      });
    }

    function getDateRecommenderAsapPickupQuote(quotes, requestedDateQuote) {
      if (!requestedDateQuote || !requestedDateQuote.transit || !requestedDateQuote.transit.minimumPickupDate) {
        return null;
      }

      var earliestPickupQuote = getEarliestPickupQuote(quotes, requestedDateQuote);

      return !!earliestPickupQuote &&
        !!earliestPickupQuote.transit &&
        !!earliestPickupQuote.transit.minimumPickupDate &&
        DateTimeService.isDateBefore(earliestPickupQuote.transit.minimumPickupDate, requestedDateQuote.transit.minimumPickupDate)
          ? earliestPickupQuote
          : null;
    }

    function getEarliestPickupQuote(allQuotes, requestedDateQuote) {
      var quotes = _.filter(allQuotes, function (quote) {
        return !!quote.transit && !!quote.transit.minimumPickupDate && quote !== requestedDateQuote;
      });

      if (!quotes || quotes.length === 0) {
        return null;
      }

      var sortedQuotes = _.sortBy(quotes, function (quote) {
        return DateTimeService.getDisplayDate(quote.transit.minimumPickupDate);
      });

      return sortedQuotes[0];
    }

    function getDateRecommenderBestAlternativeQuote(quotes, requestedDateQuote, asapPickupQuote) {
      if (!requestedDateQuote) {
        return null;
      }

      return _.find(quotes, function (quote) {
        return quote !== requestedDateQuote && quote !== asapPickupQuote;
      });
    }

    function isTransactionalRate(rate) {
      return rate.rateSource === 'Transactional';
    }

    function isTransactionalQuote(quote) {
      return !!quote.rateList && _.some(quote.rateList, isTransactionalRate);
    }

    function getDateRecommenderQuotes(quoteResults) {
      var dateRecommenderQuotesBreakDown = {};

      if (!isTruckloadResults(quoteResults)) {
        return dateRecommenderQuotesBreakDown;
      }

      var transactionalQuotes = _.filter(quoteResults, isTransactionalQuote);

      if (!transactionalQuotes || transactionalQuotes.length === 0) {
        return dateRecommenderQuotesBreakDown;
      }

      var requestedDateQuote = getDateRecommenderRequestedDateQuote(transactionalQuotes);
      dateRecommenderQuotesBreakDown.requestedDateQuote = requestedDateQuote;

      var asapPickupQuote = getDateRecommenderAsapPickupQuote(transactionalQuotes, requestedDateQuote);
      dateRecommenderQuotesBreakDown.asapPickupQuote = asapPickupQuote;

      var bestAlternativeQuote = getDateRecommenderBestAlternativeQuote(transactionalQuotes, requestedDateQuote, asapPickupQuote);
      dateRecommenderQuotesBreakDown.bestAlternativeQuote = bestAlternativeQuote;

      return dateRecommenderQuotesBreakDown;
    }
  }

  app.controller("getAQuoteResultsController", getAQuoteResultsController);
})();

(function () {
  'use strict';
  getAQuoteCustomerController.$inject = ['$q', '$scope', 'AddressService', 'BolCommentService', 'CustomerPartyService', 'ModalService', 'QuoteService', 'AdobeAnalyticsService'];
  function getAQuoteCustomerController($q, $scope, AddressService, BolCommentService, CustomerPartyService, ModalService, QuoteService, AdobeAnalyticsService) {
    var modalOptions = {
      closeButtonText: 'NO_KEEP_ACCOUNT',
      actionButtonText: 'YES_I_AM_SURE',
      headerText: 'ARE_YOU_SURE_YOU_WANT_TO_CHANGE_YOUR_ACCOUNT',
      bodyText: 'ALL_INFORMATION_ENTERED_FOR_THIS_ACCOUNT_WILL_BE_R'
    };

    /**
     * Prompts the user before changing the customer. Clears form properties specific to the old customer on "ok"
     *
     * @returns {Promise.<Boolean>}
     */
    function customerChanged() {
      var deferred = $q.defer();

      if ($scope.order.customer && $scope.isFormAltered()) {
        ModalService.showModal({}, modalOptions).then(function (result) {
          if (result === 'ok') {
            $scope.order.pickup = null;
            $scope.order.deliver = null;
            $scope.setModeType('ltl', false);
            deferred.resolve(true);
          }

          if (result === 'cancel') {
            deferred.resolve(false);
          }
        }, function (result) {
          if (result === 'cancel') {
            deferred.resolve(false);
          }
        });
      } else {
        $scope.setModeType('ltl', false);
        deferred.resolve(true);
      }

      return deferred.promise;
    }

    $scope.onSelectedDropDownCustomerChange = function (cust) {
      if (!_.isEqual(cust, $scope.order.customer)) {
        customerChanged().then(function (changed) {
          if (changed) {
            angular.element('input[name=customerRecentList]').attr('checked', false);
            $scope.order.customer = cust;
            BolCommentService.get($scope.order.customer);

            $scope.isCustomerTransactional(cust.partyCode, function() {
              /*
              Because truckload is turned on for all customers
              items need to be cleared between every customer change
              */
              $scope.order.items = [];
              $scope.addNewItem();
              $scope.order.isItemAltered = false;

              if ($scope.isNewlyTransactional) {
                $scope.isNewlyTransactional = false;
                setItemsToDry();
              }
            });
            AdobeAnalyticsService.gaqFormSelected($scope.user, 'LTL');
          } else {
            $scope.dropDownCustomer.selected = $scope.order.customer;
          }
        });
      }
    };

    $scope.isCustomerTransactional = function(customerCode, callback) {
      QuoteService.getTransactionalPricingFlag({ customerCode: customerCode }).$promise.then(function(result) {
        if (!$scope.order.isTransactional && !result.isTransactional) {
          $scope.isNewlyTransactional = true;
        }

        $scope.order.isTransactional = !result.isTransactional;
        $scope.$parent.setDatePickerOptions($scope.order.isTransactional);

        callback();
      });
    };

    function setItemsToDry() {
      _.forEach($scope.itemDdlRefData.TemperatureSensitive, function(tempType) {
        _.forEach($scope.order.items, function(item) {
          if (tempType.refDataNumber === 425) {
            item.tempCategory = tempType;
          }
        });
      });
    }

    function selectNewCustomer(cust) {
      $scope.dropDownCustomer.selected = cust;
      $scope.order.customer = cust;
      CustomerPartyService.getBOLComment({
        partyNumberOrCode: cust.partyNumber
      }, function (response) {
        $scope.order.customer.bolComment = response.bolComment;
      });
    }

    /**
     * Preps each customer for proper display in the view.
     */
    function getCustomers() {
      $scope.customers = $scope.$parent.createQuoteCustomers.customers;

      _.forEach($scope.customers, function (cust) {
        cust['addressLine1'] = AddressService.GetAddressLine1(cust.address);
        cust['addressLine2'] = AddressService.GetAddressLine2(cust.address);
        cust['addressLine3'] = AddressService.GetAddressLine3(cust.address);
        cust['addressLine4'] = AddressService.GetAddressLine4(cust.address);
        cust['displayName'] = $scope.$parent.getDisplayName(cust);
      });
    }

    function isSingleCCode() {
      return $scope.$parent.createQuoteCustomers.customers.length === 1;
    }

    function assignSingleCCode() {
      if (isSingleCCode()) {
        selectNewCustomer($scope.$parent.createQuoteCustomers.customers[0]);
      }
    }

    assignSingleCCode();
    getCustomers();
  }

  angular.module('NavisphereOnline').controller('getAQuoteCustomerController', getAQuoteCustomerController);
}());

(function () {
  'use strict';
  var app = angular.module("NavisphereOnline");

  getAQuoteController.$inject = ['$rootScope', '$locale', 'API_BASE_URL', '$http', '$scope', '$stateParams', '$timeout', '$uibModal', '$log', 'analyticsService',
    'createQuoteCustomers', 'CustomerService', 'DateTimeService', 'GAQService', 'LocationService',
    'LocationSelectionHelperService', 'QuoteService', 'refDataDDLs', 'UnitsOfMeasurementService', 'user', 'User', 'userPreferences', "ServiceOffering",
    'RefDataMappingService', 'AdobeAnalyticsService', 'QuoteHistoryTransformService', 'QuoteHistoryService'];
  function getAQuoteController($rootScope, $locale, API_BASE_URL, $http, $scope, $stateParams, $timeout, $uibModal, $log, analyticsService,
    createQuoteCustomers, CustomerService, DateTimeService, GAQService, LocationService,
    LocationSelectionHelperService, QuoteService, refDataDDLs, UnitsOfMeasurementService, user, User,
    userPreferences, ServiceOffering, RefDataMappingService, AdobeAnalyticsService, QuoteHistoryTransformService, QuoteHistoryService) {
    $scope.dropDownCustomer = {
      selected: undefined
    };
    var requestTypeLtl = "LTL";
    var requestTypeTruckload = "Truckload";
    var requestTypeFlatbed = "Flatbed";

    $scope.format = $locale.DATETIME_FORMATS['shortDate'];
    $scope.itemDdlRefData = refDataDDLs;
    $scope.itemSummary = {};
    $scope.refDataDDLs = refDataDDLs;
    $scope.noQuotesFound = $stateParams.noQuotesFound;
    $scope.pastRateTime = false;
    $scope.showNoHighValueMessage = false;
    $scope.showNoZeroDollarTLMessage = false;
    $scope.createQuoteCustomers = createQuoteCustomers;
    $scope.retrievingQuote = false;
    $scope.user = user;
    $scope.userPreferences = userPreferences;
    $scope.isMetric = $scope.userPreferences.unitOfMeasure === 'metric';
    $scope.temperatureOptions = $scope.itemDdlRefData["TemperatureSensitive"];
    $scope.freightClassOptions = $scope.itemDdlRefData["FreightClass"];
    $scope.order = GAQService.setInitialOrderState();
    $scope.getDisplayName = CustomerService.GetDisplayName;
    $scope.addNewItem = addNewItem;
    $scope.setDimensionValues = setDimensionValues;
    $scope.deleteItem = deleteItem;
    $scope.refreshLocations = refreshLocations;
    $scope.setDatePickerOptions = setDatePickerOptions;
    $scope.isFreightClassRequired = true;
    $scope.isHazardousClick = function (item) {
      item.isHazardous = !item.isHazardous;
    };
    $scope.isTeamClick = function () {
      $scope.order.isTeam = !$scope.order.isTeam;
    }
    $scope.requestType = requestTypeLtl;
    $scope.isLTL = true;
    $scope.ratingRequest = null;

    var cmUomRefNum = RefDataMappingService.getItemId('CENTIMETERS_UOM');
    var inUomRefNum = RefDataMappingService.getItemId('INCHES_UOM');

    var parsedRequestId = parseInt($stateParams.requestId);


    //Check if reQuote path and get request info from Rating
    if (!isNaN(parsedRequestId)) {
      QuoteService.getQuoteDetails({ quoteRequestId: parsedRequestId }).$promise.then(setOrderFromExistingRequest);
    } else {
      runFinalRequestSetupFunctions();
    }

    function setOrderFromExistingRequest(ratingRequest) {
      $scope.requestType = getRequestTypeFromQuoteDetails(ratingRequest.quoteDetailList)
      $scope.isLTL = ($scope.requestType === requestTypeLtl);
      // Get user customers
      User.getQuoteCustomers().$promise.then(function (customerResult) {
        // Transform Rating request data and user customers
        return QuoteHistoryTransformService.transform(ratingRequest, customerResult.customers, $scope.itemDdlRefData)
      }).then(function(transformedQuote) {
        // Create request from transformed quote data
        return QuoteHistoryService.buildParams(transformedQuote, $stateParams.requestId,  $scope.isMetric, true);
      }).then(function (params) {
        // Merge built request with the blank order
        _.merge($scope.order, params.rawQuoteParams);
        runFinalRequestSetupFunctions();
      });
    }

    function runFinalRequestSetupFunctions() {
      getCustomersWithGAQ();
      setUnitCodes();
      removeUnsupportedTempTypes();
      prefillGAQForm();
      setPickupDateWithShipDateFromResultEdit();
      setDatePickerOptions();
      setDimensionValues();
      resetTeam();
    }

    function addNewItem() {
      $scope.order.items.push(generateItem());
    }

    function deleteItem(index) {
      if ($scope.order.items.length > 0) {
        $scope.order.items.splice(index, 1);
      }

      if ($scope.order.items.length < 1) {
        $timeout(function () {
          $scope.quoteForm.$invalid = true;
        });
      }
    }

    function refreshLocations(locationResults, locationType) {
      $scope[locationType + "LocationResults"] = [];

      if (locationResults.search.length < 3) {
        return [];
      }

      return LocationService.getCities({
        zipCode: locationResults.search
      }, function (data) {
        $scope[locationType + "LocationResults"] = data;

        if (data.length === 1) {
          locationResults.select(data[0], true);
        }
      });
    }


    $scope.onLocationSelected = function (item, locationType) {
      $scope.order[locationType] = LocationSelectionHelperService.restructureLocation(item);
    };
    $scope.getLocationDisplay = function (location) {
      if (location) {
        $scope.setFreightClassRequirement($scope.order);
        if (!location.name && !location.adminDistrictCode && !location.countryCode && !location.postalCode) {
          return location.address.addressLine1 + ', ' + location.address.stateProvince + ', ' + location.address.country + ', ' + location.address.postalCode
        }
        else {
          return location.name + ', ' + location.adminDistrictCode + ' ' + location.countryCode + ' ' + location.postalCode;
        }
      }

      return "";
    };

    $scope.setFreightClassRequirement = function (order) {
      if (order.pickup && order.deliver) {
        var pickupCountryCode = order.pickup.countryCode;
        var deliverCountryCode = order.deliver.countryCode;
        var canadaCountryCode = 'CA';
        if (pickupCountryCode === canadaCountryCode && deliverCountryCode === canadaCountryCode) {
          $scope.isFreightClassRequired = false;
        } else {
          $scope.isFreightClassRequired = true;
        }
      }
    }

    $scope.openPickupDate = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.pickupDateOpened = true;
    };

    $scope.openAddressBook = function ($event, locationType) {
      analyticsService.trackWithVar('addressBook', 'addressBookValue', "addressBook clicked for" + " " + locationType);
      $event.preventDefault();
      $event.stopPropagation();
      $uibModal.open({
        templateUrl: 'app/getAQuote/views/selectAddress.tpl.html',
        size: 'lg',
        controller: 'selectAddressController',
        scope: $scope,
        resolve: {
          customerCode: function () {
            if ($scope.order.customer) {
              return $scope.order.customer.partyCode.replace(/^\s+|\s+$/gm, '');
            }

            return "";
          },
          user: function () {
            return $scope.user;
          },
          locationType: function () {
            return locationType;
          }
        }
      }).result.then(function (location) {
        $scope.order[locationType] = location;
      });
    };

    /**
     * The search employed by address book requires a customer's partyCode.
     *
     * @returns {boolean}
     */
    $scope.isAddressBookDisabled = function () {
      return !$scope.order.customer;
    };

    $scope.showTruckloadLTLButtons = function () {
      return !!($scope.order && $scope.order.customer);
    };

    function clearFieldsOnFormChange() {
      if ($scope.order) {
        var initialOrder = GAQService.setInitialOrderState();
        $scope.order.overallAccessorials = initialOrder.overallAccessorials;
        $scope.order.originAccessorials = initialOrder.originAccessorials;
        $scope.order.destinationAccessorials = initialOrder.destinationAccessorials;
        $scope.order.items = initialOrder.items;
        $scope.addNewItem();
      }
    }

    $scope.isRequiredForTLAndFB = function (existingValue) {
      if (!$scope.isLTL) {
        return false;
      } else {
        return existingValue;
      }
    };

    $scope.itemsNoResults = false;
    $scope.maxSearchResultLimit = 250;

    $scope.getQuote = function () {
      $scope.showNoHighValueMessage = false;
      $scope.showNoZeroDollarTLMessage = false;

      if ($scope.order && !$scope.isLTL && ($scope.order.items[0].totalInsuranceValue < 1 || $scope.order.items[0].totalInsuranceValue > 100000)) {
        if ($scope.order.items[0].totalInsuranceValue > 100000) {
          $scope.showNoHighValueMessage = true;
        } else if ($scope.order.items[0].totalInsuranceValue < 1) {
          $scope.showNoZeroDollarTLMessage = true;
        }
        return;
      }

      _.forEach($scope.order.items, function (item) {
        item.length = item.unitLength.value;
        item.width = item.unitWidth.value;
        item.height = item.unitHeight.value;
      });

      $scope.retrievingQuote = true;
      GAQService.getQuote($scope.order, $scope.user, $scope.isMetric, "getAQuote", $scope.requestType);

      AdobeAnalyticsService.gaqFormSubmitted($scope.user, submittedRequestType());

      analyticsService.trackWithMultipleVars('getAQuote',
        {
          'getAQuote_Account': $scope.order.customer.displayName,
          'getAQuote_PickupDate': $scope.order.pickupDate,
          'getAQuote_Origin': $scope.order.pickup.postalCode,
          'getAQuote_Destination': $scope.order.deliver.postalCode,
          'getAQuote_CommoditiesQuantity': $scope.order.items.length
        });
    };

    $scope.$on("noQuotesFound", function () {
      $scope.noQuotesFound = true;
      $scope.retrievingQuote = false;
    });

    /**
     *
     * Checks if the parts of the getAQuote form that are specific to the selected customer have been altered.
     *
     * @returns {boolean|undefined}
     */
    $scope.isFormAltered = function () {
      var conditions, flag;

      conditions = [
        $scope.order.pickup,
        $scope.order.deliver,
        $scope.order.items.length > 1,
        $scope.order.isItemAltered
      ];

      _.forEach(conditions, function (condition) {
        if (condition && !flag) {
          flag = true;
        }
      });

      return flag;
    };

    $scope.getWeightMeasurement = function () {
      return $scope.isMetric ? "kgs" : "lbs";
    };

    $scope.getWeightUnitCode = function (item) {
      var weightUnitCode;
        if (item && item.weightUnitCode && item.weightUnitCode.toLowerCase() === 'kilograms') {
          weightUnitCode = "kgs";
        }
        else {
          weightUnitCode = "lbs";
        }
        return weightUnitCode;
    };

    //TODO: move this case into UnitsOfMeasurementService
    //case: no catalog commodity but need to set UOM
    $scope.getDimensionMeasurement = function (item) {
      if (!item) {
        item = {};
      }
      if (!item.unitLength || !item.unitWidth || !item.unitHeight) {
        item.unitLength = {};
        item.unitWidth = {};
        item.unitHeight = {};
      }
      if ($scope.isMetric) {
        item.unitLength.unitRDN = cmUomRefNum;
        item.unitWidth.unitRDN = cmUomRefNum;
        item.unitHeight.unitRDN = cmUomRefNum;
        item.lengthCmUomLabel = "cm";
        return "cm";
      }
      else {
        item.unitLength.unitRDN = inUomRefNum;
        item.unitWidth.unitRDN = inUomRefNum;
        item.unitHeight.unitRDN = inUomRefNum;
        item.lengthCmUomLabel = "in";
        return "in";
      }
    };

    $scope.toggleCheck = function (accessorial) {
      accessorial.checked = !accessorial.checked;
    };

    $scope.isGreyedOut = function (property) {
      return property ? "" : "disabled";
    };

    $scope.setDropdownSize = function () {
      var itemSearchInput = angular.element('#itemSearchInput');
      var dropdownMenu = angular.element('#itemSearchInput + .dropdown-menu');
      var newWidth = (itemSearchInput.width() + parseInt(itemSearchInput.css('padding-left')) + parseInt(itemSearchInput.css('padding-right'))) + 'px';
      dropdownMenu.css('width', newWidth);
    };

    function getCustomersWithGAQ() {
      User.getQuoteCustomers().$promise.then(function (result) {
        var customers = result.customers;

        for (var i = 0; i < customers.length; i++) {
          customers[i].displayName = CustomerService.GetDisplayName(customers[i]);
        }
        $scope.customersWithGaQ = customers;

        if ($scope.customersWithGaQ.length === 1) {
          QuoteService.getTransactionalPricingFlag({ customerCode: $scope.customersWithGaQ[0].partyCode }).$promise.then(function (result) {
            $scope.order.isTransactional = !result.isTransactional;
            setDatePickerOptions($scope.order.isTransactional);

            $scope.account = $scope.customersWithGaQ[0];
            if ($scope.order.items.length === 0) {
              $scope.addNewItem();
            }
          });
        }
      });
    }

    function removeUnsupportedTempTypes() {
      $scope.temperatureOptions = _.remove($scope.temperatureOptions, function (temp) {
        return temp.refDataCode === "Mixed" || temp.refDataCode === "Produce";
      });
    }

    function prefillGAQForm() {
      if ($stateParams.rawQuoteParams) {
        if ($stateParams.rawQuoteParams.items) {
          for (var i = 0; i < $stateParams.rawQuoteParams.items.length; i++) {
            if ($stateParams.rawQuoteParams.items[i].isHazardous) {
              $stateParams.rawQuoteParams.items[i].readOnlyProperties = {};
              $stateParams.rawQuoteParams.items[i].readOnlyProperties.isHazardous = true;
            }
          }
        }
        angular.merge($scope.order, $stateParams.rawQuoteParams);
        $scope.dropDownCustomer.selected = $scope.order.customer;
      }
    }

    function generateItem() {
      var item = {
        commodity: {
          isHazardous: false
        },
        isStackable: null, // This will set no default selection  for the radio button
        linearUnitCode: $scope.linearUnitCode,
        weightUnitCode: $scope.weightUnitCode
      };

      if ($scope.order.isTransactional || !$scope.isLTL) {
        _.forEach($scope.itemDdlRefData.TemperatureSensitive, function (tempType) {
          if (tempType.refDataNumber === 425) {
            item.tempCategory = tempType;
          }
        });
      }

      return item;
    }
    function setDimensionValues() {
      _.forEach($scope.order.items, function (item) {
        // check item.unitlength, itemunitWidt, item.unitLength before asssign emppty to avoid override other propery
        if (!item.unitLength) {
          item.unitLength = {};
        }
        if (!item.unitWidth) {
          item.unitWidth = {};
        }
        if (!item.unitHeight) {
          item.unitHeight = {};
        }
        item.unitLength.value = item.length;
        item.unitWidth.value = item.width;
        item.unitHeight.value = item.height;
      });
    }

    function setDatePickerOptions(isTransactional) {
      var maxDays = 14;
      if (isTransactional === false && $scope.isLTL) {
        maxDays = 183
      }

      var todayDate = DateTimeService.getToday();
      var minDate = DateTimeService.getToday();
      var maxDate = DateTimeService.getDateAddDays(maxDays, DateTimeService.getToday());

      $scope.pastRateTime = false;
      if ($scope.isLTL) {
        $scope.pickupDateOptions = {
          showWeeks: false,
          minDate: minDate,
          maxDate: maxDate
        };
      }

      if ($scope.order && $scope.order.customer && !$scope.isLTL
          && $scope.order.pickupDate.getDate() === todayDate.getDate() &&
          DateTimeService.isLocalTimePastTwoPMEastern($scope.order.pickupDate)) {

        // if today is Friday after 2PM EDT, move to next week monday, else move to tmrw
        var moveDateBy = todayDate.getDay() === 5 ? 3 : 1;

        $scope.order.pickupDate = DateTimeService.getDateAddDays(moveDateBy, todayDate);
        $scope.pastRateTime = true;
        $scope.pickupDateOptions = {
          showWeeks: false,
          minDate: DateTimeService.getDateAddDays(moveDateBy, minDate),
          maxDate: DateTimeService.getDateAddDays(moveDateBy, maxDate)
        };
      }
    }

    function setUnitCodes() {
      if ($scope.isMetric) {
        $scope.weightUnitCode = "kilograms";
        $scope.linearUnitCode = "centimeters";
      } else {
        $scope.weightUnitCode = "pounds";
        $scope.linearUnitCode = "inches";
      }
    }

    $scope.showFreightInfoModal = function () {
      $uibModal.open({
        templateUrl: 'app/common/views/showFreightInfo.tpl.html',
        size: 'md',
        controller: 'showInfoController'
      });
    };

    $scope.displayIncompleteFieldsMessage = function (item) {
      $scope.freightClassFieldsIncompleteMessage = "";
      var message = buildFreightClassMessage(item);
      $scope.freightClassFieldsIncompleteMessage = getIncompleteFieldMessage(message);
    };

    function buildFreightClassMessage(item) {
      return {
        weight: item.weight ? '' : 'Enter Total Weight',
        quantity: item.quantity ? '' : 'Enter Packaging Quantity',
        pickupLocation: $scope.order.pickup ? '' : 'Enter Origin Location',
        deliverLocation: $scope.order.deliver ? '' : 'Enter Destination Location',
        isStackable: item.isStackable !== null ? '' : 'Enter Packaging can be stacked',
        dimensions: item.unitHeight.value && item.unitLength.value && item.unitWidth.value ? '' : 'Enter Packaging Dimensions'
      }
    }

    function getIncompleteFieldMessage(message) {
      var messages = [];
      Object.keys(message).forEach(function (key) {
        if (message[key]) {
          messages.push(message[key]);
        }
      })

      return messages.join('\n');
    }

		/*  The pickup and deliver address fields on the order may
		 *  be entered after the required fields to calculate the density based
		 *	suggestion are entered. Therefore they are been watch for changes.
		 */
    $scope.$watchCollection("[order.pickup, order.deliver]", function () {
      var order = $scope.order;
      if (order.items.length && order.pickup && order.deliver) {
        order.items.forEach(function (item) {
          $scope.getDensityBasedSuggestion(item);
        })
      }
    });

    $scope.getItemFromOrderItemsController = $rootScope.$on('getDensityBasedSuggestion', function ($event, item) {
      $scope.getDensityBasedSuggestion(item);
      $event.stopPropagation();
    });

    $scope.getDensityBasedSuggestion = function (item) {
      setItemTemporaryProperties(item);
      var requestPayload = getFreightClassRequestPayload(item);
      item._temporaryFreightClassFieldsComplete = validateRequestPayload(requestPayload);
      if (item._temporaryFreightClassFieldsComplete) {
        item._temporaryIsLoading = true;
        $scope.getCalculatedFreightClass(requestPayload, item, function (result) {
          item._temporaryIsLoading = false;
          if (result.data && result.data.freightClass) {
            item._temporarySuggestedFreightClass = result.data.freightClass;
          } else {
            displayWarningMessage(item);
          }
        })
      }
    }

		/*  These are temporary properties been added to an item
		 *  in order to facilitate tracking them individually
		 *	and will be deleted prior to submitting the quote to the API
		 */
    function setItemTemporaryProperties(item) {
      if (item) {
        item._temporaryIsLoading = false,
          item._temporarySuggestedFreightClass = null,
          item._temporaryFreightClassErrorMessage = "",
          item._temporaryFreightClassFieldsComplete = false
      }
    }

    function getFreightClassRequestPayload(item) {
      return {
        Height: getItemHeight(item),
        TotalWeight: item.weight ? item.weight : null,
        Quantity: item.quantity ? item.quantity : null,
        LinearUnit: item.linearUnitCode ? item.linearUnitCode : null,
        WeightUnit: item.weightUnitCode ? item.weightUnitCode : null,
        ShipmentDate: $scope.order.pickupDate ? $scope.order.pickupDate : null,
        Width: item.unitWidth && item.unitWidth.value ? item.unitWidth.value : null,
        Length: item.unitLength && item.unitLength.value ? item.unitLength.value : null,
        OriginCountryCode: $scope.order.pickup ? $scope.order.pickup.countryCode : null,
        CustomerCode: $scope.order.customer.partyCode ? $scope.order.customer.partyCode : null,
        DestinationCountryCode: $scope.order.deliver ? $scope.order.deliver.countryCode : null
      }
    }

    function getItemHeight(item) {
      if (item.unitHeight && item.unitHeight.value && item.isStackable !== null) {
        return (!item.isStackable && $scope.order.isTransactional ? getAdjustedHeight(item) : item.unitHeight.value);
      }

      return null;
    }

    function getAdjustedHeight(item) {
      var height = item.unitHeight.value;
      var unitCode = item.linearUnitCode;
      var adjustedHeight;

      switch (unitCode) {
        case 'inches':
          adjustedHeight = 96;
          break;
        case 'centimeters':
          adjustedHeight = 243.84;
          break;
        case 'meters':
          adjustedHeight = 2.4384;
          break;
        case 'feet':
          adjustedHeight = 8;
          break;
        default:
          adjustedHeight = height;
      }

      return adjustedHeight;
    }

    function validateRequestPayload(requestPayload) {
      return Object.keys(requestPayload).every(function (key) {
        return requestPayload[key] !== null;
      });
    }

    function setPickupDateWithShipDateFromResultEdit() {
      if ($stateParams.shipDate && DateTimeService.isValidDate($stateParams.shipDate)) {
        var shipDate = new Date($stateParams.shipDate);
        if ($stateParams.shipDate.includes("T")) {
          shipDate = DateTimeService.getRawDateTime($stateParams.shipDate);
        }

        $scope.order.pickupDate = shipDate;
      }
    }

    $scope.getCalculatedFreightClass = function (requestPayload, item, callback) {
      var url = API_BASE_URL + 'api/Rating/v1/Calculate/FreightClass';
      $http.post(url, requestPayload).then(function (result) {
        return callback(result);
      },
        function (error) {
          displayWarningMessage(item);
          item._temporaryIsLoading = false;
          $log(error);
        })
    }

    function displayWarningMessage(item) {
      item._temporaryFreightClassErrorMessage =
        'Density based suggestion could not be calculated.';
    }

    $scope.useSuggestedFreightClass = function (item) {
      $scope.freightClassOptions.forEach(function (option) {
        if (Number(option.value) === item._temporarySuggestedFreightClass) {
          item.freightClass = option;
        }
      })
    }

    $scope.setModeType = function (mode, sendAdobeEvent) {
      if (mode === 'ltl') {
        $scope.requestType = requestTypeLtl;
        $scope.isLTL = true;
        resetTeam();
        if($scope.order && $scope.order.customer && sendAdobeEvent) {
          AdobeAnalyticsService.gaqFormSelected($scope.user, 'LTL')
        }
      } else if (mode === 'tl') {
        $scope.requestType = requestTypeTruckload;
        $scope.isLTL = false;
        if($scope.order && $scope.order.customer && sendAdobeEvent) {
          AdobeAnalyticsService.gaqFormSelected($scope.user, 'TL')
        }
      } else {
        $scope.requestType = requestTypeFlatbed;
        $scope.isLTL = false;
        if($scope.order && $scope.order.customer && sendAdobeEvent) {
          AdobeAnalyticsService.gaqFormSelected($scope.user, 'FB')
        }
        checkNonLTLDateTime();
      }
      clearFieldsOnFormChange();
      setDatePickerOptions($scope.order.isTransactional);
    };

    $scope.setSelectedBox = function (mode) {
      if (mode === 'ltl' && $scope.requestType === requestTypeLtl) {
        return true;
      } else if (mode === 'tl' && $scope.requestType === requestTypeTruckload) {
        return true;
      } else if (mode === 'fb' && $scope.requestType === requestTypeFlatbed) {
        return true;
      } else {
        return false;
      }
    };

    $scope.getServiceOfferingImageUrl = function (serviceOfferingNumber) {
      return ServiceOffering.get(serviceOfferingNumber);
    };

    function resetTeam() {
      $scope.order.isTeam = false;
    }

    function submittedRequestType() {
      switch ($scope.requestType) {
        case requestTypeLtl: return 'LTL';
        case requestTypeTruckload: return 'TL';
        case requestTypeFlatbed: return 'FB';
        default: return ''
      }
    }

    function checkNonLTLDateTime() {
      if ($scope.order.pickupDate > DateTimeService.getDateAddDays(14, DateTimeService.getToday())) {
        $scope.order.pickupDate = DateTimeService.getToday();
      }
    }

    function getRequestTypeFromQuoteDetails(quoteDetailList) {
      var truckloadQuotes = 0;
      var flatbedQuotes = 0;
      var ltlQuotes = 0;
      var requestType = "";

      _.forEach(quoteDetailList, function(quoteDetail) {
        if(quoteDetail.transportModeType === 12) {
          flatbedQuotes++;
        } else if(quoteDetail.transportModeType === 2) {
          truckloadQuotes++;
        } else {
          ltlQuotes++;
        }
      });

      if (truckloadQuotes > 0 && flatbedQuotes === 0 && ltlQuotes === 0) {
        requestType = requestTypeTruckload;
      } else if (truckloadQuotes === 0 && flatbedQuotes > 0 && ltlQuotes === 0) {
        requestType = requestTypeFlatbed;
      } else {
        requestType = requestTypeLtl;
      }
      return requestType;
    }

  }
  app.controller('getAQuoteController', getAQuoteController);
})();

(function () {
  'use strict';
  emailQuoteController.$inject = ['$scope', '$uibModalInstance', 'quoteRequestId', 'quoteIds','QuoteService', '$uibModal', 'user'];
  function emailQuoteController($scope, $uibModalInstance, quoteRequestId, quoteIds, QuoteService, $uibModal, user) {
    $scope.replyTos = [user.email];
    $scope.docs = [{description: "Quote"}];

    $scope.close = function () {
      $uibModalInstance.dismiss('close');
    };
    function showConfirmation() {
      $uibModalInstance.dismiss('sent');
      $uibModal.open({
        templateUrl: 'app/common/views/emailConfirmation.tpl.html',
        size: 'lg',
        controller: 'emailConfirmationController'
      });
      $scope.processing = false;
    }

    $scope.processing = false;
    $scope.send = function () {
      $scope.processing = true;

      var toAddys = $scope.to.split(';');

      QuoteService.sendEmail({
        quoteRequestId: quoteRequestId,
        quoteIds: quoteIds,
        replyTos: $scope.replyTos,
        to: toAddys,
        message: $scope.message
      }).$promise.then(function () {
        showConfirmation();
      });
    };

  }
  angular.module('NavisphereOnline').controller('emailQuoteController', emailQuoteController);
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');

    function footerController($scope, applicationVersion) {
      $scope.applicationVersion = applicationVersion;
      $scope.date = new Date();
      $scope.showFooter = function(){
      	var url = window.location.href;
      	if(url.indexOf('map') > -1){
      		return false;
      	}
      	return true;
      }
    }
    footerController.$inject = ['$scope','applicationVersion'];
    app.controller('FooterController', footerController);
})();

(function () {
  'use strict';
  documentManagerService.$inject = ['API_BASE_URL', 'DocumentHelper', '$timeout', '$uibModal'];

  function documentManagerService(API_BASE_URL, DocumentHelper, $timeout, $uibModal) {
    var isDocumentViewerOpen = false;
    var unsetIsDocumentViewerOpen = function() {
      isDocumentViewerOpen = false;
    };

    this.checkAll = function(vm) {
      vm.noneChecked = vm.allChecked;
      vm.allChecked = !vm.allChecked;
      for(var i = 0; i < vm.documents.length; i++){
        vm.documents[i].checked = vm.allChecked;
      }
      if(vm.order) {
        vm.includePalletLabel = vm.allChecked;
        vm.incBol = vm.allChecked;
      }
    };

    this.close = function(uibModalInstance) {
      uibModalInstance.dismiss('close');
    };

    this.determineAllChecked = function(documents){
      var allChk = true;
      var noneChk = true;
      for(var i = 0; i < documents.length; i++){
        if(!documents[i].checked){
          allChk = false;
        } else {
          noneChk = false;
        }
      }

      return {
        allChecked: allChk,
        noneChecked: noneChk
      }
    };

    this.openDocumentViewer = function(controller, ticketId,  resolveObject) {
      if (isDocumentViewerOpen) return;

     isDocumentViewerOpen = true;
     resolveObject.ticketid = ticketId;
      var documentViewerModal = $uibModal.open({
        templateUrl: 'app/documentManager/views/documentViewer.tpl.html',
        size: 'lg',
        controller: controller,
        controllerAs : 'vm',
        resolve: resolveObject
      });

      documentViewerModal.result.then(unsetIsDocumentViewerOpen(),
       unsetIsDocumentViewerOpen()
      );
    };

    this.printAll = function(documents, order, incBol, includePalletLabel, shipmentNum) {
      var docIds = '';
      var filepaths = '';
      var x = 0;
      var y = 0;
      var loadNumberParam = null;
      var url='';


      for(var i = 0; i < documents.length; i++){
        if(angular.isDefined(documents[i].id) && documents[i].id > 0 && documents[i].checked) {
          docIds += '&docIds[' + x++ + ']=' + documents[i].id;
        }
        if(angular.isDefined(documents[i].path) && documents[i].checked) {
          filepaths += '&filepaths[' + y++ + ']=' + documents[i].path;
        }
      }

      if (shipmentNum) 
      {
        url = API_BASE_URL + "api/documents/combine?shipmentNumber=" + encodeURIComponent(shipmentNum)
        + docIds;
      }
      else 
      {
        var orderNumber = order ? order.customerOrderNumber : 0;

        var loadNumbers = documents
          .filter(function (doc) { return doc.loadNumber && doc.checked })
          .map(function (doc) { return doc.loadNumber });

        if (Array.isArray(loadNumbers) && loadNumbers.length > 0) {
          loadNumberParam = loadNumbers.reduce(function (accumulator, loadNumber, index) {
            return accumulator + '&loadNumbers[' + index + ']=' + loadNumber;
          }, '');

          incBol = true;
        }

        url = API_BASE_URL + "api/documents/combine" +
          '?orderNumber=' + encodeURIComponent(orderNumber) +
          '&includeBOL=' + encodeURIComponent(incBol) +
          '&includePalletLabel=' + encodeURIComponent(includePalletLabel == true) +
          docIds +
          filepaths;
      }

      $timeout(function () {

        if (!!loadNumberParam) {
          url = url + loadNumberParam;
        }

        DocumentHelper.showDocument(url);
      });
    };

    this.sendDocument = function(order, document, ticketid) {
      $uibModal.open({
        templateUrl: 'app/common/views/sendDocument.tpl.html',
        size: 'lg',
        controller: 'sendDocumentController',
        resolve: {
          order: function () { return order; },
          document: function () { return document; },
          bol: function () { return null; },
          palletLabel: function () { return null; },
          documents: function () { return null; },
          ticketid: function () { return ticketid; },
          includeBOL: function () { return false; },
          loadNumbers: function() {
            return !!document.loadNumber ? [document.loadNumber] : null;
          },
          user: ['UserServiceHelper', function (UserServiceHelper) {
            return UserServiceHelper.get();
          }]
        }
      })
    };

    this.sendDocuments = function(order, documents, ticketid) {
      $uibModal.open({
        templateUrl: 'app/common/views/sendDocument.tpl.html',
        size: 'lg',
        controller: 'sendDocumentController',
        controllerAs: 'vm',
        resolve: {
          order: function () { return order; },
          document: function () { return null; },
          bol: function () { return null; },
          palletLabel: function () { return null; },
          documents: function () { return documents; },
          ticketid: function () { return ticketid; },
          loadNumbers: function() {
            return documents
              .filter(function(doc) { return !!doc.loadNumber && !!doc.checked })
              .map(function(doc) { return doc.loadNumber });
          },
          user: ['UserServiceHelper', function (UserServiceHelper) {
            return UserServiceHelper.get();
          }]
        }
      })
    };

    this.sendShipmentDocument = function(shipmentNum, document) {
      $uibModal.open({
        templateUrl: 'app/common/views/sendDocument.tpl.html',
        size: 'lg',
        controller: 'sendShipmentDocumentController',
        controllerAs: 'vm',
        resolve: {
          documents: function () {
            return [document];
          },
          shipmentNum: shipmentNum,
          user: ['UserServiceHelper', function (UserServiceHelper) {
            return UserServiceHelper.get();
          }]
        }
      });
    };

    this.sendShipmentDocuments = function(shipmentNum, documents) {
      $uibModal.open({
        templateUrl: 'app/common/views/sendDocument.tpl.html',
        size: 'lg',
        controller: 'sendShipmentDocumentController',
        controllerAs: 'vm',
        resolve: {
          documents: function () {
            return documents
              .filter(function(doc) { return !!doc.checked });
          },
          shipmentNum: shipmentNum,
          user: ['UserServiceHelper', function (UserServiceHelper) {
            return UserServiceHelper.get();
          }]
        }
      });
    };
  }
  angular.module('NavisphereOnline').service('DocumentManagerService', documentManagerService);
})();

(function () {
  'use strict';

  shipmentDocumentViewerController.$inject = ['API_BASE_URL', 'DocumentHelper', 'DocumentManagerService', 'documents', 'shipmentNum',
                                          '$scope', '$timeout', '$uibModalInstance'];
  function shipmentDocumentViewerController(API_BASE_URL, DocumentHelper, DocumentManagerService, documents, shipmentNum,
                                         $scope, $timeout, $uibModalInstance) {

    var vm = this;

    vm.shipmentNum = shipmentNum;
    vm.documents =  !!documents ? transformDocs(documents) : [];
    vm.docSource = 'SHIPMENTS';
    vm.incBol = false;
    vm.includePalletLabel = false;
    vm.allChecked = false;
    vm.noneChecked = true;

    vm.printAll = printAll;
    vm.cancel = cancel;
    vm.close = close;
    vm.checkAll = checkAll;
    vm.sendShipmentDocuments = DocumentManagerService.sendShipmentDocuments;

    function close() {
      DocumentManagerService.close($uibModalInstance);
    }

    function transformDocs(docs) {
      console.log(docs);
      var transformedDocs = [];

      for (var i = 0; i < docs.length; i++) {
        (function (index) {
          var doc = docs[index];
          var uiDoc = {};
          uiDoc.id = doc.id;
          uiDoc.name = doc.name;
          uiDoc.description = doc.description;
          uiDoc.emailAllowed = true;
          uiDoc.printAllowed = true;
          uiDoc.docType = doc.docType;

          if (!!doc.loadNumber) {
            uiDoc.loadNumber = doc.loadNumber
          }

          if (!!doc.createdDate) {
            uiDoc.createdDate = new Date(doc.createdDate);
          }


          uiDoc.getStatus = function() {
            if(doc.status === 400) {
              return 'PENDING'
            } else if (doc.status === -100) {
              return 'ERROR'
            } else if (doc.status === null || doc.status === undefined || doc.status === 0) {
              return null;
            } else {
              return 'COMPLETE'
            }
          };
          
          uiDoc.selectAction = function() {
            uiDoc.checked = !uiDoc.checked;
            determineAllChecked();
          };

          uiDoc.linkAction = getDocumentLinkAction(doc);
          uiDoc.emailAction = getDocumentEmailAction(uiDoc);

          transformedDocs.push(uiDoc);
        })(i);

      }
      return transformedDocs;
    }

    function getDocumentLinkAction(doc) {
      return function() {
        $timeout(function() {
          DocumentHelper.showDocument(API_BASE_URL + "api/documents/" + doc.id);
        });
      }
    }
    
    function getDocumentEmailAction(doc) {
      return function() {
        DocumentManagerService.sendShipmentDocument(shipmentNum, doc);
      }
    }

    function checkAll() {
      vm.noneChecked = vm.allChecked;
      vm.allChecked = !vm.allChecked;
      for(var i = 0; i < vm.documents.length; i++){
        vm.documents[i].checked = vm.allChecked;
      }
    }

    function determineAllChecked(){
      var checkedResults = DocumentManagerService.determineAllChecked(vm.documents);
      vm.allChecked = checkedResults.allChecked;
      vm.noneChecked = checkedResults.noneChecked;
    }

    function printAll() {
      DocumentManagerService.printAll(vm.documents, null, false, false, shipmentNum);
    }

    vm.setValueToNull = function (inputElem) {
      angular.element(inputElem).val(null);
    };

    function cancel() {
      $scope.uploader.cancelAll();
      angular.forEach(
        angular.element("input[type='file']"),vm.setValueToNull);
    }
  }

  angular.module('NavisphereOnline').controller('shipmentDocumentViewerController', shipmentDocumentViewerController);
})();
(function () {
  'use strict';
  sendShipmentDocumentController.$inject = ['$scope', '$uibModal', '$uibModalInstance', 'DocumentService', 'shipmentNum', 'documents', 'user'];
  function sendShipmentDocumentController($scope, $uibModal, $uibModalInstance, DocumentService, shipmentNum, documents, user) {
    $scope.docs = documents;

    $scope.close = function () {
      $uibModalInstance.dismiss('close');
    }

    $scope.send = function () {
      $scope.processing = true;

      var toAddys = $scope.to.split(';');

      DocumentService.sendShipmentDocuments({        
        docIds: $scope.docs.map(function(doc) { return doc.id; }),
        loadNumbers: [shipmentNum],
        replyTos: [user.email],
        to: toAddys,
        message: $scope.message
      }).$promise.then(function () {
        showConfirmation();
      })
    }

    function showConfirmation () {
      $uibModalInstance.dismiss('sent');
      $uibModal.open({
        templateUrl: 'app/common/views/emailConfirmation.tpl.html',
        size: 'lg',
        controller: 'emailConfirmationController'
      });
      $scope.processing = false;
    }
  }
  angular.module('NavisphereOnline').controller('sendShipmentDocumentController', sendShipmentDocumentController);
})();

(function () {
  'use strict';
  sendDocumentController.$inject = ['$scope', '$uibModalInstance', 'order', 'bol', 'palletLabel', 'document', 'documents',
    'DocumentService', '$uibModal', 'user', 'loadNumbers', 'ticketid'];
  function sendDocumentController($scope, $uibModalInstance, order, bol, palletLabel, document, documents,
                                  DocumentService, $uibModal, user, loadNumbers, ticketid) {
    $scope.replyTos = [user.email];
    $scope.bol = bol;
    $scope.palletLabel = palletLabel;
    $scope.document = document;
    $scope.docs = [];
    var ticketid = ticketid;
    var docIds = [];
    var docPaths = [];
    var includeBOL, includePalletLabel = false;

    $scope.setDefaults = function setDefaults(){
      if (!$scope.palletLabel && Array.isArray(documents)) {
        var palletLabelDocs = documents
          .filter(function (doc) {
            return doc.checked && doc.id === -2;
          })

          if (documents.length === 1 && palletLabelDocs.length === 1) {
            $scope.palletLabel = palletLabelDocs[0];
          }
      }

      if (documents) {
        for(var i = 0; i < documents.length; i++){
          if(documents[i].id) {
            if(documents[i].id === -1){
              if(documents[i].checked){
                includeBOL = true;
                $scope.docs.push(documents[i]);
              }
            } else if (documents[i].id === -2){
              if(documents[i].checked) {
                includePalletLabel = true;
                $scope.docs.push(documents[i]);
              }
            } else{
              if(documents[i].checked) {
                docIds.push(documents[i].id);
                if(documents[i].path){
                  docPaths.push(documents[i].path);
                }
                $scope.docs.push(documents[i]);
              }
            }
          }
        }
      } else if ($scope.bol) {
        $scope.docs = [];
        $scope.docs.push($scope.bol);
      } else if ($scope.palletLabel) {
        $scope.docs = [];
        $scope.docs.push($scope.palletLabel);
      } else {
        $scope.docs = [];
        $scope.docs.push($scope.document);
      }
    };

    $scope.setDefaults();
    $scope.close = function () {
      $uibModalInstance.dismiss('close');
    };
    function showConfirmation() {
      $uibModalInstance.dismiss('sent');
      $uibModal.open({
        templateUrl: 'app/common/views/emailConfirmation.tpl.html',
        size: 'lg',
        controller: 'emailConfirmationController'
      });
      $scope.processing = false;
    }

    $scope.processing = false;
    $scope.send = function () {
      $scope.processing = true;

      var toAddys = $scope.to.split(';');

      if ($scope.bol) {
        DocumentService.sendBol({
          orderNumber: order.customerOrderNumber,
          replyTos: $scope.replyTos,
          to: toAddys,
          message: $scope.message,
          loadNumbers: loadNumbers
        }).$promise.then(function () {
          showConfirmation();
        });
      } else if ($scope.palletLabel) {
        DocumentService.sendPalletlabel({
          orderNumber: order.customerOrderNumber,
          replyTos: $scope.replyTos,
          to: toAddys,
          message: $scope.message,
          includePalletLabel: true
        }).$promise.then(function () {
          showConfirmation();
        });
      } else if ($scope.document) {
        DocumentService.sendDocument({
          documentId: $scope.document.id,
          filePath: $scope.document.path ? $scope.document.path : null,
          orderNumber: order ? order.customerOrderNumber : null,
          replyTos: $scope.replyTos,
          to: toAddys,
          message: $scope.message,
          ticketid : ticketid,
          loadNumbers: loadNumbers
        }).$promise.then(function () {
          showConfirmation();
        });
      } else {
        DocumentService.sendDocuments({
          orderNumber: order ? order.customerOrderNumber : null,
          filePaths: docPaths,
          replyTos: $scope.replyTos,
          to: toAddys,
          message: $scope.message,
          includeBol: includeBOL,
          includePalletLabel: includePalletLabel,
          docIds: docIds,
          ticketid : ticketid,
          loadNumbers: loadNumbers
        }).$promise.then(function () {
          showConfirmation();
        });
      }
    }
  }
  angular.module('NavisphereOnline').controller('sendDocumentController', sendDocumentController);
})();

(function () {
  'use strict';

  reverseLogisticsDocumentViewerController.$inject = ['API_BASE_URL', 'DocumentHelper', 'DocumentManagerService', 'documents', '$uibModalInstance', '$timeout', 'ticketid' ];
  function reverseLogisticsDocumentViewerController(API_BASE_URL, DocumentHelper, DocumentManagerService, documents, $uibModalInstance, $timeout, ticketid) {

    var vm = this;
    vm.incBol = false;
    vm.includePalletLabel = false;
    vm.allChecked = false;
    vm.noneChecked = true;
    vm.ticketid = ticketid;
    vm.docSource = 'REVERSELOGISTICS';
    vm.documents = transformDocs(documents);


    vm.printAll = printAll;
    vm.close = close;
    vm.checkAll = checkAll;
    vm.determineAllChecked = determineAllChecked;
    vm.sendDocument = DocumentManagerService.sendDocument;
    vm.sendDocuments = DocumentManagerService.sendDocuments;


    function checkAll() {
      DocumentManagerService.checkAll(vm);
    }

    function close() {
      DocumentManagerService.close($uibModalInstance);
    }

    function determineAllChecked() {
      var checkedResults = DocumentManagerService.determineAllChecked(vm.documents);
      vm.allChecked = checkedResults.allChecked;
      vm.noneChecked = checkedResults.noneChecked;
    }

    function printAll() {
      DocumentManagerService.printAll(vm.documents, vm.order, vm.incBol, vm.includePalletLabel, null);
    }

    function transformDocs(docs) {
      var transformedDocs = [];

      for (var i = 0; i < docs.length; i++) {
        (function (index) {
          var doc = docs[index];
          var uiDoc = {};
          uiDoc.id = doc.id;
          uiDoc.name = doc.name;
          uiDoc.emailAllowed = true;
          uiDoc.printAllowed = true;
          uiDoc.deleteAllowed = false;
          uiDoc.createdDate = new Date(doc.createdDate);
          uiDoc.path = doc.uncPath;
          uiDoc.getStatus = function(){return doc.status};
          uiDoc.isPending = function() {
            return doc.status !== "COMPLETE";
          };
          uiDoc.selectAction = function() {
            uiDoc.checked = !uiDoc.checked;
            determineAllChecked();
          };
          uiDoc.emailAction = function () {
            vm.sendDocument(null, uiDoc, vm.ticketid);
          };
          uiDoc.linkAction = function () {
            $timeout(function () {
              DocumentHelper.showDocument(API_BASE_URL + "api/reverselogisticsdocuments?path=" + uiDoc.path);
            });
          };
          transformedDocs.push(uiDoc);
        })(i);

      }
      return transformedDocs;
    }

  }

  angular.module('NavisphereOnline').controller('reverseLogisticsDocumentViewerController', reverseLogisticsDocumentViewerController);
})();

(function () {
  'use strict';

  orderDocumentViewerController.$inject = ['API_BASE_URL', 'authService', 'DocumentHelper', 'DocumentManagerService', 'documents', 'DocumentService', 'FileUploader', 'ModalService', 'order',
                                          '$scope', 'StatusMappingService', '$timeout', '$uibModal', '$uibModalInstance', 'UserPermissionService' ];
  function orderDocumentViewerController(API_BASE_URL, authService, DocumentHelper, DocumentManagerService, documents, DocumentService, FileUploader, ModalService, order,
                                         $scope, StatusMappingService, $timeout, $uibModal, $uibModalInstance, UserPermissionService, ticketid) {

    function init() {
      refresh();
    }

    var modalOptions = {
      closeButtonText: 'NO',
      actionButtonText: 'YES',
      headerText: 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT',
      bodyText: ''
    };
    var vm = this;

    vm.ticketid = ticketid;
    vm.order = order;
    vm.invalidFileType = false;
    vm.invalidFileSize = false;
    vm.document = { customerCode: vm.order.customerInfo.customer.partyCode };
    vm.documents =  !!documents ? transformDocs(documents) : [];
    vm.docSource = 'ORDERS';
    vm.incBol = false;
    vm.includePalletLabel = false;
    vm.allChecked = false;
    vm.noneChecked = true;

    vm.setDefaultLoad = setDefaultLoad;
    vm.setOrderNumber = setOrderNumber;
    vm.refresh = refresh;
    vm.printAll = printAll;
    vm.cancel = cancel;
    vm.close = close;
    vm.upload = upload;
    vm.sendBol = sendBol;
    vm.sendPalletLabel = sendPalletLabel;
    vm.sendDocuments = DocumentManagerService.sendDocuments;
    vm.checkAll = checkAll;


    vm.setDefaultLoad();
    vm.setOrderNumber();

    function close() {
      DocumentManagerService.close($uibModalInstance);
    }

    function setDefaultLoad() {
      if (vm.order.service.loads.length == 1) {
        vm.document.loadNumber = vm.order.service.loads[0].loadNumber;
      }
    }

    function setOrderNumber() {
      vm.document.orderNumber = vm.order.customerOrderNumber;
    }

    function sendBol(bol) {
      $uibModal.open({
        templateUrl: 'app/common/views/sendDocument.tpl.html',
        size: 'lg',
        controller: 'sendDocumentController',
        resolve: {
          order: function () { return vm.order; },
          ticketid: function () { return vm.ticketid; },
          document: function () { return null; },
          bol: function () { return bol; },
          palletLabel: function () { return null; },
          documents: function () { return null; },
          includeBOL: function () { return false; },
          loadNumbers: function() { return !!bol.loadNumber ? [bol.loadNumber] : null; },
          user: ['UserServiceHelper', function (UserServiceHelper) {
            return UserServiceHelper.get();
          }]
        }
      }).result.then(function () {
      }, function () {
      });
    }

    function sendPalletLabel(palletLabel) {
      $uibModal.open({
        templateUrl: 'app/common/views/sendDocument.tpl.html',
        size: 'lg',
        controller: 'sendDocumentController',
        resolve: {
          order: function () { return vm.order; },
          ticketid: function () { return vm.ticketid; },
          document: function () { return null; },
          bol: function () { return null; },
          palletLabel: function () { return palletLabel; },
          documents: function () { return null; },
          includeBOL: function () { return false; },
          loadNumbers: function() { return null },
          user: ['UserServiceHelper', function (UserServiceHelper) {
            return UserServiceHelper.get();
          }]
        }
      }).result.then(function () {
      }, function () {
      });
    }

    function transformDocs(docs) {
      var transformedDocs = [];

      for (var i = 0; i < docs.length; i++) {
        (function (index) {
          var doc = docs[index];
          var uiDoc = {};
          uiDoc.id = doc.id;
          uiDoc.name = doc.name;
          uiDoc.description = doc.description;
          uiDoc.emailAllowed = true;
          uiDoc.printAllowed = true;
          uiDoc.deleteAllowed = false;
          uiDoc.docType = doc.docType;

          if (!!doc.loadNumber) {
            uiDoc.loadNumber = doc.loadNumber
          }

          if (!!doc.createdDate) {
            uiDoc.createdDate = new Date(doc.createdDate);
          }

          uiDoc.getStatus = function() {
            if(doc.status === 400) {
              return 'PENDING'
            } else if (doc.status === -100) {
              return 'ERROR'
            } else if (doc.status === null || doc.status === undefined || doc.status === 0) {
              return null;
            } else {
              return 'COMPLETE'
            }
          };
          uiDoc.isPending = function(){
            return doc.status === 400;
          };
          uiDoc.selectAction = function() {
            uiDoc.checked = !uiDoc.checked;
            determineAllChecked();
          };

          if (uiDoc.docType === 'PALLET LABEL') {
            uiDoc.linkAction = doc.id > 0
              ? getDocumentLinkAction(doc)
              : getPalletLabelLinkAction(doc);
            uiDoc.emailAction = sendPalletLabel.bind(null, doc);
          } else if (uiDoc.docType === 'BOL') {
            uiDoc.linkAction = doc.id > 0
              ? getDocumentLinkAction(doc)
              : getBolLinkAction(doc);
            uiDoc.emailAction = sendBol.bind(null, doc);
          } else {
            uiDoc.linkAction = getDocumentLinkAction(doc);
            uiDoc.emailAction = function () {
              DocumentManagerService.sendDocument(vm.order, uiDoc, vm.ticketid);
            };
          }

          uiDoc.deleteAction = function () {
            ModalService.showModal({}, modalOptions).then(function (result) {
              if (result === 'ok') {
                DocumentService.delete({
                  documentId: uiDoc.id
                }).$promise.then(function () {
                  vm.refresh();
                });
              }
            });
          };
          transformedDocs.push(uiDoc);
        })(i);

      }
      return transformedDocs;
    }

    function getDocumentLinkAction(doc) {
      return function(){
        $timeout(function () {
          DocumentHelper.showDocument(API_BASE_URL + "api/documents/" + doc.id);
        });
      }
    }

    function getPalletLabelLinkAction(doc) {
      return function(){
        $timeout(function () {
          DocumentHelper.showDocument(API_BASE_URL + 'api/documents/palletLabel' + '?orderNumber=' + encodeURIComponent(vm.order.customerOrderNumber));
        });
      }
    }

    function getBolLinkAction(doc) {
      return function() {
        $timeout(function () {
          var getBolUrl = API_BASE_URL +'api/documents/bol';
          var urlParams = '?orderNumber=' + encodeURIComponent(vm.order.customerOrderNumber);

          if (!!doc.loadNumber) {
            urlParams = urlParams + '&loadNumber=' + encodeURIComponent(doc.loadNumber);
          }

          DocumentHelper.showDocument(getBolUrl + urlParams);
        });
      }
    }

    function checkAll() {
      vm.noneChecked = vm.allChecked;
      vm.allChecked = !vm.allChecked;
      for(var i = 0; i < vm.documents.length; i++){
        vm.documents[i].checked = vm.allChecked;
      }
      vm.includePalletLabel = vm.allChecked;
      vm.incBol = vm.allChecked;
    }
    function determineAllChecked(){
      var checkedResults = DocumentManagerService.determineAllChecked(vm.documents);
      vm.allChecked = checkedResults.allChecked;
      vm.noneChecked = checkedResults.noneChecked;
    }

    function refresh() {
      if (!vm.isRefreshing) {
        vm.isRefreshing = true;
        DocumentService.getAll({
          orderNumber: vm.order.customerOrderNumber
        }).$promise.then(function (orderDocuments) {
          getDefaultorderDocumentsAsync()
            .then(function (defaultOrderDocuments) {
              vm.isRefreshing = false;
              var defaultOrderDocs = defaultOrderDocuments || [];
              vm.documents = transformDocs(defaultOrderDocs.concat(orderDocuments));
              determineAllChecked();
            });
        });
      }
    }

    function getDefaultorderDocumentsAsync() {
      var partyCode = vm.order.customerInfo.customer.partyCode;
      var orderNumber = vm.order.customerOrderNumber;
      return DocumentService.getDefaultOrderDocuments({partyCode: partyCode, orderNumber: orderNumber}).$promise;
    }

    function printAll() {
      var includeBol = vm.incBol || vm.documents
        .some(function (doc) {
          return doc.docType === 'BOL' && doc.checked;
        });

      var includePalletLabel = vm.includePalletLabel || vm.documents
        .some(function (doc) {
          return doc.docType === 'PALLET LABEL' && doc.checked;
        });
      DocumentManagerService.printAll(vm.documents, vm.order, includeBol, includePalletLabel, null);
    }

    var uploader = $scope.uploader = new FileUploader({
      url: API_BASE_URL + 'api/documents',
      headers: {
        Authorization: "Bearer " + authService.getAccessToken()
      }
    });

    uploader.removeAfterUpload = true;

    function upload() {
      vm.processing = true;
      $scope.uploader.uploadAll();
    }

    uploader.onBeforeUploadItem = function (fileItem) {
      fileItem.formData.push(vm.document);
    };

    uploader.onCompleteItem = function () {
      vm.refresh();
      vm.document = { customerCode: vm.order.customerInfo.customer.partyCode };
      $scope.uploader.progress = 0;
      $scope.uploadform.$setPristine();
      $scope.uploadform.$setUntouched();
      angular.forEach(angular.element("input[type='file']"),vm.setValueToNull);
      vm.setDefaultLoad();
    };

    uploader.filters.push({
      name: 'extensionFilter',
      fn: function (item) {
        var filename = item.name;
        var extension = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
        vm.invalidFileType = !(extension === "pdf" || extension === "tif" || extension === "tiff" ||
        extension === "jpg" || extension === "jpeg");
        return true;
      }
    });

    uploader.filters.push({
      name: 'sizeFilter',
      fn: function (item) {
        var fileSize = item.size;
        fileSize = parseInt(fileSize) / (1024 * 1024);
        vm.invalidFileSize = fileSize > 5;
        return true;
      }
    });

    vm.setValueToNull = function (inputElem) {
      angular.element(inputElem).val(null);
    };

    function cancel() {
      $scope.uploader.cancelAll();
      angular.forEach(
        angular.element("input[type='file']"),vm.setValueToNull);
    }

    init();
  }

  angular.module('NavisphereOnline').controller('orderDocumentViewerController', orderDocumentViewerController);
})();

(function() {
    'use strict';
  
    developmentFeatureTogglesController.$inject = ['$scope', 'UserPermissionService'];
    function developmentFeatureTogglesController($scope, UserPermissionService) {
        $scope.devFeatureToggles = [];
        $scope.hasPermissionToPage = false;

        $scope.save = updateFeatureToggle;

        function activate() {
            $scope.hasPermissionToPage = UserPermissionService.hasPermission("[Warning] Features In Development");
            loadDevFeatureToggles();
        }
        activate();      
    

        function loadDevFeatureToggles() {
            $scope.devFeatureToggles = [];

            var toggles = UserPermissionService.getDevelopmentFeatureToggles();
            if (angular.isUndefined(toggles) || toggles === null) {
                return;
            }

            var featureKeys = Object.keys(toggles);
            if (angular.isUndefined(featureKeys) || featureKeys === null || featureKeys.length <= 0) {
                return;
            }

            var toggleKeyValues = [];
            for(var index = 0; index < featureKeys.length; index++) {
                var key = featureKeys[index];
                if (key === 'ForUnitTestsCoverageOnly') {
                    continue;
                }

                var toggle = {
                    index: toggleKeyValues.length,
                    name: key, 
                    isActive: toggles[key]
                };

                toggleKeyValues.push(toggle);
            }

            $scope.devFeatureToggles = toggleKeyValues;
        }

        function updateFeatureToggle(featureToggle) {
            if(angular.isUndefined(featureToggle) || featureToggle === null) {
                return;
            }

            $scope.devFeatureToggles[featureToggle.index].isActive = featureToggle.isActive;
            UserPermissionService.saveDevelopmentFeatureToggle(featureToggle.name, featureToggle.isActive);
        }
    }

    angular.module('NavisphereOnline').controller('developmentFeatureTogglesController', developmentFeatureTogglesController);

})();
  
(function() {
  angular
    .module('NavisphereOnline')
    .directive('smallBarChart',smallBarChart);

  smallBarChart.$inject = ['d3Service', 'moment', '$log'];

  function smallBarChart(d3Service, moment, $log){
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/smBarChart/smBarChart.html',
      scope: {
        chartValue: '='
      },
      bindToController: false,
      link: SmallBarChartLink
    };
    return directive;

    function SmallBarChartLink(scope, element) {

      var d3 = d3Service;

      var data = scope.chartValue;

      var margin = {top: 45, right: 20, bottom: 20, left: 20},
        width = 510 - margin.left - margin.right,
        height = 90 - margin.top - margin.bottom;

      var color = d3.scale.linear()
        .domain([0.0, 0.70, 1.00])
        .range(["#59A5CD", "#004F75", "#002b40"]);

      var x = d3.scale.ordinal()
        .rangeRoundBands([0, width],.1,.4);

// Scales. Note the inverted domain fo y-scale: bigger is up!
      var y = d3.scale.linear()
        .range([height, 0]);

      var xAxis = d3.svg.axis()
        .scale(x)
        .orient("bottom")
        .orient("bottom")
        .outerTickSize(0)
        .tickValues([mindate(data),maxdate(data)])
        .tickFormat(function(d){return formatDate(d)});

      var tip = d3.tip()
        .attr('class', 'd3-tip')
        .offset([-10, 0])
        .html(function (d) {
          return "<div style='margin-bottom:5px;'><strong>" + "\t" + formatDate(d.year) + "</strong></div><span style='color:#99c;'>" + (d.percent * 100).toFixed(2) + "%</span>";
        });

      // Data is nested by datagrounp
      var datagroup = d3.nest()
        .key(function (d) {
          return d.country;
        })
        .entries(data);

      // Compute the minimum and maximum year and percent across symbols.
      x.domain(data.map(function (d) {
        return d.year;
      }));

      //x.domain(data.map(function(d) { return 'yup'; }));
      y.domain([0, d3.max(datagroup, function (s) {
        return s.values[0].percent;
      })]);


      var svg = d3.select(element[0].querySelector("div")).selectAll("svg")
        .data(datagroup)
        .enter()
        .append("svg")
        //Responsive Attributes Replace Height & Width Style
        .attr("viewbox", "0 0 500 100")
        .attr("preserveAspectRatio", "xMinYMin meet")
        //add class to make it responsive
        .classed("svg-content-responsive", true)
        .append("g");

      height = 35;

      svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis);

      // Accessing nested data: https://groups.google.com/forum/#!topic/d3-js/kummm9mS4EA
      // data(function(d) {return d.values;})
      // this will dereference the values for nested data for each group

      svg.selectAll(".d3bar")
        .data(function (d) {
          return d.values;
        })
        .enter()
        .append("rect")
        .attr("class", "d3bar")
        .attr("x", function (d) {
          return x(d.year);
        })
        .attr("width", x.rangeBand())
        .attr("y", function (d) {
          return height * (1 - d.percent);
        })
        .attr("height", function (d) {
          return height * (d.percent);
        })
        .attr("fill", function (d) {
          return color(d.percent)
        })
        //.attr("fill", function(d) {return "rgb(0, " + (d*10) + ",|0)"})
        .on('mouseover', tip.show)
        .on('mouseout', tip.hide);

      svg.call(tip);


      function formatDate(d){

        return moment(d, "YYYYMM").format("MMM-YYYY");

      }

      function mindate(data){

        var arrayLength = data.length;

        for (var i = 0; i < arrayLength; i++) {
          if(data[i].percent !== 0){
            $log.info(data[i].percent);
            return data[i].year;
          }

        }
      }

      function maxdate(data){

        var arrayLength = data.length-1;

        for (var i = arrayLength; i > 0; i--) {
          if (data[i].percent !== 0) {
            $log.info(data[i].percent);
            return data[i].year;
          }
        }
      }
    }

  }

})();

(function () {
    'use strict';

    dashboardController.$inject = ['$filter', 'NotificationDismissalService', 'UserPermissionService', 'user', 'widgetDefinitions',
      'databaseStorage', 'WidgetService'];
    function dashboardController($filter, NotificationDismissalService, UserPermissionService, user, widgetDefinitions,
                                 databaseStorage, WidgetService) {
      var vm = this;
      vm.user = user;
      vm.loadDashboard = loadDashboard;
      vm.resetDashboard = resetDashboard;

      vm.dismissAllNotifications = function() {
        NotificationDismissalService.setDismissingFlag();
      };
      vm.showCreateOrderButton = function() {
        return UserPermissionService.hasPermission('Create Order');
      };
      vm.addWidget = function($event, widget){
        $event.preventDefault();
        vm.dashboardOptions.addWidget(widget.name);
      };
      function resetDashboard() {
        vm.dashboardOptions.loadWidgets(vm.dashboardOptions.defaultWidgets);
        vm.dashboardOptions.saveDashboard(true);
      }
      function loadDashboard(){
        WidgetService.getWidgets().$promise.then(function (results) {
          var defaultWidgets = [];

          angular.forEach(results, function (item) {
            // this is only needed before we deploy Widget table change
            if (item.title == 'TRACK_MY_ORDER')
            {
              defaultWidgets.push({ name: 'searchByReference', title: 'SEARCH_BY_REFERENCE_HASHSIGN' });
            }
            else if (widgetDefinitions.some(function (definition) { return definition.title == item.title}))
            {
              // Only add widgets that are also listed in the widgetDefinitions list
              defaultWidgets.push({ name: item.name, title: item.title });
            }
          }
          );

          vm.dashboardOptions = {
            widgetButtons: false,
            widgetDefinitions: widgetDefinitions,
            sortableOptions: { placeholder: 'has-warning' },
            defaultWidgets: defaultWidgets,
            storage: databaseStorage,
            storageId: 'dashBoard',
            hideWidgetName: true,
            hideToolbar: false
          };
        });
      }
      vm.loadDashboard();
    }
  angular.module('NavisphereOnline').controller('DashboardController', dashboardController);
})();

(function() {
  angular
    .module('NavisphereOnline')
    .directive('serviceAnalytics',serviceAnalytics);

  function serviceAnalytics() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/serviceAnalytics/serviceAnalytics.html',
      scope: {
        onTimePicks: '=',
        onTimeDrops: '=',
        sbcp: '=',
        sbcd: '=',
        beginDateDisp: '=',
        endDateDisp: '=',
        complete: '=',
        isEmpty: '=',
        freightMvmt: '=',
        freightMovementTitle:'=',
        dropsTitle:'=',
        picksTitle:'=',
        historicalPicksTitle:'=',
        historicalDropsTitle:'=',
        freightMovementCurrentMonthTitle:'=',
        onTimeTitle:'=',
        toTitle:'='
      },
      link: ServiceAnalyticsController
    };

    return directive;

    function ServiceAnalyticsController($scope, element, attr) {
    }
  }

})();

/**
 * Created by lennjoh on 5/17/2016.
 */

(function () {
  'use strict';


  angular.module('NavisphereOnline')
    .directive('ngJsonExportExcel', function () {
      return {
        restrict: 'AE',
        scope: {
          data : '=',
          filename: '=?',
          reportFields: '='
        },
        link: function (scope, element) {

          scope.filename = !!scope.filename ? scope.filename : 'export-excel';

          scope.fields = [];
          scope.header = [];

          angular.forEach(scope.reportFields, function(field, key) {

            if(!field || !key) {
              throw new Error('error json report fields');
            }

            scope.fields.push(key);
            scope.header.push(field);
          });

          element.bind('click', function(){
            scope.clickExport()
          });

          scope.clickExport = function() {
            scope.bodyData = scope._bodyData();
            scope.strData = scope._convertToExcel(scope.bodyData);

            scope.blob = new Blob([scope.strData], {type: "text/plain;charset=utf-8"});

            return saveAs(scope.blob, [scope.filename + '.csv']);
          };

          scope._bodyData = function(){

            var data = scope.data;
            var body = "";
            angular.forEach(data, function(dataItem) {
              var rowItems = [];

              angular.forEach(scope.fields, function(field) {
                if(field.indexOf('.')) {
                  field = field.split(".");
                  var curItem = dataItem;

                  // deep access to obect property
                  angular.forEach(field, function(prop){
                    if (curItem !== null && curItem !== angular.isUndefined) {
                      curItem = curItem[prop];
                    }
                  });

                  data = curItem;
                }
                else {
                  data = dataItem[field];
                }

                var fieldValue = data !== null ? data : ' ';

                if (fieldValue !== angular.isUndefined && angular.isObject(fieldValue)) {
                  fieldValue = scope._objectToString(fieldValue);
                }

                rowItems.push(fieldValue);
              });

              body += rowItems.toString() + '\n';
            });

            return body;
          };

          scope._convertToExcel = function(body) {
            return scope.header + '\n' + body;
          };

         scope._objectToString = function(object) {
            scope.output = '';
            angular.forEach(object, function(value, key) {
              scope.output += key + ':' + value + ' ';
            });

            return '"' + scope.output + '"';
          }
        }
      };
    });
})();

/**
 * Created by lennjoh on 5/25/2016.
 */
(function() {
  'use strict';

  angular
    .module('NavisphereOnline')
    .factory('grabInTransitData', grabInTransitData);

  /** @ngInject */
  function grabInTransitData($resource) {

    //return {InTransit: $resource(
    //  'http://devspcl4/EDW/EDW.OrderIndex.API/v1//InTransitOrders'
    //  ,{ inTransit:'@_inTransitSearch' }
    //)};

    return $resource('http://devspcl4/EDW/EDW.OrderIndex.API/v1', null, {
      'InTransit': {method: 'POST', url: 'http://devspcl4/EDW/EDW.OrderIndex.API/v1//InTransitOrders'}
    });
  }
})();



/*
 * Created by lennjoh on 5/5/2016.
 */
(function() {
  'use strict';
  angular
  .module('NavisphereOnline')
  .filter('timeconversion', function() {
      // Create the return function
      // set the required parameter name to **number**
      return function(time) {
        // Ensure that the passed in data is a number
        if(isNaN(time)) {
          // If the data is not a number or is less than one (thus not having a cardinal value) return it unmodified.
          return time;
        } else {
          // If the time less than 24 hours return it with hours.  If it is 24 hours or more convert it to days and return it with days.
          if(time < 24 && time >= 0 && time !== '') {
            return time.toFixed(2) + ' hrs';
          } else if (time >= 24) {
            return (time / 24).toFixed(2) + ' days';
          }
          else {
            return '0.00 hrs';
          }
        }
      };
    });
})();

(function() {
  'use strict';

  angular
    .module('NavisphereOnline')
    .directive('freightMovement', freightMovement);


  /** @ngInject */
  function freightMovement() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/freightMovement/freightMovement.tpl.html',
      scope: {
        freightData: '='
      },
      controller: FreightMovementController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FreightMovementController() {

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('NavisphereOnline')
    .factory('dataGrabber', dataGrabber);

  /** @ngInject */
  function dataGrabber($resource) {

    return $resource('http://devspcl4/edw/EDW.OrderMetrics.API/v1/', null, {
        'onTime': {method: 'POST', url: 'http://devspcl4/edw/EDW.OrderMetrics.API/v2/OnTime/Search/:onTimeSearch'},
        'freight': {method: 'POST', url: 'http://devspcl4/edw/EDW.OrderMetrics.API/v2/Freight/Search:freightSearch'},
        'onTimePeriod': {method: 'POST', url: 'http://devspcl4/edw/EDW.OrderMetrics.API/v2/OnTime/SearchByPeriod:onTimeSearch'},
        'historicOrders': {method: 'POST', url: 'http://devspcl4/edw/EDW.OrderMetrics.API/v2/HistoricOrders/Search:historicOrdersSearch'},
        'historicOrdersModes': {method: 'POST', url: 'http://devspcl4/edw/EDW.OrderMetrics.API/v2/HistoricOrdersModes/Search:historicOrdersModesSearch'}
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('NavisphereOnline')
    .factory('d3Service', d3Service);

  d3Service.$inject = ['$window']

  /** @ngInject */
  function d3Service($window) {
    var _d3 = $window.d3;

    return _d3;
  }
})();

(function() {
        angular
          .module('NavisphereOnline')
          .directive('percentGauge',percentGauge);

        percentGauge.$inject = ['d3Service'];

        function percentGauge(d3Service) {
          var directive = {
            restrict: 'E',
            template: '&nbsp;',
            scope: {
              gaugeValue: '=',
              isEmpty: '='
            },
            link: percentGaugeLink
          };

          return directive;

          function percentGaugeLink(scope, element) {

            scope.otpValue = scope.gaugeValue;

            var d3 = d3Service;
            scope.moveit = '';
            scope.needle;

            var barWidth, chart, chartInset, repaintGauge,
              height, margin, padRad, percent, radius, svg, totalPercent, width;

            percent = .50;
            padRad = 0.025;
            chartInset = 0;

            // Orientation of gauge:
            totalPercent = .75;

            var el = d3.select(element[0])
              .append("div")
              .classed("svg-container", true);

            margin = {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            };

            width = 600;
            height = width;
            radius = Math.min(width, height) / 2;
            barWidth = width / 8;

            /*
             Utility methods
             */
            scope.percToDeg = function (perc) {
              return perc * 360;
            };

            scope.percToRad = function (perc) {
              return scope.degToRad(scope.percToDeg(perc));
            };

            scope.degToRad = function (deg) {
              return deg * Math.PI / 180;
            };


            svg = el.append('svg')
              .attr("preserveAspectRatio", "xMinYMin meet")
              .attr("viewBox", "0 0 600 300")
              .classed("svg-content-responsive", true);

            // Add layer for the panel
            chart = svg.append('g')
              .attr('transform', "translate(" + ((width + margin.left) / 2) + ", " + ((height + margin.top) / 2) + ")");

            chart.append('path').attr('class', "arc chart-filled");
            chart.append('path').attr('class', "arc chart-empty");

            var arc2 = d3.svg.arc().outerRadius(radius - chartInset).innerRadius(radius - chartInset - barWidth);
            var arc1 = d3.svg.arc().outerRadius(radius - chartInset).innerRadius(radius - chartInset - barWidth);

            repaintGauge = function (perc) {

              var arcStartRad, arcEndRad;
              var next_start = totalPercent;
              arcStartRad = scope.percToRad(next_start);
              arcEndRad = arcStartRad + scope.percToRad(perc / 2);
              next_start += perc / 2;

              arc1.startAngle(arcStartRad).endAngle(arcEndRad);

              arcStartRad = scope.percToRad(next_start);
              arcEndRad = arcStartRad + scope.percToRad((1 - perc) / 2);
              var color = d3.scale.linear().domain([0.0, 0.70, 1.00]).range(["#59A5CD", "#004F75", "#002b40"]);

              arc2.startAngle(arcStartRad + padRad).endAngle(arcEndRad);

              chart.select(".chart-filled").attr('d', arc1);
              chart.select(".chart-empty").attr('d', arc2);

              //dynamic coloring based on the value
              chart.path = svg.selectAll('path.chart-filled').style('fill',color(perc));
            };

            var Needle = (function () {

              function Needle(el) {
                this.el = el;
                this.len = width / 3;
                this.radius = this.len / 6;
              }

              Needle.prototype.render = function () {
                return this.el.append('path').attr('class', 'needle');
              };

              Needle.prototype.moveTo = function (perc) {
                var oldValue = this.perc || 0;
                this.perc = perc;
                // Reset pointer position
                this.el.transition().delay(100).ease('quad').duration(200).select('.needle').tween('reset-progress', function () {
                  return function (percentOfPercent) {
                    var progress = (1 - percentOfPercent) * oldValue;

                    repaintGauge(progress);
                  };
                });

                this.el.transition().delay(300).ease('bounce').duration(1500).select('.needle').tween('progress', function () {
                  return function (percentOfPercent) {
                    var progress = percentOfPercent * perc;

                    repaintGauge(progress);
                  };
                });
              };
              return Needle;
            })();

            scope.needle = new Needle(chart);
            scope.needle.render();
            scope.needle.moveTo(percent);

            loadLiquidFillGauge(svg, scope.gaugeValue, scope.isEmpty);
            scope.moveit = scope.gaugeValue;

            //needle
            if (scope.moveit > 1) {
              scope.needlemoveit = scope.moveit / 100;
              scope.needle.moveTo(scope.needlemoveit);
            }
            else {
              scope.needle.moveTo(scope.moveit);
            }

            function liquidFillGaugeDefaultSettings() {

              return {
                minValue: 0,
                maxValue: 100,
                circleThickness: 0.05,
                circleFillGap: 0.05,
                circleColor: "#178BCA",
                textRiseTime: 1000,
                textVertPosition: 0,
                textSize:1,
                valueCountUp: true,
                displayPercent: true,
                textColor: "#000000"
              };
            }

            function loadLiquidFillGauge(elementId, value, isEmpty, config) {

              config = liquidFillGaugeDefaultSettings();

              var gauge = elementId;
              var radius = Math.min(parseInt(gauge.style("width")), parseInt(gauge.style("height"))) / 2;
              var locationX = width / 2 - radius;
              var locationY = parseInt(gauge.style("height")) / 2 - radius;

              var textPixels = (config.textSize * radius / 2);
              var textFinalValue = parseFloat(value).toFixed(2);
              var textStartValue = config.minValue;
              var percentText = "%";
              var circleThickness = config.circleThickness * radius;
              var circleFillGap = config.circleFillGap * radius;
              var fillCircleMargin = circleThickness + circleFillGap;
              var fillCircleRadius = radius - fillCircleMargin;

              // Rounding functions so that the correct number of decimal places is always displayed as the value counts up.
              scope.textRounder = function (value) {
                return Math.round(value);
              };
              if (parseFloat(textFinalValue) !== parseFloat(scope.textRounder(textFinalValue))) {
                scope.textRounder = function (value) {
                  return parseFloat(value).toFixed(1);
                };
              }
              if (parseFloat(textFinalValue) !== parseFloat(scope.textRounder(textFinalValue))) {
                scope.textRounder = function (value) {
                  return parseFloat(value).toFixed(2);
                };
              }

              // Scale for controlling the position of the text within the gauge.
              var textRiseScaleY = d3.scale.linear()
                .range([fillCircleMargin + fillCircleRadius * 2, (fillCircleMargin + textPixels * 0.7)])
                .domain([0, 1]);

              // Center the gauge within the parent SVG.
              var gaugeGroup = gauge.append("g")
                .attr('transform', 'translate(' + locationX + ',' + locationY + ')');

              scope.dispText = scope.textRounder(textStartValue) + percentText;

              // Text where the wave does not overlap.
              var text1 = gaugeGroup.append("text")
                .text(scope.dispText)
                .attr("class", "liquidFillGaugeText")
                .attr("text-anchor", "middle")
                .attr("font-size", textPixels + "px")
                .style("fill", config.textColor)
                .attr('transform', 'translate(' + radius + ',' + textRiseScaleY(config.textVertPosition) + ')');


              // Make the value count up.
              var textTween = function () {
                var i = d3.interpolate(this.textContent, textFinalValue);
                return function (t) {
                  this.textContent = scope.textRounder(i(t)) + percentText;
                };
              };
              text1.transition()
                .duration(config.textRiseTime)
                .tween("text", textTween);

              scope.GaugeTextUpdater = function(){

                scope.value = value;

                scope.update = function () {
                  scope.value = value;

                  scope.newFinalValue = parseFloat(scope.value).toFixed(2);

                  scope.textRounderUpdater = function () {
                    return Math.round(scope.value);
                  };

                  scope.textRounderUpdater = function () {
                    return parseFloat(scope.value).toFixed(2);
                  };

                  scope.textTween = function () {
                    if(isEmpty) {
                      var i = d3.interpolate(this.textContent, 'N/A');
                      return function () {
                        this.textContent = 'N/A';
                      };
                    } else {
                      i = d3.interpolate(this.textContent, parseFloat(scope.value).toFixed(2));
                      return function (t) {
                        this.textContent = scope.textRounderUpdater(i(t)) + percentText;
                      };
                    }

                  };

                  text1.transition()
                    .duration(config.textRiseTime)
                    .tween("text", scope.textTween);
                };
              };
              return new scope.GaugeTextUpdater();
            }
          }
        }
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  function windowLocationHref($window) {
    var setWindowLocationHref = function (href) {
      $window.location.href = href;
    };
    var getIndexOfHref = function (href) {
      return $window.location.href.indexOf(href);
    };
    var redirectToProductsPageNotFound = function () {
      $window.location.assign(appConfig.productsUIUrl + '/#/pageNotFound');
    }
    return {
      setWindowLocationHref: setWindowLocationHref,
      getIndexOfHref: getIndexOfHref,
      redirectToProductsPageNotFound: redirectToProductsPageNotFound
    };
  }

  windowLocationHref.$inject = ['$window'];
  app.factory('WindowLocationHref', windowLocationHref);
})();

(function () {
    'use strict';

    var app = angular.module('NavisphereOnline');
    function userPermissionService(localStorageService, DEV_FEATURES) {
        var profilePermissions = [];

        var loadPermissions = function () {
            var permissions = localStorageService.get('permissions');
            profilePermissions =  permissions ? permissions : [];
        };

        var hasPermission = function (permissionName) {
            loadPermissions();
            for (var i = 0; i < profilePermissions.length; i++) {
                for (var j = 0; j < profilePermissions[i].permissions.length; j++) {
                    if (profilePermissions[i].permissions[j].name.toUpperCase().trim() === permissionName.toUpperCase().trim()) {
                        return true;
                    }
                }
            }
            return false;
        };

        var isSupplier = function() {
          var user = localStorageService.get('User');
          return user.isSupplier;
        };

        var inPermissionSet = function(permissionSet){
          loadPermissions();
          for (var i = 0; i < profilePermissions.length; i++){
            for (var j = 0; j < profilePermissions[i].permissions.length; j++) {
              if(_.includes(permissionSet, profilePermissions[i].permissions[j].name)){
                return true;
              }
            }
          }
          return false;
        };

        var hasCustomerRole = function (customerCode, roleName) {
            loadPermissions();
            for (var i = 0; i < profilePermissions.length; i++) {
                if (profilePermissions[i].customerProfile.customer.partyCode.replace(/^\s+|\s+$/gm, '') === customerCode.replace(/^\s+|\s+$/gm, '')) {
                    for (var j = 0; j < profilePermissions[i].permissions.length; j++) {
                        if (profilePermissions[i].permissions[j].name === roleName) {
                            return true;
                        }
                    }
                }
            }
            return false;
        };
        var getCustomersForRole = function(roleName) {
          var customersWithRole = [];
          loadPermissions();
          for (var i = 0; i < profilePermissions.length; i++) {
            for (var j = 0; j < profilePermissions[i].permissions.length; j++) {
              if (profilePermissions[i].permissions[j].name === roleName) {
                customersWithRole.push(profilePermissions[i].customerProfile.customer);
              }
            }
          }
          return customersWithRole;
        };

         //==========  REGION: In Dev Feature Toggle ==============

        var devFeatureToggles =  {};
        var localStorageKey_DevelopmentFeatureToggles = 'devFeatureToggles';

        var hasDevelopmentFeatureAccess = function(featureName) {

            //require feature to exist
            if(angular.isUndefined(DEV_FEATURES[featureName])) {
                return false;
            }

            var hasDevPermission = hasPermission("[Warning] Features In Development");
            if (!hasDevPermission) {
                return false;
            }

            loadDevelopmentFeatureToggles();
            return devFeatureToggles[featureName];
        }

        var saveDevelopmentFeatureToggle = function(featureName, isActive) {
            //require feature to exist
            if(angular.isUndefined(DEV_FEATURES[featureName])) {
                throw new Error(featureName + ' does not exist.');
            }

            loadDevelopmentFeatureToggles();

            devFeatureToggles[featureName] = isActive;
            localStorageService.set(localStorageKey_DevelopmentFeatureToggles, devFeatureToggles);
        }

        var getDevelopmentFeatureToggles = function() {
            loadDevelopmentFeatureToggles();
            return devFeatureToggles;
        }


        function loadDevelopmentFeatureToggles() {
            var toggles = localStorageService.get(localStorageKey_DevelopmentFeatureToggles);

            if (!toggles) {
                toggles = angular.copy(DEV_FEATURES);
                localStorageService.set(localStorageKey_DevelopmentFeatureToggles, toggles);
            }

            devFeatureToggles = toggles;
        }

        //==========  END REGION: In Dev Feature Toggle ==============


        return {
            isSupplier: isSupplier,
            hasPermission: hasPermission,
            inPermissionSet : inPermissionSet,
            hasCustomerRole: hasCustomerRole,
            getCustomersForRole: getCustomersForRole,
            hasDevelopmentFeatureAccess: hasDevelopmentFeatureAccess,
            getDevelopmentFeatureToggles: getDevelopmentFeatureToggles,
            saveDevelopmentFeatureToggle: saveDevelopmentFeatureToggle
        };
    }
    userPermissionService.$inject = ['localStorageService', 'DEV_FEATURES'];
    app.factory('UserPermissionService', userPermissionService);
})();

(function () {
  'use strict';

  /* @ngInject */
  function tokenService($timeout, $rootScope, $state, localStorageService, User,
    $translate, $q, WalkthroughService, WindowLocationHref, authClient, UserApplicationService, jwtHelper, LaunchDarklyService) {

    var logoutFunctions = [];
    const accessTokenKey = "accessToken";
    const idTokenKey = "idToken";

    function addTokensToManager(oktaAuth, accessToken, idToken){
      oktaAuth.tokenManager.add(accessTokenKey, accessToken);
      oktaAuth.tokenManager.add(idTokenKey, idToken);
    }

    function decodeToken(oktaAuth){
      var authData = localStorageService.get('auth.data');
      var decodedAccessToken = oktaAuth.token.decode(authData.accessToken);
      var decodedIdToken = oktaAuth.token.decode(authData.identityToken);
      return {
        accessToken: authData.accessToken,
        accessTokenExpirationDate: decodedAccessToken.payload.exp,
        identityToken: authData.identityToken,
        idTokenExpirationDate: decodedIdToken.payload.exp
      };
    }

    return {
      addTokensToManager: addTokensToManager,
      decodeToken: decodeToken
    };
  }
  tokenService.$inject = ['$timeout', '$rootScope', '$state', 'localStorageService', 'User',
  '$translate', '$q', 'WalkthroughService', 'WindowLocationHref', 'authClient', 'UserApplicationService', 'jwtHelper', 'LaunchDarklyService'];

  angular
    .module('NavisphereOnline')
    .service('tokenService', tokenService);
})();

//angular module based on https://github.com/cowboy/jquery-throttle-debounce/blob/master/jquery.ba-throttle-debounce.js
(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    app.factory('ThrottleDebounce', ['$timeout', function ($timeout) {

        var throttle = function (delay, no_trailing, callback, debounce_mode) {
            var timeout_id,
            last_exec = 0;

            if (typeof no_trailing !== 'boolean') {
                debounce_mode = callback;
                callback = no_trailing;
                no_trailing = undefined;
            }

            var wrapper = function () {
                var that = this,
                    elapsed = +new Date() - last_exec,
                    args = arguments,
                    exec = function () {
                        last_exec = +new Date();
                        callback.apply(that, args);
                    },

                    clear = function () {
                        timeout_id = undefined;
                    };

                if (debounce_mode && !timeout_id) {
                    exec();
                }

                if (timeout_id) {
                    $timeout.cancel(timeout_id);
                }

                if (angular.isUndefined(debounce_mode) && elapsed > delay) {
                    exec();
                }
                else if (no_trailing !== true) {
                    timeout_id = $timeout(debounce_mode ? clear : exec, angular.isUndefined(debounce_mode) ? delay - elapsed : delay);
                }
            };
            return wrapper;
        };

        var debounce = function (delay, at_begin, callback) {
            return angular.isUndefined(callback)? throttle(delay, at_begin, false) : throttle(delay, callback, at_begin !== false);
        };

        return {
            throttle: throttle,
            debounce: debounce
        }
    }]);
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    function statusMappingService() {

        this.serviceStatus = {
            incomplete : 371,
            readyToPlan: 372,
            partiallyPlanned: 373,
            planned: 374,
            partiallyBooked: 375,
            booked: 376,
            intransit: 377,
            delivered: 378
        };

        this.getStatusResourceKey = function (serviceStatusRDN) {
            var resourceKey = '';
            switch (serviceStatusRDN) {
                case this.serviceStatus.incomplete:
                    resourceKey = 'INCOMPLETE';
                    break;
                case this.serviceStatus.readyToPlan:
                case this.serviceStatus.partiallyPlanned:
                case this.serviceStatus.planned:
                    resourceKey = 'ORDERED';
                    break;
                case this.serviceStatus.booked:
                case this.serviceStatus.partiallyBooked:
                    resourceKey = 'BOOKED';
                    break;
                case this.serviceStatus.intransit:
                    resourceKey = 'INTRANSIT';
                    break;
                case this.serviceStatus.delivered:
                    resourceKey = 'DELIVERED';
                    break;
                default:
                    resourceKey = 'ORDERED';
                    break;
            }
            return resourceKey;
        };
    }
    app.service('StatusMappingService', statusMappingService);
})();
(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');

    function ServiceOfferingMapping() {

        var servOffMap = {

            //service offerings
            FLATBED_SERVICE_OFFERING: 1482,
            LTL_SERVICE_OFFERING: 1484,
            TL_SERVICE_OFFERING: 1481,
            LTL_TRANSPORTATION: 1,
            LTL_FLATBED_TRANSPORTATION: 2,
            LTL_TEMP_CONTROLLED_TRANSPORTATION: 3,
            TRUCKLOAD_TRANSPORTATION: 5,
            TRUCKLOAD_TEMP_CONTROLLED_TRANSPORTATION: 6,
            TRUCKLOAD_FLATBED_TRANSPORTATION: 7,
            RAIL_INTERMODAL_TRANSPORTATION: 11,
            DOMESTIC_AIR_TRANSPORTATION: 13,
            LTL_EXPEDITED_TRANSPORTATION: 23,
            LTL_TEMP_CONTROLLED_EXPEDITED_TRANSPORTATION: 25,
            TRUCKLOAD_EXPEDITED_TRANSPORTATION: 27,
            TRUCKLOAD_TEMP_CONTROLLED_EXPEDITED_TRANSPORTATION: 28,
            INTERNATIONAL_AIR_HOUSE: 1084,
            INTERNATIONAL_AIR_DIRECT: 1085,
            INTERNATIONAL_OCEAN_NVOCC: 1086,
            DOMESTIC_AIR_SERVICE_OFFERING: 1293,
            INTERMODAL_FULL_CONTAINER_TRANSPORTATION: 1336,
            INTERMODAL_FULL_TEMP_CONTROLLED_TRANSPORTATION: 1338,
            PRODUCE_TRUCKLOAD_TEMP_CONTROLLED_TRANSPORTATION: 1386,
            PRODUCE_LTL_TEMP_CONTROLLED_TRANSPORTATION: 1389,
            BROKER_SOURCING_DIRECT_SHIP_OTHER: 1475,
            CONSOLIDATED_TRANSPORTATION: 1477,
            CONSOLIDATED_TEMP_CONTROLLED_TRANSPORTATION: 1479,
            BULK_TRANSPORTATION: 1480,
            TRUCKLOAD_TEMP_CONTROLLED_SERVICE_OFFERING: 1483,
            LTL_FLATBED_SERVICE_OFFERING: 1485,
            LTL_TEMP_CONTROLLED_SERVICE_OFFERING: 1486,
            SMALL_PARCEL: 1709,
            INTERMODAL_FULL_TEMP_CONTROLLED_SERVICE_OFFERING: 1764,
            BULK_SERVICE_OFFERING: 1765,
            CONSOLIDATED_SERVICE_OFFERING: 1766,
            CONSOLIDATED_TEMP_CONTROLLED_SERVICE_OFFERING: 1767,
            SMALL_PARCEL_TRANSPORTATION: 1815,
            OCEAN: 1840,
            TRUCKLOAD_TAUTLINER: 1841,
            TRUCKLOAD_TAUTLINER_EUROPE: 1846,
        };

        this.getServiceOfferingId = function (itemName) {
            return servOffMap[itemName];
        };
    }
    app.service('ServiceOfferingMapping', ServiceOfferingMapping);
})();

(function () {

    'use strict';

    var app = angular.module('NavisphereOnline');
    serviceOffering.$inject = ['ServiceOfferingMapping', '$filter'];

    function serviceOffering(ServiceOfferingMapping, $filter) {
        function get(serviceOfferingNumber) {
            var offering = {};
            switch (serviceOfferingNumber) {
                case ServiceOfferingMapping.getServiceOfferingId('TL_SERVICE_OFFERING'):
                case ServiceOfferingMapping.getServiceOfferingId('TRUCKLOAD'):
                case ServiceOfferingMapping.getServiceOfferingId('TRUCKLOAD_EXPEDITED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('TRUCKLOAD_TAUTLINER'):
                case ServiceOfferingMapping.getServiceOfferingId('TRUCKLOAD_TAUTLINER_EUROPE'):
                    //TL-dry
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('TRUCKLOAD');
                    offering.serviceOfferingIconUrl = 'truckload';
                    offering.genericType = 'TL';
                    break;
                case 'TL':
                case 'Truck':
                case ServiceOfferingMapping.getServiceOfferingId('TL'):
                case ServiceOfferingMapping.getServiceOfferingId('TRUCKLOAD_TEMP_CONTROLLED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('TRUCKLOAD_TEMP_CONTROLLED_EXPEDITED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('PRODUCE_TRUCKLOAD_TEMP_CONTROLLED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('TRUCKLOAD_TEMP_CONTROLLED_SERVICE_OFFERING'):
                    //TL-temp
                    offering.displayDryHours = false;
                    offering.serviceOfferingName = $filter('translate')('TRUCKLOAD');
                    offering.serviceOfferingIconUrl = 'truckload';
                    offering.genericType = 'TL';
                    break;
                case 'LTL':
                case ServiceOfferingMapping.getServiceOfferingId('LTL_SERVICE_OFFERING'):
                case ServiceOfferingMapping.getServiceOfferingId('LTL_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('LTL_EXPEDITED_TRANSPORTATION'):
                    //LTL-dry
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('LTL');
                    offering.serviceOfferingIconUrl = 'ltl';
                    offering.genericType = 'LTL';
                    break;
                case ServiceOfferingMapping.getServiceOfferingId('LTL_TEMP_CONTROLLED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('LTL_TEMP_CONTROLLED_EXPEDITED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('PRODUCE_LTL_TEMP_CONTROLLED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('LTL_TEMP_CONTROLLED_SERVICE_OFFERING'):
                    //LTL-temp
                    offering.displayDryHours = false;
                    offering.serviceOfferingName = $filter('translate')('LTL');
                    offering.serviceOfferingIconUrl = 'ltl';
                    offering.genericType = 'LTL';
                    break;
                case 'Flatbed':
                case ServiceOfferingMapping.getServiceOfferingId('FLATBED_SERVICE_OFFERING'):
                case ServiceOfferingMapping.getServiceOfferingId('LTL_FLATBED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('TRUCKLOAD_FLATBED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('LTL_FLATBED_SERVICE_OFFERING'):
                    //flatbed
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('FLATBED');
                    offering.serviceOfferingIconUrl = 'flatbed';
                    offering.genericType = 'FLATBED';
                    break;
                case 'AIR':
                case 'DAIR':
                case ServiceOfferingMapping.getServiceOfferingId('DOMESTIC_AIR_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('DOMESTIC_AIR_SERVICE_OFFERING'):
                    //domestic-air
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('AIR');
                    offering.serviceOfferingIconUrl = 'airplane';
                    offering.genericType = 'AIR';
                    break;
                case 'IAIR':
                case ServiceOfferingMapping.getServiceOfferingId('INTERNATIONAL_AIR_HOUSE'):
                case ServiceOfferingMapping.getServiceOfferingId('INTERNATIONAL_AIR_DIRECT'):
                    //international-air
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('AIR');
                    offering.serviceOfferingIconUrl = 'airplane';
                    offering.genericType = 'AIR';
                    break;
                case 'Consol':
                case ServiceOfferingMapping.getServiceOfferingId('CONSOLIDATED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('CONSOLIDATED_SERVICE_OFFERING'):
                    //consol-dry
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('CONSOLIDATED');
                    offering.serviceOfferingIconUrl = 'consolidated';
                    offering.genericType = 'CONSOLIDATED';
                    break;
                case ServiceOfferingMapping.getServiceOfferingId('CONSOLIDATED_TEMP_CONTROLLED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('CONSOLIDATED_TEMP_CONTROLLED_SERVICE_OFFERING'):
                    //consol-temp
                    offering.displayDryHours = false;
                    offering.serviceOfferingName = $filter('translate')('CONSOLIDATED');
                    offering.serviceOfferingIconUrl = 'consolidated';
                    offering.genericType = 'CONSOLIDATED';
                    break;
                case ServiceOfferingMapping.getServiceOfferingId('SMALL_PARCEL'):
                case ServiceOfferingMapping.getServiceOfferingId('SMALL_PARCEL_TRANSPORTATION'):
                    //smallparcel
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('SMALL_PARCEL');
                    offering.serviceOfferingIconUrl = 'parcel';
                    offering.genericType = 'PARCEL';
                    break;
                case 'IMDL':
                case ServiceOfferingMapping.getServiceOfferingId('INTERMODAL_FULL_CONTAINER_TRANSPORTATION'):
                    //intermodal-dry
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('INTERMODAL');
                    offering.serviceOfferingIconUrl = 'intermodal';
                    offering.genericType = 'INTERMODAL';
                    break;
                case ServiceOfferingMapping.getServiceOfferingId('INTERMODAL_FULL_TEMP_CONTROLLED_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('INTERMODAL_FULL_TEMP_CONTROLLED_SERVICE_OFFERING'):
                    //intermodal-temp
                    offering.displayDryHours = false;
                    offering.serviceOfferingName = $filter('translate')('INTERMODAL');
                    offering.serviceOfferingIconUrl = 'intermodal';
                    offering.genericType = 'INTERMODAL';
                    break;
                case 'Bulk':
                case ServiceOfferingMapping.getServiceOfferingId('BULK_TRANSPORTATION'):
                case ServiceOfferingMapping.getServiceOfferingId('BULK_SERVICE_OFFERING'):
                    //bulk
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('BULK');
                    offering.serviceOfferingIconUrl = 'bulk';
                    offering.genericType = 'BULK';
                    break;
                case 'Ocean':
                case ServiceOfferingMapping.getServiceOfferingId('INTERNATIONAL_OCEAN_NVOCC'):
                case ServiceOfferingMapping.getServiceOfferingId('OCEAN'):
                    //ocean
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('OCEAN');
                    offering.serviceOfferingIconUrl = 'cargo-ship';
                    offering.genericType = 'OCEAN';
                    break;
                case 'Rail':
                case ServiceOfferingMapping.getServiceOfferingId('RAIL_INTERMODAL_TRANSPORTATION'):
                    //rail
                    offering.displayDryHours = true;
                    offering.serviceOfferingName = $filter('translate')('RAIL');
                    offering.serviceOfferingIconUrl = 'train';
                    offering.genericType = 'RAIL';
                    break;
                default:
                    offering.serviceOfferingIconUrl = 'alert';
                    break;
            }
            return offering;
        }

        return {
            get: get
        };
    }

    app.factory('ServiceOffering', serviceOffering);
})();

(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  refDataMappingService.$inject = ['$filter', '$q', 'ReferenceData'];
  function refDataMappingService($filter, $q, ReferenceData) {

    var cacheItems = {};

    //refnumcategories by RefDataCategoryNumber
    var categoryMap = {};
    categoryMap.PACKAGING = 43;
    categoryMap.FREIGHT_CLASS = 44;
    categoryMap.TARP_TYPE = 219;
    categoryMap.LOADING_TYPE = 220;
    categoryMap.EQUIPMENT_TYPE = 98;
    categoryMap.TEMP_CATEGORY = 45;
    categoryMap.TEMP_UNIT_CATEGORY = 86;
    categoryMap.SHIPWITH_NUMBER = 3958;
    categoryMap.PICKUP_NUMBER = 356;
    categoryMap.DELIVERY_NUMBER = 351;
    categoryMap.BOL_NUMBER = 347;
    categoryMap.ORION_STATUS = 41;
    categoryMap.CARRIER_PRO_NUMBER = 2113;
    categoryMap.TRACKING_NUMBER = 5167;
    categoryMap.CUSTOMER_PO_NUMBER = 350;
    categoryMap.FREIGHT_TERM_COLLECT = 2505;
    categoryMap.QUOTE_ID = 5204;


    var itemMap = {};
    //refnums by RefDataNumber
    itemMap.DRY_TEMP_CATEGORY = 425;
    itemMap.CUSTOM_TEMP_CATEGORY = 432;
    itemMap.CONFIRMATION_NUMBER = 348;
    itemMap.PURCHASE_ORDER_NUMBER = 183;
    itemMap.CANCELED_CONDITION = 384;
    itemMap.FREIGHT_CHARGES = 486;
    itemMap.CUSTOMER_CHARGES = 488;
    itemMap.BASELINE_CHARGES = 489;
    itemMap.LINE_HAUL = 514;
    itemMap.USD = 83;
    itemMap.CAD = 84;
    itemMap.MXN = 143;
    itemMap.VENDOR_PO_LINE_NUMBER = 4793;
    itemMap.FULFILMENT_ORDER_ITEM_IDENTIFIER = 4833;
    itemMap.PO_DRAW_SOURCE = 4791;
    //UOM
    itemMap.INCHES_UOM = 1278;
    itemMap.CENTIMETERS_UOM = 1280;
    itemMap.FEET_UOM = 1279;
    itemMap.METERS_UOM = 1281;
    itemMap.LB_UOM = 1283;
    itemMap.KG_UOM = 1284;
    itemMap.FAHRENHEIT_UOM = 1286;
    itemMap.CELSIUS_UOM = 1287;
    itemMap.CUBICFEET_UOM = 1289;
    itemMap.CUBICMETERS_UOM = 1290;

    this.getCategoryId = getCategoryId;
    function getCategoryId(categoryName) {
      return categoryMap[categoryName];
    }

    this.getItemId = function (itemName) {
      return itemMap[itemName];
    };

    this.getItemByRefNum = function (refNum) {
      for (var name in itemMap) {
        if (itemMap[name] === refNum) {
          return name;
        }
      }
      return '';
    };
    //limiting this to UOM because I know all the
    //names for UOM also exist as globalization keys
    this.getUomTranslationByRefNum = function (refNum) {
      for (var name in itemMap) {
        if (itemMap[name] === refNum) {
          return $filter('translate')(name);
        }
      }
      return '';
    };
    this.getReferenceDataByCategory = function(category){
        var categories = getRefDataCategoryDDLs();
        return categories[category];
    };
    this.getRefDataCategoryDDLs = function () {
      if (cacheItems && cacheItems.Packaging && cacheItems.Packaging.length > 0) {
        var deferred = $q.defer();
        var newItems = {};
        angular.copy(cacheItems, newItems);
        deferred.resolve(newItems);
        return deferred.promise;
      }
      var refDataCategoryDDLs = {};

      var promises = [];

      var refKeys = ['Packaging', 'FreightClass', 'FBedTarpType', 'FBedLoadingType', 'ItemEquipment','Freight_Term'];
      angular.forEach(refKeys, function (key) {
        promises.push(ReferenceData.get({
          categoryCode: key
        }, function (data) {
          var filteredArray = [];
          angular.forEach(data, function (datum) {
            if (datum.value) {
              if (datum.value.toLowerCase() !== 'empty') {
                datum.label = datum.value;
                filteredArray.push(datum);
              }
            }
          });
          refDataCategoryDDLs[key] = filteredArray;
        }).$promise);
      });

      promises.push(ReferenceData.get({
        categoryCode: 'TemperatureSensitive'
      }, function (data) {
        var filteredArray = [];
        angular.forEach(data, function (datum) {
          if (datum.value) {
            if (datum.value.toLowerCase() !== 'empty' && datum.value.toLowerCase() !== 'custom') {
              filteredArray.push(datum);
            }
          }
        });
        refDataCategoryDDLs['TemperatureSensitive'] = filteredArray;
      }).$promise);

      return $q.all(promises).then(function () {
        cacheItems = refDataCategoryDDLs;
        return refDataCategoryDDLs;
      });
    };
    this.getDdlValueByCategoryAndRefNum = function (category, refNum) {
      var value = '';
      if (cacheItems[category]) {
        for (var i = 0; i < cacheItems[category].length; i++) {
          if (cacheItems[category][i].refDataNumber === refNum) {
            value = cacheItems[category][i].value;
            break;
          }
        }
      }
      return value;
    }

    this.getWeightUnitRDNFromItem = function (item) {
      var weightUnitRDN = null;

      if (_.has(item, 'totalWeight.unitRDN')) {
        weightUnitRDN = item.totalWeight.unitRDN;
      } else if (_.has(item, 'unitLength.unitRDN')) {
        weightUnitRDN = getWeightRDNFromLinearUnitRDN(item.unitLength.unitRDN);
      } else if (_.has(item, 'unitWidth.unitRDN')) {
        weightUnitRDN = getWeightRDNFromLinearUnitRDN(item.unitWidth.unitRDN);
      } else if (_.has(item, 'unitHeight.unitRDN')) {
        weightUnitRDN = getWeightRDNFromLinearUnitRDN(item.unitHeight.unitRDN);
      }

      return weightUnitRDN;
    }

    this.getDefaultWeightUnitRDN = function (isMetric) {
      var weightUnitRDN = isMetric
        ? itemMap['KG_UOM']
        : itemMap['LB_UOM'];
      
      return weightUnitRDN;
    }

    function getWeightRDNFromLinearUnitRDN(rdn) {
      var isMetric;

      switch (rdn) {
        case 1278:
        case 1279:
          isMetric = false;
          break;
        case 1280:
        case 1281:
          isMetric = true;
          break;
        default:
          return null;
      }

      var weightRDN = isMetric
        ? itemMap['KG_UOM']
        : itemMap['LB_UOM'];

      return weightRDN;
    }
  }
  app.service('RefDataMappingService', refDataMappingService);
})();

(function () {
  'use strict';
  orderLockPromptService.$inject = [];
  function orderLockPromptService() {

    this.lock = null;
  }
  angular.module('NavisphereOnline').service('OrderLockPromptService', orderLockPromptService);
})();

(function () {
  'use strict';
  orderEntryPromptService.$inject = [];
  function orderEntryPromptService() {
    this.isEntryInProgress = false;
    this.setEntryInProgress = function (isEntryInProgress) {
      this.isEntryInProgress = isEntryInProgress;
    };

    this.getEntryInProgress = function () {
      return this.isEntryInProgress;
    };
  }
  angular.module('NavisphereOnline').service('OrderEntryPromptService', orderEntryPromptService);
})();

(function () {
    var app = angular.module('NavisphereOnline');
    notificationService.$inject = ['toastr'];
    function notificationService(toastr) {
        return {
            warn: function (header, message) {
              toastr.warn(message, header, {
                closeButton: true,
                timeOut: 0,
                extendedTimeOut: 0
              });
            },
            error: function (header, message) {
              toastr.error(message, header, {
                closeButton: true,
                  timeOut: 0,
                  extendedTimeOut: 0
              });
            },
            info: function (header, message) {
              toastr.info(message, header, {
                closeButton: false,
                timeOut: 5000,
                extendedTimeOut: 100
              });
            },
            success: function (header, message) {
              toastr.success(message, header, {
                closeButton: false,
                timeOut: 5000,
                extendedTimeOut: 1000
              });
            },
            orderProcessed: function (header, message, clickCallback) {
              toastr.success(message, header, {
                closeButton: true,
                timeOut: 20000,
                onTap: clickCallback,
                allowHtml: true
              });
            }
        };
    }

    app.service('NotificationService', notificationService);
})();

(function () {
    var app = angular.module('NavisphereOnline');

    function monetaryValueFormatService() {
        this.DisplayToHundredthsPlace = function(monetaryValue) {
            if (isNaN(monetaryValue) || monetaryValue == null) {
                return monetaryValue;
            }
            else {
                return monetaryValue.toFixed(2);
            }
        }
    }
    app.service('MonetaryValueFormatService', monetaryValueFormatService);
})();
(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');

    function modalService($uibModal) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            modalFade: true,
            templateUrl: '/app/common/customModal.tpl.html'
        };

        var modalOptions = {
            closeButtonText: 'Close',
            actionButtonText: 'OK',
            headerText: 'Proceed?',
            bodyText: 'Perform this action?',
            isError: false
        };

        this.showModal = function (customModalDefaults, customModalOptions) {
            if (!customModalDefaults) customModalDefaults = {};
            customModalDefaults.backdrop = 'static';
            return this.show(customModalDefaults, customModalOptions);
        };

        this.show = function (customModalDefaults, customModalOptions) {
            //Create temp objects to work with since we're in a singleton service
            var tempModalDefaults = {};
            var tempModalOptions = {};

            //Map angular-ui modal custom defaults to modal defaults defined in this service
            angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

            //Map modal.html $scope custom properties to defaults defined in this service
            angular.extend(tempModalOptions, modalOptions, customModalOptions);

            if (!tempModalDefaults.controller) {
                tempModalDefaults.controller = function ($scope, $uibModalInstance) {
                    $scope.modalOptions = tempModalOptions;
                    $scope.modalOptions.ok = function () {
                        $uibModalInstance.close('ok');
                    };
                    $scope.modalOptions.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                };

                tempModalDefaults.controller.$inject = ['$scope', '$uibModalInstance'];
            }

            return $uibModal.open(tempModalDefaults).result;
        };
    }

    modalService.$inject = ['$uibModal'];
    app.service('ModalService', modalService);
})();

(function() {
  "use strict";

  LocationSelectionHelper.$inject = ["DateTimeService", "LocationService"];

  function LocationSelectionHelper(DateTimeService, LocationService) {
    this.onLocationSelected = function (item, order, locationType, isRecent) {
      if (order[locationType] && order[locationType].notes) {
        item.notes = order[locationType].notes;
      }
      if (order[locationType] && order[locationType].volumeQuoteId) {
        item.volumeQuoteId = order[locationType].volumeQuoteId;
      }
      order[locationType] = item;
      order[locationType].earliestTime = DateTimeService.getBeginningOfDay();
      order[locationType].latestTime = DateTimeService.getBeginningOfDay();

      order[locationType + "HasNoResults"] = false;
      return LocationService.getLocation({
        locationPartyNumberOrCode: item.locationPartyCode,
        relatedLocationId: item.relatedLocationId,
        useSupplierLocation: order.customer.useSupplierLocation,
        dateTimeZoneHandling: 2
      }, function (data) {
        if (data) {
          order[locationType].dryShippingHours = data.dryShippingHours;
          order[locationType].dryReceivingHours = data.dryReceivingHours;
          if (data.notes) {
            order[locationType].notes = data.notes.substring(0, 255);
          }
          order[locationType].address = data.physicalAddress;
          order[locationType].partyCode = data.partyCode;
          order[locationType].partyNumber = data.partyNumber;
          order[locationType].physicalAddress = data.physicalAddress;
          order[locationType].generalAddress = data.generalAddress;
          order[locationType].relatedLocationId = data.relatedLocationId;
          order[locationType].loadingTypeRDN = data.loadingTypeRDN;
        }
        order[locationType].name = order[locationType].addressName;
      });
    };
  }

  angular.module("NavisphereOnline").service("LocationSelectionHelper", LocationSelectionHelper)
})();

(function () {
  'use strict';

  function LaunchDarklyService( $rootScope, $q) {
    function initLD (sevenLetter) {
      // Polyfill from MSDN to cover `LDClient.initialize` for IE11
      if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
          value: function(search, rawPos) {
              var pos = rawPos > 0 ? rawPos|0 : 0;
              return this.substring(pos, pos + search.length) === search;
            }
        });
      }

      var deferred = $q.defer();
      var ldclient = LDClient.initialize(
        appConfig.launchDarklyClientId,
        {key:sevenLetter, anonymous:true})
      ldclient.on('ready', function () {
        deferred.resolve(ldclient)
      })
      return deferred.promise
    }
    return {
      initLD: initLD
    };
  }

  LaunchDarklyService.$inject = ['$rootScope','$q'];
  angular.module("NavisphereOnline").factory("LaunchDarklyService", LaunchDarklyService);
})();

(function() {
  function FormService() {
    this.setDropdownSize = function (itemSearchInputId) {
      if (angular.isUndefined(itemSearchInputId) || itemSearchInputId === null) {
        itemSearchInputId='itemSearchInput';
      }
      var itemSearchInput = angular.element('#' + itemSearchInputId);
      var dropdownMenu = angular.element('#' + itemSearchInputId + ' + .dropdown-menu');
      var newWidth = (itemSearchInput.width() + parseInt(itemSearchInput.css('padding-left')) + parseInt(itemSearchInput.css('padding-right'))) + 'px';
      dropdownMenu.css('width', newWidth);
    }
  }

  angular.module("NavisphereOnline").service("FormService", FormService);
})();

(function () {
  "use strict";
  FilterService.$inject = [];

  function FilterService() {
    return {
      filterThorough: filterThorough
    };

    /**
     * Allows for multiple searches by category and across categories of filters.
     * Also allows for searching within a sub-array of the original array.
     *
     * @example 1
     * You want to filter cookies. You have three different filters, representing properties of cookie objects - size, kind, baker
     * The possible values in each category are as follows:
     * size: small, medium, large
     * kind: chocolate chip, oatmeal raisin, m&m
     * baker: Jack, Jill, Jenny, John
     *
     * If you wanted to search for small cookies baked by Jack or Jill of any kind, your filters object would look like this:
     *  [
     *    [
     *      { size: "small" }
     *    ], [
     *      { baker: "Jack" },
     *      { baker: "Jill" }
     *    ]
     *  ]
     *
     * @example 2 -- searching a sub-array
     * An order has the following 3 properties: status, type, and location
     * The possible values in each category are as follows:
     * status: booked, in-transit, delivered
     * type: type1, type2, type3
     * locations: an array of location objects, each with a name, city and state
     * order: {
     *           status: "booked",
     *           type: "type1",
     *           locations: [
     *             {name: "location1", city: "Minneapolis", state: "MN"},
     *             {name: "location2", city: "St. Paul", state: "MN"}
     *           ]
     *         }
     * You want to return only "booked" or "delivered" orders that have "Minneapolis" as the city on one of their locations.
     * Your filters parameter would look like this:
     *   [
     *     [
     *       {status: "booked"},
     *       {status: "delivered"}
     *     ], [
     *       {
     *         searchValue: "Minneapolis",
     *         searchSubArray: true,
     *         arrayName: "locations",
     *         propertyToCheck: "city"
     *        }
     *     ]
     *   ]
     *
     * @param originalArray - The full array. This will be trimmed down through each layer of recursion.
     * @param filters - An array of filter category arrays. Each filter category array should contain conditions to be tested.
     * @returns {Array} - List of filtered results. Can be the original array, an empty array, or something in between.
     */
    function filterThorough(originalArray, filters) {
      if (filters && filters.length) {
        var subsetContainer = [];

        _.forEach(filters[0], function (condition) {
          if(condition.searchSubArray){
            var filteredSubset = searchSubArray(originalArray, condition);
          } else {
            var filteredSubset = _.filter(originalArray, condition);
          }

          // Merges the filteredSubset into the subsetContainer.
          Array.prototype.push.apply(subsetContainer, filteredSubset);
        });

        filters = _.drop(filters);
        return filterThorough(subsetContainer, filters);
      }

      return originalArray;
    }

    /**
     * Searches for a given property value within an array of objects nested in the original array
     *
     * @param originalArray The full array to be filtered
     * @param condition An object with the following properties:
     *        searchValue: string,
     *        searchSubArray: boolean,
     *        arrayName: string,
     *        propertyToCheck: string
     * @returns {Array} List of filtered results
     */
    function searchSubArray(originalArray, condition) {
      var filteredResults = _.filter(originalArray, function(item) {
        var subArray = item[condition.arrayName];
        var valueFound = false;
        _.forEach(subArray, function(subArrayItem) {
          if(subArrayItem[condition.propertyToCheck] === condition.searchValue) {
            valueFound = true;
          }
        });
        return valueFound;
      });

      return filteredResults;
    }
}

  angular.module("NavisphereOnline").service("FilterService", FilterService);
})();

/*global moment */
(function () {
  var app = angular.module('NavisphereOnline');

  dateTimeService.$inject = ['$filter', 'moment'];

  function dateTimeService($filter, moment) {
    Date.prototype.addDays = function(days, date){
      if(!angular.isDefined){
        date = getToday();
      }
      date.setDate(date.getDate() + days);
      return date;
    };
    //get new date and add days based on a date, won't modify passed in date.
    var getDateAddDays = function(days, date) {
      var newDate;
      if(angular.isDefined(date)){
        newDate = new Date(date);
      }
      return Date.prototype.addDays(days, newDate);
    };
    var getToday = function () {
      var now = new Date();
      now.setHours(0, 0, 0, 0);

      return now;
    };

    var getDisplayTime = function(date, userPreferences) {
      if(!date){
        return '';
      }

      return $filter('time')({
        userPreferences: userPreferences,
        date: date
      });
    };

    var getDisplayDate = function(date) {
      if(!date){
        return '';
      }

      date = moment.utc(date);

      return $filter('date')(date.format("MM/DD/YYYY"));
    };

    var getDisplayShortDate = function (date) {
      if (!date){
        return '';
      }

      date = moment.utc(date);

      return $filter('date')(date.format("MM/DD"));
    };

    var getDisplayDateAndTime = function(date) {
      if(!date){
        return '';
      }

      return $filter('date')(new Date(date), 'short');
    };

    var isValidDateRange = function (fromDate, toDate) {
      if (fromDate == "" || toDate == "")
        return true;

      if (!isValidDate(fromDate))
        return false;

      var fromMoment = moment(new Date(fromDate));
      var toMoment = moment(new Date(toDate));

      if (!toMoment.isValid())
        return true;

      var diff = fromMoment.diff(toMoment, 'days');

      return diff <= 0;
    };

    var getDateTwoYearsFromNow = function () {
      var now = getToday();

      return now.setFullYear(now.getFullYear() + 2);
    };

    var getDateFirstOfMonth = function () {

      var date = new Date();
      var firstofmonth = new Date(date.getFullYear(), date.getMonth(), 1);

      return firstofmonth;
    };

    var isValidDate = function (dateStr) {
      if (dateStr == undefined)
        return false;
      var dateTime = Date.parse(dateStr);

      return !isNaN(dateTime);
    };

    var getWeekDayName = function(day) {
      var weekDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      return weekDays[day];
    };

    var getLatestDateMinDate = function (newDate) {

      if (!newDate)
        return getToday();

      return newDate;
    };

    var getRawDateTime = function (dateTime) {
      if (dateTime) {
        var rawDateTimeInfo = dateTime.split("T");
        var rawDate = rawDateTimeInfo[0].split("-");
        var rawTime = rawDateTimeInfo[1].substring(0, 8).split(":");
        var rawDateTime = new Date(rawDate[0], parseInt(rawDate[1]) - 1, rawDate[2], rawTime[0], rawTime[1], rawTime[2]);
        return rawDateTime;
      }
      return null;
    };

    var startDateTimeLessThanOrEqualEndDateTime = function(startDate,startTime,endDate,endTime) {
      var startDateTime = new Date(startDate.getYear(), startDate.getMonth(), startDate.getDate(), startTime.getHours(), startTime.getMinutes(), 0, 0);
      var endDateTime = new Date(endDate.getYear(), endDate.getMonth(), endDate.getDate(), endTime.getHours(), endTime.getMinutes(), 0, 0);


      return startDateTime <= endDateTime;
    };

    var getDisplayDateTime = function (dateTime, userPreferences) {

      if (!dateTime) {
        return null;
      }
      var serverDateTime = null;

      var actualArrivalDateTimeInfo = dateTime.split("T");
      var dateParts = actualArrivalDateTimeInfo[0].split("-");
      var timeParts = actualArrivalDateTimeInfo[1].substring(0, 8).split(":");

      serverDateTime = getServerDateTime(timeParts, dateParts);
      if (serverDateTime) {
        var time = serverDateTime.getHours();
        return (time > 0)
          ? $filter('date')(serverDateTime, 'shortDate') + ' at ' + $filter('time')({
          userPreferences: userPreferences,
          date: serverDateTime
        })
          : $filter('date')(serverDateTime, 'shortDate');

      }
      return null;
    };

    var getDisplayDateOrTime = function (dateTime, userPreferences, getTime) {
      var dateParts = null;
      var timeParts = null;

      if (dateTime) {
        var dateInfo = dateTime.split("T");
        dateParts = dateInfo[0].split("-");
        timeParts = dateInfo[1].substring(0, 8).split(":");
      }

      var serverDateTime = getServerDateTime(timeParts, dateParts);
      if (serverDateTime) {
        return getTime ?
          $filter('time')({
            userPreferences: userPreferences,
            date: serverDateTime
          }) :
          $filter('date')(serverDateTime, 'shortDate');
      }
      return null;
    };

    function getServerDateTime(timeParts, dateParts) {
      var serverDateTime = null;
      if ((timeParts && timeParts.length > 2) && (dateParts && dateParts.length > 2)) {
        serverDateTime = new Date(dateParts[0], parseInt(dateParts[1]) - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
      } else if (dateParts && dateParts.length > 2) {
        serverDateTime = new Date(dateParts[0], parseInt(dateParts[1]) - 1, dateParts[2]);
      }
      return serverDateTime;
    }

    function isLocalTimePastTwoPMEastern (currentDate) {
      var date = new Date();
      var estTime = moment().tz('America/New_York').format('HH');

      if (parseInt(estTime) >= 14) {
        var currentDate = currentDate.getDate();
        if(currentDate == date.getDate()) {
          return true
        }
      }
      return false;
    }

    function getBeginningOfDay(){
      return moment().startOf('day').toDate();
    }

    function areDatesEqual(firstDate, secondDate) {
      return moment.utc(firstDate).startOf('day').isSame(moment.utc(secondDate).startOf('day'));
    }

    function isDateBefore(firstDate, secondDate) {
      return moment.utc(firstDate).startOf('day').isBefore(moment.utc(secondDate).startOf('day'));
    }

    return {
      getDateAddDays: getDateAddDays,
      isValidDateRange: isValidDateRange,
      isValidDate: isValidDate,
      getToday: getToday,
      getDateTwoYearsFromNow: getDateTwoYearsFromNow,
      getLatestDateMinDate: getLatestDateMinDate,
      getWeekDayName: getWeekDayName,
      getRawDateTime: getRawDateTime,
      startDateTimeLessThanOrEqualEndDateTime: startDateTimeLessThanOrEqualEndDateTime,
      getDisplayDateAndTime: getDisplayDateAndTime,
      getDisplayDateTime: getDisplayDateTime,
      getDisplayDateOrTime: getDisplayDateOrTime,
      getDisplayDate: getDisplayDate,
      getDisplayShortDate: getDisplayShortDate,
      getDisplayTime: getDisplayTime,
      getDateFirstOfMonth: getDateFirstOfMonth,
      getBeginningOfDay: getBeginningOfDay,
      isLocalTimePastTwoPMEastern: isLocalTimePastTwoPMEastern,
      areDatesEqual: areDatesEqual,
      isDateBefore: isDateBefore
    };
  }
  app.service('DateTimeService', dateTimeService);
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');

    function customerService() {
        this.GetDisplayName = function (customer) {
            var displayName = '';

            if (angular.isUndefined(customer) || customer === null) {
                return displayName;
            }

            if (customer.name) {
                displayName = customer.name;
            }

            if (customer.partyCode) {
                if (displayName) {
                    displayName += ' - ' + customer.partyCode;
                } else {
                    displayName = customer.partyCode;
                }
            }
            return displayName;
        }
    }
    app.service('CustomerService', customerService);
}());

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    conversionService.$inject = [];
    function conversionService() {
        this.convertKGtoLB = function(kgValue, decimalPlaces) {
            if (!kgValue) {
                return 0;
            }
            var lbValue = kgValue * 2.2046;
            if (decimalPlaces && isFinite(Number(decimalPlaces))) {
                lbValue = parseFloat(lbValue.toFixed(decimalPlaces));
            }
            return lbValue;
        };
        this.convertLBtoKG = function(lbValue, decimalPlaces) {
            if (!lbValue) {
                return 0;
            }
            var kgValue = lbValue * 0.4536;
            if (decimalPlaces && isFinite(Number(decimalPlaces))) {
                kgValue = parseFloat(kgValue.toFixed(decimalPlaces));
            }
            return kgValue;
        };
    }
    app.service('ConversionService', conversionService);
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    carrierRuleService.$inject = ['ServiceOfferingMapping'];
    function carrierRuleService(ServiceOfferingMapping) {
        this.showCarrier = function (serviceOfferingId,isMultiLeg) {
            var LTLServiceOfferings = [
                ServiceOfferingMapping.getServiceOfferingId('LTL_SERVICE_OFFERING'),
                ServiceOfferingMapping.getServiceOfferingId('LTL_TRANSPORTATION'),
                ServiceOfferingMapping.getServiceOfferingId('LTL_EXPEDITED_TRANSPORTATION'),
                ServiceOfferingMapping.getServiceOfferingId('LTL_TEMP_CONTROLLED_TRANSPORTATION'),
                ServiceOfferingMapping.getServiceOfferingId('LTL_TEMP_CONTROLLED_SERVICE_OFFERING'),
                ServiceOfferingMapping.getServiceOfferingId('LTL_TEMP_CONTROLLED_EXPEDITED_TRANSPORTATION'),
                ServiceOfferingMapping.getServiceOfferingId('PRODUCE_LTL_TEMP_CONTROLLED_TRANSPORTATION')
            ];
            return LTLServiceOfferings.indexOf(serviceOfferingId) > -1  && isMultiLeg=== false;
        };
    }
    app.service('CarrierRuleService', carrierRuleService);
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    app.factory('CaretPositionService', ['$document', function ($document) {

        var getCaretPosition = function (inputField) {
            var position = 0;
            // IE Support
            if ($document[0].selection) {
                inputField.focus();
                // To get cursor position, get empty selection range
                var emptySelection = $document[0].selection.createRange();
                // Move selection start to 0 position
                emptySelection.moveStart('character', -inputField.value.length);
                // The caret position is selection length
                position = emptySelection.text.length;
            }
            else if (inputField.type !== 'number' && (inputField.selectionStart || inputField.selectionStart == 0)) {
                position = inputField.selectionStart;
            }
            return position;
        };

        var setCaretPosition = function (inputElement, position) {
            if (inputElement.createTextRange) {
                var range = inputElement.createTextRange();
                range.move('character', position);
                range.select();
            }
            else {
                if (inputElement.type !== 'number' && inputElement.selectionStart) {
                    inputElement.focus();
                    inputElement.setSelectionRange(position, position);
                }
                else {
                    inputElement.focus();
                }
            }
        };

        return {
            getCaretPosition: getCaretPosition,
            setCaretPosition: setCaretPosition
        };
    }]);
})();

(function () {
  'use strict';

  /* @ngInject */
  function authService($timeout, $rootScope, $state, localStorageService, User, tokenService,
    $translate, $q, WalkthroughService, WindowLocationHref, authClient, UserApplicationService, jwtHelper, LaunchDarklyService, AcknowledgementHelper) {

    var logoutFunctions = [];
    const accessTokenKey = "accessToken";
    const idTokenKey = "idToken";

    /**
     * Adds a function to the list of functions that we need to execute when we want to logout the user.
     * For example, if we need to clear an order lock
     * @constructor
     * @param {function} logoutFunction - The function we need to run on logout.
     */
    function addLogoutFunction(logoutFunction) {
      logoutFunctions.push(logoutFunction);
    }

    function login() {
      var oktaAuth = authClient.getClient();

      oktaAuth.token.getWithRedirect({
          responseType:  [
            'token',
            'id_token'
          ],
          scopes: [
            'openid',
						'profile',
						'email',
						'groups'
          ],
          redirectUri: getRedirectUri()
      });
    }

    function loginInterop(userId, token, redirectUrl) {
      clearData();
      localStorageService.set('redirectUrl', redirectUrl);

      var oktaAuth = authClient.getClient();

      oktaAuth.token.getWithRedirect({
        responseType:  [
          'token',
          'id_token'
        ],
        scopes: [
          'openid',
					'profile',
					'email',
					'groups'
        ],
        redirectUri: getRedirectUri()
      });

    }

    function clearData() {
      localStorageService.clearAll();
      $translate.refresh();
    }

    /**
     * Function to run to logout a user.  We also need to run all of the functions that have been set as
     * required to execute before a user can be logged out.  For example, if we need to clear an order lock
     */
    function logout() {
      var promises = [],
          oktaAuth = authClient.getClient(),
          baseUrl = appConfig.baseUrl ? appConfig.baseUrl : location.origin;

      _.forEach(logoutFunctions, function (logoutFunction) {
        promises.push(logoutFunction());
      });
      var redirectUrl = localStorageService.get('redirectUrl');
      $q.all(promises)
        .then(function () {
          localStorageService.set('redirectUrl', redirectUrl);
          clearData();
          oktaAuth.session.exists()
            .then(function(exists) {
              if (exists) {
                oktaAuth.signOut({ revokeAccessToken: false });
              } else {
                window.location.assign(baseUrl);
              }
            });
        })
        .catch(function () {
          localStorageService.set('redirectUrl', redirectUrl);
          clearData();

          oktaAuth.session.exists()
            .then(function(exists) {
              if (exists) {
                oktaAuth.signOut({revokeAccessToken: false});
              } else {
                window.location.assign(baseUrl);
              }
            });
        });
    }

    function checkApplicationAccess() {
      var applications = localStorageService.get("users.applications");
      var application = applications && _.find(applications, function(application) {
          return application.applicationId === 1;
        });
      if(!application || !application.isEnabled) {
        WindowLocationHref.redirectToProductsPageNotFound();
      }
    }

    function authorizeUser() {
      var deferred = $q.defer();
      if(localStorageService.get("users.applications") === null) {
        // getUserApplication should return an empty list if the user is not found e.g. Vision users
        UserApplicationService.getUserApplications().$promise.then(function (data) {
          localStorageService.set("users.applications", data && data.applications);
          checkApplicationAccess();
          deferred.resolve();
        });
      } else {
        checkApplicationAccess();
        deferred.resolve();
      }
      return deferred.promise;
    }

    function getUserDataAndRedirect() {

      User.get().$promise.then(function (userInfo) {
        localStorageService.set("User", userInfo);
        $q.all([
          User.getCustomerProfilePermissions().$promise,
          User.getPreferences().$promise,
          WalkthroughService.getAllWalkthroughs({
            userId: userInfo.userId
          }).$promise,
          UserApplicationService.getUserApplications().$promise

        ]).then(function (result) {
          localStorageService.set("permissions", result[0]);
          localStorageService.set("preferences", result[1]);
          localStorageService.set("walkthroughs", result[2]);
          localStorageService.set("users.applications", result[3] && result[3].applications);

        }).catch(function (err) {
          console.log(err);

        }).finally(function(){
          authorizeUser().then(function() {
            var redirectUrl = localStorageService.get('redirectUrl');
            if (redirectUrl) {
              localStorageService.remove("redirectUrl");
              var shouldReload = (window.location.href === redirectUrl);
              shouldReload ? window.location.reload() : window.location.replace(decodeURIComponent(redirectUrl));
            } else {
              var preferences = localStorageService.get("preferences");
              var notConfirmed = (preferences && !preferences.preferencesConfirmed);
              notConfirmed ? $state.go('app.userPreferences') : $state.go('app.dashboard');
            }
          });
        });
      }).catch(function(err){
        authorizeUser().then(function(){
          //if no redirect, then logout
          logout();
        })
      });
    }

    function getUserData() {
      User.get().$promise
          .then(function (userInfo) {
            localStorageService.set("User", userInfo);
            $q.all([
              User.getCustomerProfilePermissions().$promise,
              User.getPreferences().$promise,
              WalkthroughService.getAllWalkthroughs({
                userId: userInfo.userId
              }).$promise,
              UserApplicationService.getUserApplications().$promise
            ])
              .then(function (result) {
                localStorageService.set("permissions", result[0]);
                localStorageService.set("preferences", result[1]);
                localStorageService.set("walkthroughs", result[2]);
                localStorageService.set("users.applications", result[3] && result[3].applications);
              })
              .catch(function (err) {
                console.log(err);
              });
          });
    }

    function getAccessToken() {
      var authToken = localStorageService.get('auth.data');
      if (authToken && authToken.accessToken) {
        try {
          if (!jwtHelper.isTokenExpired(authToken.accessToken)) {
            return authToken.accessToken;
          };
        } catch (err) {
          clearData();
        }
      }

      return null;
    }

    function getIdToken() {
      var authToken = localStorageService.get('auth.data');
      if (authToken && authToken.idToken) {
        try {
          if (!jwtHelper.isTokenExpired(authToken.idToken)) {
            return authToken.idToken;
          };
        } catch (err) {
          clearData();
        }
      }

      return null;
    }

    function getPreferences() {
      var preferences;
      if (localStorageService.get('preferences')) {
        preferences = localStorageService.get('preferences');
      }
      return preferences;
    }

    function getPermissions() {
      var permissions;
      if (localStorageService.get('permissions')) {
        permissions = localStorageService.get('permissions');
      }
      return permissions;
    }

    function isLoggedIn() {
      return !!getAccessToken();
    }

    function authenticate(oktaAuth) {
      if(location.hash.indexOf('access_token') !== -1) {
        // remove trailing / angular because Okta parse fails to retrieve params from hash
        var hashless = location.toString().replace('#/', '#');
        history.replaceState({}, '', hashless);
      }
      oktaAuth.token.parseFromUrl()
        .then(function(res) {
          var authData  = {
            accessToken: res.tokens.accessToken.accessToken,
            identityToken: res.tokens.idToken.idToken
          };
          localStorageService.set('auth.data', authData );
          tokenService.addTokensToManager(oktaAuth, res.tokens.accessToken, res.tokens.idToken);
        })
        .catch(function() {});
    }

    function errorCatch(error)
    {
      login();
      throw new AuthError(error.errorCode, error.message);
    }

    function checkAuthSession(){
      var oktaAuth = authClient.getClient();
      try{
        oktaAuth.session.get()
        .then(function(session){
          if(session.status === "ACTIVE"){
            oktaAuth.token.getWithoutPrompt({
              scopes:[
                'openid',
                'profile',
                'email',
                'groups'
              ],
              responseType: ['token', 'id_token'],
              sessionToken: session.id,
            })
            .then(function(res){
              var authData  = {
                accessToken: res.tokens.accessToken.accessToken,
                identityToken: res.tokens.idToken.idToken
              };

              if(!!authData.accessToken && !!authData.identityToken){
                localStorageService.set('auth.data', authData );
                getUserDataAndRedirect();

              } else {
                logout();
              }
            });
          } else {
            logout();
          }
        });

      } catch(err){
        logout();
      }
    }

    function setupTokenManager(oktaAuth)
    {
      const accessTokenKey = "accessToken";
      const idTokenKey = "idToken";
      const scopes = ['openid', 'profile', 'email', 'groups'];

      var tokenValues = tokenService.decodeToken(oktaAuth);

      var accessToken =
      {
        scopes: scopes,
        expiresAt: tokenValues.accessTokenExpirationDate,
        accessToken: tokenValues.accessToken
      }
      var idToken =
      {
        scopes: scopes,
        expiresAt: tokenValues.idTokenExpirationDate,
        idToken: tokenValues.identityToken
      }

      tokenService.addTokensToManager(oktaAuth, accessToken, idToken);

      oktaAuth.tokenManager.on('expired', function(key){
        oktaAuth.tokenManager.renew(key)
        .then(function(){
          oktaAuth.tokenManager.get(accessTokenKey)
          .then(function(newAccessToken) {
            oktaAuth.tokenManager.get(idTokenKey)
            .then(function(newIdToken){
              localStorageService.set('auth.data', {accessToken: newAccessToken.value, identityToken: newIdToken.value});
            })
            .catch(errorCatch);
          })
          .catch(errorCatch);
        })
        .catch(errorCatch);
      });
    }

    function getRedirectUri() {
      var baseUri = document.baseURI;
      if (!baseUri) {
        var baseNode = document.querySelector('base');
        if (baseNode) {
          baseUri = baseNode.getAttribute('href');
        }
      }

      var result = baseUri || window.location.protocol + '//' + window.location.host + window.location.pathname;

      var hashIndex = result.indexOf('#');
      if (hashIndex !== -1) {
        result = result.substring(0, hashIndex);
      }

      return result.toLowerCase();
    }

    function readAcknowledgements() {
      AcknowledgementHelper.getAcknowledgements();
    }

    return {
      login: login,
      logout: logout,
      getAccessToken: getAccessToken,
      getIdToken: getIdToken,
      isLoggedIn: isLoggedIn,
      getPreferences: getPreferences,
      getPermissions: getPermissions,
      getUserDataAndRedirect: getUserDataAndRedirect,
      addLogoutFunction: addLogoutFunction,
      loginInterop: loginInterop,
      authenticate: authenticate,
      authorizeUser: authorizeUser,
      getUserData: getUserData,
      setupTokenManager: setupTokenManager,
      readAcknowledgements: readAcknowledgements,
      checkAuthSession: checkAuthSession
    };
  }

  authService.$inject = ['$timeout', '$rootScope', '$state', 'localStorageService', 'User', 'tokenService',
    '$translate', '$q', 'WalkthroughService', 'WindowLocationHref', 'authClient', 'UserApplicationService', 'jwtHelper', 'LaunchDarklyService', 'AcknowledgementHelper'];

  angular
    .module('NavisphereOnline')
    .service('authService', authService);
})();

(function() {
  'use strict';

  angular
    .module('NavisphereOnline')
    .factory('analyticsService', analyticsService);

  /** @ngInject */
  analyticsService.$inject = ['$log', 'satellite'];
  function analyticsService($log, satellite) {
    var track = function(ruleName) {
      try {
        satellite.track(ruleName);
      } catch (e) {
        logError(e);
      }
    };

    var trackWithVar = function(ruleName, variableName, variableValue) {
      try {
        setVar(variableName, variableValue);
        track(ruleName);
      } catch (e) {
        logError(e);
      }
    };

    var trackWithMultipleVars = function(ruleName, variableSet) {
      try {
        if (variableSet) {
          _.forIn(variableSet, function(value, name) {
            setVar(name, value);
          });
        }
        track(ruleName);
      } catch (e) {
        logError(e);
      }
    };

    var setVar = function(name, value) {
      try {
        satellite.notify('Set Variable "' + String(name) + '" with value "' + String(value) + '"');
        satellite.setVar(name, value);
      } catch (e) {
        logError(e);
      }
    };

    var logError = function(exception) {
      try {
        var error = "Unknown Error";
        if (exception) {
          error = exception.toJson();
        }
        $log("Unexpected exception occurred triggering a direct call rule in Adobe DTM: " + error);
      } catch (e) {
        //Do nothing.
      }
    };

    return {
      track: track,
      trackWithVar: trackWithVar,
      trackWithMultipleVars: trackWithMultipleVars
    };
  }
})();

(function() {
  'use strict';

  /** @ngInject */
  AdobeAnalyticsService.$inject = ['$window'];
  function AdobeAnalyticsService($window) {
    var tracking = function( user ){
      const siteName = '2.0';
      const pageName = getPageName($window.location.hash.substring(2));
      if(validPageName(pageName)){
        const userType = getUserType(user.email);
        var pagePath = $window.location.hash;

        if($window.appEventData !== undefined){
          $window.appEventData.push({
          "event": "pageInitialized"
          });

          $window.appEventData.push({
            "event":"userDetected",
            "user": {
              "id": user.userId,
              "type": userType
            }
          });

          $window.appEventData.push({
            "event": "pageInfo",
            "page": {
              "path": pagePath,
              "name": '2.0 - '+pageName
            },
            "site": {
              "name": siteName
            }
          });

          $window.appEventData.push({
            "event": "pageLoadCompleted"
          });
        }
      }
    };

    var gaqFormSelected = function(user, form) {
      const siteName = '2.0';
      const pageName = getPageName($window.location.hash.substring(2));
      if($window.appEventData !== undefined) {
        $window.appEventData.push({
          "event": "gaqFormSelected",
          "user": {
            "id": user.userId
          },
          "page": {
            "name": '2.0 - '+pageName
          },
          "site": {
            "name": siteName
          },
          "gaqForm": form
        })
      }
    };

    var gaqFormSubmitted = function(user, form) {
      const siteName = '2.0';
      const pageName = getPageName($window.location.hash.substring(2));
      if($window.appEventData !== undefined) {
        $window.appEventData.push({
          "event": "gaqFormSubmitted",
          "user": {
            "id": user.userId
          },
          "page": {
            "name": '2.0 - '+pageName
          },
          "site": {
            "name": siteName
          },
          "gaqForm": form
        })
      }
    };

    var getPageName = function getPageName(hash) {
      if(!hash) { return ''; }
      var pageName = hash.split('?')[0];
      var pathParams = pageName.split('/');
      var parsed = parseLogin(pathParams.join(' '));
      return parsed;
    }

    function parseLogin(pagePath) {
      var pageName = pagePath.split('#')[0];;
      return pageName;
    }

    function validPageName(pageName) {
      if(pageName && (_.includes(pageName.toLowerCase(), 'redirecturl') || _.includes(pageName.toLowerCase(), 'id_token'))) {
        return false;
      }
      return true;
    }

    function isInternal(email){
      const internal = ['chrobinson.com', 'mytmc.com', 'freightquote.com', 'robinsonfresh.com'];
      return internal.some(function(domain){
        return email.indexOf(domain) > -1;
      });
    }

    var getUserType = function getUserType(email) {
      if(!email){ return ''; }

      if (isInternal(email)) {
        return 'Internal';
      }
      return 'External';
    }

    return {
      tracking: tracking,
      getPageName: getPageName,
      getUserType: getUserType,
      gaqFormSelected: gaqFormSelected,
      gaqFormSubmitted: gaqFormSubmitted
    };
  }

  angular
    .module('NavisphereOnline')
    .factory('AdobeAnalyticsService',AdobeAnalyticsService);

})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');

    function addressService() {
        this.GetAddressLine1 = function (address) {
            var addressLine1 = null;

            if (angular.isUndefined(address) || address === null) {
                return addressLine1;
            }

            if (address.addressLine1) {
                addressLine1 = address.addressLine1;
            }

            return addressLine1;
        };

        this.GetAddressLine2 = function (address) {
            var addressLine2 = null;

            if (angular.isUndefined(address) || address === null) {
                return addressLine2;
            }

            if (address.addressLine2) {
                addressLine2 = address.addressLine2;
            }

            return addressLine2;
        };

        this.GetAddressLine3 = function (address) {
            var addressLine3 = null;

            if (angular.isUndefined(address) || address === null) {
                return addressLine3;
            }

            if (address.city) {
                addressLine3 = address.city;
            }

            if (address.state || address.stateProvince) {
                var state = undefined;

                if (address.state) {
                    state = address.state;
                } else {
                    state = address.stateProvince;
                }

                if (addressLine3) {
                    addressLine3 += ', ' + state;
                } else {
                    addressLine3 = state;
                }
            }

            if (address.postalCode) {
                if (addressLine3) {
                    addressLine3 += ' ' + address.postalCode;
                } else {
                    addressLine3 = address.postalCode;
                }
            }

            return addressLine3;
        };

        this.GetAddressLine4 = function (address) {
            var addressLine4 = null;

            if (angular.isUndefined(address) || address === null) {
                return addressLine4;
            }

            if (address.country) {
                addressLine4 = address.country;
            }

            return addressLine4;
        }
    }
    app.service('AddressService', addressService);
}());

angular.module('resourceLoader', ['ng', 'pascalprecht.translate']).provider('resourceLoader', ['$translatePartialLoaderProvider', function ($translatePartialLoaderProvider) {
    this.loadTranslations = function (translationParts) {
        return ['$q', '$translate', 'tmhDynamicLocale', 'localStorageService', function ($q, $translate, tmhDynamicLocale, localStorageService) {

            var deferred = $q.defer();
            var preferences = angular.fromJson(localStorageService.get('preferences'));

            if (preferences) {
              tmhDynamicLocale.set(preferences.culture.toLowerCase());
            }

            angular.forEach(translationParts, function (translationPart) {
                $translatePartialLoaderProvider.addPart(translationPart);
            });

            $translate.refresh().then(function () {
                if (preferences) {
                  $translate.use(preferences.culture.toLowerCase());
                  deferred.resolve();
                } else {
                  deferred.resolve();
                }
            }, function () {
                deferred.reject();
            });
            return deferred.promise;
        }];
    };
    this.$get = function () {
        var service = function () { };
        return service;
    };
}]);

(function() {
  'use strict';
  WalkthroughService.$inject = ['$resource', 'API_BASE_URL'];
  function WalkthroughService($resource, API_BASE_URL) {
      return $resource(API_BASE_URL + 'api/walkthrough', null, {
        'getAllWalkthroughs': {method: 'GET', url: API_BASE_URL + 'api/user/:userId/walkthrough', isArray: true},
        'getWalkthrough': { method: 'GET', url: API_BASE_URL + 'api/walkthrough/:walkthroughID'},
        'insertUserWalkthrough': { method: 'POST', url: API_BASE_URL + 'api/user/walkthrough/'}
      });
  }
  angular.module('NavisphereOnline').factory('WalkthroughService', WalkthroughService);
}

)();

(function() {
    'use strict';
    User.$inject = ['$resource', '$http', 'API_BASE_URL'];
    function User($resource, $http, API_BASE_URL) {
        return $resource(API_BASE_URL + 'api/users', null, {
            'getPreferences': { method: 'GET', url: API_BASE_URL + 'api/users/preferences' },
            'savePreferences': { method: 'POST', url: API_BASE_URL + 'api/users/preferences' },
            'getInvitation': { method: 'GET', url: API_BASE_URL + 'api/users/invitationuser' },
            'exists': { method: 'GET', url: API_BASE_URL + 'api/users/exists' },
            'getCustomerProfilePermissions': { method: 'GET', url: API_BASE_URL + 'api/users/permissions' , isArray : true },
            'getRoles': { method: 'GET', url: API_BASE_URL + 'api/users/roles' },
            'getDepartments': { method: 'GET', url: API_BASE_URL + 'api/users/departments' },
            'getCreateOrderCustomers': {
                method: 'GET',
                url: API_BASE_URL + 'api/users/createordercustomers',
                transformResponse: appendTransform($http.defaults.transformResponse, function(userCustomersResponse) {
                    var recentCustomerCodes = userCustomersResponse.recentCustomerCodes;
                    var customers = userCustomersResponse.customers;
                    userCustomersResponse.recentCustomers = [];

                    angular.forEach(recentCustomerCodes, function(recentCustCode) {
                        angular.forEach(customers, function(cust) {
                            if (cust.partyCode.trim() == recentCustCode.trim())
                                userCustomersResponse.recentCustomers.push(cust);
                        });
                    });

                    return userCustomersResponse;
                })
            },
            'getQuoteCustomers': { method: 'GET', url: API_BASE_URL + 'api/users/quotecustomers' },
            'getPoDrawCustomers': { method: 'GET', url: API_BASE_URL + 'api/users/getpodrawcustomers'},
            'getReverseLogisticsCustomers': { method: 'GET', url: API_BASE_URL + 'api/users/getreverselogisticscustomers'},
            'getWidgets': { method: 'GET', url: API_BASE_URL + 'api/users/widgets' },
            'saveWidgets': { method: 'POST', url: API_BASE_URL + 'api/users/widgets' },
            'getInteropToken': {method: 'GET', url: API_BASE_URL + 'api/users/interoptoken'}
        });
    }

    function appendTransform(defaults, transform) {

        // We can't guarantee that the default transformation is an array
        defaults = angular.isArray(defaults) ? defaults : [defaults];

        // Append the new transformation to the defaults
        return defaults.concat(transform);
    }

    angular.module('NavisphereOnline').factory('User', User);
})();

(function () {
    'use strict';
    function userApplicationService($resource, API_COMMON_URL) {

        return $resource(API_COMMON_URL + 'Users/Applications', null, {
            'getUserApplications': { method: 'GET', url: API_COMMON_URL + 'Users/Applications' }
        });
    }
    userApplicationService.$inject = ['$resource', 'API_COMMON_URL'];

    angular.module('NavisphereOnline').factory('UserApplicationService', userApplicationService);
})();


(function () {
  'use strict';
  function subscriptionsEventsService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/subscriptions/events/:eventTypeNumber?inApp=:inApp&shouldEmail=:shouldEmail', { eventTypeNumber: '@eventTypeNumber', inApp: '@inApp', shouldEmail: '@shouldEmail'});
  }

  subscriptionsEventsService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('SubscriptionsEventsService', subscriptionsEventsService);
})();

(function () {
  'use strict';
  function subscriptionService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/subscription', null, {
      'get': {method: 'GET', url: API_BASE_URL + 'api/subscription', isArray : true },
      'saveNotificationPreferences': {method: 'POST', url: API_BASE_URL + 'api/users/notificationpreferences', isArray : true }
    });
  }
  subscriptionService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('SubscriptionService', subscriptionService);
})();

(function () {
  'use strict';
  function shipmentService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL, null, {
      'getShipmentsAtAGlance': { method: 'GET', url: API_BASE_URL + 'api/shipments/search/dashboard' },
    });
  }
  shipmentService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('ShipmentService', shipmentService);
})();

/**
 * Created by okoaset on 3/30/2016.
 */
(function () {
  'use strict';
  function roleService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/widgets', null, {
      'getWidgets': { method: 'GET', url: API_BASE_URL + 'api/roles/:id/widgets', isArray: true }
    });
  }
  roleService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('RoleService', roleService);
})();


(function () {
  'use strict';
  reverseLogisticsResource.$inject = ['$resource', 'API_BASE_URL'];
  function reverseLogisticsResource($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/reverseLogistics', null, {
      'search': { method: 'POST', url: API_BASE_URL + 'api/reverseLogistics/search' },
	    'getTicket': { method: 'GET', url: API_BASE_URL + 'api/tickets/:ticketId' },
	    'createNote':  {method: 'POST', url: API_BASE_URL + 'api/tickets/event' },
      'getNotes': { method: 'GET', url: API_BASE_URL + 'api/reverseLogistics/getNotes/:ticketId', isArray: true },
      'getProcessingFee': { method: 'GET', url: API_BASE_URL + 'api/reverseLogistics/processingFee/:cCode', isArray: false },
      'getRefNumTypes': { method: 'GET', url: API_BASE_URL + 'api/reverseLogistics/refnumtypes', isArray: true }
    });
  }

  angular.module('NavisphereOnline').factory('ReverseLogisticsResource', reverseLogisticsResource);
})();

(function () {
  'use strict';
  function reportingService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/orders', null, {
      'onTime': { method: 'GET', url: API_BASE_URL + 'api/reports/onTime' },
      'onTimePeriod': { method: 'GET', url: API_BASE_URL + 'api/reports/onTimeByPeriod', isArray: true },
      'servicePerformance': { method: 'GET', url: API_BASE_URL + 'api/reports/servicePerformance' },
      'inTransitV2': { method: 'GET', url: API_BASE_URL + 'api/reports/inTransitOrdersV2' },
      'overdueOrders': { method: 'GET', url: API_BASE_URL + 'api/reports/overdueOrders' },
      'historicOrders': { method: 'GET', url: API_BASE_URL + 'api/reports/historicOrders', timeout: 120000, isArray: true },
      'historicOrdersModes': { method: 'GET', url: API_BASE_URL + 'api/reports/historicOrdersModes', isArray:true},
      'reportingModeSet': {method: 'GET', url: API_BASE_URL + 'api/reports/reportingModeSet', isArray: true},
      'ordersSummaryReport': {method: 'GET', url: API_BASE_URL + 'api/reports/ordersSummary'},
      'ordersSummaryReportExport': {method: 'POST', url: API_BASE_URL + 'api/reports/ordersSummary/export'
        ,responseType: 'blob'
        ,transformResponse: function(response) {
            response.data = response;
            return response
        }
      },
      'locationReport': {method: 'GET', url: API_BASE_URL + 'api/reports/location'},
      'locationReportExport': {method: 'POST', url: API_BASE_URL + 'api/reports/location/export'
        ,responseType: 'blob'
        ,transformResponse: function(response) {
          response.data = response;
          return response
        }
      },
      'selectSavedReportConfig': { method: 'GET', url: API_BASE_URL + 'api/reports/:reportName/configuration'},
      'insertSavedReportConfig': { method: 'POST', url: API_BASE_URL + 'api/reports/configuration'},
      'updateSavedReportConfig': { method: 'PUT', url: API_BASE_URL + 'api/reports/configuration/:savedReportConfigId'},
      'deleteSavedReportConfig': { method: 'DELETE', url: API_BASE_URL + 'api/reports/configuration/:savedReportConfigId'},
      'ordersSummaryCustomers' : { method:'GET', url: API_BASE_URL + 'api/reports/ordersummary/customers'},
      'locationCustomers' : { method:'GET', url: API_BASE_URL + 'api/reports/location/customers'},
      'reportConfigSubscription': {method: 'GET', url: API_BASE_URL + 'api/reports/:reportName/schedules'},
      'subscriptionSummary' : {method: 'GET', url: API_BASE_URL + 'api/reports/subscriptions'},
      'subscriptionDetail' : { method: 'GET', url: API_BASE_URL + 'api/reports/subscription/:savedReportConfigId'},
      'insertSubscription' : {method: 'POST', url: API_BASE_URL + 'api/reports/subscription'},
      'deleteSubscription' : { method: 'DELETE', url: API_BASE_URL + 'api/reports/subscription/:savedReportConfigId'},
      'downloadFile' : {method: 'GET', url: API_BASE_URL + 'api/reports/downloadFile'
      ,responseType: 'blob'
      ,transformResponse: function(response) {
        response.data = response;
        return response
        }
      }
    });
  }
  reportingService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('ReportingService', reportingService);
})();

(function() {
    'use strict';
    function ReferenceData($resource, API_BASE_URL) {
        return $resource(API_BASE_URL + 'api/referencedata', null, {
            'get': { method: 'GET', isArray: true },
            'getTimeformats': { method: 'GET', isArray: true, url: API_BASE_URL + 'api/referencedata/timeformats' },
            'getCultures': { method: 'GET', isArray: true, url: API_BASE_URL + 'api/referencedata/timeformats' },
            'getUnitofmeasures': { method: 'GET', isArray: true, url: API_BASE_URL + 'api/referencedata/unitofmeasures' },
            'getServiceOfferings': {method:'GET', isArray: true, url: API_BASE_URL + 'api/referencedata/serviceofferings'}
        });
    }

    ReferenceData.$inject = ['$resource', 'API_BASE_URL'];
    angular.module('NavisphereOnline').factory('ReferenceData', ReferenceData);
})();


(function () {
  'use strict';
  function quoteService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/quotes', null, {
      'getQuoteDetails': {method: "GET", url: API_BASE_URL + 'api/quotes/getquotedetail/:quoteRequestId/:quoteId'},
      'getQuoteHistory': {method: "POST", url: API_BASE_URL + 'api/quotes/quotehistory'},
      'getTransactionalPricingFlag': { method: 'GET', url: API_BASE_URL + "api/quotes/:customerCode/gettransactionalpricingflag"},
      'sendEmail': { method: 'POST', url: API_BASE_URL + 'api/quotes/email' },
      'setAccessorialChecked': {method: "POST", url: API_BASE_URL + 'api/quotes/accessorialChecked'}
    });
  }
  quoteService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('QuoteService', quoteService);
})();

(function () {
  'use strict';
  function purchaseOrderService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/purchaseorders', null, {
      'availableItems': { method: 'POST', url: API_BASE_URL + 'api/purchaseorders/availableitems' }
    });
  }
  purchaseOrderService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('PurchaseOrderService', purchaseOrderService);
})();

(function () {
  'use strict';
  PreferredCarrierResource.$inject = ['$resource', 'API_BASE_URL'];
  function PreferredCarrierResource($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/PreferredCarriers', null, {
      'get': { method: 'GET', url: API_BASE_URL + 'api/PreferredCarriers' }
    });
  }

  angular.module('NavisphereOnline').factory('PreferredCarrierResource', PreferredCarrierResource);
})();

(function () {
  'use strict';
  function orderService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/orders', null, {
      'getOrderNumber': { method: 'GET', url: API_BASE_URL + 'api/orderNumber/:confirmationNumber' },
      'search': { method: 'POST', url: API_BASE_URL + 'api/orders/search' },
      'getOrdersAtAGlance': { method: 'POST', url: API_BASE_URL + 'api/orders/search/dashboard' },
      'getOrder': { method: 'GET', url: API_BASE_URL + 'api/Orders/:orderNumber' },
      'getRecentOrders': { method: 'GET', url: API_BASE_URL + 'api/orders/recent', isArray: true },
      'getRecentOrdersAtAGlance': { method: 'GET', url: API_BASE_URL + 'api/orders/recent/dashboard', isArray: true },
      'update': { method: 'PUT', url: API_BASE_URL + 'api/orders' },
      'sendTracking': { method: 'POST', url: API_BASE_URL + 'api/orders/sendtracking' }
    });
  }
  orderService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('OrderService', orderService);
})();

(function () {
  'use strict';

  OrderLoadResource.$inject = ["$resource"];
  angular
    .module('NavisphereOnline')
    .factory('OrderLoadResource', OrderLoadResource);

  /** @ngInject */
  function OrderLoadResource($resource) {
    var baseUrl = appConfig.searchGatewayApiBaseUrl;

    return $resource(baseUrl, null, {
      getShipments: { method: 'POST', url: baseUrl + '/map/search' },
      getClusterDetails: { method: 'POST', url: baseUrl + '/map/details', isArray: true },
      getClusterDetailsContinent: { method: 'POST', url: baseUrl + '/map/continent', isArray: true },
      getClusterDetailsCountry: { method: 'POST', url: baseUrl + '/map/country', isArray: true },
      getClusterDetailsState: { method: 'POST', url: baseUrl + '/map/state', isArray: true }
    });
  }
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');

    OrderEditRulesService.$inject = ['$resource', 'API_BASE_URL'];

    function OrderEditRulesService($resource, API_BASE_URL) {
        return $resource(API_BASE_URL + 'api/OrderEditRules', null, {
            'getOrderEditRules': { method: 'GET', url: API_BASE_URL + 'api/OrderEditRules', isArray: true }
        });
    }

    app.service('OrderEditRulesService', OrderEditRulesService);
})();
(function () {
    'use strict';
    LockService.$inject = ['$resource', 'API_BASE_URL'];
    function LockService($resource, API_BASE_URL) {

        return $resource(API_BASE_URL + 'api/locks', null, {
            'lockOrder': { method: 'POST', url: API_BASE_URL + 'api/locks' },
            'releaseOrder': { method: 'DELETE', url: API_BASE_URL + 'api/locks' }
        });
    }

    angular.module('NavisphereOnline').factory('LockService', LockService);
})();

(function() {
    'use strict';
    LocationService.$inject = ['$resource', 'API_BASE_URL'];
    function LocationService($resource, API_BASE_URL) {

        return $resource(API_BASE_URL + 'api/Locations', null, {
            'search': { method: 'GET', url: API_BASE_URL + 'api/Locations/search' },
            'searchPartyLocation': { method: 'GET', url: API_BASE_URL + 'api/Locations/:partyNumberOrCode/search' },
            'getLocation': { method: 'GET', url: API_BASE_URL + 'api/Locations/:locationPartyNumberOrCode' },
            'getRecentOrigins': { method: 'GET', isArray: true, url: API_BASE_URL + 'api/Locations/:customerCode/recentorigin' },
            'getRecentDestinations': { method: 'GET', isArray: true, url: API_BASE_URL + 'api/Locations/:customerCode/recentdestination' },
            'getStates': {method: 'GET', isArray: true, url: API_BASE_URL + 'api/locations/getstates/:countryCode'},
            'recommendedAddress': { method: 'POST', url: API_BASE_URL + 'api/locations/recommendedaddress' },
            'addSupplierLocation': { method: 'POST', url: API_BASE_URL + 'api/locations/addsupplierlocation' },
            'addCustomerLocation': { method: 'POST', url: API_BASE_URL + 'api/locations/customer' },
            'getCities': {method: 'GET', isArray: true, url: API_BASE_URL + 'api/locations/cities/:zipCode'}
        });
    }

    angular.module('NavisphereOnline').factory('LocationService', LocationService);
})();

(function () {
    'use strict';
    ItemService.$inject = ['$resource', 'API_BASE_URL'];

    function ItemService ($resource, API_BASE_URL) {

        return $resource(API_BASE_URL + 'api/commodities', null, {
            'get': {method: 'GET', url: API_BASE_URL + 'api/commodities/:itemId'},
            'search': { method: 'GET', url: API_BASE_URL + 'api/commodities/:customerCode/search' },
            'searchitems': { method: 'GET', url: API_BASE_URL + 'api/commodities/:customerCode/:term/searchitemsbyterm' },
            'create': { method: 'POST', url: API_BASE_URL + 'api/commodities' },
            'innerPacks': { method: 'GET', url: API_BASE_URL + 'api/commodities/innerpacks', isArray: true },
            'masterPacks': { method: 'GET', url: API_BASE_URL + 'api/commodities/masterpacks', isArray: true }
        });
    }
    angular.module('NavisphereOnline').factory('ItemService', ItemService);
})();

(function () {
    'use strict';
    InvitationService.$inject = ['$resource', 'API_BASE_URL'];
    function InvitationService($resource, API_BASE_URL) {

        return $resource(API_BASE_URL + 'api/invitation', null, {
            'GetInvitationExpired': { method: 'Get', url: API_BASE_URL + 'api/invitation/:invitationId/expired' }
        });
    }

    angular.module('NavisphereOnline').factory('InvitationService', InvitationService);
})();

(function () {
    'use strict';
    function InternalHeaderService($resource, API_COMMON_URL) {

        return $resource(API_COMMON_URL + 'Applications', null, {
            'getBannerMessageByAppId': { method: 'GET', url: API_COMMON_URL + 'Applications/:applicationId/Banners' }
        });
    }
    InternalHeaderService.$inject = ['$resource', 'API_COMMON_URL'];
    angular.module('NavisphereOnline').factory('InternalHeaderService', InternalHeaderService);
})();

(function () {
    'use strict';
    DocumentService.$inject = ['$resource', 'API_BASE_URL'];
    function DocumentService($resource, API_BASE_URL) {

        return $resource(API_BASE_URL + 'api/documents', null, {
            'getBOL': { method: 'GET', url: API_BASE_URL + 'api/documents/bol', responseType: 'arraybuffer' },
            'getPalletLabel': { method: 'GET', url: API_BASE_URL + 'api/documents/palletLabel', responseType: 'arraybuffer' },
            'getInvoice': {method: 'GET', url:API_BASE_URL + 'api/documents/invoice', responseType: 'arraybuffer' },
            'sendDocument': { method: 'POST', url: API_BASE_URL + 'api/documents/sendDocument' },
            'sendDocuments': { method: 'POST', url: API_BASE_URL + 'api/documents/sendDocuments' },
            'sendShipmentDocuments': { method: 'POST', url: API_BASE_URL + 'api/documents/sendShipmentDocuments' },
            'sendBol': { method: 'POST', url: API_BASE_URL + 'api/documents/sendBol' },
            'sendPalletlabel': { method: 'POST', url: API_BASE_URL + 'api/documents/sendPalletlabel' },
            'getAll': { method: 'GET', url: API_BASE_URL + 'api/documents/all', isArray: true},
            'combine': { method: 'GET', url: API_BASE_URL + 'api/documents/combine', responseType: 'arraybuffer' },
            'getReverseLogisticsDocuments': { method: 'GET', url: API_BASE_URL + 'api/reverselogisticsdocuments/:ticketId', isArray: true },
            'getBolSettings': { method: 'GET', url: API_BASE_URL + 'api/:partyCode/documents/settings/bolSettings' },
            'getDefaultOrderDocuments': { method: 'GET', url: API_BASE_URL + 'api/:partyCode/documents/defaultOrderDocuments/:orderNumber', isArray: true }
        });
    }

    angular.module('NavisphereOnline').factory('DocumentService', DocumentService);
})();

(function () {
  'use strict';
  CustomerPartyService.$inject = ['$resource', 'API_BASE_URL'];
  function CustomerPartyService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/customer', null, {
      'getBOLComment': {method: 'GET', url: API_BASE_URL + 'api/customer/:partyNumberOrCode/bolComment'},
      'getOnlineContact': {method: 'GET', url: API_BASE_URL + 'api/customer/:partyCode/onlineContact'}
    });
  }

  angular.module('NavisphereOnline').factory('CustomerPartyService', CustomerPartyService);
})();


(function () {
    'use strict';
    function CultureRecommendation($resource, API_BASE_URL) {
        return $resource(API_BASE_URL + 'api/culturerecommendations', null, {
            'getCultureRecommendation': { method: 'GET', isArray: true, url: API_BASE_URL + 'api/culturerecommendation' },
            'getCultureRecommendations': { method: 'GET', isArray: true, url: API_BASE_URL + 'api/culturerecommendations' }

        });
    }

    CultureRecommendation.$inject = ['$resource', 'API_BASE_URL'];
    angular.module('NavisphereOnline').factory('CultureRecommendation', CultureRecommendation);
})();

(function () {
  'use strict';
  function carrierLogService($resource, API_BASE_URL) {

    return $resource(API_BASE_URL + 'api/carrierlogs', null, {
      'get': {method: 'GET', url: API_BASE_URL + 'api/carrierlogs/:orderNumber', isArray: true}
    });
  }
  carrierLogService.$inject = ['$resource', 'API_BASE_URL'];
  angular.module('NavisphereOnline').factory('CarrierLogService', carrierLogService);
})();

(function () {
    'use strict';
    function alertService($resource, API_BASE_URL) {
        return $resource(API_BASE_URL + 'api/alerts', null, {
            'getAlerts': { method: 'GET', isArray : true },
            'dismiss': { method: 'PUT', url: API_BASE_URL + 'api/alerts/:id', params : {
                id : "@id"
            } , isArray : true }
        });
    }
    alertService.$inject = ['$resource', 'API_BASE_URL'];
    angular.module('NavisphereOnline').factory('AlertService', alertService);
})();

(function () {
  'use strict';
  function AcknowledgementService($resource, API_COMMON_URL) {

      return $resource(API_COMMON_URL + 'Applications', null, {
          'readAcknowledgements': { method: 'GET', url: API_COMMON_URL + 'Acknowledgements',
            headers: {'Cache-Control': 'no-store, private, no-cache, must-revalidate', 'Pragma': 'no-cache'}
          },
          'acknowledgeAcknowledgement': { method: 'PUT', url: API_COMMON_URL + 'Acknowledgements/:name/Acknowledge',
            params : {
              name : "@name"
            }
          }
      });
  }
  AcknowledgementService.$inject = ['$resource', 'API_COMMON_URL'];
  angular.module('NavisphereOnline').factory('AcknowledgementService', AcknowledgementService);
})();

(function () {
  "use strict";

  WalkthroughHelper.$inject = ['localStorageService', '$state', 'WalkthroughService'];
  function WalkthroughHelper(localStorageService, $state, WalkthroughService) {
    return {
      selectWalkthrough: selectWalkthrough,
      getCachedWalkthrough: getCachedWalkthrough,
      recacheWalkthroughs: recacheWalkthroughs
    };

    /**
     * Determines what walkthrough actions to perform based on user profile.
     * If showing a walkthrough, caches walkthrough so that it won't be shown again in current session.
     *
     * @param state {object}
     * @param walkthroughs {array}
     * @returns {object|null}
     */
    function selectWalkthrough(state, walkthroughs) {
      var currentWalkthrough;

      _.forEach(walkthroughs, function (walkthrough) {
        if (walkthrough.AngularState === state.name) {
          currentWalkthrough = walkthrough;
        }
      });

      return currentWalkthrough;
    }

    /**
     * Recaching the walkthroughs needs to be done separately from getCachedWalkthrough and selectWalkthrough
     * to update localStorage's list of walkthroughs with the current user's ID. Otherwise, walkthroughs would
     * potentially be recached at inapporpriate times. Recaching and updating the User ID indicates that
     * a user viewed a given walkthrough during their session.
     */
    function recacheWalkthroughs() {
      var walkthroughs = localStorageService.get("walkthroughs");
      var state = $state.current;

      _.forEach(walkthroughs, function (walkthrough) {
        if(walkthrough.AngularState === state.name) {
          walkthrough.Dismissed = true;
          localStorageService.set("walkthroughs", walkthroughs);
        }
      });
    }

    /**
     * Signals to the internalHeaderController whether to show walkthrough, so as not to show
     * a walkthrough to a user multiple times.
     *
     * @returns {object|null}
     */
    function getCachedWalkthrough() {
      var walkthroughs = localStorageService.get("walkthroughs");
      var state = $state.current;

      if (walkthroughs) {
        return selectWalkthrough(state, walkthroughs);
      }
    }
  }
  angular.module('NavisphereOnline').service('WalkthroughHelper', WalkthroughHelper);
})();

(function () {
  "use strict";
  UserServiceHelper.$inject = ["localStorageService", "User"];

  function UserServiceHelper(localStorageService, User) {
    return {
      get: get
    };

    /**
     * @returns {Promise.<Object>}
     */
    function get() {
      var storedUser = localStorageService.get("User");

      if (storedUser) {
        return storedUser;
      } else {
        return User.get().$promise.then(function (user) {
          localStorageService.set("User", user);

          return user;
        });
      }
    }
  }

  angular.module('NavisphereOnline').service('UserServiceHelper', UserServiceHelper);
})();

(function () {
  "use strict";
  OrderLockHelper.$inject = ["LockService", "OrderLockPromptService", "authService", "API_BASE_URL"];

  function OrderLockHelper(LockService, OrderLockPromptService, authService, API_BASE_URL) {

    var orderNumber = null;

    function releaseOrderLock(){
      var lock = OrderLockPromptService.lock;
      OrderLockPromptService.lock = null;
      if(lock){
        var lockOrderNumber = orderNumber;
        var userName = lock.user;
        var application = lock.application;
        var machine = lock.machine;

        orderNumber = null;
        return LockService.releaseOrder({
          orderNumber: lockOrderNumber,
          user: userName,
          application: application,
          machine: machine
        }).$promise;
      }
    };

    function releaseOrderLockSync(){
      var lock = OrderLockPromptService.lock;
      if(lock){
        $.ajax({
          method: 'DELETE',
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + authService.getAccessToken());
            return true;
          },
          url: API_BASE_URL + 'api/locks'
          + '?user=' + encodeURIComponent(lock.user)
          + '&application=' + encodeURIComponent(lock.application)
          + '&machine=' + encodeURIComponent(lock.machine)
          + '&orderNumber=' + encodeURIComponent(orderNumber)
          ,
          async: false
        });
      }
      orderNumber = null;
      OrderLockPromptService.lock = null;
    };

    function lockOrder(newOrderNumber){
      orderNumber = newOrderNumber;
      return LockService.lockOrder(newOrderNumber);
    };

    function logoutFunction(){
      var lock = OrderLockPromptService.lock;
      if(lock){
        return releaseOrderLock();
      }
      return;
    };

    authService.addLogoutFunction(logoutFunction);

    return {
      releaseOrderLock: releaseOrderLock,
      releaseOrderLockSync: releaseOrderLockSync,
      lockOrder: lockOrder
    }
  }

  angular.module('NavisphereOnline').factory('OrderLockHelper', OrderLockHelper);
})();

/*global moment */
(function () {
	"use strict";
	
  function LocationDateHelper(DateTimeService) {
		/**
		 * @param {Date} options.newValue
		 * @param {delivery|pickup} options.orderType 
		 * @param {$scope.order} options.scopeOrder 
		 * @param {$scope.$parent.order} options.scopeParentOrder 
		 * @desc returns the earliest and latest time for a delivery or pickup
		 * based on the dryShippingHours or dryReceivingHours respectively
		 */
    function getEarliestAndLatestTimeFromScopeOrder(options) {
			var newValue = options.newValue;
			var orderType = options.orderType; // delivery or pickup
			var scopeOrder = options.scopeOrder;
			var scopeParentOrder = options.scopeParentOrder;
			var hoursProperty = orderType === 'delivery' ? 'dryReceivingHours' : 'dryShippingHours' ;
			var times = {}
			
			if (newValue
				// $scope.order check was in pickupController.js prior to extraction. Not sure if it's still required,
				// but keeping it in to avoid possible bugs.
				&& scopeOrder[orderType]
				&& scopeParentOrder[orderType][hoursProperty]
			) {
				// hours = $scope.$parent.order.(delivery|pickup).(dryReceivingHours|dryShippingHours)
				var hours = scopeParentOrder[orderType][hoursProperty]
				var day = newValue.getDay();
				var dayName = DateTimeService.getWeekDayName(day);
				var dayClosedKey = dayName + 'Closed';
				var dayOpenTimeKey = dayName + 'OpenTime';
				var dayCloseTimeKey = dayName + 'CloseTime';
				
				// if closed
				if (hours[dayClosedKey]) {
					return times;
				}
				// if open time exists				
				if (hours[dayOpenTimeKey]) {
					times.earliestTime = new Date(hours[dayOpenTimeKey]);
				}

				// if close time exists
				if (hours[dayCloseTimeKey]) {
					times.latestTime = new Date(hours[dayCloseTimeKey]);
				}
			}

			return times;
		}

		/**
		 * @description returns the closeTime of the supplied date day of the week if present
		 * @param {dryShippingHours|dryReceivingHours} hours
		 * @param {Date} date date that determines which day of the week is used
		 * @returns Date | null
		 */
		function getCloseTimeFromHours(hours, date){
			var dayName = getDayNameFromDate(date);
			var dayClosedKey = dayName + 'Closed';
			var dayCloseTimeKey = dayName + 'CloseTime';
			
			// if closed or no time exists
			if (hours[dayClosedKey] || !hours[dayCloseTimeKey]) {
				return null;
			}

			// close time exists
			return new Date(hours[dayCloseTimeKey]);
		}

		/**
		 * @description returns the openTime of the supplied date day of the week if present
		 * @param {dryShippingHours|dryReceivingHours} hours
		 * @param {Date} date date that determines which day of the week is used
		 * @returns Date | null
		 */
		function getOpenTimeFromHours(hours, date){
			var dayName = getDayNameFromDate(date);
			var dayClosedKey = dayName + 'Closed';
			var dayOpenTimeKey = dayName + 'OpenTime';
			
			// if closed or no time exists
			if (hours[dayClosedKey] || !hours[dayOpenTimeKey]) {
				return null;
			}

			// close time exists
			return new Date(hours[dayOpenTimeKey]);
		}

		function getDayNameFromDate(date) {
			var day = date.getDay();
			return DateTimeService.getWeekDayName(day);
		}

    return {
			getEarliestAndLatestTimeFromScopeOrder: getEarliestAndLatestTimeFromScopeOrder,
			getCloseTimeFromHours: getCloseTimeFromHours,
			getOpenTimeFromHours: getOpenTimeFromHours
    };
	}

	LocationDateHelper.$inject = ['DateTimeService'];
	
  angular.module('NavisphereOnline').service('LocationDateHelper', LocationDateHelper);
})();

(function () {
  "use strict";
  ListStringHelper.$inject = [];

  function ListStringHelper() {
    /**
     * @param {Array<string>} arr - Array of strings
     * @param {string} and - Translated string for 'and'
     * @returns {string}
     */
    this.buildListString = function (arr, and) {
      switch (arr.length) {
        case 0:
          return '';
        case 1:
          return arr[0];
        case 2:
          return arr.join(' ' + and + ' ');
        default: {
          var str = arr.shift();
          _.forEach(arr, function (element, idx) {
            if (idx < arr.length - 1) {
              str += ', ' + element;
            } else {
              str += ', ' + and + ' ' + element;
            }
          });
          return str;
        }
      }
    };

    return this;
  }

  angular.module('NavisphereOnline').service('ListStringHelper', ListStringHelper);
})();

(function () {
  "use strict";
  ItemServiceHelper.$inject = ["ItemService"];

  function ItemServiceHelper(ItemService) {
    return {
      searchHelper: searchHelper
    };

    /**
     * Convenience function for the ItemService.search method.
     *
     * Searches for commodities specific to the customer that the user has selected.
     *
     * @param search {String}
     * @param customer {Object}
     * @param scope {Object}
     * @param shouldAddProperties {Bool}
     * @returns {Promise.<Array>} List of commodities
     */
    function searchHelper(search, customer, scope, shouldAddProperties) {
      return ItemService.search({
        customerCode: (customer.useSupplierCatalog && scope.user && scope.user.isSupplier)
          ? scope.user.supplierPartyCode
          : customer.partyCode.replace(/^\s+|\s+$/gm, ""),
        term: search,
        limit: scope.maxSearchResultLimit
      }, function(data) {
        if (shouldAddProperties) {
          _.forEach(data.items, function(item) {
            item.commodity = angular.copy(item);
            item.freightClass = (item.freightClass) ? item.freightClass.toString() : "";
          })
        }

        return data.items;
      }).$promise.then(function(resource) {
        if (resource.items.length < 1)  {
          scope.itemsNoResults = true;
          scope.maxItemSearchResults = false;
        } else {
          scope.itemsNoResults = false;
          scope.maxItemSearchResults = resource.items.length >= scope.maxSearchResultLimit;
        }

        return _.sortBy(resource.items, [function(i) { return i.commodityName }]);
      })
    }
  }

  angular.module('NavisphereOnline').service('ItemServiceHelper', ItemServiceHelper);
})();

(function () {
  "use strict";
  DocumentHelper.$inject = ["authService", "$document"];

  function DocumentHelper(authService, $document) {
    return {
      showDocument: showDocument
    };

    function showDocument(url) {
      var form = $document[0].createElement('form');
      form.setAttribute("method", "post");
      form.setAttribute("action", url);
      var hiddenField = $document[0].createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", "access_token");
      hiddenField.setAttribute("value", authService.getAccessToken());
      form.setAttribute("target", "_blank");
      form.appendChild(hiddenField);
      $document[0].body.appendChild(form);
      form.submit();
    }
  }

  angular.module('NavisphereOnline').service('DocumentHelper', DocumentHelper);
})();

(function () {
  "use strict";
  AcknowledgementHelper.$inject = ["AcknowledgementService", '$q'];

  function AcknowledgementHelper(AcknowledgementService, $q) {
    var myAcknowledgements;

    function init() {
      var acknowledgements = [];

      function readAcknowledgements() {
        AcknowledgementService.readAcknowledgements().$promise.then(function (data) {
          acknowledgements = data.acknowledgements;
        });
      }

      function updateAcknowledgement(name) {
        var deferred = $q.defer();
        var params = {
          'name': name
        }
        AcknowledgementService.acknowledgeAcknowledgement(params).$promise.then(function (data) {
          var acknowledgement = acknowledgements && _.find(acknowledgements, ['name', data.acknowledgement.name]);
          if(acknowledgement) {
            acknowledgement.isAcknowledged = true;
            deferred.resolve(acknowledgement);
          }
        });
        return deferred.promise;
      }

      function hasAnyNotAcknowledgedAcknowledgements() {
        var indexOfUnAknowledgedAcknowledgement = acknowledgements && _.findIndex(acknowledgements, ['isAcknowledged', false]);
        return indexOfUnAknowledgedAcknowledgement >= 0;
      }

      function showAcknowledgementByName(name) {
        var acknowledgement = acknowledgements && _.find(acknowledgements, ['name', name]);
        return acknowledgement ? !acknowledgement.isAcknowledged : false;
      }

      readAcknowledgements();

      return {
        updateAcknowledgement: updateAcknowledgement,
        hasAnyNotAcknowledgedAcknowledgements: hasAnyNotAcknowledgedAcknowledgements,
        showAcknowledgementByName: showAcknowledgementByName
      };
    }

    return {
      getAcknowledgements: function() {
        if(!myAcknowledgements) {
          myAcknowledgements = init();
        }
        return myAcknowledgements;
      }
    };
  }

  angular.module('NavisphereOnline').service('AcknowledgementHelper', AcknowledgementHelper);
})();

(function () {
    'use strict';
    time.$inject = ['$filter'];
    function time($filter) {
        return function (input) {

            if (input instanceof Date && !isNaN(input.valueOf())) {
                return $filter('date')(input, 'h:mm a');
            }

            if (!input) {
                return '';
            }

            if (!input.date) {
                return '';
            }

            if (!input.userPreferences) {
                return '';
            }

            var isMeridian = input.userPreferences.timeFormat === '12';

            if (isMeridian) {
                return $filter('date')(input.date, 'h:mm a');
            } else {
                return $filter('date')(input.date, 'HH:mm');
            }
        }
    }

    angular.module('NavisphereOnline').filter('time', time);
})();

(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
    app.filter('capitalize', function () {
        return function (input) {
            if (!input) {
                return input;
            }
            return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
        }
    });
})();
(function () {
  'use strict';
  showInfoController.$inject = ['$scope', '$uibModalInstance'];
  function showInfoController($scope, $uibModalInstance) {
    $scope.close = function () {
      $uibModalInstance.dismiss('close');
    };
  }
  angular.module('NavisphereOnline').controller('showInfoController', showInfoController);
})();
/**
 * Created by okoaset on 5/23/2016.
 */

(function () {
  'use strict';
  sendTrackingController.$inject = ['$scope', '$uibModalInstance','$uibModal','OrderService','trackingNumber','user'];
  function sendTrackingController($scope, $uibModalInstance,$uibModal,OrderService,trackingNumber,user) {
    $scope.replyTos = [user.email];
    $scope.processing = false;
    $scope.trackingNumber = trackingNumber;
    $scope.close = function () {
      $uibModalInstance.dismiss('close');
    };
    function showConfirmation() {
      $uibModalInstance.dismiss('sent');
      $uibModal.open({
        templateUrl: 'app/common/views/emailConfirmation.tpl.html',
        size: 'lg',
        controller: 'emailConfirmationController'
      });
      $scope.processing = false;
    }

    $scope.send = function () {
      $scope.processing = true;
      var toAddress = $scope.to.split(';');
        OrderService.sendTracking({
          TrackingNumber: trackingNumber,
          subject: $scope.subject,
          replyTos: $scope.replyTos,
          to: toAddress,
          message: $scope.message
        }).$promise.then(function () {
          showConfirmation();
        });
    };
  }
  angular.module('NavisphereOnline').controller('sendTrackingController', sendTrackingController);
})();


(function () {
  'use strict';
  emailConfirmationController.$inject = ['$scope', '$uibModalInstance'];
  function emailConfirmationController($scope, $uibModalInstance) {
    $scope.ok = function () {
      $uibModalInstance.dismiss('ok');
    };
  }
  angular.module('NavisphereOnline').controller('emailConfirmationController', emailConfirmationController);
})();

(function () {
    'use strict';
    recommendedAddressController.$inject = ['$scope', '$uibModalInstance', 'AddressService', 'recommendation', 'entered'];

    function recommendedAddressController($scope, $uibModalInstance, AddressService, recommendation, entered) {
        $scope.recommendation = recommendation;
        $scope.entered = entered;
        $scope.useRecommended = "true";
        $scope.addressCityLine = function (address) {
            return AddressService.GetAddressLine3(address);
        };
        $scope.ok = function () {
            var useRecommendationResult = {
                useRecommendation: $scope.useRecommended === 'true',
                overrideReason: $scope.useRecommended === 'false' ? $scope.overrideReason : undefined
            };
            $uibModalInstance.close(useRecommendationResult);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel button');
        };
    }
    angular.module('NavisphereOnline').controller('recommendedAddressController', recommendedAddressController);
})();

(function () {
    'use strict';
    addLocationController.$inject = ['$scope', '$uibModalInstance', '$uibModal', '$filter', 'LocationService', 'locationType', 'ModalService', 'customer', 'supplier'];
    function addLocationController($scope, $uibModalInstance, $uibModal, $filter, LocationService, locationType, ModalService, customer, supplier) {
      var defCountry = { code: 'US', name: 'United States', phoneDialingCode: 1 };
      $scope.selectedDialingCode = defCountry;
      $scope.countries = [defCountry, { code: 'CA', name: 'Canada', phoneDialingCode: 1 }, { code: 'MX', name: 'Mexico', phoneDialingCode: 52 }];
      $scope.newLocation = {
        physicalAddress: {
          country: defCountry.code
        },
        contact: {
          phoneDialingCode: $scope.selectedDialingCode.phoneDialingCode,
          phoneCountryCode: $scope.selectedDialingCode.code
        },
        isOrigin: true,
        isDestination: true
      };
      if ($scope.needsRefinement && $scope.needsRefinement[locationType]) {
        $scope.newLocation.physicalAddress.stateProvince = $scope.needsRefinement[locationType].adminDistrictCode;
        $scope.newLocation.physicalAddress.city = $scope.needsRefinement[locationType].name;
        $scope.newLocation.physicalAddress.postalCode = $scope.needsRefinement[locationType].postalCode;
        $scope.newLocation.physicalAddress.country = $scope.needsRefinement[locationType].countryCode;

        $scope.isReadOnly = {
          city: true,
          country: true,
          postalCode: true,
          stateProvince: true
        };
      }
        $scope.countryStates = {};
        $scope.submittingNewLocation = false;
        for (var i = 0; i < $scope.countries.length; i++) {
            LocationService.getStates({
                countryCode: $scope.countries[i].code
            }).$promise.then(function (result) {
                $scope.countryStates[result[0].countryCode] = result;
            });
        }
        function addErrorMessages(errors) {
            for (var e = 0; e < errors.length; e++) {
                $scope.addLocationErrors.push($filter('translate')(errors[e]));
            }
        }
        $scope.ok = function () {
            $scope.addLocationErrors = [];
            if (!$scope.submittingNewLocation) {
                $scope.submittingNewLocation = true;
                if ($scope.newLocation.physicalAddress.county) {
                    $scope.newLocation.physicalAddress.county = undefined;
                }
                LocationService.recommendedAddress($scope.newLocation.physicalAddress).$promise.then(function (result) {
                    $scope.loadingModal.close();
                    if (result.errors.length > 0) {
                        addErrorMessages(result.errors);
                        $scope.submittingNewLocation = false;
                    } else {
                        if (result.recommendationFound) {
                            $scope.recommendedModalInstance = $uibModal.open({
                                templateUrl: '../app/addLocationModals/views/recommendedAddress.tpl.html',
                                size: 'lg',
                                controller: 'recommendedAddressController',
                                backdrop: 'static',
                                resolve: {
                                    recommendation: function () { return result; },
                                    entered: function () { return $scope.newLocation.physicalAddress; }
                                }
                            });
                            $scope.recommendedModalInstance.result.then(function (useRecommendationResult) {
                                if (useRecommendationResult.useRecommendation) {
                                    $scope.newLocation.physicalAddress = result;
                                    $scope.overrideReason = undefined;
                                } else {
                                    $scope.overrideReason = useRecommendationResult.overrideReason;
                                }
                                if ($scope.newLocation.physicalAddress.addressLine1 && $scope.newLocation.physicalAddress.stateProvince
                                    && $scope.newLocation.physicalAddress.postalCode && $scope.newLocation.physicalAddress.country) {
                                    showLoadingModal($filter('translate')('CREATING_NEW_LOCATION') + '...');

                                    if(angular.isDefined(supplier)){

                                      var request = {
                                        location: $scope.newLocation,
                                        overrideCode: $scope.overrideReason
                                      };

                                      addSupplierLocation(request, true, !useRecommendationResult.useRecommendation);
                                    } else {

                                      var request = {
                                        location: $scope.newLocation,
                                        overrideCode: $scope.overrideReason,
                                        customerPartyCode: customer
                                      };

                                      addCustomerLocation(request, true, !useRecommendationResult.useRecommendation);
                                    }
                                } else {
                                    $scope.submittingNewLocation = false;
                                    $scope.loadingModal.close();
                                }
                            }, function () {
                                $scope.submittingNewLocation = false;
                            });
                        }
                        else {
                            showLoadingModal($filter('translate')('CREATING_NEW_LOCATION') + '...');

                          if(angular.isDefined(supplier)){
                            var request = {
                              location: $scope.newLocation
                            };
                            addSupplierLocation(request, false, false);
                          } else {

                            var request = {
                              location: $scope.newLocation,
                              customerPartyCode: customer
                            };

                            addCustomerLocation(request, false, false);
                          }
                        }
                    }
                }, function () {
                    $scope.addLocationErrors.push(
                      $filter('translate')("AN_ERROR_OCCURRED_FINDING_RECOMMENDED_ADDRESS"));
                    $scope.submittingNewLocation = false;
                    $scope.loadingModal.close();
                });
                showLoadingModal($filter('translate')('VALIDATING_ADDRESS') + '...');
            }
        };

        function showLoadingModal(message){

          $scope.loadingModal = $uibModal.open({
            templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
            size: 'sm',
            controller: 'loadingSpinnerController',
            backdrop: 'static',
            resolve: {
              title: function () { return message; }
            }
          });

          $scope.loadingModal.result.then(function () {
          }, function () {
          });
        }

        function addSupplierLocation(request, receivedRecommendation, overrodeRecommendation){

          LocationService.addSupplierLocation(request)
            .$promise.then(function (result) {
            $scope.submittingNewLocation = false;
            $scope.loadingModal.close();
            if (result.errors && result.errors.length > 0) {
              addErrorMessages(result.errors);
            } else {
              $scope.newLocation = result.location;
              $uibModalInstance.close($scope.newLocation);
            }
          }, function () {
            $scope.addLocationErrors.push($filter('translate')("AN_ERROR_OCCURRED_ADDING_YOUR_LOCATION"));
            $scope.submittingNewLocation = false;
            $scope.loadingModal.close();
          });
        }

        function addCustomerLocation(request, receivedRecommendation, overrodeRecommendation){

          LocationService.addCustomerLocation(request).$promise.then(function (result) {
            $scope.submittingNewLocation = false;
            $scope.loadingModal.close();
            if (result.errors && result.errors.length > 0) {
              addErrorMessages(result.errors);
            } else {
              $scope.newLocation = result.location;
              $uibModalInstance.close($scope.newLocation);
            }
          }, function () {
            $scope.addLocationErrors.push($filter('translate')("AN_ERROR_OCCURRED_ADDING_YOUR_LOCATION"));
            $scope.submittingNewLocation = false;
            $scope.loadingModal.close();
          });
        }

        $scope.cancel = function () {
            if (!$scope.newLocationForm.$dirty) {
                $uibModalInstance.dismiss('cancel button');
            } else {
                var modalOptions = {
                    closeButtonText: 'CANCEL',
                    actionButtonText: 'OK',
                    headerText: 'ARE_YOU_SURE_YOU_WANT_TO_CANCEL_ADDING_THIS_LOCATI',
                    bodyText: 'CANCELLING_WILL_RESULT_IN_THE_LOSS_OF_LOCATION'
                };
                ModalService.showModal({}, modalOptions).then(function (result) {
                    if (result === 'ok') {
                        $uibModalInstance.dismiss('cancel button');
                    }
                });
            }
        };
        $scope.dialCodeChanged = function () {
            $scope.newLocation.contact.phoneDialingCode = $scope.selectedDialingCode.phoneDialingCode;
            $scope.newLocation.contact.phoneCountryCode = $scope.selectedDialingCode.code;
        };
        $scope.countryDropChanged = function () {
            $scope.newLocation.physicalAddress.stateProvince = undefined;
        };
        $scope.locationIsOrigin = function () {
            $scope.newLocation.isOrigin = true;
            $scope.newLocation.isDestination = false;
        };
        $scope.locationIsDestination = function () {
            $scope.newLocation.isOrigin = false;
            $scope.newLocation.isDestination = true;
        };
        $scope.locationIsBoth = function () {
            $scope.newLocation.isOrigin = true;
            $scope.newLocation.isDestination = true;
        };
    }
    angular.module('NavisphereOnline').controller('addLocationController', addLocationController);
})();

(function() {
    'use strict';
    addItemController.$inject = ['$scope', '$uibModalInstance', '$filter', '$uibModal', 'itemDdlRefData',
        'RefDataMappingService', 'showFlatbedAttributes', 'ModalService', 'ItemService', 'customer',
        'user', 'preferences'];

    function addItemController($scope, $uibModalInstance, $filter, $uibModal, itemDdlRefData,
        RefDataMappingService, showFlatbedAttributes, ModalService, ItemService, customer,
        user, preferences
    ) {

        var lbUomRefNum = RefDataMappingService.getItemId('LB_UOM');
        var lbUom = $filter('translate')('LB_UOM');
        var kgUomRefNum = RefDataMappingService.getItemId('KG_UOM');
        var kgUom = $filter('translate')('KG_UOM');
        var inUomRefNum = RefDataMappingService.getItemId('INCHES_UOM');
        var inUom = $filter('translate')('INCHES_UOM');
        var ftUomRefNum = RefDataMappingService.getItemId('FEET_UOM');
        var ftUom = $filter('translate')('FEET_UOM');
        var cmUomRefNum = RefDataMappingService.getItemId('CENTIMETERS_UOM');
        var cmUom = $filter('translate')('CENTIMETERS_UOM');
        var mUom = $filter('translate')('METERS_UOM');
        var mCubedUomRefNum = RefDataMappingService.getItemId('CUBICMETERS_UOM');
        var ftCubedUomRefNum = RefDataMappingService.getItemId('CUBICFEET_UOM');

        $scope.equipmentTypes = new Array();

        for (var i = 0; i < itemDdlRefData['ItemEquipment'].length; i++) {
          if (itemDdlRefData['ItemEquipment'][i].refDataNumber !== 1882) {
            $scope.equipmentTypes.push(itemDdlRefData['ItemEquipment'][i]);
          }
        }

        $scope.itemDdlRefData = itemDdlRefData;
        $scope.showFlatbedAttributes = showFlatbedAttributes;
        $scope.suggestedItems = [];

        function setItemDefaults() {
            $scope.newItem = {
                flatbed: {}
            };

            if (preferences.unitOfMeasure === 'metric') {
                $scope.newItem.weightUom = kgUomRefNum;
                $scope.newItem.weightUomLabel = kgUom;
                $scope.newItem.perUnitWeightUom = kgUomRefNum;
                $scope.newItem.perUnitWeightUomLabel = kgUom;
                $scope.newItem.perUnitLengthUom = cmUomRefNum;
                $scope.newItem.perUnitLengthUomLabel = cmUom;
                $scope.newItem.perUnitWidthUom = cmUomRefNum;
                $scope.newItem.perUnitWidthUomLabel = cmUom;
                $scope.newItem.perUnitHeightUom = cmUomRefNum;
                $scope.newItem.perUnitHeightUomLabel = cmUom;
                $scope.newItem.perUnitVolumeUom = mCubedUomRefNum;
                $scope.newItem.perUnitVolumeUomLabel = mUom;
                $scope.newItem.perUnitDensityUom = mCubedUomRefNum;
                $scope.newItem.perUnitDensityUomLabel = mUom;
            } else {
                $scope.newItem.weightUom = lbUomRefNum;
                $scope.newItem.weightUomLabel = lbUom;
                $scope.newItem.perUnitWeightUom = lbUomRefNum;
                $scope.newItem.perUnitWeightUomLabel = lbUom;
                $scope.newItem.perUnitLengthUom = inUomRefNum;
                $scope.newItem.perUnitLengthUomLabel = inUom;
                $scope.newItem.perUnitWidthUom = inUomRefNum;
                $scope.newItem.perUnitWidthUomLabel = inUom;
                $scope.newItem.perUnitHeightUom = inUomRefNum;
                $scope.newItem.perUnitHeightUomLabel = inUom;
                $scope.newItem.perUnitVolumeUom = ftCubedUomRefNum;
                $scope.newItem.perUnitVolumeUomLabel = ftUom;
                $scope.newItem.perUnitDensityUom = ftCubedUomRefNum;
                $scope.newItem.perUnitDensityUomLabel = ftUom;
            }
            $scope.newItem.isHot = false;
            $scope.newItem.flatbed.lengthUomLabel = ftUom;
            $scope.newItem.flatbed.lengthInUomLabel = inUom;
            $scope.newItem.flatbed.widthUomLabel = inUom;
            $scope.newItem.flatbed.heightUomLabel = inUom;


            if (showFlatbedAttributes) {
                $scope.newItem.tempCategory = itemDdlRefData['TemperatureSensitive'][0];
            }
        }

        setItemDefaults();

      $scope.getCreatingItemTitle = function() { return $filter('translate')('CREATING_ITEM'); };

        $scope.save = function() {

            $scope.loadingModal = $uibModal.open({
                 templateUrl: 'app/loadingSpinner/loading-spinner.tpl.html',
                size: 'sm',
                controller: 'loadingSpinnerController',
                backdrop: 'static',
                resolve: {
                    title: $scope.getCreatingItemTitle
                }
            });

            var transformObject = {
                "commodity": {
                    "commodityName": $scope.newItem.description,
                    "nmfc": $scope.newItem.nmfc,
                    "sku": $scope.newItem.sku,
                    "plu": $scope.newItem.plu,
                    "upc": $scope.newItem.upc,
                    "isHot": $scope.newItem.isHot,
                    "totalInsuranceValue": $scope.newItem.totalInsuranceValue,
                    "freightClass": $scope.newItem.freightClass ? $scope.newItem.freightClass.refDataNumber : null,
                    "commodityCode": $scope.newItem.commodityCode
                },
                "freightClassRDN": $scope.newItem.freightClass ? $scope.newItem.freightClass.refDataNumber : null,
                "packagingTypeRDN": $scope.newItem.packaging ? $scope.newItem.packaging.refDataNumber : null,
                "unitQuantity": $scope.newItem.qty,
                "totalPallets": $scope.newItem.pallets,
                "description": $scope.newItem.description,
                "totalPalletSpaces": $scope.newItem.palletSpaces,
                "coilRacks": $scope.newItem.flatbed.coilRacks,
                "loadingTypeRDN": $scope.newItem.flatbed.loading ? $scope.newItem.flatbed.loading.refDataNumber : null,
                "itemEquipmentRDN": $scope.newItem.flatbed.equipment ? $scope.newItem.flatbed.equipment.refDataNumber : null,
                "maxTrailerAge": $scope.newItem.flatbed.trailerage,
                "requiredChainsCount": $scope.newItem.flatbed.chains,
                "requiredStrapsCount": $scope.newItem.flatbed.straps,
                "poNumber": $scope.newItem.ponum,
                "totalTrailerFeet": $scope.newItem.trailerFeet,
                "lockBars": $scope.newItem.flatbed.locksbars,
                "tarpTypeRDN": $scope.newItem.flatbed.tarp ? $scope.newItem.flatbed.tarp.refDataNumber : null,
                "temperatureCategoryRDN": $scope.newItem.tempCategory ? $scope.newItem.tempCategory.refDataNumber : null,
                "totalInsuranceValue": $scope.newItem.totalInsuranceValue,
                "unitsPerPallet": $scope.newItem.unitsPerPallet,
                "unitInsuranceValue": $scope.newItem.perUnitInsuranceValue,
                "nmfc": $scope.newItem.nmfc,
                "totalWeight": {
                    "unitRDN": $scope.newItem.weightUom,
                    "value": $scope.newItem.weight
                },
                "unitVolume": {
                    "unitRDN": $scope.newItem.perUnitVolumeUom,
                    "value": $scope.newItem.perUnitVolume
                },
                "unitDensity": {
                    "unitRDN": $scope.newItem.perUnitDensityUom,
                    "value": $scope.newItem.perUnitDensity
                },
                "unitLength": {
                    "unitRDN": $scope.newItem.perUnitLengthUom,
                    "value": $scope.newItem.perUnitLength
                },
                "unitWidth": {
                    "unitRDN": $scope.newItem.perUnitWidthUom,
                    "value": $scope.newItem.perUnitWidth
                },
                "unitHeight": {
                    "unitRDN": $scope.newItem.perUnitHeightUom,
                    "value": $scope.newItem.perUnitHeight
                },
                "unitWeight": {
                    "unitRDN": $scope.newItem.perUnitWeightUom,
                    "value": $scope.newItem.perUnitWeight
                },
                "isHot": $scope.newItem.isHot
            };

            if ($scope.newItem.flatbed.length) {
                transformObject.equipmentLength = {
                    "unitRDN": ftUomRefNum,
                    "value": $scope.newItem.flatbed.length
                };
            }

            if ($scope.newItem.flatbed.width) {
                transformObject.equipmentWidth = {
                    "unitRDN": inUomRefNum,
                    "value": $scope.newItem.flatbed.width
                };
            }

            if ($scope.newItem.flatbed.height) {
                transformObject.equipmentHeight = {
                    "unitRDN": inUomRefNum,
                    "value": $scope.newItem.flatbed.height
                };
            }

            ItemService.create({
                    customerCode: (customer.useSupplierCatalog && user.isSupplier)
                        ? user.supplierPartyCode
                        : customer.partyCode.replace(/^\s+|\s+$/gm, ''),
                    item: transformObject
                }, function(data) {
                    $scope.loadingModal.close(data);
                    $uibModalInstance.close($scope.newItem);
                },
                function(data) {
                    $scope.loadingModal.close(data);
                    var modalOptions = {
                        headerText: 'ERROR',
                        bodyText: 'A_PROBLEM_OCCURRED_CREATING_THE_NEW_ITEM_PLEASE_TR',
                        closeButtonText: null,
                        isError: true
                    };

                    if (data.data.isDuplicate) {
                        modalOptions.bodyText = 'THIS_ITEM_ALREADY_EXISTS_IN_YOUR_CATALOG_PLEASE_UP';
                    }

                    ModalService.showModal({}, modalOptions).then(function () {
                    });
                });
        };

        $scope.cancel = function() {
            if (!$scope.newItemForm || !$scope.newItemForm.$dirty) {
                $uibModalInstance.close();
                return;
            }

            var modalOptions = {
                closeButtonText: 'CANCEL',
                actionButtonText: 'OK',
                headerText: 'ARE_YOU_SURE_YOU_WANT_TO_CANCEL_ADDING_THIS_ITEM',
                bodyText: 'CANCELLING_WILL_RESULT_IN_THE_LOSS_OF_DATA_FOR_THE'
            };

            ModalService.showModal({}, modalOptions).then(function(result) {
                if (result === 'ok') {
                    $uibModalInstance.close();
                }
            });
        };

        $scope.isHotClick = function(item) {
            item.isHot = !item.isHot;
        };

        function refreshSearchItems(search) {
            if (customer && customer.partyCode) {
                return ItemService.search({
                    customerCode: (customer.useSupplierCatalog && user.isSupplier)
                        ? user.supplierPartyCode
                        : customer.partyCode.replace(/^\s+|\s+$/gm, ''),
                    term: search,
                    limit: 3
                }, function(data) {
                    angular.forEach(data.items, function(item) {
                        item.commodity = angular.copy(item);
                        item.freightClass = (item.freightClass) ? item.freightClass.toString() : '';
                    });
                    return data.items;
                });
            }
        }

        $scope.suggestedItemSearchCriteriaChanged = function(criteria) {
            if (!criteria || criteria.length < 2) {
                $scope.suggestedItems = null;
                return;
            }

            $scope.suggestedItems = refreshSearchItems(criteria);
        };

        $scope.useThisItem = function(item) {
            $uibModalInstance.close(item);
        };
    }

    angular.module('NavisphereOnline').controller('addItemController', addItemController);
})();


(function() {
  'use strict';
  addDrawController.$inject = ['$scope', '$uibModalInstance', 'customer', 'PurchaseOrderService', '$locale', 'DrawItemService',
    'DateTimeService'];

  function addDrawController($scope, $uibModalInstance, customer, PurchaseOrderService, $locale, DrawItemService,
                             DateTimeService)
  {

    $scope.customer = customer;
    $scope.searchParams = { customerCode: customer.partyCode};
    $scope.currentParams = {};
    $scope.searchResults = [];
    $scope.pagingInfo = {
      limit: '50',
      page: 1,
      sortBy: '0',
      sortDescending: '0',
      totalItems: 0
    };
    $scope.sortSelect = "0-0";
    $scope.format = $locale.DATETIME_FORMATS['shortDate'];
    DrawItemService.init();
    DrawItemService.setCustomer($scope.customer);
    $scope.getDisplayDate = function(dateTime){
      return DateTimeService.getDisplayDateOrTime(dateTime, $scope.$parent.userPreference);
    };
    $scope.getCityStateProvince = function(destination){
      var cityState = '';
      if(angular.isDefined(destination) && angular.isDefined(destination.physicalAddress)){
        if(angular.isDefined(destination.physicalAddress.city)){
          cityState += destination.physicalAddress.city;
        }
        if(angular.isDefined(destination.physicalAddress.city) && angular.isDefined(destination.physicalAddress.stateProvince)){
          cityState += ', ';
        }
        if(angular.isDefined(destination.physicalAddress.stateProvince)){
          cityState += destination.physicalAddress.stateProvince;
        }
      }
      return cityState;
    };
    $scope.search = function(searchParams, pagingInfo) {
      searchParams.page = pagingInfo.page;
      searchParams.limit = pagingInfo.limit;
      searchParams.orderBy = pagingInfo.sortBy;
      searchParams.orderByDirection = pagingInfo.sortDescending;
      PurchaseOrderService.availableItems(searchParams).$promise.then(function(result){
        $scope.currentParams = searchParams;
        $scope.currentParams.isDefined = true;
        $scope.pagingInfo.totalItems = result.total;
        $scope.searchResults = result.purchaseOrderItems;
        $scope.hasNoResults = (result.purchaseOrderItems.length < 1);
      });
    };
    $scope.clear = function(){
      $scope.searchParams.purchaseOrderNumber = undefined;
      $scope.searchParams.customerItemId = undefined;
    };
    $scope.pageChanged = function(){
      if($scope.currentParams.isDefined) {
        $scope.search($scope.currentParams, $scope.pagingInfo);
      }
    };
    $scope.sortSelected = function(sortSelect){
      if(angular.isDefined(sortSelect)) {
        var sortPieces = sortSelect.split('-');
        $scope.pagingInfo.sortBy = sortPieces[0];
        $scope.pagingInfo.sortDescending = sortPieces[1];
        $scope.pageChanged();
      }
    };
    $scope.addItem = function(item) {
      $uibModalInstance.close(item);
    };
    $scope.cancel = function() {
      $uibModalInstance.dismiss();
    };
  }
  angular.module('NavisphereOnline').controller('AddDrawController', addDrawController);
})();


(function () {
    'use strict';
    var app = angular.module('NavisphereOnline');
  
    app.directive('apShipmentDocsLink', ['$q', '$compile', '$filter', function ($q, $compile, $filter) {
      return {
        restrict: 'E',
        scope: {
          invoice: '='
        },
        controller: ['$scope', '$uibModal', function($scope, $uibModal){
          $scope.openShipmentDocumentViewer = function (shipmentNum) {
            if ($scope.isDocumentViewerOpen) {
              return;
            }
            $scope.isDocumentViewerOpen = true;
            $scope.documentViewerModal = $uibModal.open({
              templateUrl: 'app/documentManager/views/documentViewer.tpl.html',
              size: 'lg',
              controller: 'shipmentDocumentViewerController',
              controllerAs : 'vm',
              resolve: {
                shipmentNum: shipmentNum,
                documents: ['DocumentService', function (DocumentService) {
                  return DocumentService.getAll({shipmentNumber: shipmentNum}).$promise;
                }]
              }
            });
  
            $scope.documentViewerModal.result.then(function () {
              $scope.isDocumentViewerOpen = false;
            }, function () {
              $scope.isDocumentViewerOpen = false;
            });
          };
        }],
        link: function (scope, element) {
          if(scope.invoice.loadNumbers.length === 1){
            var compiled = $compile('<span class="glyphicon glyphicon-file" aria-hidden="true" ng-click="openShipmentDocumentViewer(invoice.loadNumbers[0])"></span>')(scope);
            element.append(compiled);
          } 
          else if (scope.invoice.loadNumbers.length > 1){
            var markup = '<span class="glyphicon glyphicon-duplicate" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></span>';
            markup += '<ul class="dropdown-menu">';
            markup += '<li class="dropdown-header">' + $filter('translate')('SELECT_SHIPMENT') + '</li>';
            for (var i = 0; i < scope.invoice.loadNumbers.length; i++){
              markup += '<li><a ng-click="openShipmentDocumentViewer(' + scope.invoice.loadNumbers[i] + ')">' + scope.invoice.loadNumbers[i] + '</a></li>';
            }
            markup += '</ul>';
            var comp = $compile(markup)(scope);
            element.append(comp);
          }
        }
      };
    }]);
  })();
(function () {
  'use strict';
  var app = angular.module('NavisphereOnline');

  app.directive('apDocsLink', ['$q', '$compile', '$filter', function ($q, $compile, $filter) {
    return {
      restrict: 'EA',
      scope: {
        invoice: '='
      },
      controller: ['$scope', '$uibModal', function($scope, $uibModal){

        $scope.openDocumentViewer = function (orderNum) {
          if ($scope.isDocumentViewerOpen) {
            return;
          }
          $scope.isDocumentViewerOpen = true;
          $scope.documentViewerModal = $uibModal.open({
            templateUrl: 'app/documentManager/views/documentViewer.tpl.html',
            size: 'lg',
            controller: 'orderDocumentViewerController',
            controllerAs : 'vm',
            resolve: {
              order: ['OrderService', function (OrderService) {
                var deferred = $q.defer();
                OrderService.getOrder({orderNumber: orderNum}).$promise.then(function(order){
                  order.service = order.services[0];
                  deferred.resolve(order);
                }, function (data) {
                  deferred.reject(data);
                });
                return deferred.promise;
              }],
              documents: ['DocumentService', function (DocumentService) {
                return DocumentService.getAll({orderNumber: orderNum}).$promise;
              }]
            }
          });

          $scope.documentViewerModal.result.then(function () {
            $scope.isDocumentViewerOpen = false;
          }, function () {
            $scope.isDocumentViewerOpen = false;
          });
        };
      }],
      link: function (scope, element) {
        if(scope.invoice.orderNumbers.length === 1){
          var compiled = $compile('<span class="glyphicon glyphicon-file" aria-hidden="true" ng-click="openDocumentViewer(invoice.orderNumbers[0])"></span>')(scope);
          element.append(compiled);
        } else if (scope.invoice.orderNumbers.length > 1){
          var markup = '<span class="glyphicon glyphicon-duplicate" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></span>';
          markup += '<ul class="dropdown-menu">';
          markup += '<li class="dropdown-header">' + $filter('translate')('SELECT_ORDER') + '</li>';
          for (var i = 0; i < scope.invoice.orderNumbers.length; i++){
            markup += '<li><a ng-click="openDocumentViewer(' + scope.invoice.orderNumbers[i] + ')">' + scope.invoice.orderNumbers[i] + '</a></li>';
          }
          markup += '</ul>';
          var comp = $compile(markup)(scope);
          element.append(comp);
        }
      }
    };
  }]);
})();


(function () {
    'use strict';
    function invoiceService($resource, API_BASE_URL) {

        return $resource(API_BASE_URL + 'api/invoices', null, {
            'search': { method: 'POST', url: API_BASE_URL + 'api/invoices/search' }
        });
    }
    invoiceService.$inject = ['$resource', 'API_BASE_URL'];
    angular.module('NavisphereOnline').factory('InvoiceService', invoiceService);
})();

(function () {
  'use strict';
  searchInvoicesController.$inject = ['$scope', 'InvoiceService', '$locale', '$timeout', '$document', '$http', 'DateTimeService', 'API_BASE_URL', 'authService', 'DocumentHelper', 'MonetaryValueFormatService'];
  function searchInvoicesController($scope, InvoiceService, $locale, $timeout, $document, $http, DateTimeService, API_BASE_URL, authService, DocumentHelper, MonetaryValueFormatService) {
    $scope.results = [];
    $scope.format = $locale.DATETIME_FORMATS['shortDate'];
    $scope.displayDate = DateTimeService.getRawDateTime;
    $scope.displayToHundredthsPlace = MonetaryValueFormatService.DisplayToHundredthsPlace;
    $scope.pagingInfo = {
      limit: '10',
      page: 1,
      sortBy: 'dueDate',
      sortDescending: false,
      totalItems: 0
    };
    $scope.searchParams = {
      invoiceStatus: '0',
      dateType: '0'
    };
    $scope.clear = function () {
      $scope.searchParams = {
        invoiceStatus: '0',
        dateType: '0'
      };
    };
    $scope.search = function () {
      var printStartDate = null;
      var printEndDate = null;
      var actualPickupStartDate = null;
      var actualPickupEndDate = null;

      if ($scope.searchParams.dateType === '0') {
        actualPickupStartDate = $scope.searchParams.startDate;
        actualPickupEndDate = $scope.searchParams.endDate;
      } else if ($scope.searchParams.dateType === '1') {
        printStartDate = $scope.searchParams.startDate;
        printEndDate = $scope.searchParams.endDate;
      }
      InvoiceService.search({
        page: $scope.pagingInfo.page,
        limit: $scope.pagingInfo.limit,
        invoiceNumber: $scope.searchParams.invoiceNumber,
        orderNumber: $scope.searchParams.orderNumber,
        listBilllNumber: $scope.searchParams.listBilllNumber,
        checkNumber: $scope.searchParams.checkNumber,
        referenceNumber: $scope.searchParams.referenceNumber,
        shipmentNumber: $scope.searchParams.shipmentNumber,
        actualPickupStartDate: actualPickupStartDate,
        actualPickupEndDate: actualPickupEndDate,
        printStartDate: printStartDate,
        printEndDate: printEndDate,
        invoiceStatus: $scope.searchParams.invoiceStatus,
        sortDescending: $scope.pagingInfo.sortDescending,
        sortBy: $scope.pagingInfo.sortBy
      }, function (data) {
        $scope.results = data.items;
        $scope.pagingInfo.totalItems = data.total;
        $scope.hasNoResults = data.items.length === 0;
      });
    };

    $scope.export = function () {
      var url = API_BASE_URL + 'api/invoices/export';
      var printStartDate = null;
      var printEndDate = null;
      var actualPickupStartDate = null;
      var actualPickupEndDate = null;

      if ($scope.searchParams.dateType === '0') {
        actualPickupStartDate = $scope.searchParams.startDate;
        actualPickupEndDate = $scope.searchParams.endDate;
      } else if ($scope.searchParams.dateType === '1') {
        printStartDate = $scope.searchParams.startDate;
        printEndDate = $scope.searchParams.endDate;
      }

      var data = {
        page: 1,
        limit: 1000,
        invoiceNumber: $scope.searchParams.invoiceNumber,
        orderNumber: $scope.searchParams.orderNumber,
        listBilllNumber: $scope.searchParams.listBilllNumber,
        checkNumber: $scope.searchParams.checkNumber,
        referenceNumber: $scope.searchParams.referenceNumber,
        shipmentNumber: $scope.searchParams.shipmentNumber,
        printStartDate: printStartDate,
        printEndDate: printEndDate,
        actualPickupStartDate: actualPickupStartDate,
        actualPickupEndDate: actualPickupEndDate,
        invoiceStatus: $scope.searchParams.invoiceStatus,
        sortDescending: $scope.pagingInfo.sortDescending,
        sortBy: $scope.pagingInfo.sortBy
      };
      $http.post(url, data, { responseType: 'blob' }).then(function (d) {
        return saveAs(d.data, ['InvoiceExport.xls']);
      });
    };
    $scope.openFromDate = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.fromDateOpened = true;
    };
    $scope.fromDateOptions = {
      showWeeks: false
    };
    $scope.openToDate = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.toDateOpened = true;
    };
    $scope.toDateOptions = {
      showWeeks: false
    };
    $scope.sort = function (sortBy) {
      if (sortBy === $scope.pagingInfo.sortBy) {
        $scope.pagingInfo.sortDescending = !$scope.pagingInfo.sortDescending;
      } else {
        $scope.pagingInfo.sortBy = sortBy;
        $scope.pagingInfo.sortDescending = false;
      }
      $scope.pagingInfo.page = 1;
      $scope.search();
    };
    $scope.pageChanged = function () {
      $scope.search();
    };
    $scope.displayTax = function (tax, isTaxCalculated) {
      // Determine what value to display for tax-dependent properties (tax, subtotal)
      if (isTaxCalculated) {
        return $scope.displayToHundredthsPlace(tax || 0);
      }
      return 'See Invoice';
    };
    $scope.viewInvoice = function (invoiceNum) {
      DocumentHelper.showDocument(API_BASE_URL + 'api/documents/invoice?invoiceNumber=' + encodeURIComponent(invoiceNum));
    };
  }
  angular.module('NavisphereOnline').controller('SearchInvoicesController', searchInvoicesController);
}());

(function () {
  'use strict';
  accountSummaryController.$inject = ['$scope', '$http', 'InvoiceService', '$timeout', '$document', 'invoiceResults', 'DateTimeService', 'API_BASE_URL', 'DocumentHelper', 'numberFilter'];
  function accountSummaryController($scope, $http, InvoiceService, $timeout, $document, invoiceResults, DateTimeService, API_BASE_URL, DocumentHelper, numberFilter) {
    $scope.results = invoiceResults.items;
    $scope.aggs = invoiceResults.aggs;
    $scope.total = invoiceResults.total;
    $scope.displayDate = DateTimeService.getRawDateTime;
    $scope.pagingInfo = {
      limit: '10',
      page: invoiceResults.page,
      sortBy: 'dueDate',
      sortDescending: false,
      totalItems: invoiceResults.total
    };

    function search() {
      InvoiceService.search({
        page: $scope.pagingInfo.page,
        limit: $scope.pagingInfo.limit,
        invoiceStatus: 1,
        agingBucket: $scope.agingBucket,
        sortDescending: $scope.pagingInfo.sortDescending,
        sortBy: $scope.pagingInfo.sortBy
      }, function (data) {
        $scope.results = data.items;
        $scope.pagingInfo.totalItems = data.total;
      });
    }
    $scope.setActive = function (agingBucket) {
      $scope.activeCard = agingBucket;
      $scope.agingBucket = agingBucket;
      search();
    };
    $scope.sort = function (sortBy) {
      if (sortBy === $scope.pagingInfo.sortBy) {
        $scope.pagingInfo.sortDescending = !$scope.pagingInfo.sortDescending;
      } else {
        $scope.pagingInfo.sortBy = sortBy;
        $scope.pagingInfo.sortDescending = false;
      }
      $scope.pagingInfo.page = 1;
      search();
    };
    $scope.pageChanged = function () {
      search();
    };
    $scope.displayTax = function (tax, isTaxCalculated) {
      // Determine what value to display for tax-dependent properties (tax, subtotal)
      if (isTaxCalculated) {
        return numberFilter(tax || 0);
      }
      return 'See Invoice';
    };
    $scope.viewInvoice = function (invoiceNum) {
      $timeout(function () {
        DocumentHelper.showDocument(API_BASE_URL + 'api/documents/invoice?invoiceNumber=' + encodeURIComponent(invoiceNum));
      });
    };
    $scope.export = function(){
      var url = API_BASE_URL + 'api/invoices/export';
      var data = {
        page: 1,
        limit: 1000,
        invoiceStatus: 1,
        agingBucket: $scope.agingBucket,
        sortDescending: $scope.pagingInfo.sortDescending,
        sortBy: $scope.pagingInfo.sortBy
      };
      $http.post(url, data, {responseType: 'blob'}).then(function(d){
        return saveAs(d.data, ['InvoiceExport.xls']);
      });
    };
  }

  angular.module('NavisphereOnline').controller('AccountSummaryController', accountSummaryController);
}());

(function () {

    'use strict';
    validationModalController.$inject = ['$scope', '$uibModalInstance', 'validations', 'title'];
    function validationModalController($scope, $uibModalInstance, validations, title) {

        $scope.validations = validations;
        $scope.title = title;
        $scope.ok = function () {
            $uibModalInstance.close();
        };
    }

    angular.module('NavisphereOnline').controller('validationModalController', validationModalController);
}());

(function () {
  'use strict';

  shipmentMapController.$inject = ['$scope', '$q', 'geohash', 'mapsInitializer', '$http', '$interval', '$rootScope', 'OrderLoadResource', 'analyticsService', 'graphicsService', 'localStorageService', '$filter', '$log'];

  function shipmentMapController($scope, $q, geohash, mapsInitializer, $http, $interval, $rootScope, OrderLoadResource, analyticsService, graphicsService, localStorageService, $filter, $log) {
    var vm = this;
    vm.mapObj = {};

    vm.pushpins = [];
    vm.displayMode = 'map';

    vm.weatherRefreshPromise = null;
    vm.emptyLayer = null;
    vm.showControlPanel = false;

    vm.showRoadView = true;
    vm.showAerialView = false;
    vm.showGrayscaleView = false;
    vm.showTraffic = false;
    vm.showWeather = false;
    vm.showLabels = false;

    vm.trafficManager = null;
    vm.weatherLayerVisible = (localStorageService.get('weatherLayerVisible') || "true") === "true";
    vm.infobox;
    vm.zoomLevel;
    vm.box;
    vm.searchText;
    vm.infoboxTransit = [];
    vm.infoboxDelivered = [];
    vm.infoboxTransitVisible = false;
    vm.infoboxDeliveredVisible = false;
    vm.showErrorMessage = true;
    vm.loading = true;


    /*
      Sets the error message when it finds no orders depending on current area and global
    */
    vm.setErrorMessage = function () {
      var box = {
        topLeft: {
          lat: 84.969265,
          lon: 0
        },
        bottomRight: {
          lat: -84.969265,
          lon: -1
        }
      };

      OrderLoadResource.getClusterDetailsCountry({ box: box }).$promise.then(function (data) {
        if (data.length > 0) {
          vm.errorMessage = $filter('translate')("PLEASE_PAN_OR_ZOOM_TO_SEE_ORDERS");
        } else {
          vm.errorMessage = $filter('translate')("THERE_ARE_NO_IN_TRANSIT_OR_DELIVERED_ORDERS_AT_THI");
        }
      })
    };

    // To open or close the map controls
    vm.toggleControlPanel = function () {
      vm.showControlPanel = vm.showControlPanel === true ? false : true;
      vm.hideTransitInfobox();
      vm.hideDeliveredInfobox();
    };

    vm.toggleMapView = function (mapType) {
      analyticsService.trackWithVar('toggleMapView', "mapType", mapType);

      vm.showRoadView = false;
      vm.showAerialView = false;
      vm.showGrayscaleView = false;

      if (mapType === 'road') {
        vm.showRoadView = true;
      }

      if (mapType === 'aerial') {
        vm.showAerialView = true;
      }

      if (mapType === 'grayscale') {
        vm.showGrayscaleView = true;
      }
    };

    // For the aerial map it toggles for displaying labels on the map
    vm.toggleLabels = function () {
      vm.showLabels = !vm.showLabels;
      if (vm.showAerialView) {
        if (vm.showLabels) {
          vm.mapObj.setView({ labelOverlay: Microsoft.Maps.LabelOverlay.visible });
        } else {
          vm.mapObj.setView({ labelOverlay: Microsoft.Maps.LabelOverlay.hidden });
        }
      }
    };

    // Toggles the traffic view
    vm.toggleTraffic = function () {
      analyticsService.trackWithVar('toggleTrafficControl', "trafficToggleValue", vm.showTraffic);
      vm.showTraffic = !vm.showTraffic;

      if (vm.showTraffic) {
        vm.trafficManager.show();
      } else {
        vm.trafficManager.hide();
      }
    };

    // Toggle for the weather
    vm.toggleWeather = function () {
      analyticsService.trackWithVar('toggleWeatherControl', "weatherToggleValue", vm.showWeather);
      vm.showWeather = !vm.showWeather;

      if (vm.showWeather) {
        vm.weatherLayerVisible = true;
        localStorageService.set('weatherLayerVisible', true);
        vm.weatherOverlay(vm.mapObj);
      } else {
        vm.weatherLayerVisible = false;
        localStorageService.set('weatherLayerVisible', false);
        vm.mapObj.layers.remove(vm.weatherLayer);
      }
    };

    // This function adds all the pins to the map
    vm.addPins = function (data) {
      vm.mapObj.entities.clear();

      if (data.buckets.length > 0) {
        vm.showErrorMessage = false;
      } else {
        vm.setErrorMessage();
        vm.showErrorMessage = true;
      }



      for (var i = 0; i < (data.buckets.length); i++) {
        var lat = data.buckets[i].center_lat.value;
        var lon = data.buckets[i].center_lon.value;
        var location = new Microsoft.Maps.Location(lat, lon);
        vm.infobox = new Microsoft.Maps.Infobox(location, { visible: false });

        var pin = graphicsService.generatePinsSvg(data.buckets[i].doc_count, data.buckets[i].status.buckets);

        var pushpins = new Microsoft.Maps.Pushpin(location, { icon: pin.svg, anchor: new Microsoft.Maps.Point(pin.lat, pin.lon) });

        pushpins.metadata = {
          hash_key: data.buckets[i].key,
          totals: data.buckets[i].status.buckets
        }

        Microsoft.Maps.Events.addHandler(pushpins, 'click', displayInfobox);

        vm.pushpins.push(pushpins);
      };
      if (data.buckets.length > 0) {
        vm.infobox.setMap(vm.mapObj);
        vm.mapObj.entities.push(vm.pushpins);
      }
    };

    function displayInfobox(e) {
      var hashData = geohash.decode_bbox(e.target.metadata.hash_key);
      var datapoints = { topLeft: { lat: hashData[2], lon: hashData[1] }, bottomRight: { lat: hashData[0], lon: hashData[3] } };
      vm.infoboxTransit.length = 0;
      vm.infoboxDelivered.length = 0;
      analyticsService.trackWithVar('displayInfobox', "searchValue", vm.searchText);

      // get totals for infobox
      vm.getPinTotals(e.target.metadata.totals);
      var totalAtPin = vm.transitTotal + vm.deliveredTotal;

      if (vm.zoomLevel === 5 && !vm.searchText && totalAtPin > 10) {
        // hide any infobox 
        vm.infoboxTransitVisible = false;
        vm.infoboxDeliveredVisible = false;

        vm.zoom(e.target.geometry.bounds, 3);
      } else if (vm.zoomLevel >= 5 && !vm.searchText) {
        OrderLoadResource.getClusterDetails({ box: datapoints }).$promise.then(function (data) {
          vm.seperationOfDetailedOrders(data);
        });
      } else if (vm.zoomLevel === 4 && !vm.searchText && totalAtPin === 1) {
        // show state cluster details if we have less than 100 at this point, otherwise zoom in
        OrderLoadResource.getClusterDetailsState({ box: datapoints }).$promise.then(function (data) {
          vm.seperationOfDetailedOrders(data);
        });
      } else if (vm.zoomLevel < 5 && !vm.searchText) {
        // hide any infobox 
        vm.infoboxTransitVisible = false;
        vm.infoboxDeliveredVisible = false;

        vm.zoom(e.target.geometry.bounds, 1);
      } else if (vm.searchText) {
        OrderLoadResource.getShipments({ zoom: vm.zoomLevel, box: vm.box, searchText: vm.searchText }).$promise.then(function (data) {
          if (data.buckets[0].top_item.hits.hits[0]._source.order_status === "Delivered") {
            vm.infoboxSizing(true, false);
            vm.infoboxDelivered.push(data.buckets[0].top_item.hits.hits[0]._source);
          } else if (data.buckets[0].top_item.hits.hits[0]._source.order_status === "In Transit") {
            vm.infoboxSizing(false, true);
            vm.infoboxTransit.push(data.buckets[0].top_item.hits.hits[0]._source);
          }
        });
      }
    };

    vm.zoom = function (bounds, zoomLevel) {
      // get latitude and longitude
      var topLeft = {
        latitude: bounds[0],
        longitude: bounds[1]
      };
      var bottomRight = {
        latitude: bounds[2],
        longitude: bounds[3]
      }

      // create the box for zooming
      var hashRect = Microsoft.Maps.LocationRect.fromCorners(
        new Microsoft.Maps.Location(topLeft.latitude, topLeft.longitude),
        new Microsoft.Maps.Location(bottomRight.latitude, bottomRight.longitude));

      // set the zoom level to the next
      var newZoomLevel = vm.mapObj.getZoom() + zoomLevel;

      // do the zoom (cannot animate as of 01/2018)
      vm.mapObj.setView({
        center: hashRect.center,
        zoom: newZoomLevel
      });
    }

    vm.getPinTotals = function (totals) {
      vm.transitTotal = 0;
      vm.deliveredTotal = 0;

      for (var i = 0; i < totals.length; i++) {
        if (totals[i].key === 'In Transit') {
          vm.transitTotal = totals[i].doc_count;
        } else {
          vm.deliveredTotal = totals[i].doc_count;
        }
      }
    }

    vm.seperationOfDetailedOrders = function (data) {
      var tdata = false;
      var ddata = false;
      for (var i = 0; i < (data.length); i++) {
        if (data[i]._source.order_status === "Delivered") {
          ddata = true;
          vm.infoboxSizing(ddata, tdata);
          vm.infoboxDelivered.push(data[i]._source);
        } else if (data[i]._source.order_status === "In Transit") {
          tdata = true;
          vm.infoboxSizing(ddata, tdata);
          vm.infoboxTransit.push(data[i]._source);
        }
      };
    };

    vm.infoboxSizing = function (deliveredData, transitData) {
      vm.infoboxTransitVisible = false;
      vm.infoboxDeliveredVisible = false;
      if (transitData) {
        vm.infoboxTransitVisible = true;
      }

      if (deliveredData) {
        vm.infoboxDeliveredVisible = true;
      }

      if (vm.infoboxTransitVisible || vm.infoboxDeliveredVisible) {
        vm.showControlPanel = false;
      }
    };

    vm.hideDeliveredInfobox = function () {
      vm.infoboxDeliveredVisible = false;
    };

    vm.hideTransitInfobox = function () {
      vm.infoboxTransitVisible = false;
    };

    // Tried to unit test this but it breaks Jenkin builds
    vm.detailedOrders = function (orderNumber) {
      analyticsService.trackWithVar('detailedOrders', "orderNumber", orderNumber);
      window.location.href = appConfig.ordersUIBaseUrl + '/#/detail/' + orderNumber;
    };

    // This builds out the map and styles it
    vm.loadMap = function () {
      analyticsService.track('pageLoad');

      mapsInitializer.mapInitialized.then(function () {
        vm.mapObj = new Microsoft.Maps.Map(document.getElementById('map'), {
          credentials: appConfig.bingMapKey,
          mapTypeId: Microsoft.Maps.MapTypeId.road,
          showLocateMeButton: false,
          showMapTypeSelector: false,
          showZoomButtons: true,
          zoom: 3,
          minZoom: 3,
          maxZoom: 14
        });

        vm.getCustomersOrders();
        $rootScope.$broadcast('mapObj', { mapObj: vm.mapObj });
        Microsoft.Maps.loadModule('Microsoft.Maps.Traffic', { callback: vm.trafficOverlay });
        Microsoft.Maps.Events.addHandler(vm.mapObj, 'viewchangeend', viewChanged);
      }, function (error) {
        toastr.error('Error Code: ' + error.data.responseStatus.errorCode + '<br />Message: ' + error.data.responseStatus.message);
      });
    };

    // This handles adding traffic information to the map
    vm.trafficOverlay = function () {
      vm.trafficManager = new Microsoft.Maps.Traffic.TrafficManager(vm.mapObj);
      vm.trafficManager.hide();
    };

    // An empty overlay that will be used with weather
    vm.emptyOverlay = function () {
      EmptyOverlay.prototype = new Microsoft.Maps.CustomOverlay();

      function EmptyOverlay() { }

      EmptyOverlay.prototype.onAdd = function () {
        var container = document.createElement('div');
        this.setHtmlElement(container);
      };

      vm.emptyLayer = new EmptyOverlay();
      vm.mapObj.layers.insert(vm.emptyLayer);
    };

    // This is where we will be placing the weather information for the map
    vm.customWeatherOverlayOptions = function () {
      if (!vm.weatherLayerVisible)
        return;

      $http({
        method: 'GET',
        url: 'https://api.weather.com/v3/TileServer/series/productSet/PPAcore?apiKey=' + appConfig.weatherApiKey
      }).then(function (response) {
        var series = response.data.seriesInfo.radarFcst.series;
        var s = series[0];
        var m = series[0].ts;
        for (var i = 0, l = series.length; i < l; i++) {
          if (series[i].ts > m) {
            s = series[i];
            m = series[i].ts;
          }
        }
        s.fts.sort();
        var tileSources = [];
        for (var i = 0; i < s.fts.length; i++) {
          if (tileSources.length > 5)
            break;
          var path = 'https://api.weather.com/v3/TileServer/tile/radarFcst?ts={ts}&fts={fts}&xyz={x}:{y}:{zoom}&apiKey={apiKey}';
          path = path.replace('{apiKey}', appConfig.weatherApiKey);
          path = path.replace('{fts}', s.fts[i]);
          path = path.replace('{ts}', s.ts);
          var tileSource = new Microsoft.Maps.TileSource({
            uriConstructor: path
          });

          tileSources.push(tileSource);
        }

        vm.emptyOverlay();

        var weatherLayer = new Microsoft.Maps.AnimatedTileLayer({
          mercator: tileSources,
          frameRate: 500,
          visible: true,
          loadingScreen: vm.emptyLayer
        });

        if (vm.weatherLayer) {
          vm.mapObj.layers.remove(vm.weatherLayer);
        }
        vm.weatherLayer = weatherLayer;
        vm.mapObj.layers.insert(weatherLayer);
      }, function (response) {
        $log(response);
      });
    };

    // This get the weather and refresh its self
    vm.weatherOverlay = function () {
      vm.customWeatherOverlayOptions();
      vm.weatherRefreshPromise = $interval(vm.customWeatherOverlayOptions, 1000 * 60 * 1);
    };

    vm.removeSearch = function () {
      vm.searchText = undefined;
      vm.pushpins.length = 0;
      vm.getCustomersOrders();
    };

    vm.textSearch = function () {
      vm.pushpins.length = 0;
      analyticsService.track('searchButton');
      vm.getCustomersOrders();
    };

    function viewChanged(e) {
      vm.pushpins.length = 0;
      vm.zoomLevel = vm.mapObj.getZoom();
      analyticsService.trackWithVar('zoom', "zoomLevel", vm.zoomLevel);
      var bounds = e.target.getBounds();
      var nw = bounds.getNorthwest();
      var se = bounds.getSoutheast();
      vm.box = { topLeft: { lat: nw.latitude, lon: nw.longitude }, bottomRight: { lat: se.latitude, lon: se.longitude } };

      vm.getCustomersOrders();
    }

    vm.getCustomersOrders = function () {
      var initialBox = {
        topLeft: { lat: 76, lon: 97 },
        bottomRight: { lat: -22, lon: 75 }
      };
      var defaultZoomLevel = 3;
      var newLocal = {
        box: vm.box || initialBox,
        zoom: vm.zoomLevel || defaultZoomLevel,
        searchText: vm.searchText
      };

      OrderLoadResource.getShipments(newLocal).$promise.then(function (data) {
        vm.addPins(data);
        vm.loading = false;
      });
    };

    // On Load
    vm.loadMap();
  }
  angular.module('NavisphereOnline').controller('shipmentMapController', shipmentMapController);
}());

(function() {
  'use strict';

  angular.module('NavisphereOnline')
    .directive('mapSelector', mapSelector);

  mapSelector.$inject = ['$rootScope'];
  /** @ngInject */
  function mapSelector($rootScope) {
    return {
      restrict: 'C',
      link: function(scope, element) {
        var mapObj;
        var scope = scope.vm;
        $rootScope.$on('mapObj', function(evt, data) {
          return mapObj = data.mapObj;
        });
        // Polyfill from MSDN because Microsoft
        if (!String.prototype.includes) {
          String.prototype.includes = function(search, start) {
            'use strict';
            if (typeof start !== 'number') {
              start = 0;
            }

            if (start + search.length > this.length) {
              return false;
            } else {
              return this.indexOf(search, start) !== -1;
            }
          };
        }
        element.on('click', function(evt) {
          var className = evt.target.className;
          var elementId = element.attr('id'),
            roadContainer = $('#road-container'),
            aerialContainer = $('#aerial-container'),
            grayscaleContainer = $('#grayscale-container');
          if ( !className.includes('toggle-value')) {
              var overlayImage = $('.btn-overlay-image');

            if (!element.hasClass('active-selector')) {
              element.addClass('active-selector')
            }

            if (elementId === 'road-container') {
              aerialContainer.removeClass('active-selector');
              grayscaleContainer.removeClass('active-selector');
              overlayImage.attr('src', '../app/assets/img/btn-control-map-road.png');
              mapObj.setMapType(Microsoft.Maps.MapTypeId.road);
              mapObj.setView({ labelOverlay: Microsoft.Maps.LabelOverlay.visible});

            }

            if (elementId === 'aerial-container') {
              roadContainer.removeClass('active-selector');
              grayscaleContainer.removeClass('active-selector');
              overlayImage.attr('src', '../app/assets/img/btn-control-map-aerial.png');
              if (localStorage.getItem('labelsEnabled') === 'false') {
                mapObj.setMapType(Microsoft.Maps.MapTypeId.aerial);
                mapObj.setView({ labelOverlay: Microsoft.Maps.LabelOverlay.hidden});
                scope.aerialPanelToggleText = 'Turn On Labels';
              } else {
                mapObj.setMapType(Microsoft.Maps.MapTypeId.aerial);
                mapObj.setView({ labelOverlay: Microsoft.Maps.LabelOverlay.visible});
                scope.aerialPanelToggleText = 'Turn Off Labels';
              }
            }

            if (elementId === 'grayscale-container') {
              aerialContainer.removeClass('active-selector');
              roadContainer.removeClass('active-selector');
              overlayImage.attr('src', '../app/assets/img/btn-control-map-grayscale.png');
              mapObj.setMapType(Microsoft.Maps.MapTypeId.grayscale);
              mapObj.setView({ labelOverlay: Microsoft.Maps.LabelOverlay.visible});
            }


            if (!roadContainer.hasClass('active-selector') && !aerialContainer.hasClass('active-selector') && !grayscaleContainer.hasClass('active-selector')) {
              overlayImage.attr('src', '');
            }
          } else if (roadContainer.hasClass('active-selector') || grayscaleContainer.hasClass('active-selector')) {
            return false;
          }
        });
      }
    }
  }
})();

(function() {
    'use strict';

    mapsInitializer.$inject = ["$window", "$q"]
     angular
        .module('NavisphereOnline')
        .factory('mapsInitializer', mapsInitializer);

    /** @ngInject */
    function mapsInitializer($window, $q) {
        var url = '//www.bing.com/api/maps/mapcontrol?branch=release&callback=';
        //
        var deferred = $q.defer();


        $window.bingMapsInitilized = deferred.resolve;

        var asyncLoad = function(url, callbackName) {
            var script = document.createElement('script');
            script.src = url + callbackName;
            document.body.appendChild(script);
        };
         asyncLoad(url, 'bingMapsInitilized');

         return {
             mapInitialized : deferred.promise
         };
       }
})();

(function() {
  'use strict';

  graphicsService.$inject = ["$filter", "$window"]
  angular
  .module('NavisphereOnline')
  .factory('graphicsService', graphicsService);

  function graphicsService($filter, $window) {
    var statusColors = {
      'In Transit': 'rgba(0,120,174,1)',
      'Delivered': 'rgba(244,123,32,1)',
      'Late': 'rgba(186,68,68,1)',
      'Early': 'rgba(46,153,224, 1)'
    };

    // var statusGradiant = {
    //   'In Transit': {
    //     colorOne: '#0078ae',
    //     colorTwo: '#0A5AC5'
    //   },
    //   'Delivered': {
    //     colorOne: '#F47B20',
    //     colorTwo: '#F49039'
    //   },

    //   'Late': {
    //     colorOne: '#DA0303',
    //     colorTwo: '#6C0000'
    //   },
    //   'Early': {
    //     colorOne: '#0099FF',
    //     colorTwo: '#00416C'
    //   }
    // };

    function generatePinsSvg(count, status){
      var pin = {svg: "", offset:""};
      var svg;
      var offset;
      if(status.length > 1){
        pin.svg = createClusterPinSvg(count, status)
        pin.lat = 33;
        pin.lon = 20
      }
      else if(status[0].key === "In Transit")
      {
        if(count > 1 && count < 10){
          pin.svg = getInTransitClusteredSingleDigitsSvg(count);
          pin.lat = 15.625;
          pin.lon = 58.5
        }
        else if(count > 9 && count < 100){
          pin.svg = getInTransitClusteredDoubleDigitsSvg(count);
          pin.lat = 15.625;
          pin.lon = 58.5
        }
        else if(count > 99){
          pin.svg = getInTransitClusteredMoreDigitsSvg();
          pin.lat = 15.625;
          pin.lon = 58.5
        }
        else{
          pin.svg = getInTransitSvg();
          pin.lat = 39.625;
          pin.lon = 37.5
        }
      }
      else if (status[0].key === "Delivered") {
        if(count > 1 && count < 10){
          pin.svg = getDeliveredClusteredSingleDigitsSvg(count);
          pin.lat = 15.625;
          pin.lon = 58.5
        }
        else if(count > 9 && count < 100){
          pin.svg = getDeliveredClusteredDoubleDigitsSvg(count);
          pin.lat = 15.625;
          pin.lon = 58.5
        }
        else if(count > 99){
          pin.svg = getDeliveredClusteredMoreDigitsSvg();
          pin.lat = 15.625;
          pin.lon = 58.5
        }
        else{
          pin.svg = getDeliveredSvg();
          pin.lat = 30.625;
          pin.lon = 43.5
        }
      }
      //pin.push(svg);
      return pin;
    }


    function getDeliveredSvg(){
      var svg = ['<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46" height="60" viewBox="0 0 36 49"><title>Delivered_Single</title><g id="Layer_1-2" data-name="Layer 1"><image width="36" height="49" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:#fff"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M24.16,17a6.77,6.77,0,0,1-.94,3.51A6.93,6.93,0,0,1,20.67,23a7,7,0,0,1-9.57-2.54h0A7,7,0,0,1,17.16,10a6.77,6.77,0,0,1,3.51.94A7,7,0,0,1,24.16,17Z" style="fill:#f47b20"/><path d="M21.86,14.89a.54.54,0,0,0-.16-.42l-.83-.82a.56.56,0,0,0-.82,0l-3.72,3.71L14.27,15.3a.56.56,0,0,0-.79,0l0,0-.83.82a.54.54,0,0,0-.16.42.57.57,0,0,0,.16.41l3.3,3.3a.58.58,0,0,0,.41.17.59.59,0,0,0,.42-.17L21.7,15.3A.57.57,0,0,0,21.86,14.89Z" style="fill:#fff"/></g></svg>'];
      //var svg = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46" height="60" viewBox="0 0 36 49"><defs><style>.cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3{fill:#fff;}.cls-4{fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{fill:#f47b20;}</style></defs><title>Delivered_Single</title><g class="cls-1"><g id="Layer_1" data-name="Layer 1"><image class="cls-2" width="36" height="49" xlink:href="data:image/png;base64,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"/><path class="cls-3" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-4" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-5" d="M22.16,14.94a6.79,6.79,0,0,1-.94,3.51A7,7,0,0,1,18.67,21,7,7,0,0,1,9.1,18.45a7,7,0,0,1,0-7,7,7,0,0,1,6.06-3.48,6.79,6.79,0,0,1,3.51.94,7,7,0,0,1,3.49,6.06Z" transform="translate(2 2.01)"/><path class="cls-3" d="M19.86,12.88a.57.57,0,0,0-.16-.42l-.83-.82a.55.55,0,0,0-.41-.18.54.54,0,0,0-.41.18l-3.72,3.71-2.06-2.06a.56.56,0,0,0-.82,0l-.83.82a.57.57,0,0,0-.16.42.56.56,0,0,0,.16.41l3.3,3.3a.58.58,0,0,0,.41.17.61.61,0,0,0,.42-.17l4.95-4.95A.56.56,0,0,0,19.86,12.88Z" transform="translate(2 2.01)"/></g></g></svg>']
      return svg.join('');
    }

    function getDeliveredClusteredSingleDigitsSvg(count){
      var svg = ['<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><title>Delivered_SingleDigit</title><g id="Layer_1-2" data-name="Layer 1"><image width="36" height="49" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:#fff"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M24.16,17a6.77,6.77,0,0,1-.94,3.51A6.93,6.93,0,0,1,20.67,23a7,7,0,0,1-9.57-2.54h0A7,7,0,0,1,17.16,10a6.77,6.77,0,0,1,3.51.94A7,7,0,0,1,24.16,17Z" style="fill:#f47b20"/><path d="M21.86,14.89a.54.54,0,0,0-.16-.42l-.83-.82a.56.56,0,0,0-.82,0l-3.72,3.71L14.27,15.3a.56.56,0,0,0-.79,0l0,0-.83.82a.54.54,0,0,0-.16.42.57.57,0,0,0,.16.41l3.3,3.3a.58.58,0,0,0,.41.17.59.59,0,0,0,.42-.17L21.7,15.3A.57.57,0,0,0,21.86,14.89Z" style="fill:#fff"/><image width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M36.69,35A9,9,0,1,1,19.93,30.5a9,9,0,0,1,12.28-3.28A8.92,8.92,0,0,1,36.69,35Z" style="fill:#f47b20"/><text transform="translate(24.26 39.12)" style="isolation:isolate;font-size:11px;fill:#fff;font-family:OpenSans, Open Sans, sans-serif">' + count + '</text></g></svg>'];
      //var svg = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><defs><style>.cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3,.cls-6{fill:#fff;}.cls-4{fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{fill:#f47b20;}.cls-6{font-size:12px;font-family:OpenSans, Open Sans, sans-serif;}</style></defs><title>Delivered_SingleDigit</title><g class="cls-1"><g id="Layer_1" data-name="Layer 1"><image class="cls-2" width="36" height="49" xlink:href="data:image/png;base64,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"/><path class="cls-3" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-4" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-5" d="M22.16,14.94a6.79,6.79,0,0,1-.94,3.51A7,7,0,0,1,18.67,21,7,7,0,0,1,9.1,18.45a7,7,0,0,1,0-7,7,7,0,0,1,6.06-3.48,6.79,6.79,0,0,1,3.51.94,7,7,0,0,1,3.49,6.06Z" transform="translate(2 2.01)"/><path class="cls-3" d="M19.86,12.88a.57.57,0,0,0-.16-.42l-.83-.82a.55.55,0,0,0-.41-.18.54.54,0,0,0-.41.18l-3.72,3.71-2.06-2.06a.56.56,0,0,0-.82,0l-.83.82a.57.57,0,0,0-.16.42.56.56,0,0,0,.16.41l3.3,3.3a.58.58,0,0,0,.41.17.61.61,0,0,0,.42-.17l4.95-4.95A.56.56,0,0,0,19.86,12.88Z" transform="translate(2 2.01)"/><image class="cls-2" width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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"/><path class="cls-5" d="M34.69,33a8.93,8.93,0,0,1-4.48,7.79,9,9,0,0,1-9,0,9,9,0,0,1,0-15.58,9,9,0,0,1,9,0A8.93,8.93,0,0,1,34.69,33Z" transform="translate(2 2.01)"/><text class="cls-6" transform="translate(24.26 39.12)">' + count + '</text></g></g></svg>']
      return svg.join('');
    }

    function getDeliveredClusteredDoubleDigitsSvg(count){
      var svg = ['<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><title>Delivered_DoubleDigit</title><g id="Layer_1-2" data-name="Layer 1"><image width="36" height="49" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:#fff"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M24.16,17a6.77,6.77,0,0,1-.94,3.51A6.93,6.93,0,0,1,20.67,23a7,7,0,0,1-9.57-2.54h0A7,7,0,0,1,17.16,10a6.77,6.77,0,0,1,3.51.94A7,7,0,0,1,24.16,17Z" style="fill:#f47b20"/><path d="M21.86,14.89a.54.54,0,0,0-.16-.42l-.83-.82a.56.56,0,0,0-.82,0l-3.72,3.71L14.27,15.3a.56.56,0,0,0-.79,0l0,0-.83.82a.54.54,0,0,0-.16.42.57.57,0,0,0,.16.41l3.3,3.3a.58.58,0,0,0,.41.17.59.59,0,0,0,.42-.17L21.7,15.3A.57.57,0,0,0,21.86,14.89Z" style="fill:#fff"/><image width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M36.69,35A9,9,0,1,1,19.93,30.5a9,9,0,0,1,12.28-3.28A8.92,8.92,0,0,1,36.69,35Z" style="fill:#f47b20"/><text transform="translate(20.83 39.12)" style="isolation:isolate;font-size:11px;fill:#fff;font-family:OpenSans, Open Sans, sans-serif">' + count + '</text></g></svg>'];
      //var svg = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><defs><style>.cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3,.cls-6{fill:#fff;}.cls-4{fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{fill:#f47b20;}.cls-6{font-size:12px;font-family:OpenSans, Open Sans, sans-serif;}</style></defs><title>Delivered_DoubleDigit</title><g class="cls-1"><g id="Layer_1" data-name="Layer 1"><image class="cls-2" width="36" height="49" xlink:href="data:image/png;base64,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"/><path class="cls-3" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-4" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-5" d="M22.16,14.94a6.79,6.79,0,0,1-.94,3.51A7,7,0,0,1,18.67,21,7,7,0,0,1,9.1,18.45a7,7,0,0,1,0-7,7,7,0,0,1,6.06-3.48,6.79,6.79,0,0,1,3.51.94,7,7,0,0,1,3.49,6.06Z" transform="translate(2 2.01)"/><path class="cls-3" d="M19.86,12.88a.57.57,0,0,0-.16-.42l-.83-.82a.55.55,0,0,0-.41-.18.54.54,0,0,0-.41.18l-3.72,3.71-2.06-2.06a.56.56,0,0,0-.82,0l-.83.82a.57.57,0,0,0-.16.42.56.56,0,0,0,.16.41l3.3,3.3a.58.58,0,0,0,.41.17.61.61,0,0,0,.42-.17l4.95-4.95A.56.56,0,0,0,19.86,12.88Z" transform="translate(2 2.01)"/><image class="cls-2" width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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"/><path class="cls-5" d="M34.69,33a8.93,8.93,0,0,1-4.48,7.79,9,9,0,0,1-9,0,9,9,0,0,1,0-15.58,9,9,0,0,1,9,0A8.93,8.93,0,0,1,34.69,33Z" transform="translate(2 2.01)"/><text class="cls-6" transform="translate(20.83 39.12)">' + count + '</text></g></g></svg>']
      return svg.join('');
    }

    function getDeliveredClusteredMoreDigitsSvg(count){
      var svg = ['<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><title>Delivered_99+</title><g id="Layer_1-2" data-name="Layer 1"><image width="36" height="49" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:#fff"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M24.16,17a6.77,6.77,0,0,1-.94,3.51A6.93,6.93,0,0,1,20.67,23a7,7,0,0,1-9.57-2.54h0A7,7,0,0,1,17.16,10a6.77,6.77,0,0,1,3.51.94A7,7,0,0,1,24.16,17Z" style="fill:#f47b20"/><path d="M21.86,14.89a.54.54,0,0,0-.16-.42l-.83-.82a.56.56,0,0,0-.82,0l-3.72,3.71L14.27,15.3a.56.56,0,0,0-.79,0l0,0-.83.82a.54.54,0,0,0-.16.42.57.57,0,0,0,.16.41l3.3,3.3a.58.58,0,0,0,.41.17.59.59,0,0,0,.42-.17L21.7,15.3A.57.57,0,0,0,21.86,14.89Z" style="fill:#fff"/><image width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeCAYAAADU8sWcAAAACXBIWXMAAAsSAAALEgHS3X78AAAFpUlEQVRIS8VXXXLaaBY950pIIIyxh8g93T01nfKrN+HXLIAtZB3sx5tgE3lNTdW4qpMoBGMbIYS+e+ZBgsY/mfS8TN8XquCre865/1AS/qyR5I/e6H9wyB+93QPOZjN++PCBAFAUxQsSeZ4LAK6urjSbzQT8mMh3wY9B5/O55XluRVHYaDSy7XbLuq6Z5zmKokCSJErTVJPJxNfrtRdF4Xme6+bmxoHvk3gVvAPmdDolgKiqqrjf7/eqquqFEGIzi0IIHAwG2Gw2iKJI7h4kBTNrsizbFUXRAGiur699NpvpNQIvwElyr/bt27fx7e1tmmVZX1IGIAOQmlmvaZooiiKSlLs7yYbkVtLG3TeDwWCzWq224/F4ByDc3Nz4cwJPwI+BR6NR0u/3+1VVnZjZWNK5u49JnkjqA4jNjAAEIACoSa6bpnmIoujO3Vdmdg+g3O129cnJSfOcQIxn1uW31zTNoCzLsZlN3P0nAD+RfENyLCkzs1iSdeB71Q9RFC3dvQDwWVJCctnr9R4AaDabieShBg7gJDmdTu3x8TEqy7JvZqdmdgHgVwD/7D4vJJ2RzCTFJK1z1EjaAniQ9I3k7ySHAHqSEELwqqp8Pp872ijhCTgAnp+f23a7Tdw9c/e/xXH8s6S3ki4l/YNkDuCUZF9SLGkfdgdQA1iTXEoaAUg6lTszq8fjcV0URZhOpyLpkhQfqWZd15GklORI0htJv0r6DcBvJH8BcA5gKKkHIDqwbp0FACMAQwBJF9kawNrMHjebTZnned11AYAj5R8/frTLy8u41+v1q6oam9kbST8D+EXS30m+6ZynANoyb5Xvc+gAEgAxSaEtwHuS30IIC5KrsizLPM/r7q324Ly4uLCyLHskB3Ecn0qakMwlvSF5BuAEQL8jbHtgAGh5yADsv2sAlJ2PcwCnURT1kySJh8OhTadTkmS8D/lwOOR6vY7ruu53OTsDcCZpDGBIMumAoyMQAMBR7gEgltTvCm6ElnQmKQ0hxIvFwvr9PgDA9g4Wi4WhDWfi7gOSQ0knJAf4I5zH6p4bO4tIRgB6AFK1MyGRFNd1bWdnZ9zvBgPaRXF2dsbtdmt1Xccke2p7tNeBvlD7mh2lwiRFaMVEJCN3tyRJnvgw/IVmQLsO7+7ulKapJ0nSSNqRrCXt0A6QgD9y+l1jW+UA4CQDgCBpv3C8rusnPg7KJ5OJd49rM9tIWpN8lLRB26+NJMf3Saiz0JHdAdiSrNC2XZMkid/d3Wm/+2NJIql3797JzBqSlZk9ALgDcEdyhaP+7oCeFB7bVtsvmKYDXAN4APAIoCS5jaKoOT099fV6fXACAPry5YtnWbZLkmTTNM29pIWkAsBXSXedkwqtooZk04HtlTZoI1QCuAewJLkAsARwH0KoyrJs1uu139zcSNJhyODy8tKHw2GzWCyqKIpW7v7VzH6XNCLZ74gGtOOz11UzgCfjtUK7XAoAnwB8klR0K7bsjoxD6mKgTRZJvX//PpDcuvsDgK8kM7S9GkkKXTgPiwVt6NXVQo021EsAn0j+i+StpM/uvhoMBpuiKJp9vg/gnWm5XPput6vNrDSzb+7eQ6vYSW4ArNBOvQzd0Oly3QB4vlJvAfybZBFCeFitVlsATw6KA3in3q+vr0Oe51XTNPd1XdPMQuf4HkBBcuzurx4TAB5ILt29kPSZZEFyGcfxejgc7q6urnw+nx/Uvrhkrq+vfT6f70aj0SbLMlVV1ZhZJene3b+gWzDu/sMziuThjErTNDw/JJ+Ad+oxm818Pp/Xk8nEl8tlyLJsK+mxq940iqJe0zQR2nl+OCABbKMoenFApmn66gH5QvmeAACfTqe78/Nzr6pq196S1UMIIZYUuTvTND2cziGEV0/nq6urP386H37gX/Sn4cmDIxL/t79Lr9meyH+zHwEe238A2mQ/im2CURAAAAAASUVORK5CYII=" style="opacity:0.75;isolation:isolate"/><path d="M36.69,35A9,9,0,1,1,19.93,30.5a9,9,0,0,1,12.28-3.28A8.92,8.92,0,0,1,36.69,35Z" style="fill:#f47b20"/><text transform="translate(20.83 38.12)" style="isolation:isolate;font-size:8px;fill:#fff;font-family:OpenSans, Open Sans, sans-serif">99+</text></g></svg>'];
      //var svg = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><defs><style>.cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3,.cls-6{fill:#fff;}.cls-4{fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{fill:#f47b20;}.cls-6{font-size:8px;font-family:OpenSans, Open Sans, sans-serif;}</style></defs><title>Delivered_99+</title><g class="cls-1"><g id="Layer_1" data-name="Layer 1"><image class="cls-2" width="36" height="49" xlink:href="data:image/png;base64,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"/><path class="cls-3" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-4" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-5" d="M22.16,14.94a6.79,6.79,0,0,1-.94,3.51A7,7,0,0,1,18.67,21,7,7,0,0,1,9.1,18.45a7,7,0,0,1,0-7,7,7,0,0,1,6.06-3.48,6.79,6.79,0,0,1,3.51.94,7,7,0,0,1,3.49,6.06Z" transform="translate(2 2.01)"/><path class="cls-3" d="M19.86,12.88a.57.57,0,0,0-.16-.42l-.83-.82a.55.55,0,0,0-.41-.18.54.54,0,0,0-.41.18l-3.72,3.71-2.06-2.06a.56.56,0,0,0-.82,0l-.83.82a.57.57,0,0,0-.16.42.56.56,0,0,0,.16.41l3.3,3.3a.58.58,0,0,0,.41.17.61.61,0,0,0,.42-.17l4.95-4.95A.56.56,0,0,0,19.86,12.88Z" transform="translate(2 2.01)"/><image class="cls-2" width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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"/><path class="cls-5" d="M34.69,33a8.93,8.93,0,0,1-4.48,7.79,9,9,0,0,1-9,0,9,9,0,0,1,0-15.58,9,9,0,0,1,9,0A8.93,8.93,0,0,1,34.69,33Z" transform="translate(2 2.01)"/><text class="cls-6" transform="translate(20.83 38.12)">99+</text></g></g></svg>']
      return svg.join('');
    }

    function getInTransitSvg(){
      var svg = ['<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46" height="60" viewBox="0 0 36 49"><title>InTransit_Single</title><g id="Layer_1-2" data-name="Layer 1"><image width="36" height="49" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M28.66,17.42a12.65,12.65,0,0,1-.65,4c-1.13,3.85-10.85,20-10.85,20s-9.55-16-10.85-20a10.7,10.7,0,0,1-.65-4A11,11,0,0,1,9,9.29a11.08,11.08,0,0,1,8.12-3.37,11.09,11.09,0,0,1,8.15,3.37A11.08,11.08,0,0,1,28.66,17.42Z" style="fill:#fff"/><path d="M28.66,17.42a12.65,12.65,0,0,1-.65,4c-1.13,3.85-10.85,20-10.85,20s-9.55-16-10.85-20a10.7,10.7,0,0,1-.65-4A11,11,0,0,1,9,9.29a11.08,11.08,0,0,1,8.12-3.37,11.09,11.09,0,0,1,8.15,3.37A11.08,11.08,0,0,1,28.66,17.42Z" style="fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M24.16,16.93A6.92,6.92,0,0,1,20.68,23a7,7,0,0,1-10.49-6.06,6.87,6.87,0,0,1,.94-3.51,7.08,7.08,0,0,1,2.55-2.55,7,7,0,0,1,7,0,7.08,7.08,0,0,1,2.55,2.55A6.88,6.88,0,0,1,24.16,16.93Z" style="fill:#0084d9"/></g></svg>'];
      //var svg = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46" height="60" viewBox="0 0 36 49">','<defs>','<style>.cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3{fill:#fff;}.cls-4{fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{fill:#0084d9;}</style>','</defs>','<title>InTransit_Single</title>','<g class="cls-1">','<g id="Layer_1" data-name="Layer 1">','<image class="cls-2" width="36" height="49" xlink:href="data:image/png;base64,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"/>','<path class="cls-3" d="M28.65,17.42a12.28,12.28,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.58,10.58,0,0,1-.65-4A11.07,11.07,0,0,1,9,9.29a11.07,11.07,0,0,1,8.13-3.37,11.07,11.07,0,0,1,8.13,3.37A11.07,11.07,0,0,1,28.65,17.42Z"/>','<path class="cls-3" d="M27.35,16.43a12.44,12.44,0,0,1-.65,4c-1.13,3.85-10.85,20-10.85,20S6.3,24.44,5,20.44a10.54,10.54,0,0,1-.65-4A11,11,0,0,1,7.73,8.3a11.08,11.08,0,0,1,8.12-3.37A11.08,11.08,0,0,1,24,8.3,11.08,11.08,0,0,1,27.35,16.43Z" transform="translate(1.31 0.99)"/>','<path class="cls-4" d="M27.35,16.43a12.44,12.44,0,0,1-.65,4c-1.13,3.85-10.85,20-10.85,20S6.3,24.44,5,20.44a10.54,10.54,0,0,1-.65-4A11,11,0,0,1,7.73,8.3a11.08,11.08,0,0,1,8.12-3.37A11.08,11.08,0,0,1,24,8.3,11.08,11.08,0,0,1,27.35,16.43Z" transform="translate(1.31 0.99)"/>','<path class="cls-5" d="M21.5,15.46a.57.57,0,0,0-.16-.42l-.83-.82a.57.57,0,0,0-.82,0L16,17.93l-2.06-2.06a.57.57,0,0,0-.82,0l-.83.82a.57.57,0,0,0-.16.42.56.56,0,0,0,.16.41l3.3,3.3A.56.56,0,0,0,16,21a.57.57,0,0,0,.42-.17l4.95-4.95A.56.56,0,0,0,21.5,15.46Z"/><path class="cls-5" d="M22.85,15.94A6.92,6.92,0,0,1,19.37,22a7,7,0,0,1-7,0,7,7,0,0,1-3.49-6.06,6.89,6.89,0,0,1,.94-3.51,7.08,7.08,0,0,1,2.55-2.55,7,7,0,0,1,7,0,7.08,7.08,0,0,1,2.55,2.55A6.88,6.88,0,0,1,22.85,15.94Z" transform="translate(1.31 0.99)"/>','</g>','</g>','</svg>']
      return svg.join('');
    }

    function getInTransitClusteredSingleDigitsSvg(count){
      var svg = ['<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><defs><style type="text/css">'];
      svg.push("@font-face { font-family: 'Open Sans'; src: url(data:application/x-font-woff;charset=utf-8;base64,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) format('woff'); font-weight: 300; font-style: normal; }");
      svg.push('</style></defs><title>InTransit_SingleDigit</title><g id="Layer_1-2" data-name="Layer 1"><image width="36" height="49" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:#fff"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M24.16,17a6.77,6.77,0,0,1-.94,3.51A6.93,6.93,0,0,1,20.67,23a7,7,0,0,1-9.57-2.54h0A7,7,0,0,1,17.16,10a6.77,6.77,0,0,1,3.51.94A7,7,0,0,1,24.16,17Z" style="fill:#0084d9"/><image width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M36.69,35A9,9,0,1,1,19.93,30.5a9,9,0,0,1,12.28-3.28A8.92,8.92,0,0,1,36.69,35Z" style="fill:#0084d9"/><text transform="translate(24.26 39.12)" style="isolation:isolate;font-size:11px;fill:#fff;font-family:OpenSans, Open Sans, sans-serif">' + count + '</text></g></svg>');
      //var svg = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><defs><style>.cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3,.cls-6{fill:#fff;}.cls-4{fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{fill:#0084d9;}.cls-6{font-size:12px;font-family:OpenSans, Open Sans, sans-serif;}</style></defs><title>InTransit_SingleDigit</title><g class="cls-1"><g id="Layer_1" data-name="Layer 1"><image class="cls-2" width="36" height="49" xlink:href="data:image/png;base64,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"/><path class="cls-3" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-4" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-5" d="M22.16,14.94a6.79,6.79,0,0,1-.94,3.51A7,7,0,0,1,18.67,21,7,7,0,0,1,9.1,18.45a7,7,0,0,1,0-7,7,7,0,0,1,6.06-3.48,6.79,6.79,0,0,1,3.51.94,7,7,0,0,1,3.49,6.06Z" transform="translate(2 2.01)"/><image class="cls-2" width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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"/><path class="cls-5" d="M34.69,33a8.93,8.93,0,0,1-4.48,7.79,9,9,0,0,1-9,0,9,9,0,0,1,0-15.58,9,9,0,0,1,9,0A8.93,8.93,0,0,1,34.69,33Z" transform="translate(2 2.01)"/><text class="cls-6" transform="translate(24.26 39.12)">' + count + '</text></g></g></svg>']
      return svg.join('');
    }

    function getInTransitClusteredDoubleDigitsSvg(count){
      var svg = ['<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><title>InTransit_DoubleDigit</title><g id="Layer_1-2" data-name="Layer 1"><image width="36" height="49" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:#fff"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M24.16,17a6.77,6.77,0,0,1-.94,3.51A6.93,6.93,0,0,1,20.67,23a7,7,0,0,1-9.57-2.54h0A7,7,0,0,1,17.16,10a6.77,6.77,0,0,1,3.51.94A7,7,0,0,1,24.16,17Z" style="fill:#0084d9"/><image width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M36.69,35A9,9,0,1,1,19.93,30.5a9,9,0,0,1,12.28-3.28A8.92,8.92,0,0,1,36.69,35Z" style="fill:#0084d9"/><text transform="translate(21.41 39.12)" style="isolation:isolate;font-size:11px;fill:#fff;font-family:OpenSans, Open Sans, sans-serif;">' + count + '</text></g></svg>'];
      //var svg = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><defs><style>.cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3,.cls-6{fill:#fff;}.cls-4{fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{fill:#0084d9;}.cls-6{font-size:12px;font-family:OpenSans, Open Sans, sans-serif;}</style></defs><title>InTransit_DoubleDigit</title><g class="cls-1"><g id="Layer_1" data-name="Layer 1"><image class="cls-2" width="36" height="49" xlink:href="data:image/png;base64,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"/><path class="cls-3" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-4" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-5" d="M22.16,14.94a6.79,6.79,0,0,1-.94,3.51A7,7,0,0,1,18.67,21,7,7,0,0,1,9.1,18.45a7,7,0,0,1,0-7,7,7,0,0,1,6.06-3.48,6.79,6.79,0,0,1,3.51.94,7,7,0,0,1,3.49,6.06Z" transform="translate(2 2.01)"/><image class="cls-2" width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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"/><path class="cls-5" d="M34.69,33a8.93,8.93,0,0,1-4.48,7.79,9,9,0,0,1-9,0,9,9,0,0,1,0-15.58,9,9,0,0,1,9,0A8.93,8.93,0,0,1,34.69,33Z" transform="translate(2 2.01)"/><text class="cls-6" transform="translate(20.83 39.12)">' + count + '</text></g></g></svg>']
      return svg.join('');
    }

    function getInTransitClusteredMoreDigitsSvg(){
      var svg = ['<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><title>InTransit_99+</title><g id="Layer_1-2" data-name="Layer 1"><image width="36" height="49" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:#fff"/><path d="M28.65,17.43a12.11,12.11,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.7,10.7,0,0,1-.65-4A11.13,11.13,0,0,1,9,9.3a11.09,11.09,0,0,1,8.13-3.36A11.09,11.09,0,0,1,25.26,9.3,11.12,11.12,0,0,1,28.65,17.43Z" style="fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M24.16,17a6.77,6.77,0,0,1-.94,3.51A6.93,6.93,0,0,1,20.67,23a7,7,0,0,1-9.57-2.54h0A7,7,0,0,1,17.16,10a6.77,6.77,0,0,1,3.51.94A7,7,0,0,1,24.16,17Z" style="fill:#0084d9"/><image width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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" style="opacity:0.75;isolation:isolate"/><path d="M36.69,35A9,9,0,1,1,19.93,30.5a9,9,0,0,1,12.28-3.28A8.92,8.92,0,0,1,36.69,35Z" style="fill:#0084d9"/><text transform="translate(20.83 38.12)" style="isolation:isolate;font-size:8px;fill:#fff;font-family:OpenSans, Open Sans, sans-serif">99+</text></g></svg>'];
      //var svg = ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 44 51"><defs><style>.cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3,.cls-6{fill:#fff;}.cls-4{fill:none;stroke:#aeadae;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{fill:#0084d9;}.cls-6{font-size:8px;font-family:OpenSans, Open Sans, sans-serif;}</style></defs><title>InTransit_99+</title><g class="cls-1"><g id="Layer_1" data-name="Layer 1"><image class="cls-2" width="36" height="49" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAxCAYAAACyGwuwAAAACXBIWXMAAAsSAAALEgHS3X78AAAJJklEQVRYR7WZzVLj1haF1zpHloUxDTRxIJ1bNymmGfYL9DQDhryPnyOvwDAvwAtklGLat5K+uU1bbYxBtmz5nL3uQBIY0vx1VXaVyi7b2vrO2j/nx5SErzGSfOx7faVjPve+dYDhcMizszMCQJ7nd8AGg4EA4KefftJwOBTwMrgngVqQFmJ3d9d9+PDB9ft9t1gsuFwu7wB1u13t7e3ZbDazPM9tMBjo5OTEgOeBPQpEksPhkKenp25jY8MnSeJDCImZJb1eL5nP577T6bgYIwHAey8zi5Kicy70er1VnucBQHj37p0Nh0M9BfUgEEkeHx87AH6xWCTe+9TMuiGELEmSDEAXQCopMTMHAM45IxlILiWVZlZubGyU0+l0ub29vQIQT05O7DGoLwK1MEVRJJ1OJwXQizFuktwiuQVgS9ImyQ2SHTPzAOCciwAqkrMQwrX3/tLMpmZ2LWkOYNnv98NjUMn9D1qYPM87g8GgW5Zln+SO934PwDeSXgPYacB6krrOOQcAkmKjzrX3fmJmuXNu5L3/XFXVpNvtFnmeL46Pj1ckvwh1B2hdmcFg0K2q6pWZ7SVJcgDgjaQDSd8653YBtECpJNe4iJKWAK5JXjjnzs3sFcms0+kkkrizs4M8z/EQ1A1Qm8BnZ2ceQLcoiq1ut7uXJMn3kn4A8G8A3zvnBpJ2AGyizqMEQAtkACoAM0mXknacc5tmlgLwkuicw2AwUFEUOj4+Dveh7ih0enrq0jTtJEnS63Q6uzHG7yT96Jw7lPSDpO8AvJbUJ9nCeAAEgMZ5BPAKwBbJnpl1SXbQQJO0siyt0+kYAA2HQ5G8aQlJ86M2b5Lt7e1uWZZbZjZArcgPkn4E8C+S3zQPyloYkpTUvAioVeoCSAF0SCYNsABEMwskVwDCYrGIp6enBiCisRuF8jznYDBIyrLcILljZt9677+X9C8AbwAMAGwDyAC0I6YkAoAkNFCepGvyyq3BtOFckJzHGMtOp7Pc2NiIw+HQWpVaIA4GAzefzzuNzNve+28AHADYl7RH8hWADdSjdg3InS7dfCbchrH93iStSM4lXZG8JDk1s1mSJNXZ2Vlo7oNrwsXNzU3X6/US732GOgd2dVvifQAZyWRt9A9Nrmy+96gjkAHok3xNckDyW0mvJb1KkiQLISTv379vi+I2ZOPx2DWl2QXQA9BHXdqbkrpNLvg2RM8wknQAEkkZaj/bJHcB7Djn+iGErN/vt1VKAHX/yPOcOzs7rKrKNWFMGyddAClJ3zgHHlbmbyapVesGCs1AJbVtw+/v7/P4+JhcewgWiwXTNGXTdZO1ywFwjfNnwzRGkkTtox3oBusq7cYYOwD8eDy+4bh5AwAxRqpuXmwNd5Pza6315dcv59zNSqG1O0D/sElS23NMkpmZee/vTB13gLz3IikzU2uoy/HJhdUTZgAi64ZYSVoAWJIMIQTLsuzG/w1QlmWqqkpm1o4iNJdJEsmvgWoHZah9LQHMJZXOuVJSlSRJKIrCTk5OpKYCMBgMdHl5qTRNjWTw3i9JLhsHFYAgyb4WCvUAV40yM5IzSSVq/7Hf7/9dob29PfPehwZkLqkgOUPd6leolxYvCl8zgFadReOvkHQNYN7tdisAMc9zQ+M3acPx888/yzkXSC5IFiSnkqYArlHPYRsAEpLPLf82XAG1ynPUvq6awc5DCCvvfWx3KsCtQhqNRtbr9VZpmpbNTReSxgAmqNc3S7xApUadiDrcC9Qwk+a66nQ6ZYyxWs8fYC1kh4eHtrm5GVar1cI5d0XygmQOYCxpSnIOYAXgObnUPiBKWpIsAEwkjSVdOOemZlZ678NoNLoJF9AASdLJyYnSNI0hhMrMihjjhGTeXBeoY79EPeJHVWrVIdmG6hLAmGTunBs7567MrHz9+vXq8PDQ1u9d70OaTCbW7/dXWZaVzrmppLGZ5QA+v0AlqW6AQdKC5BWAC0kjknmMcWJmRQihStM0rocLWANqVdrd3Q1FUSxjjIVz7uKFKrWfRdQlPUOdMyPn3KcY4+ckSS5DCGW/319NJpM74QL+PnXcqLS5uTk3symAz61KqKWfN6GIjUo3DkmKZEStYtn8PgdwDuCTc25sZgWA5e7ubrivDnAP6EsqmdmFc24kaQTgguSV6qoJTWjWb5eZtepco86bc0kfAYxITgDM9/f3qy+pA3xho4g1lYqimHc6ncsQwmfv/SdJe6h70ibqRXy7VHV1e5I16s1QV9UIwMcGakzyOsuyxe+//x5/++23v6kDfGG2X1cJwNLMCufcGMAn1NLnqENRAliRNKwlMhp1SI5JngM4J5mb2WWMsSyKYnV0dBTxQJU+tPzQZDKx/f39CnXOTACMJH1sHjJGHZKFpIA6iSPJStJc0lTSZ0kj1dU18d7PnHPLsizjY6cgXwoZpHo6efv2bTw8PFwsl8vrRvJzSTuS2r39BslO4zvqtszHJD8119h7f1WWZdnv98Ovv/56p+/ct8cWaDo6OopFUaxijKWZXbLu3OfrKul21l4AKNCUOYBRjPGzmU3Lspz3+/0VaiUfVAd4QCHgRiW8e/cubm1tLUnOSE7MbATgNck2wbtolhcAJiRHks4BnDe5d42mzH/55ZdHYYBnLGFPT08ty7KwWq1K7/2V937snBsB+NQoNkGd5BcAcjN7UZnftwcVAm5VQr2IWhVFMU/T9NLMctb7q1eod7KbqnvT/0j+RfKjnlnm9+1JhaS7bQB1CD5L+ijpvwD+BPABwJ8kPwD4S9LIzC6dc/Onyvy+ParQmt20gel0Om9WAhusd7NL1Zu+JckRyY8hhHGapkUIoXqqzO/bs4Ca0Ont27dxb29vkWXZVYwx8d5L0oxkJmkVY7x0zuXe+2mMscyy7Mkyv29PhmzNdHR0FJvT1Ln3/sLMPpL8g+R/SP7hvf+4Wq0uut3ubLVaVXhGmd+3Jw/O1428PSoGkIYQujHGLklfVZWyLKuur6+XIYQlgHB6ehpfAgO8EAi4hdrd3XVVVfnZbJa0p/mSYgghNke/wgvVAV4WMgA3VWdv3ryJs9ls9f79++XBwcHi4OBgcX19XbXn0PgKGOArFGqNvPNvUPteAJ71n8ZD9tVA/5S9OGT/tP0fNqrTmn7IIxAAAAAASUVORK5CYII="/><path class="cls-3" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-4" d="M26.65,15.42a12.23,12.23,0,0,1-.65,4c-1.12,3.85-10.84,20-10.84,20s-9.55-16-10.84-20a10.59,10.59,0,0,1-.65-4A11.11,11.11,0,0,1,7,7.29a11.11,11.11,0,0,1,8.13-3.36,11.11,11.11,0,0,1,8.13,3.36A11.11,11.11,0,0,1,26.65,15.42Z" transform="translate(2 2.01)"/><path class="cls-5" d="M22.16,14.94a6.79,6.79,0,0,1-.94,3.51A7,7,0,0,1,18.67,21,7,7,0,0,1,9.1,18.45a7,7,0,0,1,0-7,7,7,0,0,1,6.06-3.48,6.79,6.79,0,0,1,3.51.94,7,7,0,0,1,3.49,6.06Z" transform="translate(2 2.01)"/><image class="cls-2" width="31" height="30" transform="translate(13 21)" xlink:href="data:image/png;base64,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"/><path class="cls-5" d="M34.69,33a8.93,8.93,0,0,1-4.48,7.79,9,9,0,0,1-9,0,9,9,0,0,1,0-15.58,9,9,0,0,1,9,0A8.93,8.93,0,0,1,34.69,33Z" transform="translate(2 2.01)"/><text class="cls-6" transform="translate(20.83 38.12)">99+</text></g></g></svg>']
      return svg.join('');
    }

    function getRadius(count) {
      var minRadius = 18;
      return Math.log(count) / Math.log(10) * 5 + minRadius;
    }

    function createClusterPinSvg(count, buckets) {
      var outlineWidth = 12;
      var radius = getRadius(count);
      var size = radius * 2;
      var sectors = [];
      var l = size / 2;
      var a = 0
      var aRad = 0
      var z = 0
      var x = 0
      var y = 0
      var X = 0
      var Y = 0
      var R = 0
      var drawFullCircle = false;
      var fullCircleKey = key;
      for (var key in buckets) {
        var percent = buckets[key].doc_count / count;
        if (percent === 1) {
          drawFullCircle = true;
          fullCircleKey = buckets[key].key;
          break;
        }
        a = 360 * percent;
        var aCalc = (a > 180) ? 360 - a : a;
        var arc = 0;
        aRad = aCalc * Math.PI / 180;
        z = Math.sqrt(2 * l * l - (2 * l * l * Math.cos(aRad)));
        if (aCalc <= 90) {
          x = l * Math.sin(aRad);
        } else {
          x = l * Math.sin((180 - aCalc) * Math.PI / 180);
        }
        y = Math.sqrt(z * z - x * x);
        Y = y;

        if (a <= 180) {
          X = l + x;
          arc = 0;
        } else {
          X = l - x;
          arc = 1;
        }
        sectors.push({
          color: statusColors[buckets[key].key],
          arc: arc,
          L: l,
          X: X,
          Y: Y,
          R: R
        });
        R = R + a;
      }
      var svg = ['<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '">'];
      svg.push('<defs>');
      svg.push('<style>');
      svg.push("@font-face { font-family: 'Open Sans'; src: url(data:application/x-font-woff;charset=utf-8;base64,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) format('woff'); font-weight: 300; font-style: normal; }");
      svg.push('</style>');
      svg.push('</defs>');
      if (drawFullCircle) {
        var circle = '<circle xmlns="http://www.w3.org/2000/svg" cx="' + radius + '" cy="' + radius + '" fill="' + statusColors[fullCircleKey] + '" r="' + radius + '"></circle>';
        svg.push(circle);
      } else {
        sectors.map(function(sector) {
          var path = '<path xmlns="http://www.w3.org/2000/svg" fill="' + sector.color + '" d="M' + sector.L + ',' + sector.L + ' L' + sector.L + ',0 A' +
          sector.L + ',' + sector.L + ' 0 ' + sector.arc + ',1 ' + sector.X + ', ' + sector.Y + ' z' +
          '" transform="' + 'rotate(' + sector.R + ', ' + sector.L + ', ' + sector.L + ')' + '"></path>';
          svg.push(path);
        });
      }
      var donut = '<circle xmlns="http://www.w3.org/2000/svg" cx="' + radius + '" cy="' + radius + '" fill="#ffffff" r="' + (radius - outlineWidth) + '"></circle>';
      svg.push(donut);
      var verticalOffset = $window.SVGGraphicsElement ? '' : 'dy="5px"';
      var text = '<text xmlns="http://www.w3.org/2000/svg"  x="50%" y="50%" text-anchor="middle" font-family="Open Sans, Tahoma, Geneva, Verdana, sans-serif" font-size="13px" dominant-baseline="central" ' + verticalOffset + '>{text}</text>'
      svg.push(text);
      svg.push('</svg>');
      return svg.join('').replace('{text}', $filter('number')(count));
    };

    return {
      createClusterPinSvg: createClusterPinSvg,
      generatePinsSvg:generatePinsSvg
    };
  }
})();

(function () {
  'use strict';
  function pageNotFoundController(WindowLocationHref) {
    WindowLocationHref.redirectToProductsPageNotFound();
  }

  pageNotFoundController.$inject = ['WindowLocationHref'];
  angular.module('NavisphereOnline').controller('PageNotFoundController', pageNotFoundController);
})();

(function () {

    'use strict';
    loadingSpinnerController.$inject = ['$scope', '$uibModalInstance', 'title'];
    function loadingSpinnerController($scope, $uibModalInstance, title) {

        $scope.title = title;
        $scope.close = function () {
            $uibModalInstance.dismiss('close');
        };
    }

    angular.module('NavisphereOnline').controller('loadingSpinnerController', loadingSpinnerController);
}());


(function () {
    "use strict";

    angular.module('NavisphereOnline').factory('InteropService', ['$location', '$rootScope', 'authService', 'localStorageService', '$uibModal', 'User', '$window', '$state',
        function ($location, $rootScope, authService, localStorageService, $uibModal, User, $window, $state) {

            /**
             * Strips URL and forwards user on to appropriate page.
             * If user is logged out they are reauthenticated with Okta.
             */
            function loginUser() {

                var token = $location.search().token;
                var userId = $location.search().sourceUserId;
                var urlArr = $window.location.href.split("&redirectUrl=");
                var redirectUrl = urlArr[1];

                authService.loginInterop(userId, token, redirectUrl);
            }

            function redirectToOnlineOne(userId, redirectUri, customerCode, currentUrl) {
                var token = '';
                var permissions = localStorageService.get('permissions');

                if (!customerCode && permissions.length === 1) {
                    customerCode = permissions[0].customerProfile.customer.partyCode;
                }

                // Javascript doesn't allow opening a window from a .then() handler.
                // Need to open an empty window first, then add the url after the promise resolves
                var onlineOneWindow = $window.open('', '_blank');

                User.getInteropToken().$promise.then(function (result) {
                    token = result.value;

                    var encodedUri = encodeURIComponent(redirectUri);
                    var legacyOnlineBaseUrl = appConfig.legacyOnlineBaseUrl;
                    onlineOneWindow.location.href = legacyOnlineBaseUrl + '/Interop/Bridgeincoming.ashx?sourceUserId='
                        + userId + '&token=' + token + '&redirectUri=' + encodedUri + '&' + 'customerCode=' + customerCode;

                    if (currentUrl) {
                        $window.location.href = currentUrl;
                    } else {
                        $state.go('app.dashboard');
                    }

                });
            }

            return {
                loginUser: loginUser,
                redirectToOnlineOne: redirectToOnlineOne
            }
        }]);

})();

(function() {

    'use strict';

    interopErrorModalController.$inject = ['$scope', '$uibModalInstance'];
    function interopErrorModalController($scope, $uibModalInstance) {

        $scope.close = function () {
            $uibModalInstance.dismiss('close');
        };
    }
    angular.module('NavisphereOnline').controller('interopErrorModalController', interopErrorModalController);
}());


/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('NavisphereOnline')
    .constant('moment', moment);

})();

(function() {

    'use strict';
    cargoClaimPolicyController.$inject = ['$scope', '$uibModalInstance'];
    function cargoClaimPolicyController($scope, $uibModalInstance) {

        $scope.close = function () {
            $uibModalInstance.dismiss('close');
        };
    }
    angular.module('NavisphereOnline').controller('cargoClaimPolicyController', cargoClaimPolicyController);
}());


(function () {
    var app = angular.module('NavisphereOnline');
    app.config(['$httpProvider', '$translateProvider', '$translatePartialLoaderProvider', 'tmhDynamicLocaleProvider', 'API_BASE_URL', function ($http, $translateProvider, $translatePartialLoaderProvider, tmhDynamicLocaleProvider, API_BASE_URL) {

        function appendTransform(defaults, transform) {
            // We can't guarantee that the default transformation is an array
            defaults = angular.isArray(defaults) ? defaults : [defaults];
            // Append the new transformation to the defaults
            return defaults.concat(transform);
        }

        $translateProvider.useLoaderCache(true);

        //use the partial loader for angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: API_BASE_URL + 'api/translations?language={lang}&resourceSet={part}',
            $http: {
                //data comes back from service as array of objects [{key1: TRANSLATION_KEY, value1: TRANSLATION_VALUE}, {key2: TRANSLATION_KEY, value2: TRANSLATION_VALUE}]
                //'angular-translate needs it as one big map of {key1: value1, key2: value2}'
                //This provides a transformation on the $http response to massage the data
                transformResponse: appendTransform($http.defaults.transformResponse, function (data) {
                    var translationsMap = {};
                    if(data){
                      for (var i = 0, len = data.length; i < len; i++) {
                        var datum = data[i];
                        translationsMap[datum.key] = datum.value;
                      }
                    }
                    return translationsMap;
                })
            }
        });

        $translateProvider.preferredLanguage('en-US');
        $translateProvider.fallbackLanguage('en-US');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
    }]);
}());

'use strict';

(function () {
  var app = angular.module('NavisphereOnline');
	app.config(['$urlMatcherFactoryProvider', '$stateProvider', '$urlRouterProvider', '$httpProvider', 'resourceLoaderProvider', '$injector', '$locationProvider',
		function ($urlMatcherFactoryProvider, $stateProvider, $urlRouterProvider, $httpProvider, resourceLoaderProvider, $injector, $locationProvider) {
      $locationProvider.hashPrefix("");

		$urlMatcherFactoryProvider.caseInsensitive(true);

		$urlRouterProvider.otherwise(function($injector, $locationProvider, $stateProvider, $httpProvider) {
      if($locationProvider.path().indexOf('access_token') !== -1) {
        return;
      } else if ($locationProvider.path().indexOf('redirectUrl') !== -1 || $locationProvider.path() === '' || $locationProvider.path() === '/') {
        $locationProvider.path('/login');
      } else {
        $locationProvider.path('/pageNotFound');
      }
		});

    $stateProvider.state('app', {
      'abstract': true,
      views: {
        'header': {
          templateUrl: 'app/header/views/header_internal_light2.html',
          controller: 'InternalHeaderController'
        },
        'footer': {
          templateUrl: 'app/footer/views/footer.tpl.html',
          controller: 'FooterController'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Navigation', 'Shipment Entry']),
        user: ['UserServiceHelper', function (UserServiceHelper) {
          return UserServiceHelper.get();
        }]
      }
    }).state('login', {
      url: '/login',
      data: {
        pageTitle: 'Login'
      },
      views: {
        'header': {
          templateUrl: 'app/header/views/header_external.html'
        },
        'content': {
          templateUrl: 'app/login/views/login.tpl.html',
          controller: 'LoginController'
        },
        'footer': {
          templateUrl: 'app/footer/views/footer.tpl.html',
          controller: 'FooterController'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global'])
      }
    }).state('app.userPreferences', {
      url: '/userPreferences',
      data: {
        pageTitle: 'USER_SETUP'
      },
      views: {
        'content@': {
          templateUrl: 'app/userPreferences/views/userPreferences.tpl.html',
          controller: "userPreferencesController",
          controllerAs: 'vm'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['User Preferences', 'Common', 'Navigation', 'Global']),
        preferenceData: ['$q', 'User', 'CultureRecommendation', function ($q, User, CultureRecommendation) {
          var deferred = $q.defer();
          var dbCalls = [];

          dbCalls.push(User.getPreferences().$promise);
          dbCalls.push(CultureRecommendation.query().$promise);
          $q.all(dbCalls).then(function (data) {
            var results = {
              userPreference: data[0],
              countryList: data[1]
            };
            deferred.resolve(results);
          });
          return deferred.promise;
        }]
      }
    }).state('app.notificationPreferences', {
      url: '/notificationPreferences',
      data: {
        pageTitle: 'NOTIFICATION_SETTINGS'
      },
      views: {
        'content@': {
          templateUrl: 'app/notificationPreferences/views/notificationPreferences.tpl.html',
          controller: "notificationPreferencesController",
          controllerAs: 'vm'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Navigation', 'Global']),
        activeSubscriptions: ['SubscriptionService', function (SubscriptionService) {
          return SubscriptionService.get().$promise;
        }]
      }
    }).state('app.developmentFeatureToggles', {
      url: '/FeaturesInDevelopment',
      data: {
        pageTitle: 'Features in Development'
      },
      views: {
        'content@': {
          templateUrl: 'app/developmentFeatureToggles/views/developmentFeatureToggles.tpl.html',
          controller: 'developmentFeatureTogglesController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Navigation', 'Global'])
      }
    }).state('app.dashboard', {
      url: '/dashboard',
      data: {
        pageTitle: 'PAGE_TITLE_DASHBOARD'
      },
      views: {
        'content@': {
          templateUrl: 'app/dashboard/views/dashboard.tpl.html',
          controller: 'DashboardController',
          controllerAs: 'vm'
        }
      },
      params: {
        runIntro: null
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Navigation', 'Dashboard', 'Alerts', 'Global'])
      }
    }).state('app.reverseLogisticsSearch', {
      url: '/reverseLogistics',
      data: {
        pageTitle: 'REVERSE_LOGISTICS'
      },
      permission: 'Reverse Logistics',
      views: {
        'content@': {
          templateUrl: 'app/reverseLogistics/views/reverseLogisticsSearch.tpl.html',
          controller: 'reverseLogisticsSearchController'
        }
      },
      params: {
        rLSearchResults: null
      },
      resolve: {
        customersWithRL: ['User', function (User) {
          return User.getReverseLogisticsCustomers().$promise;
        }],
        userPreferences: ['authService', function (authService) {
          return authService.getPreferences();
        }],
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Navigation', 'Global'])
      },
      onExit: ['ReverseLogisticsService', function (ReverseLogisticsService) {
        ReverseLogisticsService.clearResults();
      }]
    }).state('app.reverseLogisticsDetail', {
      url: '/reverseLogisticsDetail',
      data: {
        pageTitle: 'REVERSE_LOGISTICS_TICKET_DETAIL'
      },
      views: {
        'content@': {
          templateUrl: 'app/reverseLogistics/views/ticketDetail.tpl.html',
          controller: 'reverseLogisticsDetailController'
        }
      },
      permission: 'Reverse Logistics',
      params: {
        ticketDetail: null,
        ticketStatus: null,
        ticketType: null,
        rLSearchResults: null
      },
      resolve: {
        ticketDetail: ['$stateParams', function ($stateParams) {
          return $stateParams.ticketDetail;
        }],
        notes: ['ReverseLogisticsResource', '$stateParams', function (ReverseLogisticsResource, $stateParams) {
          return ReverseLogisticsResource.getNotes({ ticketId: $stateParams.ticketDetail.TicketId }).$promise;
        }],
        customerSettings: ['ReverseLogisticsResource', '$stateParams', function (ReverseLogisticsResource, $stateParams) {
          return ReverseLogisticsResource.getProcessingFee({ cCode: $stateParams.ticketDetail.CustomerPartyCode }).$promise;
        }],
        refNumTypes: ['ReverseLogisticsResource', function (ReverseLogisticsResource) {
          return ReverseLogisticsResource.getRefNumTypes().$promise;
        }],
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Navigation', 'Global'])
      }
    }).state('app.quoteHistory', {
      url: '/quoteHistory',
      data: {
        pageTitle: 'QUOTE_HISTORY'
      },
      permission: 'Get A Quote',
      views: {
        'content@': {
          templateUrl: 'app/quoteHistory/views/quoteHistory.tpl.html',
          controller: "QuoteHistoryController"
        }
      },
      resolve: {
        customers: ["CustomerService", "User", function (CustomerService, User) {
          return User.getQuoteCustomers().$promise.then(function (data) {
            _.forEach(data.customers, function (customer) {
              customer.displayName = CustomerService.GetDisplayName(customer);
              customer.isVisible = true;
            });

            return data.customers;
          });
        }],
        quoteHistory: ["QuoteHistoryService", "QuoteService", "UserServiceHelper", function (QuoteHistoryService, QuoteService, UserServiceHelper) {
          var user = UserServiceHelper.get();
          var quoteHistoryRequest = QuoteHistoryService.constructQuoteHistoryRequest();
          quoteHistoryRequest.userName = user.name;

          return QuoteService.getQuoteHistory(quoteHistoryRequest).$promise;
        }],
        refDataDDLs: ['RefDataMappingService', function (RefDataMappingService) {
          return RefDataMappingService.getRefDataCategoryDDLs();
        }],
        userPreferences: ["User", function (User) {
          return User.getPreferences().$promise;
        }],
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Navigation', 'Global'])
      }
    }).state('app.orderConfirmation', {
      url: '/orderConfirmation?confirmationNumber&partyCode&userId&partyNumber',
      data: {
        pageTitle: 'ORDER_CONFIRMATION'
      },
      permission: 'Create Order',
      views: {
        "content@": {
          controller: 'orderConfirmationController',
          templateUrl: '/app/orderConfirmation/views/orderConfirmation.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Shipment Entry'])
      }
    }).state('app.orderEditConfirmation', {
      url: '/orderEditConfirmation?orderNumber',
      data: {
        pageTitle: 'ORDER_CONFIRMATION'
      },
      views: {
        "content@": {
          controller: 'orderEditConfirmationController',
          templateUrl: '/app/orderConfirmation/views/orderEditConfirmation.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common']),
        orderNumber: ['$stateParams', function ($stateParams) {
          return $stateParams.orderNumber;
        }]
			}
    }).state('app.orderDetails', {
      url: '/orderDetails?orderNumber',
      data: {
        pageTitle: 'ORDER_DETAILS'
      },
      views: {
        "content@": {
          controller: 'orderDetailsController',
          templateUrl: 'app/orderDetails/views/orderDetails.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Shipment Entry']),
        orderDetails: ['OrderService', '$stateParams', '$q', 'OrderEditRulesService', function (OrderService, $stateParams, $q, OrderEditRulesService) {
          var deferred = $q.defer();
          OrderService.getOrder({ orderNumber: $stateParams.orderNumber })
            .$promise.then(function (orderDetails) {
              OrderEditRulesService.getOrderEditRules({ serviceStatusRDN: orderDetails.services[0].statusRDN }).$promise
                .then(function (editRules) {
                  orderDetails.editRules = editRules;
                  deferred.resolve(orderDetails);
                }, function (data) {
                  deferred.reject(data);
                });
            }, function (data) {
              deferred.reject(data);
            });
          return deferred.promise;
        }],
        userPreferences: ['authService', function (authService) {
          return authService.getPreferences();
        }],
        refDataDDLs: ['RefDataMappingService', function (RefDataMappingService) {
          return RefDataMappingService.getRefDataCategoryDDLs();
        }]
      }
    }).state('app.myOrders', {
      url: '/myorders?offset&limit&statuses&methods&ranges&search&sortBy',
      data: {
        pageTitle: 'MY_ORDERS'
      },
      views: {
        "content@": {
          controller: 'myOrdersController',
          templateUrl: '/app/myOrders/views/myOrders.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Shipment Entry', 'Dashboard']),
        orderResults: ['OrderService', '$stateParams', function (OrderService, $stateParams) {

          var search = {
            offset: $stateParams.offset || 0,
            limit: $stateParams.limit || 10,
            statuses: $stateParams.statuses,
            methods: $stateParams.methods,
            ranges: $stateParams.ranges,
            search: $stateParams.search,
            sortBy: $stateParams.sortBy
          };
          return OrderService.search(search).$promise;
        }],
        userPreference: ['authService', function (authService) {
          return authService.getPreferences();
        }],
        status: ['ReferenceData', function (ReferenceData) {
          return ReferenceData.get({ categoryCode: 'ORIONStatus' }).$promise;
        }]

      }
    }).state('app.getAQuote', {
      url: '/getAQuote',
      permission: 'Get A Quote',
      data: {
        pageTitle: 'GET_A_QUOTE'
      },
      params: {
        noQuotesFound: false,
        rawQuoteParams: {},
        shipDate: null
      },
      views: {
        "content@": {
          controller: 'getAQuoteController',
          templateUrl: 'app/getAQuote/views/getAQuote.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Shipment Entry']),
        createQuoteCustomers: ['User', function (User) {
          return User.getQuoteCustomers().$promise;
        }],
        userPreferences: ['authService', function (authService) {
          return authService.getPreferences();
        }],
        refDataDDLs: ['RefDataMappingService', function (RefDataMappingService) {
          return RefDataMappingService.getRefDataCategoryDDLs();
        }]
      }
    }).state('app.reQuote', {
      url: '/reQuote?requestId',
      permission: 'Get A Quote',
      data: {
        pageTitle: 'GET_A_QUOTE'
      },
      params: {
        noQuotesFound: false,
        rawQuoteParams: {},
        shipDate: null
      },
      views: {
        "content@": {
          controller: 'getAQuoteController',
          templateUrl: 'app/getAQuote/views/getAQuote.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Shipment Entry']),
        createQuoteCustomers: ['User', function (User) {
          return User.getQuoteCustomers().$promise;
        }],
        userPreferences: ['authService', function (authService) {
          return authService.getPreferences();
        }],
        refDataDDLs: ['RefDataMappingService', function (RefDataMappingService) {
          return RefDataMappingService.getRefDataCategoryDDLs();
        }]
      }
    }).state('app.getAQuoteResults', {
      url: '/getAQuoteResults',
      data: {
        pageTitle: 'QUOTE_SUMMARY'
      },
      permission: 'Get A Quote',
      params: {
        isShippable: null,
        getAQuoteParams: null,
        quoteRequestId: null,
        quoteResults: null,
        rawQuoteParams: null
      },
      onEnter: ["$transition$", function ($transition$) {
        var stateParams = $transition$.params();
        if (!stateParams.getAQuoteParams && !stateParams.rawQuoteParams) {
          return $transition$.router.stateService.target("app.quoteHistory");
        }

        if (_.isNull(stateParams.isShippable)) {
          /*
          Quotes are shippable by default.

          It is only in cases where the user clicks view results on an expired or already ordered quote in
          Quote History that we want to prevent the quote from being shippable.
          */
          var params = _.clone(stateParams);
          params.isShippable = true;
          return $transition$.router.stateService.target($transition$.to(), params);
        }
      }],
      views: {
        "content@": {
          controller: 'getAQuoteResultsController',
          templateUrl: 'app/getAQuote/views/getAQuoteResults.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Shipment Entry']),
        userPreferences: ['authService', function (authService) {
          return authService.getPreferences();
        }]
      }
    }).state('app.quoteToOrder', {
      url: '/quoteToOrder',
      data: {
        pageTitle: "QUOTE_TO_ORDER"
      },
      permission: 'Create Order',
      params: {
        getAQuoteParams: null,
        rawQuoteParams: null,
        quoteResults: null,
        quote: null,
        destination: null,
        origin: null,
        totalCharge: null,
        totalWeight: null,
        quoteRequestId: null
      },
      onEnter: ["$transition$", function ($transition$) {
        function areAnyNull(params) {
          var flag = false;

          _.forEach(params, function (value, key) {
            if (_.isNull(value) && key !== '#') {
              flag = true;
            }
          });

          return flag;
        }

        var params = $transition$.params();

        if (areAnyNull(params)) {
          return $transition$.router.stateService.target("app.getAQuote");
        }
      }],
      views: {
        "content@": {
          controller: "quoteToOrderController",
          templateUrl: "app/getAQuote/views/quoteToOrder.tpl.html"
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global']),
        refDataDDLs: ["RefDataMappingService", function (RefDataMappingService) {
          return RefDataMappingService.getRefDataCategoryDDLs();
        }],
        userPreferences: ["User", function (User) {
          return User.getPreferences().$promise;
        }]
      }
    }).state('app.drawPO', {
      url: '/drawpo',
      data: {
        pageTitle: 'DRAW_PO'
      },
      permission: 'Draw PO',
      views: {
        "content@": {
          controller: 'DrawSearchController',
          templateUrl: 'app/purchaseOrder/views/draw-search.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global']),
        userPreferences: ['authService', function (authService) {
          return authService.getPreferences();
        }]
      }
    }).state('app.reports', {
      onExit: ['ReportPersistanceService', function (ReportPersistanceService) {
        ReportPersistanceService.clearReportConfig();
      }]
    }).state('app.reports.reportHub', {
      url: '/reportHub',
      onEnter: function() {
        document.location.href = appConfig.reportsUIBaseUrl;
      },
    }).state('app.reports.servicePerformanceReport', {
      url: '/reportHub/serviceperformance',
      data: {
        pageTitle: 'SERVICE_PERFORMANCE'
      },
      permission: 'Service Performance Report',
      views: {
        "content@": {
          controller: 'ServicePerformanceReportController',
          templateUrl: 'app/reports/views/servicePerformanceReport.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting'])
      }
    }).state('app.reports.inTransitReport', {
      url: '/reportHub/intransit',
      data: {
        pageTitle: 'IN_TRANSIT'
      },
      permission: 'In Transit Report',
      views: {
        "content@": {
          controller: 'InTransitOrdersController',
          templateUrl: 'app/reporting/inTransitOrders/views/report.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting'])
      }
    }).state('app.reports.overdueOrdersReport', {
      url: '/reportHub/overdueorders',
      data: {
        pageTitle: 'OVERDUE_ORDERS'
      },
      permission: 'Overdue Orders Report',
      views: {
        "content@": {
          controller: 'OverdueOrdersController',
          templateUrl: 'app/reporting/overdueOrders/views/report.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting'])
      }
    }).state('app.reports.ordersOverviewReport', {
      url: '/reportHub/ordersoverview',
      data: {
        pageTitle: 'ORDER_OVERVIEW'
      },
      permission: 'Orders Overview Report',
      views: {
        "content@": {
          controller: 'OrdersOverviewReportController',
          templateUrl: 'app/reports/views/ordersOverviewReport.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting']),
        customerModes: ['ReportingService', function (ReportingService) {
          return ReportingService.historicOrdersModes().$promise
        }]
      }
    }).state('app.reports.savedOrdersSummary', {
      url: '/reportHub/orderssummary/saved',
      data: {
        pageTitle: 'ORDERS_SUMMARY'
      },
      permission: 'Orders Summary Report',
      views: {
        "content@": {
          controller: 'SavedOrdersSummaryController',
          templateUrl: 'app/reporting/ordersSummary/views/savedReports.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting', 'ReportingService']),
        savedReportConfigs: ['ReportingService', function (ReportingService) {
          var configPull = { reportName: "Orders Summary Report" };
          return ReportingService.selectSavedReportConfig(configPull).$promise;
        }],
        reportConfigsSchedules: ['ReportingService', function (ReportingService) {
          var configPull = {reportName: "Orders Summary Report"};
          return ReportingService.reportConfigSubscription(configPull).$promise;
        }],
        preferences: ['User', function (User) {
          return User.getPreferences().$promise;
        }]
      }
    }).state('app.reports.createOrdersSummary', {
      url: '/reportHub/orderssummary/create',
      data: {
        pageTitle: 'CREATE_ORDERS_SUMMARY_REPORT'
      },
      params: { reportConfigPass: "" },
      permission: 'Orders Summary Report',
      views: {
        "content@": {
          controller: 'CreateOrdersSummaryController',
          templateUrl: 'app/reporting/ordersSummary/views/createReport.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting']),
        orderCustomers: ['ReportingService', function (ReportingService) {
          return ReportingService.ordersSummaryCustomers().$promise;
        }],
        customerModes: ['ReportingService', function (ReportingService) {
          return ReportingService.reportingModeSet().$promise;
        }]
      }
    }).state('app.reports.ordersSummary', {
      url: '/reportHub/orderssummary',
      data: {
        pageTitle: 'ORDERS_SUMMARY'
      },
      permission: 'Orders Summary Report',
      views: {
        "content@": {
          controller: 'OrdersSummaryController',
          templateUrl: 'app/reporting/ordersSummary/views/report.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting'])
      }
    }).state('app.reports.savedLocation', {
      url: '/reportHub/location/saved',
      data: {
        pageTitle: 'LOCATION'
      },
      permission: 'Location Report',
      views: {
        "content@": {
          controller: 'SavedLocationController',
          templateUrl: 'app/reporting/location/views/savedReports.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting']),
        savedReportConfigs: ['ReportingService', function (ReportingService) {
          var configPull = { reportName: "Location Report" };
          return ReportingService.selectSavedReportConfig(configPull).$promise;
        }],
        reportConfigsSchedules: ['ReportingService', function (ReportingService) {
          var configPull = {reportName: "Location Report"};
          return ReportingService.reportConfigSubscription(configPull).$promise;
        }],
        preferences: ['User', function (User) {
          return User.getPreferences().$promise;
        }]
      }
    }).state('app.reports.createLocation', {
      url: '/reportHub/location/create',
      data: {
        pageTitle: 'CREATE_LOCATION_REPORT'
      },
      params: { reportConfigPass: "" },
      permission: 'Location Report',
      views: {
        "content@": {
          controller: 'CreateLocationController',
          templateUrl: 'app/reporting/location/views/createReport.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting']),
        locationCustomers: ['ReportingService', function (ReportingService) {
          return ReportingService.locationCustomers().$promise
        }],
        customerModes: ['ReportingService', function (ReportingService) {
          return ReportingService.reportingModeSet().$promise;
        }]
      }
    }).state('app.reports.locationReport', {
      url: '/reportHub/location',
      data: {
        pageTitle: 'LOCATION'
      },
      permission: 'Location Report',
      views: {
        "content@": {
          controller: 'LocationReportController',
          templateUrl: 'app/reporting/location/views/report.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting'])
      }
    }).state('app.reports.subscription', {
      url: '/reportHub/subscription?token',
      data: {
        pageTitle: 'SUBSCRIPTION'
      },
      permission: 'Report Subscription',
      views: {
        "content@": {
          controller: 'SubscriptionController',
          templateUrl: 'app/reporting/subscription/views/subscription.tpl.html'
        }
      },
      params: {
        reportConfigId: null,
        reportName: null,
        previousRoute : null,
        test: null,
        subscriptionType : null,
        token: null
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting']),
        preferences: ['User', function (User) {
          return User.getPreferences().$promise;
        }]
      },
      onEnter: ['$state', '$stateParams', function ($state, $stateParams) {
        if (_.isNull($stateParams.reportConfigId) && _.isNull($stateParams.token)) {
          $state.go('app.reports.reportHub');
        }
      }]
    }).state('app.reports.unsubscribe', {
      url: '/reportHub/unsubscribe?reportConfigId?reportName',
      data: {
        pageTitle: 'UNSUBSCRIBE'
      },
      params:{
        reportConfigId : null,
        reportName: null,
        previousRoute : null
      },
      permission: 'Report Subscription',
      views: {
        "content@": {
          controller: 'UnsubscribeController',
          templateUrl: 'app/reporting/subscription/views/unsubscribe.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting']),
        subscriptionDetail: ['ReportingService', '$stateParams', function (ReportingService, $stateParams) {
          var reportConfigId = {savedReportConfigId: $stateParams.reportConfigId};
          return ReportingService.subscriptionDetail(reportConfigId).$promise
        }],
        preferences: ['User', function (User) {
          return User.getPreferences().$promise;
        }]
      }
    }).state('app.reports.subscriptionDownload', {
      url: '/reportHub/subscriptionDownload?token',
      data: {
        pageTitle: 'SUBSCRIPTION_DOWNLOAD'
      },
      permission: 'Report Subscription',
      views: {
        "content@": {
          controller: 'SubscriptionDownloadController',
          templateUrl: 'app/reporting/subscription/views/download.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global', 'Reporting']),
        token: ['$stateParams', function ($stateParams) {
          return $stateParams.token
        }]
      },
      onEnter: ["$state", "$stateParams", function ($state, $stateParams) {
        if (!$stateParams.token) {
          $state.go("app.reports.reportHub");
        }
      }]
    }).state('app.reports.noSubscriptionAccess', {
      url: '/reportHub/noSubscriptionAccess',
      data: {
        pageTitle: 'NO_SUBSCRIPTION_ACCESS'
      },
      views: {
        "content@": {
          templateUrl: 'app/reporting/subscription/views/noSubscriptionAccess.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Reporting'])
      }
    }).state('app.accountSummary', {
      url: '/accountsummary',
      data: {
        pageTitle: 'ACCOUNT_SUMMARY'
      },
      permission: 'Accounts Payable',
      views: {
        "content@": {
          controller: 'AccountSummaryController',
          templateUrl: 'app/accountsPayable/views/accountsummary.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global']),
        invoiceResults: ['InvoiceService', function (InvoiceService) {
          var search = {
            page: 1,
            limit: 10,
            invoiceStatus: 1,
            sortBy: 'dueDate',
            sortDescending: false
          };
          return InvoiceService.search(search).$promise;
        }]
      }
    }).state('app.searchInvoices', {
      url: '/searchinvoices',
      data: {
        pageTitle: 'SEARCH_INVOICES'
      },
      permission: 'Accounts Payable',
      views: {
        "content@": {
          controller: 'SearchInvoicesController',
          templateUrl: 'app/accountsPayable/views/searchinvoices.tpl.html'
        }
      },
      resolve: {
        translations: resourceLoaderProvider.loadTranslations(['Common', 'Global'])
      }
    })
      .state('Resend Invitation', {
        url: '/resendInvitation',
        data: {
          pageTitle: 'RESEND_INVITATION'
        },
        views: {
          'header': {
            templateUrl: 'app/header/views/header_external.html'
          },
          'content': {
            templateUrl: 'app/resendInvitation/views/resendInvitationForm.tpl.html',
            controller: 'resendInvitationController'
          },
          'footer': {
            templateUrl: 'app/footer/views/footer.tpl.html',
            controller: 'FooterController'
          }
        },
        resolve: {
          translations: resourceLoaderProvider.loadTranslations(['Common']),
          invitation: ['$stateParams', function ($stateParams) {
            return $stateParams.invitation;
          }]
        },
        params: { invitation: null }
      }).state('Resend Invitation Complete', {
        url: '/resendInvitationComplete',
        data: {
          pageTitle: 'RESEND_INVITATION_COMPLETE'
        },
        views: {
          'header': {
            templateUrl: 'app/header/views/header_external.html'
          },
          'content': {
            templateUrl: '../app/resendInvitation/views/resendInvitationComplete.tpl.html',
            controller: 'resendInvitationCompleteController'
          },
          'footer': {
            templateUrl: 'app/footer/views/footer.tpl.html',
            controller: 'FooterController'
          }
        },
        resolve: {
          translations: resourceLoaderProvider.loadTranslations(['Common'])
        }
      }).state('app.shipmentMap', {
        url: '/maps',
        data: {
          pageTitle: 'Maps'
        },
        views: {
          'content@': {
            templateUrl: 'app/shipmentMap/shipmentMap.html',
            controller: 'shipmentMapController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          translations: resourceLoaderProvider.loadTranslations(['Common', 'Navigation', 'Global'])
        }
      }).state('logout', {
        url: '/logout',
        data: {
          pageTitle: 'Logout'
        },
        onEnter: ['authService', function (authService) {
          authService.logout();
        }]
      }).state('bridge', {
        url: '/bridge',
        onEnter: ['InteropService', function (InteropService) {
          InteropService.loginUser();
        }
        ]
      }).state('outgoingBridge', {
        url: '/outgoingBridge',
        params: {
          redirectUrl: null,
          currentUrl: null
        },
        onEnter: ['localStorageService', 'InteropService', '$stateParams', function (localStorageService, InteropService, $stateParams) {
          var redirectUrl = $stateParams.redirectUrl;
          var currentUrl = $stateParams.currentUrl;
          var user = localStorageService.get("User");
          InteropService.redirectToOnlineOne(user.userId, redirectUrl, null, currentUrl);
        }]
      }).state('pageNotFound', {
        url: '/pageNotFound',
        data: {
          pageTitle: 'PAGE_TITLE_CREATE_SHIPMENT'
        },
        views: {
          'content': {
            controller: 'PageNotFoundController'
          }
        },
        resolve: {
          translations: resourceLoaderProvider.loadTranslations(['Common', 'Global'])
        }
      });
  }]);
}());

(function () {
  'use strict';
  function queryService() {

    function stringify(query) {
      var queryArray = Object.keys(query).map(function(queryKey){
        return encodeURI(queryKey + '=' + query[queryKey]);
      });

      return queryArray.join('&');
    }

    return {
      stringify: stringify
    };
  }
  queryService.$inject = [];
  angular.module('NavisphereOnline').factory('queryService', queryService);
})();

(function () {
  'use strict';

  /** @ngInject */
  function config(localStorageServiceProvider, jwtOptionsProvider, $httpProvider, okta_settings) {


    localStorageServiceProvider.setPrefix('NavisphereOnline');

    jwtOptionsProvider.config({
      tokenGetter: ['authService', function (authService) {
        return authService.getAccessToken();
      }],
      whiteListedDomains: okta_settings.whiteListedDomains,
      unauthenticatedRedirector: ['authService', function (authService) {
        authService.checkAuthSession();
      }]
    });

    $httpProvider.interceptors.push('jwtInterceptor');
  }

  config.$inject = ['localStorageServiceProvider', 'jwtOptionsProvider', '$httpProvider', 'okta_settings'];

  angular
    .module('NavisphereOnline')
    .config(config);
})();

       angular.element(document).on('click', 'a.ui-select-choices-row-inner' , function() { return false; });

(function () {
  'use strict';
  function externalRoutesService(searchBaseUrl, queryService) {

    function search(query){
      window.location = searchBaseUrl + '#/?' + queryService.stringify(query);
    }

    return {
      search: search
    };
  }
  externalRoutesService.$inject = ['searchBaseUrl', 'queryService'];
  angular.module('NavisphereOnline').factory('externalRoutesService', externalRoutesService);
})();

'use strict';

var bolContext = {
  Order: 1,
  Load: 2
};

var applicationIds = {
  Online2: 1,
  Inventory: 2,
  SmallBusiness: 3,
  Online1: 4,
  Products: 5,
  ManagedProcurement: 6,
  Insight: 7,
  RobinsonLabs: 8
}


angular.module('NavisphereOnline.constants', [])
  .constant('API_BASE_URL', appConfig.apiUrl)
  .constant('applicationVersion', appConfig.applicationVersion)
  .constant('bingMapKey', appConfig.bingMapKey)
  .constant('weatherApiKey', appConfig.weatherApiKey)
  .constant('DEV_FEATURES', appConfig.devFeatures)
  .constant('searchBaseUrl', appConfig.searchBaseUrl)
  .constant('reportsUIBaseUrl', appConfig.reportsUIBaseUrl)
  .constant('bolContext', bolContext)
  .constant('okta_settings', appConfig.okta_settings)
  .constant('API_COMMON_URL', appConfig.commonApiUrl)
  .constant('APPLICATIONS', applicationIds)
  .constant("OKTA_CONFIG", {
      options : {
        issuer: appConfig.okta_settings.issuer,
        clientId: appConfig.okta_settings.clientID,
        tokenManager:{
          storage: "memory",
          expireEarlySeconds: 120,
          autoRenew: true
        },
        pkce: false,
        postLogoutRedirectUri: appConfig.postLogoutRedirectUri
      },
      apiUrl : appConfig.apiUrl
  })
  .constant('MERGE_ACCOUNTS', 'MERGE ACCOUNTS');
